
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire130b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire130b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lbBr3", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f6c7a9f61a8d38da$export$ae55be85d98224ed; }, function (v) { return $f6c7a9f61a8d38da$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $f6c7a9f61a8d38da$export$d39a5bbd09211389; }, function (v) { return $f6c7a9f61a8d38da$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $f6c7a9f61a8d38da$export$882461b6382ed46c; }, function (v) { return $f6c7a9f61a8d38da$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $f6c7a9f61a8d38da$export$466bfc07425424d5; }, function (v) { return $f6c7a9f61a8d38da$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $f6c7a9f61a8d38da$export$cd75ccfd720a3cd4; }, function (v) { return $f6c7a9f61a8d38da$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $f6c7a9f61a8d38da$export$fa8d919ba61d84db; }, function (v) { return $f6c7a9f61a8d38da$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $f6c7a9f61a8d38da$export$757ceba2d55c277e; }, function (v) { return $f6c7a9f61a8d38da$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $f6c7a9f61a8d38da$export$b3890eb0ae9dca99; }, function (v) { return $f6c7a9f61a8d38da$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $f6c7a9f61a8d38da$export$502457920280e6be; }, function (v) { return $f6c7a9f61a8d38da$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $f6c7a9f61a8d38da$export$c78a37762a8d58e1; }, function (v) { return $f6c7a9f61a8d38da$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $f6c7a9f61a8d38da$export$dc54d992c10e8a18; }, function (v) { return $f6c7a9f61a8d38da$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $f6c7a9f61a8d38da$export$83d89fbfd8236492; }, function (v) { return $f6c7a9f61a8d38da$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f6c7a9f61a8d38da$export$ae55be85d98224ed;
var $f6c7a9f61a8d38da$export$d39a5bbd09211389;
var $f6c7a9f61a8d38da$export$882461b6382ed46c;
var $f6c7a9f61a8d38da$export$466bfc07425424d5;
var $f6c7a9f61a8d38da$export$cd75ccfd720a3cd4;
var $f6c7a9f61a8d38da$export$fa8d919ba61d84db;
var $f6c7a9f61a8d38da$export$757ceba2d55c277e;
var $f6c7a9f61a8d38da$export$b3890eb0ae9dca99;
var $f6c7a9f61a8d38da$export$502457920280e6be;
var $f6c7a9f61a8d38da$export$c78a37762a8d58e1;
var $f6c7a9f61a8d38da$export$dc54d992c10e8a18;
var $f6c7a9f61a8d38da$export$83d89fbfd8236492;
"use strict";

var $5NSbj = parcelRequire("5NSbj");

var $g09Uk = parcelRequire("g09Uk");
function $f6c7a9f61a8d38da$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f6c7a9f61a8d38da$var$da = new Set, $f6c7a9f61a8d38da$var$ea = {};
function $f6c7a9f61a8d38da$var$fa(a, b) {
    $f6c7a9f61a8d38da$var$ha(a, b);
    $f6c7a9f61a8d38da$var$ha(a + "Capture", b);
}
function $f6c7a9f61a8d38da$var$ha(a, b) {
    $f6c7a9f61a8d38da$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f6c7a9f61a8d38da$var$da.add(b[a]);
}
var $f6c7a9f61a8d38da$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f6c7a9f61a8d38da$var$ja = Object.prototype.hasOwnProperty, $f6c7a9f61a8d38da$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f6c7a9f61a8d38da$var$la = {}, $f6c7a9f61a8d38da$var$ma = {};
function $f6c7a9f61a8d38da$var$oa(a) {
    if ($f6c7a9f61a8d38da$var$ja.call($f6c7a9f61a8d38da$var$ma, a)) return !0;
    if ($f6c7a9f61a8d38da$var$ja.call($f6c7a9f61a8d38da$var$la, a)) return !1;
    if ($f6c7a9f61a8d38da$var$ka.test(a)) return $f6c7a9f61a8d38da$var$ma[a] = !0;
    $f6c7a9f61a8d38da$var$la[a] = !0;
    return !1;
}
function $f6c7a9f61a8d38da$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f6c7a9f61a8d38da$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f6c7a9f61a8d38da$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f6c7a9f61a8d38da$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f6c7a9f61a8d38da$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f6c7a9f61a8d38da$var$z[a] = new $f6c7a9f61a8d38da$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f6c7a9f61a8d38da$var$z[b] = new $f6c7a9f61a8d38da$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f6c7a9f61a8d38da$var$z[a] = new $f6c7a9f61a8d38da$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f6c7a9f61a8d38da$var$z[a] = new $f6c7a9f61a8d38da$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f6c7a9f61a8d38da$var$z[a] = new $f6c7a9f61a8d38da$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f6c7a9f61a8d38da$var$z[a] = new $f6c7a9f61a8d38da$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f6c7a9f61a8d38da$var$z[a] = new $f6c7a9f61a8d38da$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f6c7a9f61a8d38da$var$z[a] = new $f6c7a9f61a8d38da$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f6c7a9f61a8d38da$var$z[a] = new $f6c7a9f61a8d38da$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f6c7a9f61a8d38da$var$ra = /[\-:]([a-z])/g;
function $f6c7a9f61a8d38da$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f6c7a9f61a8d38da$var$ra, $f6c7a9f61a8d38da$var$sa);
    $f6c7a9f61a8d38da$var$z[b] = new $f6c7a9f61a8d38da$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f6c7a9f61a8d38da$var$ra, $f6c7a9f61a8d38da$var$sa);
    $f6c7a9f61a8d38da$var$z[b] = new $f6c7a9f61a8d38da$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f6c7a9f61a8d38da$var$ra, $f6c7a9f61a8d38da$var$sa);
    $f6c7a9f61a8d38da$var$z[b] = new $f6c7a9f61a8d38da$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f6c7a9f61a8d38da$var$z[a] = new $f6c7a9f61a8d38da$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f6c7a9f61a8d38da$var$z.xlinkHref = new $f6c7a9f61a8d38da$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f6c7a9f61a8d38da$var$z[a] = new $f6c7a9f61a8d38da$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f6c7a9f61a8d38da$var$ta(a, b, c, d) {
    var e = $f6c7a9f61a8d38da$var$z.hasOwnProperty(b) ? $f6c7a9f61a8d38da$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f6c7a9f61a8d38da$var$qa(b, c, e, d) && (c = null), d || null === e ? $f6c7a9f61a8d38da$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f6c7a9f61a8d38da$var$ua = $5NSbj.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f6c7a9f61a8d38da$var$va = Symbol.for("react.element"), $f6c7a9f61a8d38da$var$wa = Symbol.for("react.portal"), $f6c7a9f61a8d38da$var$ya = Symbol.for("react.fragment"), $f6c7a9f61a8d38da$var$za = Symbol.for("react.strict_mode"), $f6c7a9f61a8d38da$var$Aa = Symbol.for("react.profiler"), $f6c7a9f61a8d38da$var$Ba = Symbol.for("react.provider"), $f6c7a9f61a8d38da$var$Ca = Symbol.for("react.context"), $f6c7a9f61a8d38da$var$Da = Symbol.for("react.forward_ref"), $f6c7a9f61a8d38da$var$Ea = Symbol.for("react.suspense"), $f6c7a9f61a8d38da$var$Fa = Symbol.for("react.suspense_list"), $f6c7a9f61a8d38da$var$Ga = Symbol.for("react.memo"), $f6c7a9f61a8d38da$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f6c7a9f61a8d38da$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f6c7a9f61a8d38da$var$Ja = Symbol.iterator;
function $f6c7a9f61a8d38da$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f6c7a9f61a8d38da$var$Ja && a[$f6c7a9f61a8d38da$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f6c7a9f61a8d38da$var$A = Object.assign, $f6c7a9f61a8d38da$var$La;
function $f6c7a9f61a8d38da$var$Ma(a) {
    if (void 0 === $f6c7a9f61a8d38da$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f6c7a9f61a8d38da$var$La = b && b[1] || "";
    }
    return "\n" + $f6c7a9f61a8d38da$var$La + a;
}
var $f6c7a9f61a8d38da$var$Na = !1;
function $f6c7a9f61a8d38da$var$Oa(a, b) {
    if (!a || $f6c7a9f61a8d38da$var$Na) return "";
    $f6c7a9f61a8d38da$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f6c7a9f61a8d38da$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f6c7a9f61a8d38da$var$Ma(a) : "";
}
function $f6c7a9f61a8d38da$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $f6c7a9f61a8d38da$var$Ma(a.type);
        case 16:
            return $f6c7a9f61a8d38da$var$Ma("Lazy");
        case 13:
            return $f6c7a9f61a8d38da$var$Ma("Suspense");
        case 19:
            return $f6c7a9f61a8d38da$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f6c7a9f61a8d38da$var$Oa(a.type, !1), a;
        case 11:
            return a = $f6c7a9f61a8d38da$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $f6c7a9f61a8d38da$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $f6c7a9f61a8d38da$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f6c7a9f61a8d38da$var$ya:
            return "Fragment";
        case $f6c7a9f61a8d38da$var$wa:
            return "Portal";
        case $f6c7a9f61a8d38da$var$Aa:
            return "Profiler";
        case $f6c7a9f61a8d38da$var$za:
            return "StrictMode";
        case $f6c7a9f61a8d38da$var$Ea:
            return "Suspense";
        case $f6c7a9f61a8d38da$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f6c7a9f61a8d38da$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $f6c7a9f61a8d38da$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $f6c7a9f61a8d38da$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f6c7a9f61a8d38da$var$Ga:
            return b = a.displayName || null, null !== b ? b : $f6c7a9f61a8d38da$var$Qa(a.type) || "Memo";
        case $f6c7a9f61a8d38da$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $f6c7a9f61a8d38da$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f6c7a9f61a8d38da$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f6c7a9f61a8d38da$var$Qa(b);
        case 8:
            return b === $f6c7a9f61a8d38da$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f6c7a9f61a8d38da$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f6c7a9f61a8d38da$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f6c7a9f61a8d38da$var$Ua(a) {
    var b = $f6c7a9f61a8d38da$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f6c7a9f61a8d38da$var$Va(a) {
    a._valueTracker || (a._valueTracker = $f6c7a9f61a8d38da$var$Ua(a));
}
function $f6c7a9f61a8d38da$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f6c7a9f61a8d38da$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f6c7a9f61a8d38da$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f6c7a9f61a8d38da$var$Ya(a, b) {
    var c = b.checked;
    return $f6c7a9f61a8d38da$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f6c7a9f61a8d38da$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f6c7a9f61a8d38da$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f6c7a9f61a8d38da$var$ab(a, b) {
    b = b.checked;
    null != b && $f6c7a9f61a8d38da$var$ta(a, "checked", b, !1);
}
function $f6c7a9f61a8d38da$var$bb(a, b) {
    $f6c7a9f61a8d38da$var$ab(a, b);
    var c = $f6c7a9f61a8d38da$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f6c7a9f61a8d38da$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f6c7a9f61a8d38da$var$cb(a, b.type, $f6c7a9f61a8d38da$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f6c7a9f61a8d38da$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f6c7a9f61a8d38da$var$cb(a, b, c) {
    if ("number" !== b || $f6c7a9f61a8d38da$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f6c7a9f61a8d38da$var$eb = Array.isArray;
function $f6c7a9f61a8d38da$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f6c7a9f61a8d38da$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f6c7a9f61a8d38da$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f6c7a9f61a8d38da$var$p(91));
    return $f6c7a9f61a8d38da$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f6c7a9f61a8d38da$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f6c7a9f61a8d38da$var$p(92));
            if ($f6c7a9f61a8d38da$var$eb(c)) {
                if (1 < c.length) throw Error($f6c7a9f61a8d38da$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f6c7a9f61a8d38da$var$Sa(c)
    };
}
function $f6c7a9f61a8d38da$var$ib(a, b) {
    var c = $f6c7a9f61a8d38da$var$Sa(b.value), d = $f6c7a9f61a8d38da$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f6c7a9f61a8d38da$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f6c7a9f61a8d38da$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f6c7a9f61a8d38da$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f6c7a9f61a8d38da$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f6c7a9f61a8d38da$var$mb, $f6c7a9f61a8d38da$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f6c7a9f61a8d38da$var$mb = $f6c7a9f61a8d38da$var$mb || document.createElement("div");
        $f6c7a9f61a8d38da$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f6c7a9f61a8d38da$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f6c7a9f61a8d38da$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f6c7a9f61a8d38da$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f6c7a9f61a8d38da$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f6c7a9f61a8d38da$var$pb).forEach(function(a) {
    $f6c7a9f61a8d38da$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f6c7a9f61a8d38da$var$pb[b] = $f6c7a9f61a8d38da$var$pb[a];
    });
});
function $f6c7a9f61a8d38da$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f6c7a9f61a8d38da$var$pb.hasOwnProperty(a) && $f6c7a9f61a8d38da$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $f6c7a9f61a8d38da$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f6c7a9f61a8d38da$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f6c7a9f61a8d38da$var$tb = $f6c7a9f61a8d38da$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f6c7a9f61a8d38da$var$ub(a, b) {
    if (b) {
        if ($f6c7a9f61a8d38da$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f6c7a9f61a8d38da$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f6c7a9f61a8d38da$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f6c7a9f61a8d38da$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f6c7a9f61a8d38da$var$p(62));
    }
}
function $f6c7a9f61a8d38da$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f6c7a9f61a8d38da$var$wb = null;
function $f6c7a9f61a8d38da$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f6c7a9f61a8d38da$var$yb = null, $f6c7a9f61a8d38da$var$zb = null, $f6c7a9f61a8d38da$var$Ab = null;
function $f6c7a9f61a8d38da$var$Bb(a) {
    if (a = $f6c7a9f61a8d38da$var$Cb(a)) {
        if ("function" !== typeof $f6c7a9f61a8d38da$var$yb) throw Error($f6c7a9f61a8d38da$var$p(280));
        var b = a.stateNode;
        b && (b = $f6c7a9f61a8d38da$var$Db(b), $f6c7a9f61a8d38da$var$yb(a.stateNode, a.type, b));
    }
}
function $f6c7a9f61a8d38da$var$Eb(a) {
    $f6c7a9f61a8d38da$var$zb ? $f6c7a9f61a8d38da$var$Ab ? $f6c7a9f61a8d38da$var$Ab.push(a) : $f6c7a9f61a8d38da$var$Ab = [
        a
    ] : $f6c7a9f61a8d38da$var$zb = a;
}
function $f6c7a9f61a8d38da$var$Fb() {
    if ($f6c7a9f61a8d38da$var$zb) {
        var a = $f6c7a9f61a8d38da$var$zb, b = $f6c7a9f61a8d38da$var$Ab;
        $f6c7a9f61a8d38da$var$Ab = $f6c7a9f61a8d38da$var$zb = null;
        $f6c7a9f61a8d38da$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$f6c7a9f61a8d38da$var$Bb(b[a]);
    }
}
function $f6c7a9f61a8d38da$var$Gb(a, b) {
    return a(b);
}
function $f6c7a9f61a8d38da$var$Hb() {}
var $f6c7a9f61a8d38da$var$Ib = !1;
function $f6c7a9f61a8d38da$var$Jb(a, b, c) {
    if ($f6c7a9f61a8d38da$var$Ib) return a(b, c);
    $f6c7a9f61a8d38da$var$Ib = !0;
    try {
        return $f6c7a9f61a8d38da$var$Gb(a, b, c);
    } finally{
        if ($f6c7a9f61a8d38da$var$Ib = !1, null !== $f6c7a9f61a8d38da$var$zb || null !== $f6c7a9f61a8d38da$var$Ab) $f6c7a9f61a8d38da$var$Hb(), $f6c7a9f61a8d38da$var$Fb();
    }
}
function $f6c7a9f61a8d38da$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f6c7a9f61a8d38da$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f6c7a9f61a8d38da$var$p(231, b, typeof c));
    return c;
}
var $f6c7a9f61a8d38da$var$Lb = !1;
if ($f6c7a9f61a8d38da$var$ia) try {
    var $f6c7a9f61a8d38da$var$Mb = {};
    Object.defineProperty($f6c7a9f61a8d38da$var$Mb, "passive", {
        get: function() {
            $f6c7a9f61a8d38da$var$Lb = !0;
        }
    });
    window.addEventListener("test", $f6c7a9f61a8d38da$var$Mb, $f6c7a9f61a8d38da$var$Mb);
    window.removeEventListener("test", $f6c7a9f61a8d38da$var$Mb, $f6c7a9f61a8d38da$var$Mb);
} catch (a) {
    $f6c7a9f61a8d38da$var$Lb = !1;
}
function $f6c7a9f61a8d38da$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $f6c7a9f61a8d38da$var$Ob = !1, $f6c7a9f61a8d38da$var$Pb = null, $f6c7a9f61a8d38da$var$Qb = !1, $f6c7a9f61a8d38da$var$Rb = null, $f6c7a9f61a8d38da$var$Sb = {
    onError: function(a) {
        $f6c7a9f61a8d38da$var$Ob = !0;
        $f6c7a9f61a8d38da$var$Pb = a;
    }
};
function $f6c7a9f61a8d38da$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f6c7a9f61a8d38da$var$Ob = !1;
    $f6c7a9f61a8d38da$var$Pb = null;
    $f6c7a9f61a8d38da$var$Nb.apply($f6c7a9f61a8d38da$var$Sb, arguments);
}
function $f6c7a9f61a8d38da$var$Ub(a, b, c, d, e, f, g, h, k) {
    $f6c7a9f61a8d38da$var$Tb.apply(this, arguments);
    if ($f6c7a9f61a8d38da$var$Ob) {
        if ($f6c7a9f61a8d38da$var$Ob) {
            var l = $f6c7a9f61a8d38da$var$Pb;
            $f6c7a9f61a8d38da$var$Ob = !1;
            $f6c7a9f61a8d38da$var$Pb = null;
        } else throw Error($f6c7a9f61a8d38da$var$p(198));
        $f6c7a9f61a8d38da$var$Qb || ($f6c7a9f61a8d38da$var$Qb = !0, $f6c7a9f61a8d38da$var$Rb = l);
    }
}
function $f6c7a9f61a8d38da$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f6c7a9f61a8d38da$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f6c7a9f61a8d38da$var$Xb(a) {
    if ($f6c7a9f61a8d38da$var$Vb(a) !== a) throw Error($f6c7a9f61a8d38da$var$p(188));
}
function $f6c7a9f61a8d38da$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f6c7a9f61a8d38da$var$Vb(a);
        if (null === b) throw Error($f6c7a9f61a8d38da$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f6c7a9f61a8d38da$var$Xb(e), a;
                if (f === d) return $f6c7a9f61a8d38da$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($f6c7a9f61a8d38da$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f6c7a9f61a8d38da$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f6c7a9f61a8d38da$var$p(190));
    }
    if (3 !== c.tag) throw Error($f6c7a9f61a8d38da$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f6c7a9f61a8d38da$var$Zb(a) {
    a = $f6c7a9f61a8d38da$var$Yb(a);
    return null !== a ? $f6c7a9f61a8d38da$var$$b(a) : null;
}
function $f6c7a9f61a8d38da$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f6c7a9f61a8d38da$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f6c7a9f61a8d38da$var$ac = $g09Uk.unstable_scheduleCallback, $f6c7a9f61a8d38da$var$bc = $g09Uk.unstable_cancelCallback, $f6c7a9f61a8d38da$var$cc = $g09Uk.unstable_shouldYield, $f6c7a9f61a8d38da$var$dc = $g09Uk.unstable_requestPaint, $f6c7a9f61a8d38da$var$B = $g09Uk.unstable_now, $f6c7a9f61a8d38da$var$ec = $g09Uk.unstable_getCurrentPriorityLevel, $f6c7a9f61a8d38da$var$fc = $g09Uk.unstable_ImmediatePriority, $f6c7a9f61a8d38da$var$gc = $g09Uk.unstable_UserBlockingPriority, $f6c7a9f61a8d38da$var$hc = $g09Uk.unstable_NormalPriority, $f6c7a9f61a8d38da$var$ic = $g09Uk.unstable_LowPriority, $f6c7a9f61a8d38da$var$jc = $g09Uk.unstable_IdlePriority, $f6c7a9f61a8d38da$var$kc = null, $f6c7a9f61a8d38da$var$lc = null;
function $f6c7a9f61a8d38da$var$mc(a) {
    if ($f6c7a9f61a8d38da$var$lc && "function" === typeof $f6c7a9f61a8d38da$var$lc.onCommitFiberRoot) try {
        $f6c7a9f61a8d38da$var$lc.onCommitFiberRoot($f6c7a9f61a8d38da$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f6c7a9f61a8d38da$var$oc = Math.clz32 ? Math.clz32 : $f6c7a9f61a8d38da$var$nc, $f6c7a9f61a8d38da$var$pc = Math.log, $f6c7a9f61a8d38da$var$qc = Math.LN2;
function $f6c7a9f61a8d38da$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f6c7a9f61a8d38da$var$pc(a) / $f6c7a9f61a8d38da$var$qc | 0) | 0;
}
var $f6c7a9f61a8d38da$var$rc = 64, $f6c7a9f61a8d38da$var$sc = 4194304;
function $f6c7a9f61a8d38da$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f6c7a9f61a8d38da$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f6c7a9f61a8d38da$var$tc(h) : (f &= g, 0 !== f && (d = $f6c7a9f61a8d38da$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $f6c7a9f61a8d38da$var$tc(g) : 0 !== f && (d = $f6c7a9f61a8d38da$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f6c7a9f61a8d38da$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f6c7a9f61a8d38da$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f6c7a9f61a8d38da$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f6c7a9f61a8d38da$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f6c7a9f61a8d38da$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f6c7a9f61a8d38da$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f6c7a9f61a8d38da$var$yc() {
    var a = $f6c7a9f61a8d38da$var$rc;
    $f6c7a9f61a8d38da$var$rc <<= 1;
    0 === ($f6c7a9f61a8d38da$var$rc & 4194240) && ($f6c7a9f61a8d38da$var$rc = 64);
    return a;
}
function $f6c7a9f61a8d38da$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f6c7a9f61a8d38da$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f6c7a9f61a8d38da$var$oc(b);
    a[b] = c;
}
function $f6c7a9f61a8d38da$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f6c7a9f61a8d38da$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f6c7a9f61a8d38da$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f6c7a9f61a8d38da$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f6c7a9f61a8d38da$var$C = 0;
function $f6c7a9f61a8d38da$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f6c7a9f61a8d38da$var$Ec, $f6c7a9f61a8d38da$var$Fc, $f6c7a9f61a8d38da$var$Gc, $f6c7a9f61a8d38da$var$Hc, $f6c7a9f61a8d38da$var$Ic, $f6c7a9f61a8d38da$var$Jc = !1, $f6c7a9f61a8d38da$var$Kc = [], $f6c7a9f61a8d38da$var$Lc = null, $f6c7a9f61a8d38da$var$Mc = null, $f6c7a9f61a8d38da$var$Nc = null, $f6c7a9f61a8d38da$var$Oc = new Map, $f6c7a9f61a8d38da$var$Pc = new Map, $f6c7a9f61a8d38da$var$Qc = [], $f6c7a9f61a8d38da$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f6c7a9f61a8d38da$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f6c7a9f61a8d38da$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f6c7a9f61a8d38da$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f6c7a9f61a8d38da$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f6c7a9f61a8d38da$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f6c7a9f61a8d38da$var$Pc.delete(b.pointerId);
    }
}
function $f6c7a9f61a8d38da$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f6c7a9f61a8d38da$var$Cb(b), null !== b && $f6c7a9f61a8d38da$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f6c7a9f61a8d38da$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f6c7a9f61a8d38da$var$Lc = $f6c7a9f61a8d38da$var$Tc($f6c7a9f61a8d38da$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $f6c7a9f61a8d38da$var$Mc = $f6c7a9f61a8d38da$var$Tc($f6c7a9f61a8d38da$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $f6c7a9f61a8d38da$var$Nc = $f6c7a9f61a8d38da$var$Tc($f6c7a9f61a8d38da$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f6c7a9f61a8d38da$var$Oc.set(f, $f6c7a9f61a8d38da$var$Tc($f6c7a9f61a8d38da$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f6c7a9f61a8d38da$var$Pc.set(f, $f6c7a9f61a8d38da$var$Tc($f6c7a9f61a8d38da$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f6c7a9f61a8d38da$var$Vc(a) {
    var b = $f6c7a9f61a8d38da$var$Wc(a.target);
    if (null !== b) {
        var c = $f6c7a9f61a8d38da$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f6c7a9f61a8d38da$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $f6c7a9f61a8d38da$var$Ic(a.priority, function() {
                        $f6c7a9f61a8d38da$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f6c7a9f61a8d38da$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f6c7a9f61a8d38da$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f6c7a9f61a8d38da$var$wb = d;
            c.target.dispatchEvent(d);
            $f6c7a9f61a8d38da$var$wb = null;
        } else return b = $f6c7a9f61a8d38da$var$Cb(c), null !== b && $f6c7a9f61a8d38da$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f6c7a9f61a8d38da$var$Zc(a, b, c) {
    $f6c7a9f61a8d38da$var$Xc(a) && c.delete(b);
}
function $f6c7a9f61a8d38da$var$$c() {
    $f6c7a9f61a8d38da$var$Jc = !1;
    null !== $f6c7a9f61a8d38da$var$Lc && $f6c7a9f61a8d38da$var$Xc($f6c7a9f61a8d38da$var$Lc) && ($f6c7a9f61a8d38da$var$Lc = null);
    null !== $f6c7a9f61a8d38da$var$Mc && $f6c7a9f61a8d38da$var$Xc($f6c7a9f61a8d38da$var$Mc) && ($f6c7a9f61a8d38da$var$Mc = null);
    null !== $f6c7a9f61a8d38da$var$Nc && $f6c7a9f61a8d38da$var$Xc($f6c7a9f61a8d38da$var$Nc) && ($f6c7a9f61a8d38da$var$Nc = null);
    $f6c7a9f61a8d38da$var$Oc.forEach($f6c7a9f61a8d38da$var$Zc);
    $f6c7a9f61a8d38da$var$Pc.forEach($f6c7a9f61a8d38da$var$Zc);
}
function $f6c7a9f61a8d38da$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f6c7a9f61a8d38da$var$Jc || ($f6c7a9f61a8d38da$var$Jc = !0, $g09Uk.unstable_scheduleCallback($g09Uk.unstable_NormalPriority, $f6c7a9f61a8d38da$var$$c)));
}
function $f6c7a9f61a8d38da$var$bd(a) {
    function b(b) {
        return $f6c7a9f61a8d38da$var$ad(b, a);
    }
    if (0 < $f6c7a9f61a8d38da$var$Kc.length) {
        $f6c7a9f61a8d38da$var$ad($f6c7a9f61a8d38da$var$Kc[0], a);
        for(var c = 1; c < $f6c7a9f61a8d38da$var$Kc.length; c++){
            var d = $f6c7a9f61a8d38da$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f6c7a9f61a8d38da$var$Lc && $f6c7a9f61a8d38da$var$ad($f6c7a9f61a8d38da$var$Lc, a);
    null !== $f6c7a9f61a8d38da$var$Mc && $f6c7a9f61a8d38da$var$ad($f6c7a9f61a8d38da$var$Mc, a);
    null !== $f6c7a9f61a8d38da$var$Nc && $f6c7a9f61a8d38da$var$ad($f6c7a9f61a8d38da$var$Nc, a);
    $f6c7a9f61a8d38da$var$Oc.forEach(b);
    $f6c7a9f61a8d38da$var$Pc.forEach(b);
    for(c = 0; c < $f6c7a9f61a8d38da$var$Qc.length; c++)d = $f6c7a9f61a8d38da$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f6c7a9f61a8d38da$var$Qc.length && (c = $f6c7a9f61a8d38da$var$Qc[0], null === c.blockedOn);)$f6c7a9f61a8d38da$var$Vc(c), null === c.blockedOn && $f6c7a9f61a8d38da$var$Qc.shift();
}
var $f6c7a9f61a8d38da$var$cd = $f6c7a9f61a8d38da$var$ua.ReactCurrentBatchConfig, $f6c7a9f61a8d38da$var$dd = !0;
function $f6c7a9f61a8d38da$var$ed(a, b, c, d) {
    var e = $f6c7a9f61a8d38da$var$C, f = $f6c7a9f61a8d38da$var$cd.transition;
    $f6c7a9f61a8d38da$var$cd.transition = null;
    try {
        $f6c7a9f61a8d38da$var$C = 1, $f6c7a9f61a8d38da$var$fd(a, b, c, d);
    } finally{
        $f6c7a9f61a8d38da$var$C = e, $f6c7a9f61a8d38da$var$cd.transition = f;
    }
}
function $f6c7a9f61a8d38da$var$gd(a, b, c, d) {
    var e = $f6c7a9f61a8d38da$var$C, f = $f6c7a9f61a8d38da$var$cd.transition;
    $f6c7a9f61a8d38da$var$cd.transition = null;
    try {
        $f6c7a9f61a8d38da$var$C = 4, $f6c7a9f61a8d38da$var$fd(a, b, c, d);
    } finally{
        $f6c7a9f61a8d38da$var$C = e, $f6c7a9f61a8d38da$var$cd.transition = f;
    }
}
function $f6c7a9f61a8d38da$var$fd(a, b, c, d) {
    if ($f6c7a9f61a8d38da$var$dd) {
        var e = $f6c7a9f61a8d38da$var$Yc(a, b, c, d);
        if (null === e) $f6c7a9f61a8d38da$var$hd(a, b, d, $f6c7a9f61a8d38da$var$id, c), $f6c7a9f61a8d38da$var$Sc(a, d);
        else if ($f6c7a9f61a8d38da$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($f6c7a9f61a8d38da$var$Sc(a, d), b & 4 && -1 < $f6c7a9f61a8d38da$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $f6c7a9f61a8d38da$var$Cb(e);
                null !== f && $f6c7a9f61a8d38da$var$Ec(f);
                f = $f6c7a9f61a8d38da$var$Yc(a, b, c, d);
                null === f && $f6c7a9f61a8d38da$var$hd(a, b, d, $f6c7a9f61a8d38da$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f6c7a9f61a8d38da$var$hd(a, b, d, null, c);
    }
}
var $f6c7a9f61a8d38da$var$id = null;
function $f6c7a9f61a8d38da$var$Yc(a, b, c, d) {
    $f6c7a9f61a8d38da$var$id = null;
    a = $f6c7a9f61a8d38da$var$xb(d);
    a = $f6c7a9f61a8d38da$var$Wc(a);
    if (null !== a) {
        if (b = $f6c7a9f61a8d38da$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f6c7a9f61a8d38da$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f6c7a9f61a8d38da$var$id = a;
    return null;
}
function $f6c7a9f61a8d38da$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f6c7a9f61a8d38da$var$ec()){
                case $f6c7a9f61a8d38da$var$fc:
                    return 1;
                case $f6c7a9f61a8d38da$var$gc:
                    return 4;
                case $f6c7a9f61a8d38da$var$hc:
                case $f6c7a9f61a8d38da$var$ic:
                    return 16;
                case $f6c7a9f61a8d38da$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f6c7a9f61a8d38da$var$kd = null, $f6c7a9f61a8d38da$var$ld = null, $f6c7a9f61a8d38da$var$md = null;
function $f6c7a9f61a8d38da$var$nd() {
    if ($f6c7a9f61a8d38da$var$md) return $f6c7a9f61a8d38da$var$md;
    var a, b = $f6c7a9f61a8d38da$var$ld, c = b.length, d, e = "value" in $f6c7a9f61a8d38da$var$kd ? $f6c7a9f61a8d38da$var$kd.value : $f6c7a9f61a8d38da$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f6c7a9f61a8d38da$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f6c7a9f61a8d38da$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f6c7a9f61a8d38da$var$pd() {
    return !0;
}
function $f6c7a9f61a8d38da$var$qd() {
    return !1;
}
function $f6c7a9f61a8d38da$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f6c7a9f61a8d38da$var$pd : $f6c7a9f61a8d38da$var$qd;
        this.isPropagationStopped = $f6c7a9f61a8d38da$var$qd;
        return this;
    }
    $f6c7a9f61a8d38da$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f6c7a9f61a8d38da$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f6c7a9f61a8d38da$var$pd);
        },
        persist: function() {},
        isPersistent: $f6c7a9f61a8d38da$var$pd
    });
    return b;
}
var $f6c7a9f61a8d38da$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f6c7a9f61a8d38da$var$td = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$sd), $f6c7a9f61a8d38da$var$ud = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$sd, {
    view: 0,
    detail: 0
}), $f6c7a9f61a8d38da$var$vd = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$ud), $f6c7a9f61a8d38da$var$wd, $f6c7a9f61a8d38da$var$xd, $f6c7a9f61a8d38da$var$yd, $f6c7a9f61a8d38da$var$Ad = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f6c7a9f61a8d38da$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f6c7a9f61a8d38da$var$yd && ($f6c7a9f61a8d38da$var$yd && "mousemove" === a.type ? ($f6c7a9f61a8d38da$var$wd = a.screenX - $f6c7a9f61a8d38da$var$yd.screenX, $f6c7a9f61a8d38da$var$xd = a.screenY - $f6c7a9f61a8d38da$var$yd.screenY) : $f6c7a9f61a8d38da$var$xd = $f6c7a9f61a8d38da$var$wd = 0, $f6c7a9f61a8d38da$var$yd = a);
        return $f6c7a9f61a8d38da$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f6c7a9f61a8d38da$var$xd;
    }
}), $f6c7a9f61a8d38da$var$Bd = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Ad), $f6c7a9f61a8d38da$var$Cd = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$Ad, {
    dataTransfer: 0
}), $f6c7a9f61a8d38da$var$Dd = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Cd), $f6c7a9f61a8d38da$var$Ed = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$ud, {
    relatedTarget: 0
}), $f6c7a9f61a8d38da$var$Fd = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Ed), $f6c7a9f61a8d38da$var$Gd = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f6c7a9f61a8d38da$var$Hd = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Gd), $f6c7a9f61a8d38da$var$Id = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f6c7a9f61a8d38da$var$Jd = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Id), $f6c7a9f61a8d38da$var$Kd = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$sd, {
    data: 0
}), $f6c7a9f61a8d38da$var$Ld = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Kd), $f6c7a9f61a8d38da$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f6c7a9f61a8d38da$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f6c7a9f61a8d38da$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f6c7a9f61a8d38da$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f6c7a9f61a8d38da$var$Od[a]) ? !!b[a] : !1;
}
function $f6c7a9f61a8d38da$var$zd() {
    return $f6c7a9f61a8d38da$var$Pd;
}
var $f6c7a9f61a8d38da$var$Qd = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $f6c7a9f61a8d38da$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f6c7a9f61a8d38da$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f6c7a9f61a8d38da$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f6c7a9f61a8d38da$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $f6c7a9f61a8d38da$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f6c7a9f61a8d38da$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f6c7a9f61a8d38da$var$Rd = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Qd), $f6c7a9f61a8d38da$var$Sd = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f6c7a9f61a8d38da$var$Td = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Sd), $f6c7a9f61a8d38da$var$Ud = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f6c7a9f61a8d38da$var$zd
}), $f6c7a9f61a8d38da$var$Vd = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Ud), $f6c7a9f61a8d38da$var$Wd = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f6c7a9f61a8d38da$var$Xd = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Wd), $f6c7a9f61a8d38da$var$Yd = $f6c7a9f61a8d38da$var$A({}, $f6c7a9f61a8d38da$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f6c7a9f61a8d38da$var$Zd = $f6c7a9f61a8d38da$var$rd($f6c7a9f61a8d38da$var$Yd), $f6c7a9f61a8d38da$var$$d = [
    9,
    13,
    27,
    32
], $f6c7a9f61a8d38da$var$ae = $f6c7a9f61a8d38da$var$ia && "CompositionEvent" in window, $f6c7a9f61a8d38da$var$be = null;
$f6c7a9f61a8d38da$var$ia && "documentMode" in document && ($f6c7a9f61a8d38da$var$be = document.documentMode);
var $f6c7a9f61a8d38da$var$ce = $f6c7a9f61a8d38da$var$ia && "TextEvent" in window && !$f6c7a9f61a8d38da$var$be, $f6c7a9f61a8d38da$var$de = $f6c7a9f61a8d38da$var$ia && (!$f6c7a9f61a8d38da$var$ae || $f6c7a9f61a8d38da$var$be && 8 < $f6c7a9f61a8d38da$var$be && 11 >= $f6c7a9f61a8d38da$var$be), $f6c7a9f61a8d38da$var$ee = String.fromCharCode(32), $f6c7a9f61a8d38da$var$fe = !1;
function $f6c7a9f61a8d38da$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f6c7a9f61a8d38da$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f6c7a9f61a8d38da$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f6c7a9f61a8d38da$var$ie = !1;
function $f6c7a9f61a8d38da$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $f6c7a9f61a8d38da$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f6c7a9f61a8d38da$var$fe = !0;
            return $f6c7a9f61a8d38da$var$ee;
        case "textInput":
            return a = b.data, a === $f6c7a9f61a8d38da$var$ee && $f6c7a9f61a8d38da$var$fe ? null : a;
        default:
            return null;
    }
}
function $f6c7a9f61a8d38da$var$ke(a, b) {
    if ($f6c7a9f61a8d38da$var$ie) return "compositionend" === a || !$f6c7a9f61a8d38da$var$ae && $f6c7a9f61a8d38da$var$ge(a, b) ? (a = $f6c7a9f61a8d38da$var$nd(), $f6c7a9f61a8d38da$var$md = $f6c7a9f61a8d38da$var$ld = $f6c7a9f61a8d38da$var$kd = null, $f6c7a9f61a8d38da$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f6c7a9f61a8d38da$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f6c7a9f61a8d38da$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f6c7a9f61a8d38da$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f6c7a9f61a8d38da$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $f6c7a9f61a8d38da$var$ne(a, b, c, d) {
    $f6c7a9f61a8d38da$var$Eb(d);
    b = $f6c7a9f61a8d38da$var$oe(b, "onChange");
    0 < b.length && (c = new $f6c7a9f61a8d38da$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f6c7a9f61a8d38da$var$pe = null, $f6c7a9f61a8d38da$var$qe = null;
function $f6c7a9f61a8d38da$var$re(a) {
    $f6c7a9f61a8d38da$var$se(a, 0);
}
function $f6c7a9f61a8d38da$var$te(a) {
    var b = $f6c7a9f61a8d38da$var$ue(a);
    if ($f6c7a9f61a8d38da$var$Wa(b)) return a;
}
function $f6c7a9f61a8d38da$var$ve(a, b) {
    if ("change" === a) return b;
}
var $f6c7a9f61a8d38da$var$we = !1;
if ($f6c7a9f61a8d38da$var$ia) {
    var $f6c7a9f61a8d38da$var$xe;
    if ($f6c7a9f61a8d38da$var$ia) {
        var $f6c7a9f61a8d38da$var$ye = "oninput" in document;
        if (!$f6c7a9f61a8d38da$var$ye) {
            var $f6c7a9f61a8d38da$var$ze = document.createElement("div");
            $f6c7a9f61a8d38da$var$ze.setAttribute("oninput", "return;");
            $f6c7a9f61a8d38da$var$ye = "function" === typeof $f6c7a9f61a8d38da$var$ze.oninput;
        }
        $f6c7a9f61a8d38da$var$xe = $f6c7a9f61a8d38da$var$ye;
    } else $f6c7a9f61a8d38da$var$xe = !1;
    $f6c7a9f61a8d38da$var$we = $f6c7a9f61a8d38da$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $f6c7a9f61a8d38da$var$Ae() {
    $f6c7a9f61a8d38da$var$pe && ($f6c7a9f61a8d38da$var$pe.detachEvent("onpropertychange", $f6c7a9f61a8d38da$var$Be), $f6c7a9f61a8d38da$var$qe = $f6c7a9f61a8d38da$var$pe = null);
}
function $f6c7a9f61a8d38da$var$Be(a) {
    if ("value" === a.propertyName && $f6c7a9f61a8d38da$var$te($f6c7a9f61a8d38da$var$qe)) {
        var b = [];
        $f6c7a9f61a8d38da$var$ne(b, $f6c7a9f61a8d38da$var$qe, a, $f6c7a9f61a8d38da$var$xb(a));
        $f6c7a9f61a8d38da$var$Jb($f6c7a9f61a8d38da$var$re, b);
    }
}
function $f6c7a9f61a8d38da$var$Ce(a, b, c) {
    "focusin" === a ? ($f6c7a9f61a8d38da$var$Ae(), $f6c7a9f61a8d38da$var$pe = b, $f6c7a9f61a8d38da$var$qe = c, $f6c7a9f61a8d38da$var$pe.attachEvent("onpropertychange", $f6c7a9f61a8d38da$var$Be)) : "focusout" === a && $f6c7a9f61a8d38da$var$Ae();
}
function $f6c7a9f61a8d38da$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f6c7a9f61a8d38da$var$te($f6c7a9f61a8d38da$var$qe);
}
function $f6c7a9f61a8d38da$var$Ee(a, b) {
    if ("click" === a) return $f6c7a9f61a8d38da$var$te(b);
}
function $f6c7a9f61a8d38da$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $f6c7a9f61a8d38da$var$te(b);
}
function $f6c7a9f61a8d38da$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f6c7a9f61a8d38da$var$He = "function" === typeof Object.is ? Object.is : $f6c7a9f61a8d38da$var$Ge;
function $f6c7a9f61a8d38da$var$Ie(a, b) {
    if ($f6c7a9f61a8d38da$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f6c7a9f61a8d38da$var$ja.call(b, e) || !$f6c7a9f61a8d38da$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $f6c7a9f61a8d38da$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f6c7a9f61a8d38da$var$Ke(a, b) {
    var c = $f6c7a9f61a8d38da$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f6c7a9f61a8d38da$var$Je(c);
    }
}
function $f6c7a9f61a8d38da$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f6c7a9f61a8d38da$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f6c7a9f61a8d38da$var$Me() {
    for(var a = window, b = $f6c7a9f61a8d38da$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f6c7a9f61a8d38da$var$Xa(a.document);
    }
    return b;
}
function $f6c7a9f61a8d38da$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f6c7a9f61a8d38da$var$Oe(a) {
    var b = $f6c7a9f61a8d38da$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f6c7a9f61a8d38da$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f6c7a9f61a8d38da$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f6c7a9f61a8d38da$var$Ke(c, f);
                var g = $f6c7a9f61a8d38da$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f6c7a9f61a8d38da$var$Pe = $f6c7a9f61a8d38da$var$ia && "documentMode" in document && 11 >= document.documentMode, $f6c7a9f61a8d38da$var$Qe = null, $f6c7a9f61a8d38da$var$Re = null, $f6c7a9f61a8d38da$var$Se = null, $f6c7a9f61a8d38da$var$Te = !1;
function $f6c7a9f61a8d38da$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f6c7a9f61a8d38da$var$Te || null == $f6c7a9f61a8d38da$var$Qe || $f6c7a9f61a8d38da$var$Qe !== $f6c7a9f61a8d38da$var$Xa(d) || (d = $f6c7a9f61a8d38da$var$Qe, "selectionStart" in d && $f6c7a9f61a8d38da$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f6c7a9f61a8d38da$var$Se && $f6c7a9f61a8d38da$var$Ie($f6c7a9f61a8d38da$var$Se, d) || ($f6c7a9f61a8d38da$var$Se = d, d = $f6c7a9f61a8d38da$var$oe($f6c7a9f61a8d38da$var$Re, "onSelect"), 0 < d.length && (b = new $f6c7a9f61a8d38da$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f6c7a9f61a8d38da$var$Qe)));
}
function $f6c7a9f61a8d38da$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f6c7a9f61a8d38da$var$We = {
    animationend: $f6c7a9f61a8d38da$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $f6c7a9f61a8d38da$var$Ve("Animation", "AnimationIteration"),
    animationstart: $f6c7a9f61a8d38da$var$Ve("Animation", "AnimationStart"),
    transitionend: $f6c7a9f61a8d38da$var$Ve("Transition", "TransitionEnd")
}, $f6c7a9f61a8d38da$var$Xe = {}, $f6c7a9f61a8d38da$var$Ye = {};
$f6c7a9f61a8d38da$var$ia && ($f6c7a9f61a8d38da$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $f6c7a9f61a8d38da$var$We.animationend.animation, delete $f6c7a9f61a8d38da$var$We.animationiteration.animation, delete $f6c7a9f61a8d38da$var$We.animationstart.animation), "TransitionEvent" in window || delete $f6c7a9f61a8d38da$var$We.transitionend.transition);
function $f6c7a9f61a8d38da$var$Ze(a) {
    if ($f6c7a9f61a8d38da$var$Xe[a]) return $f6c7a9f61a8d38da$var$Xe[a];
    if (!$f6c7a9f61a8d38da$var$We[a]) return a;
    var b = $f6c7a9f61a8d38da$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f6c7a9f61a8d38da$var$Ye) return $f6c7a9f61a8d38da$var$Xe[a] = b[c];
    return a;
}
var $f6c7a9f61a8d38da$var$$e = $f6c7a9f61a8d38da$var$Ze("animationend"), $f6c7a9f61a8d38da$var$af = $f6c7a9f61a8d38da$var$Ze("animationiteration"), $f6c7a9f61a8d38da$var$bf = $f6c7a9f61a8d38da$var$Ze("animationstart"), $f6c7a9f61a8d38da$var$cf = $f6c7a9f61a8d38da$var$Ze("transitionend"), $f6c7a9f61a8d38da$var$df = new Map, $f6c7a9f61a8d38da$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f6c7a9f61a8d38da$var$ff(a, b) {
    $f6c7a9f61a8d38da$var$df.set(a, b);
    $f6c7a9f61a8d38da$var$fa(b, [
        a
    ]);
}
for(var $f6c7a9f61a8d38da$var$gf = 0; $f6c7a9f61a8d38da$var$gf < $f6c7a9f61a8d38da$var$ef.length; $f6c7a9f61a8d38da$var$gf++){
    var $f6c7a9f61a8d38da$var$hf = $f6c7a9f61a8d38da$var$ef[$f6c7a9f61a8d38da$var$gf], $f6c7a9f61a8d38da$var$jf = $f6c7a9f61a8d38da$var$hf.toLowerCase(), $f6c7a9f61a8d38da$var$kf = $f6c7a9f61a8d38da$var$hf[0].toUpperCase() + $f6c7a9f61a8d38da$var$hf.slice(1);
    $f6c7a9f61a8d38da$var$ff($f6c7a9f61a8d38da$var$jf, "on" + $f6c7a9f61a8d38da$var$kf);
}
$f6c7a9f61a8d38da$var$ff($f6c7a9f61a8d38da$var$$e, "onAnimationEnd");
$f6c7a9f61a8d38da$var$ff($f6c7a9f61a8d38da$var$af, "onAnimationIteration");
$f6c7a9f61a8d38da$var$ff($f6c7a9f61a8d38da$var$bf, "onAnimationStart");
$f6c7a9f61a8d38da$var$ff("dblclick", "onDoubleClick");
$f6c7a9f61a8d38da$var$ff("focusin", "onFocus");
$f6c7a9f61a8d38da$var$ff("focusout", "onBlur");
$f6c7a9f61a8d38da$var$ff($f6c7a9f61a8d38da$var$cf, "onTransitionEnd");
$f6c7a9f61a8d38da$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f6c7a9f61a8d38da$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f6c7a9f61a8d38da$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f6c7a9f61a8d38da$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f6c7a9f61a8d38da$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f6c7a9f61a8d38da$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f6c7a9f61a8d38da$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f6c7a9f61a8d38da$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f6c7a9f61a8d38da$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f6c7a9f61a8d38da$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f6c7a9f61a8d38da$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f6c7a9f61a8d38da$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f6c7a9f61a8d38da$var$lf));
function $f6c7a9f61a8d38da$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f6c7a9f61a8d38da$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $f6c7a9f61a8d38da$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f6c7a9f61a8d38da$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f6c7a9f61a8d38da$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($f6c7a9f61a8d38da$var$Qb) throw a = $f6c7a9f61a8d38da$var$Rb, $f6c7a9f61a8d38da$var$Qb = !1, $f6c7a9f61a8d38da$var$Rb = null, a;
}
function $f6c7a9f61a8d38da$var$D(a, b) {
    var c = b[$f6c7a9f61a8d38da$var$of];
    void 0 === c && (c = b[$f6c7a9f61a8d38da$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f6c7a9f61a8d38da$var$pf(b, a, 2, !1), c.add(d));
}
function $f6c7a9f61a8d38da$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f6c7a9f61a8d38da$var$pf(c, a, d, b);
}
var $f6c7a9f61a8d38da$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $f6c7a9f61a8d38da$var$sf(a) {
    if (!a[$f6c7a9f61a8d38da$var$rf]) {
        a[$f6c7a9f61a8d38da$var$rf] = !0;
        $f6c7a9f61a8d38da$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f6c7a9f61a8d38da$var$mf.has(b) || $f6c7a9f61a8d38da$var$qf(b, !1, a), $f6c7a9f61a8d38da$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f6c7a9f61a8d38da$var$rf] || (b[$f6c7a9f61a8d38da$var$rf] = !0, $f6c7a9f61a8d38da$var$qf("selectionchange", !1, b));
    }
}
function $f6c7a9f61a8d38da$var$pf(a, b, c, d) {
    switch($f6c7a9f61a8d38da$var$jd(b)){
        case 1:
            var e = $f6c7a9f61a8d38da$var$ed;
            break;
        case 4:
            e = $f6c7a9f61a8d38da$var$gd;
            break;
        default:
            e = $f6c7a9f61a8d38da$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f6c7a9f61a8d38da$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f6c7a9f61a8d38da$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f6c7a9f61a8d38da$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f6c7a9f61a8d38da$var$Jb(function() {
        var d = f, e = $f6c7a9f61a8d38da$var$xb(c), g = [];
        a: {
            var h = $f6c7a9f61a8d38da$var$df.get(a);
            if (void 0 !== h) {
                var k = $f6c7a9f61a8d38da$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $f6c7a9f61a8d38da$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f6c7a9f61a8d38da$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $f6c7a9f61a8d38da$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $f6c7a9f61a8d38da$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f6c7a9f61a8d38da$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f6c7a9f61a8d38da$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f6c7a9f61a8d38da$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f6c7a9f61a8d38da$var$Vd;
                        break;
                    case $f6c7a9f61a8d38da$var$$e:
                    case $f6c7a9f61a8d38da$var$af:
                    case $f6c7a9f61a8d38da$var$bf:
                        k = $f6c7a9f61a8d38da$var$Hd;
                        break;
                    case $f6c7a9f61a8d38da$var$cf:
                        k = $f6c7a9f61a8d38da$var$Xd;
                        break;
                    case "scroll":
                        k = $f6c7a9f61a8d38da$var$vd;
                        break;
                    case "wheel":
                        k = $f6c7a9f61a8d38da$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f6c7a9f61a8d38da$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f6c7a9f61a8d38da$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $f6c7a9f61a8d38da$var$Kb(w, x), null != F && t.push($f6c7a9f61a8d38da$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f6c7a9f61a8d38da$var$wb && (n = c.relatedTarget || c.fromElement) && ($f6c7a9f61a8d38da$var$Wc(n) || n[$f6c7a9f61a8d38da$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $f6c7a9f61a8d38da$var$Wc(n) : null, null !== n && (J = $f6c7a9f61a8d38da$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $f6c7a9f61a8d38da$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $f6c7a9f61a8d38da$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $f6c7a9f61a8d38da$var$ue(k);
                        u = null == n ? h : $f6c7a9f61a8d38da$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $f6c7a9f61a8d38da$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $f6c7a9f61a8d38da$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $f6c7a9f61a8d38da$var$vf(F))u++;
                            for(; 0 < w - u;)t = $f6c7a9f61a8d38da$var$vf(t), w--;
                            for(; 0 < u - w;)x = $f6c7a9f61a8d38da$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $f6c7a9f61a8d38da$var$vf(t);
                                x = $f6c7a9f61a8d38da$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $f6c7a9f61a8d38da$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $f6c7a9f61a8d38da$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $f6c7a9f61a8d38da$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $f6c7a9f61a8d38da$var$ve;
                else if ($f6c7a9f61a8d38da$var$me(h)) {
                    if ($f6c7a9f61a8d38da$var$we) na = $f6c7a9f61a8d38da$var$Fe;
                    else {
                        na = $f6c7a9f61a8d38da$var$De;
                        var xa = $f6c7a9f61a8d38da$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $f6c7a9f61a8d38da$var$Ee);
                if (na && (na = na(a, d))) {
                    $f6c7a9f61a8d38da$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $f6c7a9f61a8d38da$var$cb(h, "number", h.value);
            }
            xa = d ? $f6c7a9f61a8d38da$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($f6c7a9f61a8d38da$var$me(xa) || "true" === xa.contentEditable) $f6c7a9f61a8d38da$var$Qe = xa, $f6c7a9f61a8d38da$var$Re = d, $f6c7a9f61a8d38da$var$Se = null;
                    break;
                case "focusout":
                    $f6c7a9f61a8d38da$var$Se = $f6c7a9f61a8d38da$var$Re = $f6c7a9f61a8d38da$var$Qe = null;
                    break;
                case "mousedown":
                    $f6c7a9f61a8d38da$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f6c7a9f61a8d38da$var$Te = !1;
                    $f6c7a9f61a8d38da$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($f6c7a9f61a8d38da$var$Pe) break;
                case "keydown":
                case "keyup":
                    $f6c7a9f61a8d38da$var$Ue(g, c, e);
            }
            var $a;
            if ($f6c7a9f61a8d38da$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $f6c7a9f61a8d38da$var$ie ? $f6c7a9f61a8d38da$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($f6c7a9f61a8d38da$var$de && "ko" !== c.locale && ($f6c7a9f61a8d38da$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $f6c7a9f61a8d38da$var$ie && ($a = $f6c7a9f61a8d38da$var$nd()) : ($f6c7a9f61a8d38da$var$kd = e, $f6c7a9f61a8d38da$var$ld = "value" in $f6c7a9f61a8d38da$var$kd ? $f6c7a9f61a8d38da$var$kd.value : $f6c7a9f61a8d38da$var$kd.textContent, $f6c7a9f61a8d38da$var$ie = !0)), xa = $f6c7a9f61a8d38da$var$oe(d, ba), 0 < xa.length && (ba = new $f6c7a9f61a8d38da$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $f6c7a9f61a8d38da$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $f6c7a9f61a8d38da$var$ce ? $f6c7a9f61a8d38da$var$je(a, c) : $f6c7a9f61a8d38da$var$ke(a, c)) d = $f6c7a9f61a8d38da$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $f6c7a9f61a8d38da$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $f6c7a9f61a8d38da$var$se(g, b);
    });
}
function $f6c7a9f61a8d38da$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f6c7a9f61a8d38da$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f6c7a9f61a8d38da$var$Kb(a, c), null != f && d.unshift($f6c7a9f61a8d38da$var$tf(a, f, e)), f = $f6c7a9f61a8d38da$var$Kb(a, b), null != f && d.push($f6c7a9f61a8d38da$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f6c7a9f61a8d38da$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f6c7a9f61a8d38da$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f6c7a9f61a8d38da$var$Kb(c, f), null != k && g.unshift($f6c7a9f61a8d38da$var$tf(c, k, h))) : e || (k = $f6c7a9f61a8d38da$var$Kb(c, f), null != k && g.push($f6c7a9f61a8d38da$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f6c7a9f61a8d38da$var$xf = /\r\n?/g, $f6c7a9f61a8d38da$var$yf = /\u0000|\uFFFD/g;
function $f6c7a9f61a8d38da$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f6c7a9f61a8d38da$var$xf, "\n").replace($f6c7a9f61a8d38da$var$yf, "");
}
function $f6c7a9f61a8d38da$var$Af(a, b, c) {
    b = $f6c7a9f61a8d38da$var$zf(b);
    if ($f6c7a9f61a8d38da$var$zf(a) !== b && c) throw Error($f6c7a9f61a8d38da$var$p(425));
}
function $f6c7a9f61a8d38da$var$Bf() {}
var $f6c7a9f61a8d38da$var$Cf = null, $f6c7a9f61a8d38da$var$Df = null;
function $f6c7a9f61a8d38da$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f6c7a9f61a8d38da$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $f6c7a9f61a8d38da$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $f6c7a9f61a8d38da$var$Hf = "function" === typeof Promise ? Promise : void 0, $f6c7a9f61a8d38da$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f6c7a9f61a8d38da$var$Hf ? function(a) {
    return $f6c7a9f61a8d38da$var$Hf.resolve(null).then(a).catch($f6c7a9f61a8d38da$var$If);
} : $f6c7a9f61a8d38da$var$Ff;
function $f6c7a9f61a8d38da$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f6c7a9f61a8d38da$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f6c7a9f61a8d38da$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f6c7a9f61a8d38da$var$bd(b);
}
function $f6c7a9f61a8d38da$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f6c7a9f61a8d38da$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f6c7a9f61a8d38da$var$Nf = Math.random().toString(36).slice(2), $f6c7a9f61a8d38da$var$Of = "__reactFiber$" + $f6c7a9f61a8d38da$var$Nf, $f6c7a9f61a8d38da$var$Pf = "__reactProps$" + $f6c7a9f61a8d38da$var$Nf, $f6c7a9f61a8d38da$var$uf = "__reactContainer$" + $f6c7a9f61a8d38da$var$Nf, $f6c7a9f61a8d38da$var$of = "__reactEvents$" + $f6c7a9f61a8d38da$var$Nf, $f6c7a9f61a8d38da$var$Qf = "__reactListeners$" + $f6c7a9f61a8d38da$var$Nf, $f6c7a9f61a8d38da$var$Rf = "__reactHandles$" + $f6c7a9f61a8d38da$var$Nf;
function $f6c7a9f61a8d38da$var$Wc(a) {
    var b = a[$f6c7a9f61a8d38da$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f6c7a9f61a8d38da$var$uf] || c[$f6c7a9f61a8d38da$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f6c7a9f61a8d38da$var$Mf(a); null !== a;){
                if (c = a[$f6c7a9f61a8d38da$var$Of]) return c;
                a = $f6c7a9f61a8d38da$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f6c7a9f61a8d38da$var$Cb(a) {
    a = a[$f6c7a9f61a8d38da$var$Of] || a[$f6c7a9f61a8d38da$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f6c7a9f61a8d38da$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f6c7a9f61a8d38da$var$p(33));
}
function $f6c7a9f61a8d38da$var$Db(a) {
    return a[$f6c7a9f61a8d38da$var$Pf] || null;
}
var $f6c7a9f61a8d38da$var$Sf = [], $f6c7a9f61a8d38da$var$Tf = -1;
function $f6c7a9f61a8d38da$var$Uf(a) {
    return {
        current: a
    };
}
function $f6c7a9f61a8d38da$var$E(a) {
    0 > $f6c7a9f61a8d38da$var$Tf || (a.current = $f6c7a9f61a8d38da$var$Sf[$f6c7a9f61a8d38da$var$Tf], $f6c7a9f61a8d38da$var$Sf[$f6c7a9f61a8d38da$var$Tf] = null, $f6c7a9f61a8d38da$var$Tf--);
}
function $f6c7a9f61a8d38da$var$G(a, b) {
    $f6c7a9f61a8d38da$var$Tf++;
    $f6c7a9f61a8d38da$var$Sf[$f6c7a9f61a8d38da$var$Tf] = a.current;
    a.current = b;
}
var $f6c7a9f61a8d38da$var$Vf = {}, $f6c7a9f61a8d38da$var$H = $f6c7a9f61a8d38da$var$Uf($f6c7a9f61a8d38da$var$Vf), $f6c7a9f61a8d38da$var$Wf = $f6c7a9f61a8d38da$var$Uf(!1), $f6c7a9f61a8d38da$var$Xf = $f6c7a9f61a8d38da$var$Vf;
function $f6c7a9f61a8d38da$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f6c7a9f61a8d38da$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f6c7a9f61a8d38da$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f6c7a9f61a8d38da$var$$f() {
    $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$Wf);
    $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$H);
}
function $f6c7a9f61a8d38da$var$ag(a, b, c) {
    if ($f6c7a9f61a8d38da$var$H.current !== $f6c7a9f61a8d38da$var$Vf) throw Error($f6c7a9f61a8d38da$var$p(168));
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$H, b);
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$Wf, c);
}
function $f6c7a9f61a8d38da$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f6c7a9f61a8d38da$var$p(108, $f6c7a9f61a8d38da$var$Ra(a) || "Unknown", e));
    return $f6c7a9f61a8d38da$var$A({}, c, d);
}
function $f6c7a9f61a8d38da$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f6c7a9f61a8d38da$var$Vf;
    $f6c7a9f61a8d38da$var$Xf = $f6c7a9f61a8d38da$var$H.current;
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$H, a);
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$Wf, $f6c7a9f61a8d38da$var$Wf.current);
    return !0;
}
function $f6c7a9f61a8d38da$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f6c7a9f61a8d38da$var$p(169));
    c ? (a = $f6c7a9f61a8d38da$var$bg(a, b, $f6c7a9f61a8d38da$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$Wf), $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$H), $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$H, a)) : $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$Wf);
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$Wf, c);
}
var $f6c7a9f61a8d38da$var$eg = null, $f6c7a9f61a8d38da$var$fg = !1, $f6c7a9f61a8d38da$var$gg = !1;
function $f6c7a9f61a8d38da$var$hg(a) {
    null === $f6c7a9f61a8d38da$var$eg ? $f6c7a9f61a8d38da$var$eg = [
        a
    ] : $f6c7a9f61a8d38da$var$eg.push(a);
}
function $f6c7a9f61a8d38da$var$ig(a) {
    $f6c7a9f61a8d38da$var$fg = !0;
    $f6c7a9f61a8d38da$var$hg(a);
}
function $f6c7a9f61a8d38da$var$jg() {
    if (!$f6c7a9f61a8d38da$var$gg && null !== $f6c7a9f61a8d38da$var$eg) {
        $f6c7a9f61a8d38da$var$gg = !0;
        var a = 0, b = $f6c7a9f61a8d38da$var$C;
        try {
            var c = $f6c7a9f61a8d38da$var$eg;
            for($f6c7a9f61a8d38da$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f6c7a9f61a8d38da$var$eg = null;
            $f6c7a9f61a8d38da$var$fg = !1;
        } catch (e) {
            throw null !== $f6c7a9f61a8d38da$var$eg && ($f6c7a9f61a8d38da$var$eg = $f6c7a9f61a8d38da$var$eg.slice(a + 1)), $f6c7a9f61a8d38da$var$ac($f6c7a9f61a8d38da$var$fc, $f6c7a9f61a8d38da$var$jg), e;
        } finally{
            $f6c7a9f61a8d38da$var$C = b, $f6c7a9f61a8d38da$var$gg = !1;
        }
    }
    return null;
}
var $f6c7a9f61a8d38da$var$kg = [], $f6c7a9f61a8d38da$var$lg = 0, $f6c7a9f61a8d38da$var$mg = null, $f6c7a9f61a8d38da$var$ng = 0, $f6c7a9f61a8d38da$var$og = [], $f6c7a9f61a8d38da$var$pg = 0, $f6c7a9f61a8d38da$var$qg = null, $f6c7a9f61a8d38da$var$rg = 1, $f6c7a9f61a8d38da$var$sg = "";
function $f6c7a9f61a8d38da$var$tg(a, b) {
    $f6c7a9f61a8d38da$var$kg[$f6c7a9f61a8d38da$var$lg++] = $f6c7a9f61a8d38da$var$ng;
    $f6c7a9f61a8d38da$var$kg[$f6c7a9f61a8d38da$var$lg++] = $f6c7a9f61a8d38da$var$mg;
    $f6c7a9f61a8d38da$var$mg = a;
    $f6c7a9f61a8d38da$var$ng = b;
}
function $f6c7a9f61a8d38da$var$ug(a, b, c) {
    $f6c7a9f61a8d38da$var$og[$f6c7a9f61a8d38da$var$pg++] = $f6c7a9f61a8d38da$var$rg;
    $f6c7a9f61a8d38da$var$og[$f6c7a9f61a8d38da$var$pg++] = $f6c7a9f61a8d38da$var$sg;
    $f6c7a9f61a8d38da$var$og[$f6c7a9f61a8d38da$var$pg++] = $f6c7a9f61a8d38da$var$qg;
    $f6c7a9f61a8d38da$var$qg = a;
    var d = $f6c7a9f61a8d38da$var$rg;
    a = $f6c7a9f61a8d38da$var$sg;
    var e = 32 - $f6c7a9f61a8d38da$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f6c7a9f61a8d38da$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f6c7a9f61a8d38da$var$rg = 1 << 32 - $f6c7a9f61a8d38da$var$oc(b) + e | c << e | d;
        $f6c7a9f61a8d38da$var$sg = f + a;
    } else $f6c7a9f61a8d38da$var$rg = 1 << f | c << e | d, $f6c7a9f61a8d38da$var$sg = a;
}
function $f6c7a9f61a8d38da$var$vg(a) {
    null !== a.return && ($f6c7a9f61a8d38da$var$tg(a, 1), $f6c7a9f61a8d38da$var$ug(a, 1, 0));
}
function $f6c7a9f61a8d38da$var$wg(a) {
    for(; a === $f6c7a9f61a8d38da$var$mg;)$f6c7a9f61a8d38da$var$mg = $f6c7a9f61a8d38da$var$kg[--$f6c7a9f61a8d38da$var$lg], $f6c7a9f61a8d38da$var$kg[$f6c7a9f61a8d38da$var$lg] = null, $f6c7a9f61a8d38da$var$ng = $f6c7a9f61a8d38da$var$kg[--$f6c7a9f61a8d38da$var$lg], $f6c7a9f61a8d38da$var$kg[$f6c7a9f61a8d38da$var$lg] = null;
    for(; a === $f6c7a9f61a8d38da$var$qg;)$f6c7a9f61a8d38da$var$qg = $f6c7a9f61a8d38da$var$og[--$f6c7a9f61a8d38da$var$pg], $f6c7a9f61a8d38da$var$og[$f6c7a9f61a8d38da$var$pg] = null, $f6c7a9f61a8d38da$var$sg = $f6c7a9f61a8d38da$var$og[--$f6c7a9f61a8d38da$var$pg], $f6c7a9f61a8d38da$var$og[$f6c7a9f61a8d38da$var$pg] = null, $f6c7a9f61a8d38da$var$rg = $f6c7a9f61a8d38da$var$og[--$f6c7a9f61a8d38da$var$pg], $f6c7a9f61a8d38da$var$og[$f6c7a9f61a8d38da$var$pg] = null;
}
var $f6c7a9f61a8d38da$var$xg = null, $f6c7a9f61a8d38da$var$yg = null, $f6c7a9f61a8d38da$var$I = !1, $f6c7a9f61a8d38da$var$zg = null;
function $f6c7a9f61a8d38da$var$Ag(a, b) {
    var c = $f6c7a9f61a8d38da$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f6c7a9f61a8d38da$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f6c7a9f61a8d38da$var$xg = a, $f6c7a9f61a8d38da$var$yg = $f6c7a9f61a8d38da$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f6c7a9f61a8d38da$var$xg = a, $f6c7a9f61a8d38da$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f6c7a9f61a8d38da$var$qg ? {
                id: $f6c7a9f61a8d38da$var$rg,
                overflow: $f6c7a9f61a8d38da$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f6c7a9f61a8d38da$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f6c7a9f61a8d38da$var$xg = a, $f6c7a9f61a8d38da$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $f6c7a9f61a8d38da$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f6c7a9f61a8d38da$var$Eg(a) {
    if ($f6c7a9f61a8d38da$var$I) {
        var b = $f6c7a9f61a8d38da$var$yg;
        if (b) {
            var c = b;
            if (!$f6c7a9f61a8d38da$var$Cg(a, b)) {
                if ($f6c7a9f61a8d38da$var$Dg(a)) throw Error($f6c7a9f61a8d38da$var$p(418));
                b = $f6c7a9f61a8d38da$var$Lf(c.nextSibling);
                var d = $f6c7a9f61a8d38da$var$xg;
                b && $f6c7a9f61a8d38da$var$Cg(a, b) ? $f6c7a9f61a8d38da$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $f6c7a9f61a8d38da$var$I = !1, $f6c7a9f61a8d38da$var$xg = a);
            }
        } else {
            if ($f6c7a9f61a8d38da$var$Dg(a)) throw Error($f6c7a9f61a8d38da$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f6c7a9f61a8d38da$var$I = !1;
            $f6c7a9f61a8d38da$var$xg = a;
        }
    }
}
function $f6c7a9f61a8d38da$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f6c7a9f61a8d38da$var$xg = a;
}
function $f6c7a9f61a8d38da$var$Gg(a) {
    if (a !== $f6c7a9f61a8d38da$var$xg) return !1;
    if (!$f6c7a9f61a8d38da$var$I) return $f6c7a9f61a8d38da$var$Fg(a), $f6c7a9f61a8d38da$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f6c7a9f61a8d38da$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $f6c7a9f61a8d38da$var$yg)) {
        if ($f6c7a9f61a8d38da$var$Dg(a)) throw $f6c7a9f61a8d38da$var$Hg(), Error($f6c7a9f61a8d38da$var$p(418));
        for(; b;)$f6c7a9f61a8d38da$var$Ag(a, b), b = $f6c7a9f61a8d38da$var$Lf(b.nextSibling);
    }
    $f6c7a9f61a8d38da$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f6c7a9f61a8d38da$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f6c7a9f61a8d38da$var$yg = $f6c7a9f61a8d38da$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f6c7a9f61a8d38da$var$yg = null;
        }
    } else $f6c7a9f61a8d38da$var$yg = $f6c7a9f61a8d38da$var$xg ? $f6c7a9f61a8d38da$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f6c7a9f61a8d38da$var$Hg() {
    for(var a = $f6c7a9f61a8d38da$var$yg; a;)a = $f6c7a9f61a8d38da$var$Lf(a.nextSibling);
}
function $f6c7a9f61a8d38da$var$Ig() {
    $f6c7a9f61a8d38da$var$yg = $f6c7a9f61a8d38da$var$xg = null;
    $f6c7a9f61a8d38da$var$I = !1;
}
function $f6c7a9f61a8d38da$var$Jg(a) {
    null === $f6c7a9f61a8d38da$var$zg ? $f6c7a9f61a8d38da$var$zg = [
        a
    ] : $f6c7a9f61a8d38da$var$zg.push(a);
}
var $f6c7a9f61a8d38da$var$Kg = $f6c7a9f61a8d38da$var$ua.ReactCurrentBatchConfig;
function $f6c7a9f61a8d38da$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f6c7a9f61a8d38da$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f6c7a9f61a8d38da$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f6c7a9f61a8d38da$var$p(284));
        if (!c._owner) throw Error($f6c7a9f61a8d38da$var$p(290, a));
    }
    return a;
}
function $f6c7a9f61a8d38da$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f6c7a9f61a8d38da$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f6c7a9f61a8d38da$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $f6c7a9f61a8d38da$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f6c7a9f61a8d38da$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f6c7a9f61a8d38da$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f6c7a9f61a8d38da$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f6c7a9f61a8d38da$var$Ha && $f6c7a9f61a8d38da$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $f6c7a9f61a8d38da$var$Lg(a, b, c), d.return = a, d;
        d = $f6c7a9f61a8d38da$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f6c7a9f61a8d38da$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f6c7a9f61a8d38da$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f6c7a9f61a8d38da$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f6c7a9f61a8d38da$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f6c7a9f61a8d38da$var$va:
                    return c = $f6c7a9f61a8d38da$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $f6c7a9f61a8d38da$var$Lg(a, null, b), c.return = a, c;
                case $f6c7a9f61a8d38da$var$wa:
                    return b = $f6c7a9f61a8d38da$var$Sg(b, a.mode, c), b.return = a, b;
                case $f6c7a9f61a8d38da$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($f6c7a9f61a8d38da$var$eb(b) || $f6c7a9f61a8d38da$var$Ka(b)) return b = $f6c7a9f61a8d38da$var$Tg(b, a.mode, c, null), b.return = a, b;
            $f6c7a9f61a8d38da$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f6c7a9f61a8d38da$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f6c7a9f61a8d38da$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f6c7a9f61a8d38da$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($f6c7a9f61a8d38da$var$eb(c) || $f6c7a9f61a8d38da$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $f6c7a9f61a8d38da$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f6c7a9f61a8d38da$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f6c7a9f61a8d38da$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f6c7a9f61a8d38da$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f6c7a9f61a8d38da$var$eb(d) || $f6c7a9f61a8d38da$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $f6c7a9f61a8d38da$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $f6c7a9f61a8d38da$var$I && $f6c7a9f61a8d38da$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $f6c7a9f61a8d38da$var$I && $f6c7a9f61a8d38da$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $f6c7a9f61a8d38da$var$I && $f6c7a9f61a8d38da$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $f6c7a9f61a8d38da$var$Ka(h);
        if ("function" !== typeof l) throw Error($f6c7a9f61a8d38da$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f6c7a9f61a8d38da$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $f6c7a9f61a8d38da$var$I && $f6c7a9f61a8d38da$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $f6c7a9f61a8d38da$var$I && $f6c7a9f61a8d38da$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f6c7a9f61a8d38da$var$I && $f6c7a9f61a8d38da$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f6c7a9f61a8d38da$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f6c7a9f61a8d38da$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f6c7a9f61a8d38da$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f6c7a9f61a8d38da$var$Ha && $f6c7a9f61a8d38da$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f6c7a9f61a8d38da$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f6c7a9f61a8d38da$var$ya ? (d = $f6c7a9f61a8d38da$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f6c7a9f61a8d38da$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $f6c7a9f61a8d38da$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f6c7a9f61a8d38da$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f6c7a9f61a8d38da$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f6c7a9f61a8d38da$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f6c7a9f61a8d38da$var$eb(f)) return n(a, d, f, h);
            if ($f6c7a9f61a8d38da$var$Ka(f)) return t(a, d, f, h);
            $f6c7a9f61a8d38da$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f6c7a9f61a8d38da$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f6c7a9f61a8d38da$var$Ug = $f6c7a9f61a8d38da$var$Og(!0), $f6c7a9f61a8d38da$var$Vg = $f6c7a9f61a8d38da$var$Og(!1), $f6c7a9f61a8d38da$var$Wg = $f6c7a9f61a8d38da$var$Uf(null), $f6c7a9f61a8d38da$var$Xg = null, $f6c7a9f61a8d38da$var$Yg = null, $f6c7a9f61a8d38da$var$Zg = null;
function $f6c7a9f61a8d38da$var$$g() {
    $f6c7a9f61a8d38da$var$Zg = $f6c7a9f61a8d38da$var$Yg = $f6c7a9f61a8d38da$var$Xg = null;
}
function $f6c7a9f61a8d38da$var$ah(a) {
    var b = $f6c7a9f61a8d38da$var$Wg.current;
    $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$Wg);
    a._currentValue = b;
}
function $f6c7a9f61a8d38da$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f6c7a9f61a8d38da$var$ch(a, b) {
    $f6c7a9f61a8d38da$var$Xg = a;
    $f6c7a9f61a8d38da$var$Zg = $f6c7a9f61a8d38da$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f6c7a9f61a8d38da$var$dh = !0), a.firstContext = null);
}
function $f6c7a9f61a8d38da$var$eh(a) {
    var b = a._currentValue;
    if ($f6c7a9f61a8d38da$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f6c7a9f61a8d38da$var$Yg) {
            if (null === $f6c7a9f61a8d38da$var$Xg) throw Error($f6c7a9f61a8d38da$var$p(308));
            $f6c7a9f61a8d38da$var$Yg = a;
            $f6c7a9f61a8d38da$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f6c7a9f61a8d38da$var$Yg = $f6c7a9f61a8d38da$var$Yg.next = a;
    }
    return b;
}
var $f6c7a9f61a8d38da$var$fh = null;
function $f6c7a9f61a8d38da$var$gh(a) {
    null === $f6c7a9f61a8d38da$var$fh ? $f6c7a9f61a8d38da$var$fh = [
        a
    ] : $f6c7a9f61a8d38da$var$fh.push(a);
}
function $f6c7a9f61a8d38da$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $f6c7a9f61a8d38da$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $f6c7a9f61a8d38da$var$ih(a, d);
}
function $f6c7a9f61a8d38da$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $f6c7a9f61a8d38da$var$jh = !1;
function $f6c7a9f61a8d38da$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f6c7a9f61a8d38da$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f6c7a9f61a8d38da$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f6c7a9f61a8d38da$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($f6c7a9f61a8d38da$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $f6c7a9f61a8d38da$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $f6c7a9f61a8d38da$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $f6c7a9f61a8d38da$var$ih(a, c);
}
function $f6c7a9f61a8d38da$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f6c7a9f61a8d38da$var$Cc(a, c);
    }
}
function $f6c7a9f61a8d38da$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f6c7a9f61a8d38da$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $f6c7a9f61a8d38da$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $f6c7a9f61a8d38da$var$A({}, q, r);
                            break a;
                        case 2:
                            $f6c7a9f61a8d38da$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f6c7a9f61a8d38da$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $f6c7a9f61a8d38da$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f6c7a9f61a8d38da$var$p(191, e));
            e.call(d);
        }
    }
}
var $f6c7a9f61a8d38da$var$th = {}, $f6c7a9f61a8d38da$var$uh = $f6c7a9f61a8d38da$var$Uf($f6c7a9f61a8d38da$var$th), $f6c7a9f61a8d38da$var$vh = $f6c7a9f61a8d38da$var$Uf($f6c7a9f61a8d38da$var$th), $f6c7a9f61a8d38da$var$wh = $f6c7a9f61a8d38da$var$Uf($f6c7a9f61a8d38da$var$th);
function $f6c7a9f61a8d38da$var$xh(a) {
    if (a === $f6c7a9f61a8d38da$var$th) throw Error($f6c7a9f61a8d38da$var$p(174));
    return a;
}
function $f6c7a9f61a8d38da$var$yh(a, b) {
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$wh, b);
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$vh, a);
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$uh, $f6c7a9f61a8d38da$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f6c7a9f61a8d38da$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f6c7a9f61a8d38da$var$lb(b, a);
    }
    $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$uh);
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$uh, b);
}
function $f6c7a9f61a8d38da$var$zh() {
    $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$uh);
    $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$vh);
    $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$wh);
}
function $f6c7a9f61a8d38da$var$Ah(a) {
    $f6c7a9f61a8d38da$var$xh($f6c7a9f61a8d38da$var$wh.current);
    var b = $f6c7a9f61a8d38da$var$xh($f6c7a9f61a8d38da$var$uh.current);
    var c = $f6c7a9f61a8d38da$var$lb(b, a.type);
    b !== c && ($f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$vh, a), $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$uh, c));
}
function $f6c7a9f61a8d38da$var$Bh(a) {
    $f6c7a9f61a8d38da$var$vh.current === a && ($f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$uh), $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$vh));
}
var $f6c7a9f61a8d38da$var$L = $f6c7a9f61a8d38da$var$Uf(0);
function $f6c7a9f61a8d38da$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f6c7a9f61a8d38da$var$Dh = [];
function $f6c7a9f61a8d38da$var$Eh() {
    for(var a = 0; a < $f6c7a9f61a8d38da$var$Dh.length; a++)$f6c7a9f61a8d38da$var$Dh[a]._workInProgressVersionPrimary = null;
    $f6c7a9f61a8d38da$var$Dh.length = 0;
}
var $f6c7a9f61a8d38da$var$Fh = $f6c7a9f61a8d38da$var$ua.ReactCurrentDispatcher, $f6c7a9f61a8d38da$var$Gh = $f6c7a9f61a8d38da$var$ua.ReactCurrentBatchConfig, $f6c7a9f61a8d38da$var$Hh = 0, $f6c7a9f61a8d38da$var$M = null, $f6c7a9f61a8d38da$var$N = null, $f6c7a9f61a8d38da$var$O = null, $f6c7a9f61a8d38da$var$Ih = !1, $f6c7a9f61a8d38da$var$Jh = !1, $f6c7a9f61a8d38da$var$Kh = 0, $f6c7a9f61a8d38da$var$Lh = 0;
function $f6c7a9f61a8d38da$var$P() {
    throw Error($f6c7a9f61a8d38da$var$p(321));
}
function $f6c7a9f61a8d38da$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f6c7a9f61a8d38da$var$He(a[c], b[c])) return !1;
    return !0;
}
function $f6c7a9f61a8d38da$var$Nh(a, b, c, d, e, f) {
    $f6c7a9f61a8d38da$var$Hh = f;
    $f6c7a9f61a8d38da$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f6c7a9f61a8d38da$var$Fh.current = null === a || null === a.memoizedState ? $f6c7a9f61a8d38da$var$Oh : $f6c7a9f61a8d38da$var$Ph;
    a = c(d, e);
    if ($f6c7a9f61a8d38da$var$Jh) {
        f = 0;
        do {
            $f6c7a9f61a8d38da$var$Jh = !1;
            $f6c7a9f61a8d38da$var$Kh = 0;
            if (25 <= f) throw Error($f6c7a9f61a8d38da$var$p(301));
            f += 1;
            $f6c7a9f61a8d38da$var$O = $f6c7a9f61a8d38da$var$N = null;
            b.updateQueue = null;
            $f6c7a9f61a8d38da$var$Fh.current = $f6c7a9f61a8d38da$var$Qh;
            a = c(d, e);
        }while ($f6c7a9f61a8d38da$var$Jh);
    }
    $f6c7a9f61a8d38da$var$Fh.current = $f6c7a9f61a8d38da$var$Rh;
    b = null !== $f6c7a9f61a8d38da$var$N && null !== $f6c7a9f61a8d38da$var$N.next;
    $f6c7a9f61a8d38da$var$Hh = 0;
    $f6c7a9f61a8d38da$var$O = $f6c7a9f61a8d38da$var$N = $f6c7a9f61a8d38da$var$M = null;
    $f6c7a9f61a8d38da$var$Ih = !1;
    if (b) throw Error($f6c7a9f61a8d38da$var$p(300));
    return a;
}
function $f6c7a9f61a8d38da$var$Sh() {
    var a = 0 !== $f6c7a9f61a8d38da$var$Kh;
    $f6c7a9f61a8d38da$var$Kh = 0;
    return a;
}
function $f6c7a9f61a8d38da$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f6c7a9f61a8d38da$var$O ? $f6c7a9f61a8d38da$var$M.memoizedState = $f6c7a9f61a8d38da$var$O = a : $f6c7a9f61a8d38da$var$O = $f6c7a9f61a8d38da$var$O.next = a;
    return $f6c7a9f61a8d38da$var$O;
}
function $f6c7a9f61a8d38da$var$Uh() {
    if (null === $f6c7a9f61a8d38da$var$N) {
        var a = $f6c7a9f61a8d38da$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f6c7a9f61a8d38da$var$N.next;
    var b = null === $f6c7a9f61a8d38da$var$O ? $f6c7a9f61a8d38da$var$M.memoizedState : $f6c7a9f61a8d38da$var$O.next;
    if (null !== b) $f6c7a9f61a8d38da$var$O = b, $f6c7a9f61a8d38da$var$N = a;
    else {
        if (null === a) throw Error($f6c7a9f61a8d38da$var$p(310));
        $f6c7a9f61a8d38da$var$N = a;
        a = {
            memoizedState: $f6c7a9f61a8d38da$var$N.memoizedState,
            baseState: $f6c7a9f61a8d38da$var$N.baseState,
            baseQueue: $f6c7a9f61a8d38da$var$N.baseQueue,
            queue: $f6c7a9f61a8d38da$var$N.queue,
            next: null
        };
        null === $f6c7a9f61a8d38da$var$O ? $f6c7a9f61a8d38da$var$M.memoizedState = $f6c7a9f61a8d38da$var$O = a : $f6c7a9f61a8d38da$var$O = $f6c7a9f61a8d38da$var$O.next = a;
    }
    return $f6c7a9f61a8d38da$var$O;
}
function $f6c7a9f61a8d38da$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f6c7a9f61a8d38da$var$Wh(a) {
    var b = $f6c7a9f61a8d38da$var$Uh(), c = b.queue;
    if (null === c) throw Error($f6c7a9f61a8d38da$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f6c7a9f61a8d38da$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($f6c7a9f61a8d38da$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $f6c7a9f61a8d38da$var$M.lanes |= m;
                $f6c7a9f61a8d38da$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f6c7a9f61a8d38da$var$He(d, b.memoizedState) || ($f6c7a9f61a8d38da$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f6c7a9f61a8d38da$var$M.lanes |= f, $f6c7a9f61a8d38da$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f6c7a9f61a8d38da$var$Xh(a) {
    var b = $f6c7a9f61a8d38da$var$Uh(), c = b.queue;
    if (null === c) throw Error($f6c7a9f61a8d38da$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f6c7a9f61a8d38da$var$He(f, b.memoizedState) || ($f6c7a9f61a8d38da$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f6c7a9f61a8d38da$var$Yh() {}
function $f6c7a9f61a8d38da$var$Zh(a, b) {
    var c = $f6c7a9f61a8d38da$var$M, d = $f6c7a9f61a8d38da$var$Uh(), e = b(), f = !$f6c7a9f61a8d38da$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $f6c7a9f61a8d38da$var$dh = !0);
    d = d.queue;
    $f6c7a9f61a8d38da$var$$h($f6c7a9f61a8d38da$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f6c7a9f61a8d38da$var$O && $f6c7a9f61a8d38da$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f6c7a9f61a8d38da$var$bi(9, $f6c7a9f61a8d38da$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $f6c7a9f61a8d38da$var$Q) throw Error($f6c7a9f61a8d38da$var$p(349));
        0 !== ($f6c7a9f61a8d38da$var$Hh & 30) || $f6c7a9f61a8d38da$var$di(c, b, e);
    }
    return e;
}
function $f6c7a9f61a8d38da$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f6c7a9f61a8d38da$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f6c7a9f61a8d38da$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f6c7a9f61a8d38da$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f6c7a9f61a8d38da$var$ei(b) && $f6c7a9f61a8d38da$var$fi(a);
}
function $f6c7a9f61a8d38da$var$ai(a, b, c) {
    return c(function() {
        $f6c7a9f61a8d38da$var$ei(b) && $f6c7a9f61a8d38da$var$fi(a);
    });
}
function $f6c7a9f61a8d38da$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f6c7a9f61a8d38da$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $f6c7a9f61a8d38da$var$fi(a) {
    var b = $f6c7a9f61a8d38da$var$ih(a, 1);
    null !== b && $f6c7a9f61a8d38da$var$gi(b, a, 1, -1);
}
function $f6c7a9f61a8d38da$var$hi(a) {
    var b = $f6c7a9f61a8d38da$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f6c7a9f61a8d38da$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f6c7a9f61a8d38da$var$ii.bind(null, $f6c7a9f61a8d38da$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f6c7a9f61a8d38da$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f6c7a9f61a8d38da$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f6c7a9f61a8d38da$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f6c7a9f61a8d38da$var$ji() {
    return $f6c7a9f61a8d38da$var$Uh().memoizedState;
}
function $f6c7a9f61a8d38da$var$ki(a, b, c, d) {
    var e = $f6c7a9f61a8d38da$var$Th();
    $f6c7a9f61a8d38da$var$M.flags |= a;
    e.memoizedState = $f6c7a9f61a8d38da$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f6c7a9f61a8d38da$var$li(a, b, c, d) {
    var e = $f6c7a9f61a8d38da$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f6c7a9f61a8d38da$var$N) {
        var g = $f6c7a9f61a8d38da$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $f6c7a9f61a8d38da$var$Mh(d, g.deps)) {
            e.memoizedState = $f6c7a9f61a8d38da$var$bi(b, c, f, d);
            return;
        }
    }
    $f6c7a9f61a8d38da$var$M.flags |= a;
    e.memoizedState = $f6c7a9f61a8d38da$var$bi(1 | b, c, f, d);
}
function $f6c7a9f61a8d38da$var$mi(a, b) {
    return $f6c7a9f61a8d38da$var$ki(8390656, 8, a, b);
}
function $f6c7a9f61a8d38da$var$$h(a, b) {
    return $f6c7a9f61a8d38da$var$li(2048, 8, a, b);
}
function $f6c7a9f61a8d38da$var$ni(a, b) {
    return $f6c7a9f61a8d38da$var$li(4, 2, a, b);
}
function $f6c7a9f61a8d38da$var$oi(a, b) {
    return $f6c7a9f61a8d38da$var$li(4, 4, a, b);
}
function $f6c7a9f61a8d38da$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f6c7a9f61a8d38da$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f6c7a9f61a8d38da$var$li(4, 4, $f6c7a9f61a8d38da$var$pi.bind(null, b, a), c);
}
function $f6c7a9f61a8d38da$var$ri() {}
function $f6c7a9f61a8d38da$var$si(a, b) {
    var c = $f6c7a9f61a8d38da$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f6c7a9f61a8d38da$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f6c7a9f61a8d38da$var$ti(a, b) {
    var c = $f6c7a9f61a8d38da$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f6c7a9f61a8d38da$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f6c7a9f61a8d38da$var$ui(a, b, c) {
    if (0 === ($f6c7a9f61a8d38da$var$Hh & 21)) return a.baseState && (a.baseState = !1, $f6c7a9f61a8d38da$var$dh = !0), a.memoizedState = c;
    $f6c7a9f61a8d38da$var$He(c, b) || (c = $f6c7a9f61a8d38da$var$yc(), $f6c7a9f61a8d38da$var$M.lanes |= c, $f6c7a9f61a8d38da$var$rh |= c, a.baseState = !0);
    return b;
}
function $f6c7a9f61a8d38da$var$vi(a, b) {
    var c = $f6c7a9f61a8d38da$var$C;
    $f6c7a9f61a8d38da$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f6c7a9f61a8d38da$var$Gh.transition;
    $f6c7a9f61a8d38da$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f6c7a9f61a8d38da$var$C = c, $f6c7a9f61a8d38da$var$Gh.transition = d;
    }
}
function $f6c7a9f61a8d38da$var$wi() {
    return $f6c7a9f61a8d38da$var$Uh().memoizedState;
}
function $f6c7a9f61a8d38da$var$xi(a, b, c) {
    var d = $f6c7a9f61a8d38da$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f6c7a9f61a8d38da$var$zi(a)) $f6c7a9f61a8d38da$var$Ai(b, c);
    else if (c = $f6c7a9f61a8d38da$var$hh(a, b, c, d), null !== c) {
        var e = $f6c7a9f61a8d38da$var$R();
        $f6c7a9f61a8d38da$var$gi(c, a, d, e);
        $f6c7a9f61a8d38da$var$Bi(c, b, d);
    }
}
function $f6c7a9f61a8d38da$var$ii(a, b, c) {
    var d = $f6c7a9f61a8d38da$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f6c7a9f61a8d38da$var$zi(a)) $f6c7a9f61a8d38da$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f6c7a9f61a8d38da$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $f6c7a9f61a8d38da$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $f6c7a9f61a8d38da$var$hh(a, b, e, d);
        null !== c && (e = $f6c7a9f61a8d38da$var$R(), $f6c7a9f61a8d38da$var$gi(c, a, d, e), $f6c7a9f61a8d38da$var$Bi(c, b, d));
    }
}
function $f6c7a9f61a8d38da$var$zi(a) {
    var b = a.alternate;
    return a === $f6c7a9f61a8d38da$var$M || null !== b && b === $f6c7a9f61a8d38da$var$M;
}
function $f6c7a9f61a8d38da$var$Ai(a, b) {
    $f6c7a9f61a8d38da$var$Jh = $f6c7a9f61a8d38da$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f6c7a9f61a8d38da$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f6c7a9f61a8d38da$var$Cc(a, c);
    }
}
var $f6c7a9f61a8d38da$var$Rh = {
    readContext: $f6c7a9f61a8d38da$var$eh,
    useCallback: $f6c7a9f61a8d38da$var$P,
    useContext: $f6c7a9f61a8d38da$var$P,
    useEffect: $f6c7a9f61a8d38da$var$P,
    useImperativeHandle: $f6c7a9f61a8d38da$var$P,
    useInsertionEffect: $f6c7a9f61a8d38da$var$P,
    useLayoutEffect: $f6c7a9f61a8d38da$var$P,
    useMemo: $f6c7a9f61a8d38da$var$P,
    useReducer: $f6c7a9f61a8d38da$var$P,
    useRef: $f6c7a9f61a8d38da$var$P,
    useState: $f6c7a9f61a8d38da$var$P,
    useDebugValue: $f6c7a9f61a8d38da$var$P,
    useDeferredValue: $f6c7a9f61a8d38da$var$P,
    useTransition: $f6c7a9f61a8d38da$var$P,
    useMutableSource: $f6c7a9f61a8d38da$var$P,
    useSyncExternalStore: $f6c7a9f61a8d38da$var$P,
    useId: $f6c7a9f61a8d38da$var$P,
    unstable_isNewReconciler: !1
}, $f6c7a9f61a8d38da$var$Oh = {
    readContext: $f6c7a9f61a8d38da$var$eh,
    useCallback: function(a, b) {
        $f6c7a9f61a8d38da$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f6c7a9f61a8d38da$var$eh,
    useEffect: $f6c7a9f61a8d38da$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f6c7a9f61a8d38da$var$ki(4194308, 4, $f6c7a9f61a8d38da$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f6c7a9f61a8d38da$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f6c7a9f61a8d38da$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f6c7a9f61a8d38da$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f6c7a9f61a8d38da$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f6c7a9f61a8d38da$var$xi.bind(null, $f6c7a9f61a8d38da$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f6c7a9f61a8d38da$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f6c7a9f61a8d38da$var$hi,
    useDebugValue: $f6c7a9f61a8d38da$var$ri,
    useDeferredValue: function(a) {
        return $f6c7a9f61a8d38da$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $f6c7a9f61a8d38da$var$hi(!1), b = a[0];
        a = $f6c7a9f61a8d38da$var$vi.bind(null, a[1]);
        $f6c7a9f61a8d38da$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f6c7a9f61a8d38da$var$M, e = $f6c7a9f61a8d38da$var$Th();
        if ($f6c7a9f61a8d38da$var$I) {
            if (void 0 === c) throw Error($f6c7a9f61a8d38da$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f6c7a9f61a8d38da$var$Q) throw Error($f6c7a9f61a8d38da$var$p(349));
            0 !== ($f6c7a9f61a8d38da$var$Hh & 30) || $f6c7a9f61a8d38da$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f6c7a9f61a8d38da$var$mi($f6c7a9f61a8d38da$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f6c7a9f61a8d38da$var$bi(9, $f6c7a9f61a8d38da$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f6c7a9f61a8d38da$var$Th(), b = $f6c7a9f61a8d38da$var$Q.identifierPrefix;
        if ($f6c7a9f61a8d38da$var$I) {
            var c = $f6c7a9f61a8d38da$var$sg;
            var d = $f6c7a9f61a8d38da$var$rg;
            c = (d & ~(1 << 32 - $f6c7a9f61a8d38da$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f6c7a9f61a8d38da$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f6c7a9f61a8d38da$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f6c7a9f61a8d38da$var$Ph = {
    readContext: $f6c7a9f61a8d38da$var$eh,
    useCallback: $f6c7a9f61a8d38da$var$si,
    useContext: $f6c7a9f61a8d38da$var$eh,
    useEffect: $f6c7a9f61a8d38da$var$$h,
    useImperativeHandle: $f6c7a9f61a8d38da$var$qi,
    useInsertionEffect: $f6c7a9f61a8d38da$var$ni,
    useLayoutEffect: $f6c7a9f61a8d38da$var$oi,
    useMemo: $f6c7a9f61a8d38da$var$ti,
    useReducer: $f6c7a9f61a8d38da$var$Wh,
    useRef: $f6c7a9f61a8d38da$var$ji,
    useState: function() {
        return $f6c7a9f61a8d38da$var$Wh($f6c7a9f61a8d38da$var$Vh);
    },
    useDebugValue: $f6c7a9f61a8d38da$var$ri,
    useDeferredValue: function(a) {
        var b = $f6c7a9f61a8d38da$var$Uh();
        return $f6c7a9f61a8d38da$var$ui(b, $f6c7a9f61a8d38da$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f6c7a9f61a8d38da$var$Wh($f6c7a9f61a8d38da$var$Vh)[0], b = $f6c7a9f61a8d38da$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f6c7a9f61a8d38da$var$Yh,
    useSyncExternalStore: $f6c7a9f61a8d38da$var$Zh,
    useId: $f6c7a9f61a8d38da$var$wi,
    unstable_isNewReconciler: !1
}, $f6c7a9f61a8d38da$var$Qh = {
    readContext: $f6c7a9f61a8d38da$var$eh,
    useCallback: $f6c7a9f61a8d38da$var$si,
    useContext: $f6c7a9f61a8d38da$var$eh,
    useEffect: $f6c7a9f61a8d38da$var$$h,
    useImperativeHandle: $f6c7a9f61a8d38da$var$qi,
    useInsertionEffect: $f6c7a9f61a8d38da$var$ni,
    useLayoutEffect: $f6c7a9f61a8d38da$var$oi,
    useMemo: $f6c7a9f61a8d38da$var$ti,
    useReducer: $f6c7a9f61a8d38da$var$Xh,
    useRef: $f6c7a9f61a8d38da$var$ji,
    useState: function() {
        return $f6c7a9f61a8d38da$var$Xh($f6c7a9f61a8d38da$var$Vh);
    },
    useDebugValue: $f6c7a9f61a8d38da$var$ri,
    useDeferredValue: function(a) {
        var b = $f6c7a9f61a8d38da$var$Uh();
        return null === $f6c7a9f61a8d38da$var$N ? b.memoizedState = a : $f6c7a9f61a8d38da$var$ui(b, $f6c7a9f61a8d38da$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f6c7a9f61a8d38da$var$Xh($f6c7a9f61a8d38da$var$Vh)[0], b = $f6c7a9f61a8d38da$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f6c7a9f61a8d38da$var$Yh,
    useSyncExternalStore: $f6c7a9f61a8d38da$var$Zh,
    useId: $f6c7a9f61a8d38da$var$wi,
    unstable_isNewReconciler: !1
};
function $f6c7a9f61a8d38da$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $f6c7a9f61a8d38da$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $f6c7a9f61a8d38da$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f6c7a9f61a8d38da$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f6c7a9f61a8d38da$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f6c7a9f61a8d38da$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f6c7a9f61a8d38da$var$R(), e = $f6c7a9f61a8d38da$var$yi(a), f = $f6c7a9f61a8d38da$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f6c7a9f61a8d38da$var$nh(a, f, e);
        null !== b && ($f6c7a9f61a8d38da$var$gi(b, a, e, d), $f6c7a9f61a8d38da$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f6c7a9f61a8d38da$var$R(), e = $f6c7a9f61a8d38da$var$yi(a), f = $f6c7a9f61a8d38da$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f6c7a9f61a8d38da$var$nh(a, f, e);
        null !== b && ($f6c7a9f61a8d38da$var$gi(b, a, e, d), $f6c7a9f61a8d38da$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f6c7a9f61a8d38da$var$R(), d = $f6c7a9f61a8d38da$var$yi(a), e = $f6c7a9f61a8d38da$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $f6c7a9f61a8d38da$var$nh(a, e, d);
        null !== b && ($f6c7a9f61a8d38da$var$gi(b, a, d, c), $f6c7a9f61a8d38da$var$oh(b, a, d));
    }
};
function $f6c7a9f61a8d38da$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f6c7a9f61a8d38da$var$Ie(c, d) || !$f6c7a9f61a8d38da$var$Ie(e, f) : !0;
}
function $f6c7a9f61a8d38da$var$Gi(a, b, c) {
    var d = !1, e = $f6c7a9f61a8d38da$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f6c7a9f61a8d38da$var$eh(f) : (e = $f6c7a9f61a8d38da$var$Zf(b) ? $f6c7a9f61a8d38da$var$Xf : $f6c7a9f61a8d38da$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f6c7a9f61a8d38da$var$Yf(a, e) : $f6c7a9f61a8d38da$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f6c7a9f61a8d38da$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f6c7a9f61a8d38da$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f6c7a9f61a8d38da$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $f6c7a9f61a8d38da$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $f6c7a9f61a8d38da$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f6c7a9f61a8d38da$var$eh(f) : (f = $f6c7a9f61a8d38da$var$Zf(b) ? $f6c7a9f61a8d38da$var$Xf : $f6c7a9f61a8d38da$var$H.current, e.context = $f6c7a9f61a8d38da$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f6c7a9f61a8d38da$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f6c7a9f61a8d38da$var$Ei.enqueueReplaceState(e, e.state, null), $f6c7a9f61a8d38da$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $f6c7a9f61a8d38da$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $f6c7a9f61a8d38da$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $f6c7a9f61a8d38da$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $f6c7a9f61a8d38da$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f6c7a9f61a8d38da$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $f6c7a9f61a8d38da$var$Ni(a, b, c) {
    c = $f6c7a9f61a8d38da$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f6c7a9f61a8d38da$var$Oi || ($f6c7a9f61a8d38da$var$Oi = !0, $f6c7a9f61a8d38da$var$Pi = d);
        $f6c7a9f61a8d38da$var$Li(a, b);
    };
    return c;
}
function $f6c7a9f61a8d38da$var$Qi(a, b, c) {
    c = $f6c7a9f61a8d38da$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f6c7a9f61a8d38da$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f6c7a9f61a8d38da$var$Li(a, b);
        "function" !== typeof d && (null === $f6c7a9f61a8d38da$var$Ri ? $f6c7a9f61a8d38da$var$Ri = new Set([
            this
        ]) : $f6c7a9f61a8d38da$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f6c7a9f61a8d38da$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f6c7a9f61a8d38da$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f6c7a9f61a8d38da$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $f6c7a9f61a8d38da$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f6c7a9f61a8d38da$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f6c7a9f61a8d38da$var$mh(-1, 1), b.tag = 2, $f6c7a9f61a8d38da$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f6c7a9f61a8d38da$var$Wi = $f6c7a9f61a8d38da$var$ua.ReactCurrentOwner, $f6c7a9f61a8d38da$var$dh = !1;
function $f6c7a9f61a8d38da$var$Xi(a, b, c, d) {
    b.child = null === a ? $f6c7a9f61a8d38da$var$Vg(b, null, c, d) : $f6c7a9f61a8d38da$var$Ug(b, a.child, c, d);
}
function $f6c7a9f61a8d38da$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f6c7a9f61a8d38da$var$ch(b, e);
    d = $f6c7a9f61a8d38da$var$Nh(a, b, c, d, f, e);
    c = $f6c7a9f61a8d38da$var$Sh();
    if (null !== a && !$f6c7a9f61a8d38da$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f6c7a9f61a8d38da$var$Zi(a, b, e);
    $f6c7a9f61a8d38da$var$I && c && $f6c7a9f61a8d38da$var$vg(b);
    b.flags |= 1;
    $f6c7a9f61a8d38da$var$Xi(a, b, d, e);
    return b.child;
}
function $f6c7a9f61a8d38da$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f6c7a9f61a8d38da$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f6c7a9f61a8d38da$var$bj(a, b, f, d, e);
        a = $f6c7a9f61a8d38da$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f6c7a9f61a8d38da$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $f6c7a9f61a8d38da$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $f6c7a9f61a8d38da$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f6c7a9f61a8d38da$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f6c7a9f61a8d38da$var$Ie(f, d) && a.ref === b.ref) {
            if ($f6c7a9f61a8d38da$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f6c7a9f61a8d38da$var$dh = !0);
            else return b.lanes = a.lanes, $f6c7a9f61a8d38da$var$Zi(a, b, e);
        }
    }
    return $f6c7a9f61a8d38da$var$cj(a, b, c, d, e);
}
function $f6c7a9f61a8d38da$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$ej, $f6c7a9f61a8d38da$var$fj), $f6c7a9f61a8d38da$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$ej, $f6c7a9f61a8d38da$var$fj), $f6c7a9f61a8d38da$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$ej, $f6c7a9f61a8d38da$var$fj);
            $f6c7a9f61a8d38da$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$ej, $f6c7a9f61a8d38da$var$fj), $f6c7a9f61a8d38da$var$fj |= d;
    $f6c7a9f61a8d38da$var$Xi(a, b, e, c);
    return b.child;
}
function $f6c7a9f61a8d38da$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f6c7a9f61a8d38da$var$cj(a, b, c, d, e) {
    var f = $f6c7a9f61a8d38da$var$Zf(c) ? $f6c7a9f61a8d38da$var$Xf : $f6c7a9f61a8d38da$var$H.current;
    f = $f6c7a9f61a8d38da$var$Yf(b, f);
    $f6c7a9f61a8d38da$var$ch(b, e);
    c = $f6c7a9f61a8d38da$var$Nh(a, b, c, d, f, e);
    d = $f6c7a9f61a8d38da$var$Sh();
    if (null !== a && !$f6c7a9f61a8d38da$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f6c7a9f61a8d38da$var$Zi(a, b, e);
    $f6c7a9f61a8d38da$var$I && d && $f6c7a9f61a8d38da$var$vg(b);
    b.flags |= 1;
    $f6c7a9f61a8d38da$var$Xi(a, b, c, e);
    return b.child;
}
function $f6c7a9f61a8d38da$var$hj(a, b, c, d, e) {
    if ($f6c7a9f61a8d38da$var$Zf(c)) {
        var f = !0;
        $f6c7a9f61a8d38da$var$cg(b);
    } else f = !1;
    $f6c7a9f61a8d38da$var$ch(b, e);
    if (null === b.stateNode) $f6c7a9f61a8d38da$var$ij(a, b), $f6c7a9f61a8d38da$var$Gi(b, c, d), $f6c7a9f61a8d38da$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f6c7a9f61a8d38da$var$eh(l) : (l = $f6c7a9f61a8d38da$var$Zf(c) ? $f6c7a9f61a8d38da$var$Xf : $f6c7a9f61a8d38da$var$H.current, l = $f6c7a9f61a8d38da$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f6c7a9f61a8d38da$var$Hi(b, g, d, l);
        $f6c7a9f61a8d38da$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $f6c7a9f61a8d38da$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $f6c7a9f61a8d38da$var$Wf.current || $f6c7a9f61a8d38da$var$jh ? ("function" === typeof m && ($f6c7a9f61a8d38da$var$Di(b, c, m, d), k = b.memoizedState), (h = $f6c7a9f61a8d38da$var$jh || $f6c7a9f61a8d38da$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f6c7a9f61a8d38da$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f6c7a9f61a8d38da$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f6c7a9f61a8d38da$var$eh(k) : (k = $f6c7a9f61a8d38da$var$Zf(c) ? $f6c7a9f61a8d38da$var$Xf : $f6c7a9f61a8d38da$var$H.current, k = $f6c7a9f61a8d38da$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $f6c7a9f61a8d38da$var$Hi(b, g, d, k);
        $f6c7a9f61a8d38da$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $f6c7a9f61a8d38da$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $f6c7a9f61a8d38da$var$Wf.current || $f6c7a9f61a8d38da$var$jh ? ("function" === typeof y && ($f6c7a9f61a8d38da$var$Di(b, c, y, d), n = b.memoizedState), (l = $f6c7a9f61a8d38da$var$jh || $f6c7a9f61a8d38da$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f6c7a9f61a8d38da$var$jj(a, b, c, d, f, e);
}
function $f6c7a9f61a8d38da$var$jj(a, b, c, d, e, f) {
    $f6c7a9f61a8d38da$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f6c7a9f61a8d38da$var$dg(b, c, !1), $f6c7a9f61a8d38da$var$Zi(a, b, f);
    d = b.stateNode;
    $f6c7a9f61a8d38da$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f6c7a9f61a8d38da$var$Ug(b, a.child, null, f), b.child = $f6c7a9f61a8d38da$var$Ug(b, null, h, f)) : $f6c7a9f61a8d38da$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $f6c7a9f61a8d38da$var$dg(b, c, !0);
    return b.child;
}
function $f6c7a9f61a8d38da$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f6c7a9f61a8d38da$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f6c7a9f61a8d38da$var$ag(a, b.context, !1);
    $f6c7a9f61a8d38da$var$yh(a, b.containerInfo);
}
function $f6c7a9f61a8d38da$var$lj(a, b, c, d, e) {
    $f6c7a9f61a8d38da$var$Ig();
    $f6c7a9f61a8d38da$var$Jg(e);
    b.flags |= 256;
    $f6c7a9f61a8d38da$var$Xi(a, b, c, d);
    return b.child;
}
var $f6c7a9f61a8d38da$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f6c7a9f61a8d38da$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f6c7a9f61a8d38da$var$oj(a, b, c) {
    var d = b.pendingProps, e = $f6c7a9f61a8d38da$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$L, e & 1);
    if (null === a) {
        $f6c7a9f61a8d38da$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $f6c7a9f61a8d38da$var$pj(g, d, 0, null), a = $f6c7a9f61a8d38da$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f6c7a9f61a8d38da$var$nj(c), b.memoizedState = $f6c7a9f61a8d38da$var$mj, a) : $f6c7a9f61a8d38da$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $f6c7a9f61a8d38da$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $f6c7a9f61a8d38da$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $f6c7a9f61a8d38da$var$Pg(h, f) : (f = $f6c7a9f61a8d38da$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $f6c7a9f61a8d38da$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $f6c7a9f61a8d38da$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $f6c7a9f61a8d38da$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $f6c7a9f61a8d38da$var$qj(a, b) {
    b = $f6c7a9f61a8d38da$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f6c7a9f61a8d38da$var$sj(a, b, c, d) {
    null !== d && $f6c7a9f61a8d38da$var$Jg(d);
    $f6c7a9f61a8d38da$var$Ug(b, a.child, null, c);
    a = $f6c7a9f61a8d38da$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f6c7a9f61a8d38da$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $f6c7a9f61a8d38da$var$Ki(Error($f6c7a9f61a8d38da$var$p(422))), $f6c7a9f61a8d38da$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $f6c7a9f61a8d38da$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $f6c7a9f61a8d38da$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $f6c7a9f61a8d38da$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $f6c7a9f61a8d38da$var$nj(g);
        b.memoizedState = $f6c7a9f61a8d38da$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $f6c7a9f61a8d38da$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($f6c7a9f61a8d38da$var$p(419));
        d = $f6c7a9f61a8d38da$var$Ki(f, d, void 0);
        return $f6c7a9f61a8d38da$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($f6c7a9f61a8d38da$var$dh || h) {
        d = $f6c7a9f61a8d38da$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $f6c7a9f61a8d38da$var$ih(a, e), $f6c7a9f61a8d38da$var$gi(d, a, e, -1));
        }
        $f6c7a9f61a8d38da$var$tj();
        d = $f6c7a9f61a8d38da$var$Ki(Error($f6c7a9f61a8d38da$var$p(421)));
        return $f6c7a9f61a8d38da$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $f6c7a9f61a8d38da$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $f6c7a9f61a8d38da$var$yg = $f6c7a9f61a8d38da$var$Lf(e.nextSibling);
    $f6c7a9f61a8d38da$var$xg = b;
    $f6c7a9f61a8d38da$var$I = !0;
    $f6c7a9f61a8d38da$var$zg = null;
    null !== a && ($f6c7a9f61a8d38da$var$og[$f6c7a9f61a8d38da$var$pg++] = $f6c7a9f61a8d38da$var$rg, $f6c7a9f61a8d38da$var$og[$f6c7a9f61a8d38da$var$pg++] = $f6c7a9f61a8d38da$var$sg, $f6c7a9f61a8d38da$var$og[$f6c7a9f61a8d38da$var$pg++] = $f6c7a9f61a8d38da$var$qg, $f6c7a9f61a8d38da$var$rg = a.id, $f6c7a9f61a8d38da$var$sg = a.overflow, $f6c7a9f61a8d38da$var$qg = b);
    b = $f6c7a9f61a8d38da$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $f6c7a9f61a8d38da$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f6c7a9f61a8d38da$var$bh(a.return, b, c);
}
function $f6c7a9f61a8d38da$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f6c7a9f61a8d38da$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f6c7a9f61a8d38da$var$Xi(a, b, d.children, c);
    d = $f6c7a9f61a8d38da$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f6c7a9f61a8d38da$var$vj(a, c, b);
            else if (19 === a.tag) $f6c7a9f61a8d38da$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f6c7a9f61a8d38da$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f6c7a9f61a8d38da$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f6c7a9f61a8d38da$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f6c7a9f61a8d38da$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $f6c7a9f61a8d38da$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f6c7a9f61a8d38da$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $f6c7a9f61a8d38da$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f6c7a9f61a8d38da$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f6c7a9f61a8d38da$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f6c7a9f61a8d38da$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f6c7a9f61a8d38da$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f6c7a9f61a8d38da$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $f6c7a9f61a8d38da$var$kj(b);
            $f6c7a9f61a8d38da$var$Ig();
            break;
        case 5:
            $f6c7a9f61a8d38da$var$Ah(b);
            break;
        case 1:
            $f6c7a9f61a8d38da$var$Zf(b.type) && $f6c7a9f61a8d38da$var$cg(b);
            break;
        case 4:
            $f6c7a9f61a8d38da$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$L, $f6c7a9f61a8d38da$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f6c7a9f61a8d38da$var$oj(a, b, c);
                $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$L, $f6c7a9f61a8d38da$var$L.current & 1);
                a = $f6c7a9f61a8d38da$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$L, $f6c7a9f61a8d38da$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f6c7a9f61a8d38da$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$L, $f6c7a9f61a8d38da$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f6c7a9f61a8d38da$var$dj(a, b, c);
    }
    return $f6c7a9f61a8d38da$var$Zi(a, b, c);
}
var $f6c7a9f61a8d38da$var$zj, $f6c7a9f61a8d38da$var$Aj, $f6c7a9f61a8d38da$var$Bj, $f6c7a9f61a8d38da$var$Cj;
$f6c7a9f61a8d38da$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f6c7a9f61a8d38da$var$Aj = function() {};
$f6c7a9f61a8d38da$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f6c7a9f61a8d38da$var$xh($f6c7a9f61a8d38da$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f6c7a9f61a8d38da$var$Ya(a, e);
                d = $f6c7a9f61a8d38da$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $f6c7a9f61a8d38da$var$A({}, e, {
                    value: void 0
                });
                d = $f6c7a9f61a8d38da$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f6c7a9f61a8d38da$var$gb(a, e);
                d = $f6c7a9f61a8d38da$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f6c7a9f61a8d38da$var$Bf);
        }
        $f6c7a9f61a8d38da$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f6c7a9f61a8d38da$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f6c7a9f61a8d38da$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f6c7a9f61a8d38da$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f6c7a9f61a8d38da$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f6c7a9f61a8d38da$var$Dj(a, b) {
    if (!$f6c7a9f61a8d38da$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f6c7a9f61a8d38da$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f6c7a9f61a8d38da$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $f6c7a9f61a8d38da$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f6c7a9f61a8d38da$var$S(b), null;
        case 1:
            return $f6c7a9f61a8d38da$var$Zf(b.type) && $f6c7a9f61a8d38da$var$$f(), $f6c7a9f61a8d38da$var$S(b), null;
        case 3:
            d = b.stateNode;
            $f6c7a9f61a8d38da$var$zh();
            $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$Wf);
            $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$H);
            $f6c7a9f61a8d38da$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f6c7a9f61a8d38da$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f6c7a9f61a8d38da$var$zg && ($f6c7a9f61a8d38da$var$Fj($f6c7a9f61a8d38da$var$zg), $f6c7a9f61a8d38da$var$zg = null));
            $f6c7a9f61a8d38da$var$Aj(a, b);
            $f6c7a9f61a8d38da$var$S(b);
            return null;
        case 5:
            $f6c7a9f61a8d38da$var$Bh(b);
            var e = $f6c7a9f61a8d38da$var$xh($f6c7a9f61a8d38da$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f6c7a9f61a8d38da$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f6c7a9f61a8d38da$var$p(166));
                    $f6c7a9f61a8d38da$var$S(b);
                    return null;
                }
                a = $f6c7a9f61a8d38da$var$xh($f6c7a9f61a8d38da$var$uh.current);
                if ($f6c7a9f61a8d38da$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f6c7a9f61a8d38da$var$Of] = b;
                    d[$f6c7a9f61a8d38da$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f6c7a9f61a8d38da$var$D("cancel", d);
                            $f6c7a9f61a8d38da$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f6c7a9f61a8d38da$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f6c7a9f61a8d38da$var$lf.length; e++)$f6c7a9f61a8d38da$var$D($f6c7a9f61a8d38da$var$lf[e], d);
                            break;
                        case "source":
                            $f6c7a9f61a8d38da$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f6c7a9f61a8d38da$var$D("error", d);
                            $f6c7a9f61a8d38da$var$D("load", d);
                            break;
                        case "details":
                            $f6c7a9f61a8d38da$var$D("toggle", d);
                            break;
                        case "input":
                            $f6c7a9f61a8d38da$var$Za(d, f);
                            $f6c7a9f61a8d38da$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f6c7a9f61a8d38da$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f6c7a9f61a8d38da$var$hb(d, f), $f6c7a9f61a8d38da$var$D("invalid", d);
                    }
                    $f6c7a9f61a8d38da$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f6c7a9f61a8d38da$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f6c7a9f61a8d38da$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f6c7a9f61a8d38da$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f6c7a9f61a8d38da$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f6c7a9f61a8d38da$var$Va(d);
                            $f6c7a9f61a8d38da$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $f6c7a9f61a8d38da$var$Va(d);
                            $f6c7a9f61a8d38da$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f6c7a9f61a8d38da$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f6c7a9f61a8d38da$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f6c7a9f61a8d38da$var$Of] = b;
                    a[$f6c7a9f61a8d38da$var$Pf] = d;
                    $f6c7a9f61a8d38da$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f6c7a9f61a8d38da$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $f6c7a9f61a8d38da$var$D("cancel", a);
                                $f6c7a9f61a8d38da$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f6c7a9f61a8d38da$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f6c7a9f61a8d38da$var$lf.length; e++)$f6c7a9f61a8d38da$var$D($f6c7a9f61a8d38da$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f6c7a9f61a8d38da$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f6c7a9f61a8d38da$var$D("error", a);
                                $f6c7a9f61a8d38da$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f6c7a9f61a8d38da$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f6c7a9f61a8d38da$var$Za(a, d);
                                e = $f6c7a9f61a8d38da$var$Ya(a, d);
                                $f6c7a9f61a8d38da$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f6c7a9f61a8d38da$var$A({}, d, {
                                    value: void 0
                                });
                                $f6c7a9f61a8d38da$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f6c7a9f61a8d38da$var$hb(a, d);
                                e = $f6c7a9f61a8d38da$var$gb(a, d);
                                $f6c7a9f61a8d38da$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f6c7a9f61a8d38da$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f6c7a9f61a8d38da$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f6c7a9f61a8d38da$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f6c7a9f61a8d38da$var$ob(a, k) : "number" === typeof k && $f6c7a9f61a8d38da$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f6c7a9f61a8d38da$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f6c7a9f61a8d38da$var$D("scroll", a) : null != k && $f6c7a9f61a8d38da$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f6c7a9f61a8d38da$var$Va(a);
                                $f6c7a9f61a8d38da$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $f6c7a9f61a8d38da$var$Va(a);
                                $f6c7a9f61a8d38da$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f6c7a9f61a8d38da$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f6c7a9f61a8d38da$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f6c7a9f61a8d38da$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f6c7a9f61a8d38da$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f6c7a9f61a8d38da$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f6c7a9f61a8d38da$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f6c7a9f61a8d38da$var$p(166));
                c = $f6c7a9f61a8d38da$var$xh($f6c7a9f61a8d38da$var$wh.current);
                $f6c7a9f61a8d38da$var$xh($f6c7a9f61a8d38da$var$uh.current);
                if ($f6c7a9f61a8d38da$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f6c7a9f61a8d38da$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f6c7a9f61a8d38da$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $f6c7a9f61a8d38da$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f6c7a9f61a8d38da$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f6c7a9f61a8d38da$var$Of] = b, b.stateNode = d;
            }
            $f6c7a9f61a8d38da$var$S(b);
            return null;
        case 13:
            $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($f6c7a9f61a8d38da$var$I && null !== $f6c7a9f61a8d38da$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $f6c7a9f61a8d38da$var$Hg(), $f6c7a9f61a8d38da$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $f6c7a9f61a8d38da$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($f6c7a9f61a8d38da$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($f6c7a9f61a8d38da$var$p(317));
                        f[$f6c7a9f61a8d38da$var$Of] = b;
                    } else $f6c7a9f61a8d38da$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $f6c7a9f61a8d38da$var$S(b);
                    f = !1;
                } else null !== $f6c7a9f61a8d38da$var$zg && ($f6c7a9f61a8d38da$var$Fj($f6c7a9f61a8d38da$var$zg), $f6c7a9f61a8d38da$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f6c7a9f61a8d38da$var$L.current & 1) ? 0 === $f6c7a9f61a8d38da$var$T && ($f6c7a9f61a8d38da$var$T = 3) : $f6c7a9f61a8d38da$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $f6c7a9f61a8d38da$var$S(b);
            return null;
        case 4:
            return $f6c7a9f61a8d38da$var$zh(), $f6c7a9f61a8d38da$var$Aj(a, b), null === a && $f6c7a9f61a8d38da$var$sf(b.stateNode.containerInfo), $f6c7a9f61a8d38da$var$S(b), null;
        case 10:
            return $f6c7a9f61a8d38da$var$ah(b.type._context), $f6c7a9f61a8d38da$var$S(b), null;
        case 17:
            return $f6c7a9f61a8d38da$var$Zf(b.type) && $f6c7a9f61a8d38da$var$$f(), $f6c7a9f61a8d38da$var$S(b), null;
        case 19:
            $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$L);
            f = b.memoizedState;
            if (null === f) return $f6c7a9f61a8d38da$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f6c7a9f61a8d38da$var$Dj(f, !1);
                else {
                    if (0 !== $f6c7a9f61a8d38da$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f6c7a9f61a8d38da$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f6c7a9f61a8d38da$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$L, $f6c7a9f61a8d38da$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f6c7a9f61a8d38da$var$B() > $f6c7a9f61a8d38da$var$Gj && (b.flags |= 128, d = !0, $f6c7a9f61a8d38da$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f6c7a9f61a8d38da$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f6c7a9f61a8d38da$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f6c7a9f61a8d38da$var$I) return $f6c7a9f61a8d38da$var$S(b), null;
                    } else 2 * $f6c7a9f61a8d38da$var$B() - f.renderingStartTime > $f6c7a9f61a8d38da$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $f6c7a9f61a8d38da$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f6c7a9f61a8d38da$var$B(), b.sibling = null, c = $f6c7a9f61a8d38da$var$L.current, $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$L, d ? c & 1 | 2 : c & 1), b;
            $f6c7a9f61a8d38da$var$S(b);
            return null;
        case 22:
        case 23:
            return $f6c7a9f61a8d38da$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f6c7a9f61a8d38da$var$fj & 1073741824) && ($f6c7a9f61a8d38da$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f6c7a9f61a8d38da$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f6c7a9f61a8d38da$var$p(156, b.tag));
}
function $f6c7a9f61a8d38da$var$Ij(a, b) {
    $f6c7a9f61a8d38da$var$wg(b);
    switch(b.tag){
        case 1:
            return $f6c7a9f61a8d38da$var$Zf(b.type) && $f6c7a9f61a8d38da$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f6c7a9f61a8d38da$var$zh(), $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$Wf), $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$H), $f6c7a9f61a8d38da$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f6c7a9f61a8d38da$var$Bh(b), null;
        case 13:
            $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f6c7a9f61a8d38da$var$p(340));
                $f6c7a9f61a8d38da$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$L), null;
        case 4:
            return $f6c7a9f61a8d38da$var$zh(), null;
        case 10:
            return $f6c7a9f61a8d38da$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $f6c7a9f61a8d38da$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f6c7a9f61a8d38da$var$Jj = !1, $f6c7a9f61a8d38da$var$U = !1, $f6c7a9f61a8d38da$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $f6c7a9f61a8d38da$var$V = null;
function $f6c7a9f61a8d38da$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f6c7a9f61a8d38da$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $f6c7a9f61a8d38da$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f6c7a9f61a8d38da$var$W(a, b, d);
    }
}
var $f6c7a9f61a8d38da$var$Nj = !1;
function $f6c7a9f61a8d38da$var$Oj(a, b) {
    $f6c7a9f61a8d38da$var$Cf = $f6c7a9f61a8d38da$var$dd;
    a = $f6c7a9f61a8d38da$var$Me();
    if ($f6c7a9f61a8d38da$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f6c7a9f61a8d38da$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $f6c7a9f61a8d38da$var$dd = !1;
    for($f6c7a9f61a8d38da$var$V = b; null !== $f6c7a9f61a8d38da$var$V;)if (b = $f6c7a9f61a8d38da$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f6c7a9f61a8d38da$var$V = a;
    else for(; null !== $f6c7a9f61a8d38da$var$V;){
        b = $f6c7a9f61a8d38da$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $f6c7a9f61a8d38da$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f6c7a9f61a8d38da$var$p(163));
            }
        } catch (F) {
            $f6c7a9f61a8d38da$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f6c7a9f61a8d38da$var$V = a;
            break;
        }
        $f6c7a9f61a8d38da$var$V = b.return;
    }
    n = $f6c7a9f61a8d38da$var$Nj;
    $f6c7a9f61a8d38da$var$Nj = !1;
    return n;
}
function $f6c7a9f61a8d38da$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f6c7a9f61a8d38da$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f6c7a9f61a8d38da$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f6c7a9f61a8d38da$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f6c7a9f61a8d38da$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f6c7a9f61a8d38da$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f6c7a9f61a8d38da$var$Of], delete b[$f6c7a9f61a8d38da$var$Pf], delete b[$f6c7a9f61a8d38da$var$of], delete b[$f6c7a9f61a8d38da$var$Qf], delete b[$f6c7a9f61a8d38da$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f6c7a9f61a8d38da$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f6c7a9f61a8d38da$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f6c7a9f61a8d38da$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f6c7a9f61a8d38da$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f6c7a9f61a8d38da$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($f6c7a9f61a8d38da$var$Vj(a, b, c), a = a.sibling; null !== a;)$f6c7a9f61a8d38da$var$Vj(a, b, c), a = a.sibling;
}
function $f6c7a9f61a8d38da$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f6c7a9f61a8d38da$var$Wj(a, b, c), a = a.sibling; null !== a;)$f6c7a9f61a8d38da$var$Wj(a, b, c), a = a.sibling;
}
var $f6c7a9f61a8d38da$var$X = null, $f6c7a9f61a8d38da$var$Xj = !1;
function $f6c7a9f61a8d38da$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$f6c7a9f61a8d38da$var$Zj(a, b, c), c = c.sibling;
}
function $f6c7a9f61a8d38da$var$Zj(a, b, c) {
    if ($f6c7a9f61a8d38da$var$lc && "function" === typeof $f6c7a9f61a8d38da$var$lc.onCommitFiberUnmount) try {
        $f6c7a9f61a8d38da$var$lc.onCommitFiberUnmount($f6c7a9f61a8d38da$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f6c7a9f61a8d38da$var$U || $f6c7a9f61a8d38da$var$Lj(c, b);
        case 6:
            var d = $f6c7a9f61a8d38da$var$X, e = $f6c7a9f61a8d38da$var$Xj;
            $f6c7a9f61a8d38da$var$X = null;
            $f6c7a9f61a8d38da$var$Yj(a, b, c);
            $f6c7a9f61a8d38da$var$X = d;
            $f6c7a9f61a8d38da$var$Xj = e;
            null !== $f6c7a9f61a8d38da$var$X && ($f6c7a9f61a8d38da$var$Xj ? (a = $f6c7a9f61a8d38da$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f6c7a9f61a8d38da$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f6c7a9f61a8d38da$var$X && ($f6c7a9f61a8d38da$var$Xj ? (a = $f6c7a9f61a8d38da$var$X, c = c.stateNode, 8 === a.nodeType ? $f6c7a9f61a8d38da$var$Kf(a.parentNode, c) : 1 === a.nodeType && $f6c7a9f61a8d38da$var$Kf(a, c), $f6c7a9f61a8d38da$var$bd(a)) : $f6c7a9f61a8d38da$var$Kf($f6c7a9f61a8d38da$var$X, c.stateNode));
            break;
        case 4:
            d = $f6c7a9f61a8d38da$var$X;
            e = $f6c7a9f61a8d38da$var$Xj;
            $f6c7a9f61a8d38da$var$X = c.stateNode.containerInfo;
            $f6c7a9f61a8d38da$var$Xj = !0;
            $f6c7a9f61a8d38da$var$Yj(a, b, c);
            $f6c7a9f61a8d38da$var$X = d;
            $f6c7a9f61a8d38da$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f6c7a9f61a8d38da$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f6c7a9f61a8d38da$var$Mj(c, b, g) : 0 !== (f & 4) && $f6c7a9f61a8d38da$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f6c7a9f61a8d38da$var$Yj(a, b, c);
            break;
        case 1:
            if (!$f6c7a9f61a8d38da$var$U && ($f6c7a9f61a8d38da$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f6c7a9f61a8d38da$var$W(c, b, h);
            }
            $f6c7a9f61a8d38da$var$Yj(a, b, c);
            break;
        case 21:
            $f6c7a9f61a8d38da$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f6c7a9f61a8d38da$var$U = (d = $f6c7a9f61a8d38da$var$U) || null !== c.memoizedState, $f6c7a9f61a8d38da$var$Yj(a, b, c), $f6c7a9f61a8d38da$var$U = d) : $f6c7a9f61a8d38da$var$Yj(a, b, c);
            break;
        default:
            $f6c7a9f61a8d38da$var$Yj(a, b, c);
    }
}
function $f6c7a9f61a8d38da$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f6c7a9f61a8d38da$var$Kj);
        b.forEach(function(b) {
            var d = $f6c7a9f61a8d38da$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f6c7a9f61a8d38da$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f6c7a9f61a8d38da$var$X = h.stateNode;
                        $f6c7a9f61a8d38da$var$Xj = !1;
                        break a;
                    case 3:
                        $f6c7a9f61a8d38da$var$X = h.stateNode.containerInfo;
                        $f6c7a9f61a8d38da$var$Xj = !0;
                        break a;
                    case 4:
                        $f6c7a9f61a8d38da$var$X = h.stateNode.containerInfo;
                        $f6c7a9f61a8d38da$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f6c7a9f61a8d38da$var$X) throw Error($f6c7a9f61a8d38da$var$p(160));
            $f6c7a9f61a8d38da$var$Zj(f, g, e);
            $f6c7a9f61a8d38da$var$X = null;
            $f6c7a9f61a8d38da$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f6c7a9f61a8d38da$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f6c7a9f61a8d38da$var$dk(b, a), b = b.sibling;
}
function $f6c7a9f61a8d38da$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f6c7a9f61a8d38da$var$ck(b, a);
            $f6c7a9f61a8d38da$var$ek(a);
            if (d & 4) {
                try {
                    $f6c7a9f61a8d38da$var$Pj(3, a, a.return), $f6c7a9f61a8d38da$var$Qj(3, a);
                } catch (t) {
                    $f6c7a9f61a8d38da$var$W(a, a.return, t);
                }
                try {
                    $f6c7a9f61a8d38da$var$Pj(5, a, a.return);
                } catch (t) {
                    $f6c7a9f61a8d38da$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $f6c7a9f61a8d38da$var$ck(b, a);
            $f6c7a9f61a8d38da$var$ek(a);
            d & 512 && null !== c && $f6c7a9f61a8d38da$var$Lj(c, c.return);
            break;
        case 5:
            $f6c7a9f61a8d38da$var$ck(b, a);
            $f6c7a9f61a8d38da$var$ek(a);
            d & 512 && null !== c && $f6c7a9f61a8d38da$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f6c7a9f61a8d38da$var$ob(e, "");
                } catch (t) {
                    $f6c7a9f61a8d38da$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f6c7a9f61a8d38da$var$ab(e, f);
                    $f6c7a9f61a8d38da$var$vb(h, g);
                    var l = $f6c7a9f61a8d38da$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $f6c7a9f61a8d38da$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $f6c7a9f61a8d38da$var$nb(e, q) : "children" === m ? $f6c7a9f61a8d38da$var$ob(e, q) : $f6c7a9f61a8d38da$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $f6c7a9f61a8d38da$var$bb(e, f);
                            break;
                        case "textarea":
                            $f6c7a9f61a8d38da$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f6c7a9f61a8d38da$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $f6c7a9f61a8d38da$var$fb(e, !!f.multiple, f.defaultValue, !0) : $f6c7a9f61a8d38da$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f6c7a9f61a8d38da$var$Pf] = f;
                } catch (t) {
                    $f6c7a9f61a8d38da$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $f6c7a9f61a8d38da$var$ck(b, a);
            $f6c7a9f61a8d38da$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f6c7a9f61a8d38da$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $f6c7a9f61a8d38da$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $f6c7a9f61a8d38da$var$ck(b, a);
            $f6c7a9f61a8d38da$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f6c7a9f61a8d38da$var$bd(b.containerInfo);
            } catch (t) {
                $f6c7a9f61a8d38da$var$W(a, a.return, t);
            }
            break;
        case 4:
            $f6c7a9f61a8d38da$var$ck(b, a);
            $f6c7a9f61a8d38da$var$ek(a);
            break;
        case 13:
            $f6c7a9f61a8d38da$var$ck(b, a);
            $f6c7a9f61a8d38da$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($f6c7a9f61a8d38da$var$fk = $f6c7a9f61a8d38da$var$B()));
            d & 4 && $f6c7a9f61a8d38da$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f6c7a9f61a8d38da$var$U = (l = $f6c7a9f61a8d38da$var$U) || m, $f6c7a9f61a8d38da$var$ck(b, a), $f6c7a9f61a8d38da$var$U = l) : $f6c7a9f61a8d38da$var$ck(b, a);
            $f6c7a9f61a8d38da$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($f6c7a9f61a8d38da$var$V = a, m = a.child; null !== m;){
                    for(q = $f6c7a9f61a8d38da$var$V = m; null !== $f6c7a9f61a8d38da$var$V;){
                        r = $f6c7a9f61a8d38da$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f6c7a9f61a8d38da$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $f6c7a9f61a8d38da$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $f6c7a9f61a8d38da$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $f6c7a9f61a8d38da$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $f6c7a9f61a8d38da$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $f6c7a9f61a8d38da$var$V = y) : $f6c7a9f61a8d38da$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f6c7a9f61a8d38da$var$rb("display", g));
                            } catch (t) {
                                $f6c7a9f61a8d38da$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $f6c7a9f61a8d38da$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $f6c7a9f61a8d38da$var$ck(b, a);
            $f6c7a9f61a8d38da$var$ek(a);
            d & 4 && $f6c7a9f61a8d38da$var$ak(a);
            break;
        case 21:
            break;
        default:
            $f6c7a9f61a8d38da$var$ck(b, a), $f6c7a9f61a8d38da$var$ek(a);
    }
}
function $f6c7a9f61a8d38da$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f6c7a9f61a8d38da$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f6c7a9f61a8d38da$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f6c7a9f61a8d38da$var$ob(e, ""), d.flags &= -33);
                    var f = $f6c7a9f61a8d38da$var$Uj(a);
                    $f6c7a9f61a8d38da$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f6c7a9f61a8d38da$var$Uj(a);
                    $f6c7a9f61a8d38da$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($f6c7a9f61a8d38da$var$p(161));
            }
        } catch (k) {
            $f6c7a9f61a8d38da$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f6c7a9f61a8d38da$var$hk(a, b, c) {
    $f6c7a9f61a8d38da$var$V = a;
    $f6c7a9f61a8d38da$var$ik(a, b, c);
}
function $f6c7a9f61a8d38da$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f6c7a9f61a8d38da$var$V;){
        var e = $f6c7a9f61a8d38da$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f6c7a9f61a8d38da$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f6c7a9f61a8d38da$var$U;
                h = $f6c7a9f61a8d38da$var$Jj;
                var l = $f6c7a9f61a8d38da$var$U;
                $f6c7a9f61a8d38da$var$Jj = g;
                if (($f6c7a9f61a8d38da$var$U = k) && !l) for($f6c7a9f61a8d38da$var$V = e; null !== $f6c7a9f61a8d38da$var$V;)g = $f6c7a9f61a8d38da$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f6c7a9f61a8d38da$var$jk(e) : null !== k ? (k.return = g, $f6c7a9f61a8d38da$var$V = k) : $f6c7a9f61a8d38da$var$jk(e);
                for(; null !== f;)$f6c7a9f61a8d38da$var$V = f, $f6c7a9f61a8d38da$var$ik(f, b, c), f = f.sibling;
                $f6c7a9f61a8d38da$var$V = e;
                $f6c7a9f61a8d38da$var$Jj = h;
                $f6c7a9f61a8d38da$var$U = l;
            }
            $f6c7a9f61a8d38da$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f6c7a9f61a8d38da$var$V = f) : $f6c7a9f61a8d38da$var$kk(a, b, c);
    }
}
function $f6c7a9f61a8d38da$var$kk(a) {
    for(; null !== $f6c7a9f61a8d38da$var$V;){
        var b = $f6c7a9f61a8d38da$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f6c7a9f61a8d38da$var$U || $f6c7a9f61a8d38da$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f6c7a9f61a8d38da$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f6c7a9f61a8d38da$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f6c7a9f61a8d38da$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f6c7a9f61a8d38da$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $f6c7a9f61a8d38da$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($f6c7a9f61a8d38da$var$p(163));
                }
                $f6c7a9f61a8d38da$var$U || b.flags & 512 && $f6c7a9f61a8d38da$var$Rj(b);
            } catch (r) {
                $f6c7a9f61a8d38da$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $f6c7a9f61a8d38da$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f6c7a9f61a8d38da$var$V = c;
            break;
        }
        $f6c7a9f61a8d38da$var$V = b.return;
    }
}
function $f6c7a9f61a8d38da$var$gk(a) {
    for(; null !== $f6c7a9f61a8d38da$var$V;){
        var b = $f6c7a9f61a8d38da$var$V;
        if (b === a) {
            $f6c7a9f61a8d38da$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f6c7a9f61a8d38da$var$V = c;
            break;
        }
        $f6c7a9f61a8d38da$var$V = b.return;
    }
}
function $f6c7a9f61a8d38da$var$jk(a) {
    for(; null !== $f6c7a9f61a8d38da$var$V;){
        var b = $f6c7a9f61a8d38da$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f6c7a9f61a8d38da$var$Qj(4, b);
                    } catch (k) {
                        $f6c7a9f61a8d38da$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f6c7a9f61a8d38da$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f6c7a9f61a8d38da$var$Rj(b);
                    } catch (k) {
                        $f6c7a9f61a8d38da$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f6c7a9f61a8d38da$var$Rj(b);
                    } catch (k) {
                        $f6c7a9f61a8d38da$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $f6c7a9f61a8d38da$var$W(b, b.return, k);
        }
        if (b === a) {
            $f6c7a9f61a8d38da$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f6c7a9f61a8d38da$var$V = h;
            break;
        }
        $f6c7a9f61a8d38da$var$V = b.return;
    }
}
var $f6c7a9f61a8d38da$var$lk = Math.ceil, $f6c7a9f61a8d38da$var$mk = $f6c7a9f61a8d38da$var$ua.ReactCurrentDispatcher, $f6c7a9f61a8d38da$var$nk = $f6c7a9f61a8d38da$var$ua.ReactCurrentOwner, $f6c7a9f61a8d38da$var$ok = $f6c7a9f61a8d38da$var$ua.ReactCurrentBatchConfig, $f6c7a9f61a8d38da$var$K = 0, $f6c7a9f61a8d38da$var$Q = null, $f6c7a9f61a8d38da$var$Y = null, $f6c7a9f61a8d38da$var$Z = 0, $f6c7a9f61a8d38da$var$fj = 0, $f6c7a9f61a8d38da$var$ej = $f6c7a9f61a8d38da$var$Uf(0), $f6c7a9f61a8d38da$var$T = 0, $f6c7a9f61a8d38da$var$pk = null, $f6c7a9f61a8d38da$var$rh = 0, $f6c7a9f61a8d38da$var$qk = 0, $f6c7a9f61a8d38da$var$rk = 0, $f6c7a9f61a8d38da$var$sk = null, $f6c7a9f61a8d38da$var$tk = null, $f6c7a9f61a8d38da$var$fk = 0, $f6c7a9f61a8d38da$var$Gj = Infinity, $f6c7a9f61a8d38da$var$uk = null, $f6c7a9f61a8d38da$var$Oi = !1, $f6c7a9f61a8d38da$var$Pi = null, $f6c7a9f61a8d38da$var$Ri = null, $f6c7a9f61a8d38da$var$vk = !1, $f6c7a9f61a8d38da$var$wk = null, $f6c7a9f61a8d38da$var$xk = 0, $f6c7a9f61a8d38da$var$yk = 0, $f6c7a9f61a8d38da$var$zk = null, $f6c7a9f61a8d38da$var$Ak = -1, $f6c7a9f61a8d38da$var$Bk = 0;
function $f6c7a9f61a8d38da$var$R() {
    return 0 !== ($f6c7a9f61a8d38da$var$K & 6) ? $f6c7a9f61a8d38da$var$B() : -1 !== $f6c7a9f61a8d38da$var$Ak ? $f6c7a9f61a8d38da$var$Ak : $f6c7a9f61a8d38da$var$Ak = $f6c7a9f61a8d38da$var$B();
}
function $f6c7a9f61a8d38da$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f6c7a9f61a8d38da$var$K & 2) && 0 !== $f6c7a9f61a8d38da$var$Z) return $f6c7a9f61a8d38da$var$Z & -$f6c7a9f61a8d38da$var$Z;
    if (null !== $f6c7a9f61a8d38da$var$Kg.transition) return 0 === $f6c7a9f61a8d38da$var$Bk && ($f6c7a9f61a8d38da$var$Bk = $f6c7a9f61a8d38da$var$yc()), $f6c7a9f61a8d38da$var$Bk;
    a = $f6c7a9f61a8d38da$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f6c7a9f61a8d38da$var$jd(a.type);
    return a;
}
function $f6c7a9f61a8d38da$var$gi(a, b, c, d) {
    if (50 < $f6c7a9f61a8d38da$var$yk) throw $f6c7a9f61a8d38da$var$yk = 0, $f6c7a9f61a8d38da$var$zk = null, Error($f6c7a9f61a8d38da$var$p(185));
    $f6c7a9f61a8d38da$var$Ac(a, c, d);
    if (0 === ($f6c7a9f61a8d38da$var$K & 2) || a !== $f6c7a9f61a8d38da$var$Q) a === $f6c7a9f61a8d38da$var$Q && (0 === ($f6c7a9f61a8d38da$var$K & 2) && ($f6c7a9f61a8d38da$var$qk |= c), 4 === $f6c7a9f61a8d38da$var$T && $f6c7a9f61a8d38da$var$Ck(a, $f6c7a9f61a8d38da$var$Z)), $f6c7a9f61a8d38da$var$Dk(a, d), 1 === c && 0 === $f6c7a9f61a8d38da$var$K && 0 === (b.mode & 1) && ($f6c7a9f61a8d38da$var$Gj = $f6c7a9f61a8d38da$var$B() + 500, $f6c7a9f61a8d38da$var$fg && $f6c7a9f61a8d38da$var$jg());
}
function $f6c7a9f61a8d38da$var$Dk(a, b) {
    var c = a.callbackNode;
    $f6c7a9f61a8d38da$var$wc(a, b);
    var d = $f6c7a9f61a8d38da$var$uc(a, a === $f6c7a9f61a8d38da$var$Q ? $f6c7a9f61a8d38da$var$Z : 0);
    if (0 === d) null !== c && $f6c7a9f61a8d38da$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f6c7a9f61a8d38da$var$bc(c);
        if (1 === b) 0 === a.tag ? $f6c7a9f61a8d38da$var$ig($f6c7a9f61a8d38da$var$Ek.bind(null, a)) : $f6c7a9f61a8d38da$var$hg($f6c7a9f61a8d38da$var$Ek.bind(null, a)), $f6c7a9f61a8d38da$var$Jf(function() {
            0 === ($f6c7a9f61a8d38da$var$K & 6) && $f6c7a9f61a8d38da$var$jg();
        }), c = null;
        else {
            switch($f6c7a9f61a8d38da$var$Dc(d)){
                case 1:
                    c = $f6c7a9f61a8d38da$var$fc;
                    break;
                case 4:
                    c = $f6c7a9f61a8d38da$var$gc;
                    break;
                case 16:
                    c = $f6c7a9f61a8d38da$var$hc;
                    break;
                case 536870912:
                    c = $f6c7a9f61a8d38da$var$jc;
                    break;
                default:
                    c = $f6c7a9f61a8d38da$var$hc;
            }
            c = $f6c7a9f61a8d38da$var$Fk(c, $f6c7a9f61a8d38da$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f6c7a9f61a8d38da$var$Gk(a, b) {
    $f6c7a9f61a8d38da$var$Ak = -1;
    $f6c7a9f61a8d38da$var$Bk = 0;
    if (0 !== ($f6c7a9f61a8d38da$var$K & 6)) throw Error($f6c7a9f61a8d38da$var$p(327));
    var c = a.callbackNode;
    if ($f6c7a9f61a8d38da$var$Hk() && a.callbackNode !== c) return null;
    var d = $f6c7a9f61a8d38da$var$uc(a, a === $f6c7a9f61a8d38da$var$Q ? $f6c7a9f61a8d38da$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f6c7a9f61a8d38da$var$Ik(a, d);
    else {
        b = d;
        var e = $f6c7a9f61a8d38da$var$K;
        $f6c7a9f61a8d38da$var$K |= 2;
        var f = $f6c7a9f61a8d38da$var$Jk();
        if ($f6c7a9f61a8d38da$var$Q !== a || $f6c7a9f61a8d38da$var$Z !== b) $f6c7a9f61a8d38da$var$uk = null, $f6c7a9f61a8d38da$var$Gj = $f6c7a9f61a8d38da$var$B() + 500, $f6c7a9f61a8d38da$var$Kk(a, b);
        for(;;)try {
            $f6c7a9f61a8d38da$var$Lk();
            break;
        } catch (h) {
            $f6c7a9f61a8d38da$var$Mk(a, h);
        }
        $f6c7a9f61a8d38da$var$$g();
        $f6c7a9f61a8d38da$var$mk.current = f;
        $f6c7a9f61a8d38da$var$K = e;
        null !== $f6c7a9f61a8d38da$var$Y ? b = 0 : ($f6c7a9f61a8d38da$var$Q = null, $f6c7a9f61a8d38da$var$Z = 0, b = $f6c7a9f61a8d38da$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $f6c7a9f61a8d38da$var$xc(a), 0 !== e && (d = e, b = $f6c7a9f61a8d38da$var$Nk(a, e)));
        if (1 === b) throw c = $f6c7a9f61a8d38da$var$pk, $f6c7a9f61a8d38da$var$Kk(a, 0), $f6c7a9f61a8d38da$var$Ck(a, d), $f6c7a9f61a8d38da$var$Dk(a, $f6c7a9f61a8d38da$var$B()), c;
        if (6 === b) $f6c7a9f61a8d38da$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f6c7a9f61a8d38da$var$Ok(e) && (b = $f6c7a9f61a8d38da$var$Ik(a, d), 2 === b && (f = $f6c7a9f61a8d38da$var$xc(a), 0 !== f && (d = f, b = $f6c7a9f61a8d38da$var$Nk(a, f))), 1 === b)) throw c = $f6c7a9f61a8d38da$var$pk, $f6c7a9f61a8d38da$var$Kk(a, 0), $f6c7a9f61a8d38da$var$Ck(a, d), $f6c7a9f61a8d38da$var$Dk(a, $f6c7a9f61a8d38da$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f6c7a9f61a8d38da$var$p(345));
                case 2:
                    $f6c7a9f61a8d38da$var$Pk(a, $f6c7a9f61a8d38da$var$tk, $f6c7a9f61a8d38da$var$uk);
                    break;
                case 3:
                    $f6c7a9f61a8d38da$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $f6c7a9f61a8d38da$var$fk + 500 - $f6c7a9f61a8d38da$var$B(), 10 < b)) {
                        if (0 !== $f6c7a9f61a8d38da$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f6c7a9f61a8d38da$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f6c7a9f61a8d38da$var$Ff($f6c7a9f61a8d38da$var$Pk.bind(null, a, $f6c7a9f61a8d38da$var$tk, $f6c7a9f61a8d38da$var$uk), b);
                        break;
                    }
                    $f6c7a9f61a8d38da$var$Pk(a, $f6c7a9f61a8d38da$var$tk, $f6c7a9f61a8d38da$var$uk);
                    break;
                case 4:
                    $f6c7a9f61a8d38da$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f6c7a9f61a8d38da$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f6c7a9f61a8d38da$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f6c7a9f61a8d38da$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f6c7a9f61a8d38da$var$Ff($f6c7a9f61a8d38da$var$Pk.bind(null, a, $f6c7a9f61a8d38da$var$tk, $f6c7a9f61a8d38da$var$uk), d);
                        break;
                    }
                    $f6c7a9f61a8d38da$var$Pk(a, $f6c7a9f61a8d38da$var$tk, $f6c7a9f61a8d38da$var$uk);
                    break;
                case 5:
                    $f6c7a9f61a8d38da$var$Pk(a, $f6c7a9f61a8d38da$var$tk, $f6c7a9f61a8d38da$var$uk);
                    break;
                default:
                    throw Error($f6c7a9f61a8d38da$var$p(329));
            }
        }
    }
    $f6c7a9f61a8d38da$var$Dk(a, $f6c7a9f61a8d38da$var$B());
    return a.callbackNode === c ? $f6c7a9f61a8d38da$var$Gk.bind(null, a) : null;
}
function $f6c7a9f61a8d38da$var$Nk(a, b) {
    var c = $f6c7a9f61a8d38da$var$sk;
    a.current.memoizedState.isDehydrated && ($f6c7a9f61a8d38da$var$Kk(a, b).flags |= 256);
    a = $f6c7a9f61a8d38da$var$Ik(a, b);
    2 !== a && (b = $f6c7a9f61a8d38da$var$tk, $f6c7a9f61a8d38da$var$tk = c, null !== b && $f6c7a9f61a8d38da$var$Fj(b));
    return a;
}
function $f6c7a9f61a8d38da$var$Fj(a) {
    null === $f6c7a9f61a8d38da$var$tk ? $f6c7a9f61a8d38da$var$tk = a : $f6c7a9f61a8d38da$var$tk.push.apply($f6c7a9f61a8d38da$var$tk, a);
}
function $f6c7a9f61a8d38da$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f6c7a9f61a8d38da$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f6c7a9f61a8d38da$var$Ck(a, b) {
    b &= ~$f6c7a9f61a8d38da$var$rk;
    b &= ~$f6c7a9f61a8d38da$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f6c7a9f61a8d38da$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f6c7a9f61a8d38da$var$Ek(a) {
    if (0 !== ($f6c7a9f61a8d38da$var$K & 6)) throw Error($f6c7a9f61a8d38da$var$p(327));
    $f6c7a9f61a8d38da$var$Hk();
    var b = $f6c7a9f61a8d38da$var$uc(a, 0);
    if (0 === (b & 1)) return $f6c7a9f61a8d38da$var$Dk(a, $f6c7a9f61a8d38da$var$B()), null;
    var c = $f6c7a9f61a8d38da$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f6c7a9f61a8d38da$var$xc(a);
        0 !== d && (b = d, c = $f6c7a9f61a8d38da$var$Nk(a, d));
    }
    if (1 === c) throw c = $f6c7a9f61a8d38da$var$pk, $f6c7a9f61a8d38da$var$Kk(a, 0), $f6c7a9f61a8d38da$var$Ck(a, b), $f6c7a9f61a8d38da$var$Dk(a, $f6c7a9f61a8d38da$var$B()), c;
    if (6 === c) throw Error($f6c7a9f61a8d38da$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f6c7a9f61a8d38da$var$Pk(a, $f6c7a9f61a8d38da$var$tk, $f6c7a9f61a8d38da$var$uk);
    $f6c7a9f61a8d38da$var$Dk(a, $f6c7a9f61a8d38da$var$B());
    return null;
}
function $f6c7a9f61a8d38da$var$Qk(a, b) {
    var c = $f6c7a9f61a8d38da$var$K;
    $f6c7a9f61a8d38da$var$K |= 1;
    try {
        return a(b);
    } finally{
        $f6c7a9f61a8d38da$var$K = c, 0 === $f6c7a9f61a8d38da$var$K && ($f6c7a9f61a8d38da$var$Gj = $f6c7a9f61a8d38da$var$B() + 500, $f6c7a9f61a8d38da$var$fg && $f6c7a9f61a8d38da$var$jg());
    }
}
function $f6c7a9f61a8d38da$var$Rk(a) {
    null !== $f6c7a9f61a8d38da$var$wk && 0 === $f6c7a9f61a8d38da$var$wk.tag && 0 === ($f6c7a9f61a8d38da$var$K & 6) && $f6c7a9f61a8d38da$var$Hk();
    var b = $f6c7a9f61a8d38da$var$K;
    $f6c7a9f61a8d38da$var$K |= 1;
    var c = $f6c7a9f61a8d38da$var$ok.transition, d = $f6c7a9f61a8d38da$var$C;
    try {
        if ($f6c7a9f61a8d38da$var$ok.transition = null, $f6c7a9f61a8d38da$var$C = 1, a) return a();
    } finally{
        $f6c7a9f61a8d38da$var$C = d, $f6c7a9f61a8d38da$var$ok.transition = c, $f6c7a9f61a8d38da$var$K = b, 0 === ($f6c7a9f61a8d38da$var$K & 6) && $f6c7a9f61a8d38da$var$jg();
    }
}
function $f6c7a9f61a8d38da$var$Hj() {
    $f6c7a9f61a8d38da$var$fj = $f6c7a9f61a8d38da$var$ej.current;
    $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$ej);
}
function $f6c7a9f61a8d38da$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f6c7a9f61a8d38da$var$Gf(c));
    if (null !== $f6c7a9f61a8d38da$var$Y) for(c = $f6c7a9f61a8d38da$var$Y.return; null !== c;){
        var d = c;
        $f6c7a9f61a8d38da$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f6c7a9f61a8d38da$var$$f();
                break;
            case 3:
                $f6c7a9f61a8d38da$var$zh();
                $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$Wf);
                $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$H);
                $f6c7a9f61a8d38da$var$Eh();
                break;
            case 5:
                $f6c7a9f61a8d38da$var$Bh(d);
                break;
            case 4:
                $f6c7a9f61a8d38da$var$zh();
                break;
            case 13:
                $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$L);
                break;
            case 19:
                $f6c7a9f61a8d38da$var$E($f6c7a9f61a8d38da$var$L);
                break;
            case 10:
                $f6c7a9f61a8d38da$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $f6c7a9f61a8d38da$var$Hj();
        }
        c = c.return;
    }
    $f6c7a9f61a8d38da$var$Q = a;
    $f6c7a9f61a8d38da$var$Y = a = $f6c7a9f61a8d38da$var$Pg(a.current, null);
    $f6c7a9f61a8d38da$var$Z = $f6c7a9f61a8d38da$var$fj = b;
    $f6c7a9f61a8d38da$var$T = 0;
    $f6c7a9f61a8d38da$var$pk = null;
    $f6c7a9f61a8d38da$var$rk = $f6c7a9f61a8d38da$var$qk = $f6c7a9f61a8d38da$var$rh = 0;
    $f6c7a9f61a8d38da$var$tk = $f6c7a9f61a8d38da$var$sk = null;
    if (null !== $f6c7a9f61a8d38da$var$fh) {
        for(b = 0; b < $f6c7a9f61a8d38da$var$fh.length; b++)if (c = $f6c7a9f61a8d38da$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f6c7a9f61a8d38da$var$fh = null;
    }
    return a;
}
function $f6c7a9f61a8d38da$var$Mk(a, b) {
    do {
        var c = $f6c7a9f61a8d38da$var$Y;
        try {
            $f6c7a9f61a8d38da$var$$g();
            $f6c7a9f61a8d38da$var$Fh.current = $f6c7a9f61a8d38da$var$Rh;
            if ($f6c7a9f61a8d38da$var$Ih) {
                for(var d = $f6c7a9f61a8d38da$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f6c7a9f61a8d38da$var$Ih = !1;
            }
            $f6c7a9f61a8d38da$var$Hh = 0;
            $f6c7a9f61a8d38da$var$O = $f6c7a9f61a8d38da$var$N = $f6c7a9f61a8d38da$var$M = null;
            $f6c7a9f61a8d38da$var$Jh = !1;
            $f6c7a9f61a8d38da$var$Kh = 0;
            $f6c7a9f61a8d38da$var$nk.current = null;
            if (null === c || null === c.return) {
                $f6c7a9f61a8d38da$var$T = 1;
                $f6c7a9f61a8d38da$var$pk = b;
                $f6c7a9f61a8d38da$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f6c7a9f61a8d38da$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $f6c7a9f61a8d38da$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f6c7a9f61a8d38da$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $f6c7a9f61a8d38da$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f6c7a9f61a8d38da$var$Si(f, l, b);
                            $f6c7a9f61a8d38da$var$tj();
                            break a;
                        }
                        k = Error($f6c7a9f61a8d38da$var$p(426));
                    }
                } else if ($f6c7a9f61a8d38da$var$I && h.mode & 1) {
                    var J = $f6c7a9f61a8d38da$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f6c7a9f61a8d38da$var$Vi(J, g, h, f, b);
                        $f6c7a9f61a8d38da$var$Jg($f6c7a9f61a8d38da$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $f6c7a9f61a8d38da$var$Ji(k, h);
                4 !== $f6c7a9f61a8d38da$var$T && ($f6c7a9f61a8d38da$var$T = 2);
                null === $f6c7a9f61a8d38da$var$sk ? $f6c7a9f61a8d38da$var$sk = [
                    f
                ] : $f6c7a9f61a8d38da$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $f6c7a9f61a8d38da$var$Ni(f, k, b);
                            $f6c7a9f61a8d38da$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $f6c7a9f61a8d38da$var$Ri || !$f6c7a9f61a8d38da$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $f6c7a9f61a8d38da$var$Qi(f, h, b);
                                $f6c7a9f61a8d38da$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $f6c7a9f61a8d38da$var$Sk(c);
        } catch (na) {
            b = na;
            $f6c7a9f61a8d38da$var$Y === c && null !== c && ($f6c7a9f61a8d38da$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f6c7a9f61a8d38da$var$Jk() {
    var a = $f6c7a9f61a8d38da$var$mk.current;
    $f6c7a9f61a8d38da$var$mk.current = $f6c7a9f61a8d38da$var$Rh;
    return null === a ? $f6c7a9f61a8d38da$var$Rh : a;
}
function $f6c7a9f61a8d38da$var$tj() {
    if (0 === $f6c7a9f61a8d38da$var$T || 3 === $f6c7a9f61a8d38da$var$T || 2 === $f6c7a9f61a8d38da$var$T) $f6c7a9f61a8d38da$var$T = 4;
    null === $f6c7a9f61a8d38da$var$Q || 0 === ($f6c7a9f61a8d38da$var$rh & 268435455) && 0 === ($f6c7a9f61a8d38da$var$qk & 268435455) || $f6c7a9f61a8d38da$var$Ck($f6c7a9f61a8d38da$var$Q, $f6c7a9f61a8d38da$var$Z);
}
function $f6c7a9f61a8d38da$var$Ik(a, b) {
    var c = $f6c7a9f61a8d38da$var$K;
    $f6c7a9f61a8d38da$var$K |= 2;
    var d = $f6c7a9f61a8d38da$var$Jk();
    if ($f6c7a9f61a8d38da$var$Q !== a || $f6c7a9f61a8d38da$var$Z !== b) $f6c7a9f61a8d38da$var$uk = null, $f6c7a9f61a8d38da$var$Kk(a, b);
    for(;;)try {
        $f6c7a9f61a8d38da$var$Tk();
        break;
    } catch (e) {
        $f6c7a9f61a8d38da$var$Mk(a, e);
    }
    $f6c7a9f61a8d38da$var$$g();
    $f6c7a9f61a8d38da$var$K = c;
    $f6c7a9f61a8d38da$var$mk.current = d;
    if (null !== $f6c7a9f61a8d38da$var$Y) throw Error($f6c7a9f61a8d38da$var$p(261));
    $f6c7a9f61a8d38da$var$Q = null;
    $f6c7a9f61a8d38da$var$Z = 0;
    return $f6c7a9f61a8d38da$var$T;
}
function $f6c7a9f61a8d38da$var$Tk() {
    for(; null !== $f6c7a9f61a8d38da$var$Y;)$f6c7a9f61a8d38da$var$Uk($f6c7a9f61a8d38da$var$Y);
}
function $f6c7a9f61a8d38da$var$Lk() {
    for(; null !== $f6c7a9f61a8d38da$var$Y && !$f6c7a9f61a8d38da$var$cc();)$f6c7a9f61a8d38da$var$Uk($f6c7a9f61a8d38da$var$Y);
}
function $f6c7a9f61a8d38da$var$Uk(a) {
    var b = $f6c7a9f61a8d38da$var$Vk(a.alternate, a, $f6c7a9f61a8d38da$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f6c7a9f61a8d38da$var$Sk(a) : $f6c7a9f61a8d38da$var$Y = b;
    $f6c7a9f61a8d38da$var$nk.current = null;
}
function $f6c7a9f61a8d38da$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f6c7a9f61a8d38da$var$Ej(c, b, $f6c7a9f61a8d38da$var$fj), null !== c) {
                $f6c7a9f61a8d38da$var$Y = c;
                return;
            }
        } else {
            c = $f6c7a9f61a8d38da$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f6c7a9f61a8d38da$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f6c7a9f61a8d38da$var$T = 6;
                $f6c7a9f61a8d38da$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f6c7a9f61a8d38da$var$Y = b;
            return;
        }
        $f6c7a9f61a8d38da$var$Y = b = a;
    }while (null !== b);
    0 === $f6c7a9f61a8d38da$var$T && ($f6c7a9f61a8d38da$var$T = 5);
}
function $f6c7a9f61a8d38da$var$Pk(a, b, c) {
    var d = $f6c7a9f61a8d38da$var$C, e = $f6c7a9f61a8d38da$var$ok.transition;
    try {
        $f6c7a9f61a8d38da$var$ok.transition = null, $f6c7a9f61a8d38da$var$C = 1, $f6c7a9f61a8d38da$var$Wk(a, b, c, d);
    } finally{
        $f6c7a9f61a8d38da$var$ok.transition = e, $f6c7a9f61a8d38da$var$C = d;
    }
    return null;
}
function $f6c7a9f61a8d38da$var$Wk(a, b, c, d) {
    do $f6c7a9f61a8d38da$var$Hk();
    while (null !== $f6c7a9f61a8d38da$var$wk);
    if (0 !== ($f6c7a9f61a8d38da$var$K & 6)) throw Error($f6c7a9f61a8d38da$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f6c7a9f61a8d38da$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f6c7a9f61a8d38da$var$Bc(a, f);
    a === $f6c7a9f61a8d38da$var$Q && ($f6c7a9f61a8d38da$var$Y = $f6c7a9f61a8d38da$var$Q = null, $f6c7a9f61a8d38da$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f6c7a9f61a8d38da$var$vk || ($f6c7a9f61a8d38da$var$vk = !0, $f6c7a9f61a8d38da$var$Fk($f6c7a9f61a8d38da$var$hc, function() {
        $f6c7a9f61a8d38da$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f6c7a9f61a8d38da$var$ok.transition;
        $f6c7a9f61a8d38da$var$ok.transition = null;
        var g = $f6c7a9f61a8d38da$var$C;
        $f6c7a9f61a8d38da$var$C = 1;
        var h = $f6c7a9f61a8d38da$var$K;
        $f6c7a9f61a8d38da$var$K |= 4;
        $f6c7a9f61a8d38da$var$nk.current = null;
        $f6c7a9f61a8d38da$var$Oj(a, c);
        $f6c7a9f61a8d38da$var$dk(c, a);
        $f6c7a9f61a8d38da$var$Oe($f6c7a9f61a8d38da$var$Df);
        $f6c7a9f61a8d38da$var$dd = !!$f6c7a9f61a8d38da$var$Cf;
        $f6c7a9f61a8d38da$var$Df = $f6c7a9f61a8d38da$var$Cf = null;
        a.current = c;
        $f6c7a9f61a8d38da$var$hk(c, a, e);
        $f6c7a9f61a8d38da$var$dc();
        $f6c7a9f61a8d38da$var$K = h;
        $f6c7a9f61a8d38da$var$C = g;
        $f6c7a9f61a8d38da$var$ok.transition = f;
    } else a.current = c;
    $f6c7a9f61a8d38da$var$vk && ($f6c7a9f61a8d38da$var$vk = !1, $f6c7a9f61a8d38da$var$wk = a, $f6c7a9f61a8d38da$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($f6c7a9f61a8d38da$var$Ri = null);
    $f6c7a9f61a8d38da$var$mc(c.stateNode, d);
    $f6c7a9f61a8d38da$var$Dk(a, $f6c7a9f61a8d38da$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($f6c7a9f61a8d38da$var$Oi) throw $f6c7a9f61a8d38da$var$Oi = !1, a = $f6c7a9f61a8d38da$var$Pi, $f6c7a9f61a8d38da$var$Pi = null, a;
    0 !== ($f6c7a9f61a8d38da$var$xk & 1) && 0 !== a.tag && $f6c7a9f61a8d38da$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f6c7a9f61a8d38da$var$zk ? $f6c7a9f61a8d38da$var$yk++ : ($f6c7a9f61a8d38da$var$yk = 0, $f6c7a9f61a8d38da$var$zk = a) : $f6c7a9f61a8d38da$var$yk = 0;
    $f6c7a9f61a8d38da$var$jg();
    return null;
}
function $f6c7a9f61a8d38da$var$Hk() {
    if (null !== $f6c7a9f61a8d38da$var$wk) {
        var a = $f6c7a9f61a8d38da$var$Dc($f6c7a9f61a8d38da$var$xk), b = $f6c7a9f61a8d38da$var$ok.transition, c = $f6c7a9f61a8d38da$var$C;
        try {
            $f6c7a9f61a8d38da$var$ok.transition = null;
            $f6c7a9f61a8d38da$var$C = 16 > a ? 16 : a;
            if (null === $f6c7a9f61a8d38da$var$wk) var d = !1;
            else {
                a = $f6c7a9f61a8d38da$var$wk;
                $f6c7a9f61a8d38da$var$wk = null;
                $f6c7a9f61a8d38da$var$xk = 0;
                if (0 !== ($f6c7a9f61a8d38da$var$K & 6)) throw Error($f6c7a9f61a8d38da$var$p(331));
                var e = $f6c7a9f61a8d38da$var$K;
                $f6c7a9f61a8d38da$var$K |= 4;
                for($f6c7a9f61a8d38da$var$V = a.current; null !== $f6c7a9f61a8d38da$var$V;){
                    var f = $f6c7a9f61a8d38da$var$V, g = f.child;
                    if (0 !== ($f6c7a9f61a8d38da$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f6c7a9f61a8d38da$var$V = l; null !== $f6c7a9f61a8d38da$var$V;){
                                    var m = $f6c7a9f61a8d38da$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f6c7a9f61a8d38da$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $f6c7a9f61a8d38da$var$V = q;
                                    else for(; null !== $f6c7a9f61a8d38da$var$V;){
                                        m = $f6c7a9f61a8d38da$var$V;
                                        var r = m.sibling, y = m.return;
                                        $f6c7a9f61a8d38da$var$Sj(m);
                                        if (m === l) {
                                            $f6c7a9f61a8d38da$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $f6c7a9f61a8d38da$var$V = r;
                                            break;
                                        }
                                        $f6c7a9f61a8d38da$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $f6c7a9f61a8d38da$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f6c7a9f61a8d38da$var$V = g;
                    else b: for(; null !== $f6c7a9f61a8d38da$var$V;){
                        f = $f6c7a9f61a8d38da$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f6c7a9f61a8d38da$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $f6c7a9f61a8d38da$var$V = x;
                            break b;
                        }
                        $f6c7a9f61a8d38da$var$V = f.return;
                    }
                }
                var w = a.current;
                for($f6c7a9f61a8d38da$var$V = w; null !== $f6c7a9f61a8d38da$var$V;){
                    g = $f6c7a9f61a8d38da$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $f6c7a9f61a8d38da$var$V = u;
                    else b: for(g = w; null !== $f6c7a9f61a8d38da$var$V;){
                        h = $f6c7a9f61a8d38da$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f6c7a9f61a8d38da$var$Qj(9, h);
                            }
                        } catch (na) {
                            $f6c7a9f61a8d38da$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $f6c7a9f61a8d38da$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f6c7a9f61a8d38da$var$V = F;
                            break b;
                        }
                        $f6c7a9f61a8d38da$var$V = h.return;
                    }
                }
                $f6c7a9f61a8d38da$var$K = e;
                $f6c7a9f61a8d38da$var$jg();
                if ($f6c7a9f61a8d38da$var$lc && "function" === typeof $f6c7a9f61a8d38da$var$lc.onPostCommitFiberRoot) try {
                    $f6c7a9f61a8d38da$var$lc.onPostCommitFiberRoot($f6c7a9f61a8d38da$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $f6c7a9f61a8d38da$var$C = c, $f6c7a9f61a8d38da$var$ok.transition = b;
        }
    }
    return !1;
}
function $f6c7a9f61a8d38da$var$Xk(a, b, c) {
    b = $f6c7a9f61a8d38da$var$Ji(c, b);
    b = $f6c7a9f61a8d38da$var$Ni(a, b, 1);
    a = $f6c7a9f61a8d38da$var$nh(a, b, 1);
    b = $f6c7a9f61a8d38da$var$R();
    null !== a && ($f6c7a9f61a8d38da$var$Ac(a, 1, b), $f6c7a9f61a8d38da$var$Dk(a, b));
}
function $f6c7a9f61a8d38da$var$W(a, b, c) {
    if (3 === a.tag) $f6c7a9f61a8d38da$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f6c7a9f61a8d38da$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f6c7a9f61a8d38da$var$Ri || !$f6c7a9f61a8d38da$var$Ri.has(d))) {
                a = $f6c7a9f61a8d38da$var$Ji(c, a);
                a = $f6c7a9f61a8d38da$var$Qi(b, a, 1);
                b = $f6c7a9f61a8d38da$var$nh(b, a, 1);
                a = $f6c7a9f61a8d38da$var$R();
                null !== b && ($f6c7a9f61a8d38da$var$Ac(b, 1, a), $f6c7a9f61a8d38da$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f6c7a9f61a8d38da$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f6c7a9f61a8d38da$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $f6c7a9f61a8d38da$var$Q === a && ($f6c7a9f61a8d38da$var$Z & c) === c && (4 === $f6c7a9f61a8d38da$var$T || 3 === $f6c7a9f61a8d38da$var$T && ($f6c7a9f61a8d38da$var$Z & 130023424) === $f6c7a9f61a8d38da$var$Z && 500 > $f6c7a9f61a8d38da$var$B() - $f6c7a9f61a8d38da$var$fk ? $f6c7a9f61a8d38da$var$Kk(a, 0) : $f6c7a9f61a8d38da$var$rk |= c);
    $f6c7a9f61a8d38da$var$Dk(a, b);
}
function $f6c7a9f61a8d38da$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f6c7a9f61a8d38da$var$sc, $f6c7a9f61a8d38da$var$sc <<= 1, 0 === ($f6c7a9f61a8d38da$var$sc & 130023424) && ($f6c7a9f61a8d38da$var$sc = 4194304)));
    var c = $f6c7a9f61a8d38da$var$R();
    a = $f6c7a9f61a8d38da$var$ih(a, b);
    null !== a && ($f6c7a9f61a8d38da$var$Ac(a, b, c), $f6c7a9f61a8d38da$var$Dk(a, c));
}
function $f6c7a9f61a8d38da$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f6c7a9f61a8d38da$var$Yk(a, c);
}
function $f6c7a9f61a8d38da$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f6c7a9f61a8d38da$var$p(314));
    }
    null !== d && d.delete(b);
    $f6c7a9f61a8d38da$var$Yk(a, c);
}
var $f6c7a9f61a8d38da$var$Vk;
$f6c7a9f61a8d38da$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f6c7a9f61a8d38da$var$Wf.current) $f6c7a9f61a8d38da$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f6c7a9f61a8d38da$var$dh = !1, $f6c7a9f61a8d38da$var$yj(a, b, c);
            $f6c7a9f61a8d38da$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f6c7a9f61a8d38da$var$dh = !1, $f6c7a9f61a8d38da$var$I && 0 !== (b.flags & 1048576) && $f6c7a9f61a8d38da$var$ug(b, $f6c7a9f61a8d38da$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $f6c7a9f61a8d38da$var$ij(a, b);
            a = b.pendingProps;
            var e = $f6c7a9f61a8d38da$var$Yf(b, $f6c7a9f61a8d38da$var$H.current);
            $f6c7a9f61a8d38da$var$ch(b, c);
            e = $f6c7a9f61a8d38da$var$Nh(null, b, d, a, e, c);
            var f = $f6c7a9f61a8d38da$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f6c7a9f61a8d38da$var$Zf(d) ? (f = !0, $f6c7a9f61a8d38da$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f6c7a9f61a8d38da$var$kh(b), e.updater = $f6c7a9f61a8d38da$var$Ei, b.stateNode = e, e._reactInternals = b, $f6c7a9f61a8d38da$var$Ii(b, d, a, c), b = $f6c7a9f61a8d38da$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $f6c7a9f61a8d38da$var$I && f && $f6c7a9f61a8d38da$var$vg(b), $f6c7a9f61a8d38da$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $f6c7a9f61a8d38da$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f6c7a9f61a8d38da$var$Zk(d);
                a = $f6c7a9f61a8d38da$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $f6c7a9f61a8d38da$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f6c7a9f61a8d38da$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f6c7a9f61a8d38da$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f6c7a9f61a8d38da$var$$i(null, b, d, $f6c7a9f61a8d38da$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($f6c7a9f61a8d38da$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f6c7a9f61a8d38da$var$Ci(d, e), $f6c7a9f61a8d38da$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f6c7a9f61a8d38da$var$Ci(d, e), $f6c7a9f61a8d38da$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $f6c7a9f61a8d38da$var$kj(b);
                if (null === a) throw Error($f6c7a9f61a8d38da$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f6c7a9f61a8d38da$var$lh(a, b);
                $f6c7a9f61a8d38da$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $f6c7a9f61a8d38da$var$Ji(Error($f6c7a9f61a8d38da$var$p(423)), b);
                        b = $f6c7a9f61a8d38da$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $f6c7a9f61a8d38da$var$Ji(Error($f6c7a9f61a8d38da$var$p(424)), b);
                        b = $f6c7a9f61a8d38da$var$lj(a, b, d, c, e);
                        break a;
                    } else for($f6c7a9f61a8d38da$var$yg = $f6c7a9f61a8d38da$var$Lf(b.stateNode.containerInfo.firstChild), $f6c7a9f61a8d38da$var$xg = b, $f6c7a9f61a8d38da$var$I = !0, $f6c7a9f61a8d38da$var$zg = null, c = $f6c7a9f61a8d38da$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f6c7a9f61a8d38da$var$Ig();
                    if (d === e) {
                        b = $f6c7a9f61a8d38da$var$Zi(a, b, c);
                        break a;
                    }
                    $f6c7a9f61a8d38da$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f6c7a9f61a8d38da$var$Ah(b), null === a && $f6c7a9f61a8d38da$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f6c7a9f61a8d38da$var$Ef(d, e) ? g = null : null !== f && $f6c7a9f61a8d38da$var$Ef(d, f) && (b.flags |= 32), $f6c7a9f61a8d38da$var$gj(a, b), $f6c7a9f61a8d38da$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $f6c7a9f61a8d38da$var$Eg(b), null;
        case 13:
            return $f6c7a9f61a8d38da$var$oj(a, b, c);
        case 4:
            return $f6c7a9f61a8d38da$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f6c7a9f61a8d38da$var$Ug(b, null, d, c) : $f6c7a9f61a8d38da$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f6c7a9f61a8d38da$var$Ci(d, e), $f6c7a9f61a8d38da$var$Yi(a, b, d, e, c);
        case 7:
            return $f6c7a9f61a8d38da$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f6c7a9f61a8d38da$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f6c7a9f61a8d38da$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f6c7a9f61a8d38da$var$G($f6c7a9f61a8d38da$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f6c7a9f61a8d38da$var$He(f.value, g)) {
                        if (f.children === e.children && !$f6c7a9f61a8d38da$var$Wf.current) {
                            b = $f6c7a9f61a8d38da$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f6c7a9f61a8d38da$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f6c7a9f61a8d38da$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f6c7a9f61a8d38da$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f6c7a9f61a8d38da$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f6c7a9f61a8d38da$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f6c7a9f61a8d38da$var$ch(b, c), e = $f6c7a9f61a8d38da$var$eh(e), d = d(e), b.flags |= 1, $f6c7a9f61a8d38da$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f6c7a9f61a8d38da$var$Ci(d, b.pendingProps), e = $f6c7a9f61a8d38da$var$Ci(d.type, e), $f6c7a9f61a8d38da$var$$i(a, b, d, e, c);
        case 15:
            return $f6c7a9f61a8d38da$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f6c7a9f61a8d38da$var$Ci(d, e), $f6c7a9f61a8d38da$var$ij(a, b), b.tag = 1, $f6c7a9f61a8d38da$var$Zf(d) ? (a = !0, $f6c7a9f61a8d38da$var$cg(b)) : a = !1, $f6c7a9f61a8d38da$var$ch(b, c), $f6c7a9f61a8d38da$var$Gi(b, d, e), $f6c7a9f61a8d38da$var$Ii(b, d, e, c), $f6c7a9f61a8d38da$var$jj(null, b, d, !0, a, c);
        case 19:
            return $f6c7a9f61a8d38da$var$xj(a, b, c);
        case 22:
            return $f6c7a9f61a8d38da$var$dj(a, b, c);
    }
    throw Error($f6c7a9f61a8d38da$var$p(156, b.tag));
};
function $f6c7a9f61a8d38da$var$Fk(a, b) {
    return $f6c7a9f61a8d38da$var$ac(a, b);
}
function $f6c7a9f61a8d38da$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f6c7a9f61a8d38da$var$Bg(a, b, c, d) {
    return new $f6c7a9f61a8d38da$var$$k(a, b, c, d);
}
function $f6c7a9f61a8d38da$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f6c7a9f61a8d38da$var$Zk(a) {
    if ("function" === typeof a) return $f6c7a9f61a8d38da$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f6c7a9f61a8d38da$var$Da) return 11;
        if (a === $f6c7a9f61a8d38da$var$Ga) return 14;
    }
    return 2;
}
function $f6c7a9f61a8d38da$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $f6c7a9f61a8d38da$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f6c7a9f61a8d38da$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f6c7a9f61a8d38da$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f6c7a9f61a8d38da$var$ya:
            return $f6c7a9f61a8d38da$var$Tg(c.children, e, f, b);
        case $f6c7a9f61a8d38da$var$za:
            g = 8;
            e |= 8;
            break;
        case $f6c7a9f61a8d38da$var$Aa:
            return a = $f6c7a9f61a8d38da$var$Bg(12, c, b, e | 2), a.elementType = $f6c7a9f61a8d38da$var$Aa, a.lanes = f, a;
        case $f6c7a9f61a8d38da$var$Ea:
            return a = $f6c7a9f61a8d38da$var$Bg(13, c, b, e), a.elementType = $f6c7a9f61a8d38da$var$Ea, a.lanes = f, a;
        case $f6c7a9f61a8d38da$var$Fa:
            return a = $f6c7a9f61a8d38da$var$Bg(19, c, b, e), a.elementType = $f6c7a9f61a8d38da$var$Fa, a.lanes = f, a;
        case $f6c7a9f61a8d38da$var$Ia:
            return $f6c7a9f61a8d38da$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f6c7a9f61a8d38da$var$Ba:
                    g = 10;
                    break a;
                case $f6c7a9f61a8d38da$var$Ca:
                    g = 9;
                    break a;
                case $f6c7a9f61a8d38da$var$Da:
                    g = 11;
                    break a;
                case $f6c7a9f61a8d38da$var$Ga:
                    g = 14;
                    break a;
                case $f6c7a9f61a8d38da$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f6c7a9f61a8d38da$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f6c7a9f61a8d38da$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f6c7a9f61a8d38da$var$Tg(a, b, c, d) {
    a = $f6c7a9f61a8d38da$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f6c7a9f61a8d38da$var$pj(a, b, c, d) {
    a = $f6c7a9f61a8d38da$var$Bg(22, a, d, b);
    a.elementType = $f6c7a9f61a8d38da$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $f6c7a9f61a8d38da$var$Qg(a, b, c) {
    a = $f6c7a9f61a8d38da$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f6c7a9f61a8d38da$var$Sg(a, b, c) {
    b = $f6c7a9f61a8d38da$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f6c7a9f61a8d38da$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f6c7a9f61a8d38da$var$zc(0);
    this.expirationTimes = $f6c7a9f61a8d38da$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f6c7a9f61a8d38da$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f6c7a9f61a8d38da$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $f6c7a9f61a8d38da$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f6c7a9f61a8d38da$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f6c7a9f61a8d38da$var$kh(f);
    return a;
}
function $f6c7a9f61a8d38da$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f6c7a9f61a8d38da$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f6c7a9f61a8d38da$var$dl(a) {
    if (!a) return $f6c7a9f61a8d38da$var$Vf;
    a = a._reactInternals;
    a: {
        if ($f6c7a9f61a8d38da$var$Vb(a) !== a || 1 !== a.tag) throw Error($f6c7a9f61a8d38da$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f6c7a9f61a8d38da$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f6c7a9f61a8d38da$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f6c7a9f61a8d38da$var$Zf(c)) return $f6c7a9f61a8d38da$var$bg(a, c, b);
    }
    return b;
}
function $f6c7a9f61a8d38da$var$el(a, b, c, d, e, f, g, h, k) {
    a = $f6c7a9f61a8d38da$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $f6c7a9f61a8d38da$var$dl(null);
    c = a.current;
    d = $f6c7a9f61a8d38da$var$R();
    e = $f6c7a9f61a8d38da$var$yi(c);
    f = $f6c7a9f61a8d38da$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f6c7a9f61a8d38da$var$nh(c, f, e);
    a.current.lanes = e;
    $f6c7a9f61a8d38da$var$Ac(a, e, d);
    $f6c7a9f61a8d38da$var$Dk(a, d);
    return a;
}
function $f6c7a9f61a8d38da$var$fl(a, b, c, d) {
    var e = b.current, f = $f6c7a9f61a8d38da$var$R(), g = $f6c7a9f61a8d38da$var$yi(e);
    c = $f6c7a9f61a8d38da$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f6c7a9f61a8d38da$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $f6c7a9f61a8d38da$var$nh(e, b, g);
    null !== a && ($f6c7a9f61a8d38da$var$gi(a, e, g, f), $f6c7a9f61a8d38da$var$oh(a, e, g));
    return g;
}
function $f6c7a9f61a8d38da$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f6c7a9f61a8d38da$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f6c7a9f61a8d38da$var$il(a, b) {
    $f6c7a9f61a8d38da$var$hl(a, b);
    (a = a.alternate) && $f6c7a9f61a8d38da$var$hl(a, b);
}
function $f6c7a9f61a8d38da$var$jl() {
    return null;
}
var $f6c7a9f61a8d38da$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f6c7a9f61a8d38da$var$ll(a) {
    this._internalRoot = a;
}
$f6c7a9f61a8d38da$var$ml.prototype.render = $f6c7a9f61a8d38da$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f6c7a9f61a8d38da$var$p(409));
    $f6c7a9f61a8d38da$var$fl(a, b, null, null);
};
$f6c7a9f61a8d38da$var$ml.prototype.unmount = $f6c7a9f61a8d38da$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f6c7a9f61a8d38da$var$Rk(function() {
            $f6c7a9f61a8d38da$var$fl(null, a, null, null);
        });
        b[$f6c7a9f61a8d38da$var$uf] = null;
    }
};
function $f6c7a9f61a8d38da$var$ml(a) {
    this._internalRoot = a;
}
$f6c7a9f61a8d38da$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f6c7a9f61a8d38da$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f6c7a9f61a8d38da$var$Qc.length && 0 !== b && b < $f6c7a9f61a8d38da$var$Qc[c].priority; c++);
        $f6c7a9f61a8d38da$var$Qc.splice(c, 0, a);
        0 === c && $f6c7a9f61a8d38da$var$Vc(a);
    }
};
function $f6c7a9f61a8d38da$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f6c7a9f61a8d38da$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f6c7a9f61a8d38da$var$pl() {}
function $f6c7a9f61a8d38da$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f6c7a9f61a8d38da$var$gl(g);
                f.call(a);
            };
        }
        var g = $f6c7a9f61a8d38da$var$el(b, d, a, 0, null, !1, !1, "", $f6c7a9f61a8d38da$var$pl);
        a._reactRootContainer = g;
        a[$f6c7a9f61a8d38da$var$uf] = g.current;
        $f6c7a9f61a8d38da$var$sf(8 === a.nodeType ? a.parentNode : a);
        $f6c7a9f61a8d38da$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f6c7a9f61a8d38da$var$gl(k);
            h.call(a);
        };
    }
    var k = $f6c7a9f61a8d38da$var$bl(a, 0, !1, null, null, !1, !1, "", $f6c7a9f61a8d38da$var$pl);
    a._reactRootContainer = k;
    a[$f6c7a9f61a8d38da$var$uf] = k.current;
    $f6c7a9f61a8d38da$var$sf(8 === a.nodeType ? a.parentNode : a);
    $f6c7a9f61a8d38da$var$Rk(function() {
        $f6c7a9f61a8d38da$var$fl(b, k, c, d);
    });
    return k;
}
function $f6c7a9f61a8d38da$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f6c7a9f61a8d38da$var$gl(g);
                h.call(a);
            };
        }
        $f6c7a9f61a8d38da$var$fl(b, g, a, e);
    } else g = $f6c7a9f61a8d38da$var$ql(c, b, a, e, d);
    return $f6c7a9f61a8d38da$var$gl(g);
}
$f6c7a9f61a8d38da$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f6c7a9f61a8d38da$var$tc(b.pendingLanes);
                0 !== c && ($f6c7a9f61a8d38da$var$Cc(b, c | 1), $f6c7a9f61a8d38da$var$Dk(b, $f6c7a9f61a8d38da$var$B()), 0 === ($f6c7a9f61a8d38da$var$K & 6) && ($f6c7a9f61a8d38da$var$Gj = $f6c7a9f61a8d38da$var$B() + 500, $f6c7a9f61a8d38da$var$jg()));
            }
            break;
        case 13:
            $f6c7a9f61a8d38da$var$Rk(function() {
                var b = $f6c7a9f61a8d38da$var$ih(a, 1);
                if (null !== b) {
                    var c = $f6c7a9f61a8d38da$var$R();
                    $f6c7a9f61a8d38da$var$gi(b, a, 1, c);
                }
            }), $f6c7a9f61a8d38da$var$il(a, 1);
    }
};
$f6c7a9f61a8d38da$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f6c7a9f61a8d38da$var$ih(a, 134217728);
        if (null !== b) {
            var c = $f6c7a9f61a8d38da$var$R();
            $f6c7a9f61a8d38da$var$gi(b, a, 134217728, c);
        }
        $f6c7a9f61a8d38da$var$il(a, 134217728);
    }
};
$f6c7a9f61a8d38da$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $f6c7a9f61a8d38da$var$yi(a), c = $f6c7a9f61a8d38da$var$ih(a, b);
        if (null !== c) {
            var d = $f6c7a9f61a8d38da$var$R();
            $f6c7a9f61a8d38da$var$gi(c, a, b, d);
        }
        $f6c7a9f61a8d38da$var$il(a, b);
    }
};
$f6c7a9f61a8d38da$var$Hc = function() {
    return $f6c7a9f61a8d38da$var$C;
};
$f6c7a9f61a8d38da$var$Ic = function(a, b) {
    var c = $f6c7a9f61a8d38da$var$C;
    try {
        return $f6c7a9f61a8d38da$var$C = a, b();
    } finally{
        $f6c7a9f61a8d38da$var$C = c;
    }
};
$f6c7a9f61a8d38da$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $f6c7a9f61a8d38da$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f6c7a9f61a8d38da$var$Db(d);
                        if (!e) throw Error($f6c7a9f61a8d38da$var$p(90));
                        $f6c7a9f61a8d38da$var$Wa(d);
                        $f6c7a9f61a8d38da$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f6c7a9f61a8d38da$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $f6c7a9f61a8d38da$var$fb(a, !!c.multiple, b, !1);
    }
};
$f6c7a9f61a8d38da$var$Gb = $f6c7a9f61a8d38da$var$Qk;
$f6c7a9f61a8d38da$var$Hb = $f6c7a9f61a8d38da$var$Rk;
var $f6c7a9f61a8d38da$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $f6c7a9f61a8d38da$var$Cb,
        $f6c7a9f61a8d38da$var$ue,
        $f6c7a9f61a8d38da$var$Db,
        $f6c7a9f61a8d38da$var$Eb,
        $f6c7a9f61a8d38da$var$Fb,
        $f6c7a9f61a8d38da$var$Qk
    ]
}, $f6c7a9f61a8d38da$var$tl = {
    findFiberByHostInstance: $f6c7a9f61a8d38da$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $f6c7a9f61a8d38da$var$ul = {
    bundleType: $f6c7a9f61a8d38da$var$tl.bundleType,
    version: $f6c7a9f61a8d38da$var$tl.version,
    rendererPackageName: $f6c7a9f61a8d38da$var$tl.rendererPackageName,
    rendererConfig: $f6c7a9f61a8d38da$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f6c7a9f61a8d38da$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f6c7a9f61a8d38da$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f6c7a9f61a8d38da$var$tl.findFiberByHostInstance || $f6c7a9f61a8d38da$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f6c7a9f61a8d38da$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f6c7a9f61a8d38da$var$vl.isDisabled && $f6c7a9f61a8d38da$var$vl.supportsFiber) try {
        $f6c7a9f61a8d38da$var$kc = $f6c7a9f61a8d38da$var$vl.inject($f6c7a9f61a8d38da$var$ul), $f6c7a9f61a8d38da$var$lc = $f6c7a9f61a8d38da$var$vl;
    } catch (a) {}
}
$f6c7a9f61a8d38da$export$ae55be85d98224ed = $f6c7a9f61a8d38da$var$sl;
$f6c7a9f61a8d38da$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f6c7a9f61a8d38da$var$nl(b)) throw Error($f6c7a9f61a8d38da$var$p(200));
    return $f6c7a9f61a8d38da$var$cl(a, b, null, c);
};
$f6c7a9f61a8d38da$export$882461b6382ed46c = function(a, b) {
    if (!$f6c7a9f61a8d38da$var$nl(a)) throw Error($f6c7a9f61a8d38da$var$p(299));
    var c = !1, d = "", e = $f6c7a9f61a8d38da$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f6c7a9f61a8d38da$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$f6c7a9f61a8d38da$var$uf] = b.current;
    $f6c7a9f61a8d38da$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $f6c7a9f61a8d38da$var$ll(b);
};
$f6c7a9f61a8d38da$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f6c7a9f61a8d38da$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f6c7a9f61a8d38da$var$p(268, a));
    }
    a = $f6c7a9f61a8d38da$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f6c7a9f61a8d38da$export$cd75ccfd720a3cd4 = function(a) {
    return $f6c7a9f61a8d38da$var$Rk(a);
};
$f6c7a9f61a8d38da$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f6c7a9f61a8d38da$var$ol(b)) throw Error($f6c7a9f61a8d38da$var$p(200));
    return $f6c7a9f61a8d38da$var$rl(null, a, b, !0, c);
};
$f6c7a9f61a8d38da$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f6c7a9f61a8d38da$var$nl(a)) throw Error($f6c7a9f61a8d38da$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f6c7a9f61a8d38da$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f6c7a9f61a8d38da$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f6c7a9f61a8d38da$var$uf] = b.current;
    $f6c7a9f61a8d38da$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f6c7a9f61a8d38da$var$ml(b);
};
$f6c7a9f61a8d38da$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f6c7a9f61a8d38da$var$ol(b)) throw Error($f6c7a9f61a8d38da$var$p(200));
    return $f6c7a9f61a8d38da$var$rl(null, a, b, !1, c);
};
$f6c7a9f61a8d38da$export$502457920280e6be = function(a) {
    if (!$f6c7a9f61a8d38da$var$ol(a)) throw Error($f6c7a9f61a8d38da$var$p(40));
    return a._reactRootContainer ? ($f6c7a9f61a8d38da$var$Rk(function() {
        $f6c7a9f61a8d38da$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f6c7a9f61a8d38da$var$uf] = null;
        });
    }), !0) : !1;
};
$f6c7a9f61a8d38da$export$c78a37762a8d58e1 = $f6c7a9f61a8d38da$var$Qk;
$f6c7a9f61a8d38da$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f6c7a9f61a8d38da$var$ol(c)) throw Error($f6c7a9f61a8d38da$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f6c7a9f61a8d38da$var$p(38));
    return $f6c7a9f61a8d38da$var$rl(a, b, c, !1, d);
};
$f6c7a9f61a8d38da$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("5NSbj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5Jb0O"));

});
parcelRegister("5Jb0O", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $42b9b2814d955c9b$export$dca3b0875bd9a954; }, function (v) { return $42b9b2814d955c9b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $42b9b2814d955c9b$export$16fa2f45be04daa8; }, function (v) { return $42b9b2814d955c9b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $42b9b2814d955c9b$export$ffb0004e005737fa; }, function (v) { return $42b9b2814d955c9b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $42b9b2814d955c9b$export$e2c29f18771995cb; }, function (v) { return $42b9b2814d955c9b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $42b9b2814d955c9b$export$221d75b3f55bb0bd; }, function (v) { return $42b9b2814d955c9b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $42b9b2814d955c9b$export$5f8d39834fd61797; }, function (v) { return $42b9b2814d955c9b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $42b9b2814d955c9b$export$74bf444e3cd11ea5; }, function (v) { return $42b9b2814d955c9b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $42b9b2814d955c9b$export$ae55be85d98224ed; }, function (v) { return $42b9b2814d955c9b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $42b9b2814d955c9b$export$3ba232387fd5d6dd; }, function (v) { return $42b9b2814d955c9b$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $42b9b2814d955c9b$export$e530037191fcd5d7; }, function (v) { return $42b9b2814d955c9b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $42b9b2814d955c9b$export$fd42f52fd3ae1109; }, function (v) { return $42b9b2814d955c9b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $42b9b2814d955c9b$export$c8a8987d4410bf2d; }, function (v) { return $42b9b2814d955c9b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $42b9b2814d955c9b$export$d38cd72104c1f0e9; }, function (v) { return $42b9b2814d955c9b$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $42b9b2814d955c9b$export$7d1e3a5e95ceca43; }, function (v) { return $42b9b2814d955c9b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $42b9b2814d955c9b$export$257a8862b851cb5b; }, function (v) { return $42b9b2814d955c9b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $42b9b2814d955c9b$export$a8257692ac88316c; }, function (v) { return $42b9b2814d955c9b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $42b9b2814d955c9b$export$488013bae63b21da; }, function (v) { return $42b9b2814d955c9b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $42b9b2814d955c9b$export$7c73462e0d25e514; }, function (v) { return $42b9b2814d955c9b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $42b9b2814d955c9b$export$7568632d0d33d16d; }, function (v) { return $42b9b2814d955c9b$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $42b9b2814d955c9b$export$88948ce120ea2619; }, function (v) { return $42b9b2814d955c9b$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $42b9b2814d955c9b$export$35808ee640e87ca7; }, function (v) { return $42b9b2814d955c9b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $42b9b2814d955c9b$export$fae74005e78b1a27; }, function (v) { return $42b9b2814d955c9b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $42b9b2814d955c9b$export$dc8fbce3eb94dc1e; }, function (v) { return $42b9b2814d955c9b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $42b9b2814d955c9b$export$6a7bc4e911dc01cf; }, function (v) { return $42b9b2814d955c9b$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $42b9b2814d955c9b$export$6d9c69b0de29b591; }, function (v) { return $42b9b2814d955c9b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $42b9b2814d955c9b$export$f680877a34711e37; }, function (v) { return $42b9b2814d955c9b$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $42b9b2814d955c9b$export$d5a552a76deda3c2; }, function (v) { return $42b9b2814d955c9b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $42b9b2814d955c9b$export$aaabe4eda9ed9969; }, function (v) { return $42b9b2814d955c9b$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $42b9b2814d955c9b$export$e5c5a5f917a5871c; }, function (v) { return $42b9b2814d955c9b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $42b9b2814d955c9b$export$1538c33de8887b59; }, function (v) { return $42b9b2814d955c9b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $42b9b2814d955c9b$export$13e3392192263954; }, function (v) { return $42b9b2814d955c9b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $42b9b2814d955c9b$export$b8f5890fc79d6aca; }, function (v) { return $42b9b2814d955c9b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $42b9b2814d955c9b$export$60241385465d0a34; }, function (v) { return $42b9b2814d955c9b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $42b9b2814d955c9b$export$306c0aa65ff9ec16; }, function (v) { return $42b9b2814d955c9b$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $42b9b2814d955c9b$export$7b286972b8d8ccbf; }, function (v) { return $42b9b2814d955c9b$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $42b9b2814d955c9b$export$83d89fbfd8236492; }, function (v) { return $42b9b2814d955c9b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $42b9b2814d955c9b$export$dca3b0875bd9a954;
var $42b9b2814d955c9b$export$16fa2f45be04daa8;
var $42b9b2814d955c9b$export$ffb0004e005737fa;
var $42b9b2814d955c9b$export$e2c29f18771995cb;
var $42b9b2814d955c9b$export$221d75b3f55bb0bd;
var $42b9b2814d955c9b$export$5f8d39834fd61797;
var $42b9b2814d955c9b$export$74bf444e3cd11ea5;
var $42b9b2814d955c9b$export$ae55be85d98224ed;
var $42b9b2814d955c9b$export$3ba232387fd5d6dd;
var $42b9b2814d955c9b$export$e530037191fcd5d7;
var $42b9b2814d955c9b$export$fd42f52fd3ae1109;
var $42b9b2814d955c9b$export$c8a8987d4410bf2d;
var $42b9b2814d955c9b$export$d38cd72104c1f0e9;
var $42b9b2814d955c9b$export$7d1e3a5e95ceca43;
var $42b9b2814d955c9b$export$257a8862b851cb5b;
var $42b9b2814d955c9b$export$a8257692ac88316c;
var $42b9b2814d955c9b$export$488013bae63b21da;
var $42b9b2814d955c9b$export$7c73462e0d25e514;
var $42b9b2814d955c9b$export$7568632d0d33d16d;
var $42b9b2814d955c9b$export$88948ce120ea2619;
var $42b9b2814d955c9b$export$35808ee640e87ca7;
var $42b9b2814d955c9b$export$fae74005e78b1a27;
var $42b9b2814d955c9b$export$dc8fbce3eb94dc1e;
var $42b9b2814d955c9b$export$6a7bc4e911dc01cf;
var $42b9b2814d955c9b$export$6d9c69b0de29b591;
var $42b9b2814d955c9b$export$f680877a34711e37;
var $42b9b2814d955c9b$export$d5a552a76deda3c2;
var $42b9b2814d955c9b$export$aaabe4eda9ed9969;
var $42b9b2814d955c9b$export$e5c5a5f917a5871c;
var $42b9b2814d955c9b$export$1538c33de8887b59;
var $42b9b2814d955c9b$export$13e3392192263954;
var $42b9b2814d955c9b$export$b8f5890fc79d6aca;
var $42b9b2814d955c9b$export$60241385465d0a34;
var $42b9b2814d955c9b$export$306c0aa65ff9ec16;
var $42b9b2814d955c9b$export$7b286972b8d8ccbf;
var $42b9b2814d955c9b$export$83d89fbfd8236492;
"use strict";
var $42b9b2814d955c9b$var$l = Symbol.for("react.element"), $42b9b2814d955c9b$var$n = Symbol.for("react.portal"), $42b9b2814d955c9b$var$p = Symbol.for("react.fragment"), $42b9b2814d955c9b$var$q = Symbol.for("react.strict_mode"), $42b9b2814d955c9b$var$r = Symbol.for("react.profiler"), $42b9b2814d955c9b$var$t = Symbol.for("react.provider"), $42b9b2814d955c9b$var$u = Symbol.for("react.context"), $42b9b2814d955c9b$var$v = Symbol.for("react.forward_ref"), $42b9b2814d955c9b$var$w = Symbol.for("react.suspense"), $42b9b2814d955c9b$var$x = Symbol.for("react.memo"), $42b9b2814d955c9b$var$y = Symbol.for("react.lazy"), $42b9b2814d955c9b$var$z = Symbol.iterator;
function $42b9b2814d955c9b$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $42b9b2814d955c9b$var$z && a[$42b9b2814d955c9b$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $42b9b2814d955c9b$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $42b9b2814d955c9b$var$C = Object.assign, $42b9b2814d955c9b$var$D = {};
function $42b9b2814d955c9b$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $42b9b2814d955c9b$var$D;
    this.updater = e || $42b9b2814d955c9b$var$B;
}
$42b9b2814d955c9b$var$E.prototype.isReactComponent = {};
$42b9b2814d955c9b$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$42b9b2814d955c9b$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $42b9b2814d955c9b$var$F() {}
$42b9b2814d955c9b$var$F.prototype = $42b9b2814d955c9b$var$E.prototype;
function $42b9b2814d955c9b$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $42b9b2814d955c9b$var$D;
    this.updater = e || $42b9b2814d955c9b$var$B;
}
var $42b9b2814d955c9b$var$H = $42b9b2814d955c9b$var$G.prototype = new $42b9b2814d955c9b$var$F;
$42b9b2814d955c9b$var$H.constructor = $42b9b2814d955c9b$var$G;
$42b9b2814d955c9b$var$C($42b9b2814d955c9b$var$H, $42b9b2814d955c9b$var$E.prototype);
$42b9b2814d955c9b$var$H.isPureReactComponent = !0;
var $42b9b2814d955c9b$var$I = Array.isArray, $42b9b2814d955c9b$var$J = Object.prototype.hasOwnProperty, $42b9b2814d955c9b$var$K = {
    current: null
}, $42b9b2814d955c9b$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $42b9b2814d955c9b$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$42b9b2814d955c9b$var$J.call(b, d) && !$42b9b2814d955c9b$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $42b9b2814d955c9b$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $42b9b2814d955c9b$var$K.current
    };
}
function $42b9b2814d955c9b$var$N(a, b) {
    return {
        $$typeof: $42b9b2814d955c9b$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $42b9b2814d955c9b$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $42b9b2814d955c9b$var$l;
}
function $42b9b2814d955c9b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $42b9b2814d955c9b$var$P = /\/+/g;
function $42b9b2814d955c9b$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $42b9b2814d955c9b$var$escape("" + a.key) : b.toString(36);
}
function $42b9b2814d955c9b$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $42b9b2814d955c9b$var$l:
                case $42b9b2814d955c9b$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $42b9b2814d955c9b$var$Q(h, 0) : d, $42b9b2814d955c9b$var$I(c) ? (e = "", null != a && (e = a.replace($42b9b2814d955c9b$var$P, "$&/") + "/"), $42b9b2814d955c9b$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($42b9b2814d955c9b$var$O(c) && (c = $42b9b2814d955c9b$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($42b9b2814d955c9b$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($42b9b2814d955c9b$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $42b9b2814d955c9b$var$Q(k, g);
        h += $42b9b2814d955c9b$var$R(k, b, e, f, c);
    }
    else if (f = $42b9b2814d955c9b$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $42b9b2814d955c9b$var$Q(k, g++), h += $42b9b2814d955c9b$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $42b9b2814d955c9b$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $42b9b2814d955c9b$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $42b9b2814d955c9b$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $42b9b2814d955c9b$var$U = {
    current: null
}, $42b9b2814d955c9b$var$V = {
    transition: null
}, $42b9b2814d955c9b$var$W = {
    ReactCurrentDispatcher: $42b9b2814d955c9b$var$U,
    ReactCurrentBatchConfig: $42b9b2814d955c9b$var$V,
    ReactCurrentOwner: $42b9b2814d955c9b$var$K
};
function $42b9b2814d955c9b$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$42b9b2814d955c9b$export$dca3b0875bd9a954 = {
    map: $42b9b2814d955c9b$var$S,
    forEach: function(a, b, e) {
        $42b9b2814d955c9b$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $42b9b2814d955c9b$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $42b9b2814d955c9b$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$42b9b2814d955c9b$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$42b9b2814d955c9b$export$16fa2f45be04daa8 = $42b9b2814d955c9b$var$E;
$42b9b2814d955c9b$export$ffb0004e005737fa = $42b9b2814d955c9b$var$p;
$42b9b2814d955c9b$export$e2c29f18771995cb = $42b9b2814d955c9b$var$r;
$42b9b2814d955c9b$export$221d75b3f55bb0bd = $42b9b2814d955c9b$var$G;
$42b9b2814d955c9b$export$5f8d39834fd61797 = $42b9b2814d955c9b$var$q;
$42b9b2814d955c9b$export$74bf444e3cd11ea5 = $42b9b2814d955c9b$var$w;
$42b9b2814d955c9b$export$ae55be85d98224ed = $42b9b2814d955c9b$var$W;
$42b9b2814d955c9b$export$3ba232387fd5d6dd = $42b9b2814d955c9b$var$X;
$42b9b2814d955c9b$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $42b9b2814d955c9b$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $42b9b2814d955c9b$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$42b9b2814d955c9b$var$J.call(b, f) && !$42b9b2814d955c9b$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $42b9b2814d955c9b$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$42b9b2814d955c9b$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $42b9b2814d955c9b$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $42b9b2814d955c9b$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$42b9b2814d955c9b$export$c8a8987d4410bf2d = $42b9b2814d955c9b$var$M;
$42b9b2814d955c9b$export$d38cd72104c1f0e9 = function(a) {
    var b = $42b9b2814d955c9b$var$M.bind(null, a);
    b.type = a;
    return b;
};
$42b9b2814d955c9b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$42b9b2814d955c9b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $42b9b2814d955c9b$var$v,
        render: a
    };
};
$42b9b2814d955c9b$export$a8257692ac88316c = $42b9b2814d955c9b$var$O;
$42b9b2814d955c9b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $42b9b2814d955c9b$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $42b9b2814d955c9b$var$T
    };
};
$42b9b2814d955c9b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $42b9b2814d955c9b$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$42b9b2814d955c9b$export$7568632d0d33d16d = function(a) {
    var b = $42b9b2814d955c9b$var$V.transition;
    $42b9b2814d955c9b$var$V.transition = {};
    try {
        a();
    } finally{
        $42b9b2814d955c9b$var$V.transition = b;
    }
};
$42b9b2814d955c9b$export$88948ce120ea2619 = $42b9b2814d955c9b$var$X;
$42b9b2814d955c9b$export$35808ee640e87ca7 = function(a, b) {
    return $42b9b2814d955c9b$var$U.current.useCallback(a, b);
};
$42b9b2814d955c9b$export$fae74005e78b1a27 = function(a) {
    return $42b9b2814d955c9b$var$U.current.useContext(a);
};
$42b9b2814d955c9b$export$dc8fbce3eb94dc1e = function() {};
$42b9b2814d955c9b$export$6a7bc4e911dc01cf = function(a) {
    return $42b9b2814d955c9b$var$U.current.useDeferredValue(a);
};
$42b9b2814d955c9b$export$6d9c69b0de29b591 = function(a, b) {
    return $42b9b2814d955c9b$var$U.current.useEffect(a, b);
};
$42b9b2814d955c9b$export$f680877a34711e37 = function() {
    return $42b9b2814d955c9b$var$U.current.useId();
};
$42b9b2814d955c9b$export$d5a552a76deda3c2 = function(a, b, e) {
    return $42b9b2814d955c9b$var$U.current.useImperativeHandle(a, b, e);
};
$42b9b2814d955c9b$export$aaabe4eda9ed9969 = function(a, b) {
    return $42b9b2814d955c9b$var$U.current.useInsertionEffect(a, b);
};
$42b9b2814d955c9b$export$e5c5a5f917a5871c = function(a, b) {
    return $42b9b2814d955c9b$var$U.current.useLayoutEffect(a, b);
};
$42b9b2814d955c9b$export$1538c33de8887b59 = function(a, b) {
    return $42b9b2814d955c9b$var$U.current.useMemo(a, b);
};
$42b9b2814d955c9b$export$13e3392192263954 = function(a, b, e) {
    return $42b9b2814d955c9b$var$U.current.useReducer(a, b, e);
};
$42b9b2814d955c9b$export$b8f5890fc79d6aca = function(a) {
    return $42b9b2814d955c9b$var$U.current.useRef(a);
};
$42b9b2814d955c9b$export$60241385465d0a34 = function(a) {
    return $42b9b2814d955c9b$var$U.current.useState(a);
};
$42b9b2814d955c9b$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $42b9b2814d955c9b$var$U.current.useSyncExternalStore(a, b, e);
};
$42b9b2814d955c9b$export$7b286972b8d8ccbf = function() {
    return $42b9b2814d955c9b$var$U.current.useTransition();
};
$42b9b2814d955c9b$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("g09Uk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2MZ6a"));

});
parcelRegister("2MZ6a", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $207f75577cd41328$export$c4744153514ff05d; }, function (v) { return $207f75577cd41328$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $207f75577cd41328$export$3e506c1ccc9cc1a7; }, function (v) { return $207f75577cd41328$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $207f75577cd41328$export$e26fe2ed2fa76875; }, function (v) { return $207f75577cd41328$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $207f75577cd41328$export$502329bbf4b505b1; }, function (v) { return $207f75577cd41328$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $207f75577cd41328$export$6e3807111c4874c4; }, function (v) { return $207f75577cd41328$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $207f75577cd41328$export$c27134553091fb3a; }, function (v) { return $207f75577cd41328$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $207f75577cd41328$export$33ee1acdc04fd2a2; }, function (v) { return $207f75577cd41328$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $207f75577cd41328$export$b00a404bbd5edef2; }, function (v) { return $207f75577cd41328$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $207f75577cd41328$export$8352ce38b91d0c62; }, function (v) { return $207f75577cd41328$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $207f75577cd41328$export$d66a1c1c77bd778b; }, function (v) { return $207f75577cd41328$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $207f75577cd41328$export$d3dfb8e4810cb555; }, function (v) { return $207f75577cd41328$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $207f75577cd41328$export$839f9183b0465a69; }, function (v) { return $207f75577cd41328$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $207f75577cd41328$export$72fdf0e06517287b; }, function (v) { return $207f75577cd41328$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $207f75577cd41328$export$4b844e58a3e414b4; }, function (v) { return $207f75577cd41328$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $207f75577cd41328$export$816d2913ae6b83b1; }, function (v) { return $207f75577cd41328$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $207f75577cd41328$export$61bcfe829111a1d0; }, function (v) { return $207f75577cd41328$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $207f75577cd41328$export$7ee8c9beb337bc3f; }, function (v) { return $207f75577cd41328$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $207f75577cd41328$export$b5836b71941fa3ed; }, function (v) { return $207f75577cd41328$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $207f75577cd41328$export$cf845f2c119da08a; }, function (v) { return $207f75577cd41328$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $207f75577cd41328$export$c4744153514ff05d;
var $207f75577cd41328$export$3e506c1ccc9cc1a7;
var $207f75577cd41328$export$e26fe2ed2fa76875;
var $207f75577cd41328$export$502329bbf4b505b1;
var $207f75577cd41328$export$6e3807111c4874c4;
var $207f75577cd41328$export$c27134553091fb3a;
var $207f75577cd41328$export$33ee1acdc04fd2a2;
var $207f75577cd41328$export$b00a404bbd5edef2;
var $207f75577cd41328$export$8352ce38b91d0c62;
var $207f75577cd41328$export$d66a1c1c77bd778b;
var $207f75577cd41328$export$d3dfb8e4810cb555;
var $207f75577cd41328$export$839f9183b0465a69;
var $207f75577cd41328$export$72fdf0e06517287b;
var $207f75577cd41328$export$4b844e58a3e414b4;
var $207f75577cd41328$export$816d2913ae6b83b1;
var $207f75577cd41328$export$61bcfe829111a1d0;
var $207f75577cd41328$export$7ee8c9beb337bc3f;
var $207f75577cd41328$export$b5836b71941fa3ed;
var $207f75577cd41328$export$cf845f2c119da08a;
"use strict";
function $207f75577cd41328$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $207f75577cd41328$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $207f75577cd41328$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $207f75577cd41328$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $207f75577cd41328$var$g(C, c)) n < e && 0 > $207f75577cd41328$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $207f75577cd41328$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $207f75577cd41328$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $207f75577cd41328$var$l = performance;
    $207f75577cd41328$export$c4744153514ff05d = function() {
        return $207f75577cd41328$var$l.now();
    };
} else {
    var $207f75577cd41328$var$p = Date, $207f75577cd41328$var$q = $207f75577cd41328$var$p.now();
    $207f75577cd41328$export$c4744153514ff05d = function() {
        return $207f75577cd41328$var$p.now() - $207f75577cd41328$var$q;
    };
}
var $207f75577cd41328$var$r = [], $207f75577cd41328$var$t = [], $207f75577cd41328$var$u = 1, $207f75577cd41328$var$v = null, $207f75577cd41328$var$y = 3, $207f75577cd41328$var$z = !1, $207f75577cd41328$var$A = !1, $207f75577cd41328$var$B = !1, $207f75577cd41328$var$D = "function" === typeof setTimeout ? setTimeout : null, $207f75577cd41328$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $207f75577cd41328$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $207f75577cd41328$var$G(a) {
    for(var b = $207f75577cd41328$var$h($207f75577cd41328$var$t); null !== b;){
        if (null === b.callback) $207f75577cd41328$var$k($207f75577cd41328$var$t);
        else if (b.startTime <= a) $207f75577cd41328$var$k($207f75577cd41328$var$t), b.sortIndex = b.expirationTime, $207f75577cd41328$var$f($207f75577cd41328$var$r, b);
        else break;
        b = $207f75577cd41328$var$h($207f75577cd41328$var$t);
    }
}
function $207f75577cd41328$var$H(a) {
    $207f75577cd41328$var$B = !1;
    $207f75577cd41328$var$G(a);
    if (!$207f75577cd41328$var$A) {
        if (null !== $207f75577cd41328$var$h($207f75577cd41328$var$r)) $207f75577cd41328$var$A = !0, $207f75577cd41328$var$I($207f75577cd41328$var$J);
        else {
            var b = $207f75577cd41328$var$h($207f75577cd41328$var$t);
            null !== b && $207f75577cd41328$var$K($207f75577cd41328$var$H, b.startTime - a);
        }
    }
}
function $207f75577cd41328$var$J(a, b) {
    $207f75577cd41328$var$A = !1;
    $207f75577cd41328$var$B && ($207f75577cd41328$var$B = !1, $207f75577cd41328$var$E($207f75577cd41328$var$L), $207f75577cd41328$var$L = -1);
    $207f75577cd41328$var$z = !0;
    var c = $207f75577cd41328$var$y;
    try {
        $207f75577cd41328$var$G(b);
        for($207f75577cd41328$var$v = $207f75577cd41328$var$h($207f75577cd41328$var$r); null !== $207f75577cd41328$var$v && (!($207f75577cd41328$var$v.expirationTime > b) || a && !$207f75577cd41328$var$M());){
            var d = $207f75577cd41328$var$v.callback;
            if ("function" === typeof d) {
                $207f75577cd41328$var$v.callback = null;
                $207f75577cd41328$var$y = $207f75577cd41328$var$v.priorityLevel;
                var e = d($207f75577cd41328$var$v.expirationTime <= b);
                b = $207f75577cd41328$export$c4744153514ff05d();
                "function" === typeof e ? $207f75577cd41328$var$v.callback = e : $207f75577cd41328$var$v === $207f75577cd41328$var$h($207f75577cd41328$var$r) && $207f75577cd41328$var$k($207f75577cd41328$var$r);
                $207f75577cd41328$var$G(b);
            } else $207f75577cd41328$var$k($207f75577cd41328$var$r);
            $207f75577cd41328$var$v = $207f75577cd41328$var$h($207f75577cd41328$var$r);
        }
        if (null !== $207f75577cd41328$var$v) var w = !0;
        else {
            var m = $207f75577cd41328$var$h($207f75577cd41328$var$t);
            null !== m && $207f75577cd41328$var$K($207f75577cd41328$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $207f75577cd41328$var$v = null, $207f75577cd41328$var$y = c, $207f75577cd41328$var$z = !1;
    }
}
var $207f75577cd41328$var$N = !1, $207f75577cd41328$var$O = null, $207f75577cd41328$var$L = -1, $207f75577cd41328$var$P = 5, $207f75577cd41328$var$Q = -1;
function $207f75577cd41328$var$M() {
    return $207f75577cd41328$export$c4744153514ff05d() - $207f75577cd41328$var$Q < $207f75577cd41328$var$P ? !1 : !0;
}
function $207f75577cd41328$var$R() {
    if (null !== $207f75577cd41328$var$O) {
        var a = $207f75577cd41328$export$c4744153514ff05d();
        $207f75577cd41328$var$Q = a;
        var b = !0;
        try {
            b = $207f75577cd41328$var$O(!0, a);
        } finally{
            b ? $207f75577cd41328$var$S() : ($207f75577cd41328$var$N = !1, $207f75577cd41328$var$O = null);
        }
    } else $207f75577cd41328$var$N = !1;
}
var $207f75577cd41328$var$S;
if ("function" === typeof $207f75577cd41328$var$F) $207f75577cd41328$var$S = function() {
    $207f75577cd41328$var$F($207f75577cd41328$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $207f75577cd41328$var$T = new MessageChannel, $207f75577cd41328$var$U = $207f75577cd41328$var$T.port2;
    $207f75577cd41328$var$T.port1.onmessage = $207f75577cd41328$var$R;
    $207f75577cd41328$var$S = function() {
        $207f75577cd41328$var$U.postMessage(null);
    };
} else $207f75577cd41328$var$S = function() {
    $207f75577cd41328$var$D($207f75577cd41328$var$R, 0);
};
function $207f75577cd41328$var$I(a) {
    $207f75577cd41328$var$O = a;
    $207f75577cd41328$var$N || ($207f75577cd41328$var$N = !0, $207f75577cd41328$var$S());
}
function $207f75577cd41328$var$K(a, b) {
    $207f75577cd41328$var$L = $207f75577cd41328$var$D(function() {
        a($207f75577cd41328$export$c4744153514ff05d());
    }, b);
}
$207f75577cd41328$export$3e506c1ccc9cc1a7 = 5;
$207f75577cd41328$export$e26fe2ed2fa76875 = 1;
$207f75577cd41328$export$502329bbf4b505b1 = 4;
$207f75577cd41328$export$6e3807111c4874c4 = 3;
$207f75577cd41328$export$c27134553091fb3a = null;
$207f75577cd41328$export$33ee1acdc04fd2a2 = 2;
$207f75577cd41328$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$207f75577cd41328$export$8352ce38b91d0c62 = function() {
    $207f75577cd41328$var$A || $207f75577cd41328$var$z || ($207f75577cd41328$var$A = !0, $207f75577cd41328$var$I($207f75577cd41328$var$J));
};
$207f75577cd41328$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $207f75577cd41328$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$207f75577cd41328$export$d3dfb8e4810cb555 = function() {
    return $207f75577cd41328$var$y;
};
$207f75577cd41328$export$839f9183b0465a69 = function() {
    return $207f75577cd41328$var$h($207f75577cd41328$var$r);
};
$207f75577cd41328$export$72fdf0e06517287b = function(a) {
    switch($207f75577cd41328$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $207f75577cd41328$var$y;
    }
    var c = $207f75577cd41328$var$y;
    $207f75577cd41328$var$y = b;
    try {
        return a();
    } finally{
        $207f75577cd41328$var$y = c;
    }
};
$207f75577cd41328$export$4b844e58a3e414b4 = function() {};
$207f75577cd41328$export$816d2913ae6b83b1 = function() {};
$207f75577cd41328$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $207f75577cd41328$var$y;
    $207f75577cd41328$var$y = a;
    try {
        return b();
    } finally{
        $207f75577cd41328$var$y = c;
    }
};
$207f75577cd41328$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $207f75577cd41328$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $207f75577cd41328$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $207f75577cd41328$var$f($207f75577cd41328$var$t, a), null === $207f75577cd41328$var$h($207f75577cd41328$var$r) && a === $207f75577cd41328$var$h($207f75577cd41328$var$t) && ($207f75577cd41328$var$B ? ($207f75577cd41328$var$E($207f75577cd41328$var$L), $207f75577cd41328$var$L = -1) : $207f75577cd41328$var$B = !0, $207f75577cd41328$var$K($207f75577cd41328$var$H, c - d))) : (a.sortIndex = e, $207f75577cd41328$var$f($207f75577cd41328$var$r, a), $207f75577cd41328$var$A || $207f75577cd41328$var$z || ($207f75577cd41328$var$A = !0, $207f75577cd41328$var$I($207f75577cd41328$var$J)));
    return a;
};
$207f75577cd41328$export$b5836b71941fa3ed = $207f75577cd41328$var$M;
$207f75577cd41328$export$cf845f2c119da08a = function(a) {
    var b = $207f75577cd41328$var$y;
    return function() {
        var c = $207f75577cd41328$var$y;
        $207f75577cd41328$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $207f75577cd41328$var$y = c;
        }
    };
};

});



parcelRegister("hHzFu", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ce321ec5149acfe9$export$ffb0004e005737fa; }, function (v) { return $ce321ec5149acfe9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ce321ec5149acfe9$export$34b9dba7ce09269b; }, function (v) { return $ce321ec5149acfe9$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ce321ec5149acfe9$export$25062201e9e25d76; }, function (v) { return $ce321ec5149acfe9$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ce321ec5149acfe9$export$ffb0004e005737fa;
var $ce321ec5149acfe9$export$34b9dba7ce09269b;
var $ce321ec5149acfe9$export$25062201e9e25d76;
"use strict";

var $5NSbj = parcelRequire("5NSbj");
var $ce321ec5149acfe9$var$k = Symbol.for("react.element"), $ce321ec5149acfe9$var$l = Symbol.for("react.fragment"), $ce321ec5149acfe9$var$m = Object.prototype.hasOwnProperty, $ce321ec5149acfe9$var$n = $5NSbj.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ce321ec5149acfe9$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ce321ec5149acfe9$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$ce321ec5149acfe9$var$m.call(a, b) && !$ce321ec5149acfe9$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $ce321ec5149acfe9$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $ce321ec5149acfe9$var$n.current
    };
}
$ce321ec5149acfe9$export$ffb0004e005737fa = $ce321ec5149acfe9$var$l;
$ce321ec5149acfe9$export$34b9dba7ce09269b = $ce321ec5149acfe9$var$q;
$ce321ec5149acfe9$export$25062201e9e25d76 = $ce321ec5149acfe9$var$q;

});

parcelRegister("g5hZU", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $fRRcL = parcelRequire("fRRcL");
function $bb5b12ede33ebc1b$var$emptyFunction() {}
function $bb5b12ede33ebc1b$var$emptyFunctionWithReset() {}
$bb5b12ede33ebc1b$var$emptyFunctionWithReset.resetWarningCache = $bb5b12ede33ebc1b$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $fRRcL) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $bb5b12ede33ebc1b$var$emptyFunctionWithReset,
        resetWarningCache: $bb5b12ede33ebc1b$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("fRRcL", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $b8d5139e8a8c9096$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $b8d5139e8a8c9096$var$ReactPropTypesSecret;

});


parcelRegister("k8ZyL", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $eaa44e78d9a0fa78$export$2b8d127b894957b9; }, function (v) { return $eaa44e78d9a0fa78$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $eaa44e78d9a0fa78$export$cea3a54a6425200c; }, function (v) { return $eaa44e78d9a0fa78$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $eaa44e78d9a0fa78$export$a7c73072b1a182ae; }, function (v) { return $eaa44e78d9a0fa78$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $eaa44e78d9a0fa78$export$9f27bc3417b4524d; }, function (v) { return $eaa44e78d9a0fa78$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $eaa44e78d9a0fa78$export$db77ccec0bb4ccac; }, function (v) { return $eaa44e78d9a0fa78$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $eaa44e78d9a0fa78$export$8392c0c9d3dcbd35; }, function (v) { return $eaa44e78d9a0fa78$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $eaa44e78d9a0fa78$export$ffb0004e005737fa; }, function (v) { return $eaa44e78d9a0fa78$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $eaa44e78d9a0fa78$export$b624eff549462981; }, function (v) { return $eaa44e78d9a0fa78$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $eaa44e78d9a0fa78$export$7897aa7841a5380c; }, function (v) { return $eaa44e78d9a0fa78$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $eaa44e78d9a0fa78$export$602eac185826482c; }, function (v) { return $eaa44e78d9a0fa78$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $eaa44e78d9a0fa78$export$e2c29f18771995cb; }, function (v) { return $eaa44e78d9a0fa78$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $eaa44e78d9a0fa78$export$5f8d39834fd61797; }, function (v) { return $eaa44e78d9a0fa78$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $eaa44e78d9a0fa78$export$74bf444e3cd11ea5; }, function (v) { return $eaa44e78d9a0fa78$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $eaa44e78d9a0fa78$export$92387174baf9b227; }, function (v) { return $eaa44e78d9a0fa78$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $eaa44e78d9a0fa78$export$ec112efeb987d9c6; }, function (v) { return $eaa44e78d9a0fa78$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $eaa44e78d9a0fa78$export$b706b080d889d2c9; }, function (v) { return $eaa44e78d9a0fa78$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $eaa44e78d9a0fa78$export$5be5a87408f70ddc; }, function (v) { return $eaa44e78d9a0fa78$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $eaa44e78d9a0fa78$export$45a5e7f76e0caa8d; }, function (v) { return $eaa44e78d9a0fa78$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $eaa44e78d9a0fa78$export$455c2e768291efa6; }, function (v) { return $eaa44e78d9a0fa78$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $eaa44e78d9a0fa78$export$9522e17588c12572; }, function (v) { return $eaa44e78d9a0fa78$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $eaa44e78d9a0fa78$export$2110ac352bb060b9; }, function (v) { return $eaa44e78d9a0fa78$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $eaa44e78d9a0fa78$export$56885ab8b9c456ab; }, function (v) { return $eaa44e78d9a0fa78$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $eaa44e78d9a0fa78$export$d927fcb6adf8f9de; }, function (v) { return $eaa44e78d9a0fa78$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $eaa44e78d9a0fa78$export$b82d16f27459e05a; }, function (v) { return $eaa44e78d9a0fa78$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $eaa44e78d9a0fa78$export$522c17b4f5e123e8; }, function (v) { return $eaa44e78d9a0fa78$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $eaa44e78d9a0fa78$export$1aabd8a0274ecfd6; }, function (v) { return $eaa44e78d9a0fa78$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $eaa44e78d9a0fa78$export$9b621391a187a31a; }, function (v) { return $eaa44e78d9a0fa78$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $eaa44e78d9a0fa78$export$f5bbd400c2f4426f; }, function (v) { return $eaa44e78d9a0fa78$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eaa44e78d9a0fa78$export$2b8d127b894957b9;
var $eaa44e78d9a0fa78$export$cea3a54a6425200c;
var $eaa44e78d9a0fa78$export$a7c73072b1a182ae;
var $eaa44e78d9a0fa78$export$9f27bc3417b4524d;
var $eaa44e78d9a0fa78$export$db77ccec0bb4ccac;
var $eaa44e78d9a0fa78$export$8392c0c9d3dcbd35;
var $eaa44e78d9a0fa78$export$ffb0004e005737fa;
var $eaa44e78d9a0fa78$export$b624eff549462981;
var $eaa44e78d9a0fa78$export$7897aa7841a5380c;
var $eaa44e78d9a0fa78$export$602eac185826482c;
var $eaa44e78d9a0fa78$export$e2c29f18771995cb;
var $eaa44e78d9a0fa78$export$5f8d39834fd61797;
var $eaa44e78d9a0fa78$export$74bf444e3cd11ea5;
var $eaa44e78d9a0fa78$export$92387174baf9b227;
var $eaa44e78d9a0fa78$export$ec112efeb987d9c6;
var $eaa44e78d9a0fa78$export$b706b080d889d2c9;
var $eaa44e78d9a0fa78$export$5be5a87408f70ddc;
var $eaa44e78d9a0fa78$export$45a5e7f76e0caa8d;
var $eaa44e78d9a0fa78$export$455c2e768291efa6;
var $eaa44e78d9a0fa78$export$9522e17588c12572;
var $eaa44e78d9a0fa78$export$2110ac352bb060b9;
var $eaa44e78d9a0fa78$export$56885ab8b9c456ab;
var $eaa44e78d9a0fa78$export$d927fcb6adf8f9de;
var $eaa44e78d9a0fa78$export$b82d16f27459e05a;
var $eaa44e78d9a0fa78$export$522c17b4f5e123e8;
var $eaa44e78d9a0fa78$export$1aabd8a0274ecfd6;
var $eaa44e78d9a0fa78$export$9b621391a187a31a;
var $eaa44e78d9a0fa78$export$f5bbd400c2f4426f;
"use strict";
var $eaa44e78d9a0fa78$var$b = "function" === typeof Symbol && Symbol.for, $eaa44e78d9a0fa78$var$c = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.element") : 60103, $eaa44e78d9a0fa78$var$d = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.portal") : 60106, $eaa44e78d9a0fa78$var$e = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.fragment") : 60107, $eaa44e78d9a0fa78$var$f = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.strict_mode") : 60108, $eaa44e78d9a0fa78$var$g = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.profiler") : 60114, $eaa44e78d9a0fa78$var$h = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.provider") : 60109, $eaa44e78d9a0fa78$var$k = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.context") : 60110, $eaa44e78d9a0fa78$var$l = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.async_mode") : 60111, $eaa44e78d9a0fa78$var$m = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.concurrent_mode") : 60111, $eaa44e78d9a0fa78$var$n = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.forward_ref") : 60112, $eaa44e78d9a0fa78$var$p = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.suspense") : 60113, $eaa44e78d9a0fa78$var$q = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.suspense_list") : 60120, $eaa44e78d9a0fa78$var$r = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.memo") : 60115, $eaa44e78d9a0fa78$var$t = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.lazy") : 60116, $eaa44e78d9a0fa78$var$v = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.block") : 60121, $eaa44e78d9a0fa78$var$w = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.fundamental") : 60117, $eaa44e78d9a0fa78$var$x = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.responder") : 60118, $eaa44e78d9a0fa78$var$y = $eaa44e78d9a0fa78$var$b ? Symbol.for("react.scope") : 60119;
function $eaa44e78d9a0fa78$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $eaa44e78d9a0fa78$var$c:
                switch(a = a.type, a){
                    case $eaa44e78d9a0fa78$var$l:
                    case $eaa44e78d9a0fa78$var$m:
                    case $eaa44e78d9a0fa78$var$e:
                    case $eaa44e78d9a0fa78$var$g:
                    case $eaa44e78d9a0fa78$var$f:
                    case $eaa44e78d9a0fa78$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $eaa44e78d9a0fa78$var$k:
                            case $eaa44e78d9a0fa78$var$n:
                            case $eaa44e78d9a0fa78$var$t:
                            case $eaa44e78d9a0fa78$var$r:
                            case $eaa44e78d9a0fa78$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $eaa44e78d9a0fa78$var$d:
                return u;
        }
    }
}
function $eaa44e78d9a0fa78$var$A(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$m;
}
$eaa44e78d9a0fa78$export$2b8d127b894957b9 = $eaa44e78d9a0fa78$var$l;
$eaa44e78d9a0fa78$export$cea3a54a6425200c = $eaa44e78d9a0fa78$var$m;
$eaa44e78d9a0fa78$export$a7c73072b1a182ae = $eaa44e78d9a0fa78$var$k;
$eaa44e78d9a0fa78$export$9f27bc3417b4524d = $eaa44e78d9a0fa78$var$h;
$eaa44e78d9a0fa78$export$db77ccec0bb4ccac = $eaa44e78d9a0fa78$var$c;
$eaa44e78d9a0fa78$export$8392c0c9d3dcbd35 = $eaa44e78d9a0fa78$var$n;
$eaa44e78d9a0fa78$export$ffb0004e005737fa = $eaa44e78d9a0fa78$var$e;
$eaa44e78d9a0fa78$export$b624eff549462981 = $eaa44e78d9a0fa78$var$t;
$eaa44e78d9a0fa78$export$7897aa7841a5380c = $eaa44e78d9a0fa78$var$r;
$eaa44e78d9a0fa78$export$602eac185826482c = $eaa44e78d9a0fa78$var$d;
$eaa44e78d9a0fa78$export$e2c29f18771995cb = $eaa44e78d9a0fa78$var$g;
$eaa44e78d9a0fa78$export$5f8d39834fd61797 = $eaa44e78d9a0fa78$var$f;
$eaa44e78d9a0fa78$export$74bf444e3cd11ea5 = $eaa44e78d9a0fa78$var$p;
$eaa44e78d9a0fa78$export$92387174baf9b227 = function(a) {
    return $eaa44e78d9a0fa78$var$A(a) || $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$l;
};
$eaa44e78d9a0fa78$export$ec112efeb987d9c6 = $eaa44e78d9a0fa78$var$A;
$eaa44e78d9a0fa78$export$b706b080d889d2c9 = function(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$k;
};
$eaa44e78d9a0fa78$export$5be5a87408f70ddc = function(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$h;
};
$eaa44e78d9a0fa78$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $eaa44e78d9a0fa78$var$c;
};
$eaa44e78d9a0fa78$export$455c2e768291efa6 = function(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$n;
};
$eaa44e78d9a0fa78$export$9522e17588c12572 = function(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$e;
};
$eaa44e78d9a0fa78$export$2110ac352bb060b9 = function(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$t;
};
$eaa44e78d9a0fa78$export$56885ab8b9c456ab = function(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$r;
};
$eaa44e78d9a0fa78$export$d927fcb6adf8f9de = function(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$d;
};
$eaa44e78d9a0fa78$export$b82d16f27459e05a = function(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$g;
};
$eaa44e78d9a0fa78$export$522c17b4f5e123e8 = function(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$f;
};
$eaa44e78d9a0fa78$export$1aabd8a0274ecfd6 = function(a) {
    return $eaa44e78d9a0fa78$var$z(a) === $eaa44e78d9a0fa78$var$p;
};
$eaa44e78d9a0fa78$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $eaa44e78d9a0fa78$var$e || a === $eaa44e78d9a0fa78$var$m || a === $eaa44e78d9a0fa78$var$g || a === $eaa44e78d9a0fa78$var$f || a === $eaa44e78d9a0fa78$var$p || a === $eaa44e78d9a0fa78$var$q || "object" === typeof a && null !== a && (a.$$typeof === $eaa44e78d9a0fa78$var$t || a.$$typeof === $eaa44e78d9a0fa78$var$r || a.$$typeof === $eaa44e78d9a0fa78$var$h || a.$$typeof === $eaa44e78d9a0fa78$var$k || a.$$typeof === $eaa44e78d9a0fa78$var$n || a.$$typeof === $eaa44e78d9a0fa78$var$w || a.$$typeof === $eaa44e78d9a0fa78$var$x || a.$$typeof === $eaa44e78d9a0fa78$var$y || a.$$typeof === $eaa44e78d9a0fa78$var$v);
};
$eaa44e78d9a0fa78$export$f5bbd400c2f4426f = $eaa44e78d9a0fa78$var$z;

});

parcelRegister("a9Dz7", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $76496f8af7ea28b8$export$306c0aa65ff9ec16; }, function (v) { return $76496f8af7ea28b8$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $76496f8af7ea28b8$export$306c0aa65ff9ec16;
"use strict";

var $5NSbj = parcelRequire("5NSbj");
function $76496f8af7ea28b8$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $76496f8af7ea28b8$var$k = "function" === typeof Object.is ? Object.is : $76496f8af7ea28b8$var$h, $76496f8af7ea28b8$var$l = $5NSbj.useState, $76496f8af7ea28b8$var$m = $5NSbj.useEffect, $76496f8af7ea28b8$var$n = $5NSbj.useLayoutEffect, $76496f8af7ea28b8$var$p = $5NSbj.useDebugValue;
function $76496f8af7ea28b8$var$q(a, b) {
    var d = b(), f = $76496f8af7ea28b8$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $76496f8af7ea28b8$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $76496f8af7ea28b8$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $76496f8af7ea28b8$var$m(function() {
        $76496f8af7ea28b8$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $76496f8af7ea28b8$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $76496f8af7ea28b8$var$p(d);
    return d;
}
function $76496f8af7ea28b8$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$76496f8af7ea28b8$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $76496f8af7ea28b8$var$t(a, b) {
    return b();
}
var $76496f8af7ea28b8$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $76496f8af7ea28b8$var$t : $76496f8af7ea28b8$var$q;
$76496f8af7ea28b8$export$306c0aa65ff9ec16 = void 0 !== $5NSbj.useSyncExternalStore ? $5NSbj.useSyncExternalStore : $76496f8af7ea28b8$var$u;

});

var $265f56d83db539c0$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $265f56d83db539c0$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $265f56d83db539c0$exports));
try {
    regeneratorRuntime = $265f56d83db539c0$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $265f56d83db539c0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($265f56d83db539c0$var$runtime);
}


var $fdb09cd070e137df$export$882461b6382ed46c;
var $fdb09cd070e137df$export$757ceba2d55c277e;
"use strict";
var $178ae9275e33f716$exports = {};
"use strict";
function $178ae9275e33f716$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($178ae9275e33f716$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$178ae9275e33f716$var$checkDCE();

$178ae9275e33f716$exports = (parcelRequire("lbBr3"));


var $fdb09cd070e137df$var$i;
$fdb09cd070e137df$export$882461b6382ed46c = $178ae9275e33f716$exports.createRoot;
$fdb09cd070e137df$export$757ceba2d55c277e = $178ae9275e33f716$exports.hydrateRoot;


class $506fdaa0545346a2$export$1871035840b7f83a extends Error {
    constructor(message = "Offline storage is not available"){
        super(message);
        this.name = "OfflineStorageNotAvailableError";
    }
}
class $506fdaa0545346a2$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(message);
        this.name = "TimeoutError";
    }
}
class $506fdaa0545346a2$export$65bd6083489bd8bb extends Error {
    constructor(message){
        super(message);
        this.name = "HttpError";
    }
}
class $506fdaa0545346a2$export$5e64a9683d127ef6 extends Error {
    constructor(message){
        super(message);
        this.name = "LoginError";
    }
}
class $506fdaa0545346a2$export$4511c7da58e2d9c2 extends Error {
    constructor(message){
        super(message);
        this.name = "UnexpectedStateError";
    }
}


var $7d3633f2d0caaef5$exports = {};

$parcel$export($7d3633f2d0caaef5$exports, "rejectUnless", function () { return $7d3633f2d0caaef5$export$8d90b058a02656d9; });
$parcel$export($7d3633f2d0caaef5$exports, "rejectIfNotOkay", function () { return $7d3633f2d0caaef5$export$3a2f576a374b4dda; });
$parcel$export($7d3633f2d0caaef5$exports, "options", function () { return $7d3633f2d0caaef5$export$41c562ebe57d11e2; });
$parcel$export($7d3633f2d0caaef5$exports, "option", function () { return $7d3633f2d0caaef5$export$a75d1723e6bda2ec; });
$parcel$export($7d3633f2d0caaef5$exports, "headers", function () { return $7d3633f2d0caaef5$export$838e2a576d4d6ff6; });
$parcel$export($7d3633f2d0caaef5$exports, "header", function () { return $7d3633f2d0caaef5$export$38e42c68cf43b5d4; });
$parcel$export($7d3633f2d0caaef5$exports, "liftToPromiseField", function () { return $7d3633f2d0caaef5$export$e39d76e25ce37988; });
$parcel$export($7d3633f2d0caaef5$exports, "makeAbortableFetch", function () { return $7d3633f2d0caaef5$export$9c77439751b4390b; });
$parcel$export($7d3633f2d0caaef5$exports, "makeFetchWithTimeout", function () { return $7d3633f2d0caaef5$export$e9a8372937ef7f1; });
$parcel$export($7d3633f2d0caaef5$exports, "makeFetchFailOnHttpErrors", function () { return $7d3633f2d0caaef5$export$fe633c745f42b5cd; });
$parcel$export($7d3633f2d0caaef5$exports, "makeFetchSupportGetBody", function () { return $7d3633f2d0caaef5$export$f4ba43f659d5549c; });
$parcel$export($7d3633f2d0caaef5$exports, "fetch", function () { return $7d3633f2d0caaef5$export$e7aa7bc5c1b3cfb3; });
$parcel$export($7d3633f2d0caaef5$exports, "get", function () { return $7d3633f2d0caaef5$export$3988ae62b71be9a3; });
$parcel$export($7d3633f2d0caaef5$exports, "post", function () { return $7d3633f2d0caaef5$export$299ba2dee77727e9; });
$parcel$export($7d3633f2d0caaef5$exports, "delete_", function () { return $7d3633f2d0caaef5$export$38dab5a9fea42f39; });
$parcel$export($7d3633f2d0caaef5$exports, "makeSearchParams", function () { return $7d3633f2d0caaef5$export$92871f7982deaf9f; });
var $f4177b5095a62a77$exports = {};
$f4177b5095a62a77$exports = (data, opts = {})=>{
    const { sorted: sorted, ignorenull: ignorenull, ignoreEmptyArray: ignoreEmptyArray, useDot: useDot, skipIndex: skipIndex, skipBracket: skipBracket, whitespace: whitespace = "+" } = opts;
    const encode = (value)=>String(value).replace(/[^ !'()~*]/gu, encodeURIComponent).replace(/ /g, whitespace).replace(/[!'()~*]/g, (ch)=>`%${ch.charCodeAt().toString(16).slice(-2).toUpperCase()}`);
    const keys = (obj, keyarr = Object.keys(obj))=>sorted ? keyarr.sort() : keyarr;
    const filterjoin = (arr)=>arr.filter((e)=>e).join("&");
    const objnest = (name, obj)=>filterjoin(keys(obj).map((key)=>useDot ? nest(`${name}.${key}`, obj[key]) : nest(`${name}[${key}]`, obj[key])));
    const arrnest = (name, arr, brackets = skipBracket ? "" : "[]")=>arr.length ? filterjoin(arr.map((elem, index)=>skipIndex ? nest(name + brackets, elem) : nest(name + "[" + index + "]", elem))) : ignoreEmptyArray ? null : encode(name + brackets);
    const setnest = (name, set)=>filterjoin(Array.from(set).map((elem)=>nest(name, elem)));
    const nest = (name, value, type = typeof value, f = null)=>{
        if (value === f) f = ignorenull ? f : encode(name) + "=" + f;
        else if (/string|number|boolean/.test(type)) f = encode(name) + "=" + encode(value);
        else if (Array.isArray(value)) f = arrnest(name, value);
        else if (value instanceof Set) f = setnest(name, value);
        else if (type === "object") f = objnest(name, value);
        return f;
    };
    return data && filterjoin(keys(data).map((key)=>nest(key, data[key])));
};


var $d84591a9ff0ebb48$exports = {};
var $11b3c3fd62c22b91$exports = {};
var $7930f30efbe644a1$exports = {};
var $fd1d129950ecf19e$exports = {};
var $a74be12dfba1a9ac$exports = {};
$a74be12dfba1a9ac$exports = {
    "@@functional/placeholder": true
};


function $fd1d129950ecf19e$var$_isPlaceholder(a) {
    return a === $a74be12dfba1a9ac$exports;
}
$fd1d129950ecf19e$exports = $fd1d129950ecf19e$var$_isPlaceholder;


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $7930f30efbe644a1$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $fd1d129950ecf19e$exports(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
$7930f30efbe644a1$exports = $7930f30efbe644a1$var$_curry1;



/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $11b3c3fd62c22b91$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $fd1d129950ecf19e$exports(a) ? f2 : $7930f30efbe644a1$exports(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $fd1d129950ecf19e$exports(a) && $fd1d129950ecf19e$exports(b) ? f2 : $fd1d129950ecf19e$exports(a) ? $7930f30efbe644a1$exports(function(_a) {
                    return fn(_a, b);
                }) : $fd1d129950ecf19e$exports(b) ? $7930f30efbe644a1$exports(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
$11b3c3fd62c22b91$exports = $11b3c3fd62c22b91$var$_curry2;


var $978b2ede170a45e5$exports = {};
var $79baec68be7bb256$exports = {};



/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $79baec68be7bb256$var$_curry3(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return $fd1d129950ecf19e$exports(a) ? f3 : $11b3c3fd62c22b91$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return $fd1d129950ecf19e$exports(a) && $fd1d129950ecf19e$exports(b) ? f3 : $fd1d129950ecf19e$exports(a) ? $11b3c3fd62c22b91$exports(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : $fd1d129950ecf19e$exports(b) ? $11b3c3fd62c22b91$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : $7930f30efbe644a1$exports(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return $fd1d129950ecf19e$exports(a) && $fd1d129950ecf19e$exports(b) && $fd1d129950ecf19e$exports(c) ? f3 : $fd1d129950ecf19e$exports(a) && $fd1d129950ecf19e$exports(b) ? $11b3c3fd62c22b91$exports(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : $fd1d129950ecf19e$exports(a) && $fd1d129950ecf19e$exports(c) ? $11b3c3fd62c22b91$exports(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : $fd1d129950ecf19e$exports(b) && $fd1d129950ecf19e$exports(c) ? $11b3c3fd62c22b91$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : $fd1d129950ecf19e$exports(a) ? $7930f30efbe644a1$exports(function(_a) {
                    return fn(_a, b, c);
                }) : $fd1d129950ecf19e$exports(b) ? $7930f30efbe644a1$exports(function(_b) {
                    return fn(a, _b, c);
                }) : $fd1d129950ecf19e$exports(c) ? $7930f30efbe644a1$exports(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}
$79baec68be7bb256$exports = $79baec68be7bb256$var$_curry3;


var $a060db5eca4f28fd$exports = {};
function $a060db5eca4f28fd$var$_isObject(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}
$a060db5eca4f28fd$exports = $a060db5eca4f28fd$var$_isObject;


var $9b2e7c822ef70d5b$exports = {};

var $b67b11238be38685$exports = {};
function $b67b11238be38685$var$_has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
$b67b11238be38685$exports = $b67b11238be38685$var$_has;


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $9b2e7c822ef70d5b$var$mergeWithKey = /*#__PURE__*/ $79baec68be7bb256$exports(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    l = l || {};
    r = r || {};
    for(k in l)if ($b67b11238be38685$exports(k, l)) result[k] = $b67b11238be38685$exports(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ($b67b11238be38685$exports(k, r) && !$b67b11238be38685$exports(k, result)) result[k] = r[k];
    return result;
});
$9b2e7c822ef70d5b$exports = $9b2e7c822ef70d5b$var$mergeWithKey;


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $978b2ede170a45e5$var$mergeDeepWithKey = /*#__PURE__*/ $79baec68be7bb256$exports(function mergeDeepWithKey(fn, lObj, rObj) {
    return $9b2e7c822ef70d5b$exports(function(k, lVal, rVal) {
        if ($a060db5eca4f28fd$exports(lVal) && $a060db5eca4f28fd$exports(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
$978b2ede170a45e5$exports = $978b2ede170a45e5$var$mergeDeepWithKey;


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $d84591a9ff0ebb48$var$mergeDeepLeft = /*#__PURE__*/ $11b3c3fd62c22b91$exports(function mergeDeepLeft(lObj, rObj) {
    return $978b2ede170a45e5$exports(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
$d84591a9ff0ebb48$exports = $d84591a9ff0ebb48$var$mergeDeepLeft;


var $00ab3e86e584dd7b$exports = {};
var $e54479dfc8e6276d$exports = {};
function $e54479dfc8e6276d$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}
$e54479dfc8e6276d$exports = $e54479dfc8e6276d$var$_arity;


var $889892c42e9badec$exports = {};
function $889892c42e9badec$var$_pipe(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}
$889892c42e9badec$exports = $889892c42e9badec$var$_pipe;


var $79955e417640e2d0$exports = {};

var $72f6f8d46a04a8db$exports = {};
var $8d26e1096e1356d4$exports = {};
var $12e66c9e65e60cae$exports = {};

var $ba1de13db1e87172$exports = {};
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ $ba1de13db1e87172$exports = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};


var $acb10f4bb9254ad8$exports = {};
function $acb10f4bb9254ad8$var$_isString(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}
$acb10f4bb9254ad8$exports = $acb10f4bb9254ad8$var$_isString;


/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */ var $12e66c9e65e60cae$var$_isArrayLike = /*#__PURE__*/ $7930f30efbe644a1$exports(function isArrayLike(x) {
    if ($ba1de13db1e87172$exports(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if ($acb10f4bb9254ad8$exports(x)) return false;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
$12e66c9e65e60cae$exports = $12e66c9e65e60cae$var$_isArrayLike;


var $8d26e1096e1356d4$var$symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function $8d26e1096e1356d4$var$_createReduce(arrayReduce, methodReduce, iterableReduce) {
    return function _reduce(xf, acc, list) {
        if ($12e66c9e65e60cae$exports(list)) return arrayReduce(xf, acc, list);
        if (list == null) return acc;
        if (typeof list["fantasy-land/reduce"] === "function") return methodReduce(xf, acc, list, "fantasy-land/reduce");
        if (list[$8d26e1096e1356d4$var$symIterator] != null) return iterableReduce(xf, acc, list[$8d26e1096e1356d4$var$symIterator]());
        if (typeof list.next === "function") return iterableReduce(xf, acc, list);
        if (typeof list.reduce === "function") return methodReduce(xf, acc, list, "reduce");
        throw new TypeError("reduce: list must be array or iterable");
    };
}
$8d26e1096e1356d4$exports = $8d26e1096e1356d4$var$_createReduce;


var $58e8baccbb3f3299$exports = {};
function $58e8baccbb3f3299$var$_xArrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}
$58e8baccbb3f3299$exports = $58e8baccbb3f3299$var$_xArrayReduce;


var $3431363f125f2e07$exports = {};


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $3431363f125f2e07$var$bind = /*#__PURE__*/ $11b3c3fd62c22b91$exports(function bind(fn, thisObj) {
    return $e54479dfc8e6276d$exports(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
$3431363f125f2e07$exports = $3431363f125f2e07$var$bind;


function $72f6f8d46a04a8db$var$_xIterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function $72f6f8d46a04a8db$var$_xMethodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName]($3431363f125f2e07$exports(xf["@@transducer/step"], xf), acc));
}
var $72f6f8d46a04a8db$var$_xReduce = /*#__PURE__*/ $8d26e1096e1356d4$exports($58e8baccbb3f3299$exports, $72f6f8d46a04a8db$var$_xMethodReduce, $72f6f8d46a04a8db$var$_xIterableReduce);
$72f6f8d46a04a8db$exports = $72f6f8d46a04a8db$var$_xReduce;


var $d161b2485e3b6c60$exports = {};
var $d161b2485e3b6c60$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $d161b2485e3b6c60$var$_xwrap(fn) {
    return new $d161b2485e3b6c60$var$XWrap(fn);
}
$d161b2485e3b6c60$exports = $d161b2485e3b6c60$var$_xwrap;


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Be cautious of mutating and returning the accumulator. If you reuse it across
 * invocations, it will continue to accumulate onto the same value. The general
 * recommendation is to always return a new value. If you can't do so for
 * performance reasons, then be sure to reinitialize the accumulator on each
 * invocation.
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $79955e417640e2d0$var$reduce = /*#__PURE__*/ $79baec68be7bb256$exports(function(xf, acc, list) {
    return $72f6f8d46a04a8db$exports(typeof xf === "function" ? $d161b2485e3b6c60$exports(xf) : xf, acc, list);
});
$79955e417640e2d0$exports = $79955e417640e2d0$var$reduce;


var $af38f6844df9a44f$exports = {};
var $6cbc125171a9f4c6$exports = {};

/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implementation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */ function $6cbc125171a9f4c6$var$_checkForMethod(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return $ba1de13db1e87172$exports(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}
$6cbc125171a9f4c6$exports = $6cbc125171a9f4c6$var$_checkForMethod;



var $4c3ac4a56cdd2fd0$exports = {};


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $4c3ac4a56cdd2fd0$var$slice = /*#__PURE__*/ $79baec68be7bb256$exports(/*#__PURE__*/ $6cbc125171a9f4c6$exports("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
$4c3ac4a56cdd2fd0$exports = $4c3ac4a56cdd2fd0$var$slice;


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $af38f6844df9a44f$var$tail = /*#__PURE__*/ $7930f30efbe644a1$exports(/*#__PURE__*/ $6cbc125171a9f4c6$exports("tail", /*#__PURE__*/ $4c3ac4a56cdd2fd0$exports(1, Infinity)));
$af38f6844df9a44f$exports = $af38f6844df9a44f$var$tail;


/**
 * Performs left-to-right function composition. The first argument may have
 * any arity; the remaining arguments must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      const f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 * @symb R.pipe(f, g, h)(a)(b) = h(g(f(a)))(b)
 */ function $00ab3e86e584dd7b$var$pipe() {
    if (arguments.length === 0) throw new Error("pipe requires at least one argument");
    return $e54479dfc8e6276d$exports(arguments[0].length, $79955e417640e2d0$exports($889892c42e9badec$exports, arguments[0], $af38f6844df9a44f$exports(arguments)));
}
$00ab3e86e584dd7b$exports = $00ab3e86e584dd7b$var$pipe;



const $7d3633f2d0caaef5$export$8d90b058a02656d9 = (pred)=>(response)=>{
        if (pred(response)) return response;
        else {
            const err = new (0, $506fdaa0545346a2$export$65bd6083489bd8bb)(response.statusText);
            err.response = response;
            throw err;
        }
    };
const $7d3633f2d0caaef5$export$3a2f576a374b4dda = (response)=>{
    return $7d3633f2d0caaef5$export$8d90b058a02656d9((response)=>response.ok)(response);
};
const $7d3633f2d0caaef5$export$41c562ebe57d11e2 = (newOpts)=>(fetch)=>(url, opts = {})=>fetch(url, (0, (/*@__PURE__*/$parcel$interopDefault($d84591a9ff0ebb48$exports)))(opts, newOpts));
const $7d3633f2d0caaef5$export$a75d1723e6bda2ec = (name, value)=>$7d3633f2d0caaef5$export$41c562ebe57d11e2({
        [name]: value
    });
const $7d3633f2d0caaef5$export$838e2a576d4d6ff6 = (value)=>$7d3633f2d0caaef5$export$a75d1723e6bda2ec("headers", value);
const $7d3633f2d0caaef5$export$38e42c68cf43b5d4 = (name, value)=>$7d3633f2d0caaef5$export$838e2a576d4d6ff6({
        [name]: value
    });
const $7d3633f2d0caaef5$export$e39d76e25ce37988 = (wrapper)=>(f)=>(...params)=>{
            let rest;
            const promise = wrapper((...innerParams)=>{
                const { promise: promise, ...innerRest } = f(...innerParams);
                rest = innerRest;
                return promise;
            })(...params);
            return {
                promise: promise,
                ...rest
            };
        };
const $7d3633f2d0caaef5$export$9c77439751b4390b = (fetch)=>(url, opts = {})=>{
        const controller = opts.abortController || new AbortController();
        const promise = fetch(url, {
            signal: controller.signal,
            ...opts
        });
        return {
            controller: controller,
            promise: promise
        };
    };
const $7d3633f2d0caaef5$export$e9a8372937ef7f1 = (abortableFetch)=>(url, opts = {})=>{
        // offline db consistency requires ajax calls to fail reliably,
        // so we enforce a default timeout on ajax calls
        const { timeout: timeout = 60000, ...rest } = opts;
        const { controller: controller, promise: promise } = abortableFetch(url, rest);
        if (timeout !== 0) {
            const newPromise = promise.catch((error)=>{
                // Change error name in case of time out so that we can
                // distinguish it from explicit abort.
                if (error.name === "AbortError" && promise.timedOut) error = new (0, $506fdaa0545346a2$export$66d311bf29d5c89c)(`Request timed out after ${timeout / 1000} seconds`);
                throw error;
            });
            setTimeout(()=>{
                promise.timedOut = true;
                controller.abort();
            }, timeout);
            return {
                controller: controller,
                promise: newPromise
            };
        }
        return {
            controller: controller,
            promise: promise
        };
    };
const $7d3633f2d0caaef5$export$fe633c745f42b5cd = (fetch)=>(url, opts = {})=>{
        const { failOnHttpErrors: failOnHttpErrors = true, ...rest } = opts;
        const promise = fetch(url, rest);
        if (failOnHttpErrors) return promise.then($7d3633f2d0caaef5$export$3a2f576a374b4dda);
        return promise;
    };
const $7d3633f2d0caaef5$export$f4ba43f659d5549c = (fetch)=>(url, opts = {})=>{
        const { body: body, method: method, ...rest } = opts;
        let newUrl = url;
        let newOpts = opts;
        if (Object.keys(opts).includes("method") && Object.keys(opts).includes("body") && method.toUpperCase() === "GET" && body instanceof URLSearchParams) {
            const [main, ...fragments] = newUrl.split("#");
            const separator = main.includes("?") ? "&" : "?";
            // append the body to the query string
            newUrl = `${main}${separator}${body.toString()}#${fragments.join("#")}`;
            // remove the body since it has been moved to URL
            newOpts = {
                method: method,
                rest: rest
            };
        }
        return fetch(newUrl, newOpts);
    };
const $7d3633f2d0caaef5$export$e7aa7bc5c1b3cfb3 = (0, (/*@__PURE__*/$parcel$interopDefault($00ab3e86e584dd7b$exports)))(// Same as jQuery.ajax
$7d3633f2d0caaef5$export$a75d1723e6bda2ec("credentials", "same-origin"), $7d3633f2d0caaef5$export$38e42c68cf43b5d4("X-Requested-With", "XMLHttpRequest"), $7d3633f2d0caaef5$export$fe633c745f42b5cd, $7d3633f2d0caaef5$export$f4ba43f659d5549c, $7d3633f2d0caaef5$export$9c77439751b4390b, $7d3633f2d0caaef5$export$e9a8372937ef7f1)(window.fetch);
const $7d3633f2d0caaef5$export$3988ae62b71be9a3 = $7d3633f2d0caaef5$export$e39d76e25ce37988($7d3633f2d0caaef5$export$a75d1723e6bda2ec("method", "GET"))($7d3633f2d0caaef5$export$e7aa7bc5c1b3cfb3);
const $7d3633f2d0caaef5$export$299ba2dee77727e9 = $7d3633f2d0caaef5$export$e39d76e25ce37988($7d3633f2d0caaef5$export$a75d1723e6bda2ec("method", "POST"))($7d3633f2d0caaef5$export$e7aa7bc5c1b3cfb3);
const $7d3633f2d0caaef5$export$38dab5a9fea42f39 = $7d3633f2d0caaef5$export$e39d76e25ce37988($7d3633f2d0caaef5$export$a75d1723e6bda2ec("method", "DELETE"))($7d3633f2d0caaef5$export$e7aa7bc5c1b3cfb3);
const $7d3633f2d0caaef5$export$92871f7982deaf9f = (data)=>new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($f4177b5095a62a77$exports)))(data, {
        ignorenull: true
    }));


class $3b58afcf3e935267$export$1a748576aa07f99b extends Error {
    constructor(message){
        super(message);
        this.name = "PasswordHashingError";
    }
}
function $3b58afcf3e935267$export$1d2e6bc0307ffd89() {
    return $7d3633f2d0caaef5$export$3988ae62b71be9a3("api/about", {
        // we want fresh configuration each time
        cache: "no-store"
    }).promise.then((response)=>response.json());
}
function $3b58afcf3e935267$export$596d806903d1f59e(credentials) {
    return $7d3633f2d0caaef5$export$299ba2dee77727e9("login", {
        body: new URLSearchParams(credentials)
    }).promise.then((response)=>response.json()).then((data)=>{
        if (data.success) return Promise.resolve();
        else return Promise.reject(new (0, $506fdaa0545346a2$export$5e64a9683d127ef6)(data.error));
    });
}
function $3b58afcf3e935267$export$708be5cd94908894(password) {
    return $7d3633f2d0caaef5$export$299ba2dee77727e9("api/private/hash-password", {
        body: new URLSearchParams({
            password: password
        })
    }).promise.then((response)=>response.json()).then((data)=>{
        if (data.success) return Promise.resolve(data.hash);
        else return Promise.reject(new $3b58afcf3e935267$export$1a748576aa07f99b(data.error));
    });
}
function $3b58afcf3e935267$export$b3b4cde15a96b715(file) {
    const data = new FormData();
    data.append("opml", file);
    return $7d3633f2d0caaef5$export$299ba2dee77727e9("opml", {
        body: data,
        failOnHttpErrors: false
    }).promise.then($7d3633f2d0caaef5$export$8d90b058a02656d9((response)=>response.status === 200 || response.status === 202 || response.status === 400)).then((response)=>response.json().then((data)=>({
                response: response,
                data: data
            })));
}
function $3b58afcf3e935267$export$a0973bcfe11b05c9() {
    return $7d3633f2d0caaef5$export$38dab5a9fea42f39("api/session/current").promise;
}



function $c6a75ba9dc9fd47e$export$c36f611d5eb39a7() {
    return $7d3633f2d0caaef5$export$3988ae62b71be9a3("tags").promise.then((response)=>response.json());
}
function $c6a75ba9dc9fd47e$export$6f3c7c74c4b252bb(tag, color) {
    return $7d3633f2d0caaef5$export$299ba2dee77727e9("tags/color", {
        body: $7d3633f2d0caaef5$export$92871f7982deaf9f({
            tag: tag,
            color: color
        })
    }).promise;
}



class $648254c988c3de43$export$5521c47db270880f extends Event {
    constructor(value){
        super("change");
        this.value = value;
    }
}
class $648254c988c3de43$export$8fa6ce44b7b131e9 extends EventTarget {
    constructor(value){
        super();
        this.value = value;
    }
    update(value) {
        if (this.value !== value) {
            this.value = value;
            const event = new $648254c988c3de43$export$5521c47db270880f(value);
            this.dispatchEvent(event);
        }
    }
}



/**
 * Object describing what state a request is in.
 * @enum {string}
 */ const $c097b691ff08d4e3$export$62aa48085237e36f = {
    INITIAL: "initial",
    LOADING: "loading",
    SUCCESS: "success",
    FAILURE: "failure"
};


var $fcda9d1f1901e894$exports = {};
"use strict";

$fcda9d1f1901e894$exports = (parcelRequire("hHzFu"));



var $5NSbj = parcelRequire("5NSbj");
var $f95d863e1a691bb4$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f95d863e1a691bb4$var$ReactIs, $f95d863e1a691bb4$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$f95d863e1a691bb4$exports = (parcelRequire("g5hZU"))();


var $ea2d4a6a4b369f4b$exports = {};
function $ea2d4a6a4b369f4b$var$nullable(subRequirement) {
    const check = (required, props, key, ...rest)=>{
        if (props[key] === null) return null;
        const sub = required ? subRequirement.isRequired : subRequirement;
        return sub(props, key, ...rest);
    };
    const fn = check.bind(null, false);
    fn.isRequired = check.bind(null, true);
    return fn;
}
Object.defineProperty($ea2d4a6a4b369f4b$exports, "__esModule", {
    value: true
});
$ea2d4a6a4b369f4b$exports.default = $ea2d4a6a4b369f4b$var$nullable;
$ea2d4a6a4b369f4b$exports = Object.assign($ea2d4a6a4b369f4b$exports.default, $ea2d4a6a4b369f4b$exports);
$ea2d4a6a4b369f4b$exports.default.default = $ea2d4a6a4b369f4b$exports;


function $3467a1f7c53ba5c6$export$2e2bcd8739ae039(o, p) {
    $3467a1f7c53ba5c6$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3467a1f7c53ba5c6$export$2e2bcd8739ae039(o, p);
}


function $48e796ba58cc9652$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $3467a1f7c53ba5c6$export$2e2bcd8739ae039)(subClass, superClass);
}



var $5NSbj = parcelRequire("5NSbj");

function $b31eec711470155e$export$2e2bcd8739ae039() {
    $b31eec711470155e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b31eec711470155e$export$2e2bcd8739ae039.apply(this, arguments);
}


function $ede7406254f84206$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $ede7406254f84206$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $ede7406254f84206$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $ede7406254f84206$var$isAbsolute(to);
    var isFromAbs = from && $ede7406254f84206$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $ede7406254f84206$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $ede7406254f84206$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $ede7406254f84206$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $ede7406254f84206$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$ede7406254f84206$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $ede7406254f84206$export$2e2bcd8739ae039 = $ede7406254f84206$var$resolvePathname;


function $5b77a27f0f04b35c$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $5b77a27f0f04b35c$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $5b77a27f0f04b35c$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $5b77a27f0f04b35c$var$valueOf(a);
        var bValue = $5b77a27f0f04b35c$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $5b77a27f0f04b35c$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $5b77a27f0f04b35c$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $5b77a27f0f04b35c$export$2e2bcd8739ae039 = $5b77a27f0f04b35c$var$valueEqual;



var $a463912d05fdd635$var$isProduction = true;
var $a463912d05fdd635$var$prefix = "Invariant failed";
function $a463912d05fdd635$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($a463912d05fdd635$var$isProduction) throw new Error($a463912d05fdd635$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($a463912d05fdd635$var$prefix, ": ").concat(provided) : $a463912d05fdd635$var$prefix;
    throw new Error(value);
}


function $9fd79409a44ca9b3$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $9fd79409a44ca9b3$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $9fd79409a44ca9b3$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $9fd79409a44ca9b3$var$stripBasename(path, prefix) {
    return $9fd79409a44ca9b3$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $9fd79409a44ca9b3$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $9fd79409a44ca9b3$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $9fd79409a44ca9b3$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $9fd79409a44ca9b3$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $9fd79409a44ca9b3$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $ede7406254f84206$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $9fd79409a44ca9b3$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $5b77a27f0f04b35c$export$2e2bcd8739ae039)(a.state, b.state);
}
function $9fd79409a44ca9b3$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $9fd79409a44ca9b3$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $9fd79409a44ca9b3$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $9fd79409a44ca9b3$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $9fd79409a44ca9b3$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $9fd79409a44ca9b3$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $9fd79409a44ca9b3$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $9fd79409a44ca9b3$var$PopStateEvent = "popstate";
var $9fd79409a44ca9b3$var$HashChangeEvent = "hashchange";
function $9fd79409a44ca9b3$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $9fd79409a44ca9b3$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$9fd79409a44ca9b3$var$canUseDOM && (0, $a463912d05fdd635$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $9fd79409a44ca9b3$var$supportsHistory();
    var needsHashChangeListener = !$9fd79409a44ca9b3$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $9fd79409a44ca9b3$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $9fd79409a44ca9b3$var$stripTrailingSlash($9fd79409a44ca9b3$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $9fd79409a44ca9b3$var$stripBasename(path, basename);
        return $9fd79409a44ca9b3$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $9fd79409a44ca9b3$var$createTransitionManager();
    function setState(nextState) {
        (0, $b31eec711470155e$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($9fd79409a44ca9b3$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($9fd79409a44ca9b3$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($9fd79409a44ca9b3$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $9fd79409a44ca9b3$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $9fd79409a44ca9b3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $9fd79409a44ca9b3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($9fd79409a44ca9b3$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($9fd79409a44ca9b3$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($9fd79409a44ca9b3$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($9fd79409a44ca9b3$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $9fd79409a44ca9b3$var$HashChangeEvent$1 = "hashchange";
var $9fd79409a44ca9b3$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $9fd79409a44ca9b3$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $9fd79409a44ca9b3$var$stripLeadingSlash,
        decodePath: $9fd79409a44ca9b3$var$addLeadingSlash
    },
    slash: {
        encodePath: $9fd79409a44ca9b3$var$addLeadingSlash,
        decodePath: $9fd79409a44ca9b3$var$addLeadingSlash
    }
};
function $9fd79409a44ca9b3$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $9fd79409a44ca9b3$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $9fd79409a44ca9b3$var$pushHashPath(path) {
    window.location.hash = path;
}
function $9fd79409a44ca9b3$var$replaceHashPath(path) {
    window.location.replace($9fd79409a44ca9b3$var$stripHash(window.location.href) + "#" + path);
}
function $9fd79409a44ca9b3$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$9fd79409a44ca9b3$var$canUseDOM && (0, $a463912d05fdd635$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $9fd79409a44ca9b3$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $9fd79409a44ca9b3$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $9fd79409a44ca9b3$var$stripTrailingSlash($9fd79409a44ca9b3$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $9fd79409a44ca9b3$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($9fd79409a44ca9b3$var$getHashPath());
        if (basename) path = $9fd79409a44ca9b3$var$stripBasename(path, basename);
        return $9fd79409a44ca9b3$export$90c043f1c57770b8(path);
    }
    var transitionManager = $9fd79409a44ca9b3$var$createTransitionManager();
    function setState(nextState) {
        (0, $b31eec711470155e$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $9fd79409a44ca9b3$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $9fd79409a44ca9b3$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $9fd79409a44ca9b3$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($9fd79409a44ca9b3$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($9fd79409a44ca9b3$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $9fd79409a44ca9b3$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $9fd79409a44ca9b3$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $9fd79409a44ca9b3$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $9fd79409a44ca9b3$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $9fd79409a44ca9b3$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $9fd79409a44ca9b3$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $9fd79409a44ca9b3$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $9fd79409a44ca9b3$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $9fd79409a44ca9b3$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($9fd79409a44ca9b3$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $9fd79409a44ca9b3$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $9fd79409a44ca9b3$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $9fd79409a44ca9b3$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $9fd79409a44ca9b3$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($9fd79409a44ca9b3$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($9fd79409a44ca9b3$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($9fd79409a44ca9b3$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $9fd79409a44ca9b3$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $9fd79409a44ca9b3$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $9fd79409a44ca9b3$var$createTransitionManager();
    function setState(nextState) {
        (0, $b31eec711470155e$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $9fd79409a44ca9b3$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $9fd79409a44ca9b3$export$90c043f1c57770b8(entry, undefined, createKey()) : $9fd79409a44ca9b3$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $9fd79409a44ca9b3$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $9fd79409a44ca9b3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $9fd79409a44ca9b3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $9fd79409a44ca9b3$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $db5871a1f097cef4$exports = {};
var $6b30b1083ab29cfc$exports = {};
$6b30b1083ab29cfc$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $db5871a1f097cef4$exports = $db5871a1f097cef4$var$pathToRegexp;
$db5871a1f097cef4$exports.parse = $db5871a1f097cef4$var$parse;
$db5871a1f097cef4$exports.compile = $db5871a1f097cef4$var$compile;
$db5871a1f097cef4$exports.tokensToFunction = $db5871a1f097cef4$var$tokensToFunction;
$db5871a1f097cef4$exports.tokensToRegExp = $db5871a1f097cef4$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $db5871a1f097cef4$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $db5871a1f097cef4$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $db5871a1f097cef4$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $db5871a1f097cef4$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $db5871a1f097cef4$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $db5871a1f097cef4$var$compile(str, options) {
    return $db5871a1f097cef4$var$tokensToFunction($db5871a1f097cef4$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $db5871a1f097cef4$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $db5871a1f097cef4$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $db5871a1f097cef4$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $db5871a1f097cef4$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $db5871a1f097cef4$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($6b30b1083ab29cfc$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $db5871a1f097cef4$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $db5871a1f097cef4$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $db5871a1f097cef4$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $db5871a1f097cef4$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $db5871a1f097cef4$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $db5871a1f097cef4$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $db5871a1f097cef4$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $db5871a1f097cef4$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($db5871a1f097cef4$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $db5871a1f097cef4$var$flags(options));
    return $db5871a1f097cef4$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $db5871a1f097cef4$var$stringToRegexp(path, keys, options) {
    return $db5871a1f097cef4$var$tokensToRegExp($db5871a1f097cef4$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $db5871a1f097cef4$var$tokensToRegExp(tokens, keys, options) {
    if (!$6b30b1083ab29cfc$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $db5871a1f097cef4$var$escapeString(token);
        else {
            var prefix = $db5871a1f097cef4$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $db5871a1f097cef4$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $db5871a1f097cef4$var$attachKeys(new RegExp("^" + route, $db5871a1f097cef4$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $db5871a1f097cef4$var$pathToRegexp(path, keys, options) {
    if (!$6b30b1083ab29cfc$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $db5871a1f097cef4$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($6b30b1083ab29cfc$exports(path)) return $db5871a1f097cef4$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $db5871a1f097cef4$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $d83c66a7ec69d19c$exports = {};
"use strict";

$d83c66a7ec69d19c$exports = (parcelRequire("k8ZyL"));


function $9544dcb536634e1c$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $89e04f82e84d04a4$exports = {};
"use strict";

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $89e04f82e84d04a4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $89e04f82e84d04a4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $89e04f82e84d04a4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $89e04f82e84d04a4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $89e04f82e84d04a4$var$TYPE_STATICS = {};
$89e04f82e84d04a4$var$TYPE_STATICS[$d83c66a7ec69d19c$exports.ForwardRef] = $89e04f82e84d04a4$var$FORWARD_REF_STATICS;
$89e04f82e84d04a4$var$TYPE_STATICS[$d83c66a7ec69d19c$exports.Memo] = $89e04f82e84d04a4$var$MEMO_STATICS;
function $89e04f82e84d04a4$var$getStatics(component) {
    // React v16.11 and below
    if ($d83c66a7ec69d19c$exports.isMemo(component)) return $89e04f82e84d04a4$var$MEMO_STATICS;
     // React v16.12 and above
    return $89e04f82e84d04a4$var$TYPE_STATICS[component["$$typeof"]] || $89e04f82e84d04a4$var$REACT_STATICS;
}
var $89e04f82e84d04a4$var$defineProperty = Object.defineProperty;
var $89e04f82e84d04a4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $89e04f82e84d04a4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $89e04f82e84d04a4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $89e04f82e84d04a4$var$getPrototypeOf = Object.getPrototypeOf;
var $89e04f82e84d04a4$var$objectPrototype = Object.prototype;
function $89e04f82e84d04a4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($89e04f82e84d04a4$var$objectPrototype) {
            var inheritedComponent = $89e04f82e84d04a4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $89e04f82e84d04a4$var$objectPrototype) $89e04f82e84d04a4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $89e04f82e84d04a4$var$getOwnPropertyNames(sourceComponent);
        if ($89e04f82e84d04a4$var$getOwnPropertySymbols) keys = keys.concat($89e04f82e84d04a4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $89e04f82e84d04a4$var$getStatics(targetComponent);
        var sourceStatics = $89e04f82e84d04a4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$89e04f82e84d04a4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $89e04f82e84d04a4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $89e04f82e84d04a4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$89e04f82e84d04a4$exports = $89e04f82e84d04a4$var$hoistNonReactStatics;


var $88361e604f4abd56$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $88361e604f4abd56$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $88361e604f4abd56$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $88361e604f4abd56$var$commonjsGlobal[key] = ($88361e604f4abd56$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $88361e604f4abd56$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $88361e604f4abd56$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $88361e604f4abd56$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $88361e604f4abd56$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $88361e604f4abd56$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $48e796ba58cc9652$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $88361e604f4abd56$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($88361e604f4abd56$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $88361e604f4abd56$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $48e796ba58cc9652$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $88361e604f4abd56$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $88361e604f4abd56$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $88361e604f4abd56$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $88361e604f4abd56$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createContext || $88361e604f4abd56$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $88361e604f4abd56$var$createNamedContext = function createNamedContext(name) {
    var context = $88361e604f4abd56$var$createContext();
    context.displayName = name;
    return context;
};
var $88361e604f4abd56$export$c213558b66925821 = /*#__PURE__*/ $88361e604f4abd56$var$createNamedContext("Router-History");
var $88361e604f4abd56$export$63baa8ccbe60bb07 = /*#__PURE__*/ $88361e604f4abd56$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $88361e604f4abd56$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $48e796ba58cc9652$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $88361e604f4abd56$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $48e796ba58cc9652$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $9fd79409a44ca9b3$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component);
var $88361e604f4abd56$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $48e796ba58cc9652$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $88361e604f4abd56$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $a463912d05fdd635$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $88361e604f4abd56$var$messageType;
var $88361e604f4abd56$var$cache = {};
var $88361e604f4abd56$var$cacheLimit = 10000;
var $88361e604f4abd56$var$cacheCount = 0;
function $88361e604f4abd56$var$compilePath(path) {
    if ($88361e604f4abd56$var$cache[path]) return $88361e604f4abd56$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($db5871a1f097cef4$exports))).compile(path);
    if ($88361e604f4abd56$var$cacheCount < $88361e604f4abd56$var$cacheLimit) {
        $88361e604f4abd56$var$cache[path] = generator;
        $88361e604f4abd56$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $88361e604f4abd56$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $88361e604f4abd56$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $88361e604f4abd56$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $a463912d05fdd635$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $9fd79409a44ca9b3$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $88361e604f4abd56$export$82476f982757e71e(to, computedMatch.params) : (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, to, {
            pathname: $88361e604f4abd56$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $9fd79409a44ca9b3$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $9fd79409a44ca9b3$export$c3e8bb440bd55b18)(prevLocation, (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $88361e604f4abd56$var$cache$1 = {};
var $88361e604f4abd56$var$cacheLimit$1 = 10000;
var $88361e604f4abd56$var$cacheCount$1 = 0;
function $88361e604f4abd56$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $88361e604f4abd56$var$cache$1[cacheKey] || ($88361e604f4abd56$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($db5871a1f097cef4$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($88361e604f4abd56$var$cacheCount$1 < $88361e604f4abd56$var$cacheLimit$1) {
        pathCache[path] = result;
        $88361e604f4abd56$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $88361e604f4abd56$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $88361e604f4abd56$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $88361e604f4abd56$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Children.count(children) === 0;
}
function $88361e604f4abd56$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $88361e604f4abd56$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $48e796ba58cc9652$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $a463912d05fdd635$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $88361e604f4abd56$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $88361e604f4abd56$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component);
function $88361e604f4abd56$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $88361e604f4abd56$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, location, {
        pathname: $88361e604f4abd56$var$addLeadingSlash(basename) + location.pathname
    });
}
function $88361e604f4abd56$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $88361e604f4abd56$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $88361e604f4abd56$var$createURL(location) {
    return typeof location === "string" ? location : (0, $9fd79409a44ca9b3$export$fe53371bee54353d)(location);
}
function $88361e604f4abd56$var$staticHandler(methodName) {
    return function() {
        (0, $a463912d05fdd635$export$2e2bcd8739ae039)(false);
    };
}
function $88361e604f4abd56$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $88361e604f4abd56$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $48e796ba58cc9652$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $88361e604f4abd56$var$noop;
        };
        _this.handleBlock = function() {
            return $88361e604f4abd56$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $88361e604f4abd56$var$addBasename(basename, (0, $9fd79409a44ca9b3$export$90c043f1c57770b8)(location));
        context.url = $88361e604f4abd56$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $9544dcb536634e1c$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $88361e604f4abd56$var$addLeadingSlash(basename + $88361e604f4abd56$var$createURL(path));
            },
            action: "POP",
            location: $88361e604f4abd56$var$stripBasename(basename, (0, $9fd79409a44ca9b3$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $88361e604f4abd56$var$staticHandler("go"),
            goBack: $88361e604f4abd56$var$staticHandler("goBack"),
            goForward: $88361e604f4abd56$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$export$55185c17a0fcbe46, (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $88361e604f4abd56$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $48e796ba58cc9652$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $a463912d05fdd635$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $88361e604f4abd56$export$81336c211d5ff295(location.pathname, (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $88361e604f4abd56$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $9544dcb536634e1c$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($88361e604f4abd56$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $a463912d05fdd635$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement(Component, (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($89e04f82e84d04a4$exports)))(C, Component);
}
var $88361e604f4abd56$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).useContext;
function $88361e604f4abd56$export$3420e1dc2c4a518c() {
    return $88361e604f4abd56$var$useContext($88361e604f4abd56$export$c213558b66925821);
}
function $88361e604f4abd56$export$45d76561a5302f2b() {
    return $88361e604f4abd56$var$useContext($88361e604f4abd56$export$63baa8ccbe60bb07).location;
}
function $88361e604f4abd56$export$99eaa27ddbbb95ef() {
    var match = $88361e604f4abd56$var$useContext($88361e604f4abd56$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $88361e604f4abd56$export$632be4bb944c1bc7(path) {
    var location = $88361e604f4abd56$export$45d76561a5302f2b();
    var match = $88361e604f4abd56$var$useContext($88361e604f4abd56$export$63baa8ccbe60bb07).match;
    return path ? $88361e604f4abd56$export$81336c211d5ff295(location.pathname, path) : match;
}
var $88361e604f4abd56$var$global$1, $88361e604f4abd56$var$key, $88361e604f4abd56$var$buildNames, $88361e604f4abd56$var$initialBuildName, $88361e604f4abd56$var$secondaryBuildName;




var $5NSbj = parcelRequire("5NSbj");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $a751150471783e33$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $48e796ba58cc9652$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $9fd79409a44ca9b3$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement((0, $88361e604f4abd56$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $a751150471783e33$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $48e796ba58cc9652$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $9fd79409a44ca9b3$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement((0, $88361e604f4abd56$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component);
var $a751150471783e33$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $a751150471783e33$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $9fd79409a44ca9b3$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $a751150471783e33$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $a751150471783e33$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).forwardRef;
if (typeof $a751150471783e33$var$forwardRef === "undefined") $a751150471783e33$var$forwardRef = $a751150471783e33$var$forwardRefShim;
function $a751150471783e33$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $a751150471783e33$var$LinkAnchor = $a751150471783e33$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $9544dcb536634e1c$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$a751150471783e33$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($a751150471783e33$var$forwardRefShim !== $a751150471783e33$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $a751150471783e33$export$a6c7ac8248d6e38a = $a751150471783e33$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $a751150471783e33$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $9544dcb536634e1c$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement((0, $88361e604f4abd56$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $a463912d05fdd635$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $a751150471783e33$var$normalizeToLocation($a751150471783e33$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $a751150471783e33$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $9fd79409a44ca9b3$export$fe53371bee54353d)(context.location) === (0, $9fd79409a44ca9b3$export$fe53371bee54353d)($a751150471783e33$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($a751150471783e33$var$forwardRefShim !== $a751150471783e33$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement(component, props);
    });
});
var $a751150471783e33$var$toType, $a751150471783e33$var$refType;
var $a751150471783e33$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $a751150471783e33$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).forwardRef;
if (typeof $a751150471783e33$var$forwardRef$1 === "undefined") $a751150471783e33$var$forwardRef$1 = $a751150471783e33$var$forwardRefShim$1;
function $a751150471783e33$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $a751150471783e33$export$b0d92dbee9b5b60d = $a751150471783e33$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $9544dcb536634e1c$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement((0, $88361e604f4abd56$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $a463912d05fdd635$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $a751150471783e33$var$normalizeToLocation($a751150471783e33$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $88361e604f4abd56$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $a751150471783e33$var$joinClassnames(className, activeClassName);
            style = (0, $b31eec711470155e$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $b31eec711470155e$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($a751150471783e33$var$forwardRefShim$1 !== $a751150471783e33$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement($a751150471783e33$export$a6c7ac8248d6e38a, props);
    });
});
var $a751150471783e33$var$ariaCurrentType;


function $9bfddff2bd1f5fe3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9bfddff2bd1f5fe3$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9bfddff2bd1f5fe3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9bfddff2bd1f5fe3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9bfddff2bd1f5fe3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9bfddff2bd1f5fe3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9bfddff2bd1f5fe3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9bfddff2bd1f5fe3$var$_typeof(obj);
}
function $9bfddff2bd1f5fe3$var$_wrapRegExp() {
    $9bfddff2bd1f5fe3$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $9bfddff2bd1f5fe3$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $9bfddff2bd1f5fe3$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $9bfddff2bd1f5fe3$var$_wrapRegExp.apply(this, arguments);
}
function $9bfddff2bd1f5fe3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9bfddff2bd1f5fe3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9bfddff2bd1f5fe3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9bfddff2bd1f5fe3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9bfddff2bd1f5fe3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9bfddff2bd1f5fe3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9bfddff2bd1f5fe3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9bfddff2bd1f5fe3$var$_setPrototypeOf(subClass, superClass);
}
function $9bfddff2bd1f5fe3$var$_setPrototypeOf(o, p) {
    $9bfddff2bd1f5fe3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9bfddff2bd1f5fe3$var$_setPrototypeOf(o, p);
}
function $9bfddff2bd1f5fe3$var$_slicedToArray(arr, i) {
    return $9bfddff2bd1f5fe3$var$_arrayWithHoles(arr) || $9bfddff2bd1f5fe3$var$_iterableToArrayLimit(arr, i) || $9bfddff2bd1f5fe3$var$_unsupportedIterableToArray(arr, i) || $9bfddff2bd1f5fe3$var$_nonIterableRest();
}
function $9bfddff2bd1f5fe3$var$_toConsumableArray(arr) {
    return $9bfddff2bd1f5fe3$var$_arrayWithoutHoles(arr) || $9bfddff2bd1f5fe3$var$_iterableToArray(arr) || $9bfddff2bd1f5fe3$var$_unsupportedIterableToArray(arr) || $9bfddff2bd1f5fe3$var$_nonIterableSpread();
}
function $9bfddff2bd1f5fe3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9bfddff2bd1f5fe3$var$_arrayLikeToArray(arr);
}
function $9bfddff2bd1f5fe3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9bfddff2bd1f5fe3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9bfddff2bd1f5fe3$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9bfddff2bd1f5fe3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9bfddff2bd1f5fe3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9bfddff2bd1f5fe3$var$_arrayLikeToArray(o, minLen);
}
function $9bfddff2bd1f5fe3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9bfddff2bd1f5fe3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9bfddff2bd1f5fe3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $9bfddff2bd1f5fe3$var$noop = function noop() {};
var $9bfddff2bd1f5fe3$var$_WINDOW = {};
var $9bfddff2bd1f5fe3$var$_DOCUMENT = {};
var $9bfddff2bd1f5fe3$var$_MUTATION_OBSERVER = null;
var $9bfddff2bd1f5fe3$var$_PERFORMANCE = {
    mark: $9bfddff2bd1f5fe3$var$noop,
    measure: $9bfddff2bd1f5fe3$var$noop
};
try {
    if (typeof window !== "undefined") $9bfddff2bd1f5fe3$var$_WINDOW = window;
    if (typeof document !== "undefined") $9bfddff2bd1f5fe3$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $9bfddff2bd1f5fe3$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $9bfddff2bd1f5fe3$var$_PERFORMANCE = performance;
} catch (e) {}
var $9bfddff2bd1f5fe3$var$_ref = $9bfddff2bd1f5fe3$var$_WINDOW.navigator || {}, $9bfddff2bd1f5fe3$var$_ref$userAgent = $9bfddff2bd1f5fe3$var$_ref.userAgent, $9bfddff2bd1f5fe3$var$userAgent = $9bfddff2bd1f5fe3$var$_ref$userAgent === void 0 ? "" : $9bfddff2bd1f5fe3$var$_ref$userAgent;
var $9bfddff2bd1f5fe3$var$WINDOW = $9bfddff2bd1f5fe3$var$_WINDOW;
var $9bfddff2bd1f5fe3$var$DOCUMENT = $9bfddff2bd1f5fe3$var$_DOCUMENT;
var $9bfddff2bd1f5fe3$var$MUTATION_OBSERVER = $9bfddff2bd1f5fe3$var$_MUTATION_OBSERVER;
var $9bfddff2bd1f5fe3$var$PERFORMANCE = $9bfddff2bd1f5fe3$var$_PERFORMANCE;
var $9bfddff2bd1f5fe3$var$IS_BROWSER = !!$9bfddff2bd1f5fe3$var$WINDOW.document;
var $9bfddff2bd1f5fe3$var$IS_DOM = !!$9bfddff2bd1f5fe3$var$DOCUMENT.documentElement && !!$9bfddff2bd1f5fe3$var$DOCUMENT.head && typeof $9bfddff2bd1f5fe3$var$DOCUMENT.addEventListener === "function" && typeof $9bfddff2bd1f5fe3$var$DOCUMENT.createElement === "function";
var $9bfddff2bd1f5fe3$var$IS_IE = ~$9bfddff2bd1f5fe3$var$userAgent.indexOf("MSIE") || ~$9bfddff2bd1f5fe3$var$userAgent.indexOf("Trident/");
var $9bfddff2bd1f5fe3$var$_familyProxy, $9bfddff2bd1f5fe3$var$_familyProxy2, $9bfddff2bd1f5fe3$var$_familyProxy3, $9bfddff2bd1f5fe3$var$_familyProxy4, $9bfddff2bd1f5fe3$var$_familyProxy5;
var $9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var $9bfddff2bd1f5fe3$var$UNITS_IN_GRID = 16;
var $9bfddff2bd1f5fe3$var$DEFAULT_CSS_PREFIX = "fa";
var $9bfddff2bd1f5fe3$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var $9bfddff2bd1f5fe3$var$DATA_FA_I2SVG = "data-fa-i2svg";
var $9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var $9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var $9bfddff2bd1f5fe3$var$DATA_PREFIX = "data-prefix";
var $9bfddff2bd1f5fe3$var$DATA_ICON = "data-icon";
var $9bfddff2bd1f5fe3$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var $9bfddff2bd1f5fe3$var$MUTATION_APPROACH_ASYNC = "async";
var $9bfddff2bd1f5fe3$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var $9bfddff2bd1f5fe3$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC = "classic";
var $9bfddff2bd1f5fe3$var$FAMILY_SHARP = "sharp";
var $9bfddff2bd1f5fe3$var$FAMILIES = [
    $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC,
    $9bfddff2bd1f5fe3$var$FAMILY_SHARP
];
function $9bfddff2bd1f5fe3$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$9bfddff2bd1f5fe3$var$FAMILY_CLASSIC];
        }
    });
}
var $9bfddff2bd1f5fe3$var$PREFIX_TO_STYLE = $9bfddff2bd1f5fe3$var$familyProxy(($9bfddff2bd1f5fe3$var$_familyProxy = {}, $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_familyProxy, $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC, {
    "fa": "solid",
    "fas": "solid",
    "fa-solid": "solid",
    "far": "regular",
    "fa-regular": "regular",
    "fal": "light",
    "fa-light": "light",
    "fat": "thin",
    "fa-thin": "thin",
    "fad": "duotone",
    "fa-duotone": "duotone",
    "fab": "brands",
    "fa-brands": "brands",
    "fak": "kit",
    "fakd": "kit",
    "fa-kit": "kit",
    "fa-kit-duotone": "kit"
}), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_familyProxy, $9bfddff2bd1f5fe3$var$FAMILY_SHARP, {
    "fa": "solid",
    "fass": "solid",
    "fa-solid": "solid",
    "fasr": "regular",
    "fa-regular": "regular",
    "fasl": "light",
    "fa-light": "light",
    "fast": "thin",
    "fa-thin": "thin"
}), $9bfddff2bd1f5fe3$var$_familyProxy));
var $9bfddff2bd1f5fe3$var$STYLE_TO_PREFIX = $9bfddff2bd1f5fe3$var$familyProxy(($9bfddff2bd1f5fe3$var$_familyProxy2 = {}, $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_familyProxy2, $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC, {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab",
    kit: "fak"
}), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_familyProxy2, $9bfddff2bd1f5fe3$var$FAMILY_SHARP, {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
}), $9bfddff2bd1f5fe3$var$_familyProxy2));
var $9bfddff2bd1f5fe3$var$PREFIX_TO_LONG_STYLE = $9bfddff2bd1f5fe3$var$familyProxy(($9bfddff2bd1f5fe3$var$_familyProxy3 = {}, $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_familyProxy3, $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC, {
    fab: "fa-brands",
    fad: "fa-duotone",
    fak: "fa-kit",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
}), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_familyProxy3, $9bfddff2bd1f5fe3$var$FAMILY_SHARP, {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
}), $9bfddff2bd1f5fe3$var$_familyProxy3));
var $9bfddff2bd1f5fe3$var$LONG_STYLE_TO_PREFIX = $9bfddff2bd1f5fe3$var$familyProxy(($9bfddff2bd1f5fe3$var$_familyProxy4 = {}, $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_familyProxy4, $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC, {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
}), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_familyProxy4, $9bfddff2bd1f5fe3$var$FAMILY_SHARP, {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
}), $9bfddff2bd1f5fe3$var$_familyProxy4));
var $9bfddff2bd1f5fe3$var$ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/; // eslint-disable-line no-useless-escape
var $9bfddff2bd1f5fe3$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var $9bfddff2bd1f5fe3$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var $9bfddff2bd1f5fe3$var$FONT_WEIGHT_TO_PREFIX = $9bfddff2bd1f5fe3$var$familyProxy(($9bfddff2bd1f5fe3$var$_familyProxy5 = {}, $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_familyProxy5, $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC, {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
}), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_familyProxy5, $9bfddff2bd1f5fe3$var$FAMILY_SHARP, {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
}), $9bfddff2bd1f5fe3$var$_familyProxy5));
var $9bfddff2bd1f5fe3$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $9bfddff2bd1f5fe3$var$oneToTwenty = $9bfddff2bd1f5fe3$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $9bfddff2bd1f5fe3$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var $9bfddff2bd1f5fe3$var$DUOTONE_CLASSES = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var $9bfddff2bd1f5fe3$var$prefixes = new Set();
Object.keys($9bfddff2bd1f5fe3$var$STYLE_TO_PREFIX[$9bfddff2bd1f5fe3$var$FAMILY_CLASSIC]).map($9bfddff2bd1f5fe3$var$prefixes.add.bind($9bfddff2bd1f5fe3$var$prefixes));
Object.keys($9bfddff2bd1f5fe3$var$STYLE_TO_PREFIX[$9bfddff2bd1f5fe3$var$FAMILY_SHARP]).map($9bfddff2bd1f5fe3$var$prefixes.add.bind($9bfddff2bd1f5fe3$var$prefixes));
var $9bfddff2bd1f5fe3$var$RESERVED_CLASSES = [].concat($9bfddff2bd1f5fe3$var$FAMILIES, $9bfddff2bd1f5fe3$var$_toConsumableArray($9bfddff2bd1f5fe3$var$prefixes), [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $9bfddff2bd1f5fe3$var$DUOTONE_CLASSES.GROUP,
    $9bfddff2bd1f5fe3$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $9bfddff2bd1f5fe3$var$DUOTONE_CLASSES.PRIMARY,
    $9bfddff2bd1f5fe3$var$DUOTONE_CLASSES.SECONDARY
]).concat($9bfddff2bd1f5fe3$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($9bfddff2bd1f5fe3$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $9bfddff2bd1f5fe3$var$initial = $9bfddff2bd1f5fe3$var$WINDOW.FontAwesomeConfig || {};
function $9bfddff2bd1f5fe3$var$getAttrConfig(attr) {
    var element = $9bfddff2bd1f5fe3$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $9bfddff2bd1f5fe3$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($9bfddff2bd1f5fe3$var$DOCUMENT && typeof $9bfddff2bd1f5fe3$var$DOCUMENT.querySelector === "function") {
    var $9bfddff2bd1f5fe3$var$attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    $9bfddff2bd1f5fe3$var$attrs.forEach(function(_ref) {
        var _ref2 = $9bfddff2bd1f5fe3$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $9bfddff2bd1f5fe3$var$coerce($9bfddff2bd1f5fe3$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $9bfddff2bd1f5fe3$var$initial[key] = val;
    });
}
var $9bfddff2bd1f5fe3$var$_default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: $9bfddff2bd1f5fe3$var$DEFAULT_CSS_PREFIX,
    replacementClass: $9bfddff2bd1f5fe3$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($9bfddff2bd1f5fe3$var$initial.familyPrefix) $9bfddff2bd1f5fe3$var$initial.cssPrefix = $9bfddff2bd1f5fe3$var$initial.familyPrefix;
var $9bfddff2bd1f5fe3$var$_config = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$_default), $9bfddff2bd1f5fe3$var$initial);
if (!$9bfddff2bd1f5fe3$var$_config.autoReplaceSvg) $9bfddff2bd1f5fe3$var$_config.observeMutations = false;
var $9bfddff2bd1f5fe3$var$config = {};
Object.keys($9bfddff2bd1f5fe3$var$_default).forEach(function(key) {
    Object.defineProperty($9bfddff2bd1f5fe3$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $9bfddff2bd1f5fe3$var$_config[key] = val;
            $9bfddff2bd1f5fe3$var$_onChangeCb.forEach(function(cb) {
                return cb($9bfddff2bd1f5fe3$var$config);
            });
        },
        get: function get() {
            return $9bfddff2bd1f5fe3$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($9bfddff2bd1f5fe3$var$config, "familyPrefix", {
    enumerable: true,
    set: function set(val) {
        $9bfddff2bd1f5fe3$var$_config.cssPrefix = val;
        $9bfddff2bd1f5fe3$var$_onChangeCb.forEach(function(cb) {
            return cb($9bfddff2bd1f5fe3$var$config);
        });
    },
    get: function get() {
        return $9bfddff2bd1f5fe3$var$_config.cssPrefix;
    }
});
$9bfddff2bd1f5fe3$var$WINDOW.FontAwesomeConfig = $9bfddff2bd1f5fe3$var$config;
var $9bfddff2bd1f5fe3$var$_onChangeCb = [];
function $9bfddff2bd1f5fe3$var$onChange(cb) {
    $9bfddff2bd1f5fe3$var$_onChangeCb.push(cb);
    return function() {
        $9bfddff2bd1f5fe3$var$_onChangeCb.splice($9bfddff2bd1f5fe3$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $9bfddff2bd1f5fe3$var$d = $9bfddff2bd1f5fe3$var$UNITS_IN_GRID;
var $9bfddff2bd1f5fe3$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $9bfddff2bd1f5fe3$var$insertCss(css) {
    if (!css || !$9bfddff2bd1f5fe3$var$IS_DOM) return;
    var style = $9bfddff2bd1f5fe3$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = $9bfddff2bd1f5fe3$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $9bfddff2bd1f5fe3$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $9bfddff2bd1f5fe3$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $9bfddff2bd1f5fe3$var$nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += $9bfddff2bd1f5fe3$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $9bfddff2bd1f5fe3$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $9bfddff2bd1f5fe3$var$classArray(node) {
    if (node.classList) return $9bfddff2bd1f5fe3$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function $9bfddff2bd1f5fe3$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $9bfddff2bd1f5fe3$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat($9bfddff2bd1f5fe3$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $9bfddff2bd1f5fe3$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, "");
}
function $9bfddff2bd1f5fe3$var$transformIsMeaningful(transform) {
    return transform.size !== $9bfddff2bd1f5fe3$var$meaninglessTransform.size || transform.x !== $9bfddff2bd1f5fe3$var$meaninglessTransform.x || transform.y !== $9bfddff2bd1f5fe3$var$meaninglessTransform.y || transform.rotate !== $9bfddff2bd1f5fe3$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $9bfddff2bd1f5fe3$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $9bfddff2bd1f5fe3$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $9bfddff2bd1f5fe3$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $9bfddff2bd1f5fe3$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && $9bfddff2bd1f5fe3$var$IS_IE) val += "translate(".concat(transform.x / $9bfddff2bd1f5fe3$var$d - width / 2, "em, ").concat(transform.y / $9bfddff2bd1f5fe3$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $9bfddff2bd1f5fe3$var$d, "em), calc(-50% + ").concat(transform.y / $9bfddff2bd1f5fe3$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $9bfddff2bd1f5fe3$var$d, "em, ").concat(transform.y / $9bfddff2bd1f5fe3$var$d, "em) ");
    val += "scale(".concat(transform.size / $9bfddff2bd1f5fe3$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $9bfddff2bd1f5fe3$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $9bfddff2bd1f5fe3$var$baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, 0));\n          transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function $9bfddff2bd1f5fe3$var$css() {
    var dcp = $9bfddff2bd1f5fe3$var$DEFAULT_CSS_PREFIX;
    var drc = $9bfddff2bd1f5fe3$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $9bfddff2bd1f5fe3$var$config.cssPrefix;
    var rc = $9bfddff2bd1f5fe3$var$config.replacementClass;
    var s = $9bfddff2bd1f5fe3$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $9bfddff2bd1f5fe3$var$_cssInserted = false;
function $9bfddff2bd1f5fe3$var$ensureCss() {
    if ($9bfddff2bd1f5fe3$var$config.autoAddCss && !$9bfddff2bd1f5fe3$var$_cssInserted) {
        $9bfddff2bd1f5fe3$var$insertCss($9bfddff2bd1f5fe3$var$css());
        $9bfddff2bd1f5fe3$var$_cssInserted = true;
    }
}
var $9bfddff2bd1f5fe3$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $9bfddff2bd1f5fe3$var$css,
                insertCss: $9bfddff2bd1f5fe3$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $9bfddff2bd1f5fe3$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $9bfddff2bd1f5fe3$var$ensureCss();
            }
        };
    }
};
var $9bfddff2bd1f5fe3$var$w = $9bfddff2bd1f5fe3$var$WINDOW || {};
if (!$9bfddff2bd1f5fe3$var$w[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER]) $9bfddff2bd1f5fe3$var$w[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER] = {};
if (!$9bfddff2bd1f5fe3$var$w[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].styles) $9bfddff2bd1f5fe3$var$w[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$9bfddff2bd1f5fe3$var$w[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].hooks) $9bfddff2bd1f5fe3$var$w[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$9bfddff2bd1f5fe3$var$w[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].shims) $9bfddff2bd1f5fe3$var$w[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].shims = [];
var $9bfddff2bd1f5fe3$var$namespace = $9bfddff2bd1f5fe3$var$w[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER];
var $9bfddff2bd1f5fe3$var$functions = [];
var $9bfddff2bd1f5fe3$var$listener = function listener() {
    $9bfddff2bd1f5fe3$var$DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    $9bfddff2bd1f5fe3$var$loaded = 1;
    $9bfddff2bd1f5fe3$var$functions.map(function(fn) {
        return fn();
    });
};
var $9bfddff2bd1f5fe3$var$loaded = false;
if ($9bfddff2bd1f5fe3$var$IS_DOM) {
    $9bfddff2bd1f5fe3$var$loaded = ($9bfddff2bd1f5fe3$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($9bfddff2bd1f5fe3$var$DOCUMENT.readyState);
    if (!$9bfddff2bd1f5fe3$var$loaded) $9bfddff2bd1f5fe3$var$DOCUMENT.addEventListener("DOMContentLoaded", $9bfddff2bd1f5fe3$var$listener);
}
function $9bfddff2bd1f5fe3$var$domready(fn) {
    if (!$9bfddff2bd1f5fe3$var$IS_DOM) return;
    $9bfddff2bd1f5fe3$var$loaded ? setTimeout(fn, 0) : $9bfddff2bd1f5fe3$var$functions.push(fn);
}
function $9bfddff2bd1f5fe3$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return $9bfddff2bd1f5fe3$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($9bfddff2bd1f5fe3$var$joinAttributes(attributes), ">").concat(children.map($9bfddff2bd1f5fe3$var$toHtml).join(""), "</").concat(tag, ">");
}
function $9bfddff2bd1f5fe3$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $9bfddff2bd1f5fe3$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $9bfddff2bd1f5fe3$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $9bfddff2bd1f5fe3$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $9bfddff2bd1f5fe3$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $9bfddff2bd1f5fe3$var$toHex(unicode) {
    var decoded = $9bfddff2bd1f5fe3$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $9bfddff2bd1f5fe3$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $9bfddff2bd1f5fe3$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $9bfddff2bd1f5fe3$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $9bfddff2bd1f5fe3$var$normalizeIcons(icons);
    if (typeof $9bfddff2bd1f5fe3$var$namespace.hooks.addPack === "function" && !skipHooks) $9bfddff2bd1f5fe3$var$namespace.hooks.addPack(prefix, $9bfddff2bd1f5fe3$var$normalizeIcons(icons));
    else $9bfddff2bd1f5fe3$var$namespace.styles[prefix] = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $9bfddff2bd1f5fe3$var$defineIcons("fa", icons);
}
var $9bfddff2bd1f5fe3$var$duotonePathRe = [
    /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $9bfddff2bd1f5fe3$var$_LONG_STYLE, $9bfddff2bd1f5fe3$var$_PREFIXES, $9bfddff2bd1f5fe3$var$_PREFIXES_FOR_FAMILY;
var $9bfddff2bd1f5fe3$var$styles = $9bfddff2bd1f5fe3$var$namespace.styles, $9bfddff2bd1f5fe3$var$shims = $9bfddff2bd1f5fe3$var$namespace.shims;
var $9bfddff2bd1f5fe3$var$LONG_STYLE = ($9bfddff2bd1f5fe3$var$_LONG_STYLE = {}, $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_LONG_STYLE, $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC, Object.values($9bfddff2bd1f5fe3$var$PREFIX_TO_LONG_STYLE[$9bfddff2bd1f5fe3$var$FAMILY_CLASSIC])), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_LONG_STYLE, $9bfddff2bd1f5fe3$var$FAMILY_SHARP, Object.values($9bfddff2bd1f5fe3$var$PREFIX_TO_LONG_STYLE[$9bfddff2bd1f5fe3$var$FAMILY_SHARP])), $9bfddff2bd1f5fe3$var$_LONG_STYLE);
var $9bfddff2bd1f5fe3$var$_defaultUsablePrefix = null;
var $9bfddff2bd1f5fe3$var$_byUnicode = {};
var $9bfddff2bd1f5fe3$var$_byLigature = {};
var $9bfddff2bd1f5fe3$var$_byOldName = {};
var $9bfddff2bd1f5fe3$var$_byOldUnicode = {};
var $9bfddff2bd1f5fe3$var$_byAlias = {};
var $9bfddff2bd1f5fe3$var$PREFIXES = ($9bfddff2bd1f5fe3$var$_PREFIXES = {}, $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_PREFIXES, $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC, Object.keys($9bfddff2bd1f5fe3$var$PREFIX_TO_STYLE[$9bfddff2bd1f5fe3$var$FAMILY_CLASSIC])), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_PREFIXES, $9bfddff2bd1f5fe3$var$FAMILY_SHARP, Object.keys($9bfddff2bd1f5fe3$var$PREFIX_TO_STYLE[$9bfddff2bd1f5fe3$var$FAMILY_SHARP])), $9bfddff2bd1f5fe3$var$_PREFIXES);
function $9bfddff2bd1f5fe3$var$isReserved(name) {
    return ~$9bfddff2bd1f5fe3$var$RESERVED_CLASSES.indexOf(name);
}
function $9bfddff2bd1f5fe3$var$getIconName(cssPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !$9bfddff2bd1f5fe3$var$isReserved(iconName)) return iconName;
    else return null;
}
var $9bfddff2bd1f5fe3$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $9bfddff2bd1f5fe3$var$reduce($9bfddff2bd1f5fe3$var$styles, function(o, style, prefix) {
            o[prefix] = $9bfddff2bd1f5fe3$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $9bfddff2bd1f5fe3$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "number";
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $9bfddff2bd1f5fe3$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "string";
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $9bfddff2bd1f5fe3$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = "far" in $9bfddff2bd1f5fe3$var$styles || $9bfddff2bd1f5fe3$var$config.autoFetchSvg;
    var shimLookups = $9bfddff2bd1f5fe3$var$reduce($9bfddff2bd1f5fe3$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        if (typeof maybeNameMaybeUnicode === "string") acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === "number") acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $9bfddff2bd1f5fe3$var$_byOldName = shimLookups.names;
    $9bfddff2bd1f5fe3$var$_byOldUnicode = shimLookups.unicodes;
    $9bfddff2bd1f5fe3$var$_defaultUsablePrefix = $9bfddff2bd1f5fe3$var$getCanonicalPrefix($9bfddff2bd1f5fe3$var$config.styleDefault, {
        family: $9bfddff2bd1f5fe3$var$config.familyDefault
    });
};
$9bfddff2bd1f5fe3$var$onChange(function(c) {
    $9bfddff2bd1f5fe3$var$_defaultUsablePrefix = $9bfddff2bd1f5fe3$var$getCanonicalPrefix(c.styleDefault, {
        family: $9bfddff2bd1f5fe3$var$config.familyDefault
    });
});
$9bfddff2bd1f5fe3$var$build();
function $9bfddff2bd1f5fe3$var$byUnicode(prefix, unicode) {
    return ($9bfddff2bd1f5fe3$var$_byUnicode[prefix] || {})[unicode];
}
function $9bfddff2bd1f5fe3$var$byLigature(prefix, ligature) {
    return ($9bfddff2bd1f5fe3$var$_byLigature[prefix] || {})[ligature];
}
function $9bfddff2bd1f5fe3$var$byAlias(prefix, alias) {
    return ($9bfddff2bd1f5fe3$var$_byAlias[prefix] || {})[alias];
}
function $9bfddff2bd1f5fe3$var$byOldName(name) {
    return $9bfddff2bd1f5fe3$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $9bfddff2bd1f5fe3$var$byOldUnicode(unicode) {
    var oldUnicode = $9bfddff2bd1f5fe3$var$_byOldUnicode[unicode];
    var newUnicode = $9bfddff2bd1f5fe3$var$byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix() {
    return $9bfddff2bd1f5fe3$var$_defaultUsablePrefix;
}
var $9bfddff2bd1f5fe3$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $9bfddff2bd1f5fe3$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC : _params$family;
    var style = $9bfddff2bd1f5fe3$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = $9bfddff2bd1f5fe3$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $9bfddff2bd1f5fe3$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $9bfddff2bd1f5fe3$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var $9bfddff2bd1f5fe3$var$PREFIXES_FOR_FAMILY = ($9bfddff2bd1f5fe3$var$_PREFIXES_FOR_FAMILY = {}, $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_PREFIXES_FOR_FAMILY, $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC, Object.keys($9bfddff2bd1f5fe3$var$PREFIX_TO_LONG_STYLE[$9bfddff2bd1f5fe3$var$FAMILY_CLASSIC])), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_PREFIXES_FOR_FAMILY, $9bfddff2bd1f5fe3$var$FAMILY_SHARP, Object.keys($9bfddff2bd1f5fe3$var$PREFIX_TO_LONG_STYLE[$9bfddff2bd1f5fe3$var$FAMILY_SHARP])), $9bfddff2bd1f5fe3$var$_PREFIXES_FOR_FAMILY);
function $9bfddff2bd1f5fe3$var$getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, $9bfddff2bd1f5fe3$var$_defineProperty(_famProps, $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC, "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat($9bfddff2bd1f5fe3$var$FAMILY_CLASSIC)), $9bfddff2bd1f5fe3$var$_defineProperty(_famProps, $9bfddff2bd1f5fe3$var$FAMILY_SHARP, "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat($9bfddff2bd1f5fe3$var$FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$9bfddff2bd1f5fe3$var$FAMILY_CLASSIC]) || values.some(function(v) {
        return $9bfddff2bd1f5fe3$var$PREFIXES_FOR_FAMILY[$9bfddff2bd1f5fe3$var$FAMILY_CLASSIC].includes(v);
    })) family = $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$9bfddff2bd1f5fe3$var$FAMILY_SHARP]) || values.some(function(v) {
        return $9bfddff2bd1f5fe3$var$PREFIXES_FOR_FAMILY[$9bfddff2bd1f5fe3$var$FAMILY_SHARP].includes(v);
    })) family = $9bfddff2bd1f5fe3$var$FAMILY_SHARP;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $9bfddff2bd1f5fe3$var$getIconName($9bfddff2bd1f5fe3$var$config.cssPrefix, cls);
        if ($9bfddff2bd1f5fe3$var$styles[cls]) {
            cls = $9bfddff2bd1f5fe3$var$LONG_STYLE[family].includes(cls) ? $9bfddff2bd1f5fe3$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($9bfddff2bd1f5fe3$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $9bfddff2bd1f5fe3$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $9bfddff2bd1f5fe3$var$config.replacementClass && cls !== famProps[$9bfddff2bd1f5fe3$var$FAMILY_CLASSIC] && cls !== famProps[$9bfddff2bd1f5fe3$var$FAMILY_SHARP]) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === "fa" ? $9bfddff2bd1f5fe3$var$byOldName(acc.iconName) : {};
            var aliasIconName = $9bfddff2bd1f5fe3$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !$9bfddff2bd1f5fe3$var$styles["far"] && $9bfddff2bd1f5fe3$var$styles["fas"] && !$9bfddff2bd1f5fe3$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = "fas";
        }
        return acc;
    }, $9bfddff2bd1f5fe3$var$emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) canonical.prefix = "fab";
    if (values.includes("fa-duotone") || values.includes("fad")) canonical.prefix = "fad";
    if (!canonical.prefix && family === $9bfddff2bd1f5fe3$var$FAMILY_SHARP && ($9bfddff2bd1f5fe3$var$styles["fass"] || $9bfddff2bd1f5fe3$var$config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = $9bfddff2bd1f5fe3$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix() || "fas";
    return canonical;
}
var $9bfddff2bd1f5fe3$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $9bfddff2bd1f5fe3$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $9bfddff2bd1f5fe3$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $9bfddff2bd1f5fe3$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
                    var longPrefix = $9bfddff2bd1f5fe3$var$PREFIX_TO_LONG_STYLE[$9bfddff2bd1f5fe3$var$FAMILY_CLASSIC][key];
                    if (longPrefix) $9bfddff2bd1f5fe3$var$defineIcons(longPrefix, additions[key]);
                    $9bfddff2bd1f5fe3$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === "string") additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $9bfddff2bd1f5fe3$var$_plugins = [];
var $9bfddff2bd1f5fe3$var$_hooks = {};
var $9bfddff2bd1f5fe3$var$providers = {};
var $9bfddff2bd1f5fe3$var$defaultProviderKeys = Object.keys($9bfddff2bd1f5fe3$var$providers);
function $9bfddff2bd1f5fe3$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $9bfddff2bd1f5fe3$var$_plugins = nextPlugins;
    $9bfddff2bd1f5fe3$var$_hooks = {};
    Object.keys($9bfddff2bd1f5fe3$var$providers).forEach(function(k) {
        if ($9bfddff2bd1f5fe3$var$defaultProviderKeys.indexOf(k) === -1) delete $9bfddff2bd1f5fe3$var$providers[k];
    });
    $9bfddff2bd1f5fe3$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === "function") obj[tk] = mixout[tk];
            if ($9bfddff2bd1f5fe3$var$_typeof(mixout[tk]) === "object") Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$9bfddff2bd1f5fe3$var$_hooks[hook]) $9bfddff2bd1f5fe3$var$_hooks[hook] = [];
                $9bfddff2bd1f5fe3$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($9bfddff2bd1f5fe3$var$providers);
    });
    return obj;
}
function $9bfddff2bd1f5fe3$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $9bfddff2bd1f5fe3$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $9bfddff2bd1f5fe3$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $9bfddff2bd1f5fe3$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $9bfddff2bd1f5fe3$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $9bfddff2bd1f5fe3$var$providers[hook] ? $9bfddff2bd1f5fe3$var$providers[hook].apply(null, args) : undefined;
}
function $9bfddff2bd1f5fe3$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") iconLookup.prefix = "fas";
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $9bfddff2bd1f5fe3$var$byAlias(prefix, iconName) || iconName;
    return $9bfddff2bd1f5fe3$var$iconFromMapping($9bfddff2bd1f5fe3$var$library.definitions, prefix, iconName) || $9bfddff2bd1f5fe3$var$iconFromMapping($9bfddff2bd1f5fe3$var$namespace.styles, prefix, iconName);
}
var $9bfddff2bd1f5fe3$var$library = new $9bfddff2bd1f5fe3$var$Library();
var $9bfddff2bd1f5fe3$var$noAuto = function noAuto() {
    $9bfddff2bd1f5fe3$var$config.autoReplaceSvg = false;
    $9bfddff2bd1f5fe3$var$config.observeMutations = false;
    $9bfddff2bd1f5fe3$var$callHooks("noAuto");
};
var $9bfddff2bd1f5fe3$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($9bfddff2bd1f5fe3$var$IS_DOM) {
            $9bfddff2bd1f5fe3$var$callHooks("beforeI2svg", params);
            $9bfddff2bd1f5fe3$var$callProvided("pseudoElements2svg", params);
            return $9bfddff2bd1f5fe3$var$callProvided("i2svg", params);
        } else return Promise.reject("Operation requires a DOM of some kind.");
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($9bfddff2bd1f5fe3$var$config.autoReplaceSvg === false) $9bfddff2bd1f5fe3$var$config.autoReplaceSvg = true;
        $9bfddff2bd1f5fe3$var$config.observeMutations = true;
        $9bfddff2bd1f5fe3$var$domready(function() {
            $9bfddff2bd1f5fe3$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $9bfddff2bd1f5fe3$var$callHooks("watch", params);
        });
    }
};
var $9bfddff2bd1f5fe3$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($9bfddff2bd1f5fe3$var$_typeof(_icon) === "object" && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $9bfddff2bd1f5fe3$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $9bfddff2bd1f5fe3$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $9bfddff2bd1f5fe3$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === "string" && (_icon.indexOf("".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-")) > -1 || _icon.match($9bfddff2bd1f5fe3$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $9bfddff2bd1f5fe3$var$getCanonicalIcon(_icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix(),
                iconName: $9bfddff2bd1f5fe3$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === "string") {
            var _prefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $9bfddff2bd1f5fe3$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $9bfddff2bd1f5fe3$export$644d8ea042df96a6 = {
    noAuto: $9bfddff2bd1f5fe3$var$noAuto,
    config: $9bfddff2bd1f5fe3$var$config,
    dom: $9bfddff2bd1f5fe3$var$dom,
    parse: $9bfddff2bd1f5fe3$var$parse,
    library: $9bfddff2bd1f5fe3$var$library,
    findIconDefinition: $9bfddff2bd1f5fe3$var$findIconDefinition,
    toHtml: $9bfddff2bd1f5fe3$var$toHtml
};
var $9bfddff2bd1f5fe3$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $9bfddff2bd1f5fe3$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($9bfddff2bd1f5fe3$var$namespace.styles).length > 0 || $9bfddff2bd1f5fe3$var$config.autoFetchSvg) && $9bfddff2bd1f5fe3$var$IS_DOM && $9bfddff2bd1f5fe3$var$config.autoReplaceSvg) $9bfddff2bd1f5fe3$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $9bfddff2bd1f5fe3$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return $9bfddff2bd1f5fe3$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!$9bfddff2bd1f5fe3$var$IS_DOM) return;
            var container = $9bfddff2bd1f5fe3$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $9bfddff2bd1f5fe3$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($9bfddff2bd1f5fe3$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $9bfddff2bd1f5fe3$var$joinStyles($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, styles), {}, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $9bfddff2bd1f5fe3$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $9bfddff2bd1f5fe3$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === "fak";
    var attrClass = [
        $9bfddff2bd1f5fe3$var$config.replacementClass,
        iconName ? "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat(iconName) : ""
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, extra.attributes), {}, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$9bfddff2bd1f5fe3$var$DATA_FA_I2SVG] = "";
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $9bfddff2bd1f5fe3$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $9bfddff2bd1f5fe3$var$callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : $9bfddff2bd1f5fe3$var$callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $9bfddff2bd1f5fe3$var$asSymbol(args);
    else return $9bfddff2bd1f5fe3$var$asIcon(args);
}
function $9bfddff2bd1f5fe3$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[$9bfddff2bd1f5fe3$var$DATA_FA_I2SVG] = "";
    var styles = $9bfddff2bd1f5fe3$var$_objectSpread2({}, extra.styles);
    if ($9bfddff2bd1f5fe3$var$transformIsMeaningful(transform)) {
        styles["transform"] = $9bfddff2bd1f5fe3$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = $9bfddff2bd1f5fe3$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $9bfddff2bd1f5fe3$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = $9bfddff2bd1f5fe3$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var $9bfddff2bd1f5fe3$var$styles$1 = $9bfddff2bd1f5fe3$var$namespace.styles;
function $9bfddff2bd1f5fe3$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $9bfddff2bd1f5fe3$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat($9bfddff2bd1f5fe3$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat($9bfddff2bd1f5fe3$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat($9bfddff2bd1f5fe3$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $9bfddff2bd1f5fe3$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $9bfddff2bd1f5fe3$var$maybeNotifyMissing(iconName, prefix) {
    if (!$9bfddff2bd1f5fe3$var$PRODUCTION && !$9bfddff2bd1f5fe3$var$config.showMissingIcons && iconName) console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
}
function $9bfddff2bd1f5fe3$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === "fa" && $9bfddff2bd1f5fe3$var$config.styleDefault !== null) prefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $9bfddff2bd1f5fe3$var$callProvided("missingIconAbstract") || {}
        };
        if (givenPrefix === "fa") {
            var shim = $9bfddff2bd1f5fe3$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $9bfddff2bd1f5fe3$var$styles$1[prefix] && $9bfddff2bd1f5fe3$var$styles$1[prefix][iconName]) {
            var icon = $9bfddff2bd1f5fe3$var$styles$1[prefix][iconName];
            return resolve($9bfddff2bd1f5fe3$var$asFoundIcon(icon));
        }
        $9bfddff2bd1f5fe3$var$maybeNotifyMissing(iconName, prefix);
        resolve($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$missingIconResolutionMixin), {}, {
            icon: $9bfddff2bd1f5fe3$var$config.showMissingIcons && iconName ? $9bfddff2bd1f5fe3$var$callProvided("missingIconAbstract") || {} : {}
        }));
    });
}
var $9bfddff2bd1f5fe3$var$noop$1 = function noop() {};
var $9bfddff2bd1f5fe3$var$p = $9bfddff2bd1f5fe3$var$config.measurePerformance && $9bfddff2bd1f5fe3$var$PERFORMANCE && $9bfddff2bd1f5fe3$var$PERFORMANCE.mark && $9bfddff2bd1f5fe3$var$PERFORMANCE.measure ? $9bfddff2bd1f5fe3$var$PERFORMANCE : {
    mark: $9bfddff2bd1f5fe3$var$noop$1,
    measure: $9bfddff2bd1f5fe3$var$noop$1
};
var $9bfddff2bd1f5fe3$var$preamble = 'FA "6.5.2"';
var $9bfddff2bd1f5fe3$var$begin = function begin(name) {
    $9bfddff2bd1f5fe3$var$p.mark("".concat($9bfddff2bd1f5fe3$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $9bfddff2bd1f5fe3$var$end(name);
    };
};
var $9bfddff2bd1f5fe3$var$end = function end(name) {
    $9bfddff2bd1f5fe3$var$p.mark("".concat($9bfddff2bd1f5fe3$var$preamble, " ").concat(name, " ends"));
    $9bfddff2bd1f5fe3$var$p.measure("".concat($9bfddff2bd1f5fe3$var$preamble, " ").concat(name), "".concat($9bfddff2bd1f5fe3$var$preamble, " ").concat(name, " begins"), "".concat($9bfddff2bd1f5fe3$var$preamble, " ").concat(name, " ends"));
};
var $9bfddff2bd1f5fe3$var$perf = {
    begin: $9bfddff2bd1f5fe3$var$begin,
    end: $9bfddff2bd1f5fe3$var$end
};
var $9bfddff2bd1f5fe3$var$noop$2 = function noop() {};
function $9bfddff2bd1f5fe3$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($9bfddff2bd1f5fe3$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $9bfddff2bd1f5fe3$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($9bfddff2bd1f5fe3$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($9bfddff2bd1f5fe3$var$DATA_ICON) : null;
    return prefix && icon;
}
function $9bfddff2bd1f5fe3$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($9bfddff2bd1f5fe3$var$config.replacementClass);
}
function $9bfddff2bd1f5fe3$var$getMutator() {
    if ($9bfddff2bd1f5fe3$var$config.autoReplaceSvg === true) return $9bfddff2bd1f5fe3$var$mutators.replace;
    var mutator = $9bfddff2bd1f5fe3$var$mutators[$9bfddff2bd1f5fe3$var$config.autoReplaceSvg];
    return mutator || $9bfddff2bd1f5fe3$var$mutators.replace;
}
function $9bfddff2bd1f5fe3$var$createElementNS(tag) {
    return $9bfddff2bd1f5fe3$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function $9bfddff2bd1f5fe3$var$createElement(tag) {
    return $9bfddff2bd1f5fe3$var$DOCUMENT.createElement(tag);
}
function $9bfddff2bd1f5fe3$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? $9bfddff2bd1f5fe3$var$createElementNS : $9bfddff2bd1f5fe3$var$createElement : _params$ceFn;
    if (typeof abstractObj === "string") return $9bfddff2bd1f5fe3$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($9bfddff2bd1f5fe3$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $9bfddff2bd1f5fe3$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $9bfddff2bd1f5fe3$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(_abstract) {
                node.parentNode.insertBefore($9bfddff2bd1f5fe3$var$convertSVG(_abstract), node);
            });
            if (node.getAttribute($9bfddff2bd1f5fe3$var$DATA_FA_I2SVG) === null && $9bfddff2bd1f5fe3$var$config.keepOriginalSource) {
                var comment = $9bfddff2bd1f5fe3$var$DOCUMENT.createComment($9bfddff2bd1f5fe3$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$9bfddff2bd1f5fe3$var$classArray(node).indexOf($9bfddff2bd1f5fe3$var$config.replacementClass)) return $9bfddff2bd1f5fe3$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-.*"));
        delete _abstract2[0].attributes.id;
        if (_abstract2[0].attributes.class) {
            var splitClasses = _abstract2[0].attributes.class.split(" ").reduce(function(acc, cls) {
                if (cls === $9bfddff2bd1f5fe3$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            _abstract2[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) node.removeAttribute("class");
            else node.setAttribute("class", splitClasses.toNode.join(" "));
        }
        var newInnerHTML = _abstract2.map(function(a) {
            return $9bfddff2bd1f5fe3$var$toHtml(a);
        }).join("\n");
        node.setAttribute($9bfddff2bd1f5fe3$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $9bfddff2bd1f5fe3$var$performOperationSync(op) {
    op();
}
function $9bfddff2bd1f5fe3$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : $9bfddff2bd1f5fe3$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $9bfddff2bd1f5fe3$var$performOperationSync;
        if ($9bfddff2bd1f5fe3$var$config.mutateApproach === $9bfddff2bd1f5fe3$var$MUTATION_APPROACH_ASYNC) frame = $9bfddff2bd1f5fe3$var$WINDOW.requestAnimationFrame || $9bfddff2bd1f5fe3$var$performOperationSync;
        frame(function() {
            var mutator = $9bfddff2bd1f5fe3$var$getMutator();
            var mark = $9bfddff2bd1f5fe3$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $9bfddff2bd1f5fe3$var$disabled = false;
function $9bfddff2bd1f5fe3$var$disableObservation() {
    $9bfddff2bd1f5fe3$var$disabled = true;
}
function $9bfddff2bd1f5fe3$var$enableObservation() {
    $9bfddff2bd1f5fe3$var$disabled = false;
}
var $9bfddff2bd1f5fe3$var$mo = null;
function $9bfddff2bd1f5fe3$var$observe(options) {
    if (!$9bfddff2bd1f5fe3$var$MUTATION_OBSERVER) return;
    if (!$9bfddff2bd1f5fe3$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $9bfddff2bd1f5fe3$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $9bfddff2bd1f5fe3$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $9bfddff2bd1f5fe3$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $9bfddff2bd1f5fe3$var$DOCUMENT : _options$observeMutat;
    $9bfddff2bd1f5fe3$var$mo = new $9bfddff2bd1f5fe3$var$MUTATION_OBSERVER(function(objects) {
        if ($9bfddff2bd1f5fe3$var$disabled) return;
        var defaultPrefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
        $9bfddff2bd1f5fe3$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$9bfddff2bd1f5fe3$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($9bfddff2bd1f5fe3$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $9bfddff2bd1f5fe3$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $9bfddff2bd1f5fe3$var$isWatched(mutationRecord.target) && ~$9bfddff2bd1f5fe3$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && $9bfddff2bd1f5fe3$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $9bfddff2bd1f5fe3$var$getCanonicalIcon($9bfddff2bd1f5fe3$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($9bfddff2bd1f5fe3$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($9bfddff2bd1f5fe3$var$DATA_ICON, iconName);
                } else if ($9bfddff2bd1f5fe3$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$9bfddff2bd1f5fe3$var$IS_DOM) return;
    $9bfddff2bd1f5fe3$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $9bfddff2bd1f5fe3$var$disconnect() {
    if (!$9bfddff2bd1f5fe3$var$mo) return;
    $9bfddff2bd1f5fe3$var$mo.disconnect();
}
function $9bfddff2bd1f5fe3$var$styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $9bfddff2bd1f5fe3$var$classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = $9bfddff2bd1f5fe3$var$getCanonicalIcon($9bfddff2bd1f5fe3$var$classArray(node));
    if (!val.prefix) val.prefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $9bfddff2bd1f5fe3$var$byLigature(val.prefix, node.innerText) || $9bfddff2bd1f5fe3$var$byUnicode(val.prefix, $9bfddff2bd1f5fe3$var$toHex(node.innerText));
    if (!val.iconName && $9bfddff2bd1f5fe3$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $9bfddff2bd1f5fe3$var$attributesParser(node) {
    var extraAttributes = $9bfddff2bd1f5fe3$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if ($9bfddff2bd1f5fe3$var$config.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($9bfddff2bd1f5fe3$var$config.replacementClass, "-title-").concat(titleId || $9bfddff2bd1f5fe3$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $9bfddff2bd1f5fe3$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $9bfddff2bd1f5fe3$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $9bfddff2bd1f5fe3$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $9bfddff2bd1f5fe3$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $9bfddff2bd1f5fe3$var$attributesParser(node);
    var pluginMeta = $9bfddff2bd1f5fe3$var$chainHooks("parseNodeAttributes", {}, node);
    var extraStyles = parser.styleParser ? $9bfddff2bd1f5fe3$var$styleParser(node) : [];
    return $9bfddff2bd1f5fe3$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: $9bfddff2bd1f5fe3$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $9bfddff2bd1f5fe3$var$styles$2 = $9bfddff2bd1f5fe3$var$namespace.styles;
function $9bfddff2bd1f5fe3$var$generateMutation(node) {
    var nodeMeta = $9bfddff2bd1f5fe3$var$config.autoReplaceSvg === "nest" ? $9bfddff2bd1f5fe3$var$parseMeta(node, {
        styleParser: false
    }) : $9bfddff2bd1f5fe3$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($9bfddff2bd1f5fe3$var$LAYERS_TEXT_CLASSNAME)) return $9bfddff2bd1f5fe3$var$callProvided("generateLayersText", node, nodeMeta);
    else return $9bfddff2bd1f5fe3$var$callProvided("generateSvgReplacementMutation", node, nodeMeta);
}
var $9bfddff2bd1f5fe3$var$knownPrefixes = new Set();
$9bfddff2bd1f5fe3$var$FAMILIES.map(function(family) {
    $9bfddff2bd1f5fe3$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($9bfddff2bd1f5fe3$var$PREFIX_TO_STYLE[$9bfddff2bd1f5fe3$var$FAMILY_CLASSIC]).map($9bfddff2bd1f5fe3$var$knownPrefixes.add.bind($9bfddff2bd1f5fe3$var$knownPrefixes));
Object.keys($9bfddff2bd1f5fe3$var$PREFIX_TO_STYLE[$9bfddff2bd1f5fe3$var$FAMILY_SHARP]).map($9bfddff2bd1f5fe3$var$knownPrefixes.add.bind($9bfddff2bd1f5fe3$var$knownPrefixes));
$9bfddff2bd1f5fe3$var$knownPrefixes = $9bfddff2bd1f5fe3$var$_toConsumableArray($9bfddff2bd1f5fe3$var$knownPrefixes);
function $9bfddff2bd1f5fe3$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$9bfddff2bd1f5fe3$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $9bfddff2bd1f5fe3$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($9bfddff2bd1f5fe3$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($9bfddff2bd1f5fe3$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $9bfddff2bd1f5fe3$var$config.autoFetchSvg ? $9bfddff2bd1f5fe3$var$knownPrefixes : $9bfddff2bd1f5fe3$var$FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys($9bfddff2bd1f5fe3$var$styles$2));
    if (!prefixes.includes("fa")) prefixes.push("fa");
    var prefixesDomQuery = [
        ".".concat($9bfddff2bd1f5fe3$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($9bfddff2bd1f5fe3$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($9bfddff2bd1f5fe3$var$DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $9bfddff2bd1f5fe3$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return Promise.resolve();
    var mark = $9bfddff2bd1f5fe3$var$perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $9bfddff2bd1f5fe3$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$9bfddff2bd1f5fe3$var$PRODUCTION) {
                if (e.name === "MissingIcon") console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $9bfddff2bd1f5fe3$var$perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $9bfddff2bd1f5fe3$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $9bfddff2bd1f5fe3$var$generateMutation(node).then(function(mutation) {
        if (mutation) $9bfddff2bd1f5fe3$var$perform([
            mutation
        ], callback);
    });
}
function $9bfddff2bd1f5fe3$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $9bfddff2bd1f5fe3$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $9bfddff2bd1f5fe3$var$findIconDefinition(mask || {});
        return next(iconDefinition, $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $9bfddff2bd1f5fe3$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $9bfddff2bd1f5fe3$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $9bfddff2bd1f5fe3$var$domVariants($9bfddff2bd1f5fe3$var$_objectSpread2({
        type: "icon"
    }, iconDefinition), function() {
        $9bfddff2bd1f5fe3$var$callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($9bfddff2bd1f5fe3$var$config.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($9bfddff2bd1f5fe3$var$config.replacementClass, "-title-").concat(titleId || $9bfddff2bd1f5fe3$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $9bfddff2bd1f5fe3$var$makeInlineSvgAbstract({
            icons: {
                main: $9bfddff2bd1f5fe3$var$asFoundIcon(icon),
                mask: mask ? $9bfddff2bd1f5fe3$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $9bfddff2bd1f5fe3$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $9bfddff2bd1f5fe3$var$resolveIcons($9bfddff2bd1f5fe3$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $9bfddff2bd1f5fe3$var$onTree;
                accumulator.nodeCallback = $9bfddff2bd1f5fe3$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $9bfddff2bd1f5fe3$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return $9bfddff2bd1f5fe3$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $9bfddff2bd1f5fe3$var$findIcon(iconName, prefix),
                    mask.iconName ? $9bfddff2bd1f5fe3$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $9bfddff2bd1f5fe3$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $9bfddff2bd1f5fe3$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $9bfddff2bd1f5fe3$var$joinStyles(styles);
            if (styleString.length > 0) attributes["style"] = styleString;
            var nextChild;
            if ($9bfddff2bd1f5fe3$var$transformIsMeaningful(transform)) nextChild = $9bfddff2bd1f5fe3$var$callProvided("generateAbstractTransformGrouping", {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $9bfddff2bd1f5fe3$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $9bfddff2bd1f5fe3$var$domVariants({
                    type: "layer"
                }, function() {
                    $9bfddff2bd1f5fe3$var$callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-layers")
                                ].concat($9bfddff2bd1f5fe3$var$_toConsumableArray(classes)).join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $9bfddff2bd1f5fe3$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $9bfddff2bd1f5fe3$var$domVariants({
                    type: "counter",
                    content: content
                }, function() {
                    $9bfddff2bd1f5fe3$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $9bfddff2bd1f5fe3$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-layers-counter")
                            ].concat($9bfddff2bd1f5fe3$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $9bfddff2bd1f5fe3$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $9bfddff2bd1f5fe3$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $9bfddff2bd1f5fe3$var$domVariants({
                    type: "text",
                    content: content
                }, function() {
                    $9bfddff2bd1f5fe3$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $9bfddff2bd1f5fe3$var$makeLayersTextAbstract({
                        content: content,
                        transform: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-layers-text")
                            ].concat($9bfddff2bd1f5fe3$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($9bfddff2bd1f5fe3$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($9bfddff2bd1f5fe3$var$config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
            return Promise.resolve([
                node,
                $9bfddff2bd1f5fe3$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $9bfddff2bd1f5fe3$var$CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var $9bfddff2bd1f5fe3$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $9bfddff2bd1f5fe3$var$hexValueFromContent(content) {
    var cleaned = content.replace($9bfddff2bd1f5fe3$var$CLEAN_CONTENT_PATTERN, "");
    var codePoint = $9bfddff2bd1f5fe3$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $9bfddff2bd1f5fe3$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $9bfddff2bd1f5fe3$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $9bfddff2bd1f5fe3$var$toHex(cleaned[0]) : $9bfddff2bd1f5fe3$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $9bfddff2bd1f5fe3$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $9bfddff2bd1f5fe3$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $9bfddff2bd1f5fe3$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match($9bfddff2bd1f5fe3$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles.getPropertyValue("content");
            var family = ~[
                "Sharp"
            ].indexOf(fontFamily[2]) ? $9bfddff2bd1f5fe3$var$FAMILY_SHARP : $9bfddff2bd1f5fe3$var$FAMILY_CLASSIC;
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Thin",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? $9bfddff2bd1f5fe3$var$STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : $9bfddff2bd1f5fe3$var$FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = $9bfddff2bd1f5fe3$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith("FontAwesome");
            var iconName = $9bfddff2bd1f5fe3$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $9bfddff2bd1f5fe3$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($9bfddff2bd1f5fe3$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($9bfddff2bd1f5fe3$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $9bfddff2bd1f5fe3$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $9bfddff2bd1f5fe3$var$findIcon(iconName, prefix).then(function(main) {
                    var _abstract = $9bfddff2bd1f5fe3$var$makeInlineSvgAbstract($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $9bfddff2bd1f5fe3$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $9bfddff2bd1f5fe3$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
                    if (position === "::before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = _abstract.map(function(a) {
                        return $9bfddff2bd1f5fe3$var$toHtml(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $9bfddff2bd1f5fe3$var$replace(node) {
    return Promise.all([
        $9bfddff2bd1f5fe3$var$replaceForPosition(node, "::before"),
        $9bfddff2bd1f5fe3$var$replaceForPosition(node, "::after")
    ]);
}
function $9bfddff2bd1f5fe3$var$processable(node) {
    return node.parentNode !== document.head && !~$9bfddff2bd1f5fe3$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $9bfddff2bd1f5fe3$var$searchPseudoElements(root) {
    if (!$9bfddff2bd1f5fe3$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $9bfddff2bd1f5fe3$var$toArray(root.querySelectorAll("*")).filter($9bfddff2bd1f5fe3$var$processable).map($9bfddff2bd1f5fe3$var$replace);
        var end = $9bfddff2bd1f5fe3$var$perf.begin("searchPseudoElements");
        $9bfddff2bd1f5fe3$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $9bfddff2bd1f5fe3$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $9bfddff2bd1f5fe3$var$enableObservation();
            reject();
        });
    });
}
var $9bfddff2bd1f5fe3$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $9bfddff2bd1f5fe3$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $9bfddff2bd1f5fe3$var$DOCUMENT : _params$node;
            if ($9bfddff2bd1f5fe3$var$config.searchPseudoElements) $9bfddff2bd1f5fe3$var$searchPseudoElements(node);
        };
    }
};
var $9bfddff2bd1f5fe3$var$_unwatched = false;
var $9bfddff2bd1f5fe3$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $9bfddff2bd1f5fe3$var$disableObservation();
                    $9bfddff2bd1f5fe3$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $9bfddff2bd1f5fe3$var$observe($9bfddff2bd1f5fe3$var$chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto: function noAuto() {
                $9bfddff2bd1f5fe3$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($9bfddff2bd1f5fe3$var$_unwatched) $9bfddff2bd1f5fe3$var$enableObservation();
                else $9bfddff2bd1f5fe3$var$observe($9bfddff2bd1f5fe3$var$chainHooks("mutationObserverCallbacks", {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $9bfddff2bd1f5fe3$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $9bfddff2bd1f5fe3$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $9bfddff2bd1f5fe3$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute("data-fa-transform");
                if (transformString) accumulator.transform = $9bfddff2bd1f5fe3$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: "g",
                        attributes: $9bfddff2bd1f5fe3$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $9bfddff2bd1f5fe3$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $9bfddff2bd1f5fe3$var$fillBlack(_abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (_abstract.attributes && (_abstract.attributes.fill || force)) _abstract.attributes.fill = "black";
    return _abstract;
}
function $9bfddff2bd1f5fe3$var$deGroup(_abstract2) {
    if (_abstract2.tag === "g") return _abstract2.children;
    else return [
        _abstract2
    ];
}
var $9bfddff2bd1f5fe3$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute("data-fa-mask");
                var mask = !maskData ? $9bfddff2bd1f5fe3$var$emptyCanonicalIcon() : $9bfddff2bd1f5fe3$var$getCanonicalIcon(maskData.split(" ").map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $9bfddff2bd1f5fe3$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: "rect",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$ALL_SPACE), {}, {
                    fill: "white"
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($9bfddff2bd1f5fe3$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: "g",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2({}, trans.inner),
                children: [
                    $9bfddff2bd1f5fe3$var$fillBlack($9bfddff2bd1f5fe3$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: "g",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $9bfddff2bd1f5fe3$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $9bfddff2bd1f5fe3$var$nextUniqueId());
            var maskTag = {
                tag: "mask",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: $9bfddff2bd1f5fe3$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $9bfddff2bd1f5fe3$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $9bfddff2bd1f5fe3$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($9bfddff2bd1f5fe3$var$WINDOW.matchMedia) reduceMotion = $9bfddff2bd1f5fe3$var$WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: "currentColor"
            };
            var ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            }; // Ring
            gChildren.push({
                tag: "path",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, FILL), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            var OPACITY_ANIMATE = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: "opacity"
            });
            var dot = {
                tag: "circle",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, FILL), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: "animate",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            }, {
                tag: "animate",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: "1;0;1;1;0;1;"
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, FILL), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: "path",
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, FILL), {}, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }),
                children: [
                    {
                        tag: "animate",
                        attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "0;0;1;1;0;0;"
                        })
                    }
                ]
            });
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var $9bfddff2bd1f5fe3$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute("data-fa-symbol");
                var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var $9bfddff2bd1f5fe3$var$plugins = [
    $9bfddff2bd1f5fe3$var$InjectCSS,
    $9bfddff2bd1f5fe3$var$ReplaceElements,
    $9bfddff2bd1f5fe3$var$Layers,
    $9bfddff2bd1f5fe3$var$LayersCounter,
    $9bfddff2bd1f5fe3$var$LayersText,
    $9bfddff2bd1f5fe3$var$PseudoElements,
    $9bfddff2bd1f5fe3$var$MutationObserver$1,
    $9bfddff2bd1f5fe3$var$PowerTransforms,
    $9bfddff2bd1f5fe3$var$Masks,
    $9bfddff2bd1f5fe3$var$MissingIconIndicator,
    $9bfddff2bd1f5fe3$var$SvgSymbols
];
$9bfddff2bd1f5fe3$var$registerPlugins($9bfddff2bd1f5fe3$var$plugins, {
    mixoutsTo: $9bfddff2bd1f5fe3$export$644d8ea042df96a6
});
var $9bfddff2bd1f5fe3$export$4f8e844b2782642c = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.noAuto;
var $9bfddff2bd1f5fe3$export$e506a1d27d1eaa20 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.config;
var $9bfddff2bd1f5fe3$export$b839f963c7dc0e34 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.library;
var $9bfddff2bd1f5fe3$export$df3a06d6289f983e = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.dom;
var $9bfddff2bd1f5fe3$export$98e6a39c04603d36 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.parse;
var $9bfddff2bd1f5fe3$export$221fed4a47f597a5 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.findIconDefinition;
var $9bfddff2bd1f5fe3$export$a10125c086a4df16 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.toHtml;
var $9bfddff2bd1f5fe3$export$1ca1ec8b29a4ce27 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.icon;
var $9bfddff2bd1f5fe3$export$50a222d9023da98b = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.layer;
var $9bfddff2bd1f5fe3$export$6f093cfa640b7166 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.text;
var $9bfddff2bd1f5fe3$export$e575061ef2a070eb = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.counter;




var $5NSbj = parcelRequire("5NSbj");
function $ed572b0153b27b45$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ed572b0153b27b45$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ed572b0153b27b45$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ed572b0153b27b45$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ed572b0153b27b45$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ed572b0153b27b45$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ed572b0153b27b45$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ed572b0153b27b45$var$_typeof(obj);
}
function $ed572b0153b27b45$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ed572b0153b27b45$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ed572b0153b27b45$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ed572b0153b27b45$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ed572b0153b27b45$var$_toConsumableArray(arr) {
    return $ed572b0153b27b45$var$_arrayWithoutHoles(arr) || $ed572b0153b27b45$var$_iterableToArray(arr) || $ed572b0153b27b45$var$_unsupportedIterableToArray(arr) || $ed572b0153b27b45$var$_nonIterableSpread();
}
function $ed572b0153b27b45$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ed572b0153b27b45$var$_arrayLikeToArray(arr);
}
function $ed572b0153b27b45$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ed572b0153b27b45$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ed572b0153b27b45$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ed572b0153b27b45$var$_arrayLikeToArray(o, minLen);
}
function $ed572b0153b27b45$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ed572b0153b27b45$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $ed572b0153b27b45$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, $ed572b0153b27b45$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), $ed572b0153b27b45$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), $ed572b0153b27b45$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), $ed572b0153b27b45$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $ed572b0153b27b45$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $ed572b0153b27b45$var$camelize(string) {
    if ($ed572b0153b27b45$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $ed572b0153b27b45$var$_excluded = [
    "style"
];
function $ed572b0153b27b45$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $ed572b0153b27b45$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = $ed572b0153b27b45$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[$ed572b0153b27b45$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $ed572b0153b27b45$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return $ed572b0153b27b45$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = $ed572b0153b27b45$var$styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$ed572b0153b27b45$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $ed572b0153b27b45$var$_objectWithoutProperties(extraProps, $ed572b0153b27b45$var$_excluded);
    mixins.attrs["style"] = $ed572b0153b27b45$var$_objectSpread2($ed572b0153b27b45$var$_objectSpread2({}, mixins.attrs["style"]), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $ed572b0153b27b45$var$_objectSpread2($ed572b0153b27b45$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($ed572b0153b27b45$var$_toConsumableArray(children)));
}
var $ed572b0153b27b45$var$PRODUCTION = false;
try {
    $ed572b0153b27b45$var$PRODUCTION = true;
} catch (e) {}
function $ed572b0153b27b45$var$log() {
    if (!$ed572b0153b27b45$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $ed572b0153b27b45$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $ed572b0153b27b45$var$_typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $9bfddff2bd1f5fe3$export$98e6a39c04603d36).icon) return (0, $9bfddff2bd1f5fe3$export$98e6a39c04603d36).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $ed572b0153b27b45$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $ed572b0153b27b45$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $ed572b0153b27b45$var$_defineProperty({}, key, value) : {};
}
var $ed572b0153b27b45$export$2b9260d4a45c8710 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).forwardRef(function(props, ref) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $ed572b0153b27b45$var$normalizeIconArgs(iconArgs);
    var classes = $ed572b0153b27b45$var$objectWithKey("classes", [].concat($ed572b0153b27b45$var$_toConsumableArray($ed572b0153b27b45$var$classList(props)), $ed572b0153b27b45$var$_toConsumableArray(className.split(" "))));
    var transform = $ed572b0153b27b45$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $9bfddff2bd1f5fe3$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $ed572b0153b27b45$var$objectWithKey("mask", $ed572b0153b27b45$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $9bfddff2bd1f5fe3$export$1ca1ec8b29a4ce27)(iconLookup, $ed572b0153b27b45$var$_objectSpread2($ed572b0153b27b45$var$_objectSpread2($ed572b0153b27b45$var$_objectSpread2($ed572b0153b27b45$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $ed572b0153b27b45$var$log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$ed572b0153b27b45$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $ed572b0153b27b45$var$convertCurry(abstract[0], extraProps);
});
$ed572b0153b27b45$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
$ed572b0153b27b45$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool
};
$ed572b0153b27b45$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $ed572b0153b27b45$var$convertCurry = $ed572b0153b27b45$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement);




var $5NSbj = parcelRequire("5NSbj");
const $5c9ab921368ace58$var$w = "collapsed", $5c9ab921368ace58$var$p = "collapsing", $5c9ab921368ace58$var$r = "expanding", $5c9ab921368ace58$var$a = "expanded", $5c9ab921368ace58$var$K = "collapse-css-transition", $5c9ab921368ace58$var$M = "div", $5c9ab921368ace58$var$Q = "0px";
function $5c9ab921368ace58$var$N(o) {
    requestAnimationFrame(function() {
        requestAnimationFrame(o);
    });
}
const $5c9ab921368ace58$export$78768a9af065a7b = ({ children: o, transition: T, style: A, render: d, elementType: y = $5c9ab921368ace58$var$M, isOpen: n, collapseHeight: s = $5c9ab921368ace58$var$Q, onInit: L, onChange: P, className: v = $5c9ab921368ace58$var$K, addState: R, noAnim: h, overflowOnExpanded: S, ...F })=>{
    const m = ()=>s === "0px" ? "hidden" : void 0, [W, u] = (0, $5NSbj.useReducer)((t)=>t + 1, 0), i = (0, $5NSbj.useRef)(), [b, l] = (0, $5NSbj.useState)(0), e = (0, $5NSbj.useRef)({
        collapse: n ? $5c9ab921368ace58$var$a : $5c9ab921368ace58$var$w,
        style: {
            height: n ? void 0 : s,
            visibility: n ? void 0 : m()
        }
    }).current;
    (0, $5NSbj.useEffect)(()=>{
        b && g(P);
    }, [
        b
    ]);
    const g = (t, f = {})=>{
        t && t({
            state: e.collapse,
            style: e.style,
            ...f
        });
    };
    function C() {
        i.current && (e.collapse = $5c9ab921368ace58$var$w, e.style = {
            height: s,
            visibility: m()
        }, u(), setTimeout(()=>l(Date.now), 0));
    }
    function $() {
        if (i.current) {
            if (h) return C();
            e.collapse = $5c9ab921368ace58$var$p, e.style = {
                height: x(),
                visibility: void 0
            }, u(), $5c9ab921368ace58$var$N(()=>{
                i.current && e.collapse === $5c9ab921368ace58$var$p && (e.style = {
                    height: s,
                    visibility: void 0
                }, l(Date.now));
            });
        }
    }
    function q() {
        if (i.current) {
            if (h) return E();
            e.collapse = $5c9ab921368ace58$var$r, $5c9ab921368ace58$var$N(()=>{
                i.current && e.collapse === $5c9ab921368ace58$var$r && (e.style = {
                    height: x(),
                    visibility: void 0
                }, l(Date.now));
            });
        }
    }
    function E() {
        i.current && (e.collapse = $5c9ab921368ace58$var$a, e.style = {
            height: void 0,
            visibility: void 0
        }, u(), setTimeout(()=>l(Date.now), 0));
    }
    function x() {
        return `${i.current.scrollHeight}px`;
    }
    function G({ target: t, propertyName: f }) {
        if (t === i.current && f === "height") {
            const c = t.style.height;
            switch(e.collapse){
                case $5c9ab921368ace58$var$r:
                    c === void 0 || c === s || E();
                    break;
                case $5c9ab921368ace58$var$p:
                    c === void 0 || c !== s || C();
                    break;
            }
        }
    }
    const k = e.collapse === $5c9ab921368ace58$var$a || e.collapse === $5c9ab921368ace58$var$r;
    !k && n && q(), k && !n && $();
    const I = {
        overflow: e.collapse === $5c9ab921368ace58$var$a && S ? void 0 : "hidden",
        transition: T,
        ...A,
        ...e.style
    }, X = y, j = (0, $5NSbj.useCallback)((t)=>{
        t && (i.current = t, g(L, {
            node: t
        }));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        y
    ]), U = R ? `${v} --c-${e.collapse}` : v;
    return(// @ts-ignore
    /* @__PURE__ */ (0, $fcda9d1f1901e894$exports.jsx)(X, {
        ref: j,
        style: I,
        onTransitionEnd: G,
        className: U,
        ...F,
        children: typeof o == "function" ? o(e.collapse) : typeof d == "function" ? d(e.collapse) : o
    }));
};


var $9230d46773d20d22$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $9230d46773d20d22$exports) {
        classNames.default = classNames;
        $9230d46773d20d22$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();





var $5NSbj = parcelRequire("5NSbj");


var $5NSbj = parcelRequire("5NSbj");
const $6d231a1f6cc2b85c$var$defaultOptions = {};
/**
 *
 * useInput Hook
 *
 * Handles an input's value and onChange props internally to
 * make text input creation process easier
 *
 * @param {unknown} [initialValue] Initial value of the input
 * @param {Options} [options] Options object
 * @returns {InputHandler} Input handler with value and onChange
 * @see https://rooks.vercel.app/docs/useInput
 */ function $6d231a1f6cc2b85c$export$1e36b9f257eee5fa(initialValue = "", options = $6d231a1f6cc2b85c$var$defaultOptions) {
    const [value, setValue] = (0, $5NSbj.useState)(initialValue);
    const onChange = (0, $5NSbj.useCallback)((event)=>{
        const newValue = event.target.value;
        let shouldUpdate = true;
        if (typeof options.validate === "function") shouldUpdate = options.validate(newValue, value);
        if (shouldUpdate) setValue(newValue);
    }, [
        options,
        value
    ]);
    // sync with default value
    (0, $5NSbj.useEffect)(()=>{
        setValue(initialValue);
    }, [
        initialValue
    ]);
    const handler = {
        onChange: onChange,
        value: value
    };
    return handler;
}





function $1adbe19d09ddc903$export$2e2bcd8739ae039({ setTitle: setTitle }) {
    const [state, setState] = (0, $5NSbj.useState)((0, $c097b691ff08d4e3$export$62aa48085237e36f).INITIAL);
    const [hashedPassword, setHashedPassword] = (0, $5NSbj.useState)("");
    const [error, setError] = (0, $5NSbj.useState)(null);
    const passwordEntry = (0, $6d231a1f6cc2b85c$export$1e36b9f257eee5fa)("");
    const history = (0, $88361e604f4abd56$export$3420e1dc2c4a518c)();
    const submit = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        setState((0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING);
        (0, $3b58afcf3e935267$export$708be5cd94908894)(passwordEntry.value.trim()).then((hashedPassword)=>{
            setHashedPassword(hashedPassword);
            setState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
        }).catch((error)=>{
            if (error instanceof (0, $506fdaa0545346a2$export$65bd6083489bd8bb) && error.response.status === 403) {
                history.push("/sign/in", {
                    error: "Generating a new password hash requires being logged in or not setting \u201Cpassword\u201D in selfoss configuration.",
                    returnLocation: "/password"
                });
                return;
            }
            setError(error);
            setState((0, $c097b691ff08d4e3$export$62aa48085237e36f).ERROR);
        });
    }, [
        history,
        passwordEntry.value
    ]);
    (0, $5NSbj.useEffect)(()=>{
        setTitle("selfoss password hash generator");
        return ()=>{
            setTitle(null);
        };
    }, [
        setTitle
    ]);
    const message = state === (0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
        className: "error",
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("label", {
            children: [
                "Generated Password (insert this into config.ini):",
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                    type: "text",
                    value: hashedPassword,
                    readOnly: true
                })
            ]
        })
    }) : state === (0, $c097b691ff08d4e3$export$62aa48085237e36f).ERROR ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("p", {
        className: "error",
        children: [
            "Unexpected happened.",
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("details", {
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("pre", {
                    children: [
                        "$",
                        JSON.stringify(error)
                    ]
                })
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("form", {
        action: "",
        method: "post",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
            id: "login",
            children: [
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h1", {
                        children: "hash generator"
                    })
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: "password",
                            children: "Password:"
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            type: "password",
                            name: "password",
                            autoComplete: "new-password",
                            accessKey: "p",
                            ...passwordEntry
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    className: "message-container",
                    "aria-live": "assertive",
                    children: message
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            className: "button",
                            type: "submit",
                            value: state === (0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING ? "Hashing password\u2026" : "Compute hash",
                            accessKey: "g",
                            disabled: state === (0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING
                        })
                    ]
                })
            ]
        })
    });
}
$1adbe19d09ddc903$export$2e2bcd8739ae039.propTypes = {
    setTitle: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};




var $5NSbj = parcelRequire("5NSbj");

var $66149cfac528b117$exports = {};
"use strict";

$66149cfac528b117$exports = (parcelRequire("a9Dz7"));


const $53c3b946f51d9aa7$export$8793edee2d425525 = ()=>{};


/**
 *
 * @returns {boolean} Is navigator online
 */ function $3d007043bfaeffb3$var$getSnapshot() {
    if (typeof window === "undefined") return null;
    return navigator.onLine;
}
function $3d007043bfaeffb3$var$subscribe(onStoreChange) {
    if (typeof window !== "undefined") {
        window.addEventListener("online", onStoreChange);
        window.addEventListener("offline", onStoreChange);
        return ()=>{
            window.removeEventListener("online", onStoreChange);
            window.removeEventListener("offline", onStoreChange);
        };
    } else {
        console.warn("useOnline: window is undefined.");
        return 0, $53c3b946f51d9aa7$export$8793edee2d425525;
    }
}
/**
 * useOnline hook
 *
 * Returns true if navigator is online, false if not.
 *
 * @returns {boolean} The value of navigator.onLine
 * @see https://rooks.vercel.app/docs/useOnline
 */ function $3d007043bfaeffb3$export$6feb6ada280bcdab() {
    const isOnline = (0, $66149cfac528b117$exports.useSyncExternalStore)($3d007043bfaeffb3$var$subscribe, $3d007043bfaeffb3$var$getSnapshot);
    return isOnline;
}






function $4a4791c9c37eaae1$export$2e2bcd8739ae039({ setTitle: setTitle }) {
    const [state, setState] = (0, $5NSbj.useState)((0, $c097b691ff08d4e3$export$62aa48085237e36f).INITIAL);
    const [message, setMessage] = (0, $5NSbj.useState)(null);
    const fileEntry = (0, $5NSbj.useRef)();
    const history = (0, $88361e604f4abd56$export$3420e1dc2c4a518c)();
    const submit = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        setState((0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING);
        const file = fileEntry.current.files[0];
        (0, $3b58afcf3e935267$export$b3b4cde15a96b715)(file).then(({ response: response, data: data })=>{
            const { messages: messages } = data;
            if (response.status === 200) {
                setState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
                setMessage(/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("p", {
                    className: "msg success",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                            children: messages.map((msg, i)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                    children: msg
                                }, i))
                        }),
                        "You might want to ",
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
                            href: "update",
                            children: "update now"
                        }),
                        " or ",
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
                            to: "/",
                            children: "view your feeds"
                        }),
                        "."
                    ]
                }));
            } else if (response.status === 202) {
                setState((0, $c097b691ff08d4e3$export$62aa48085237e36f).ERROR);
                setMessage(/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("p", {
                    className: "msg error",
                    children: [
                        "The following feeds could not be imported:",
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                            children: messages.map((msg, i)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                    children: msg
                                }, i))
                        })
                    ]
                }));
            } else if (response.status === 400) {
                setState((0, $c097b691ff08d4e3$export$62aa48085237e36f).ERROR);
                setMessage(/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("p", {
                    className: "msg error",
                    children: [
                        "There was a problem importing your OPML file:",
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                            children: messages.map((msg, i)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                    children: msg
                                }, i))
                        })
                    ]
                }));
            } else throw new (0, $506fdaa0545346a2$export$4511c7da58e2d9c2)(`OPML import handler received status ${response.status}. This should not happen.`);
        }).catch((error)=>{
            if (error instanceof (0, $506fdaa0545346a2$export$65bd6083489bd8bb) && error.response.status === 403) {
                history.push("/sign/in", {
                    error: "Importing OPML file requires being logged in or not setting \u201Cpassword\u201D in selfoss configuration.",
                    returnLocation: "/opml"
                });
                return;
            } else {
                setState((0, $c097b691ff08d4e3$export$62aa48085237e36f).ERROR);
                setMessage(/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                    className: "msg error",
                    children: [
                        "Unexpected error occurred.",
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("details", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("pre", {
                                children: error.message
                            })
                        })
                    ]
                }));
            }
        });
    }, [
        history
    ]);
    (0, $5NSbj.useEffect)(()=>{
        setTitle("selfoss OPML importer");
        return ()=>{
            setTitle(null);
        };
    }, [
        setTitle
    ]);
    const isOnline = (0, $3d007043bfaeffb3$export$6feb6ada280bcdab)();
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("form", {
        action: "",
        method: "post",
        encType: "multipart/form-data",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
            id: "opml",
            children: [
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h1", {
                        children: "Upload an OPML File"
                    })
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
                        children: "Coming from a different RSS Reader? Export your subscriptions to an OPML file and upload it here. OPML export is usually located somewhere in settings, consult the reader\u2019s manual."
                    })
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    className: "message-container",
                    "aria-live": "assertive",
                    children: [
                        !isOnline && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            className: "msg error",
                            children: "OPML import requires an internet connection. Please reconnect before proceeding."
                        }),
                        message
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    className: "center",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: "opml",
                            children: "Opml.xml:"
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            type: "file",
                            accessKey: "f",
                            ref: fileEntry,
                            id: "opml",
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    className: "button",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            type: "submit",
                            value: state === (0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING ? "Importing\u2026" : "Deliver my OPML!",
                            accessKey: "d",
                            disabled: !isOnline || state === (0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING
                        })
                    ]
                })
            ]
        })
    });
}
$4a4791c9c37eaae1$export$2e2bcd8739ae039.propTypes = {
    setTitle: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};




var $5NSbj = parcelRequire("5NSbj");




var $5NSbj = parcelRequire("5NSbj");


var $3af4382a42f8c157$exports = {};
"use strict";
Object.defineProperty($3af4382a42f8c157$exports, "__esModule", {
    value: true
});
var $3af4382a42f8c157$var$prefix = "fab";
var $3af4382a42f8c157$var$iconName = "diaspora";
var $3af4382a42f8c157$var$width = 512;
var $3af4382a42f8c157$var$height = 512;
var $3af4382a42f8c157$var$aliases = [];
var $3af4382a42f8c157$var$unicode = "f791";
var $3af4382a42f8c157$var$svgPathData = "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z";
$3af4382a42f8c157$exports.definition = {
    prefix: $3af4382a42f8c157$var$prefix,
    iconName: $3af4382a42f8c157$var$iconName,
    icon: [
        $3af4382a42f8c157$var$width,
        $3af4382a42f8c157$var$height,
        $3af4382a42f8c157$var$aliases,
        $3af4382a42f8c157$var$unicode,
        $3af4382a42f8c157$var$svgPathData
    ]
};
$3af4382a42f8c157$exports.faDiaspora = $3af4382a42f8c157$exports.definition;
$3af4382a42f8c157$exports.prefix = $3af4382a42f8c157$var$prefix;
$3af4382a42f8c157$exports.iconName = $3af4382a42f8c157$var$iconName;
$3af4382a42f8c157$exports.width = $3af4382a42f8c157$var$width;
$3af4382a42f8c157$exports.height = $3af4382a42f8c157$var$height;
$3af4382a42f8c157$exports.ligatures = $3af4382a42f8c157$var$aliases;
$3af4382a42f8c157$exports.unicode = $3af4382a42f8c157$var$unicode;
$3af4382a42f8c157$exports.svgPathData = $3af4382a42f8c157$var$svgPathData;
$3af4382a42f8c157$exports.aliases = $3af4382a42f8c157$var$aliases;


var $164536c7567608d5$exports = {};
"use strict";
Object.defineProperty($164536c7567608d5$exports, "__esModule", {
    value: true
});
var $d0fe6b5e5bc9cff1$exports = {};
"use strict";
Object.defineProperty($d0fe6b5e5bc9cff1$exports, "__esModule", {
    value: true
});
var $d0fe6b5e5bc9cff1$var$prefix = "fab";
var $d0fe6b5e5bc9cff1$var$iconName = "square-facebook";
var $d0fe6b5e5bc9cff1$var$width = 448;
var $d0fe6b5e5bc9cff1$var$height = 512;
var $d0fe6b5e5bc9cff1$var$aliases = [
    "facebook-square"
];
var $d0fe6b5e5bc9cff1$var$unicode = "f082";
var $d0fe6b5e5bc9cff1$var$svgPathData = "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z";
$d0fe6b5e5bc9cff1$exports.definition = {
    prefix: $d0fe6b5e5bc9cff1$var$prefix,
    iconName: $d0fe6b5e5bc9cff1$var$iconName,
    icon: [
        $d0fe6b5e5bc9cff1$var$width,
        $d0fe6b5e5bc9cff1$var$height,
        $d0fe6b5e5bc9cff1$var$aliases,
        $d0fe6b5e5bc9cff1$var$unicode,
        $d0fe6b5e5bc9cff1$var$svgPathData
    ]
};
$d0fe6b5e5bc9cff1$exports.faSquareFacebook = $d0fe6b5e5bc9cff1$exports.definition;
$d0fe6b5e5bc9cff1$exports.prefix = $d0fe6b5e5bc9cff1$var$prefix;
$d0fe6b5e5bc9cff1$exports.iconName = $d0fe6b5e5bc9cff1$var$iconName;
$d0fe6b5e5bc9cff1$exports.width = $d0fe6b5e5bc9cff1$var$width;
$d0fe6b5e5bc9cff1$exports.height = $d0fe6b5e5bc9cff1$var$height;
$d0fe6b5e5bc9cff1$exports.ligatures = $d0fe6b5e5bc9cff1$var$aliases;
$d0fe6b5e5bc9cff1$exports.unicode = $d0fe6b5e5bc9cff1$var$unicode;
$d0fe6b5e5bc9cff1$exports.svgPathData = $d0fe6b5e5bc9cff1$var$svgPathData;
$d0fe6b5e5bc9cff1$exports.aliases = $d0fe6b5e5bc9cff1$var$aliases;


$164536c7567608d5$exports.definition = {
    prefix: $d0fe6b5e5bc9cff1$exports.prefix,
    iconName: $d0fe6b5e5bc9cff1$exports.iconName,
    icon: [
        $d0fe6b5e5bc9cff1$exports.width,
        $d0fe6b5e5bc9cff1$exports.height,
        $d0fe6b5e5bc9cff1$exports.aliases,
        $d0fe6b5e5bc9cff1$exports.unicode,
        $d0fe6b5e5bc9cff1$exports.svgPathData
    ]
};
$164536c7567608d5$exports.faFacebookSquare = $164536c7567608d5$exports.definition;
$164536c7567608d5$exports.prefix = $d0fe6b5e5bc9cff1$exports.prefix;
$164536c7567608d5$exports.iconName = $d0fe6b5e5bc9cff1$exports.iconName;
$164536c7567608d5$exports.width = $d0fe6b5e5bc9cff1$exports.width;
$164536c7567608d5$exports.height = $d0fe6b5e5bc9cff1$exports.height;
$164536c7567608d5$exports.ligatures = $d0fe6b5e5bc9cff1$exports.aliases;
$164536c7567608d5$exports.unicode = $d0fe6b5e5bc9cff1$exports.unicode;
$164536c7567608d5$exports.svgPathData = $d0fe6b5e5bc9cff1$exports.svgPathData;
$164536c7567608d5$exports.aliases = $d0fe6b5e5bc9cff1$exports.aliases;


var $d7a77b6f799d2f63$exports = {};
"use strict";
Object.defineProperty($d7a77b6f799d2f63$exports, "__esModule", {
    value: true
});
var $d7a77b6f799d2f63$var$prefix = "fab";
var $d7a77b6f799d2f63$var$iconName = "get-pocket";
var $d7a77b6f799d2f63$var$width = 448;
var $d7a77b6f799d2f63$var$height = 512;
var $d7a77b6f799d2f63$var$aliases = [];
var $d7a77b6f799d2f63$var$unicode = "f265";
var $d7a77b6f799d2f63$var$svgPathData = "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z";
$d7a77b6f799d2f63$exports.definition = {
    prefix: $d7a77b6f799d2f63$var$prefix,
    iconName: $d7a77b6f799d2f63$var$iconName,
    icon: [
        $d7a77b6f799d2f63$var$width,
        $d7a77b6f799d2f63$var$height,
        $d7a77b6f799d2f63$var$aliases,
        $d7a77b6f799d2f63$var$unicode,
        $d7a77b6f799d2f63$var$svgPathData
    ]
};
$d7a77b6f799d2f63$exports.faGetPocket = $d7a77b6f799d2f63$exports.definition;
$d7a77b6f799d2f63$exports.prefix = $d7a77b6f799d2f63$var$prefix;
$d7a77b6f799d2f63$exports.iconName = $d7a77b6f799d2f63$var$iconName;
$d7a77b6f799d2f63$exports.width = $d7a77b6f799d2f63$var$width;
$d7a77b6f799d2f63$exports.height = $d7a77b6f799d2f63$var$height;
$d7a77b6f799d2f63$exports.ligatures = $d7a77b6f799d2f63$var$aliases;
$d7a77b6f799d2f63$exports.unicode = $d7a77b6f799d2f63$var$unicode;
$d7a77b6f799d2f63$exports.svgPathData = $d7a77b6f799d2f63$var$svgPathData;
$d7a77b6f799d2f63$exports.aliases = $d7a77b6f799d2f63$var$aliases;


var $d7e8063e124a7dab$exports = {};
"use strict";
Object.defineProperty($d7e8063e124a7dab$exports, "__esModule", {
    value: true
});
var $d7e8063e124a7dab$var$prefix = "fab";
var $d7e8063e124a7dab$var$iconName = "twitter";
var $d7e8063e124a7dab$var$width = 512;
var $d7e8063e124a7dab$var$height = 512;
var $d7e8063e124a7dab$var$aliases = [];
var $d7e8063e124a7dab$var$unicode = "f099";
var $d7e8063e124a7dab$var$svgPathData = "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z";
$d7e8063e124a7dab$exports.definition = {
    prefix: $d7e8063e124a7dab$var$prefix,
    iconName: $d7e8063e124a7dab$var$iconName,
    icon: [
        $d7e8063e124a7dab$var$width,
        $d7e8063e124a7dab$var$height,
        $d7e8063e124a7dab$var$aliases,
        $d7e8063e124a7dab$var$unicode,
        $d7e8063e124a7dab$var$svgPathData
    ]
};
$d7e8063e124a7dab$exports.faTwitter = $d7e8063e124a7dab$exports.definition;
$d7e8063e124a7dab$exports.prefix = $d7e8063e124a7dab$var$prefix;
$d7e8063e124a7dab$exports.iconName = $d7e8063e124a7dab$var$iconName;
$d7e8063e124a7dab$exports.width = $d7e8063e124a7dab$var$width;
$d7e8063e124a7dab$exports.height = $d7e8063e124a7dab$var$height;
$d7e8063e124a7dab$exports.ligatures = $d7e8063e124a7dab$var$aliases;
$d7e8063e124a7dab$exports.unicode = $d7e8063e124a7dab$var$unicode;
$d7e8063e124a7dab$exports.svgPathData = $d7e8063e124a7dab$var$svgPathData;
$d7e8063e124a7dab$exports.aliases = $d7e8063e124a7dab$var$aliases;


var $ee1da5f4ecb633d4$exports = {};
"use strict";
Object.defineProperty($ee1da5f4ecb633d4$exports, "__esModule", {
    value: true
});
var $ee1da5f4ecb633d4$var$prefix = "fab";
var $ee1da5f4ecb633d4$var$iconName = "wordpress-simple";
var $ee1da5f4ecb633d4$var$width = 512;
var $ee1da5f4ecb633d4$var$height = 512;
var $ee1da5f4ecb633d4$var$aliases = [];
var $ee1da5f4ecb633d4$var$unicode = "f411";
var $ee1da5f4ecb633d4$var$svgPathData = "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z";
$ee1da5f4ecb633d4$exports.definition = {
    prefix: $ee1da5f4ecb633d4$var$prefix,
    iconName: $ee1da5f4ecb633d4$var$iconName,
    icon: [
        $ee1da5f4ecb633d4$var$width,
        $ee1da5f4ecb633d4$var$height,
        $ee1da5f4ecb633d4$var$aliases,
        $ee1da5f4ecb633d4$var$unicode,
        $ee1da5f4ecb633d4$var$svgPathData
    ]
};
$ee1da5f4ecb633d4$exports.faWordpressSimple = $ee1da5f4ecb633d4$exports.definition;
$ee1da5f4ecb633d4$exports.prefix = $ee1da5f4ecb633d4$var$prefix;
$ee1da5f4ecb633d4$exports.iconName = $ee1da5f4ecb633d4$var$iconName;
$ee1da5f4ecb633d4$exports.width = $ee1da5f4ecb633d4$var$width;
$ee1da5f4ecb633d4$exports.height = $ee1da5f4ecb633d4$var$height;
$ee1da5f4ecb633d4$exports.ligatures = $ee1da5f4ecb633d4$var$aliases;
$ee1da5f4ecb633d4$exports.unicode = $ee1da5f4ecb633d4$var$unicode;
$ee1da5f4ecb633d4$exports.svgPathData = $ee1da5f4ecb633d4$var$svgPathData;
$ee1da5f4ecb633d4$exports.aliases = $ee1da5f4ecb633d4$var$aliases;


var $e15eeddf947b426f$exports = {};
"use strict";
Object.defineProperty($e15eeddf947b426f$exports, "__esModule", {
    value: true
});
var $e15eeddf947b426f$var$prefix = "fab";
var $e15eeddf947b426f$var$iconName = "mastodon";
var $e15eeddf947b426f$var$width = 448;
var $e15eeddf947b426f$var$height = 512;
var $e15eeddf947b426f$var$aliases = [];
var $e15eeddf947b426f$var$unicode = "f4f6";
var $e15eeddf947b426f$var$svgPathData = "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z";
$e15eeddf947b426f$exports.definition = {
    prefix: $e15eeddf947b426f$var$prefix,
    iconName: $e15eeddf947b426f$var$iconName,
    icon: [
        $e15eeddf947b426f$var$width,
        $e15eeddf947b426f$var$height,
        $e15eeddf947b426f$var$aliases,
        $e15eeddf947b426f$var$unicode,
        $e15eeddf947b426f$var$svgPathData
    ]
};
$e15eeddf947b426f$exports.faMastodon = $e15eeddf947b426f$exports.definition;
$e15eeddf947b426f$exports.prefix = $e15eeddf947b426f$var$prefix;
$e15eeddf947b426f$exports.iconName = $e15eeddf947b426f$var$iconName;
$e15eeddf947b426f$exports.width = $e15eeddf947b426f$var$width;
$e15eeddf947b426f$exports.height = $e15eeddf947b426f$var$height;
$e15eeddf947b426f$exports.ligatures = $e15eeddf947b426f$var$aliases;
$e15eeddf947b426f$exports.unicode = $e15eeddf947b426f$var$unicode;
$e15eeddf947b426f$exports.svgPathData = $e15eeddf947b426f$var$svgPathData;
$e15eeddf947b426f$exports.aliases = $e15eeddf947b426f$var$aliases;


var $154f2d6577c9bf5d$exports = {};
"use strict";
Object.defineProperty($154f2d6577c9bf5d$exports, "__esModule", {
    value: true
});
var $d3388fc3d30da66a$exports = {};
"use strict";
Object.defineProperty($d3388fc3d30da66a$exports, "__esModule", {
    value: true
});
var $d3388fc3d30da66a$var$prefix = "far";
var $d3388fc3d30da66a$var$iconName = "circle-check";
var $d3388fc3d30da66a$var$width = 512;
var $d3388fc3d30da66a$var$height = 512;
var $d3388fc3d30da66a$var$aliases = [
    61533,
    "check-circle"
];
var $d3388fc3d30da66a$var$unicode = "f058";
var $d3388fc3d30da66a$var$svgPathData = "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z";
$d3388fc3d30da66a$exports.definition = {
    prefix: $d3388fc3d30da66a$var$prefix,
    iconName: $d3388fc3d30da66a$var$iconName,
    icon: [
        $d3388fc3d30da66a$var$width,
        $d3388fc3d30da66a$var$height,
        $d3388fc3d30da66a$var$aliases,
        $d3388fc3d30da66a$var$unicode,
        $d3388fc3d30da66a$var$svgPathData
    ]
};
$d3388fc3d30da66a$exports.faCircleCheck = $d3388fc3d30da66a$exports.definition;
$d3388fc3d30da66a$exports.prefix = $d3388fc3d30da66a$var$prefix;
$d3388fc3d30da66a$exports.iconName = $d3388fc3d30da66a$var$iconName;
$d3388fc3d30da66a$exports.width = $d3388fc3d30da66a$var$width;
$d3388fc3d30da66a$exports.height = $d3388fc3d30da66a$var$height;
$d3388fc3d30da66a$exports.ligatures = $d3388fc3d30da66a$var$aliases;
$d3388fc3d30da66a$exports.unicode = $d3388fc3d30da66a$var$unicode;
$d3388fc3d30da66a$exports.svgPathData = $d3388fc3d30da66a$var$svgPathData;
$d3388fc3d30da66a$exports.aliases = $d3388fc3d30da66a$var$aliases;


$154f2d6577c9bf5d$exports.definition = {
    prefix: $d3388fc3d30da66a$exports.prefix,
    iconName: $d3388fc3d30da66a$exports.iconName,
    icon: [
        $d3388fc3d30da66a$exports.width,
        $d3388fc3d30da66a$exports.height,
        $d3388fc3d30da66a$exports.aliases,
        $d3388fc3d30da66a$exports.unicode,
        $d3388fc3d30da66a$exports.svgPathData
    ]
};
$154f2d6577c9bf5d$exports.faCheckCircle = $154f2d6577c9bf5d$exports.definition;
$154f2d6577c9bf5d$exports.prefix = $d3388fc3d30da66a$exports.prefix;
$154f2d6577c9bf5d$exports.iconName = $d3388fc3d30da66a$exports.iconName;
$154f2d6577c9bf5d$exports.width = $d3388fc3d30da66a$exports.width;
$154f2d6577c9bf5d$exports.height = $d3388fc3d30da66a$exports.height;
$154f2d6577c9bf5d$exports.ligatures = $d3388fc3d30da66a$exports.aliases;
$154f2d6577c9bf5d$exports.unicode = $d3388fc3d30da66a$exports.unicode;
$154f2d6577c9bf5d$exports.svgPathData = $d3388fc3d30da66a$exports.svgPathData;
$154f2d6577c9bf5d$exports.aliases = $d3388fc3d30da66a$exports.aliases;


var $1e8ca391384385ce$exports = {};
"use strict";
Object.defineProperty($1e8ca391384385ce$exports, "__esModule", {
    value: true
});
var $1e8ca391384385ce$var$prefix = "far";
var $1e8ca391384385ce$var$iconName = "star";
var $1e8ca391384385ce$var$width = 576;
var $1e8ca391384385ce$var$height = 512;
var $1e8ca391384385ce$var$aliases = [
    11088,
    61446
];
var $1e8ca391384385ce$var$unicode = "f005";
var $1e8ca391384385ce$var$svgPathData = "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z";
$1e8ca391384385ce$exports.definition = {
    prefix: $1e8ca391384385ce$var$prefix,
    iconName: $1e8ca391384385ce$var$iconName,
    icon: [
        $1e8ca391384385ce$var$width,
        $1e8ca391384385ce$var$height,
        $1e8ca391384385ce$var$aliases,
        $1e8ca391384385ce$var$unicode,
        $1e8ca391384385ce$var$svgPathData
    ]
};
$1e8ca391384385ce$exports.faStar = $1e8ca391384385ce$exports.definition;
$1e8ca391384385ce$exports.prefix = $1e8ca391384385ce$var$prefix;
$1e8ca391384385ce$exports.iconName = $1e8ca391384385ce$var$iconName;
$1e8ca391384385ce$exports.width = $1e8ca391384385ce$var$width;
$1e8ca391384385ce$exports.height = $1e8ca391384385ce$var$height;
$1e8ca391384385ce$exports.ligatures = $1e8ca391384385ce$var$aliases;
$1e8ca391384385ce$exports.unicode = $1e8ca391384385ce$var$unicode;
$1e8ca391384385ce$exports.svgPathData = $1e8ca391384385ce$var$svgPathData;
$1e8ca391384385ce$exports.aliases = $1e8ca391384385ce$var$aliases;


var $72abcd8059f7a937$exports = {};
"use strict";
Object.defineProperty($72abcd8059f7a937$exports, "__esModule", {
    value: true
});
var $5b42293b476b3f18$exports = {};
"use strict";
Object.defineProperty($5b42293b476b3f18$exports, "__esModule", {
    value: true
});
var $5b42293b476b3f18$var$prefix = "far";
var $5b42293b476b3f18$var$iconName = "circle-xmark";
var $5b42293b476b3f18$var$width = 512;
var $5b42293b476b3f18$var$height = 512;
var $5b42293b476b3f18$var$aliases = [
    61532,
    "times-circle",
    "xmark-circle"
];
var $5b42293b476b3f18$var$unicode = "f057";
var $5b42293b476b3f18$var$svgPathData = "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
$5b42293b476b3f18$exports.definition = {
    prefix: $5b42293b476b3f18$var$prefix,
    iconName: $5b42293b476b3f18$var$iconName,
    icon: [
        $5b42293b476b3f18$var$width,
        $5b42293b476b3f18$var$height,
        $5b42293b476b3f18$var$aliases,
        $5b42293b476b3f18$var$unicode,
        $5b42293b476b3f18$var$svgPathData
    ]
};
$5b42293b476b3f18$exports.faCircleXmark = $5b42293b476b3f18$exports.definition;
$5b42293b476b3f18$exports.prefix = $5b42293b476b3f18$var$prefix;
$5b42293b476b3f18$exports.iconName = $5b42293b476b3f18$var$iconName;
$5b42293b476b3f18$exports.width = $5b42293b476b3f18$var$width;
$5b42293b476b3f18$exports.height = $5b42293b476b3f18$var$height;
$5b42293b476b3f18$exports.ligatures = $5b42293b476b3f18$var$aliases;
$5b42293b476b3f18$exports.unicode = $5b42293b476b3f18$var$unicode;
$5b42293b476b3f18$exports.svgPathData = $5b42293b476b3f18$var$svgPathData;
$5b42293b476b3f18$exports.aliases = $5b42293b476b3f18$var$aliases;


$72abcd8059f7a937$exports.definition = {
    prefix: $5b42293b476b3f18$exports.prefix,
    iconName: $5b42293b476b3f18$exports.iconName,
    icon: [
        $5b42293b476b3f18$exports.width,
        $5b42293b476b3f18$exports.height,
        $5b42293b476b3f18$exports.aliases,
        $5b42293b476b3f18$exports.unicode,
        $5b42293b476b3f18$exports.svgPathData
    ]
};
$72abcd8059f7a937$exports.faTimesCircle = $72abcd8059f7a937$exports.definition;
$72abcd8059f7a937$exports.prefix = $5b42293b476b3f18$exports.prefix;
$72abcd8059f7a937$exports.iconName = $5b42293b476b3f18$exports.iconName;
$72abcd8059f7a937$exports.width = $5b42293b476b3f18$exports.width;
$72abcd8059f7a937$exports.height = $5b42293b476b3f18$exports.height;
$72abcd8059f7a937$exports.ligatures = $5b42293b476b3f18$exports.aliases;
$72abcd8059f7a937$exports.unicode = $5b42293b476b3f18$exports.unicode;
$72abcd8059f7a937$exports.svgPathData = $5b42293b476b3f18$exports.svgPathData;
$72abcd8059f7a937$exports.aliases = $5b42293b476b3f18$exports.aliases;


var $2feb01c0637ffeff$exports = {};
"use strict";
Object.defineProperty($2feb01c0637ffeff$exports, "__esModule", {
    value: true
});
var $53d82ec27a6b7ce9$exports = {};
"use strict";
Object.defineProperty($53d82ec27a6b7ce9$exports, "__esModule", {
    value: true
});
var $53d82ec27a6b7ce9$var$prefix = "fas";
var $53d82ec27a6b7ce9$var$iconName = "circle-down";
var $53d82ec27a6b7ce9$var$width = 512;
var $53d82ec27a6b7ce9$var$height = 512;
var $53d82ec27a6b7ce9$var$aliases = [
    61466,
    "arrow-alt-circle-down"
];
var $53d82ec27a6b7ce9$var$unicode = "f358";
var $53d82ec27a6b7ce9$var$svgPathData = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z";
$53d82ec27a6b7ce9$exports.definition = {
    prefix: $53d82ec27a6b7ce9$var$prefix,
    iconName: $53d82ec27a6b7ce9$var$iconName,
    icon: [
        $53d82ec27a6b7ce9$var$width,
        $53d82ec27a6b7ce9$var$height,
        $53d82ec27a6b7ce9$var$aliases,
        $53d82ec27a6b7ce9$var$unicode,
        $53d82ec27a6b7ce9$var$svgPathData
    ]
};
$53d82ec27a6b7ce9$exports.faCircleDown = $53d82ec27a6b7ce9$exports.definition;
$53d82ec27a6b7ce9$exports.prefix = $53d82ec27a6b7ce9$var$prefix;
$53d82ec27a6b7ce9$exports.iconName = $53d82ec27a6b7ce9$var$iconName;
$53d82ec27a6b7ce9$exports.width = $53d82ec27a6b7ce9$var$width;
$53d82ec27a6b7ce9$exports.height = $53d82ec27a6b7ce9$var$height;
$53d82ec27a6b7ce9$exports.ligatures = $53d82ec27a6b7ce9$var$aliases;
$53d82ec27a6b7ce9$exports.unicode = $53d82ec27a6b7ce9$var$unicode;
$53d82ec27a6b7ce9$exports.svgPathData = $53d82ec27a6b7ce9$var$svgPathData;
$53d82ec27a6b7ce9$exports.aliases = $53d82ec27a6b7ce9$var$aliases;


$2feb01c0637ffeff$exports.definition = {
    prefix: $53d82ec27a6b7ce9$exports.prefix,
    iconName: $53d82ec27a6b7ce9$exports.iconName,
    icon: [
        $53d82ec27a6b7ce9$exports.width,
        $53d82ec27a6b7ce9$exports.height,
        $53d82ec27a6b7ce9$exports.aliases,
        $53d82ec27a6b7ce9$exports.unicode,
        $53d82ec27a6b7ce9$exports.svgPathData
    ]
};
$2feb01c0637ffeff$exports.faArrowAltCircleDown = $2feb01c0637ffeff$exports.definition;
$2feb01c0637ffeff$exports.prefix = $53d82ec27a6b7ce9$exports.prefix;
$2feb01c0637ffeff$exports.iconName = $53d82ec27a6b7ce9$exports.iconName;
$2feb01c0637ffeff$exports.width = $53d82ec27a6b7ce9$exports.width;
$2feb01c0637ffeff$exports.height = $53d82ec27a6b7ce9$exports.height;
$2feb01c0637ffeff$exports.ligatures = $53d82ec27a6b7ce9$exports.aliases;
$2feb01c0637ffeff$exports.unicode = $53d82ec27a6b7ce9$exports.unicode;
$2feb01c0637ffeff$exports.svgPathData = $53d82ec27a6b7ce9$exports.svgPathData;
$2feb01c0637ffeff$exports.aliases = $53d82ec27a6b7ce9$exports.aliases;


var $e4ff5d82615e7815$exports = {};
"use strict";
Object.defineProperty($e4ff5d82615e7815$exports, "__esModule", {
    value: true
});
var $e4ff5d82615e7815$var$prefix = "fas";
var $e4ff5d82615e7815$var$iconName = "arrow-right";
var $e4ff5d82615e7815$var$width = 448;
var $e4ff5d82615e7815$var$height = 512;
var $e4ff5d82615e7815$var$aliases = [
    8594
];
var $e4ff5d82615e7815$var$unicode = "f061";
var $e4ff5d82615e7815$var$svgPathData = "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z";
$e4ff5d82615e7815$exports.definition = {
    prefix: $e4ff5d82615e7815$var$prefix,
    iconName: $e4ff5d82615e7815$var$iconName,
    icon: [
        $e4ff5d82615e7815$var$width,
        $e4ff5d82615e7815$var$height,
        $e4ff5d82615e7815$var$aliases,
        $e4ff5d82615e7815$var$unicode,
        $e4ff5d82615e7815$var$svgPathData
    ]
};
$e4ff5d82615e7815$exports.faArrowRight = $e4ff5d82615e7815$exports.definition;
$e4ff5d82615e7815$exports.prefix = $e4ff5d82615e7815$var$prefix;
$e4ff5d82615e7815$exports.iconName = $e4ff5d82615e7815$var$iconName;
$e4ff5d82615e7815$exports.width = $e4ff5d82615e7815$var$width;
$e4ff5d82615e7815$exports.height = $e4ff5d82615e7815$var$height;
$e4ff5d82615e7815$exports.ligatures = $e4ff5d82615e7815$var$aliases;
$e4ff5d82615e7815$exports.unicode = $e4ff5d82615e7815$var$unicode;
$e4ff5d82615e7815$exports.svgPathData = $e4ff5d82615e7815$var$svgPathData;
$e4ff5d82615e7815$exports.aliases = $e4ff5d82615e7815$var$aliases;


var $e9206858efef3e95$exports = {};
"use strict";
Object.defineProperty($e9206858efef3e95$exports, "__esModule", {
    value: true
});
var $e9206858efef3e95$var$prefix = "fas";
var $e9206858efef3e95$var$iconName = "check";
var $e9206858efef3e95$var$width = 448;
var $e9206858efef3e95$var$height = 512;
var $e9206858efef3e95$var$aliases = [
    10003,
    10004
];
var $e9206858efef3e95$var$unicode = "f00c";
var $e9206858efef3e95$var$svgPathData = "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z";
$e9206858efef3e95$exports.definition = {
    prefix: $e9206858efef3e95$var$prefix,
    iconName: $e9206858efef3e95$var$iconName,
    icon: [
        $e9206858efef3e95$var$width,
        $e9206858efef3e95$var$height,
        $e9206858efef3e95$var$aliases,
        $e9206858efef3e95$var$unicode,
        $e9206858efef3e95$var$svgPathData
    ]
};
$e9206858efef3e95$exports.faCheck = $e9206858efef3e95$exports.definition;
$e9206858efef3e95$exports.prefix = $e9206858efef3e95$var$prefix;
$e9206858efef3e95$exports.iconName = $e9206858efef3e95$var$iconName;
$e9206858efef3e95$exports.width = $e9206858efef3e95$var$width;
$e9206858efef3e95$exports.height = $e9206858efef3e95$var$height;
$e9206858efef3e95$exports.ligatures = $e9206858efef3e95$var$aliases;
$e9206858efef3e95$exports.unicode = $e9206858efef3e95$var$unicode;
$e9206858efef3e95$exports.svgPathData = $e9206858efef3e95$var$svgPathData;
$e9206858efef3e95$exports.aliases = $e9206858efef3e95$var$aliases;


var $8e226679142db257$exports = {};
"use strict";
Object.defineProperty($8e226679142db257$exports, "__esModule", {
    value: true
});
var $dfa3efc3728a4590$exports = {};
"use strict";
Object.defineProperty($dfa3efc3728a4590$exports, "__esModule", {
    value: true
});
var $dfa3efc3728a4590$var$prefix = "fas";
var $dfa3efc3728a4590$var$iconName = "circle-check";
var $dfa3efc3728a4590$var$width = 512;
var $dfa3efc3728a4590$var$height = 512;
var $dfa3efc3728a4590$var$aliases = [
    61533,
    "check-circle"
];
var $dfa3efc3728a4590$var$unicode = "f058";
var $dfa3efc3728a4590$var$svgPathData = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
$dfa3efc3728a4590$exports.definition = {
    prefix: $dfa3efc3728a4590$var$prefix,
    iconName: $dfa3efc3728a4590$var$iconName,
    icon: [
        $dfa3efc3728a4590$var$width,
        $dfa3efc3728a4590$var$height,
        $dfa3efc3728a4590$var$aliases,
        $dfa3efc3728a4590$var$unicode,
        $dfa3efc3728a4590$var$svgPathData
    ]
};
$dfa3efc3728a4590$exports.faCircleCheck = $dfa3efc3728a4590$exports.definition;
$dfa3efc3728a4590$exports.prefix = $dfa3efc3728a4590$var$prefix;
$dfa3efc3728a4590$exports.iconName = $dfa3efc3728a4590$var$iconName;
$dfa3efc3728a4590$exports.width = $dfa3efc3728a4590$var$width;
$dfa3efc3728a4590$exports.height = $dfa3efc3728a4590$var$height;
$dfa3efc3728a4590$exports.ligatures = $dfa3efc3728a4590$var$aliases;
$dfa3efc3728a4590$exports.unicode = $dfa3efc3728a4590$var$unicode;
$dfa3efc3728a4590$exports.svgPathData = $dfa3efc3728a4590$var$svgPathData;
$dfa3efc3728a4590$exports.aliases = $dfa3efc3728a4590$var$aliases;


$8e226679142db257$exports.definition = {
    prefix: $dfa3efc3728a4590$exports.prefix,
    iconName: $dfa3efc3728a4590$exports.iconName,
    icon: [
        $dfa3efc3728a4590$exports.width,
        $dfa3efc3728a4590$exports.height,
        $dfa3efc3728a4590$exports.aliases,
        $dfa3efc3728a4590$exports.unicode,
        $dfa3efc3728a4590$exports.svgPathData
    ]
};
$8e226679142db257$exports.faCheckCircle = $8e226679142db257$exports.definition;
$8e226679142db257$exports.prefix = $dfa3efc3728a4590$exports.prefix;
$8e226679142db257$exports.iconName = $dfa3efc3728a4590$exports.iconName;
$8e226679142db257$exports.width = $dfa3efc3728a4590$exports.width;
$8e226679142db257$exports.height = $dfa3efc3728a4590$exports.height;
$8e226679142db257$exports.ligatures = $dfa3efc3728a4590$exports.aliases;
$8e226679142db257$exports.unicode = $dfa3efc3728a4590$exports.unicode;
$8e226679142db257$exports.svgPathData = $dfa3efc3728a4590$exports.svgPathData;
$8e226679142db257$exports.aliases = $dfa3efc3728a4590$exports.aliases;


var $b39548c706c2a5e0$exports = {};
"use strict";
Object.defineProperty($b39548c706c2a5e0$exports, "__esModule", {
    value: true
});
var $b39548c706c2a5e0$var$prefix = "fas";
var $b39548c706c2a5e0$var$iconName = "caret-down";
var $b39548c706c2a5e0$var$width = 320;
var $b39548c706c2a5e0$var$height = 512;
var $b39548c706c2a5e0$var$aliases = [];
var $b39548c706c2a5e0$var$unicode = "f0d7";
var $b39548c706c2a5e0$var$svgPathData = "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z";
$b39548c706c2a5e0$exports.definition = {
    prefix: $b39548c706c2a5e0$var$prefix,
    iconName: $b39548c706c2a5e0$var$iconName,
    icon: [
        $b39548c706c2a5e0$var$width,
        $b39548c706c2a5e0$var$height,
        $b39548c706c2a5e0$var$aliases,
        $b39548c706c2a5e0$var$unicode,
        $b39548c706c2a5e0$var$svgPathData
    ]
};
$b39548c706c2a5e0$exports.faCaretDown = $b39548c706c2a5e0$exports.definition;
$b39548c706c2a5e0$exports.prefix = $b39548c706c2a5e0$var$prefix;
$b39548c706c2a5e0$exports.iconName = $b39548c706c2a5e0$var$iconName;
$b39548c706c2a5e0$exports.width = $b39548c706c2a5e0$var$width;
$b39548c706c2a5e0$exports.height = $b39548c706c2a5e0$var$height;
$b39548c706c2a5e0$exports.ligatures = $b39548c706c2a5e0$var$aliases;
$b39548c706c2a5e0$exports.unicode = $b39548c706c2a5e0$var$unicode;
$b39548c706c2a5e0$exports.svgPathData = $b39548c706c2a5e0$var$svgPathData;
$b39548c706c2a5e0$exports.aliases = $b39548c706c2a5e0$var$aliases;


var $e9e52821f7276495$exports = {};
"use strict";
Object.defineProperty($e9e52821f7276495$exports, "__esModule", {
    value: true
});
var $e9e52821f7276495$var$prefix = "fas";
var $e9e52821f7276495$var$iconName = "caret-right";
var $e9e52821f7276495$var$width = 256;
var $e9e52821f7276495$var$height = 512;
var $e9e52821f7276495$var$aliases = [];
var $e9e52821f7276495$var$unicode = "f0da";
var $e9e52821f7276495$var$svgPathData = "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z";
$e9e52821f7276495$exports.definition = {
    prefix: $e9e52821f7276495$var$prefix,
    iconName: $e9e52821f7276495$var$iconName,
    icon: [
        $e9e52821f7276495$var$width,
        $e9e52821f7276495$var$height,
        $e9e52821f7276495$var$aliases,
        $e9e52821f7276495$var$unicode,
        $e9e52821f7276495$var$svgPathData
    ]
};
$e9e52821f7276495$exports.faCaretRight = $e9e52821f7276495$exports.definition;
$e9e52821f7276495$exports.prefix = $e9e52821f7276495$var$prefix;
$e9e52821f7276495$exports.iconName = $e9e52821f7276495$var$iconName;
$e9e52821f7276495$exports.width = $e9e52821f7276495$var$width;
$e9e52821f7276495$exports.height = $e9e52821f7276495$var$height;
$e9e52821f7276495$exports.ligatures = $e9e52821f7276495$var$aliases;
$e9e52821f7276495$exports.unicode = $e9e52821f7276495$var$unicode;
$e9e52821f7276495$exports.svgPathData = $e9e52821f7276495$var$svgPathData;
$e9e52821f7276495$exports.aliases = $e9e52821f7276495$var$aliases;


var $89b603728dcec9de$exports = {};
"use strict";
Object.defineProperty($89b603728dcec9de$exports, "__esModule", {
    value: true
});
var $31c27e3921df46d5$exports = {};
"use strict";
Object.defineProperty($31c27e3921df46d5$exports, "__esModule", {
    value: true
});
var $31c27e3921df46d5$var$prefix = "fas";
var $31c27e3921df46d5$var$iconName = "cloud-arrow-up";
var $31c27e3921df46d5$var$width = 640;
var $31c27e3921df46d5$var$height = 512;
var $31c27e3921df46d5$var$aliases = [
    62338,
    "cloud-upload",
    "cloud-upload-alt"
];
var $31c27e3921df46d5$var$unicode = "f0ee";
var $31c27e3921df46d5$var$svgPathData = "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z";
$31c27e3921df46d5$exports.definition = {
    prefix: $31c27e3921df46d5$var$prefix,
    iconName: $31c27e3921df46d5$var$iconName,
    icon: [
        $31c27e3921df46d5$var$width,
        $31c27e3921df46d5$var$height,
        $31c27e3921df46d5$var$aliases,
        $31c27e3921df46d5$var$unicode,
        $31c27e3921df46d5$var$svgPathData
    ]
};
$31c27e3921df46d5$exports.faCloudArrowUp = $31c27e3921df46d5$exports.definition;
$31c27e3921df46d5$exports.prefix = $31c27e3921df46d5$var$prefix;
$31c27e3921df46d5$exports.iconName = $31c27e3921df46d5$var$iconName;
$31c27e3921df46d5$exports.width = $31c27e3921df46d5$var$width;
$31c27e3921df46d5$exports.height = $31c27e3921df46d5$var$height;
$31c27e3921df46d5$exports.ligatures = $31c27e3921df46d5$var$aliases;
$31c27e3921df46d5$exports.unicode = $31c27e3921df46d5$var$unicode;
$31c27e3921df46d5$exports.svgPathData = $31c27e3921df46d5$var$svgPathData;
$31c27e3921df46d5$exports.aliases = $31c27e3921df46d5$var$aliases;


$89b603728dcec9de$exports.definition = {
    prefix: $31c27e3921df46d5$exports.prefix,
    iconName: $31c27e3921df46d5$exports.iconName,
    icon: [
        $31c27e3921df46d5$exports.width,
        $31c27e3921df46d5$exports.height,
        $31c27e3921df46d5$exports.aliases,
        $31c27e3921df46d5$exports.unicode,
        $31c27e3921df46d5$exports.svgPathData
    ]
};
$89b603728dcec9de$exports.faCloudUploadAlt = $89b603728dcec9de$exports.definition;
$89b603728dcec9de$exports.prefix = $31c27e3921df46d5$exports.prefix;
$89b603728dcec9de$exports.iconName = $31c27e3921df46d5$exports.iconName;
$89b603728dcec9de$exports.width = $31c27e3921df46d5$exports.width;
$89b603728dcec9de$exports.height = $31c27e3921df46d5$exports.height;
$89b603728dcec9de$exports.ligatures = $31c27e3921df46d5$exports.aliases;
$89b603728dcec9de$exports.unicode = $31c27e3921df46d5$exports.unicode;
$89b603728dcec9de$exports.svgPathData = $31c27e3921df46d5$exports.svgPathData;
$89b603728dcec9de$exports.aliases = $31c27e3921df46d5$exports.aliases;


var $2af23e40017b25d9$exports = {};
"use strict";
Object.defineProperty($2af23e40017b25d9$exports, "__esModule", {
    value: true
});
var $a749e0663c54d6fc$exports = {};
"use strict";
Object.defineProperty($a749e0663c54d6fc$exports, "__esModule", {
    value: true
});
var $a749e0663c54d6fc$var$prefix = "fas";
var $a749e0663c54d6fc$var$iconName = "gear";
var $a749e0663c54d6fc$var$width = 512;
var $a749e0663c54d6fc$var$height = 512;
var $a749e0663c54d6fc$var$aliases = [
    9881,
    "cog"
];
var $a749e0663c54d6fc$var$unicode = "f013";
var $a749e0663c54d6fc$var$svgPathData = "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z";
$a749e0663c54d6fc$exports.definition = {
    prefix: $a749e0663c54d6fc$var$prefix,
    iconName: $a749e0663c54d6fc$var$iconName,
    icon: [
        $a749e0663c54d6fc$var$width,
        $a749e0663c54d6fc$var$height,
        $a749e0663c54d6fc$var$aliases,
        $a749e0663c54d6fc$var$unicode,
        $a749e0663c54d6fc$var$svgPathData
    ]
};
$a749e0663c54d6fc$exports.faGear = $a749e0663c54d6fc$exports.definition;
$a749e0663c54d6fc$exports.prefix = $a749e0663c54d6fc$var$prefix;
$a749e0663c54d6fc$exports.iconName = $a749e0663c54d6fc$var$iconName;
$a749e0663c54d6fc$exports.width = $a749e0663c54d6fc$var$width;
$a749e0663c54d6fc$exports.height = $a749e0663c54d6fc$var$height;
$a749e0663c54d6fc$exports.ligatures = $a749e0663c54d6fc$var$aliases;
$a749e0663c54d6fc$exports.unicode = $a749e0663c54d6fc$var$unicode;
$a749e0663c54d6fc$exports.svgPathData = $a749e0663c54d6fc$var$svgPathData;
$a749e0663c54d6fc$exports.aliases = $a749e0663c54d6fc$var$aliases;


$2af23e40017b25d9$exports.definition = {
    prefix: $a749e0663c54d6fc$exports.prefix,
    iconName: $a749e0663c54d6fc$exports.iconName,
    icon: [
        $a749e0663c54d6fc$exports.width,
        $a749e0663c54d6fc$exports.height,
        $a749e0663c54d6fc$exports.aliases,
        $a749e0663c54d6fc$exports.unicode,
        $a749e0663c54d6fc$exports.svgPathData
    ]
};
$2af23e40017b25d9$exports.faCog = $2af23e40017b25d9$exports.definition;
$2af23e40017b25d9$exports.prefix = $a749e0663c54d6fc$exports.prefix;
$2af23e40017b25d9$exports.iconName = $a749e0663c54d6fc$exports.iconName;
$2af23e40017b25d9$exports.width = $a749e0663c54d6fc$exports.width;
$2af23e40017b25d9$exports.height = $a749e0663c54d6fc$exports.height;
$2af23e40017b25d9$exports.ligatures = $a749e0663c54d6fc$exports.aliases;
$2af23e40017b25d9$exports.unicode = $a749e0663c54d6fc$exports.unicode;
$2af23e40017b25d9$exports.svgPathData = $a749e0663c54d6fc$exports.svgPathData;
$2af23e40017b25d9$exports.aliases = $a749e0663c54d6fc$exports.aliases;


var $9e163d018ad3ce2a$exports = {};
"use strict";
Object.defineProperty($9e163d018ad3ce2a$exports, "__esModule", {
    value: true
});
var $9e163d018ad3ce2a$var$prefix = "fas";
var $9e163d018ad3ce2a$var$iconName = "copy";
var $9e163d018ad3ce2a$var$width = 448;
var $9e163d018ad3ce2a$var$height = 512;
var $9e163d018ad3ce2a$var$aliases = [];
var $9e163d018ad3ce2a$var$unicode = "f0c5";
var $9e163d018ad3ce2a$var$svgPathData = "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z";
$9e163d018ad3ce2a$exports.definition = {
    prefix: $9e163d018ad3ce2a$var$prefix,
    iconName: $9e163d018ad3ce2a$var$iconName,
    icon: [
        $9e163d018ad3ce2a$var$width,
        $9e163d018ad3ce2a$var$height,
        $9e163d018ad3ce2a$var$aliases,
        $9e163d018ad3ce2a$var$unicode,
        $9e163d018ad3ce2a$var$svgPathData
    ]
};
$9e163d018ad3ce2a$exports.faCopy = $9e163d018ad3ce2a$exports.definition;
$9e163d018ad3ce2a$exports.prefix = $9e163d018ad3ce2a$var$prefix;
$9e163d018ad3ce2a$exports.iconName = $9e163d018ad3ce2a$var$iconName;
$9e163d018ad3ce2a$exports.width = $9e163d018ad3ce2a$var$width;
$9e163d018ad3ce2a$exports.height = $9e163d018ad3ce2a$var$height;
$9e163d018ad3ce2a$exports.ligatures = $9e163d018ad3ce2a$var$aliases;
$9e163d018ad3ce2a$exports.unicode = $9e163d018ad3ce2a$var$unicode;
$9e163d018ad3ce2a$exports.svgPathData = $9e163d018ad3ce2a$var$svgPathData;
$9e163d018ad3ce2a$exports.aliases = $9e163d018ad3ce2a$var$aliases;


var $9ba76af6c08a1d33$exports = {};
"use strict";
Object.defineProperty($9ba76af6c08a1d33$exports, "__esModule", {
    value: true
});
var $9ba76af6c08a1d33$var$prefix = "fas";
var $9ba76af6c08a1d33$var$iconName = "envelope";
var $9ba76af6c08a1d33$var$width = 512;
var $9ba76af6c08a1d33$var$height = 512;
var $9ba76af6c08a1d33$var$aliases = [
    128386,
    9993,
    61443
];
var $9ba76af6c08a1d33$var$unicode = "f0e0";
var $9ba76af6c08a1d33$var$svgPathData = "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z";
$9ba76af6c08a1d33$exports.definition = {
    prefix: $9ba76af6c08a1d33$var$prefix,
    iconName: $9ba76af6c08a1d33$var$iconName,
    icon: [
        $9ba76af6c08a1d33$var$width,
        $9ba76af6c08a1d33$var$height,
        $9ba76af6c08a1d33$var$aliases,
        $9ba76af6c08a1d33$var$unicode,
        $9ba76af6c08a1d33$var$svgPathData
    ]
};
$9ba76af6c08a1d33$exports.faEnvelope = $9ba76af6c08a1d33$exports.definition;
$9ba76af6c08a1d33$exports.prefix = $9ba76af6c08a1d33$var$prefix;
$9ba76af6c08a1d33$exports.iconName = $9ba76af6c08a1d33$var$iconName;
$9ba76af6c08a1d33$exports.width = $9ba76af6c08a1d33$var$width;
$9ba76af6c08a1d33$exports.height = $9ba76af6c08a1d33$var$height;
$9ba76af6c08a1d33$exports.ligatures = $9ba76af6c08a1d33$var$aliases;
$9ba76af6c08a1d33$exports.unicode = $9ba76af6c08a1d33$var$unicode;
$9ba76af6c08a1d33$exports.svgPathData = $9ba76af6c08a1d33$var$svgPathData;
$9ba76af6c08a1d33$exports.aliases = $9ba76af6c08a1d33$var$aliases;


var $4f6e76a0ad832aa1$exports = {};
"use strict";
Object.defineProperty($4f6e76a0ad832aa1$exports, "__esModule", {
    value: true
});
var $1005239a8ed8fecd$exports = {};
"use strict";
Object.defineProperty($1005239a8ed8fecd$exports, "__esModule", {
    value: true
});
var $1005239a8ed8fecd$var$prefix = "fas";
var $1005239a8ed8fecd$var$iconName = "up-right-from-square";
var $1005239a8ed8fecd$var$width = 512;
var $1005239a8ed8fecd$var$height = 512;
var $1005239a8ed8fecd$var$aliases = [
    "external-link-alt"
];
var $1005239a8ed8fecd$var$unicode = "f35d";
var $1005239a8ed8fecd$var$svgPathData = "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z";
$1005239a8ed8fecd$exports.definition = {
    prefix: $1005239a8ed8fecd$var$prefix,
    iconName: $1005239a8ed8fecd$var$iconName,
    icon: [
        $1005239a8ed8fecd$var$width,
        $1005239a8ed8fecd$var$height,
        $1005239a8ed8fecd$var$aliases,
        $1005239a8ed8fecd$var$unicode,
        $1005239a8ed8fecd$var$svgPathData
    ]
};
$1005239a8ed8fecd$exports.faUpRightFromSquare = $1005239a8ed8fecd$exports.definition;
$1005239a8ed8fecd$exports.prefix = $1005239a8ed8fecd$var$prefix;
$1005239a8ed8fecd$exports.iconName = $1005239a8ed8fecd$var$iconName;
$1005239a8ed8fecd$exports.width = $1005239a8ed8fecd$var$width;
$1005239a8ed8fecd$exports.height = $1005239a8ed8fecd$var$height;
$1005239a8ed8fecd$exports.ligatures = $1005239a8ed8fecd$var$aliases;
$1005239a8ed8fecd$exports.unicode = $1005239a8ed8fecd$var$unicode;
$1005239a8ed8fecd$exports.svgPathData = $1005239a8ed8fecd$var$svgPathData;
$1005239a8ed8fecd$exports.aliases = $1005239a8ed8fecd$var$aliases;


$4f6e76a0ad832aa1$exports.definition = {
    prefix: $1005239a8ed8fecd$exports.prefix,
    iconName: $1005239a8ed8fecd$exports.iconName,
    icon: [
        $1005239a8ed8fecd$exports.width,
        $1005239a8ed8fecd$exports.height,
        $1005239a8ed8fecd$exports.aliases,
        $1005239a8ed8fecd$exports.unicode,
        $1005239a8ed8fecd$exports.svgPathData
    ]
};
$4f6e76a0ad832aa1$exports.faExternalLinkAlt = $4f6e76a0ad832aa1$exports.definition;
$4f6e76a0ad832aa1$exports.prefix = $1005239a8ed8fecd$exports.prefix;
$4f6e76a0ad832aa1$exports.iconName = $1005239a8ed8fecd$exports.iconName;
$4f6e76a0ad832aa1$exports.width = $1005239a8ed8fecd$exports.width;
$4f6e76a0ad832aa1$exports.height = $1005239a8ed8fecd$exports.height;
$4f6e76a0ad832aa1$exports.ligatures = $1005239a8ed8fecd$exports.aliases;
$4f6e76a0ad832aa1$exports.unicode = $1005239a8ed8fecd$exports.unicode;
$4f6e76a0ad832aa1$exports.svgPathData = $1005239a8ed8fecd$exports.svgPathData;
$4f6e76a0ad832aa1$exports.aliases = $1005239a8ed8fecd$exports.aliases;


var $c4ec402fabc5b4fe$exports = {};
"use strict";
Object.defineProperty($c4ec402fabc5b4fe$exports, "__esModule", {
    value: true
});
var $c4ec402fabc5b4fe$var$prefix = "fas";
var $c4ec402fabc5b4fe$var$iconName = "key";
var $c4ec402fabc5b4fe$var$width = 512;
var $c4ec402fabc5b4fe$var$height = 512;
var $c4ec402fabc5b4fe$var$aliases = [
    128273
];
var $c4ec402fabc5b4fe$var$unicode = "f084";
var $c4ec402fabc5b4fe$var$svgPathData = "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z";
$c4ec402fabc5b4fe$exports.definition = {
    prefix: $c4ec402fabc5b4fe$var$prefix,
    iconName: $c4ec402fabc5b4fe$var$iconName,
    icon: [
        $c4ec402fabc5b4fe$var$width,
        $c4ec402fabc5b4fe$var$height,
        $c4ec402fabc5b4fe$var$aliases,
        $c4ec402fabc5b4fe$var$unicode,
        $c4ec402fabc5b4fe$var$svgPathData
    ]
};
$c4ec402fabc5b4fe$exports.faKey = $c4ec402fabc5b4fe$exports.definition;
$c4ec402fabc5b4fe$exports.prefix = $c4ec402fabc5b4fe$var$prefix;
$c4ec402fabc5b4fe$exports.iconName = $c4ec402fabc5b4fe$var$iconName;
$c4ec402fabc5b4fe$exports.width = $c4ec402fabc5b4fe$var$width;
$c4ec402fabc5b4fe$exports.height = $c4ec402fabc5b4fe$var$height;
$c4ec402fabc5b4fe$exports.ligatures = $c4ec402fabc5b4fe$var$aliases;
$c4ec402fabc5b4fe$exports.unicode = $c4ec402fabc5b4fe$var$unicode;
$c4ec402fabc5b4fe$exports.svgPathData = $c4ec402fabc5b4fe$var$svgPathData;
$c4ec402fabc5b4fe$exports.aliases = $c4ec402fabc5b4fe$var$aliases;


var $83e399a08305a885$exports = {};
"use strict";
Object.defineProperty($83e399a08305a885$exports, "__esModule", {
    value: true
});
var $28e5ea3492a10643$exports = {};
"use strict";
Object.defineProperty($28e5ea3492a10643$exports, "__esModule", {
    value: true
});
var $28e5ea3492a10643$var$prefix = "fas";
var $28e5ea3492a10643$var$iconName = "magnifying-glass";
var $28e5ea3492a10643$var$width = 512;
var $28e5ea3492a10643$var$height = 512;
var $28e5ea3492a10643$var$aliases = [
    128269,
    "search"
];
var $28e5ea3492a10643$var$unicode = "f002";
var $28e5ea3492a10643$var$svgPathData = "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z";
$28e5ea3492a10643$exports.definition = {
    prefix: $28e5ea3492a10643$var$prefix,
    iconName: $28e5ea3492a10643$var$iconName,
    icon: [
        $28e5ea3492a10643$var$width,
        $28e5ea3492a10643$var$height,
        $28e5ea3492a10643$var$aliases,
        $28e5ea3492a10643$var$unicode,
        $28e5ea3492a10643$var$svgPathData
    ]
};
$28e5ea3492a10643$exports.faMagnifyingGlass = $28e5ea3492a10643$exports.definition;
$28e5ea3492a10643$exports.prefix = $28e5ea3492a10643$var$prefix;
$28e5ea3492a10643$exports.iconName = $28e5ea3492a10643$var$iconName;
$28e5ea3492a10643$exports.width = $28e5ea3492a10643$var$width;
$28e5ea3492a10643$exports.height = $28e5ea3492a10643$var$height;
$28e5ea3492a10643$exports.ligatures = $28e5ea3492a10643$var$aliases;
$28e5ea3492a10643$exports.unicode = $28e5ea3492a10643$var$unicode;
$28e5ea3492a10643$exports.svgPathData = $28e5ea3492a10643$var$svgPathData;
$28e5ea3492a10643$exports.aliases = $28e5ea3492a10643$var$aliases;


$83e399a08305a885$exports.definition = {
    prefix: $28e5ea3492a10643$exports.prefix,
    iconName: $28e5ea3492a10643$exports.iconName,
    icon: [
        $28e5ea3492a10643$exports.width,
        $28e5ea3492a10643$exports.height,
        $28e5ea3492a10643$exports.aliases,
        $28e5ea3492a10643$exports.unicode,
        $28e5ea3492a10643$exports.svgPathData
    ]
};
$83e399a08305a885$exports.faSearch = $83e399a08305a885$exports.definition;
$83e399a08305a885$exports.prefix = $28e5ea3492a10643$exports.prefix;
$83e399a08305a885$exports.iconName = $28e5ea3492a10643$exports.iconName;
$83e399a08305a885$exports.width = $28e5ea3492a10643$exports.width;
$83e399a08305a885$exports.height = $28e5ea3492a10643$exports.height;
$83e399a08305a885$exports.ligatures = $28e5ea3492a10643$exports.aliases;
$83e399a08305a885$exports.unicode = $28e5ea3492a10643$exports.unicode;
$83e399a08305a885$exports.svgPathData = $28e5ea3492a10643$exports.svgPathData;
$83e399a08305a885$exports.aliases = $28e5ea3492a10643$exports.aliases;


var $1788f2b1ea8f3501$exports = {};
"use strict";
Object.defineProperty($1788f2b1ea8f3501$exports, "__esModule", {
    value: true
});
var $482cf6497b419ab9$exports = {};
"use strict";
Object.defineProperty($482cf6497b419ab9$exports, "__esModule", {
    value: true
});
var $482cf6497b419ab9$var$prefix = "fas";
var $482cf6497b419ab9$var$iconName = "share-nodes";
var $482cf6497b419ab9$var$width = 448;
var $482cf6497b419ab9$var$height = 512;
var $482cf6497b419ab9$var$aliases = [
    "share-alt"
];
var $482cf6497b419ab9$var$unicode = "f1e0";
var $482cf6497b419ab9$var$svgPathData = "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z";
$482cf6497b419ab9$exports.definition = {
    prefix: $482cf6497b419ab9$var$prefix,
    iconName: $482cf6497b419ab9$var$iconName,
    icon: [
        $482cf6497b419ab9$var$width,
        $482cf6497b419ab9$var$height,
        $482cf6497b419ab9$var$aliases,
        $482cf6497b419ab9$var$unicode,
        $482cf6497b419ab9$var$svgPathData
    ]
};
$482cf6497b419ab9$exports.faShareNodes = $482cf6497b419ab9$exports.definition;
$482cf6497b419ab9$exports.prefix = $482cf6497b419ab9$var$prefix;
$482cf6497b419ab9$exports.iconName = $482cf6497b419ab9$var$iconName;
$482cf6497b419ab9$exports.width = $482cf6497b419ab9$var$width;
$482cf6497b419ab9$exports.height = $482cf6497b419ab9$var$height;
$482cf6497b419ab9$exports.ligatures = $482cf6497b419ab9$var$aliases;
$482cf6497b419ab9$exports.unicode = $482cf6497b419ab9$var$unicode;
$482cf6497b419ab9$exports.svgPathData = $482cf6497b419ab9$var$svgPathData;
$482cf6497b419ab9$exports.aliases = $482cf6497b419ab9$var$aliases;


$1788f2b1ea8f3501$exports.definition = {
    prefix: $482cf6497b419ab9$exports.prefix,
    iconName: $482cf6497b419ab9$exports.iconName,
    icon: [
        $482cf6497b419ab9$exports.width,
        $482cf6497b419ab9$exports.height,
        $482cf6497b419ab9$exports.aliases,
        $482cf6497b419ab9$exports.unicode,
        $482cf6497b419ab9$exports.svgPathData
    ]
};
$1788f2b1ea8f3501$exports.faShareAlt = $1788f2b1ea8f3501$exports.definition;
$1788f2b1ea8f3501$exports.prefix = $482cf6497b419ab9$exports.prefix;
$1788f2b1ea8f3501$exports.iconName = $482cf6497b419ab9$exports.iconName;
$1788f2b1ea8f3501$exports.width = $482cf6497b419ab9$exports.width;
$1788f2b1ea8f3501$exports.height = $482cf6497b419ab9$exports.height;
$1788f2b1ea8f3501$exports.ligatures = $482cf6497b419ab9$exports.aliases;
$1788f2b1ea8f3501$exports.unicode = $482cf6497b419ab9$exports.unicode;
$1788f2b1ea8f3501$exports.svgPathData = $482cf6497b419ab9$exports.svgPathData;
$1788f2b1ea8f3501$exports.aliases = $482cf6497b419ab9$exports.aliases;


var $7ab16ab4e5fbaa94$exports = {};
"use strict";
Object.defineProperty($7ab16ab4e5fbaa94$exports, "__esModule", {
    value: true
});
var $92a7526ef4732e2b$exports = {};
"use strict";
Object.defineProperty($92a7526ef4732e2b$exports, "__esModule", {
    value: true
});
var $92a7526ef4732e2b$var$prefix = "fas";
var $92a7526ef4732e2b$var$iconName = "right-from-bracket";
var $92a7526ef4732e2b$var$width = 512;
var $92a7526ef4732e2b$var$height = 512;
var $92a7526ef4732e2b$var$aliases = [
    "sign-out-alt"
];
var $92a7526ef4732e2b$var$unicode = "f2f5";
var $92a7526ef4732e2b$var$svgPathData = "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z";
$92a7526ef4732e2b$exports.definition = {
    prefix: $92a7526ef4732e2b$var$prefix,
    iconName: $92a7526ef4732e2b$var$iconName,
    icon: [
        $92a7526ef4732e2b$var$width,
        $92a7526ef4732e2b$var$height,
        $92a7526ef4732e2b$var$aliases,
        $92a7526ef4732e2b$var$unicode,
        $92a7526ef4732e2b$var$svgPathData
    ]
};
$92a7526ef4732e2b$exports.faRightFromBracket = $92a7526ef4732e2b$exports.definition;
$92a7526ef4732e2b$exports.prefix = $92a7526ef4732e2b$var$prefix;
$92a7526ef4732e2b$exports.iconName = $92a7526ef4732e2b$var$iconName;
$92a7526ef4732e2b$exports.width = $92a7526ef4732e2b$var$width;
$92a7526ef4732e2b$exports.height = $92a7526ef4732e2b$var$height;
$92a7526ef4732e2b$exports.ligatures = $92a7526ef4732e2b$var$aliases;
$92a7526ef4732e2b$exports.unicode = $92a7526ef4732e2b$var$unicode;
$92a7526ef4732e2b$exports.svgPathData = $92a7526ef4732e2b$var$svgPathData;
$92a7526ef4732e2b$exports.aliases = $92a7526ef4732e2b$var$aliases;


$7ab16ab4e5fbaa94$exports.definition = {
    prefix: $92a7526ef4732e2b$exports.prefix,
    iconName: $92a7526ef4732e2b$exports.iconName,
    icon: [
        $92a7526ef4732e2b$exports.width,
        $92a7526ef4732e2b$exports.height,
        $92a7526ef4732e2b$exports.aliases,
        $92a7526ef4732e2b$exports.unicode,
        $92a7526ef4732e2b$exports.svgPathData
    ]
};
$7ab16ab4e5fbaa94$exports.faSignOutAlt = $7ab16ab4e5fbaa94$exports.definition;
$7ab16ab4e5fbaa94$exports.prefix = $92a7526ef4732e2b$exports.prefix;
$7ab16ab4e5fbaa94$exports.iconName = $92a7526ef4732e2b$exports.iconName;
$7ab16ab4e5fbaa94$exports.width = $92a7526ef4732e2b$exports.width;
$7ab16ab4e5fbaa94$exports.height = $92a7526ef4732e2b$exports.height;
$7ab16ab4e5fbaa94$exports.ligatures = $92a7526ef4732e2b$exports.aliases;
$7ab16ab4e5fbaa94$exports.unicode = $92a7526ef4732e2b$exports.unicode;
$7ab16ab4e5fbaa94$exports.svgPathData = $92a7526ef4732e2b$exports.svgPathData;
$7ab16ab4e5fbaa94$exports.aliases = $92a7526ef4732e2b$exports.aliases;


var $f7bce8bbcf358cf9$exports = {};
"use strict";
Object.defineProperty($f7bce8bbcf358cf9$exports, "__esModule", {
    value: true
});
var $f7bce8bbcf358cf9$var$prefix = "fas";
var $f7bce8bbcf358cf9$var$iconName = "slash";
var $f7bce8bbcf358cf9$var$width = 640;
var $f7bce8bbcf358cf9$var$height = 512;
var $f7bce8bbcf358cf9$var$aliases = [];
var $f7bce8bbcf358cf9$var$unicode = "f715";
var $f7bce8bbcf358cf9$var$svgPathData = "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z";
$f7bce8bbcf358cf9$exports.definition = {
    prefix: $f7bce8bbcf358cf9$var$prefix,
    iconName: $f7bce8bbcf358cf9$var$iconName,
    icon: [
        $f7bce8bbcf358cf9$var$width,
        $f7bce8bbcf358cf9$var$height,
        $f7bce8bbcf358cf9$var$aliases,
        $f7bce8bbcf358cf9$var$unicode,
        $f7bce8bbcf358cf9$var$svgPathData
    ]
};
$f7bce8bbcf358cf9$exports.faSlash = $f7bce8bbcf358cf9$exports.definition;
$f7bce8bbcf358cf9$exports.prefix = $f7bce8bbcf358cf9$var$prefix;
$f7bce8bbcf358cf9$exports.iconName = $f7bce8bbcf358cf9$var$iconName;
$f7bce8bbcf358cf9$exports.width = $f7bce8bbcf358cf9$var$width;
$f7bce8bbcf358cf9$exports.height = $f7bce8bbcf358cf9$var$height;
$f7bce8bbcf358cf9$exports.ligatures = $f7bce8bbcf358cf9$var$aliases;
$f7bce8bbcf358cf9$exports.unicode = $f7bce8bbcf358cf9$var$unicode;
$f7bce8bbcf358cf9$exports.svgPathData = $f7bce8bbcf358cf9$var$svgPathData;
$f7bce8bbcf358cf9$exports.aliases = $f7bce8bbcf358cf9$var$aliases;


var $16a4fe33ccdf2ed7$exports = {};
"use strict";
Object.defineProperty($16a4fe33ccdf2ed7$exports, "__esModule", {
    value: true
});
var $16a4fe33ccdf2ed7$var$prefix = "fas";
var $16a4fe33ccdf2ed7$var$iconName = "spinner";
var $16a4fe33ccdf2ed7$var$width = 512;
var $16a4fe33ccdf2ed7$var$height = 512;
var $16a4fe33ccdf2ed7$var$aliases = [];
var $16a4fe33ccdf2ed7$var$unicode = "f110";
var $16a4fe33ccdf2ed7$var$svgPathData = "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z";
$16a4fe33ccdf2ed7$exports.definition = {
    prefix: $16a4fe33ccdf2ed7$var$prefix,
    iconName: $16a4fe33ccdf2ed7$var$iconName,
    icon: [
        $16a4fe33ccdf2ed7$var$width,
        $16a4fe33ccdf2ed7$var$height,
        $16a4fe33ccdf2ed7$var$aliases,
        $16a4fe33ccdf2ed7$var$unicode,
        $16a4fe33ccdf2ed7$var$svgPathData
    ]
};
$16a4fe33ccdf2ed7$exports.faSpinner = $16a4fe33ccdf2ed7$exports.definition;
$16a4fe33ccdf2ed7$exports.prefix = $16a4fe33ccdf2ed7$var$prefix;
$16a4fe33ccdf2ed7$exports.iconName = $16a4fe33ccdf2ed7$var$iconName;
$16a4fe33ccdf2ed7$exports.width = $16a4fe33ccdf2ed7$var$width;
$16a4fe33ccdf2ed7$exports.height = $16a4fe33ccdf2ed7$var$height;
$16a4fe33ccdf2ed7$exports.ligatures = $16a4fe33ccdf2ed7$var$aliases;
$16a4fe33ccdf2ed7$exports.unicode = $16a4fe33ccdf2ed7$var$unicode;
$16a4fe33ccdf2ed7$exports.svgPathData = $16a4fe33ccdf2ed7$var$svgPathData;
$16a4fe33ccdf2ed7$exports.aliases = $16a4fe33ccdf2ed7$var$aliases;


var $2d6ef9374862f0b1$exports = {};
"use strict";
Object.defineProperty($2d6ef9374862f0b1$exports, "__esModule", {
    value: true
});
var $2d6ef9374862f0b1$var$prefix = "fas";
var $2d6ef9374862f0b1$var$iconName = "star";
var $2d6ef9374862f0b1$var$width = 576;
var $2d6ef9374862f0b1$var$height = 512;
var $2d6ef9374862f0b1$var$aliases = [
    11088,
    61446
];
var $2d6ef9374862f0b1$var$unicode = "f005";
var $2d6ef9374862f0b1$var$svgPathData = "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z";
$2d6ef9374862f0b1$exports.definition = {
    prefix: $2d6ef9374862f0b1$var$prefix,
    iconName: $2d6ef9374862f0b1$var$iconName,
    icon: [
        $2d6ef9374862f0b1$var$width,
        $2d6ef9374862f0b1$var$height,
        $2d6ef9374862f0b1$var$aliases,
        $2d6ef9374862f0b1$var$unicode,
        $2d6ef9374862f0b1$var$svgPathData
    ]
};
$2d6ef9374862f0b1$exports.faStar = $2d6ef9374862f0b1$exports.definition;
$2d6ef9374862f0b1$exports.prefix = $2d6ef9374862f0b1$var$prefix;
$2d6ef9374862f0b1$exports.iconName = $2d6ef9374862f0b1$var$iconName;
$2d6ef9374862f0b1$exports.width = $2d6ef9374862f0b1$var$width;
$2d6ef9374862f0b1$exports.height = $2d6ef9374862f0b1$var$height;
$2d6ef9374862f0b1$exports.ligatures = $2d6ef9374862f0b1$var$aliases;
$2d6ef9374862f0b1$exports.unicode = $2d6ef9374862f0b1$var$unicode;
$2d6ef9374862f0b1$exports.svgPathData = $2d6ef9374862f0b1$var$svgPathData;
$2d6ef9374862f0b1$exports.aliases = $2d6ef9374862f0b1$var$aliases;


var $6a208664f359f326$exports = {};
"use strict";
Object.defineProperty($6a208664f359f326$exports, "__esModule", {
    value: true
});
var $381148eb8a7561d1$exports = {};
"use strict";
Object.defineProperty($381148eb8a7561d1$exports, "__esModule", {
    value: true
});
var $381148eb8a7561d1$var$prefix = "fas";
var $381148eb8a7561d1$var$iconName = "rotate";
var $381148eb8a7561d1$var$width = 512;
var $381148eb8a7561d1$var$height = 512;
var $381148eb8a7561d1$var$aliases = [
    128260,
    "sync-alt"
];
var $381148eb8a7561d1$var$unicode = "f2f1";
var $381148eb8a7561d1$var$svgPathData = "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z";
$381148eb8a7561d1$exports.definition = {
    prefix: $381148eb8a7561d1$var$prefix,
    iconName: $381148eb8a7561d1$var$iconName,
    icon: [
        $381148eb8a7561d1$var$width,
        $381148eb8a7561d1$var$height,
        $381148eb8a7561d1$var$aliases,
        $381148eb8a7561d1$var$unicode,
        $381148eb8a7561d1$var$svgPathData
    ]
};
$381148eb8a7561d1$exports.faRotate = $381148eb8a7561d1$exports.definition;
$381148eb8a7561d1$exports.prefix = $381148eb8a7561d1$var$prefix;
$381148eb8a7561d1$exports.iconName = $381148eb8a7561d1$var$iconName;
$381148eb8a7561d1$exports.width = $381148eb8a7561d1$var$width;
$381148eb8a7561d1$exports.height = $381148eb8a7561d1$var$height;
$381148eb8a7561d1$exports.ligatures = $381148eb8a7561d1$var$aliases;
$381148eb8a7561d1$exports.unicode = $381148eb8a7561d1$var$unicode;
$381148eb8a7561d1$exports.svgPathData = $381148eb8a7561d1$var$svgPathData;
$381148eb8a7561d1$exports.aliases = $381148eb8a7561d1$var$aliases;


$6a208664f359f326$exports.definition = {
    prefix: $381148eb8a7561d1$exports.prefix,
    iconName: $381148eb8a7561d1$exports.iconName,
    icon: [
        $381148eb8a7561d1$exports.width,
        $381148eb8a7561d1$exports.height,
        $381148eb8a7561d1$exports.aliases,
        $381148eb8a7561d1$exports.unicode,
        $381148eb8a7561d1$exports.svgPathData
    ]
};
$6a208664f359f326$exports.faSyncAlt = $6a208664f359f326$exports.definition;
$6a208664f359f326$exports.prefix = $381148eb8a7561d1$exports.prefix;
$6a208664f359f326$exports.iconName = $381148eb8a7561d1$exports.iconName;
$6a208664f359f326$exports.width = $381148eb8a7561d1$exports.width;
$6a208664f359f326$exports.height = $381148eb8a7561d1$exports.height;
$6a208664f359f326$exports.ligatures = $381148eb8a7561d1$exports.aliases;
$6a208664f359f326$exports.unicode = $381148eb8a7561d1$exports.unicode;
$6a208664f359f326$exports.svgPathData = $381148eb8a7561d1$exports.svgPathData;
$6a208664f359f326$exports.aliases = $381148eb8a7561d1$exports.aliases;


var $246a305793432a97$exports = {};
"use strict";
Object.defineProperty($246a305793432a97$exports, "__esModule", {
    value: true
});
var $e6ffc3c33e64566b$exports = {};
"use strict";
Object.defineProperty($e6ffc3c33e64566b$exports, "__esModule", {
    value: true
});
var $e6ffc3c33e64566b$var$prefix = "fas";
var $e6ffc3c33e64566b$var$iconName = "xmark";
var $e6ffc3c33e64566b$var$width = 384;
var $e6ffc3c33e64566b$var$height = 512;
var $e6ffc3c33e64566b$var$aliases = [
    128473,
    10005,
    10006,
    10060,
    215,
    "close",
    "multiply",
    "remove",
    "times"
];
var $e6ffc3c33e64566b$var$unicode = "f00d";
var $e6ffc3c33e64566b$var$svgPathData = "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z";
$e6ffc3c33e64566b$exports.definition = {
    prefix: $e6ffc3c33e64566b$var$prefix,
    iconName: $e6ffc3c33e64566b$var$iconName,
    icon: [
        $e6ffc3c33e64566b$var$width,
        $e6ffc3c33e64566b$var$height,
        $e6ffc3c33e64566b$var$aliases,
        $e6ffc3c33e64566b$var$unicode,
        $e6ffc3c33e64566b$var$svgPathData
    ]
};
$e6ffc3c33e64566b$exports.faXmark = $e6ffc3c33e64566b$exports.definition;
$e6ffc3c33e64566b$exports.prefix = $e6ffc3c33e64566b$var$prefix;
$e6ffc3c33e64566b$exports.iconName = $e6ffc3c33e64566b$var$iconName;
$e6ffc3c33e64566b$exports.width = $e6ffc3c33e64566b$var$width;
$e6ffc3c33e64566b$exports.height = $e6ffc3c33e64566b$var$height;
$e6ffc3c33e64566b$exports.ligatures = $e6ffc3c33e64566b$var$aliases;
$e6ffc3c33e64566b$exports.unicode = $e6ffc3c33e64566b$var$unicode;
$e6ffc3c33e64566b$exports.svgPathData = $e6ffc3c33e64566b$var$svgPathData;
$e6ffc3c33e64566b$exports.aliases = $e6ffc3c33e64566b$var$aliases;


$246a305793432a97$exports.definition = {
    prefix: $e6ffc3c33e64566b$exports.prefix,
    iconName: $e6ffc3c33e64566b$exports.iconName,
    icon: [
        $e6ffc3c33e64566b$exports.width,
        $e6ffc3c33e64566b$exports.height,
        $e6ffc3c33e64566b$exports.aliases,
        $e6ffc3c33e64566b$exports.unicode,
        $e6ffc3c33e64566b$exports.svgPathData
    ]
};
$246a305793432a97$exports.faTimes = $246a305793432a97$exports.definition;
$246a305793432a97$exports.prefix = $e6ffc3c33e64566b$exports.prefix;
$246a305793432a97$exports.iconName = $e6ffc3c33e64566b$exports.iconName;
$246a305793432a97$exports.width = $e6ffc3c33e64566b$exports.width;
$246a305793432a97$exports.height = $e6ffc3c33e64566b$exports.height;
$246a305793432a97$exports.ligatures = $e6ffc3c33e64566b$exports.aliases;
$246a305793432a97$exports.unicode = $e6ffc3c33e64566b$exports.unicode;
$246a305793432a97$exports.svgPathData = $e6ffc3c33e64566b$exports.svgPathData;
$246a305793432a97$exports.aliases = $e6ffc3c33e64566b$exports.aliases;


var $9abdfe45332a1725$exports = {};
"use strict";
Object.defineProperty($9abdfe45332a1725$exports, "__esModule", {
    value: true
});
var $9abdfe45332a1725$var$prefix = "fas";
var $9abdfe45332a1725$var$iconName = "wifi";
var $9abdfe45332a1725$var$width = 640;
var $9abdfe45332a1725$var$height = 512;
var $9abdfe45332a1725$var$aliases = [
    "wifi-3",
    "wifi-strong"
];
var $9abdfe45332a1725$var$unicode = "f1eb";
var $9abdfe45332a1725$var$svgPathData = "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z";
$9abdfe45332a1725$exports.definition = {
    prefix: $9abdfe45332a1725$var$prefix,
    iconName: $9abdfe45332a1725$var$iconName,
    icon: [
        $9abdfe45332a1725$var$width,
        $9abdfe45332a1725$var$height,
        $9abdfe45332a1725$var$aliases,
        $9abdfe45332a1725$var$unicode,
        $9abdfe45332a1725$var$svgPathData
    ]
};
$9abdfe45332a1725$exports.faWifi = $9abdfe45332a1725$exports.definition;
$9abdfe45332a1725$exports.prefix = $9abdfe45332a1725$var$prefix;
$9abdfe45332a1725$exports.iconName = $9abdfe45332a1725$var$iconName;
$9abdfe45332a1725$exports.width = $9abdfe45332a1725$var$width;
$9abdfe45332a1725$exports.height = $9abdfe45332a1725$var$height;
$9abdfe45332a1725$exports.ligatures = $9abdfe45332a1725$var$aliases;
$9abdfe45332a1725$exports.unicode = $9abdfe45332a1725$var$unicode;
$9abdfe45332a1725$exports.svgPathData = $9abdfe45332a1725$var$svgPathData;
$9abdfe45332a1725$exports.aliases = $9abdfe45332a1725$var$aliases;


var $82bc0658f9dcb3c7$export$2e2bcd8739ae039 = [
    124.155,
    133.529,
    [],
    null,
    // wallabag.svg: Free Art License 1.3 https://github.com/wallabag/logo
    "M108.69.004c-.241-.026-.512.083-.777.299-.572.465-5.551 1.614-8.504 3.917-4.768 3.72-7.707 10.796-9.04 14.708-.024.06-.205.603-.265.79-.62 1.499-1.857 1.495-1.857 1.495v.002c-.6-.065-1.202-.102-1.809-.102-.54 0-1.078.03-1.615.082-.012.002-.02 0-.031 0-1.581.233-2.451-1.696-2.633-2.156C80.312 13.735 75.342 3.277 64.174.463c0 0-2.028-1.554-1.41 1.074.588 2.51 1.805 5.048 1.535 8.74-.124 1.704-1.18 10.442 6.85 14.99.763.432 1.44.796 2.05 1.102-4.041 3.235-7.715 7.739-10.858 12.852 1.597-.981 10.206-5.557 24.097.177 14.29 5.897 23.155.777 24.254.08-3.454-5.678-7.561-10.62-12.103-13.943.303-.083.612-.168.939-.264 6.023-1.742 7.553-6.84 7.875-11.209.364-4.954.615-5.029 1.691-9.486.774-3.21.32-4.495-.404-4.572zM86.774 50.228a4.677 4.677 0 00-1.652.256 6.555 6.555 0 00-1.332.615 3.879 3.879 0 00-1.094.985c-.322.432-.486.901-.486 1.396v16.307c0 2.158-.362 3.75-1.078 4.73-.688.94-1.85 1.397-3.55 1.397-1.704 0-2.876-.46-3.583-1.402-.734-.98-1.108-2.57-1.108-4.725V53.73c0-.908-.383-1.727-1.144-2.437-.751-.702-1.75-1.059-2.973-1.059-1.258 0-2.297.352-3.086 1.045-.81.71-1.22 1.536-1.22 2.451v15.807c0 1.988.193 3.869.574 5.588.393 1.758 1.077 3.3 2.035 4.586.968 1.299 2.282 2.322 3.906 3.049 1.607.716 3.617 1.08 5.975 1.08 2.457 0 4.515-.457 6.115-1.356a10.678 10.678 0 003.371-2.95 10.256 10.256 0 003.295 2.95c1.58.9 3.669 1.354 6.21 1.354 2.358 0 4.358-.363 5.946-1.08 1.601-.726 2.903-1.752 3.873-3.05.96-1.29 1.644-2.832 2.033-4.585.381-1.72.577-3.6.577-5.588V53.73c0-.91-.398-1.733-1.184-2.445-.767-.697-1.82-1.05-3.121-1.05-1.181 0-2.161.356-2.912 1.058-.76.71-1.145 1.53-1.145 2.437v16.057c0 2.154-.381 3.742-1.134 4.72-.728.947-1.891 1.407-3.555 1.407-1.703 0-2.863-.458-3.549-1.397-.716-.979-1.078-2.57-1.078-4.73v-16.12c0-1.097-.501-1.997-1.45-2.597-.805-.507-1.607-.81-2.476-.842zM51.796 82.363a31.2 31.2 0 001.865 5.742c.666 3.745 1.561 12.563-2.674 20.282-3.731 6.8-22.15 16.069-49.484 10.748 0 0-1.096-.765-1.428-.135-.491.932 1.516 1.684 3.582 2.228 19.03 5.04 47.756 2.989 56.777-4.443 4.116-3.388 5.705-7.953 6.108-12.865l.002.008s.11-1.288 1.718-.32c.461.276 2.126 1.36 2.391 2.585.232 1.743.248 3.884-.652 5.383-1.287 2.144-1.302 2.45.392 3.66 1.04.742 5.289 3.865 11.2 7.416.015.01.022.02.037.028 1.25.753 2.988 2.595 2.988 2.595 2.662 3.08 8.45 9.277 10.97 8.11 1.19-.551-.05-3.033-.05-3.033s1.98 2.572 3.043 1.695c.809-.668-.473-3.23-.473-3.23s1.73 1.5 2.758.945c1.258-.68-.188-4.614-10.08-10.627-9.896-6.018-12.579-6.941-12.815-9.627 0 0-.004-.134.004-.365.077-.593.416-1.848 1.854-1.713 2.14.346 4.347.53 6.607.53 2.587 0 5.106-.236 7.535-.689l.002.002.164-.029c.284-.036.838-.019.84.67-.09.873-.331 1.752-.845 2.52-1.447 2.168-.971 2.466.54 3.859.934.859 5.212 4.622 11.07 8.264.013.009.016.016.03.023 1.25.752 3.41 2.814 3.41 2.814 2.428 2.466 6.895 6.595 9.328 6.346 1.646-.168.305-3.002.305-3.002s2.079 2.006 3.1 1.416c1.142-.659-.475-2.754-.475-2.754s1.338.708 2.283.473c.948-.236 1.187-2.643-8.654-8.736-9.842-6.098-13.154-8.244-12.947-10.577 0 0 .003-.379.1-.957.238-1.236.994-3.346 3.406-4.55.079-.04.147-.084.209-.13 7.668-4.45 13.27-11.614 15.246-20.56-1.99 4.941-16.737 8.78-34.647 8.78-17.903 0-32.65-3.839-34.64-8.78z"
];


"use strict";
const $3f033ef2cbff8b8d$export$a67558cb68d63c7e = {
    prefix: "fac",
    iconName: "wallabag",
    icon: (0, $82bc0658f9dcb3c7$export$2e2bcd8739ae039)
};


function $6efe1fd0084e29cd$export$7f7cbe89f1eacd2({ label: label, size: size }) {
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                icon: $16a4fe33ccdf2ed7$exports.faSpinner,
                size: size,
                spin: true,
                "aria-hidden": "true",
                title: label
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                className: "visually-hidden",
                role: "alert",
                children: label
            })
        ]
    });
}
$6efe1fd0084e29cd$export$7f7cbe89f1eacd2.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string
};
function $6efe1fd0084e29cd$export$84dbad74efe95918({ label: label }) {
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
        className: "spinner-big",
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($6efe1fd0084e29cd$export$7f7cbe89f1eacd2, {
            size: "10x",
            label: label
        })
    });
}
$6efe1fd0084e29cd$export$84dbad74efe95918.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string.isRequired
};





var $5NSbj = parcelRequire("5NSbj");
const $7b0908670bf0de1b$export$326f6d1b69f1c06e = /*#__PURE__*/ (0, $5NSbj.createContext)();



var $5NSbj = parcelRequire("5NSbj");
function $5211519f9db04406$export$e51161e9fbfde80e(translated, params) {
    let formatted = "";
    let curChar = undefined;
    let buffer = "";
    let state = "out";
    let placeholder = undefined;
    let plural = undefined;
    let pluralKeyword = undefined;
    let pluralValue = undefined;
    for(let i = 0, len = translated.length; i < len; i++){
        curChar = translated.charAt(i);
        switch(curChar){
            case "{":
                if (placeholder) {
                    if (state == "plural") {
                        pluralKeyword = buffer.trim();
                        if ([
                            "zero",
                            "one",
                            "other"
                        ].includes(pluralKeyword)) buffer = "";
                        else pluralKeyword = undefined;
                    }
                } else {
                    formatted = formatted + buffer;
                    buffer = "";
                    placeholder = {};
                    state = "index";
                }
                break;
            case "}":
            case ",":
                if (placeholder) {
                    if (state == "index") {
                        const index = buffer.trim();
                        const intIndex = parseInt(index);
                        placeholder.index = Number.isNaN(intIndex) ? index : intIndex;
                        placeholder.value = params[placeholder.index];
                        buffer = "";
                    } else if (state == "type") {
                        placeholder.type = buffer.trim();
                        buffer = "";
                        if (placeholder.type == "plural") {
                            plural = {};
                            state = "plural";
                        }
                    }
                    if (curChar == "}") {
                        if (state == "plural" && pluralKeyword) {
                            plural[pluralKeyword] = buffer;
                            buffer = "";
                            pluralKeyword = undefined;
                        } else if (plural) {
                            if ("zero" in plural && placeholder.value === 0) pluralValue = plural.zero;
                            else if ("one" in plural && placeholder.value == 1) pluralValue = plural.one;
                            else pluralValue = plural.other;
                            formatted = formatted + pluralValue.replace("#", placeholder.value);
                            plural = undefined;
                            placeholder = undefined;
                            state = "out";
                        } else {
                            formatted = formatted + placeholder.value;
                            placeholder = undefined;
                            state = "out";
                        }
                    } else if (curChar == "," && state == "index") state = "type";
                }
                break;
            default:
                buffer = buffer + curChar;
                break;
        }
    }
    if (state != "out") return "Error formatting '" + translated + "', bug report?";
    formatted = formatted + buffer;
    return formatted;
}
const $5211519f9db04406$export$51216bcc3983e55d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createContext();


function $8ef53a23f964ed7b$var$handleLogIn({ event: event, configuration: configuration, history: history, setLoading: setLoading, username: username, password: password, enableOffline: enableOffline, returnLocation: returnLocation }) {
    event.preventDefault();
    setLoading(true);
    selfoss.login({
        configuration: configuration,
        username: username,
        password: password,
        enableOffline: enableOffline
    }).then(()=>{
        history.push(returnLocation);
    }).catch((err)=>{
        const message = err instanceof (0, $506fdaa0545346a2$export$5e64a9683d127ef6) ? selfoss.app._("login_invalid_credentials") : selfoss.app._("login_error_generic", {
            errorMessage: err instanceof (0, $506fdaa0545346a2$export$65bd6083489bd8bb) ? `HTTP ${err.response.status} ${err.message}` : err.message
        });
        history.replace("/sign/in", {
            error: message
        });
    }).finally(()=>{
        setLoading(false);
    });
}
function $8ef53a23f964ed7b$export$2e2bcd8739ae039({ offlineEnabled: offlineEnabled }) {
    const [username, setUsername] = (0, $5NSbj.useState)("");
    const [password, setPassword] = (0, $5NSbj.useState)("");
    const [loading, setLoading] = (0, $5NSbj.useState)(false);
    const [enableOffline, setEnableOffline] = (0, $5NSbj.useState)(offlineEnabled);
    const configuration = (0, $5NSbj.useContext)((0, $7b0908670bf0de1b$export$326f6d1b69f1c06e));
    const history = (0, $88361e604f4abd56$export$3420e1dc2c4a518c)();
    const location = (0, $88361e604f4abd56$export$45d76561a5302f2b)();
    const error = location?.state?.error;
    const returnLocation = location?.state?.returnLocation ?? "/";
    const formOnSubmit = (0, $5NSbj.useCallback)((event)=>$8ef53a23f964ed7b$var$handleLogIn({
            event: event,
            configuration: configuration,
            history: history,
            setLoading: setLoading,
            username: username,
            password: password,
            enableOffline: enableOffline,
            returnLocation: returnLocation
        }), [
        configuration,
        history,
        username,
        password,
        enableOffline,
        returnLocation
    ]);
    const usernameOnChange = (0, $5NSbj.useCallback)((event)=>setUsername(event.target.value), []);
    const passwordOnChange = (0, $5NSbj.useCallback)((event)=>setPassword(event.target.value), []);
    const offlineOnChange = (0, $5NSbj.useCallback)((event)=>setEnableOffline(event.target.checked), [
        setEnableOffline
    ]);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
        children: [
            loading ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $6efe1fd0084e29cd$export$84dbad74efe95918), {
                label: _("login_in_progress")
            }) : null,
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("form", {
                action: "",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    loading: loading
                }),
                method: "post",
                onSubmit: formOnSubmit,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
                    id: "login",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("h1", {
                                children: [
                                    configuration.htmlTitle,
                                    " login"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                                    htmlFor: "username",
                                    children: _("login_username")
                                }),
                                " ",
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                                    type: "text",
                                    name: "username",
                                    id: "username",
                                    accessKey: "u",
                                    autoComplete: "username",
                                    onChange: usernameOnChange,
                                    value: username,
                                    autoFocus: true,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                                    htmlFor: "password",
                                    children: _("login_password")
                                }),
                                " ",
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                                    type: "password",
                                    name: "password",
                                    id: "password",
                                    accessKey: "p",
                                    autoComplete: "current-password",
                                    onChange: passwordOnChange,
                                    value: password
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                                    htmlFor: "enableoffline",
                                    children: _("login_offline")
                                }),
                                " ",
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                                            type: "checkbox",
                                            name: "enableoffline",
                                            id: "enableoffline",
                                            accessKey: "o",
                                            onChange: offlineOnChange,
                                            checked: enableOffline
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                            className: "badge-experimental",
                                            children: _("experimental")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            className: "error",
                            "aria-live": "assertive",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                            className: "button",
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                                    type: "submit",
                                    accessKey: "l",
                                    value: _("login")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
$8ef53a23f964ed7b$export$2e2bcd8739ae039.propTypes = {
    offlineEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired
};




var $5NSbj = parcelRequire("5NSbj");




var $5NSbj = parcelRequire("5NSbj");

var $5NSbj = parcelRequire("5NSbj");


var $5NSbj = parcelRequire("5NSbj");



var $5NSbj = parcelRequire("5NSbj");


var $5NSbj = parcelRequire("5NSbj");


const $ebbd2ea8f474cd9c$export$30c2dce1a652e248 = (state)=>!!state && state[0] === "o";
const $ebbd2ea8f474cd9c$export$3e3e6d241f8feb60 = (0, $178ae9275e33f716$exports.unstable_batchedUpdates) || ((callback)=>callback());
const $ebbd2ea8f474cd9c$export$68c286be0e7e55b7 = Object.values || ((obj)=>Object.keys(obj).map((key)=>obj[key]));
const $ebbd2ea8f474cd9c$export$de749ee021c3ab62 = (a, b, diff = 0.0001)=>Math.abs(a - b) < diff;
const $ebbd2ea8f474cd9c$export$d5639c01d489b0c = (transition, name)=>transition === true || !!(transition && transition[name]);
const $ebbd2ea8f474cd9c$export$175e60bb96229ece = (fn, arg)=>typeof fn === "function" ? fn(arg) : fn;
const $ebbd2ea8f474cd9c$var$internalKey = "_szhsinMenu";
const $ebbd2ea8f474cd9c$export$7d9f7e9c1c02b41e = (component)=>component[$ebbd2ea8f474cd9c$var$internalKey];
const $ebbd2ea8f474cd9c$export$4c4bf90f1b4d3105 = (name, component)=>Object.defineProperty(component, $ebbd2ea8f474cd9c$var$internalKey, {
        value: name
    });
const $ebbd2ea8f474cd9c$export$9d1611c77c2fe928 = (target, source)=>{
    source && Object.keys(source).forEach((key)=>{
        const targetProp = target[key];
        const sourceProp = source[key];
        if (typeof sourceProp === "function" && targetProp) target[key] = (...arg)=>{
            sourceProp(...arg);
            targetProp(...arg);
        };
        else target[key] = sourceProp;
    });
    return target;
};
const $ebbd2ea8f474cd9c$export$4bc3c325941e6f67 = (paddingStr)=>{
    if (typeof paddingStr !== "string") return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    const padding = paddingStr.trim().split(/\s+/, 4).map(parseFloat);
    const top = !isNaN(padding[0]) ? padding[0] : 0;
    const right = !isNaN(padding[1]) ? padding[1] : top;
    return {
        top: top,
        right: right,
        bottom: !isNaN(padding[2]) ? padding[2] : top,
        left: !isNaN(padding[3]) ? padding[3] : right
    };
};
const $ebbd2ea8f474cd9c$export$7414735161c19437 = (node)=>{
    while(node){
        node = node.parentNode;
        if (!node || node === document.body || !node.parentNode) return;
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = getComputedStyle(node);
        if (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)) return node;
    }
};
function $ebbd2ea8f474cd9c$export$ffb2d5922287e12(isDisabled, isHovering) {
    return {
        "aria-disabled": isDisabled || undefined,
        tabIndex: isHovering ? 0 : -1
    };
}
function $ebbd2ea8f474cd9c$export$a12bd5aaf0b59fa0(nodeList, node) {
    for(let i = 0; i < nodeList.length; i++){
        if (nodeList[i] === node) return i;
    }
    return -1;
}



var $5NSbj = parcelRequire("5NSbj");
const $570b0fb7328e20ff$export$7ae630fe844fbd1f = ({ block: block, element: element, modifiers: modifiers, className: className })=>(0, $5NSbj.useMemo)(()=>{
        const blockElement = element ? `${block}__${element}` : block;
        let classString = blockElement;
        modifiers && Object.keys(modifiers).forEach((name)=>{
            const value = modifiers[name];
            if (value) classString += ` ${blockElement}--${value === true ? name : `${name}-${value}`}`;
        });
        let expandedClassName = typeof className === "function" ? className(modifiers) : className;
        if (typeof expandedClassName === "string") {
            expandedClassName = expandedClassName.trim();
            if (expandedClassName) classString += ` ${expandedClassName}`;
        }
        return classString;
    }, [
        block,
        element,
        modifiers,
        className
    ]);



var $5NSbj = parcelRequire("5NSbj");
const $b3a633b3f550cddb$export$ccf052fa53df1929 = "szh-menu-container";
const $b3a633b3f550cddb$export$832250593589325a = "szh-menu";
const $b3a633b3f550cddb$export$b3d82f113f746a0 = "szh-menu-button";
const $b3a633b3f550cddb$export$3b35f0f35c840df9 = "arrow";
const $b3a633b3f550cddb$export$b5a3c9a9995a8c24 = "item";
const $b3a633b3f550cddb$export$10b42530e0558a83 = "divider";
const $b3a633b3f550cddb$export$29e3fcfc61abbafd = "header";
const $b3a633b3f550cddb$export$e4f8e9b9e6d790ae = "group";
const $b3a633b3f550cddb$export$3b437b9ab85faa03 = "submenu";
const $b3a633b3f550cddb$export$d6766e4ef63d0cb0 = "radio-group";
const $b3a633b3f550cddb$export$15c1690330cd94e = /*#__PURE__*/ (0, $5NSbj.createContext)();
const $b3a633b3f550cddb$export$7cb023214e4bda1e = /*#__PURE__*/ (0, $5NSbj.createContext)({});
const $b3a633b3f550cddb$export$1c2bdfb4407fdacf = /*#__PURE__*/ (0, $5NSbj.createContext)({});
const $b3a633b3f550cddb$export$ee9f2ec6c8119c2a = /*#__PURE__*/ (0, $5NSbj.createContext)({});
const $b3a633b3f550cddb$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $5NSbj.createContext)({});
const $b3a633b3f550cddb$export$8fa45c82eddfe270 = /*#__PURE__*/ (0, $5NSbj.createContext)({});
const $b3a633b3f550cddb$export$4b0075e5ea5e1f26 = /*#__PURE__*/ Object.freeze({
    ENTER: "Enter",
    ESC: "Escape",
    SPACE: " ",
    HOME: "Home",
    END: "End",
    LEFT: "ArrowLeft",
    RIGHT: "ArrowRight",
    UP: "ArrowUp",
    DOWN: "ArrowDown"
});
const $b3a633b3f550cddb$export$6db955af9e6f8fcd = /*#__PURE__*/ Object.freeze({
    RESET: 0,
    SET: 1,
    UNSET: 2,
    INCREASE: 3,
    DECREASE: 4,
    FIRST: 5,
    LAST: 6,
    SET_INDEX: 7
});
const $b3a633b3f550cddb$export$8fd8df51a9b835e6 = /*#__PURE__*/ Object.freeze({
    CLICK: "click",
    CANCEL: "cancel",
    BLUR: "blur",
    SCROLL: "scroll"
});
const $b3a633b3f550cddb$export$8c6ccba1b6ce32e9 = /*#__PURE__*/ Object.freeze({
    FIRST: "first",
    LAST: "last"
});
const $b3a633b3f550cddb$export$be1d8b0328ba66b6 = /*#__PURE__*/ Object.freeze({
    entering: "opening",
    entered: "open",
    exiting: "closing",
    exited: "closed"
});
const $b3a633b3f550cddb$export$f8d144aafbd3a470 = "absolute";
const $b3a633b3f550cddb$export$a5a9d7469a9cc520 = "presentation";
const $b3a633b3f550cddb$export$3e982710469daaf = "menuitem";
const $b3a633b3f550cddb$export$988a172bcdaead26 = {
    "aria-hidden": true,
    role: $b3a633b3f550cddb$export$3e982710469daaf
};


const $e8bd578383d21cff$export$b286f91cddfedb5a = ({ className: className, containerRef: containerRef, containerProps: containerProps, children: children, isOpen: isOpen, theming: theming, transition: transition, onClose: onClose })=>{
    const itemTransition = (0, $ebbd2ea8f474cd9c$export$d5639c01d489b0c)(transition, "item");
    const onKeyDown = ({ key: key })=>{
        switch(key){
            case (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).ESC:
                (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(onClose, {
                    key: key,
                    reason: (0, $b3a633b3f550cddb$export$8fd8df51a9b835e6).CANCEL
                });
                break;
        }
    };
    const onBlur = (e)=>{
        if (isOpen && !e.currentTarget.contains(e.relatedTarget)) (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(onClose, {
            reason: (0, $b3a633b3f550cddb$export$8fd8df51a9b835e6).BLUR
        });
    };
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
        ...(0, $ebbd2ea8f474cd9c$export$9d1611c77c2fe928)({
            onKeyDown: onKeyDown,
            onBlur: onBlur
        }, containerProps),
        className: (0, $570b0fb7328e20ff$export$7ae630fe844fbd1f)({
            block: (0, $b3a633b3f550cddb$export$ccf052fa53df1929),
            modifiers: (0, $5NSbj.useMemo)(()=>({
                    theme: theming,
                    itemTransition: itemTransition
                }), [
                theming,
                itemTransition
            ]),
            className: className
        }),
        style: {
            position: "absolute",
            ...containerProps == null ? void 0 : containerProps.style
        },
        ref: containerRef,
        children: children
    });
};



const $e3629dd4bb589715$export$fd76cd1ffdc0d698 = ()=>{
    let timer, count = 0;
    return {
        toggle: (isOpen)=>{
            isOpen ? count++ : count--;
            count = Math.max(count, 0);
        },
        on: (closeDelay, pending, settled)=>{
            if (count) {
                if (!timer) timer = setTimeout(()=>{
                    timer = 0;
                    pending();
                }, closeDelay);
            } else settled == null || settled();
        },
        off: ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = 0;
            }
        }
    };
};




var $5NSbj = parcelRequire("5NSbj");


const $e5337538acbea236$export$7bfdd97581ca93c = (menuRef, focusRef)=>{
    const [hoverItem, setHoverItem] = (0, $5NSbj.useState)();
    const stateRef = (0, $5NSbj.useRef)({
        items: [],
        hoverIndex: -1,
        sorted: false
    });
    const mutableState = stateRef.current;
    const updateItems = (0, $5NSbj.useCallback)((item, isMounted)=>{
        const { items: items } = mutableState;
        if (!item) mutableState.items = [];
        else if (isMounted) items.push(item);
        else {
            const index = items.indexOf(item);
            if (index > -1) {
                items.splice(index, 1);
                if (item.contains(document.activeElement)) {
                    focusRef.current.focus();
                    setHoverItem();
                }
            }
        }
        mutableState.hoverIndex = -1;
        mutableState.sorted = false;
    }, [
        mutableState,
        focusRef
    ]);
    const dispatch = (0, $5NSbj.useCallback)((actionType, item, nextIndex)=>{
        const { items: items, hoverIndex: hoverIndex } = mutableState;
        const sortItems = ()=>{
            if (mutableState.sorted) return;
            const orderedNodes = menuRef.current.querySelectorAll(".szh-menu__item");
            items.sort((a, b)=>(0, $ebbd2ea8f474cd9c$export$a12bd5aaf0b59fa0)(orderedNodes, a) - (0, $ebbd2ea8f474cd9c$export$a12bd5aaf0b59fa0)(orderedNodes, b));
            mutableState.sorted = true;
        };
        let index = -1, newItem = undefined;
        switch(actionType){
            case (0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).RESET:
                break;
            case (0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).SET:
                newItem = item;
                break;
            case (0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).UNSET:
                newItem = (prevItem)=>prevItem === item ? undefined : prevItem;
                break;
            case (0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).FIRST:
                sortItems();
                index = 0;
                newItem = items[index];
                break;
            case (0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).LAST:
                sortItems();
                index = items.length - 1;
                newItem = items[index];
                break;
            case (0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).SET_INDEX:
                sortItems();
                index = nextIndex;
                newItem = items[index];
                break;
            case (0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).INCREASE:
                sortItems();
                index = hoverIndex;
                if (index < 0) index = items.indexOf(item);
                index++;
                if (index >= items.length) index = 0;
                newItem = items[index];
                break;
            case (0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).DECREASE:
                sortItems();
                index = hoverIndex;
                if (index < 0) index = items.indexOf(item);
                index--;
                if (index < 0) index = items.length - 1;
                newItem = items[index];
                break;
            default:
        }
        if (!newItem) index = -1;
        setHoverItem(newItem);
        mutableState.hoverIndex = index;
    }, [
        menuRef,
        mutableState
    ]);
    return {
        hoverItem: hoverItem,
        dispatch: dispatch,
        updateItems: updateItems
    };
};




const $27e968aa7dd55770$export$62e2806a96b09d4 = (containerRef, menuRef, menuScroll, boundingBoxPadding)=>{
    const menuRect = menuRef.current.getBoundingClientRect();
    const containerRect = containerRef.current.getBoundingClientRect();
    const boundingRect = menuScroll === window ? {
        left: 0,
        top: 0,
        right: document.documentElement.clientWidth,
        bottom: window.innerHeight
    } : menuScroll.getBoundingClientRect();
    const padding = (0, $ebbd2ea8f474cd9c$export$4bc3c325941e6f67)(boundingBoxPadding);
    const getLeftOverflow = (x)=>x + containerRect.left - boundingRect.left - padding.left;
    const getRightOverflow = (x)=>x + containerRect.left + menuRect.width - boundingRect.right + padding.right;
    const getTopOverflow = (y)=>y + containerRect.top - boundingRect.top - padding.top;
    const getBottomOverflow = (y)=>y + containerRect.top + menuRect.height - boundingRect.bottom + padding.bottom;
    const confineHorizontally = (x)=>{
        let leftOverflow = getLeftOverflow(x);
        if (leftOverflow < 0) x -= leftOverflow;
        else {
            const rightOverflow = getRightOverflow(x);
            if (rightOverflow > 0) {
                x -= rightOverflow;
                leftOverflow = getLeftOverflow(x);
                if (leftOverflow < 0) x -= leftOverflow;
            }
        }
        return x;
    };
    const confineVertically = (y)=>{
        let topOverflow = getTopOverflow(y);
        if (topOverflow < 0) y -= topOverflow;
        else {
            const bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                y -= bottomOverflow;
                topOverflow = getTopOverflow(y);
                if (topOverflow < 0) y -= topOverflow;
            }
        }
        return y;
    };
    return {
        menuRect: menuRect,
        containerRect: containerRect,
        getLeftOverflow: getLeftOverflow,
        getRightOverflow: getRightOverflow,
        getTopOverflow: getTopOverflow,
        getBottomOverflow: getBottomOverflow,
        confineHorizontally: confineHorizontally,
        confineVertically: confineVertically
    };
};


const $68c0da076d4036e0$export$95257ec7631d2e00 = ({ arrowRef: arrowRef, menuY: menuY, anchorRect: anchorRect, containerRect: containerRect, menuRect: menuRect })=>{
    let y = anchorRect.top - containerRect.top - menuY + anchorRect.height / 2;
    const offset = arrowRef.current.offsetHeight * 1.25;
    y = Math.max(offset, y);
    y = Math.min(y, menuRect.height - offset);
    return y;
};


const $bf4de7683ae1e1aa$export$f768fc0fa8f5878e = ({ anchorRect: anchorRect, containerRect: containerRect, menuRect: menuRect, placeLeftorRightY: placeLeftorRightY, placeLeftX: placeLeftX, placeRightX: placeRightX, getLeftOverflow: getLeftOverflow, getRightOverflow: getRightOverflow, confineHorizontally: confineHorizontally, confineVertically: confineVertically, arrowRef: arrowRef, arrow: arrow, direction: direction, position: position })=>{
    let computedDirection = direction;
    let y = placeLeftorRightY;
    if (position !== "initial") {
        y = confineVertically(y);
        if (position === "anchor") {
            y = Math.min(y, anchorRect.bottom - containerRect.top);
            y = Math.max(y, anchorRect.top - containerRect.top - menuRect.height);
        }
    }
    let x, leftOverflow, rightOverflow;
    if (computedDirection === "left") {
        x = placeLeftX;
        if (position !== "initial") {
            leftOverflow = getLeftOverflow(x);
            if (leftOverflow < 0) {
                rightOverflow = getRightOverflow(placeRightX);
                if (rightOverflow <= 0 || -leftOverflow > rightOverflow) {
                    x = placeRightX;
                    computedDirection = "right";
                }
            }
        }
    } else {
        x = placeRightX;
        if (position !== "initial") {
            rightOverflow = getRightOverflow(x);
            if (rightOverflow > 0) {
                leftOverflow = getLeftOverflow(placeLeftX);
                if (leftOverflow >= 0 || -leftOverflow < rightOverflow) {
                    x = placeLeftX;
                    computedDirection = "left";
                }
            }
        }
    }
    if (position === "auto") x = confineHorizontally(x);
    const arrowY = arrow ? (0, $68c0da076d4036e0$export$95257ec7631d2e00)({
        menuY: y,
        arrowRef: arrowRef,
        anchorRect: anchorRect,
        containerRect: containerRect,
        menuRect: menuRect
    }) : undefined;
    return {
        arrowY: arrowY,
        x: x,
        y: y,
        computedDirection: computedDirection
    };
};


const $d8027c23bb708e6e$export$4c9b3bcc0c46b8d3 = ({ arrowRef: arrowRef, menuX: menuX, anchorRect: anchorRect, containerRect: containerRect, menuRect: menuRect })=>{
    let x = anchorRect.left - containerRect.left - menuX + anchorRect.width / 2;
    const offset = arrowRef.current.offsetWidth * 1.25;
    x = Math.max(offset, x);
    x = Math.min(x, menuRect.width - offset);
    return x;
};


const $71db7584d8295f12$export$65848579d307fa3f = ({ anchorRect: anchorRect, containerRect: containerRect, menuRect: menuRect, placeToporBottomX: placeToporBottomX, placeTopY: placeTopY, placeBottomY: placeBottomY, getTopOverflow: getTopOverflow, getBottomOverflow: getBottomOverflow, confineHorizontally: confineHorizontally, confineVertically: confineVertically, arrowRef: arrowRef, arrow: arrow, direction: direction, position: position })=>{
    let computedDirection = direction === "top" ? "top" : "bottom";
    let x = placeToporBottomX;
    if (position !== "initial") {
        x = confineHorizontally(x);
        if (position === "anchor") {
            x = Math.min(x, anchorRect.right - containerRect.left);
            x = Math.max(x, anchorRect.left - containerRect.left - menuRect.width);
        }
    }
    let y, topOverflow, bottomOverflow;
    if (computedDirection === "top") {
        y = placeTopY;
        if (position !== "initial") {
            topOverflow = getTopOverflow(y);
            if (topOverflow < 0) {
                bottomOverflow = getBottomOverflow(placeBottomY);
                if (bottomOverflow <= 0 || -topOverflow > bottomOverflow) {
                    y = placeBottomY;
                    computedDirection = "bottom";
                }
            }
        }
    } else {
        y = placeBottomY;
        if (position !== "initial") {
            bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                topOverflow = getTopOverflow(placeTopY);
                if (topOverflow >= 0 || -topOverflow < bottomOverflow) {
                    y = placeTopY;
                    computedDirection = "top";
                }
            }
        }
    }
    if (position === "auto") y = confineVertically(y);
    const arrowX = arrow ? (0, $d8027c23bb708e6e$export$4c9b3bcc0c46b8d3)({
        menuX: x,
        arrowRef: arrowRef,
        anchorRect: anchorRect,
        containerRect: containerRect,
        menuRect: menuRect
    }) : undefined;
    return {
        arrowX: arrowX,
        x: x,
        y: y,
        computedDirection: computedDirection
    };
};


const $73071dbcf8fba4bc$export$5a6e2d3543ff3d7e = ({ arrow: arrow, align: align, direction: direction, gap: gap, shift: shift, position: position, anchorRect: anchorRect, arrowRef: arrowRef, positionHelpers: positionHelpers })=>{
    const { menuRect: menuRect, containerRect: containerRect } = positionHelpers;
    const isHorizontal = direction === "left" || direction === "right";
    let horizontalOffset = isHorizontal ? gap : shift;
    let verticalOffset = isHorizontal ? shift : gap;
    if (arrow) {
        const arrowElt = arrowRef.current;
        if (isHorizontal) horizontalOffset += arrowElt.offsetWidth;
        else verticalOffset += arrowElt.offsetHeight;
    }
    const placeLeftX = anchorRect.left - containerRect.left - menuRect.width - horizontalOffset;
    const placeRightX = anchorRect.right - containerRect.left + horizontalOffset;
    const placeTopY = anchorRect.top - containerRect.top - menuRect.height - verticalOffset;
    const placeBottomY = anchorRect.bottom - containerRect.top + verticalOffset;
    let placeToporBottomX, placeLeftorRightY;
    if (align === "end") {
        placeToporBottomX = anchorRect.right - containerRect.left - menuRect.width;
        placeLeftorRightY = anchorRect.bottom - containerRect.top - menuRect.height;
    } else if (align === "center") {
        placeToporBottomX = anchorRect.left - containerRect.left - (menuRect.width - anchorRect.width) / 2;
        placeLeftorRightY = anchorRect.top - containerRect.top - (menuRect.height - anchorRect.height) / 2;
    } else {
        placeToporBottomX = anchorRect.left - containerRect.left;
        placeLeftorRightY = anchorRect.top - containerRect.top;
    }
    placeToporBottomX += horizontalOffset;
    placeLeftorRightY += verticalOffset;
    const options = {
        ...positionHelpers,
        anchorRect: anchorRect,
        placeLeftX: placeLeftX,
        placeRightX: placeRightX,
        placeLeftorRightY: placeLeftorRightY,
        placeTopY: placeTopY,
        placeBottomY: placeBottomY,
        placeToporBottomX: placeToporBottomX,
        arrowRef: arrowRef,
        arrow: arrow,
        direction: direction,
        position: position
    };
    switch(direction){
        case "left":
        case "right":
            return (0, $bf4de7683ae1e1aa$export$f768fc0fa8f5878e)(options);
        case "top":
        case "bottom":
        default:
            return (0, $71db7584d8295f12$export$65848579d307fa3f)(options);
    }
};



var $5NSbj = parcelRequire("5NSbj");
const $b0722025c304d424$export$e5c5a5f917a5871c = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $5NSbj.useLayoutEffect) : (0, $5NSbj.useEffect);




var $5NSbj = parcelRequire("5NSbj");
function $32acd8b8bedbec88$var$setRef(ref, instance) {
    typeof ref === "function" ? ref(instance) : ref.current = instance;
}
const $32acd8b8bedbec88$export$2d8be4568b07be94 = (refA, refB)=>(0, $5NSbj.useMemo)(()=>{
        if (!refA) return refB;
        if (!refB) return refA;
        return (instance)=>{
            $32acd8b8bedbec88$var$setRef(refA, instance);
            $32acd8b8bedbec88$var$setRef(refB, instance);
        };
    }, [
        refA,
        refB
    ]);


const $9ebbde454e54369e$var$offScreen = -9999;
const $9ebbde454e54369e$export$d4c4e98c5044dc8 = ({ ariaLabel: ariaLabel, menuClassName: menuClassName, menuStyle: menuStyle, arrow: arrow, arrowProps: arrowProps = {}, anchorPoint: anchorPoint, anchorRef: anchorRef, containerRef: containerRef, containerProps: containerProps, focusProps: focusProps, externalRef: externalRef, parentScrollingRef: parentScrollingRef, align: align = "start", direction: direction = "bottom", position: position = "auto", overflow: overflow = "visible", setDownOverflow: setDownOverflow, repositionFlag: repositionFlag, captureFocus: captureFocus = true, state: state, endTransition: endTransition, isDisabled: isDisabled, menuItemFocus: menuItemFocus, gap: gap = 0, shift: shift = 0, children: children, onClose: onClose, ...restProps })=>{
    const [menuPosition, setMenuPosition] = (0, $5NSbj.useState)({
        x: $9ebbde454e54369e$var$offScreen,
        y: $9ebbde454e54369e$var$offScreen
    });
    const [arrowPosition, setArrowPosition] = (0, $5NSbj.useState)({});
    const [overflowData, setOverflowData] = (0, $5NSbj.useState)();
    const [expandedDirection, setExpandedDirection] = (0, $5NSbj.useState)(direction);
    const [submenuCtx] = (0, $5NSbj.useState)((0, $e3629dd4bb589715$export$fd76cd1ffdc0d698));
    const [reposSubmenu, forceReposSubmenu] = (0, $5NSbj.useReducer)((c)=>c + 1, 1);
    const { transition: transition, boundingBoxRef: boundingBoxRef, boundingBoxPadding: boundingBoxPadding, rootMenuRef: rootMenuRef, rootAnchorRef: rootAnchorRef, scrollNodesRef: scrollNodesRef, reposition: reposition, viewScroll: viewScroll, submenuCloseDelay: submenuCloseDelay } = (0, $5NSbj.useContext)((0, $b3a633b3f550cddb$export$8fa45c82eddfe270));
    const { submenuCtx: parentSubmenuCtx, reposSubmenu: reposFlag = repositionFlag } = (0, $5NSbj.useContext)((0, $b3a633b3f550cddb$export$1c2bdfb4407fdacf));
    const menuRef = (0, $5NSbj.useRef)(null);
    const focusRef = (0, $5NSbj.useRef)();
    const arrowRef = (0, $5NSbj.useRef)();
    const prevOpen = (0, $5NSbj.useRef)(false);
    const latestMenuSize = (0, $5NSbj.useRef)({
        width: 0,
        height: 0
    });
    const latestHandlePosition = (0, $5NSbj.useRef)(()=>{});
    const { hoverItem: hoverItem, dispatch: dispatch, updateItems: updateItems } = (0, $e5337538acbea236$export$7bfdd97581ca93c)(menuRef, focusRef);
    const isOpen = (0, $ebbd2ea8f474cd9c$export$30c2dce1a652e248)(state);
    const openTransition = (0, $ebbd2ea8f474cd9c$export$d5639c01d489b0c)(transition, "open");
    const closeTransition = (0, $ebbd2ea8f474cd9c$export$d5639c01d489b0c)(transition, "close");
    const scrollNodes = scrollNodesRef.current;
    const onKeyDown = (e)=>{
        switch(e.key){
            case (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).HOME:
                dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).FIRST);
                break;
            case (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).END:
                dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).LAST);
                break;
            case (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).UP:
                dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).DECREASE, hoverItem);
                break;
            case (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).DOWN:
                dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).INCREASE, hoverItem);
                break;
            case (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).SPACE:
                if (e.target && e.target.className.indexOf((0, $b3a633b3f550cddb$export$832250593589325a)) !== -1) e.preventDefault();
                return;
            default:
                return;
        }
        e.preventDefault();
        e.stopPropagation();
    };
    const onAnimationEnd = ()=>{
        if (state === "closing") setOverflowData();
        (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(endTransition);
    };
    const onPointerMove = (e)=>{
        e.stopPropagation();
        submenuCtx.on(submenuCloseDelay, ()=>{
            dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).RESET);
            focusRef.current.focus();
        });
    };
    const onPointerLeave = (e)=>{
        if (e.target === e.currentTarget) submenuCtx.off();
    };
    const handlePosition = (0, $5NSbj.useCallback)((noOverflowCheck)=>{
        var _anchorRef$current;
        const anchorRect = anchorRef ? (_anchorRef$current = anchorRef.current) == null ? void 0 : _anchorRef$current.getBoundingClientRect() : anchorPoint ? {
            left: anchorPoint.x,
            right: anchorPoint.x,
            top: anchorPoint.y,
            bottom: anchorPoint.y,
            width: 0,
            height: 0
        } : null;
        if (!anchorRect) return;
        if (!scrollNodes.menu) scrollNodes.menu = (boundingBoxRef ? boundingBoxRef.current : (0, $ebbd2ea8f474cd9c$export$7414735161c19437)(rootMenuRef.current)) || window;
        const positionHelpers = (0, $27e968aa7dd55770$export$62e2806a96b09d4)(containerRef, menuRef, scrollNodes.menu, boundingBoxPadding);
        let { arrowX: arrowX, arrowY: arrowY, x: x, y: y, computedDirection: computedDirection } = (0, $73071dbcf8fba4bc$export$5a6e2d3543ff3d7e)({
            arrow: arrow,
            align: align,
            direction: direction,
            gap: gap,
            shift: shift,
            position: position,
            anchorRect: anchorRect,
            arrowRef: arrowRef,
            positionHelpers: positionHelpers
        });
        const { menuRect: menuRect } = positionHelpers;
        let menuHeight = menuRect.height;
        if (!noOverflowCheck && overflow !== "visible") {
            const { getTopOverflow: getTopOverflow, getBottomOverflow: getBottomOverflow } = positionHelpers;
            let height, overflowAmt;
            const prevHeight = latestMenuSize.current.height;
            const bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0 || (0, $ebbd2ea8f474cd9c$export$de749ee021c3ab62)(bottomOverflow, 0) && (0, $ebbd2ea8f474cd9c$export$de749ee021c3ab62)(menuHeight, prevHeight)) {
                height = menuHeight - bottomOverflow;
                overflowAmt = bottomOverflow;
            } else {
                const topOverflow = getTopOverflow(y);
                if (topOverflow < 0 || (0, $ebbd2ea8f474cd9c$export$de749ee021c3ab62)(topOverflow, 0) && (0, $ebbd2ea8f474cd9c$export$de749ee021c3ab62)(menuHeight, prevHeight)) {
                    height = menuHeight + topOverflow;
                    overflowAmt = 0 - topOverflow;
                    if (height >= 0) y -= topOverflow;
                }
            }
            if (height >= 0) {
                menuHeight = height;
                setOverflowData({
                    height: height,
                    overflowAmt: overflowAmt
                });
            } else setOverflowData();
        }
        if (arrow) setArrowPosition({
            x: arrowX,
            y: arrowY
        });
        setMenuPosition({
            x: x,
            y: y
        });
        setExpandedDirection(computedDirection);
        latestMenuSize.current = {
            width: menuRect.width,
            height: menuHeight
        };
    }, [
        arrow,
        align,
        boundingBoxPadding,
        direction,
        gap,
        shift,
        position,
        overflow,
        anchorPoint,
        anchorRef,
        containerRef,
        boundingBoxRef,
        rootMenuRef,
        scrollNodes
    ]);
    (0, $b0722025c304d424$export$e5c5a5f917a5871c)(()=>{
        if (isOpen) {
            handlePosition();
            if (prevOpen.current) forceReposSubmenu();
        }
        prevOpen.current = isOpen;
        latestHandlePosition.current = handlePosition;
    }, [
        isOpen,
        handlePosition,
        reposFlag
    ]);
    (0, $b0722025c304d424$export$e5c5a5f917a5871c)(()=>{
        if (overflowData && !setDownOverflow) menuRef.current.scrollTop = 0;
    }, [
        overflowData,
        setDownOverflow
    ]);
    (0, $b0722025c304d424$export$e5c5a5f917a5871c)(()=>updateItems, [
        updateItems
    ]);
    (0, $5NSbj.useEffect)(()=>{
        let { menu: menuScroll } = scrollNodes;
        if (!isOpen || !menuScroll) return;
        menuScroll = menuScroll.addEventListener ? menuScroll : window;
        if (!scrollNodes.anchors) {
            scrollNodes.anchors = [];
            let anchorScroll = (0, $ebbd2ea8f474cd9c$export$7414735161c19437)(rootAnchorRef && rootAnchorRef.current);
            while(anchorScroll && anchorScroll !== menuScroll){
                scrollNodes.anchors.push(anchorScroll);
                anchorScroll = (0, $ebbd2ea8f474cd9c$export$7414735161c19437)(anchorScroll);
            }
        }
        let scroll = viewScroll;
        if (scrollNodes.anchors.length && scroll === "initial") scroll = "auto";
        if (scroll === "initial") return;
        const handleScroll = ()=>{
            if (scroll === "auto") (0, $ebbd2ea8f474cd9c$export$3e3e6d241f8feb60)(()=>handlePosition(true));
            else (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(onClose, {
                reason: (0, $b3a633b3f550cddb$export$8fd8df51a9b835e6).SCROLL
            });
        };
        const scrollObservers = scrollNodes.anchors.concat(viewScroll !== "initial" ? menuScroll : []);
        scrollObservers.forEach((o)=>o.addEventListener("scroll", handleScroll));
        return ()=>scrollObservers.forEach((o)=>o.removeEventListener("scroll", handleScroll));
    }, [
        rootAnchorRef,
        scrollNodes,
        isOpen,
        onClose,
        viewScroll,
        handlePosition
    ]);
    const hasOverflow = !!overflowData && overflowData.overflowAmt > 0;
    (0, $5NSbj.useEffect)(()=>{
        if (hasOverflow || !isOpen || !parentScrollingRef) return;
        const handleScroll = ()=>(0, $ebbd2ea8f474cd9c$export$3e3e6d241f8feb60)(handlePosition);
        const parentScroll = parentScrollingRef.current;
        parentScroll.addEventListener("scroll", handleScroll);
        return ()=>parentScroll.removeEventListener("scroll", handleScroll);
    }, [
        isOpen,
        hasOverflow,
        parentScrollingRef,
        handlePosition
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (typeof ResizeObserver !== "function" || reposition === "initial") return;
        const resizeObserver = new ResizeObserver(([entry])=>{
            const { borderBoxSize: borderBoxSize, target: target } = entry;
            let width, height;
            if (borderBoxSize) {
                const { inlineSize: inlineSize, blockSize: blockSize } = borderBoxSize[0] || borderBoxSize;
                width = inlineSize;
                height = blockSize;
            } else {
                const borderRect = target.getBoundingClientRect();
                width = borderRect.width;
                height = borderRect.height;
            }
            if (width === 0 || height === 0) return;
            if ((0, $ebbd2ea8f474cd9c$export$de749ee021c3ab62)(width, latestMenuSize.current.width, 1) && (0, $ebbd2ea8f474cd9c$export$de749ee021c3ab62)(height, latestMenuSize.current.height, 1)) return;
            (0, $178ae9275e33f716$exports.flushSync)(()=>{
                latestHandlePosition.current();
                forceReposSubmenu();
            });
        });
        const observeTarget = menuRef.current;
        resizeObserver.observe(observeTarget, {
            box: "border-box"
        });
        return ()=>resizeObserver.unobserve(observeTarget);
    }, [
        reposition
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (!isOpen) {
            dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).RESET);
            if (!closeTransition) setOverflowData();
            return;
        }
        const { position: position, alwaysUpdate: alwaysUpdate } = menuItemFocus || {};
        const setItemFocus = ()=>{
            if (position === (0, $b3a633b3f550cddb$export$8c6ccba1b6ce32e9).FIRST) dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).FIRST);
            else if (position === (0, $b3a633b3f550cddb$export$8c6ccba1b6ce32e9).LAST) dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).LAST);
            else if (position >= -1) dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).SET_INDEX, undefined, position);
        };
        if (alwaysUpdate) setItemFocus();
        else if (captureFocus) {
            const id = setTimeout(()=>{
                const menuElt = menuRef.current;
                if (menuElt && !menuElt.contains(document.activeElement)) {
                    focusRef.current.focus();
                    setItemFocus();
                }
            }, openTransition ? 170 : 100);
            return ()=>clearTimeout(id);
        }
    }, [
        isOpen,
        openTransition,
        closeTransition,
        captureFocus,
        menuItemFocus,
        dispatch
    ]);
    const itemContext = (0, $5NSbj.useMemo)(()=>({
            isParentOpen: isOpen,
            submenuCtx: submenuCtx,
            dispatch: dispatch,
            updateItems: updateItems
        }), [
        isOpen,
        submenuCtx,
        dispatch,
        updateItems
    ]);
    let maxHeight, overflowAmt;
    if (overflowData) setDownOverflow ? overflowAmt = overflowData.overflowAmt : maxHeight = overflowData.height;
    const listContext = (0, $5NSbj.useMemo)(()=>({
            reposSubmenu: reposSubmenu,
            submenuCtx: submenuCtx,
            overflow: overflow,
            overflowAmt: overflowAmt,
            parentMenuRef: menuRef,
            parentDir: expandedDirection
        }), [
        reposSubmenu,
        submenuCtx,
        overflow,
        overflowAmt,
        expandedDirection
    ]);
    const overflowStyle = maxHeight >= 0 ? {
        maxHeight: maxHeight,
        overflow: overflow
    } : undefined;
    const modifiers = (0, $5NSbj.useMemo)(()=>({
            state: state,
            dir: expandedDirection
        }), [
        state,
        expandedDirection
    ]);
    const arrowModifiers = (0, $5NSbj.useMemo)(()=>({
            dir: expandedDirection
        }), [
        expandedDirection
    ]);
    const _arrowClassName = (0, $570b0fb7328e20ff$export$7ae630fe844fbd1f)({
        block: (0, $b3a633b3f550cddb$export$832250593589325a),
        element: (0, $b3a633b3f550cddb$export$3b35f0f35c840df9),
        modifiers: arrowModifiers,
        className: arrowProps.className
    });
    const menu = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
        role: "menu",
        "aria-label": ariaLabel,
        ...(0, $ebbd2ea8f474cd9c$export$ffb2d5922287e12)(isDisabled),
        ...(0, $ebbd2ea8f474cd9c$export$9d1611c77c2fe928)({
            onPointerEnter: parentSubmenuCtx == null ? void 0 : parentSubmenuCtx.off,
            onPointerMove: onPointerMove,
            onPointerLeave: onPointerLeave,
            onKeyDown: onKeyDown,
            onAnimationEnd: onAnimationEnd
        }, restProps),
        ref: (0, $32acd8b8bedbec88$export$2d8be4568b07be94)(externalRef, menuRef),
        className: (0, $570b0fb7328e20ff$export$7ae630fe844fbd1f)({
            block: (0, $b3a633b3f550cddb$export$832250593589325a),
            modifiers: modifiers,
            className: menuClassName
        }),
        style: {
            ...menuStyle,
            ...overflowStyle,
            margin: 0,
            display: state === "closed" ? "none" : undefined,
            position: (0, $b3a633b3f550cddb$export$f8d144aafbd3a470),
            left: menuPosition.x,
            top: menuPosition.y
        },
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                tabIndex: -1,
                style: {
                    position: (0, $b3a633b3f550cddb$export$f8d144aafbd3a470),
                    left: 0,
                    top: 0,
                    display: "block",
                    outline: "none"
                },
                ref: focusRef,
                ...(0, $b3a633b3f550cddb$export$988a172bcdaead26),
                ...focusProps
            }),
            arrow && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                ...(0, $b3a633b3f550cddb$export$988a172bcdaead26),
                ...arrowProps,
                className: _arrowClassName,
                style: {
                    display: "block",
                    position: (0, $b3a633b3f550cddb$export$f8d144aafbd3a470),
                    left: arrowPosition.x,
                    top: arrowPosition.y,
                    ...arrowProps.style
                },
                ref: arrowRef
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b3a633b3f550cddb$export$1c2bdfb4407fdacf).Provider, {
                value: listContext,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b3a633b3f550cddb$export$7cb023214e4bda1e).Provider, {
                    value: itemContext,
                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b3a633b3f550cddb$export$15c1690330cd94e).Provider, {
                        value: hoverItem,
                        children: (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(children, modifiers)
                    })
                })
            })
        ]
    });
    return containerProps ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $e8bd578383d21cff$export$b286f91cddfedb5a), {
        ...containerProps,
        isOpen: isOpen,
        children: menu
    }) : menu;
};






const $848352008823df68$export$a5a70f2f059d02ee = /*#__PURE__*/ (0, $5NSbj.forwardRef)(function ControlledMenu({ "aria-label": ariaLabel, className: className, containerProps: containerProps, initialMounted: initialMounted, unmountOnClose: unmountOnClose, transition: transition, transitionTimeout: transitionTimeout, boundingBoxRef: boundingBoxRef, boundingBoxPadding: boundingBoxPadding, reposition: reposition = "auto", submenuOpenDelay: submenuOpenDelay = 300, submenuCloseDelay: submenuCloseDelay = 150, viewScroll: viewScroll = "initial", portal: portal, theming: theming, onItemClick: onItemClick, ...restProps }, externalRef) {
    const containerRef = (0, $5NSbj.useRef)(null);
    const scrollNodesRef = (0, $5NSbj.useRef)({});
    const { anchorRef: anchorRef, state: state, onClose: onClose } = restProps;
    const settings = (0, $5NSbj.useMemo)(()=>({
            initialMounted: initialMounted,
            unmountOnClose: unmountOnClose,
            transition: transition,
            transitionTimeout: transitionTimeout,
            boundingBoxRef: boundingBoxRef,
            boundingBoxPadding: boundingBoxPadding,
            rootMenuRef: containerRef,
            rootAnchorRef: anchorRef,
            scrollNodesRef: scrollNodesRef,
            reposition: reposition,
            viewScroll: viewScroll,
            submenuOpenDelay: submenuOpenDelay,
            submenuCloseDelay: submenuCloseDelay
        }), [
        initialMounted,
        unmountOnClose,
        transition,
        transitionTimeout,
        anchorRef,
        boundingBoxRef,
        boundingBoxPadding,
        reposition,
        viewScroll,
        submenuOpenDelay,
        submenuCloseDelay
    ]);
    const eventHandlers = (0, $5NSbj.useMemo)(()=>({
            handleClick (event, isCheckorRadio) {
                if (!event.stopPropagation) (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(onItemClick, event);
                let keepOpen = event.keepOpen;
                if (keepOpen === undefined) keepOpen = isCheckorRadio && event.key === (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).SPACE;
                if (!keepOpen) (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(onClose, {
                    value: event.value,
                    key: event.key,
                    reason: (0, $b3a633b3f550cddb$export$8fd8df51a9b835e6).CLICK
                });
            },
            handleClose (key) {
                (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(onClose, {
                    key: key,
                    reason: (0, $b3a633b3f550cddb$export$8fd8df51a9b835e6).CLICK
                });
            }
        }), [
        onItemClick,
        onClose
    ]);
    if (!state) return null;
    const menuList = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b3a633b3f550cddb$export$8fa45c82eddfe270).Provider, {
        value: settings,
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b3a633b3f550cddb$export$ee9f2ec6c8119c2a).Provider, {
            value: eventHandlers,
            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $9ebbde454e54369e$export$d4c4e98c5044dc8), {
                ...restProps,
                ariaLabel: ariaLabel || "Menu",
                externalRef: externalRef,
                containerRef: containerRef,
                containerProps: {
                    className: className,
                    containerRef: containerRef,
                    containerProps: containerProps,
                    theming: theming,
                    transition: transition,
                    onClose: onClose
                }
            })
        })
    });
    if (portal === true && typeof document !== "undefined") return /*#__PURE__*/ (0, $178ae9275e33f716$exports.createPortal)(menuList, document.body);
    else if (portal) return portal.target ? /*#__PURE__*/ (0, $178ae9275e33f716$exports.createPortal)(menuList, portal.target) : portal.stablePosition ? null : menuList;
    return menuList;
});




var $5NSbj = parcelRequire("5NSbj");

var $5NSbj = parcelRequire("5NSbj");
const $13065be277d0c711$export$3a9d054b510f1baf = 0;
const $13065be277d0c711$export$df38205c966be359 = 1;
const $13065be277d0c711$export$78e9e6e3e014d60a = 2;
const $13065be277d0c711$export$6f37f73bf74e3970 = 3;
const $13065be277d0c711$export$4aacc83d4d59139f = 4;
const $13065be277d0c711$export$84cbff306f539230 = 5;
const $13065be277d0c711$export$bb38bb9a1161268 = 6;
const $13065be277d0c711$export$e50006273435e7d4 = [
    "preEnter",
    "entering",
    "entered",
    "preExit",
    "exiting",
    "exited",
    "unmounted"
];
const $13065be277d0c711$export$50fdfeece43146fd = (status)=>({
        _s: status,
        status: $13065be277d0c711$export$e50006273435e7d4[status],
        isEnter: status < $13065be277d0c711$export$6f37f73bf74e3970,
        isMounted: status !== $13065be277d0c711$export$bb38bb9a1161268,
        isResolved: status === $13065be277d0c711$export$78e9e6e3e014d60a || status > $13065be277d0c711$export$4aacc83d4d59139f
    });
const $13065be277d0c711$export$eb0971344425f03e = (unmounted)=>unmounted ? $13065be277d0c711$export$bb38bb9a1161268 : $13065be277d0c711$export$84cbff306f539230;
const $13065be277d0c711$export$c9efa50dd559122e = (status, unmountOnExit)=>{
    switch(status){
        case $13065be277d0c711$export$df38205c966be359:
        case $13065be277d0c711$export$3a9d054b510f1baf:
            return $13065be277d0c711$export$78e9e6e3e014d60a;
        case $13065be277d0c711$export$4aacc83d4d59139f:
        case $13065be277d0c711$export$6f37f73bf74e3970:
            return $13065be277d0c711$export$eb0971344425f03e(unmountOnExit);
    }
};
const $13065be277d0c711$export$d2e3f47e67110e3a = (timeout)=>typeof timeout === "object" ? [
        timeout.enter,
        timeout.exit
    ] : [
        timeout,
        timeout
    ];
const $13065be277d0c711$export$bdd553fddd433dcb = (transitState, status)=>setTimeout(()=>{
        // Reading document.body.offsetTop can force browser to repaint before transition to the next state
        isNaN(document.body.offsetTop) || transitState(status + 1);
    }, 0);


const $f9660b46c0dd48f6$var$updateState = (status, setState, latestState, timeoutId, onChange)=>{
    clearTimeout(timeoutId.current);
    const state = (0, $13065be277d0c711$export$50fdfeece43146fd)(status);
    setState(state);
    latestState.current = state;
    onChange && onChange({
        current: state
    });
};
const $f9660b46c0dd48f6$export$7b286972b8d8ccbf = ({ enter: enter = true, exit: exit = true, preEnter: preEnter, preExit: preExit, timeout: timeout, initialEntered: initialEntered, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, onStateChange: onChange } = {})=>{
    const [state, setState] = (0, $5NSbj.useState)(()=>(0, $13065be277d0c711$export$50fdfeece43146fd)(initialEntered ? (0, $13065be277d0c711$export$78e9e6e3e014d60a) : (0, $13065be277d0c711$export$eb0971344425f03e)(mountOnEnter)));
    const latestState = (0, $5NSbj.useRef)(state);
    const timeoutId = (0, $5NSbj.useRef)();
    const [enterTimeout, exitTimeout] = (0, $13065be277d0c711$export$d2e3f47e67110e3a)(timeout);
    const endTransition = (0, $5NSbj.useCallback)(()=>{
        const status = (0, $13065be277d0c711$export$c9efa50dd559122e)(latestState.current._s, unmountOnExit);
        status && $f9660b46c0dd48f6$var$updateState(status, setState, latestState, timeoutId, onChange);
    }, [
        onChange,
        unmountOnExit
    ]);
    const toggle = (0, $5NSbj.useCallback)((toEnter)=>{
        const transitState = (status)=>{
            $f9660b46c0dd48f6$var$updateState(status, setState, latestState, timeoutId, onChange);
            switch(status){
                case 0, $13065be277d0c711$export$df38205c966be359:
                    if (enterTimeout >= 0) timeoutId.current = setTimeout(endTransition, enterTimeout);
                    break;
                case 0, $13065be277d0c711$export$4aacc83d4d59139f:
                    if (exitTimeout >= 0) timeoutId.current = setTimeout(endTransition, exitTimeout);
                    break;
                case 0, $13065be277d0c711$export$3a9d054b510f1baf:
                case 0, $13065be277d0c711$export$6f37f73bf74e3970:
                    timeoutId.current = (0, $13065be277d0c711$export$bdd553fddd433dcb)(transitState, status);
                    break;
            }
        };
        const enterStage = latestState.current.isEnter;
        if (typeof toEnter !== "boolean") toEnter = !enterStage;
        if (toEnter) !enterStage && transitState(enter ? preEnter ? (0, $13065be277d0c711$export$3a9d054b510f1baf) : (0, $13065be277d0c711$export$df38205c966be359) : (0, $13065be277d0c711$export$78e9e6e3e014d60a));
        else enterStage && transitState(exit ? preExit ? (0, $13065be277d0c711$export$6f37f73bf74e3970) : (0, $13065be277d0c711$export$4aacc83d4d59139f) : (0, $13065be277d0c711$export$eb0971344425f03e)(unmountOnExit));
    }, [
        endTransition,
        onChange,
        enter,
        exit,
        preEnter,
        preExit,
        enterTimeout,
        exitTimeout,
        unmountOnExit
    ]);
    (0, $5NSbj.useEffect)(()=>()=>clearTimeout(timeoutId.current), []);
    return [
        state,
        toggle,
        endTransition
    ];
};




const $45aa3fd3be15f6f6$export$8091e3849c182a6 = ({ initialOpen: initialOpen, initialMounted: initialMounted, unmountOnClose: unmountOnClose, transition: transition, transitionTimeout: transitionTimeout = 500 } = {})=>{
    const [{ status: status }, toggleMenu, endTransition] = (0, $f9660b46c0dd48f6$export$7b286972b8d8ccbf)({
        initialEntered: initialOpen,
        mountOnEnter: !initialMounted,
        unmountOnExit: unmountOnClose,
        timeout: transitionTimeout,
        enter: (0, $ebbd2ea8f474cd9c$export$d5639c01d489b0c)(transition, "open"),
        exit: (0, $ebbd2ea8f474cd9c$export$d5639c01d489b0c)(transition, "close")
    });
    return [
        {
            state: (0, $b3a633b3f550cddb$export$be1d8b0328ba66b6)[status],
            endTransition: endTransition
        },
        toggleMenu
    ];
};


const $c8cdaa3196935526$export$1668883ac2d8e856 = (options)=>{
    const [menuProps, toggleMenu] = (0, $45aa3fd3be15f6f6$export$8091e3849c182a6)(options);
    const [menuItemFocus, setMenuItemFocus] = (0, $5NSbj.useState)();
    const openMenu = (position, alwaysUpdate)=>{
        setMenuItemFocus({
            position: position,
            alwaysUpdate: alwaysUpdate
        });
        toggleMenu(true);
    };
    return [
        {
            menuItemFocus: menuItemFocus,
            ...menuProps
        },
        toggleMenu,
        openMenu
    ];
};



var $5NSbj = parcelRequire("5NSbj");
const $fd866673d9d773b8$export$98524f11226063fc = (state, onToggle)=>{
    const [skipOpen] = (0, $5NSbj.useState)({});
    return {
        onMouseDown: ()=>{
            skipOpen.v = state && state !== "closed";
        },
        onClick: (e)=>skipOpen.v ? skipOpen.v = false : onToggle(true, e)
    };
};





var $5NSbj = parcelRequire("5NSbj");

const $04bf68f3ca08be1e$export$8410607abb05084e = (onMenuChange, isOpen)=>{
    const prevOpen = (0, $5NSbj.useRef)(isOpen);
    (0, $5NSbj.useEffect)(()=>{
        if (prevOpen.current !== isOpen) (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(onMenuChange, {
            open: isOpen
        });
        prevOpen.current = isOpen;
    }, [
        onMenuChange,
        isOpen
    ]);
};




const $bd4c4042067d9063$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $5NSbj.forwardRef)(function Menu({ "aria-label": ariaLabel, captureFocus: _, initialOpen: _1, menuButton: menuButton, instanceRef: instanceRef, onMenuChange: onMenuChange, ...restProps }, externalRef) {
    const [stateProps, toggleMenu, openMenu] = (0, $c8cdaa3196935526$export$1668883ac2d8e856)(restProps);
    const { state: state } = stateProps;
    const isOpen = (0, $ebbd2ea8f474cd9c$export$30c2dce1a652e248)(state);
    const buttonRef = (0, $5NSbj.useRef)(null);
    const anchorProps = (0, $fd866673d9d773b8$export$98524f11226063fc)(state, (_, e)=>openMenu(!e.detail ? (0, $b3a633b3f550cddb$export$8c6ccba1b6ce32e9).FIRST : undefined));
    const handleClose = (0, $5NSbj.useCallback)((e)=>{
        toggleMenu(false);
        if (e.key) buttonRef.current.focus();
    }, [
        toggleMenu
    ]);
    const onKeyDown = (e)=>{
        switch(e.key){
            case (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).UP:
                openMenu((0, $b3a633b3f550cddb$export$8c6ccba1b6ce32e9).LAST);
                break;
            case (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).DOWN:
                openMenu((0, $b3a633b3f550cddb$export$8c6ccba1b6ce32e9).FIRST);
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    const button = (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(menuButton, {
        open: isOpen
    });
    if (!button || !button.type) throw new Error("Menu requires a menuButton prop.");
    const buttonProps = {
        ref: (0, $32acd8b8bedbec88$export$2d8be4568b07be94)(button.ref, buttonRef),
        ...(0, $ebbd2ea8f474cd9c$export$9d1611c77c2fe928)({
            onKeyDown: onKeyDown,
            ...anchorProps
        }, button.props)
    };
    if ((0, $ebbd2ea8f474cd9c$export$7d9f7e9c1c02b41e)(button.type) === "MenuButton") buttonProps.isOpen = isOpen;
    const renderButton = /*#__PURE__*/ (0, $5NSbj.cloneElement)(button, buttonProps);
    (0, $04bf68f3ca08be1e$export$8410607abb05084e)(onMenuChange, isOpen);
    (0, $5NSbj.useImperativeHandle)(instanceRef, ()=>({
            openMenu: openMenu,
            closeMenu: ()=>toggleMenu(false)
        }));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $5NSbj.Fragment), {
        children: [
            renderButton,
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $848352008823df68$export$a5a70f2f059d02ee), {
                ...restProps,
                ...stateProps,
                "aria-label": ariaLabel || (typeof button.props.children === "string" ? button.props.children : "Menu"),
                anchorRef: buttonRef,
                ref: externalRef,
                onClose: handleClose
            })
        ]
    });
});


var $5NSbj = parcelRequire("5NSbj");






const $c5b00af6cfe5984a$export$266a769812832828 = /*#__PURE__*/ (0, $ebbd2ea8f474cd9c$export$4c4bf90f1b4d3105)("MenuButton", /*#__PURE__*/ (0, $5NSbj.forwardRef)(function MenuButton({ className: className, isOpen: isOpen, disabled: disabled, children: children, ...restProps }, ref) {
    const modifiers = (0, $5NSbj.useMemo)(()=>({
            open: isOpen
        }), [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
        "aria-haspopup": true,
        "aria-expanded": isOpen,
        "aria-disabled": disabled || undefined,
        type: "button",
        disabled: disabled,
        ...restProps,
        ref: ref,
        className: (0, $570b0fb7328e20ff$export$7ae630fe844fbd1f)({
            block: (0, $b3a633b3f550cddb$export$b3d82f113f746a0),
            modifiers: modifiers,
            className: className
        }),
        children: children
    });
}));


var $5NSbj = parcelRequire("5NSbj");



var $5NSbj = parcelRequire("5NSbj");

const $5ca14287304f2e15$export$68b1d6ee802c4a06 = (isDisabled, itemRef, updateItems)=>{
    (0, $b0722025c304d424$export$e5c5a5f917a5871c)(()=>{
        if (isDisabled) return;
        const item = itemRef.current;
        updateItems(item, true);
        return ()=>{
            updateItems(item);
        };
    }, [
        isDisabled,
        itemRef,
        updateItems
    ]);
};



const $5587aff3d1a84b4b$export$c75b31607cdc621e = (itemRef, focusRef, isHovering, isDisabled)=>{
    const { submenuCloseDelay: submenuCloseDelay } = (0, $5NSbj.useContext)((0, $b3a633b3f550cddb$export$8fa45c82eddfe270));
    const { isParentOpen: isParentOpen, submenuCtx: submenuCtx, dispatch: dispatch, updateItems: updateItems } = (0, $5NSbj.useContext)((0, $b3a633b3f550cddb$export$7cb023214e4bda1e));
    const setHover = ()=>{
        !isHovering && !isDisabled && dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).SET, itemRef.current);
    };
    const unsetHover = ()=>{
        !isDisabled && dispatch((0, $b3a633b3f550cddb$export$6db955af9e6f8fcd).UNSET, itemRef.current);
    };
    const onBlur = (e)=>{
        if (isHovering && !e.currentTarget.contains(e.relatedTarget)) unsetHover();
    };
    const onPointerMove = (e)=>{
        if (!isDisabled) {
            e.stopPropagation();
            submenuCtx.on(submenuCloseDelay, setHover, setHover);
        }
    };
    const onPointerLeave = (_, keepHover)=>{
        submenuCtx.off();
        !keepHover && unsetHover();
    };
    (0, $5ca14287304f2e15$export$68b1d6ee802c4a06)(isDisabled, itemRef, updateItems);
    (0, $5NSbj.useEffect)(()=>{
        if (isHovering && isParentOpen) focusRef.current && focusRef.current.focus();
    }, [
        focusRef,
        isHovering,
        isParentOpen
    ]);
    return {
        setHover: setHover,
        onBlur: onBlur,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerLeave
    };
};






var $5NSbj = parcelRequire("5NSbj");


const $b761fb6816b94e3b$export$9f154fa70a6daa25 = (name, WrappedComponent)=>{
    const Component = /*#__PURE__*/ (0, $5NSbj.memo)(WrappedComponent);
    const WithHovering = /*#__PURE__*/ (0, $5NSbj.forwardRef)((props, ref)=>{
        const itemRef = (0, $5NSbj.useRef)(null);
        return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)(Component, {
            ...props,
            itemRef: itemRef,
            externalRef: ref,
            isHovering: (0, $5NSbj.useContext)((0, $b3a633b3f550cddb$export$15c1690330cd94e)) === itemRef.current
        });
    });
    WithHovering.displayName = `WithHovering(${name})`;
    return WithHovering;
};




const $2f8c26b01cf457e1$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $b761fb6816b94e3b$export$9f154fa70a6daa25)("MenuItem", function MenuItem({ className: className, value: value, href: href, type: type, checked: checked, disabled: disabled, children: children, onClick: onClick, isHovering: isHovering, itemRef: itemRef, externalRef: externalRef, ...restProps }) {
    const isDisabled = !!disabled;
    const { setHover: setHover, ...restStateProps } = (0, $5587aff3d1a84b4b$export$c75b31607cdc621e)(itemRef, itemRef, isHovering, isDisabled);
    const eventHandlers = (0, $5NSbj.useContext)((0, $b3a633b3f550cddb$export$ee9f2ec6c8119c2a));
    const radioGroup = (0, $5NSbj.useContext)((0, $b3a633b3f550cddb$export$a79eda4ff50e30b6));
    const isRadio = type === "radio";
    const isCheckBox = type === "checkbox";
    const isAnchor = !!href && !isDisabled && !isRadio && !isCheckBox;
    const isChecked = isRadio ? radioGroup.value === value : isCheckBox ? !!checked : false;
    const handleClick = (e)=>{
        if (isDisabled) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        const event = {
            value: value,
            syntheticEvent: e
        };
        if (e.key !== undefined) event.key = e.key;
        if (isCheckBox) event.checked = !isChecked;
        if (isRadio) event.name = radioGroup.name;
        (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(onClick, event);
        if (isRadio) (0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(radioGroup.onRadioChange, event);
        eventHandlers.handleClick(event, isCheckBox || isRadio);
    };
    const handleKeyDown = (e)=>{
        if (!isHovering) return;
        switch(e.key){
            case (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).ENTER:
                e.preventDefault();
            case (0, $b3a633b3f550cddb$export$4b0075e5ea5e1f26).SPACE:
                isAnchor ? itemRef.current.click() : handleClick(e);
        }
    };
    const modifiers = (0, $5NSbj.useMemo)(()=>({
            type: type,
            disabled: isDisabled,
            hover: isHovering,
            checked: isChecked,
            anchor: isAnchor
        }), [
        type,
        isDisabled,
        isHovering,
        isChecked,
        isAnchor
    ]);
    const mergedProps = (0, $ebbd2ea8f474cd9c$export$9d1611c77c2fe928)({
        ...restStateProps,
        onPointerDown: setHover,
        onKeyDown: handleKeyDown,
        onClick: handleClick
    }, restProps);
    const menuItemProps = {
        role: isRadio ? "menuitemradio" : isCheckBox ? "menuitemcheckbox" : (0, $b3a633b3f550cddb$export$3e982710469daaf),
        "aria-checked": isRadio || isCheckBox ? isChecked : undefined,
        ...(0, $ebbd2ea8f474cd9c$export$ffb2d5922287e12)(isDisabled, isHovering),
        ...mergedProps,
        ref: (0, $32acd8b8bedbec88$export$2d8be4568b07be94)(externalRef, itemRef),
        className: (0, $570b0fb7328e20ff$export$7ae630fe844fbd1f)({
            block: (0, $b3a633b3f550cddb$export$832250593589325a),
            element: (0, $b3a633b3f550cddb$export$b5a3c9a9995a8c24),
            modifiers: modifiers,
            className: className
        }),
        children: (0, $5NSbj.useMemo)(()=>(0, $ebbd2ea8f474cd9c$export$175e60bb96229ece)(children, modifiers), [
            children,
            modifiers
        ])
    };
    return isAnchor ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
        role: (0, $b3a633b3f550cddb$export$a5a9d7469a9cc520),
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
            href: href,
            ...menuItemProps
        })
    }) : /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
        ...menuItemProps
    });
});



/**
 * @callback completeCallback
 */ /**
 * @typedef {Object} Options
 * @property {number} [duration]
 * @property {string} [easing]
 * @property {completeCallback} [complete]
 */ /**
 * @param {Element} element
 * @param {Object.<string, string>} properties
 * @param {completeCallback} complete
 */ function $11fdf00616b3f275$var$fadeComplete(element, properties, complete) {
    if (properties.transition) element.style.transition = properties.transition;
    else element.style.removeProperty("transition");
    if (properties.opacity) element.style.opacity = properties.opacity;
    else element.style.removeProperty("opacity");
    if (complete) complete();
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$82e6205b15e6c637(element, options = {}) {
    const o = $11fdf00616b3f275$var$getOptions(options);
    const properties = {
        transition: element.style.transition || undefined,
        opacity: element.style.opacity || undefined
    };
    // styles necessary for the animation
    if (!element.style.opacity) element.style.opacity = 0;
    element.style.removeProperty("display");
    element.style.transition = `opacity ${o.duration / 1000}s ${o.easing}`;
    requestAnimationFrame(function() {
        element.style.opacity = 1;
    });
    setTimeout(function() {
        $11fdf00616b3f275$var$fadeComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$c091916f1530334c(element, options = {}) {
    const o = $11fdf00616b3f275$var$getOptions(options);
    const properties = {
        transition: element.style.transition || undefined,
        opacity: element.style.opacity || undefined
    };
    // styles necessary for the animation
    if (!element.style.opacity) element.style.opacity = 1;
    element.style.transition = `opacity ${o.duration / 1000}s ${o.easing}`;
    requestAnimationFrame(function() {
        element.style.opacity = 0;
    });
    setTimeout(function() {
        element.style.display = "none";
        $11fdf00616b3f275$var$fadeComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$75d3d2c72ecccf9b(element, options = {}) {
    const display = element.style.display || undefined;
    if (display == "none") $11fdf00616b3f275$export$82e6205b15e6c637(element, options);
    else $11fdf00616b3f275$export$c091916f1530334c(element, options);
}
/**
 * @param {Options} options
 * @return {Options}
 */ function $11fdf00616b3f275$var$getOptions(options) {
    return {
        duration: options.duration || 400,
        easing: options.easing || "ease-out",
        complete: options.complete || undefined
    };
}
/**
 * @param {Element} element
 */ function $11fdf00616b3f275$export$fe8985bb6374093c(element) {
    element.style.display = "none";
}
/**
 * @param {Element} element
 */ function $11fdf00616b3f275$export$57bf213be019eeb0(element) {
    element.style.removeProperty("display");
}
/**
 * @param {Element} element
 * @param {Object.<string, string>} properties
 * @param {completeCallback} complete
 */ function $11fdf00616b3f275$var$slideComplete(element, properties, complete) {
    if (properties.transition) element.style.transition = properties.transition;
    else element.style.removeProperty("transition");
    if (properties.overflowY) element.style.overflowY = properties.overflowY;
    else element.style.removeProperty("overflow-y");
    if (properties.marginTop) element.style.marginTop = properties.marginTop;
    else element.style.removeProperty("margin-top");
    if (properties.marginBottom) element.style.marginBottom = properties.marginBottom;
    else element.style.removeProperty("margin-bottom");
    if (properties.paddingTop) element.style.paddingTop = properties.paddingTop;
    else element.style.removeProperty("padding-top");
    if (properties.paddingBottom) element.style.paddingBottom = properties.paddingBottom;
    else element.style.removeProperty("padding-bottom");
    if (properties.height) element.style.height = properties.height;
    else element.style.removeProperty("height");
    if (complete) complete();
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$abdd11a06a163232(element, options = {}) {
    const o = $11fdf00616b3f275$var$getOptions(options);
    const properties = {
        transition: element.style.transition || undefined,
        overflowY: element.style.overflowY || undefined,
        marginTop: element.style.marginTop || undefined,
        marginBottom: element.style.marginBottom || undefined,
        paddingTop: element.style.paddingTop || undefined,
        paddingBottom: element.style.paddingBottom || undefined,
        heigth: element.style.height || undefined
    };
    const cs = window.getComputedStyle(element);
    const marginTop = cs.getPropertyValue("margin-top");
    const marginBottom = cs.getPropertyValue("margin-bottom");
    const paddingTop = cs.getPropertyValue("padding-top");
    const paddingBottom = cs.getPropertyValue("padding-bottom");
    // styles necessary for the animation
    if (!element.style.height) element.style.height = "0px";
    element.style.marginTop = "0px";
    element.style.marginBottom = "0px";
    element.style.paddingTop = "0px";
    element.style.paddingBottom = "0px";
    element.style.overflowY = "hidden";
    element.style.removeProperty("display");
    element.style.transition = `height ${o.duration / 1000}s ${o.easing}, margin ${o.duration / 1000}s ${o.easing}, padding ${o.duration / 1000}s ${o.easing}`;
    requestAnimationFrame(function() {
        let height = element.scrollHeight;
        if (cs.getPropertyValue("box-sizing") == "border-box") height += parseFloat(paddingTop) + parseFloat(paddingBottom);
        element.style.height = `${height}px`;
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
    });
    setTimeout(function() {
        $11fdf00616b3f275$var$slideComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$715de50cedc228a8(element, options = {}) {
    const display = element.style.display || undefined;
    if (display == "none") $11fdf00616b3f275$export$abdd11a06a163232(element, options);
    else $11fdf00616b3f275$export$deed561b1a0ff1ea(element, options);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$deed561b1a0ff1ea(element, options = {}) {
    const o = $11fdf00616b3f275$var$getOptions(options);
    const properties = {
        transition: element.style.transition || undefined,
        overflowY: element.style.overflowY || undefined,
        marginTop: element.style.marginTop || undefined,
        marginBottom: element.style.marginBottom || undefined,
        paddingTop: element.style.paddingTop || undefined,
        paddingBottom: element.style.paddingBottom || undefined,
        heigth: element.style.height || undefined
    };
    const cs = window.getComputedStyle(element);
    const marginTop = cs.getPropertyValue("margin-top");
    const marginBottom = cs.getPropertyValue("margin-bottom");
    const paddingTop = cs.getPropertyValue("padding-top");
    const paddingBottom = cs.getPropertyValue("padding-bottom");
    // styles necessary for the animation
    requestAnimationFrame(function() {
        if (!element.style.height) {
            let height = element.scrollHeight;
            if (cs.getPropertyValue("box-sizing") == "content-box") height -= parseFloat(paddingTop) + parseFloat(paddingBottom);
            element.style.height = `${height}px`;
        }
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
        element.style.overflowY = "hidden";
        element.style.transition = `height ${o.duration / 1000}s ${o.easing}, margin ${o.duration / 1000}s ${o.easing}, padding ${o.duration / 1000}s ${o.easing}`;
        requestAnimationFrame(function() {
            element.style.height = "0px";
            element.style.marginTop = "0px";
            element.style.marginBottom = "0px";
            element.style.paddingTop = "0px";
            element.style.paddingBottom = "0px";
        });
    });
    setTimeout(function() {
        element.style.display = "none";
        $11fdf00616b3f275$var$slideComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 */ function $11fdf00616b3f275$export$e03c1c3201ee8bb7(element) {
    const display = element.style.display || undefined;
    if (display == "none") $11fdf00616b3f275$export$57bf213be019eeb0(element);
    else $11fdf00616b3f275$export$fe8985bb6374093c(element);
}



/**
 * Object describing how feed items are filtered in the view.
 * @enum {string}
 */ const $1901e2fb1eeb5912$export$c67e46de1ec7dfa6 = {
    NEWEST: "newest",
    UNREAD: "unread",
    STARRED: "starred"
};


function $7c8cbf542ee98bec$export$46e843a62e9cebcc(type) {
    if (type == "newest") return (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).NEWEST;
    else if (type == "unread") return (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).UNREAD;
    else if (type == "starred") return (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).STARRED;
    else throw new Error(`Invalid filter type: \u{201C}${type}\u{201D}`);
}
function $7c8cbf542ee98bec$export$63b3966ca4cc85d9(type) {
    if (type == (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).NEWEST) return "newest";
    else if (type == (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).UNREAD) return "unread";
    else if (type == (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).STARRED) return "starred";
}
const $7c8cbf542ee98bec$export$f1004941042944df = "/:filter(newest|unread|starred)/:category(all|tag-[^/]+|source-[0-9]+)/:id?";
function $7c8cbf542ee98bec$export$d0bb2ab5375d1521(location, { filter: filter, category: category, id: id, search: search }) {
    const queryString = new URLSearchParams(location.search);
    let path;
    if (location.pathname.match(/^\/(newest|unread|starred)\//) !== null) {
        const [, ...segments] = location.pathname.split("/");
        path = (0, $88361e604f4abd56$export$82476f982757e71e)($7c8cbf542ee98bec$export$f1004941042944df, {
            filter: filter ?? segments[0],
            category: category ?? segments[1],
            id: typeof id !== "undefined" ? id : segments[2]
        });
    } else path = (0, $88361e604f4abd56$export$82476f982757e71e)($7c8cbf542ee98bec$export$f1004941042944df, {
        // TODO: change default from config
        filter: filter ?? "unread",
        category: category ?? "all",
        id: id
    });
    if (typeof search !== "undefined") {
        if (search) queryString.set("search", search);
        else queryString.delete("search");
    }
    return {
        pathname: path,
        search: queryString.toString()
    };
}
function $7c8cbf542ee98bec$export$7f0beea2aa79e4fa(location, params) {
    const { pathname: pathname, search: search } = $7c8cbf542ee98bec$export$d0bb2ab5375d1521(location, params);
    return pathname + (search !== "" ? `?${search}` : "");
}
function $7c8cbf542ee98bec$export$e64cf1b9b4b3aa56(location) {
    const state = location.state ?? {};
    return {
        ...state,
        forceReload: (state.forceReload ?? 0) + 1
    };
}




/**
 * Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ const { replace: $ec6aeee77f582aff$var$replace } = "";
// escape
const $ec6aeee77f582aff$var$es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
const $ec6aeee77f582aff$var$ca = /[&<>'"]/g;
const $ec6aeee77f582aff$var$esca = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "'": "&#39;",
    '"': "&quot;"
};
const $ec6aeee77f582aff$var$pe = (m)=>$ec6aeee77f582aff$var$esca[m];
const $ec6aeee77f582aff$export$4e7f196112fea3c5 = (es)=>$ec6aeee77f582aff$var$replace.call(es, $ec6aeee77f582aff$var$ca, $ec6aeee77f582aff$var$pe);
// unescape
const $ec6aeee77f582aff$var$unes = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"'
};
const $ec6aeee77f582aff$var$cape = (m)=>$ec6aeee77f582aff$var$unes[m];
const $ec6aeee77f582aff$export$e8bacd2802a88316 = (un)=>$ec6aeee77f582aff$var$replace.call(un, $ec6aeee77f582aff$var$es, $ec6aeee77f582aff$var$cape);



/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $1e1752ba20547388$var$isArray = Array.isArray;
var $1e1752ba20547388$export$2e2bcd8739ae039 = $1e1752ba20547388$var$isArray;



/** Detect free variable `global` from Node.js. */ var $29cd6e27d4144838$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $29cd6e27d4144838$export$2e2bcd8739ae039 = $29cd6e27d4144838$var$freeGlobal;


/** Detect free variable `self`. */ var $1cbf55c3e44c46ce$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1cbf55c3e44c46ce$var$root = (0, $29cd6e27d4144838$export$2e2bcd8739ae039) || $1cbf55c3e44c46ce$var$freeSelf || Function("return this")();
var $1cbf55c3e44c46ce$export$2e2bcd8739ae039 = $1cbf55c3e44c46ce$var$root;


/** Built-in value references. */ var $213ba81f8d233690$var$Symbol = (0, $1cbf55c3e44c46ce$export$2e2bcd8739ae039).Symbol;
var $213ba81f8d233690$export$2e2bcd8739ae039 = $213ba81f8d233690$var$Symbol;



/** Used for built-in method references. */ var $b20e7619a952e06f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b20e7619a952e06f$var$hasOwnProperty = $b20e7619a952e06f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b20e7619a952e06f$var$nativeObjectToString = $b20e7619a952e06f$var$objectProto.toString;
/** Built-in value references. */ var $b20e7619a952e06f$var$symToStringTag = (0, $213ba81f8d233690$export$2e2bcd8739ae039) ? (0, $213ba81f8d233690$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b20e7619a952e06f$var$getRawTag(value) {
    var isOwn = $b20e7619a952e06f$var$hasOwnProperty.call(value, $b20e7619a952e06f$var$symToStringTag), tag = value[$b20e7619a952e06f$var$symToStringTag];
    try {
        value[$b20e7619a952e06f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b20e7619a952e06f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b20e7619a952e06f$var$symToStringTag] = tag;
        else delete value[$b20e7619a952e06f$var$symToStringTag];
    }
    return result;
}
var $b20e7619a952e06f$export$2e2bcd8739ae039 = $b20e7619a952e06f$var$getRawTag;


/** Used for built-in method references. */ var $52bc3b663434685e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $52bc3b663434685e$var$nativeObjectToString = $52bc3b663434685e$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $52bc3b663434685e$var$objectToString(value) {
    return $52bc3b663434685e$var$nativeObjectToString.call(value);
}
var $52bc3b663434685e$export$2e2bcd8739ae039 = $52bc3b663434685e$var$objectToString;


/** `Object#toString` result references. */ var $9b15b088b5f05768$var$nullTag = "[object Null]", $9b15b088b5f05768$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $9b15b088b5f05768$var$symToStringTag = (0, $213ba81f8d233690$export$2e2bcd8739ae039) ? (0, $213ba81f8d233690$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $9b15b088b5f05768$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $9b15b088b5f05768$var$undefinedTag : $9b15b088b5f05768$var$nullTag;
    return $9b15b088b5f05768$var$symToStringTag && $9b15b088b5f05768$var$symToStringTag in Object(value) ? (0, $b20e7619a952e06f$export$2e2bcd8739ae039)(value) : (0, $52bc3b663434685e$export$2e2bcd8739ae039)(value);
}
var $9b15b088b5f05768$export$2e2bcd8739ae039 = $9b15b088b5f05768$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $12b35a1d6f51d03d$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $12b35a1d6f51d03d$export$2e2bcd8739ae039 = $12b35a1d6f51d03d$var$isObjectLike;


/** `Object#toString` result references. */ var $5a2540ebbf553ace$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5a2540ebbf553ace$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $12b35a1d6f51d03d$export$2e2bcd8739ae039)(value) && (0, $9b15b088b5f05768$export$2e2bcd8739ae039)(value) == $5a2540ebbf553ace$var$symbolTag;
}
var $5a2540ebbf553ace$export$2e2bcd8739ae039 = $5a2540ebbf553ace$var$isSymbol;


/** Used to match property names within property paths. */ var $1d2b8ce830c1b769$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $1d2b8ce830c1b769$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $1d2b8ce830c1b769$var$isKey(value, object) {
    if ((0, $1e1752ba20547388$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, $5a2540ebbf553ace$export$2e2bcd8739ae039)(value)) return true;
    return $1d2b8ce830c1b769$var$reIsPlainProp.test(value) || !$1d2b8ce830c1b769$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $1d2b8ce830c1b769$export$2e2bcd8739ae039 = $1d2b8ce830c1b769$var$isKey;



/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $9a883469b282241c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $9a883469b282241c$export$2e2bcd8739ae039 = $9a883469b282241c$var$isObject;


/** `Object#toString` result references. */ var $15f7be8fcefbe5ec$var$asyncTag = "[object AsyncFunction]", $15f7be8fcefbe5ec$var$funcTag = "[object Function]", $15f7be8fcefbe5ec$var$genTag = "[object GeneratorFunction]", $15f7be8fcefbe5ec$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $15f7be8fcefbe5ec$var$isFunction(value) {
    if (!(0, $9a883469b282241c$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $9b15b088b5f05768$export$2e2bcd8739ae039)(value);
    return tag == $15f7be8fcefbe5ec$var$funcTag || tag == $15f7be8fcefbe5ec$var$genTag || tag == $15f7be8fcefbe5ec$var$asyncTag || tag == $15f7be8fcefbe5ec$var$proxyTag;
}
var $15f7be8fcefbe5ec$export$2e2bcd8739ae039 = $15f7be8fcefbe5ec$var$isFunction;



/** Used to detect overreaching core-js shims. */ var $e3c265cc9322f731$var$coreJsData = (0, $1cbf55c3e44c46ce$export$2e2bcd8739ae039)["__core-js_shared__"];
var $e3c265cc9322f731$export$2e2bcd8739ae039 = $e3c265cc9322f731$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $2239ff27cf281dc7$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $e3c265cc9322f731$export$2e2bcd8739ae039) && (0, $e3c265cc9322f731$export$2e2bcd8739ae039).keys && (0, $e3c265cc9322f731$export$2e2bcd8739ae039).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $2239ff27cf281dc7$var$isMasked(func) {
    return !!$2239ff27cf281dc7$var$maskSrcKey && $2239ff27cf281dc7$var$maskSrcKey in func;
}
var $2239ff27cf281dc7$export$2e2bcd8739ae039 = $2239ff27cf281dc7$var$isMasked;



/** Used for built-in method references. */ var $f14b9f0ef1f2f879$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f14b9f0ef1f2f879$var$funcToString = $f14b9f0ef1f2f879$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f14b9f0ef1f2f879$var$toSource(func) {
    if (func != null) {
        try {
            return $f14b9f0ef1f2f879$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $f14b9f0ef1f2f879$export$2e2bcd8739ae039 = $f14b9f0ef1f2f879$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $5bac622fc0b75967$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $5bac622fc0b75967$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $5bac622fc0b75967$var$funcProto = Function.prototype, $5bac622fc0b75967$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $5bac622fc0b75967$var$funcToString = $5bac622fc0b75967$var$funcProto.toString;
/** Used to check objects for own properties. */ var $5bac622fc0b75967$var$hasOwnProperty = $5bac622fc0b75967$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $5bac622fc0b75967$var$reIsNative = RegExp("^" + $5bac622fc0b75967$var$funcToString.call($5bac622fc0b75967$var$hasOwnProperty).replace($5bac622fc0b75967$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $5bac622fc0b75967$var$baseIsNative(value) {
    if (!(0, $9a883469b282241c$export$2e2bcd8739ae039)(value) || (0, $2239ff27cf281dc7$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $15f7be8fcefbe5ec$export$2e2bcd8739ae039)(value) ? $5bac622fc0b75967$var$reIsNative : $5bac622fc0b75967$var$reIsHostCtor;
    return pattern.test((0, $f14b9f0ef1f2f879$export$2e2bcd8739ae039)(value));
}
var $5bac622fc0b75967$export$2e2bcd8739ae039 = $5bac622fc0b75967$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $4308e40ccc761669$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $4308e40ccc761669$export$2e2bcd8739ae039 = $4308e40ccc761669$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $3bb6135c399dfe41$var$getNative(object, key) {
    var value = (0, $4308e40ccc761669$export$2e2bcd8739ae039)(object, key);
    return (0, $5bac622fc0b75967$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $3bb6135c399dfe41$export$2e2bcd8739ae039 = $3bb6135c399dfe41$var$getNative;


/* Built-in method references that are verified to be native. */ var $625bc15752ae5862$var$nativeCreate = (0, $3bb6135c399dfe41$export$2e2bcd8739ae039)(Object, "create");
var $625bc15752ae5862$export$2e2bcd8739ae039 = $625bc15752ae5862$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $afc915431c3aa343$var$hashClear() {
    this.__data__ = (0, $625bc15752ae5862$export$2e2bcd8739ae039) ? (0, $625bc15752ae5862$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $afc915431c3aa343$export$2e2bcd8739ae039 = $afc915431c3aa343$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $15cfc6594cdf6abb$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $15cfc6594cdf6abb$export$2e2bcd8739ae039 = $15cfc6594cdf6abb$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $405ebaef7811c33a$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $405ebaef7811c33a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $405ebaef7811c33a$var$hasOwnProperty = $405ebaef7811c33a$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $405ebaef7811c33a$var$hashGet(key) {
    var data = this.__data__;
    if (0, $625bc15752ae5862$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $405ebaef7811c33a$var$HASH_UNDEFINED ? undefined : result;
    }
    return $405ebaef7811c33a$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $405ebaef7811c33a$export$2e2bcd8739ae039 = $405ebaef7811c33a$var$hashGet;



/** Used for built-in method references. */ var $3c93aa4ccf1473c1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c93aa4ccf1473c1$var$hasOwnProperty = $3c93aa4ccf1473c1$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3c93aa4ccf1473c1$var$hashHas(key) {
    var data = this.__data__;
    return (0, $625bc15752ae5862$export$2e2bcd8739ae039) ? data[key] !== undefined : $3c93aa4ccf1473c1$var$hasOwnProperty.call(data, key);
}
var $3c93aa4ccf1473c1$export$2e2bcd8739ae039 = $3c93aa4ccf1473c1$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $7e7a5c85d7addecd$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7e7a5c85d7addecd$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $625bc15752ae5862$export$2e2bcd8739ae039) && value === undefined ? $7e7a5c85d7addecd$var$HASH_UNDEFINED : value;
    return this;
}
var $7e7a5c85d7addecd$export$2e2bcd8739ae039 = $7e7a5c85d7addecd$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7f3ebd7d474e8eb0$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$7f3ebd7d474e8eb0$var$Hash.prototype.clear = (0, $afc915431c3aa343$export$2e2bcd8739ae039);
$7f3ebd7d474e8eb0$var$Hash.prototype["delete"] = (0, $15cfc6594cdf6abb$export$2e2bcd8739ae039);
$7f3ebd7d474e8eb0$var$Hash.prototype.get = (0, $405ebaef7811c33a$export$2e2bcd8739ae039);
$7f3ebd7d474e8eb0$var$Hash.prototype.has = (0, $3c93aa4ccf1473c1$export$2e2bcd8739ae039);
$7f3ebd7d474e8eb0$var$Hash.prototype.set = (0, $7e7a5c85d7addecd$export$2e2bcd8739ae039);
var $7f3ebd7d474e8eb0$export$2e2bcd8739ae039 = $7f3ebd7d474e8eb0$var$Hash;


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4b69bb4229beea01$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $4b69bb4229beea01$export$2e2bcd8739ae039 = $4b69bb4229beea01$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e14dbe683b673f9b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $e14dbe683b673f9b$export$2e2bcd8739ae039 = $e14dbe683b673f9b$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $5c73de08059c4603$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $e14dbe683b673f9b$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $5c73de08059c4603$export$2e2bcd8739ae039 = $5c73de08059c4603$var$assocIndexOf;


/** Used for built-in method references. */ var $74d0ca12e1e7309f$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $74d0ca12e1e7309f$var$splice = $74d0ca12e1e7309f$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $74d0ca12e1e7309f$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $5c73de08059c4603$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $74d0ca12e1e7309f$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $74d0ca12e1e7309f$export$2e2bcd8739ae039 = $74d0ca12e1e7309f$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dda10546e10ea921$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $5c73de08059c4603$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $dda10546e10ea921$export$2e2bcd8739ae039 = $dda10546e10ea921$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a075ad7a6b10f106$var$listCacheHas(key) {
    return (0, $5c73de08059c4603$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $a075ad7a6b10f106$export$2e2bcd8739ae039 = $a075ad7a6b10f106$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b9463aa6dc4bfbfd$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $5c73de08059c4603$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $b9463aa6dc4bfbfd$export$2e2bcd8739ae039 = $b9463aa6dc4bfbfd$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d3714f12bfd2739b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d3714f12bfd2739b$var$ListCache.prototype.clear = (0, $4b69bb4229beea01$export$2e2bcd8739ae039);
$d3714f12bfd2739b$var$ListCache.prototype["delete"] = (0, $74d0ca12e1e7309f$export$2e2bcd8739ae039);
$d3714f12bfd2739b$var$ListCache.prototype.get = (0, $dda10546e10ea921$export$2e2bcd8739ae039);
$d3714f12bfd2739b$var$ListCache.prototype.has = (0, $a075ad7a6b10f106$export$2e2bcd8739ae039);
$d3714f12bfd2739b$var$ListCache.prototype.set = (0, $b9463aa6dc4bfbfd$export$2e2bcd8739ae039);
var $d3714f12bfd2739b$export$2e2bcd8739ae039 = $d3714f12bfd2739b$var$ListCache;




/* Built-in method references that are verified to be native. */ var $8746442e8a9e7980$var$Map = (0, $3bb6135c399dfe41$export$2e2bcd8739ae039)((0, $1cbf55c3e44c46ce$export$2e2bcd8739ae039), "Map");
var $8746442e8a9e7980$export$2e2bcd8739ae039 = $8746442e8a9e7980$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $fc9cd1acfec5308f$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $7f3ebd7d474e8eb0$export$2e2bcd8739ae039),
        "map": new ((0, $8746442e8a9e7980$export$2e2bcd8739ae039) || (0, $d3714f12bfd2739b$export$2e2bcd8739ae039)),
        "string": new (0, $7f3ebd7d474e8eb0$export$2e2bcd8739ae039)
    };
}
var $fc9cd1acfec5308f$export$2e2bcd8739ae039 = $fc9cd1acfec5308f$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $2c727976c911cf30$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $2c727976c911cf30$export$2e2bcd8739ae039 = $2c727976c911cf30$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $5eeda81790dd7ae5$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $2c727976c911cf30$export$2e2bcd8739ae039)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $5eeda81790dd7ae5$export$2e2bcd8739ae039 = $5eeda81790dd7ae5$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2e4bebfe466e5034$var$mapCacheDelete(key) {
    var result = (0, $5eeda81790dd7ae5$export$2e2bcd8739ae039)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $2e4bebfe466e5034$export$2e2bcd8739ae039 = $2e4bebfe466e5034$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $22505230c7344f95$var$mapCacheGet(key) {
    return (0, $5eeda81790dd7ae5$export$2e2bcd8739ae039)(this, key).get(key);
}
var $22505230c7344f95$export$2e2bcd8739ae039 = $22505230c7344f95$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ac79a23f4e50d8bf$var$mapCacheHas(key) {
    return (0, $5eeda81790dd7ae5$export$2e2bcd8739ae039)(this, key).has(key);
}
var $ac79a23f4e50d8bf$export$2e2bcd8739ae039 = $ac79a23f4e50d8bf$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $489f5c25a81773b1$var$mapCacheSet(key, value) {
    var data = (0, $5eeda81790dd7ae5$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $489f5c25a81773b1$export$2e2bcd8739ae039 = $489f5c25a81773b1$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $14d8778d8d730781$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$14d8778d8d730781$var$MapCache.prototype.clear = (0, $fc9cd1acfec5308f$export$2e2bcd8739ae039);
$14d8778d8d730781$var$MapCache.prototype["delete"] = (0, $2e4bebfe466e5034$export$2e2bcd8739ae039);
$14d8778d8d730781$var$MapCache.prototype.get = (0, $22505230c7344f95$export$2e2bcd8739ae039);
$14d8778d8d730781$var$MapCache.prototype.has = (0, $ac79a23f4e50d8bf$export$2e2bcd8739ae039);
$14d8778d8d730781$var$MapCache.prototype.set = (0, $489f5c25a81773b1$export$2e2bcd8739ae039);
var $14d8778d8d730781$export$2e2bcd8739ae039 = $14d8778d8d730781$var$MapCache;


/** Error message constants. */ var $52f97e9c5fc92313$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $52f97e9c5fc92313$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($52f97e9c5fc92313$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($52f97e9c5fc92313$var$memoize.Cache || (0, $14d8778d8d730781$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$52f97e9c5fc92313$var$memoize.Cache = (0, $14d8778d8d730781$export$2e2bcd8739ae039);
var $52f97e9c5fc92313$export$2e2bcd8739ae039 = $52f97e9c5fc92313$var$memoize;


/** Used as the maximum memoize cache size. */ var $776baccb4ee0ed53$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $776baccb4ee0ed53$var$memoizeCapped(func) {
    var result = (0, $52f97e9c5fc92313$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $776baccb4ee0ed53$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $776baccb4ee0ed53$export$2e2bcd8739ae039 = $776baccb4ee0ed53$var$memoizeCapped;


/** Used to match property names within property paths. */ var $66f2d0e55716bc61$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $66f2d0e55716bc61$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $66f2d0e55716bc61$var$stringToPath = (0, $776baccb4ee0ed53$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($66f2d0e55716bc61$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($66f2d0e55716bc61$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $66f2d0e55716bc61$export$2e2bcd8739ae039 = $66f2d0e55716bc61$var$stringToPath;



/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $31878feae60a9167$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $31878feae60a9167$export$2e2bcd8739ae039 = $31878feae60a9167$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f17249cf96ab0e91$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f17249cf96ab0e91$var$symbolProto = (0, $213ba81f8d233690$export$2e2bcd8739ae039) ? (0, $213ba81f8d233690$export$2e2bcd8739ae039).prototype : undefined, $f17249cf96ab0e91$var$symbolToString = $f17249cf96ab0e91$var$symbolProto ? $f17249cf96ab0e91$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f17249cf96ab0e91$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $1e1752ba20547388$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $31878feae60a9167$export$2e2bcd8739ae039)(value, $f17249cf96ab0e91$var$baseToString) + "";
    if ((0, $5a2540ebbf553ace$export$2e2bcd8739ae039)(value)) return $f17249cf96ab0e91$var$symbolToString ? $f17249cf96ab0e91$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f17249cf96ab0e91$var$INFINITY ? "-0" : result;
}
var $f17249cf96ab0e91$export$2e2bcd8739ae039 = $f17249cf96ab0e91$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $cc2c747def446e5e$var$toString(value) {
    return value == null ? "" : (0, $f17249cf96ab0e91$export$2e2bcd8739ae039)(value);
}
var $cc2c747def446e5e$export$2e2bcd8739ae039 = $cc2c747def446e5e$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $3281c6aec7b1af5b$var$castPath(value, object) {
    if ((0, $1e1752ba20547388$export$2e2bcd8739ae039)(value)) return value;
    return (0, $1d2b8ce830c1b769$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $66f2d0e55716bc61$export$2e2bcd8739ae039)((0, $cc2c747def446e5e$export$2e2bcd8739ae039)(value));
}
var $3281c6aec7b1af5b$export$2e2bcd8739ae039 = $3281c6aec7b1af5b$var$castPath;



/** Used as references for various `Number` constants. */ var $5a52b012f527fd8b$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $5a52b012f527fd8b$var$toKey(value) {
    if (typeof value == "string" || (0, $5a2540ebbf553ace$export$2e2bcd8739ae039)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$5a52b012f527fd8b$var$INFINITY ? "-0" : result;
}
var $5a52b012f527fd8b$export$2e2bcd8739ae039 = $5a52b012f527fd8b$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $f1ab29f3b886c84b$var$baseGet(object, path) {
    path = (0, $3281c6aec7b1af5b$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $5a52b012f527fd8b$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $f1ab29f3b886c84b$export$2e2bcd8739ae039 = $f1ab29f3b886c84b$var$baseGet;



var $4ebc8e06beafd880$var$defineProperty = function() {
    try {
        var func = (0, $3bb6135c399dfe41$export$2e2bcd8739ae039)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $4ebc8e06beafd880$export$2e2bcd8739ae039 = $4ebc8e06beafd880$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $e874431ea56f06d0$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $4ebc8e06beafd880$export$2e2bcd8739ae039)) (0, $4ebc8e06beafd880$export$2e2bcd8739ae039)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $e874431ea56f06d0$export$2e2bcd8739ae039 = $e874431ea56f06d0$var$baseAssignValue;



/** Used for built-in method references. */ var $37c8b8086f9a2826$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $37c8b8086f9a2826$var$hasOwnProperty = $37c8b8086f9a2826$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $37c8b8086f9a2826$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($37c8b8086f9a2826$var$hasOwnProperty.call(object, key) && (0, $e14dbe683b673f9b$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $e874431ea56f06d0$export$2e2bcd8739ae039)(object, key, value);
}
var $37c8b8086f9a2826$export$2e2bcd8739ae039 = $37c8b8086f9a2826$var$assignValue;



/** Used as references for various `Number` constants. */ var $4a17ca83a682a8ec$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $4a17ca83a682a8ec$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $4a17ca83a682a8ec$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $4a17ca83a682a8ec$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $4a17ca83a682a8ec$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $4a17ca83a682a8ec$export$2e2bcd8739ae039 = $4a17ca83a682a8ec$var$isIndex;




/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $16d52dd8de1034eb$var$baseSet(object, path, value, customizer) {
    if (!(0, $9a883469b282241c$export$2e2bcd8739ae039)(object)) return object;
    path = (0, $3281c6aec7b1af5b$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = (0, $5a52b012f527fd8b$export$2e2bcd8739ae039)(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = (0, $9a883469b282241c$export$2e2bcd8739ae039)(objValue) ? objValue : (0, $4a17ca83a682a8ec$export$2e2bcd8739ae039)(path[index + 1]) ? [] : {};
        }
        (0, $37c8b8086f9a2826$export$2e2bcd8739ae039)(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $16d52dd8de1034eb$export$2e2bcd8739ae039 = $16d52dd8de1034eb$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $034c132369d4c9f5$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = (0, $f1ab29f3b886c84b$export$2e2bcd8739ae039)(object, path);
        if (predicate(value, path)) (0, $16d52dd8de1034eb$export$2e2bcd8739ae039)(result, (0, $3281c6aec7b1af5b$export$2e2bcd8739ae039)(path, object), value);
    }
    return result;
}
var $034c132369d4c9f5$export$2e2bcd8739ae039 = $034c132369d4c9f5$var$basePickBy;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $b449890be02da008$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $b449890be02da008$export$2e2bcd8739ae039 = $b449890be02da008$var$baseHasIn;





/** `Object#toString` result references. */ var $441b21c3ff615585$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $441b21c3ff615585$var$baseIsArguments(value) {
    return (0, $12b35a1d6f51d03d$export$2e2bcd8739ae039)(value) && (0, $9b15b088b5f05768$export$2e2bcd8739ae039)(value) == $441b21c3ff615585$var$argsTag;
}
var $441b21c3ff615585$export$2e2bcd8739ae039 = $441b21c3ff615585$var$baseIsArguments;



/** Used for built-in method references. */ var $af98781099b078da$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $af98781099b078da$var$hasOwnProperty = $af98781099b078da$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $af98781099b078da$var$propertyIsEnumerable = $af98781099b078da$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $af98781099b078da$var$isArguments = (0, $441b21c3ff615585$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $441b21c3ff615585$export$2e2bcd8739ae039) : function(value) {
    return (0, $12b35a1d6f51d03d$export$2e2bcd8739ae039)(value) && $af98781099b078da$var$hasOwnProperty.call(value, "callee") && !$af98781099b078da$var$propertyIsEnumerable.call(value, "callee");
};
var $af98781099b078da$export$2e2bcd8739ae039 = $af98781099b078da$var$isArguments;




/** Used as references for various `Number` constants. */ var $85e964891d7c59e6$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $85e964891d7c59e6$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $85e964891d7c59e6$var$MAX_SAFE_INTEGER;
}
var $85e964891d7c59e6$export$2e2bcd8739ae039 = $85e964891d7c59e6$var$isLength;



/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $f038ef27f8a033e9$var$hasPath(object, path, hasFunc) {
    path = (0, $3281c6aec7b1af5b$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $5a52b012f527fd8b$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $85e964891d7c59e6$export$2e2bcd8739ae039)(length) && (0, $4a17ca83a682a8ec$export$2e2bcd8739ae039)(key, length) && ((0, $1e1752ba20547388$export$2e2bcd8739ae039)(object) || (0, $af98781099b078da$export$2e2bcd8739ae039)(object));
}
var $f038ef27f8a033e9$export$2e2bcd8739ae039 = $f038ef27f8a033e9$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $bc4649f325999590$var$hasIn(object, path) {
    return object != null && (0, $f038ef27f8a033e9$export$2e2bcd8739ae039)(object, path, (0, $b449890be02da008$export$2e2bcd8739ae039));
}
var $bc4649f325999590$export$2e2bcd8739ae039 = $bc4649f325999590$var$hasIn;


/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $71aa8fbb956005ef$var$basePick(object, paths) {
    return (0, $034c132369d4c9f5$export$2e2bcd8739ae039)(object, paths, function(value, path) {
        return (0, $bc4649f325999590$export$2e2bcd8739ae039)(object, path);
    });
}
var $71aa8fbb956005ef$export$2e2bcd8739ae039 = $71aa8fbb956005ef$var$basePick;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $b89a1ddf24057e86$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $b89a1ddf24057e86$export$2e2bcd8739ae039 = $b89a1ddf24057e86$var$arrayPush;





/** Built-in value references. */ var $a426efb23533eebe$var$spreadableSymbol = (0, $213ba81f8d233690$export$2e2bcd8739ae039) ? (0, $213ba81f8d233690$export$2e2bcd8739ae039).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $a426efb23533eebe$var$isFlattenable(value) {
    return (0, $1e1752ba20547388$export$2e2bcd8739ae039)(value) || (0, $af98781099b078da$export$2e2bcd8739ae039)(value) || !!($a426efb23533eebe$var$spreadableSymbol && value && value[$a426efb23533eebe$var$spreadableSymbol]);
}
var $a426efb23533eebe$export$2e2bcd8739ae039 = $a426efb23533eebe$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $871373df25110aff$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $a426efb23533eebe$export$2e2bcd8739ae039));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $871373df25110aff$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $b89a1ddf24057e86$export$2e2bcd8739ae039)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $871373df25110aff$export$2e2bcd8739ae039 = $871373df25110aff$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $ff889d71de4dc96b$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $871373df25110aff$export$2e2bcd8739ae039)(array, 1) : [];
}
var $ff889d71de4dc96b$export$2e2bcd8739ae039 = $ff889d71de4dc96b$var$flatten;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $a3a46d2bc27fac9b$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $a3a46d2bc27fac9b$export$2e2bcd8739ae039 = $a3a46d2bc27fac9b$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $e77c398c65791961$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $e77c398c65791961$var$overRest(func, start, transform) {
    start = $e77c398c65791961$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $e77c398c65791961$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $a3a46d2bc27fac9b$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $e77c398c65791961$export$2e2bcd8739ae039 = $e77c398c65791961$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $14787307a1c81a02$var$constant(value) {
    return function() {
        return value;
    };
}
var $14787307a1c81a02$export$2e2bcd8739ae039 = $14787307a1c81a02$var$constant;



/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0db74ad790c2f67a$var$identity(value) {
    return value;
}
var $0db74ad790c2f67a$export$2e2bcd8739ae039 = $0db74ad790c2f67a$var$identity;


/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $311796813c8a1c1a$var$baseSetToString = !(0, $4ebc8e06beafd880$export$2e2bcd8739ae039) ? (0, $0db74ad790c2f67a$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $4ebc8e06beafd880$export$2e2bcd8739ae039)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $14787307a1c81a02$export$2e2bcd8739ae039)(string),
        "writable": true
    });
};
var $311796813c8a1c1a$export$2e2bcd8739ae039 = $311796813c8a1c1a$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $e38f144d8eeef262$var$HOT_COUNT = 800, $e38f144d8eeef262$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e38f144d8eeef262$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $e38f144d8eeef262$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $e38f144d8eeef262$var$nativeNow(), remaining = $e38f144d8eeef262$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $e38f144d8eeef262$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $e38f144d8eeef262$export$2e2bcd8739ae039 = $e38f144d8eeef262$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $31a596daad90a909$var$setToString = (0, $e38f144d8eeef262$export$2e2bcd8739ae039)((0, $311796813c8a1c1a$export$2e2bcd8739ae039));
var $31a596daad90a909$export$2e2bcd8739ae039 = $31a596daad90a909$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $b9b8c3325512b9a6$var$flatRest(func) {
    return (0, $31a596daad90a909$export$2e2bcd8739ae039)((0, $e77c398c65791961$export$2e2bcd8739ae039)(func, undefined, (0, $ff889d71de4dc96b$export$2e2bcd8739ae039)), func + "");
}
var $b9b8c3325512b9a6$export$2e2bcd8739ae039 = $b9b8c3325512b9a6$var$flatRest;


/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $7b4876663da3b34b$var$pick = (0, $b9b8c3325512b9a6$export$2e2bcd8739ae039)(function(object, paths) {
    return object == null ? {} : (0, $71aa8fbb956005ef$export$2e2bcd8739ae039)(object, paths);
});
var $7b4876663da3b34b$export$2e2bcd8739ae039 = $7b4876663da3b34b$var$pick;




var $5NSbj = parcelRequire("5NSbj");


function $837434887dc9a867$export$2e2bcd8739ae039({ spoutParamName: spoutParamName, spoutParam: spoutParam, params: params = {}, sourceErrors: sourceErrors, sourceId: sourceId, setEditedSource: setEditedSource, setDirty: setDirty }) {
    const updateSourceParam = (0, $5NSbj.useCallback)((event)=>{
        setDirty(true);
        setEditedSource(({ params: params, ...restSource })=>({
                ...restSource,
                params: {
                    ...params,
                    [spoutParamName]: event.target.value
                }
            }));
    }, [
        setEditedSource,
        setDirty,
        spoutParamName
    ]);
    const updateSourceParamBool = (0, $5NSbj.useCallback)((event)=>updateSourceParam({
            target: {
                value: event.target.checked ? "1" : undefined
            }
        }), [
        updateSourceParam
    ]);
    let value = spoutParamName in params ? params[spoutParamName] : spoutParam.default;
    let control = null;
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    if ([
        "text",
        "checkbox",
        "url"
    ].includes(spoutParam.type)) {
        let checked = undefined;
        if (spoutParam.type === "checkbox") {
            checked = value == "1";
            // Value always has to be 1 since HTML sends [name]=[value] when a checkbox is checked
            // and omits the field altogether from HTTP request when not checked.
            value = "1";
        }
        control = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
            id: `${spoutParamName}-${sourceId}`,
            type: spoutParam.type,
            name: spoutParamName,
            value: value,
            checked: checked,
            onChange: spoutParam.type !== "checkbox" ? updateSourceParam : updateSourceParamBool
        });
    } else if (spoutParam.type === "password") control = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
        id: `${spoutParamName}-${sourceId}`,
        type: spoutParam.type,
        name: spoutParamName,
        placeholder: _("source_pwd_placeholder"),
        onChange: updateSourceParam
    });
    else if (spoutParam.type === "select") control = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("select", {
        id: `${spoutParamName}-${sourceId}`,
        name: spoutParamName,
        size: "1",
        value: value,
        onChange: updateSourceParam,
        children: Object.entries(spoutParam.values).map(([optionName, optionTitle])=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("option", {
                value: optionName,
                children: optionTitle
            }, optionName))
    });
    else return null;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                htmlFor: `${spoutParamName}-${sourceId}`,
                children: spoutParam.title
            }),
            control,
            sourceErrors[spoutParamName] ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                className: "error",
                children: sourceErrors[spoutParamName]
            }) : null
        ]
    });
}
$837434887dc9a867$export$2e2bcd8739ae039.propTypes = {
    spoutParamName: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string.isRequired,
    spoutParam: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    params: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    sourceErrors: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string).isRequired,
    sourceId: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    setEditedSource: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    setDirty: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};




function $3972545cf57eb298$export$722fbec263ad908a(id, values) {
    return $7d3633f2d0caaef5$export$299ba2dee77727e9(`source/${id}`, {
        headers: {
            "content-type": "application/json; charset=utf-8"
        },
        body: JSON.stringify(values),
        failOnHttpErrors: false
    }).promise.then($7d3633f2d0caaef5$export$8d90b058a02656d9((response)=>response.ok || response.status === 400)).then((response)=>response.json());
}
function $3972545cf57eb298$export$c1f8f7c408fa54a(id) {
    return $7d3633f2d0caaef5$export$299ba2dee77727e9("source/" + id + "/update", {
        timeout: 0
    }).promise;
}
function $3972545cf57eb298$export$c5eb18431f66026b() {
    return $7d3633f2d0caaef5$export$3988ae62b71be9a3("update", {
        headers: {
            "Accept": "text/event-stream"
        },
        timeout: 0
    }).promise.then((response)=>response.text());
}
function $3972545cf57eb298$export$cd7f480d6b8286c3(id) {
    return $7d3633f2d0caaef5$export$38dab5a9fea42f39(`source/${id}`).promise;
}
function $3972545cf57eb298$export$316f19f1ddc6b34e(abortController) {
    return $7d3633f2d0caaef5$export$3988ae62b71be9a3("sources", {
        abortController: abortController
    }).promise.then((response)=>response.json());
}
function $3972545cf57eb298$export$ba43f46f09336c84() {
    return $7d3633f2d0caaef5$export$3988ae62b71be9a3("source").promise.then((response)=>response.json());
}
function $3972545cf57eb298$export$d72d2378a998c10c(spoutClass) {
    return $7d3633f2d0caaef5$export$3988ae62b71be9a3("source/params", {
        body: $7d3633f2d0caaef5$export$92871f7982deaf9f({
            spout: spoutClass
        })
    }).promise.then((res)=>res.json());
}
function $3972545cf57eb298$export$432f698644f45d1() {
    return $7d3633f2d0caaef5$export$3988ae62b71be9a3("sources/stats").promise.then((response)=>response.json());
}




const $5a6da2536ef5e06f$var$FAST_DURATION_MS = 200;
// cancel source editing
function $5a6da2536ef5e06f$var$handleCancel({ source: source, sourceElem: sourceElem, setSources: setSources, setEditedSource: setEditedSource }) {
    const id = source.id;
    if (id.toString().startsWith("new-")) (0, $11fdf00616b3f275$export$c091916f1530334c)(sourceElem.current, {
        duration: $5a6da2536ef5e06f$var$FAST_DURATION_MS,
        complete: ()=>{
            // Remove the source from this page’s model.
            setSources((sources)=>sources.filter((source)=>source.id !== id));
        }
    });
    else // Hide the input form.
    setEditedSource(null);
}
// save source
function $5a6da2536ef5e06f$var$handleSave({ event: event, setSources: setSources, source: source, setEditedSource: setEditedSource, setSourceActionLoading: setSourceActionLoading, setJustSavedTimeout: setJustSavedTimeout, setSourceErrors: setSourceErrors }) {
    event.preventDefault();
    // remove old errors
    setSourceErrors({});
    setSourceActionLoading(true);
    const newSource = source;
    const { id: id, tags: tags, filter: filter, params: params, ...restSource } = source;
    // Make tags into a list.
    const tagsList = tags ? tags.split(",").map((tag)=>tag.trim()).filter((tag)=>tag !== "") : [];
    const values = {
        ...restSource,
        ...params,
        tags: tagsList,
        filter: filter || null
    };
    $3972545cf57eb298$export$722fbec263ad908a(id, values).then((response)=>{
        if (!response.success) setSourceErrors(response);
        else {
            // Set justSavedTimeout state variable to a timeout.
            // The view will show “saved” text while the timeout runs.
            setJustSavedTimeout((oldTimeout)=>{
                // Only keep the most recent timeout.
                if (oldTimeout !== null) clearTimeout(oldTimeout);
                return window.setTimeout(()=>{
                    setJustSavedTimeout(null);
                }, 10000);
            });
            // Hide the input form.
            setEditedSource(null);
            // Update tags and sources for navigation.
            selfoss.app.setTags(response.tags);
            selfoss.app.setTagsState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
            selfoss.app.setSources(response.sources);
            selfoss.app.setSourcesState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
            // Update sources in this page’s model.
            setSources((sources)=>sources.map((source)=>{
                    if (source.id === id) return {
                        ...newSource,
                        id: response.id,
                        tags: tagsList,
                        // Use fetched title.
                        title: response.title
                    };
                    else return source;
                }));
        }
    }).catch((error)=>{
        selfoss.app.showError(selfoss.app._("error_edit_source") + " " + error.message);
    }).finally(()=>{
        setSourceActionLoading(false);
    });
}
// delete source
function $5a6da2536ef5e06f$var$handleDelete({ source: source, sourceElem: sourceElem, setSources: setSources, setSourceBeingDeleted: setSourceBeingDeleted, setDirty: setDirty }) {
    const answer = confirm(selfoss.app._("source_warn"));
    if (answer == false) return;
    // get id
    const id = source.id;
    setDirty(false);
    // show loading
    setSourceBeingDeleted(true);
    // delete on server
    $3972545cf57eb298$export$cd7f480d6b8286c3(id).then(()=>{
        (0, $11fdf00616b3f275$export$c091916f1530334c)(sourceElem.current, {
            duration: $5a6da2536ef5e06f$var$FAST_DURATION_MS,
            complete: ()=>{
                // Remove the source from this page’s model.
                setSources((sources)=>sources.filter((source)=>source.id !== id));
            }
        });
        // Reload tags and remove source from navigation.
        selfoss.reloadTags();
        selfoss.app.setSources((sources)=>sources.filter((source)=>source.id !== id));
    }).catch((error)=>{
        setSourceBeingDeleted(false);
        selfoss.app.showError(selfoss.app._("error_delete_source") + " " + error.message);
    });
}
// start editing
function $5a6da2536ef5e06f$var$handleEdit({ event: event, source: source, setEditedSource: setEditedSource }) {
    event.preventDefault();
    const { id: id, title: title, tags: tags, filter: filter, spout: spout, params: params } = source;
    setEditedSource({
        id: id,
        title: title ? (0, $ec6aeee77f582aff$export$e8bacd2802a88316)(title) : "",
        tags: tags ? tags.map((0, $ec6aeee77f582aff$export$e8bacd2802a88316)).join(",") : "",
        filter: filter,
        spout: spout,
        params: params
    });
}
// select new source spout type
function $5a6da2536ef5e06f$var$handleSpoutChange({ event: event, setSpouts: setSpouts, updateEditedSource: updateEditedSource, setSourceParamsLoading: setSourceParamsLoading, setSourceParamsError: setSourceParamsError }) {
    const spoutClass = event.target.value;
    updateEditedSource({
        spout: spoutClass
    });
    if (spoutClass.trim().length === 0) return;
    setSourceParamsLoading(true);
    $3972545cf57eb298$export$d72d2378a998c10c(spoutClass).then(({ spout: spout })=>{
        setSourceParamsLoading(false);
        setSpouts((spouts)=>({
                ...spouts,
                [spoutClass]: spout
            }));
        const defaults = Object.fromEntries(Object.entries(spout.params).map(([param, props])=>[
                param,
                props["default"] ?? ""
            ]));
        updateEditedSource((source)=>{
            const oldCompatibleParams = (0, $7b4876663da3b34b$export$2e2bcd8739ae039)(source.params, Object.keys(spout.params));
            return {
                params: {
                    ...defaults,
                    ...oldCompatibleParams
                }
            };
        });
    }).catch((error)=>{
        setSourceParamsLoading(false);
        setSourceParamsError(error.message);
    });
}
// Taken from https://stackoverflow.com/a/15289883/160386
const $5a6da2536ef5e06f$var$MS_PER_DAY = 86400000;
function $5a6da2536ef5e06f$var$daysAgo(date) {
    // Get number of days between now and when the last entry was seen
    // Note: The time of the two dates is set to midnight
    // to get the difference of the two dates in calendar days
    // instead of a day equaling any 24 hour period which makes it
    // impossible to distinguish today and yesterday.
    const now = new Date();
    const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const old = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return Math.floor((today - old) / $5a6da2536ef5e06f$var$MS_PER_DAY);
}
function $5a6da2536ef5e06f$var$SourceEditForm({ source: source, sourceElem: sourceElem, sourceError: sourceError, setSources: setSources, spouts: spouts, setSpouts: setSpouts, setEditedSource: setEditedSource, sourceActionLoading: sourceActionLoading, setSourceActionLoading: setSourceActionLoading, sourceParamsLoading: sourceParamsLoading, setSourceParamsLoading: setSourceParamsLoading, sourceParamsError: sourceParamsError, setSourceParamsError: setSourceParamsError, setJustSavedTimeout: setJustSavedTimeout, sourceErrors: sourceErrors, setSourceErrors: setSourceErrors, dirty: dirty, setDirty: setDirty }) {
    const sourceId = source.id;
    const updateEditedSource = (0, $5NSbj.useCallback)((changes)=>{
        setDirty(true);
        if (typeof changes === "function") setEditedSource((source)=>({
                ...source,
                ...changes(source)
            }));
        else setEditedSource((source)=>({
                ...source,
                ...changes
            }));
    }, [
        setEditedSource,
        setDirty
    ]);
    const titleOnChange = (0, $5NSbj.useCallback)((event)=>updateEditedSource({
            title: event.target.value
        }), [
        updateEditedSource
    ]);
    const tagsOnChange = (0, $5NSbj.useCallback)((event)=>updateEditedSource({
            tags: event.target.value
        }), [
        updateEditedSource
    ]);
    const filterOnChange = (0, $5NSbj.useCallback)((event)=>updateEditedSource({
            filter: event.target.value
        }), [
        updateEditedSource
    ]);
    const spoutOnChange = (0, $5NSbj.useCallback)((event)=>$5a6da2536ef5e06f$var$handleSpoutChange({
            event: event,
            setSpouts: setSpouts,
            updateEditedSource: updateEditedSource,
            setSourceParamsLoading: setSourceParamsLoading,
            setSourceParamsError: setSourceParamsError
        }), [
        setSpouts,
        updateEditedSource,
        setSourceParamsLoading,
        setSourceParamsError
    ]);
    const saveOnClick = (0, $5NSbj.useCallback)((event)=>{
        setDirty(false);
        $5a6da2536ef5e06f$var$handleSave({
            event: event,
            setSources: setSources,
            source: source,
            setEditedSource: setEditedSource,
            setSourceActionLoading: setSourceActionLoading,
            setJustSavedTimeout: setJustSavedTimeout,
            setSourceErrors: setSourceErrors
        });
    }, [
        setSources,
        source,
        setEditedSource,
        setSourceActionLoading,
        setJustSavedTimeout,
        setSourceErrors,
        setDirty
    ]);
    const cancelOnClick = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        if (dirty) {
            const answer = confirm(selfoss.app._("source_warn_cancel_dirty"));
            if (answer === false) return;
        }
        setDirty(false);
        $5a6da2536ef5e06f$var$handleCancel({
            event: event,
            source: source,
            sourceElem: sourceElem,
            setSources: setSources,
            setEditedSource: setEditedSource
        });
    }, [
        source,
        sourceElem,
        setSources,
        setEditedSource,
        dirty,
        setDirty
    ]);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    const sourceParamsContent = sourceParamsLoading ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $6efe1fd0084e29cd$export$7f7cbe89f1eacd2), {
        size: "3x",
        label: _("source_params_loading")
    }) : sourceParamsError ?? (Object.keys(spouts).includes(source.spout) && Object.keys(spouts[source.spout].params).length > 0 ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
        children: Object.entries(spouts[source.spout].params).map(([spoutParamName, spoutParam])=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $837434887dc9a867$export$2e2bcd8739ae039), {
                params: source.params,
                spoutParamName: spoutParamName,
                spoutParam: spoutParam,
                sourceErrors: sourceErrors,
                sourceId: sourceId,
                setEditedSource: setEditedSource,
                setDirty: setDirty
            }, spoutParamName))
    }) : null);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("form", {
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
            className: "source-edit-form",
            children: [
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: `title-${sourceId}`,
                            children: _("source_title")
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            id: `title-${sourceId}`,
                            type: "text",
                            name: "title",
                            accessKey: "t",
                            value: source.title ?? "",
                            placeholder: _("source_autotitle_hint"),
                            onChange: titleOnChange,
                            autoFocus: true
                        }),
                        sourceErrors["title"] ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors["title"]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: `tags-${sourceId}`,
                            children: _("source_tags")
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            id: `tags-${sourceId}`,
                            type: "text",
                            name: "tags",
                            accessKey: "g",
                            value: source.tags ?? "",
                            onChange: tagsOnChange
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("span", {
                            className: "source-edit-form-help",
                            children: [
                                " ",
                                _("source_comma")
                            ]
                        }),
                        sourceErrors["tags"] ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors["tags"]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: `filter-${sourceId}`,
                            children: _("source_filter")
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            id: `filter-${sourceId}`,
                            type: "text",
                            name: "filter",
                            accessKey: "f",
                            value: source.filter ?? "",
                            onChange: filterOnChange
                        }),
                        sourceErrors["filter"] ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors["filter"]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: `type-${sourceId}`,
                            children: _("source_type")
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("select", {
                            id: `type-${sourceId}`,
                            className: "source-spout",
                            name: "spout",
                            accessKey: "y",
                            onChange: spoutOnChange,
                            value: source.spout,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("option", {
                                    value: "",
                                    children: _("source_select")
                                }),
                                Object.entries(spouts).map(([spouttype, spout])=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("option", {
                                        title: spout.description,
                                        value: spouttype,
                                        children: spout.name
                                    }, spouttype))
                            ]
                        }),
                        sourceErrors["spout"] ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors["spout"]
                        }) : null
                    ]
                }),
                sourceParamsContent ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    className: "source-params",
                    children: sourceParamsContent
                }) : null,
                sourceError ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    className: "source-error",
                    "aria-live": "assertive",
                    children: sourceError
                }) : null,
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    className: "source-action",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            type: "submit",
                            className: "source-save",
                            accessKey: "s",
                            onClick: saveOnClick,
                            children: [
                                _("source_save"),
                                sourceActionLoading && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $6efe1fd0084e29cd$export$7f7cbe89f1eacd2), {
                                            label: _("source_saving")
                                        })
                                    ]
                                })
                            ]
                        }),
                        " \u2022 ",
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                            type: "submit",
                            className: "source-cancel",
                            accessKey: "c",
                            onClick: cancelOnClick,
                            children: _("source_cancel")
                        })
                    ]
                })
            ]
        })
    });
}
$5a6da2536ef5e06f$var$SourceEditForm.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    sourceElem: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    sourceError: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    spouts: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    setSpouts: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    setEditedSource: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    sourceActionLoading: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    setSourceActionLoading: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    sourceParamsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    setSourceParamsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    sourceParamsError: (0, (/*@__PURE__*/$parcel$interopDefault($ea2d4a6a4b369f4b$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string).isRequired,
    setSourceParamsError: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    setJustSavedTimeout: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    sourceErrors: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string).isRequired,
    setSourceErrors: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    dirty: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    setDirty: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};
function $5a6da2536ef5e06f$export$2e2bcd8739ae039({ source: source, setSources: setSources, spouts: spouts, setSpouts: setSpouts, dirty: dirty, setDirtySources: setDirtySources }) {
    const isNew = !source.title;
    const classes = {
        source: true,
        "source-new": isNew,
        error: source.error && source.error.length > 0
    };
    const [editedSource, setEditedSource] = (0, $5NSbj.useState)(isNew ? {
        ...source
    } : null);
    const [sourceActionLoading, setSourceActionLoading] = (0, $5NSbj.useState)(false);
    const [sourceBeingDeleted, setSourceBeingDeleted] = (0, $5NSbj.useState)(false);
    const [sourceParamsLoading, setSourceParamsLoading] = (0, $5NSbj.useState)(false);
    const [justSavedTimeout, setJustSavedTimeout] = (0, $5NSbj.useState)(null);
    const [sourceParamsError, setSourceParamsError] = (0, $5NSbj.useState)(null);
    const [sourceErrors, setSourceErrors] = (0, $5NSbj.useState)({});
    (0, $5NSbj.useEffect)(()=>{
        // Prevent timeout from trying to update state after unmount.
        const oldTimeout = justSavedTimeout;
        return ()=>{
            if (oldTimeout !== null) clearTimeout(oldTimeout);
        };
    }, [
        justSavedTimeout
    ]);
    const editOnClick = (0, $5NSbj.useCallback)((event)=>$5a6da2536ef5e06f$var$handleEdit({
            event: event,
            source: source,
            setEditedSource: setEditedSource
        }), [
        source
    ]);
    const setDirty = (0, $5NSbj.useCallback)((dirty)=>{
        setDirtySources((dirtySources)=>({
                ...dirtySources,
                [source.id]: dirty
            }));
    }, [
        source.id,
        setDirtySources
    ]);
    const history = (0, $88361e604f4abd56$export$3420e1dc2c4a518c)();
    const location = (0, $88361e604f4abd56$export$45d76561a5302f2b)();
    const sourceElem = (0, $5NSbj.useRef)(null);
    const extraMenuOnSelection = (0, $5NSbj.useCallback)(({ value: value })=>{
        if (value === "delete") $5a6da2536ef5e06f$var$handleDelete({
            source: source,
            sourceElem: sourceElem,
            setSources: setSources,
            setSourceBeingDeleted: setSourceBeingDeleted,
            setDirty: setDirty
        });
        else if (value === "browse") history.push((0, $7c8cbf542ee98bec$export$d0bb2ab5375d1521)(location, {
            category: `source-${source.id}`
        }));
    }, [
        source,
        sourceElem,
        setSources,
        setDirty,
        location,
        history
    ]);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))(classes),
        "data-id": source.id,
        id: `source-${source.id}`,
        ref: sourceElem,
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                className: "source-icon",
                children: source.icon && source.icon != "0" ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("img", {
                    src: `favicons/${source.icon}`,
                    "aria-hidden": "true",
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h2", {
                className: "source-title",
                children: source.title ? (0, $ec6aeee77f582aff$export$e8bacd2802a88316)(source.title) : _("source_new")
            }),
            " ",
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                className: "source-edit-delete",
                children: [
                    !editedSource && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                                type: "button",
                                accessKey: "e",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                    "source-showparams": true,
                                    saved: justSavedTimeout !== null
                                }),
                                onClick: editOnClick,
                                "aria-expanded": !!editedSource,
                                children: _(justSavedTimeout !== null ? "source_saved" : "source_edit")
                            }),
                            " \u2022 "
                        ]
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $bd4c4042067d9063$export$d9b273488cd8ce6f), {
                        onItemClick: extraMenuOnSelection,
                        menuButton: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $c5b00af6cfe5984a$export$266a769812832828), {
                            className: "source-menu-button",
                            children: [
                                _("source_menu"),
                                sourceBeingDeleted && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $6efe1fd0084e29cd$export$7f7cbe89f1eacd2), {
                                            label: _("source_deleting")
                                        })
                                    ]
                                })
                            ]
                        }),
                        menuClassName: "popup-menu",
                        children: [
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $2f8c26b01cf457e1$export$2ce376c2cc3355c8), {
                                accessKey: "d",
                                className: "popup-menu-item source-browse",
                                value: "browse",
                                children: _("source_browse")
                            }),
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $2f8c26b01cf457e1$export$2ce376c2cc3355c8), {
                                accessKey: "d",
                                className: "popup-menu-item source-delete",
                                value: "delete",
                                children: _("source_delete")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                className: "source-days",
                children: source.lastentry ? ` \u{2022} ${_("source_last_post")} ${_("days", [
                    $5a6da2536ef5e06f$var$daysAgo(new Date(source.lastentry * 1000))
                ])}` : null
            }),
            editedSource ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($5a6da2536ef5e06f$var$SourceEditForm, {
                setSources: setSources,
                spouts: spouts,
                setSpouts: setSpouts,
                setEditedSource: setEditedSource,
                sourceActionLoading: sourceActionLoading,
                setSourceActionLoading: setSourceActionLoading,
                sourceParamsLoading: sourceParamsLoading,
                setSourceParamsLoading: setSourceParamsLoading,
                sourceParamsError: sourceParamsError,
                setSourceParamsError: setSourceParamsError,
                setJustSavedTimeout: setJustSavedTimeout,
                sourceErrors: sourceErrors,
                setSourceErrors: setSourceErrors,
                dirty: dirty,
                setDirty: setDirty,
                sourceElem: sourceElem,
                sourceError: source.error,
                source: editedSource
            }) : null
        ]
    });
}
$5a6da2536ef5e06f$export$2e2bcd8739ae039.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    spouts: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    setSpouts: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    dirty: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    setDirtySources: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};






var $5NSbj = parcelRequire("5NSbj");


var $5NSbj = parcelRequire("5NSbj");
/**
 * useMediaMatch
 *
 * A react hook that signals whether or not a media query is matched.
 *
 * @param query The media query to signal on. Example, `"print"` will signal
 * `true` when previewing in print mode, and `false` otherwise.
 * @returns Whether or not the media query is currently matched.
 * @see https://rooks.vercel.app/docs/useMediaMatch
 */ function $e7a20526a850bf87$export$b1eecdc553bff745(query) {
    const matchMedia = (0, $5NSbj.useMemo)(()=>window.matchMedia(query), [
        query
    ]);
    const [matches, setMatches] = (0, $5NSbj.useState)(()=>matchMedia.matches);
    (0, $5NSbj.useEffect)(()=>{
        setMatches(matchMedia.matches);
        const listener = (event)=>setMatches(event.matches);
        if (matchMedia.addEventListener) {
            matchMedia.addEventListener("change", listener);
            return ()=>matchMedia.removeEventListener("change", listener);
        } else {
            matchMedia.addListener(listener);
            return ()=>matchMedia.removeListener(listener);
        }
    }, [
        matchMedia
    ]);
    if (typeof window === "undefined") {
        console.warn("useMediaMatch cannot function as window is undefined.");
        return false;
    }
    return matches;
}


function $cdbcc1ec15a05191$export$7bcdf1c247ef07b1() {
    const location = (0, $88361e604f4abd56$export$45d76561a5302f2b)();
    const forceReload = location?.state?.forceReload;
    const [oldForceReload, setOldForceReload] = (0, $5NSbj.useState)(forceReload);
    if (oldForceReload !== forceReload) setOldForceReload(forceReload);
    // The location state is not persisted during navigation
    // so forceReload would change to undefined on successive navigation,
    // triggering an unwanter reload.
    // We use a separate counter to prevent that.
    const [reloadCounter, setReloadCounter] = (0, $5NSbj.useState)(0);
    if (forceReload !== undefined && forceReload !== oldForceReload) {
        const newReloadCounter = reloadCounter + 1;
        setReloadCounter(newReloadCounter);
        return newReloadCounter;
    }
    return reloadCounter;
}
function $cdbcc1ec15a05191$export$443718c44347a6b3() {
    return (0, $e7a20526a850bf87$export$b1eecdc553bff745)("(max-width: 641px)");
}
function $cdbcc1ec15a05191$export$96b5b894afc1d2e3(valueListenable) {
    const [value, setValue] = (0, $5NSbj.useState)(valueListenable.value);
    (0, $5NSbj.useEffect)(()=>{
        const listener = (event)=>{
            setValue(event.value);
        };
        // It might happen that values change between creating the component and setting up the event handlers.
        listener({
            value: valueListenable.value
        });
        valueListenable.addEventListener("change", listener);
        return ()=>{
            valueListenable.removeEventListener("change", listener);
        };
    }, [
        valueListenable
    ]);
    return value;
}




function $354786050498b51e$var$rand() {
    // https://www.php.net/manual/en/function.mt-getrandmax.php#117620
    return Math.floor(Math.random() * 2147483647);
}
function $354786050498b51e$var$handleAddSource({ event: event = null, setSources: setSources, setSpouts: setSpouts, extraInitialData: extraInitialData = {} }) {
    if (event) event.preventDefault();
    // Add new empty source.
    setSources((sources)=>[
            {
                id: "new-" + $354786050498b51e$var$rand(),
                ...extraInitialData
            },
            ...sources
        ]);
    // Refresh the spout datea
    $3972545cf57eb298$export$ba43f46f09336c84().then(({ spouts: spouts })=>{
        // Update spout data.
        setSpouts(spouts);
    }).catch(()=>{
        console.error("Unable to update spouts, falling back to previously fetched list.");
    });
}
// load sources
function $354786050498b51e$var$loadSources({ abortController: abortController, location: location, setSpouts: setSpouts, setSources: setSources, setLoadingState: setLoadingState }) {
    if (abortController.signal.aborted) return Promise.resolve();
    setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING);
    return (0, $3972545cf57eb298$export$316f19f1ddc6b34e)(abortController).then(({ sources: sources, spouts: spouts })=>{
        if (abortController.signal.aborted) return;
        setSpouts(spouts);
        setSources(sources);
        setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
        if (location.hash.startsWith("#source-")) {
            const source = document.querySelector(`.source[data-id="${location.hash.replace(/^#source-/, "")}"]`);
            if (!source) return;
            // needs to be delayed for some reason
            requestAnimationFrame(()=>{
                source.scrollIntoView();
            });
        }
    }).catch((error)=>{
        if (error.name === "AbortError" || abortController.signal.aborted) return;
        selfoss.handleAjaxError(error, false).catch((error)=>{
            if (error instanceof (0, $506fdaa0545346a2$export$65bd6083489bd8bb) && error.response.status === 403) {
                selfoss.history.push("/sign/in", {
                    error: selfoss.app._("error_session_expired")
                });
                return;
            }
            selfoss.app.showError(selfoss.app._("error_loading") + " " + error.message);
        });
        setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).FAILURE);
    });
}
function $354786050498b51e$export$2e2bcd8739ae039() {
    const [spouts, setSpouts] = (0, $5NSbj.useState)([]);
    const [sources, setSources] = (0, $5NSbj.useState)([]);
    const [loadingState, setLoadingState] = (0, $5NSbj.useState)((0, $c097b691ff08d4e3$export$62aa48085237e36f).INITIAL);
    const forceReload = (0, $cdbcc1ec15a05191$export$7bcdf1c247ef07b1)();
    const history = (0, $88361e604f4abd56$export$3420e1dc2c4a518c)();
    const location = (0, $88361e604f4abd56$export$45d76561a5302f2b)();
    const isAdding = (0, $88361e604f4abd56$export$632be4bb944c1bc7)("/manage/sources/add");
    (0, $5NSbj.useEffect)(()=>{
        const abortController = new AbortController();
        $354786050498b51e$var$loadSources({
            abortController: abortController,
            location: location,
            setSpouts: setSpouts,
            setSources: setSources,
            setLoadingState: setLoadingState
        }).then(()=>{
            if (isAdding) {
                const params = new URLSearchParams(location.search);
                $354786050498b51e$var$handleAddSource({
                    setSources: setSources,
                    setSpouts: setSpouts,
                    extraInitialData: {
                        spout: "spouts\\rss\\feed",
                        params: {
                            url: params.get("url") ?? ""
                        }
                    }
                });
                // Clear the value from the state so it does not bug us forever.
                history.replace("/manage/sources");
            }
        });
        return ()=>{
            abortController.abort();
        };
    }, [
        forceReload
    ]);
    const addOnClick = (0, $5NSbj.useCallback)((event)=>$354786050498b51e$var$handleAddSource({
            event: event,
            setSources: setSources,
            setSpouts: setSpouts
        }), []);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    const [dirtySources, setDirtySources] = (0, $5NSbj.useState)({});
    const isDirty = (0, $5NSbj.useMemo)(()=>Object.values(dirtySources).includes(true), [
        dirtySources
    ]);
    if (loadingState === (0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING) return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $6efe1fd0084e29cd$export$84dbad74efe95918), {
        label: _("sources_loading")
    });
    if (loadingState !== (0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS) return null;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $88361e604f4abd56$export$83716a4aa1642908), {
                when: isDirty,
                message: _("sources_leaving_unsaved_prompt")
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                className: "source-add",
                onClick: addOnClick,
                children: _("source_add")
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
                className: "source-export",
                href: "opmlexport",
                children: _("source_export")
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
                className: "source-opml",
                to: "/opml",
                children: _("source_opml")
            }),
            sources ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                children: sources.map((source)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $5a6da2536ef5e06f$export$2e2bcd8739ae039), {
                        dirty: dirtySources[source.id] ?? false,
                        source: source,
                        setSources: setSources,
                        spouts: spouts,
                        setSpouts: setSpouts,
                        setDirtySources: setDirtySources
                    }, source.id))
            }) : /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
                children: _("no_sources")
            })
        ]
    });
}




var $5NSbj = parcelRequire("5NSbj");



var $7f88ad86c77db2c7$exports = {};
"use strict";
Object.defineProperty($7f88ad86c77db2c7$exports, "__esModule", {
    value: true
});
$7f88ad86c77db2c7$exports.useStateWithDeps = $7f88ad86c77db2c7$var$useStateWithDeps;

var $5NSbj = parcelRequire("5NSbj");
var $9b6079926271415c$exports = {};
"use strict";
Object.defineProperty($9b6079926271415c$exports, "__esModule", {
    value: true
});
$9b6079926271415c$exports.useForceUpdate = $9b6079926271415c$var$useForceUpdate;

var $5NSbj = parcelRequire("5NSbj");
function $9b6079926271415c$var$_slicedToArray(arr, i) {
    return $9b6079926271415c$var$_arrayWithHoles(arr) || $9b6079926271415c$var$_iterableToArrayLimit(arr, i) || $9b6079926271415c$var$_unsupportedIterableToArray(arr, i) || $9b6079926271415c$var$_nonIterableRest();
}
function $9b6079926271415c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9b6079926271415c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9b6079926271415c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9b6079926271415c$var$_arrayLikeToArray(o, minLen);
}
function $9b6079926271415c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9b6079926271415c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9b6079926271415c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9b6079926271415c$var$useForceUpdate() {
    var _useReducer = (0, $5NSbj.useReducer)(function(x) {
        return !x;
    }, false), _useReducer2 = $9b6079926271415c$var$_slicedToArray(_useReducer, 2), forceUpdate = _useReducer2[1];
    return function() {
        return forceUpdate();
    };
}


var $f446ed18a2496453$exports = {};
"use strict";
Object.defineProperty($f446ed18a2496453$exports, "__esModule", {
    value: true
});
$f446ed18a2496453$exports.depsAreEqual = $f446ed18a2496453$var$depsAreEqual;
function $f446ed18a2496453$var$depsAreEqual(prevDeps, deps) {
    return prevDeps.length === deps.length && deps.every(function(dep, index) {
        return Object.is(dep, prevDeps[index]);
    });
}


var $15e1f0f410678794$exports = {};
"use strict";
Object.defineProperty($15e1f0f410678794$exports, "__esModule", {
    value: true
});
$15e1f0f410678794$exports.isFunction = $15e1f0f410678794$var$isFunction;
// eslint-disable-next-line @typescript-eslint/ban-types
function $15e1f0f410678794$var$isFunction(input) {
    return typeof input === "function";
}


/**
 * `useState` hook with an additional dependency array that resets
 * the state to the `initialState` param when the dependencies passed
 * in the `deps` array change.
 *
 * @param initialState
 * The state that will be set when the component mounts or the
 * dependencies change.
 *
 * It can also be a function which resolves to the state. If the state
 * is reset due to a change of dependencies, this function will be called with the previous
 * state (`undefined` for the first call upon mount).
 * @param deps Dependencies for this hook that resets the state to `initialState`
 */ function $7f88ad86c77db2c7$var$useStateWithDeps(initialState, deps) {
    var isMounted = (0, $5NSbj.useRef)(false); // Determine initial state
    var usableInitialState = null;
    if (!isMounted.current) {
        isMounted.current = true;
        if ((0, $15e1f0f410678794$exports.isFunction)(initialState)) usableInitialState = initialState();
        else usableInitialState = initialState;
    } // It would be possible to use useState instead of
    // useRef to store the state, however this would
    // trigger re-renders whenever the state is reset due
    // to a change in dependencies. In order to avoid these
    // re-renders, the state is stored in a ref and an
    // update is triggered via forceUpdate below when necessary
    var state = (0, $5NSbj.useRef)(usableInitialState); // Check if dependencies have changed
    var prevDeps = (0, $5NSbj.useRef)(deps);
    if (!(0, $f446ed18a2496453$exports.depsAreEqual)(prevDeps.current, deps)) {
        // Update state and deps
        var nextState;
        if ((0, $15e1f0f410678794$exports.isFunction)(initialState)) nextState = initialState(state.current);
        else nextState = initialState;
        state.current = nextState;
        prevDeps.current = deps;
    }
    var forceUpdate = (0, $9b6079926271415c$exports.useForceUpdate)();
    var updateState = (0, $5NSbj.useCallback)(function updateState(newState) {
        var nextState;
        if ((0, $15e1f0f410678794$exports.isFunction)(newState)) nextState = newState(state.current);
        else nextState = newState;
        if (!Object.is(state.current, nextState)) {
            state.current = nextState;
            forceUpdate();
        }
    }, []);
    return [
        state.current,
        updateState
    ];
}





var $5NSbj = parcelRequire("5NSbj");



var $5NSbj = parcelRequire("5NSbj");
/**
 * usePreviousImmediate hook for React
 *
 * @param currentValue The value whose previous value is to be tracked
 * @returns The previous value
 * @see https://rooks.vercel.app/docs/usePreviousImmediate
 */ function $7591aa31d7cb8c81$export$f6f3f74729fdd0b7(currentValue) {
    const previousRef = (0, $5NSbj.useRef)(null);
    (0, $5NSbj.useEffect)(()=>{
        previousRef.current = currentValue;
    });
    return previousRef.current;
}




/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ /*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $2a6aaf9039da226f$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $2a6aaf9039da226f$var$candidateSelector = /* #__PURE__ */ $2a6aaf9039da226f$var$candidateSelectors.join(",");
var $2a6aaf9039da226f$var$NoElement = typeof Element === "undefined";
var $2a6aaf9039da226f$var$matches = $2a6aaf9039da226f$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $2a6aaf9039da226f$var$getRootNode = !$2a6aaf9039da226f$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $2a6aaf9039da226f$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $2a6aaf9039da226f$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $2a6aaf9039da226f$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($2a6aaf9039da226f$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($2a6aaf9039da226f$var$candidateSelector));
    if (includeContainer && $2a6aaf9039da226f$var$matches.call(el, $2a6aaf9039da226f$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $2a6aaf9039da226f$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($2a6aaf9039da226f$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $2a6aaf9039da226f$var$matches.call(element, $2a6aaf9039da226f$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$2a6aaf9039da226f$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $2a6aaf9039da226f$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $2a6aaf9039da226f$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $2a6aaf9039da226f$var$isContentEditable(node)) && !$2a6aaf9039da226f$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $2a6aaf9039da226f$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $2a6aaf9039da226f$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$2a6aaf9039da226f$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $2a6aaf9039da226f$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $2a6aaf9039da226f$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $2a6aaf9039da226f$var$isHiddenInput = function isHiddenInput(node) {
    return $2a6aaf9039da226f$var$isInput(node) && node.type === "hidden";
};
var $2a6aaf9039da226f$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $2a6aaf9039da226f$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $2a6aaf9039da226f$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $2a6aaf9039da226f$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $2a6aaf9039da226f$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $2a6aaf9039da226f$var$isRadio = function isRadio(node) {
    return $2a6aaf9039da226f$var$isInput(node) && node.type === "radio";
};
var $2a6aaf9039da226f$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $2a6aaf9039da226f$var$isRadio(node) && !$2a6aaf9039da226f$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $2a6aaf9039da226f$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $2a6aaf9039da226f$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $2a6aaf9039da226f$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $2a6aaf9039da226f$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $2a6aaf9039da226f$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $2a6aaf9039da226f$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($2a6aaf9039da226f$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $2a6aaf9039da226f$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $2a6aaf9039da226f$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($2a6aaf9039da226f$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $2a6aaf9039da226f$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $2a6aaf9039da226f$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $2a6aaf9039da226f$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $2a6aaf9039da226f$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $2a6aaf9039da226f$var$isInert(node) || $2a6aaf9039da226f$var$isHiddenInput(node) || $2a6aaf9039da226f$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $2a6aaf9039da226f$var$isDetailsWithSummary(node) || $2a6aaf9039da226f$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $2a6aaf9039da226f$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($2a6aaf9039da226f$var$isNonTabbableRadio(node) || $2a6aaf9039da226f$export$a4672efddb4181b8(node) < 0 || !$2a6aaf9039da226f$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $2a6aaf9039da226f$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $2a6aaf9039da226f$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $2a6aaf9039da226f$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($2a6aaf9039da226f$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $2a6aaf9039da226f$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $2a6aaf9039da226f$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $2a6aaf9039da226f$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $2a6aaf9039da226f$var$isValidShadowRootTabbable
    });
    else candidates = $2a6aaf9039da226f$var$getCandidates(container, options.includeContainer, $2a6aaf9039da226f$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $2a6aaf9039da226f$var$sortByOrder(candidates);
};
var $2a6aaf9039da226f$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $2a6aaf9039da226f$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $2a6aaf9039da226f$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $2a6aaf9039da226f$var$getCandidates(container, options.includeContainer, $2a6aaf9039da226f$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $2a6aaf9039da226f$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($2a6aaf9039da226f$var$matches.call(node, $2a6aaf9039da226f$var$candidateSelector) === false) return false;
    return $2a6aaf9039da226f$var$isNodeMatchingSelectorTabbable(options, node);
};
var $2a6aaf9039da226f$var$focusableCandidateSelector = /* #__PURE__ */ $2a6aaf9039da226f$var$candidateSelectors.concat("iframe").join(",");
var $2a6aaf9039da226f$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($2a6aaf9039da226f$var$matches.call(node, $2a6aaf9039da226f$var$focusableCandidateSelector) === false) return false;
    return $2a6aaf9039da226f$var$isNodeMatchingSelectorFocusable(options, node);
};


function $66c441288a5fbbb7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66c441288a5fbbb7$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66c441288a5fbbb7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $66c441288a5fbbb7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66c441288a5fbbb7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $66c441288a5fbbb7$var$_defineProperty(obj, key, value) {
    key = $66c441288a5fbbb7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $66c441288a5fbbb7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $66c441288a5fbbb7$var$_toPropertyKey(arg) {
    var key = $66c441288a5fbbb7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var $66c441288a5fbbb7$var$activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap.pause();
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0) trapStack[trapStack.length - 1].unpause();
    }
};
var $66c441288a5fbbb7$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var $66c441288a5fbbb7$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $66c441288a5fbbb7$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $66c441288a5fbbb7$var$isKeyForward = function isKeyForward(e) {
    return $66c441288a5fbbb7$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $66c441288a5fbbb7$var$isKeyBackward = function isKeyBackward(e) {
    return $66c441288a5fbbb7$var$isTabEvent(e) && e.shiftKey;
};
var $66c441288a5fbbb7$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var $66c441288a5fbbb7$var$findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $66c441288a5fbbb7$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var $66c441288a5fbbb7$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $66c441288a5fbbb7$var$internalTrapStack = [];
var $66c441288a5fbbb7$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $66c441288a5fbbb7$var$internalTrapStack;
    var config = $66c441288a5fbbb7$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: $66c441288a5fbbb7$var$isKeyForward,
        isKeyBackward: $66c441288a5fbbb7$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption("initialFocus");
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || !(0, $2a6aaf9039da226f$export$4c063cf1350e6fed)(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $2a6aaf9039da226f$export$17100aea90429aa7)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $2a6aaf9039da226f$export$ecc6d1fcdff4f700)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $2a6aaf9039da226f$export$a4672efddb4181b8)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
        ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/ var getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === getActiveElement(document)) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($66c441288a5fbbb7$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref2) {
        var target = _ref2.target, event = _ref2.event, _ref2$isBackward = _ref2.isBackward, isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
        target = target || $66c441288a5fbbb7$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = $66c441288a5fbbb7$var$findIndex(state.tabbableGroups, function(_ref3) {
                    var firstTabbableNode = _ref3.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $2a6aaf9039da226f$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $2a6aaf9039da226f$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$66c441288a5fbbb7$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = $66c441288a5fbbb7$var$findIndex(state.tabbableGroups, function(_ref4) {
                    var lastTabbableNode = _ref4.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $2a6aaf9039da226f$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $2a6aaf9039da226f$export$a4672efddb4181b8)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$66c441288a5fbbb7$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption("fallbackFocus");
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $66c441288a5fbbb7$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($66c441288a5fbbb7$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($66c441288a5fbbb7$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $66c441288a5fbbb7$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $2a6aaf9039da226f$export$a4672efddb4181b8)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $2a6aaf9039da226f$export$a4672efddb4181b8)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) tryFocus(nextNode);
            else tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($66c441288a5fbbb7$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(event) {
        if ($66c441288a5fbbb7$var$isEscapeEvent(event) && $66c441288a5fbbb7$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
            return;
        }
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    var checkClick = function checkClick(e) {
        var target = $66c441288a5fbbb7$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($66c441288a5fbbb7$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($66c441288a5fbbb7$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $66c441288a5fbbb7$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $66c441288a5fbbb7$var$delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $66c441288a5fbbb7$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $66c441288a5fbbb7$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $66c441288a5fbbb7$var$delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (state.paused || !state.active) return this;
            var onPause = getOption(pauseOptions, "onPause");
            var onPostPause = getOption(pauseOptions, "onPostPause");
            state.paused = true;
            onPause === null || onPause === void 0 || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === void 0 || onPostPause();
            return this;
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.paused || !state.active) return this;
            var onUnpause = getOption(unpauseOptions, "onUnpause");
            var onPostUnpause = getOption(unpauseOptions, "onPostUnpause");
            state.paused = false;
            onUnpause === null || onUnpause === void 0 || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};




var $5NSbj = parcelRequire("5NSbj");
function $49b55be3b2a6e8d6$export$3b062b02b4537682() {
    return (0, $cdbcc1ec15a05191$export$96b5b894afc1d2e3)(selfoss.loggedin);
}
function $49b55be3b2a6e8d6$export$f5bdb3b3cec7f803() {
    const loggedIn = $49b55be3b2a6e8d6$export$3b062b02b4537682();
    return (0, $5NSbj.useMemo)(()=>selfoss.isAllowedToRead(), [
        loggedIn
    ]);
}
function $49b55be3b2a6e8d6$export$683005ba76038aff() {
    const loggedIn = $49b55be3b2a6e8d6$export$3b062b02b4537682();
    return (0, $5NSbj.useMemo)(()=>selfoss.isAllowedToUpdate(), [
        loggedIn
    ]);
}
function $49b55be3b2a6e8d6$export$b416b77cd328c02f() {
    const loggedIn = $49b55be3b2a6e8d6$export$3b062b02b4537682();
    return (0, $5NSbj.useMemo)(()=>selfoss.isAllowedToWrite(), [
        loggedIn
    ]);
}






const $72f11e9f95fb1286$export$cacd6541cfeeb6c1 = {
    PREV: "prev",
    NEXT: "next"
};
function $72f11e9f95fb1286$export$d976747ecb966cea(target) {
    const viewportHeight = document.body.clientHeight;
    const viewportScrollTop = window.scrollY;
    const targetBb = target.getBoundingClientRect();
    const targetTop = window.scrollY + targetBb.top;
    const targetHeight = targetBb.height;
    // scroll down
    if (viewportScrollTop + viewportHeight < targetTop + targetHeight + 80) {
        if (targetHeight > viewportHeight) window.scrollTo({
            top: targetTop
        });
        else {
            const marginTop = (viewportHeight - targetHeight) / 2;
            const scrollTop = targetTop - marginTop;
            window.scrollTo({
                top: scrollTop
            });
        }
    }
    // scroll up
    if (targetTop <= viewportScrollTop) window.scrollTo({
        top: targetTop
    });
}




var $5NSbj = parcelRequire("5NSbj");

var $1766ce9febb68b06$exports = {};
var $b3f095897a2a15c4$exports = {};
function $b3f095897a2a15c4$var$_arrayReduce(reducer, acc, list) {
    var index = 0;
    var length = list.length;
    while(index < length){
        acc = reducer(acc, list[index]);
        index += 1;
    }
    return acc;
}
$b3f095897a2a15c4$exports = $b3f095897a2a15c4$var$_arrayReduce;



var $73c64daa93a8819d$exports = {};

var $86add80f0c251f70$exports = {};
function $86add80f0c251f70$var$_isTransformer(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}
$86add80f0c251f70$exports = $86add80f0c251f70$var$_isTransformer;


/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer created by [transducerCreator] to return a new transformer
 * (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} transducerCreator transducer factory if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */ function $73c64daa93a8819d$var$_dispatchable(methodNames, transducerCreator, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var obj = arguments[arguments.length - 1];
        if (!$ba1de13db1e87172$exports(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
                idx += 1;
            }
            if ($86add80f0c251f70$exports(obj)) {
                var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}
$73c64daa93a8819d$exports = $73c64daa93a8819d$var$_dispatchable;


var $199a9bffa9acc914$exports = {};
function $199a9bffa9acc914$var$_map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}
$199a9bffa9acc914$exports = $199a9bffa9acc914$var$_map;


var $bcb7553705419549$exports = {};
var $3862c4e8edd52321$exports = {};
$3862c4e8edd52321$exports = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};


var $bcb7553705419549$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype["@@transducer/init"] = $3862c4e8edd52321$exports.init;
    XMap.prototype["@@transducer/result"] = $3862c4e8edd52321$exports.result;
    XMap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, this.f(input));
    };
    return XMap;
}();
var $bcb7553705419549$var$_xmap = function _xmap(f) {
    return function(xf) {
        return new $bcb7553705419549$var$XMap(f, xf);
    };
};
$bcb7553705419549$exports = $bcb7553705419549$var$_xmap;


var $3740a839312e525e$exports = {};



var $f188947f79ac2c90$exports = {};


/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $f188947f79ac2c90$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        var hasPlaceholder = false;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$fd1d129950ecf19e$exports(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$fd1d129950ecf19e$exports(result)) left -= 1;
            else hasPlaceholder = true;
            combinedIdx += 1;
        }
        return !hasPlaceholder && left <= 0 ? fn.apply(this, combined) : $e54479dfc8e6276d$exports(Math.max(0, left), $f188947f79ac2c90$var$_curryN(length, combined, fn));
    };
}
$f188947f79ac2c90$exports = $f188947f79ac2c90$var$_curryN;


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $3740a839312e525e$var$curryN = /*#__PURE__*/ $11b3c3fd62c22b91$exports(function curryN(length, fn) {
    if (length === 1) return $7930f30efbe644a1$exports(fn);
    return $e54479dfc8e6276d$exports(length, $f188947f79ac2c90$exports(length, [], fn));
});
$3740a839312e525e$exports = $3740a839312e525e$var$curryN;


var $f69bceee8d75a960$exports = {};


var $dace07fd8f8db19f$exports = {};

var $dace07fd8f8db19f$var$toString = Object.prototype.toString;
var $dace07fd8f8db19f$var$_isArguments = /*#__PURE__*/ function() {
    return $dace07fd8f8db19f$var$toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return $dace07fd8f8db19f$var$toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return $b67b11238be38685$exports("callee", x);
    };
}();
$dace07fd8f8db19f$exports = $dace07fd8f8db19f$var$_isArguments;


var $f69bceee8d75a960$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var $f69bceee8d75a960$var$nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
];
// Safari bug
var $f69bceee8d75a960$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var $f69bceee8d75a960$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $f69bceee8d75a960$var$keys = typeof Object.keys === "function" && !$f69bceee8d75a960$var$hasArgsEnumBug ? /*#__PURE__*/ $7930f30efbe644a1$exports(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ $7930f30efbe644a1$exports(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $f69bceee8d75a960$var$hasArgsEnumBug && $dace07fd8f8db19f$exports(obj);
    for(prop in obj)if ($b67b11238be38685$exports(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if ($f69bceee8d75a960$var$hasEnumBug) {
        nIdx = $f69bceee8d75a960$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $f69bceee8d75a960$var$nonEnumerableProps[nIdx];
            if ($b67b11238be38685$exports(prop, obj) && !$f69bceee8d75a960$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
$f69bceee8d75a960$exports = $f69bceee8d75a960$var$keys;


/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $1766ce9febb68b06$var$map = /*#__PURE__*/ $11b3c3fd62c22b91$exports(/*#__PURE__*/ $73c64daa93a8819d$exports([
    "fantasy-land/map",
    "map"
], $bcb7553705419549$exports, function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case "[object Function]":
            return $3740a839312e525e$exports(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case "[object Object]":
            return $b3f095897a2a15c4$exports(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, $f69bceee8d75a960$exports(functor));
        default:
            return $199a9bffa9acc914$exports(fn, functor);
    }
}));
$1766ce9febb68b06$exports = $1766ce9febb68b06$var$map;




function $f686a1f3350288b9$var$materializeSharerIcon(sharer) {
    const { icon: icon } = sharer;
    return {
        ...sharer,
        icon: typeof icon === "string" && icon.includes("<") ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: icon
            }
        }) : icon
    };
}
function $f686a1f3350288b9$export$aebedbd51beb48eb({ configuration: configuration, _: _ }) {
    return (0, $5NSbj.useMemo)(()=>{
        const availableSharers = {
            "a": {
                label: _("share_native_label"),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $1788f2b1ea8f3501$exports.faShareAlt
                }),
                action: ({ url: url, title: title })=>{
                    navigator.share({
                        title: title,
                        url: url
                    }).catch((e)=>{
                        if (e.name === "AbortError") (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.showError(_("error_share_native_abort"));
                        else (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.showError(_("error_share_native"));
                    });
                },
                available: "share" in navigator
            },
            "d": {
                label: _("share_diaspora_label"),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $3af4382a42f8c157$exports.faDiaspora
                }),
                action: ({ url: url, title: title })=>{
                    window.open("https://share.diasporafoundation.org/?url=" + encodeURIComponent(url) + "&title=" + encodeURIComponent(title), undefined, "noreferrer");
                }
            },
            "t": {
                label: _("share_twitter_label"),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $d7e8063e124a7dab$exports.faTwitter
                }),
                action: ({ url: url, title: title })=>{
                    window.open("https://twitter.com/intent/tweet?source=webclient&text=" + encodeURIComponent(title) + " " + encodeURIComponent(url), undefined, "noreferrer");
                }
            },
            "f": {
                label: _("share_facebook_label"),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $164536c7567608d5$exports.faFacebookSquare
                }),
                action: ({ url: url, title: title })=>{
                    window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url) + "&t=" + encodeURIComponent(title), undefined, "noreferrer");
                }
            },
            "m": {
                label: _("share_mastodon_label"),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $e15eeddf947b426f$exports.faMastodon
                }),
                action: ({ url: url, title: title })=>{
                    window.open(configuration.mastodon + "/share?text=" + encodeURIComponent('"' + title + '"\n' + url), undefined, "noreferrer");
                },
                available: configuration.mastodon !== null
            },
            "p": {
                label: _("share_pocket_label"),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $d7a77b6f799d2f63$exports.faGetPocket
                }),
                action: ({ url: url, title: title })=>{
                    window.open("https://getpocket.com/save?url=" + encodeURIComponent(url) + "&title=" + encodeURIComponent(title), undefined, "noreferrer");
                }
            },
            "w": {
                label: _("share_wallabag_label"),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $3f033ef2cbff8b8d$export$a67558cb68d63c7e
                }),
                action: ({ url: url })=>{
                    if (configuration.wallabag.version === 2) window.open(configuration.wallabag.url + "/bookmarklet?url=" + encodeURIComponent(url), undefined, "noreferrer");
                    else window.open(configuration.wallabag.url + "/?action=add&url=" + btoa(url), undefined, "noreferrer");
                },
                available: configuration.wallabag !== null
            },
            "s": {
                label: _("share_wordpress_label"),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $ee1da5f4ecb633d4$exports.faWordpressSimple
                }),
                action: ({ url: url, title: title })=>{
                    window.open(configuration.wordpress + "/wp-admin/press-this.php?u=" + encodeURIComponent(url) + "&t=" + encodeURIComponent(title), undefined, "noreferrer");
                },
                available: configuration.wordpress !== null
            },
            "e": {
                label: _("share_mail_label"),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $9ba76af6c08a1d33$exports.faEnvelope
                }),
                action: ({ url: url, title: title })=>{
                    document.location.href = "mailto:?body=" + encodeURIComponent(url) + "&subject=" + encodeURIComponent(title);
                }
            },
            "c": {
                label: _("share_copy_label"),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $9e163d018ad3ce2a$exports.faCopy
                }),
                action: ({ url: url })=>{
                    navigator.clipboard.writeText(url).then(()=>{
                        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.showMessage(_("info_url_copied"));
                    });
                }
            },
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1766ce9febb68b06$exports)))($f686a1f3350288b9$var$materializeSharerIcon, (0, $ee388dae0165e99c$export$2e2bcd8739ae039).customSharers ?? {})
        };
        const enabledSharers = [];
        for (const letter of configuration.share){
            const sharer = availableSharers[letter];
            if (sharer !== undefined && (sharer.available ?? true)) {
                const { label: label, icon: icon, action: action } = sharer;
                enabledSharers.push({
                    key: letter,
                    label: label,
                    icon: icon,
                    action: action
                });
            }
        }
        return enabledSharers;
    }, [
        configuration,
        _
    ]);
}



var $5NSbj = parcelRequire("5NSbj");
const $f848676e0d96e999$export$83fe3bee12eb51bb = "carousel";
const $f848676e0d96e999$export$b861c6f4d58b4c2f = "controller";
const $f848676e0d96e999$export$607ce719f0ec9b98 = "navigation";
const $f848676e0d96e999$export$52cbc29cf5406ba8 = "no-scroll";
const $f848676e0d96e999$export$9d2e4856063e1a22 = "portal";
const $f848676e0d96e999$export$62f3c66ae8dab8a3 = "root";
const $f848676e0d96e999$export$5414719b40b8294f = "toolbar";
const $f848676e0d96e999$export$a23b14c1465897d = "captions";
const $f848676e0d96e999$export$8ae0dbe553798d04 = "counter";
const $f848676e0d96e999$export$ace9d67c0f2290af = "download";
const $f848676e0d96e999$export$4792108761b262a9 = "fullscreen";
const $f848676e0d96e999$export$c21ea5a712f18fb6 = "inline";
const $f848676e0d96e999$export$6bbdc870e6ef9c88 = "share";
const $f848676e0d96e999$export$be7dc72e63e6ef2e = "slideshow";
const $f848676e0d96e999$export$6bf9d56640f46f01 = "thumbnails";
const $f848676e0d96e999$export$929980e2a2c57ecf = "zoom";
const $f848676e0d96e999$export$554a1415841c52a8 = "loading";
const $f848676e0d96e999$export$38ce62e512432ebb = "playing";
const $f848676e0d96e999$export$2ed3c80dbc178d91 = "error";
const $f848676e0d96e999$export$a195e517d37aaa33 = "complete";
const $f848676e0d96e999$export$e51f1c6d74b54a13 = "placeholder";
const $f848676e0d96e999$export$6751782e799f6445 = (status)=>`active-slide-${status}`;
const $f848676e0d96e999$export$7ab73e7383503259 = $f848676e0d96e999$export$6751782e799f6445($f848676e0d96e999$export$554a1415841c52a8);
const $f848676e0d96e999$export$ccb5eb0b2db52ae8 = $f848676e0d96e999$export$6751782e799f6445($f848676e0d96e999$export$38ce62e512432ebb);
const $f848676e0d96e999$export$817be438d1d0e4cf = $f848676e0d96e999$export$6751782e799f6445($f848676e0d96e999$export$2ed3c80dbc178d91);
const $f848676e0d96e999$export$2ec1d32caeb97dfe = $f848676e0d96e999$export$6751782e799f6445($f848676e0d96e999$export$a195e517d37aaa33);
const $f848676e0d96e999$export$37b171d829eeeaa2 = "fullsize";
const $f848676e0d96e999$export$974a68ef150451f5 = "flex_center";
const $f848676e0d96e999$export$b6426a00c33a0175 = "no_scroll";
const $f848676e0d96e999$export$651541414233b476 = "no_scroll_padding";
const $f848676e0d96e999$export$ac396c284080b10c = "slide_wrapper";
const $f848676e0d96e999$export$a007161537026955 = "prev";
const $f848676e0d96e999$export$f1d7a854db833ed4 = "next";
const $f848676e0d96e999$export$c43bd1a4101c4078 = "swipe";
const $f848676e0d96e999$export$493a596486210a21 = "close";
const $f848676e0d96e999$export$e15fc153f45a963d = "onPointerDown";
const $f848676e0d96e999$export$1f8863949fbdd7e5 = "onPointerMove";
const $f848676e0d96e999$export$2d868b67a5791b8a = "onPointerUp";
const $f848676e0d96e999$export$526cafa85592f1a5 = "onPointerLeave";
const $f848676e0d96e999$export$22151cee048c4be9 = "onPointerCancel";
const $f848676e0d96e999$export$1aba4f3521686ca9 = "onKeyDown";
const $f848676e0d96e999$export$bdb9f99d61a6879b = "onKeyUp";
const $f848676e0d96e999$export$5635dc9d647242c7 = "onWheel";
const $f848676e0d96e999$export$e8d60d9b5ceff7c0 = "Escape";
const $f848676e0d96e999$export$17dec1da9b0e2eb3 = "ArrowLeft";
const $f848676e0d96e999$export$91898c0e7e48903 = "ArrowRight";
const $f848676e0d96e999$export$d62fb7722b07f2f3 = "button";
const $f848676e0d96e999$export$c5f5ca1963fed141 = "icon";
const $f848676e0d96e999$export$eff7fe5eefd707ad = "contain";
const $f848676e0d96e999$export$9a9f12fc3f1c1e4f = "cover";
const $f848676e0d96e999$export$b149fc25cb186fec = "Unknown action type";



"use client";
const $ce68a3edc3fc357d$var$cssPrefix$3 = "yarl__";
function $ce68a3edc3fc357d$export$4f5d2d50c9deca37(...classes) {
    return [
        ...classes
    ].filter(Boolean).join(" ");
}
function $ce68a3edc3fc357d$export$1283875077dc8f0a(name) {
    return `${$ce68a3edc3fc357d$var$cssPrefix$3}${name}`;
}
function $ce68a3edc3fc357d$export$8b4981022bd80a4e(name) {
    return `--${$ce68a3edc3fc357d$var$cssPrefix$3}${name}`;
}
function $ce68a3edc3fc357d$export$195c4126907dde97(base, prefix) {
    return `${base}${prefix ? `_${prefix}` : ""}`;
}
function $ce68a3edc3fc357d$export$3e7cd27eed1727c(base) {
    return (prefix)=>$ce68a3edc3fc357d$export$195c4126907dde97(base, prefix);
}
function $ce68a3edc3fc357d$export$1237798dc640739a(labels, defaultLabel) {
    var _a;
    return (_a = labels === null || labels === void 0 ? void 0 : labels[defaultLabel]) !== null && _a !== void 0 ? _a : defaultLabel;
}
function $ce68a3edc3fc357d$export$de863c629cb9919d(...cleaners) {
    return ()=>{
        cleaners.forEach((cleaner)=>{
            cleaner();
        });
    };
}
function $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0(name, contextName, context) {
    return ()=>{
        const ctx = $5NSbj.useContext(context);
        if (!ctx) throw new Error(`${name} must be used within a ${contextName}.Provider`);
        return ctx;
    };
}
function $ce68a3edc3fc357d$export$fef62134eea24008() {
    return typeof window !== "undefined";
}
function $ce68a3edc3fc357d$export$2077e0241d6afd3c(value, decimals = 0) {
    const factor = 10 ** decimals;
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
function $ce68a3edc3fc357d$export$55ec18c411514c07(slide) {
    return slide.type === undefined || slide.type === "image";
}
function $ce68a3edc3fc357d$export$f5ba2f5b3fd12e6e(image, imageFit) {
    return image.imageFit === (0, $f848676e0d96e999$export$9a9f12fc3f1c1e4f) || image.imageFit !== (0, $f848676e0d96e999$export$eff7fe5eefd707ad) && imageFit === (0, $f848676e0d96e999$export$9a9f12fc3f1c1e4f);
}
function $ce68a3edc3fc357d$export$5f87784a266e50a4(value) {
    return typeof value === "string" ? Number.parseInt(value, 10) : value;
}
function $ce68a3edc3fc357d$export$7871fb532d320d99(input) {
    if (typeof input === "number") return {
        pixel: input
    };
    if (typeof input === "string") {
        const value = $ce68a3edc3fc357d$export$5f87784a266e50a4(input);
        return input.endsWith("%") ? {
            percent: value
        } : {
            pixel: value
        };
    }
    return {
        pixel: 0
    };
}
function $ce68a3edc3fc357d$export$7ff571008bce9900(containerRect, padding) {
    const paddingValue = $ce68a3edc3fc357d$export$7871fb532d320d99(padding);
    const paddingPixels = paddingValue.percent !== undefined ? containerRect.width / 100 * paddingValue.percent : paddingValue.pixel;
    return {
        width: Math.max(containerRect.width - 2 * paddingPixels, 0),
        height: Math.max(containerRect.height - 2 * paddingPixels, 0)
    };
}
function $ce68a3edc3fc357d$export$508f096bfcdaac40() {
    return ($ce68a3edc3fc357d$export$fef62134eea24008() ? window === null || window === void 0 ? void 0 : window.devicePixelRatio : undefined) || 1;
}
function $ce68a3edc3fc357d$export$501611100333094a(index, slidesCount) {
    return slidesCount > 0 ? (index % slidesCount + slidesCount) % slidesCount : 0;
}
function $ce68a3edc3fc357d$export$883ece934910f98d(slides) {
    return slides.length > 0;
}
function $ce68a3edc3fc357d$export$cdfb855c5eb3bc84(slides, index) {
    return slides[$ce68a3edc3fc357d$export$501611100333094a(index, slides.length)];
}
function $ce68a3edc3fc357d$export$9f2f3fed4fdffdfc(slides, index) {
    return $ce68a3edc3fc357d$export$883ece934910f98d(slides) ? $ce68a3edc3fc357d$export$cdfb855c5eb3bc84(slides, index) : undefined;
}
function $ce68a3edc3fc357d$export$b2184449b7659b5a(slide) {
    return $ce68a3edc3fc357d$export$55ec18c411514c07(slide) ? slide.src : undefined;
}
function $ce68a3edc3fc357d$export$34ce6a408311d810(toolbar, key, button) {
    if (!button) return toolbar;
    const { buttons: buttons, ...restToolbar } = toolbar;
    const index = buttons.findIndex((item)=>item === key);
    const buttonWithKey = $5NSbj.isValidElement(button) ? $5NSbj.cloneElement(button, {
        key: key
    }, null) : button;
    if (index >= 0) {
        const result = [
            ...buttons
        ];
        result.splice(index, 1, buttonWithKey);
        return {
            buttons: result,
            ...restToolbar
        };
    }
    return {
        buttons: [
            buttonWithKey,
            ...buttons
        ],
        ...restToolbar
    };
}
function $ce68a3edc3fc357d$export$e88693bab67822d1() {
    const stopPropagation = (event)=>{
        event.stopPropagation();
    };
    return {
        onPointerDown: stopPropagation,
        onKeyDown: stopPropagation,
        onWheel: stopPropagation
    };
}
function $ce68a3edc3fc357d$export$aab7f3145c728301(carousel, slides, minimum = 0) {
    return Math.min(carousel.preload, Math.max(carousel.finite ? slides.length - 1 : Math.floor(slides.length / 2), minimum));
}
const $ce68a3edc3fc357d$export$d626463445cef3e9 = {
    open: false,
    close: ()=>{},
    index: 0,
    slides: [],
    render: {},
    plugins: [],
    toolbar: {
        buttons: [
            (0, $f848676e0d96e999$export$493a596486210a21)
        ]
    },
    labels: {},
    animation: {
        fade: 250,
        swipe: 500,
        easing: {
            fade: "ease",
            swipe: "ease-out",
            navigation: "ease-in-out"
        }
    },
    carousel: {
        finite: false,
        preload: 2,
        padding: "16px",
        spacing: "30%",
        imageFit: (0, $f848676e0d96e999$export$eff7fe5eefd707ad),
        imageProps: {}
    },
    controller: {
        ref: null,
        focus: true,
        aria: false,
        touchAction: "none",
        closeOnPullUp: false,
        closeOnPullDown: false,
        closeOnBackdropClick: false,
        preventDefaultWheelX: true,
        preventDefaultWheelY: false
    },
    portal: {},
    noScroll: {
        disabled: false
    },
    on: {},
    styles: {},
    className: ""
};
function $ce68a3edc3fc357d$export$c5ba3739ffba980d(name, component) {
    return {
        name: name,
        component: component
    };
}
function $ce68a3edc3fc357d$export$270e7ba5936d3c48(module, children) {
    return {
        module: module,
        children: children
    };
}
function $ce68a3edc3fc357d$var$traverseNode(node, target, apply) {
    if (node.module.name === target) return apply(node);
    if (node.children) return [
        $ce68a3edc3fc357d$export$270e7ba5936d3c48(node.module, node.children.flatMap((n)=>{
            var _a;
            return (_a = $ce68a3edc3fc357d$var$traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : [];
        }))
    ];
    return [
        node
    ];
}
function $ce68a3edc3fc357d$var$traverse(nodes, target, apply) {
    return nodes.flatMap((node)=>{
        var _a;
        return (_a = $ce68a3edc3fc357d$var$traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : [];
    });
}
function $ce68a3edc3fc357d$export$bc996c07eb970c78(root, plugins = [], augmentations = []) {
    let config = root;
    const contains = (target)=>{
        const nodes = [
            ...config
        ];
        while(nodes.length > 0){
            const node = nodes.pop();
            if ((node === null || node === void 0 ? void 0 : node.module.name) === target) return true;
            if (node === null || node === void 0 ? void 0 : node.children) nodes.push(...node.children);
        }
        return false;
    };
    const addParent = (target, module)=>{
        if (target === "") {
            config = [
                $ce68a3edc3fc357d$export$270e7ba5936d3c48(module, config)
            ];
            return;
        }
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>[
                $ce68a3edc3fc357d$export$270e7ba5936d3c48(module, [
                    node
                ])
            ]);
    };
    const append = (target, module)=>{
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>[
                $ce68a3edc3fc357d$export$270e7ba5936d3c48(node.module, [
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48(module, node.children)
                ])
            ]);
    };
    const addChild = (target, module, precede)=>{
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>{
            var _a;
            return [
                $ce68a3edc3fc357d$export$270e7ba5936d3c48(node.module, [
                    ...precede ? [
                        $ce68a3edc3fc357d$export$270e7ba5936d3c48(module)
                    ] : [],
                    ...(_a = node.children) !== null && _a !== void 0 ? _a : [],
                    ...!precede ? [
                        $ce68a3edc3fc357d$export$270e7ba5936d3c48(module)
                    ] : []
                ])
            ];
        });
    };
    const addSibling = (target, module, precede)=>{
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>[
                ...precede ? [
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48(module)
                ] : [],
                node,
                ...!precede ? [
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48(module)
                ] : []
            ]);
    };
    const addModule = (module)=>{
        append((0, $f848676e0d96e999$export$b861c6f4d58b4c2f), module);
    };
    const replace = (target, module)=>{
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>[
                $ce68a3edc3fc357d$export$270e7ba5936d3c48(module, node.children)
            ]);
    };
    const remove = (target)=>{
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>node.children);
    };
    const augment = (augmentation)=>{
        augmentations.push(augmentation);
    };
    plugins.forEach((plugin)=>{
        plugin({
            contains: contains,
            addParent: addParent,
            append: append,
            addChild: addChild,
            addSibling: addSibling,
            addModule: addModule,
            replace: replace,
            remove: remove,
            augment: augment
        });
    });
    return {
        config: config,
        augmentation: (props)=>augmentations.reduce((acc, augmentation)=>augmentation(acc), props)
    };
}
const $ce68a3edc3fc357d$export$f4208dae105d4d3 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$91a992459f6e0f07 = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useEvents", "EventsContext", $ce68a3edc3fc357d$export$f4208dae105d4d3);
function $ce68a3edc3fc357d$export$686accdd53ac150f({ children: children }) {
    const [subscriptions] = $5NSbj.useState({});
    $5NSbj.useEffect(()=>()=>{
            Object.keys(subscriptions).forEach((topic)=>delete subscriptions[topic]);
        }, [
        subscriptions
    ]);
    const context = $5NSbj.useMemo(()=>{
        const unsubscribe = (topic, callback)=>{
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.splice(0, subscriptions[topic].length, ...subscriptions[topic].filter((cb)=>cb !== callback));
        };
        const subscribe = (topic, callback)=>{
            if (!subscriptions[topic]) subscriptions[topic] = [];
            subscriptions[topic].push(callback);
            return ()=>unsubscribe(topic, callback);
        };
        const publish = (...[topic, event])=>{
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.forEach((callback)=>callback(event));
        };
        return {
            publish: publish,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }, [
        subscriptions
    ]);
    return $5NSbj.createElement($ce68a3edc3fc357d$export$f4208dae105d4d3.Provider, {
        value: context
    }, children);
}
const $ce68a3edc3fc357d$export$9f6b9cbf1d54cc28 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$d930f3536e1c64f6 = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useLightboxProps", "LightboxPropsContext", $ce68a3edc3fc357d$export$9f6b9cbf1d54cc28);
function $ce68a3edc3fc357d$export$7141a340a3dea601({ children: children, ...props }) {
    return $5NSbj.createElement($ce68a3edc3fc357d$export$9f6b9cbf1d54cc28.Provider, {
        value: props
    }, children);
}
const $ce68a3edc3fc357d$export$c24db94cf7704d3a = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$566121e2bbc52eec = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useLightboxState", "LightboxStateContext", $ce68a3edc3fc357d$export$c24db94cf7704d3a);
const $ce68a3edc3fc357d$export$42eb31c6c0f01c10 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$9463bb14d6ba055e = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useLightboxDispatch", "LightboxDispatchContext", $ce68a3edc3fc357d$export$42eb31c6c0f01c10);
function $ce68a3edc3fc357d$var$reducer(state, action) {
    switch(action.type){
        case "swipe":
            {
                const { slides: slides } = state;
                const increment = (action === null || action === void 0 ? void 0 : action.increment) || 0;
                const globalIndex = state.globalIndex + increment;
                const currentIndex = $ce68a3edc3fc357d$export$501611100333094a(globalIndex, slides.length);
                const currentSlide = $ce68a3edc3fc357d$export$9f2f3fed4fdffdfc(slides, currentIndex);
                const animation = increment || action.duration ? {
                    increment: increment,
                    duration: action.duration,
                    easing: action.easing
                } : undefined;
                return {
                    slides: slides,
                    currentIndex: currentIndex,
                    globalIndex: globalIndex,
                    currentSlide: currentSlide,
                    animation: animation
                };
            }
        case "update":
            if (action.slides !== state.slides || action.index !== state.currentIndex) return {
                slides: action.slides,
                currentIndex: action.index,
                globalIndex: action.index,
                currentSlide: $ce68a3edc3fc357d$export$9f2f3fed4fdffdfc(action.slides, action.index)
            };
            return state;
        default:
            throw new Error((0, $f848676e0d96e999$export$b149fc25cb186fec));
    }
}
function $ce68a3edc3fc357d$export$62d2e1d2e7609988({ slides: slides, index: index, children: children }) {
    const [state, dispatch] = $5NSbj.useReducer($ce68a3edc3fc357d$var$reducer, {
        slides: slides,
        currentIndex: index,
        globalIndex: index,
        currentSlide: $ce68a3edc3fc357d$export$9f2f3fed4fdffdfc(slides, index)
    });
    $5NSbj.useEffect(()=>{
        dispatch({
            type: "update",
            slides: slides,
            index: index
        });
    }, [
        slides,
        index
    ]);
    const context = $5NSbj.useMemo(()=>({
            ...state,
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return $5NSbj.createElement($ce68a3edc3fc357d$export$42eb31c6c0f01c10.Provider, {
        value: dispatch
    }, $5NSbj.createElement($ce68a3edc3fc357d$export$c24db94cf7704d3a.Provider, {
        value: context
    }, children));
}
const $ce68a3edc3fc357d$export$e338b1178a56544e = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$1bc7162631c81b3f = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useTimeouts", "TimeoutsContext", $ce68a3edc3fc357d$export$e338b1178a56544e);
function $ce68a3edc3fc357d$export$9d9954f5885fa393({ children: children }) {
    const [timeouts] = $5NSbj.useState([]);
    $5NSbj.useEffect(()=>()=>{
            timeouts.forEach((tid)=>window.clearTimeout(tid));
            timeouts.splice(0, timeouts.length);
        }, [
        timeouts
    ]);
    const context = $5NSbj.useMemo(()=>{
        const removeTimeout = (id)=>{
            timeouts.splice(0, timeouts.length, ...timeouts.filter((tid)=>tid !== id));
        };
        const setTimeout = (fn, delay)=>{
            const id = window.setTimeout(()=>{
                removeTimeout(id);
                fn();
            }, delay);
            timeouts.push(id);
            return id;
        };
        const clearTimeout = (id)=>{
            if (id !== undefined) {
                removeTimeout(id);
                window.clearTimeout(id);
            }
        };
        return {
            setTimeout: setTimeout,
            clearTimeout: clearTimeout
        };
    }, [
        timeouts
    ]);
    return $5NSbj.createElement($ce68a3edc3fc357d$export$e338b1178a56544e.Provider, {
        value: context
    }, children);
}
const $ce68a3edc3fc357d$export$c25acd513dcc8062 = $5NSbj.forwardRef(function IconButton({ label: label$1, className: className, icon: Icon, renderIcon: renderIcon, onClick: onClick, style: style, ...rest }, ref) {
    const { styles: styles, labels: labels } = $ce68a3edc3fc357d$export$d930f3536e1c64f6();
    return $5NSbj.createElement("button", {
        ref: ref,
        type: "button",
        "aria-label": $ce68a3edc3fc357d$export$1237798dc640739a(labels, label$1),
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$d62fb7722b07f2f3)), className),
        onClick: onClick,
        style: {
            ...style,
            ...styles.button
        },
        ...rest
    }, renderIcon ? renderIcon() : $5NSbj.createElement(Icon, {
        className: $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$c5f5ca1963fed141)),
        style: styles.icon
    }));
});
function $ce68a3edc3fc357d$var$svgIcon(name, children) {
    const icon = (props)=>$5NSbj.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24",
            "aria-hidden": "true",
            focusable: "false",
            ...props
        }, children);
    icon.displayName = name;
    return icon;
}
function $ce68a3edc3fc357d$export$274edc73af1ae9c8(name, glyph) {
    return $ce68a3edc3fc357d$var$svgIcon(name, $5NSbj.createElement("g", {
        fill: "currentColor"
    }, $5NSbj.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph));
}
function $ce68a3edc3fc357d$export$6b1fd58c1dc933ec(name, glyph) {
    return $ce68a3edc3fc357d$var$svgIcon(name, $5NSbj.createElement($5NSbj.Fragment, null, $5NSbj.createElement("defs", null, $5NSbj.createElement("mask", {
        id: "strike"
    }, $5NSbj.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "white"
    }), $5NSbj.createElement("path", {
        d: "M0 0L24 24",
        stroke: "black",
        strokeWidth: 4
    }))), $5NSbj.createElement("path", {
        d: "M0.70707 2.121320L21.878680 23.292883",
        stroke: "currentColor",
        strokeWidth: 2
    }), $5NSbj.createElement("g", {
        fill: "currentColor",
        mask: "url(#strike)"
    }, $5NSbj.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph)));
}
const $ce68a3edc3fc357d$export$cae179f078f4b4a4 = $ce68a3edc3fc357d$export$274edc73af1ae9c8("Close", $5NSbj.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
const $ce68a3edc3fc357d$export$d05925e1c7f3f136 = $ce68a3edc3fc357d$export$274edc73af1ae9c8("Previous", $5NSbj.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}));
const $ce68a3edc3fc357d$export$3da0e0ec94bd4ce1 = $ce68a3edc3fc357d$export$274edc73af1ae9c8("Next", $5NSbj.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));
const $ce68a3edc3fc357d$export$b936c55164dcf1db = $ce68a3edc3fc357d$export$274edc73af1ae9c8("Loading", $5NSbj.createElement($5NSbj.Fragment, null, Array.from({
    length: 8
}).map((_, index, array)=>$5NSbj.createElement("line", {
        key: index,
        x1: "12",
        y1: "6.5",
        x2: "12",
        y2: "1.8",
        strokeLinecap: "round",
        strokeWidth: "2.6",
        stroke: "currentColor",
        strokeOpacity: 1 / array.length * (index + 1),
        transform: `rotate(${360 / array.length * index}, 12, 12)`
    }))));
const $ce68a3edc3fc357d$export$19bc16ee58e19b3d = $ce68a3edc3fc357d$export$274edc73af1ae9c8("Error", $5NSbj.createElement("path", {
    d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z"
}));
const $ce68a3edc3fc357d$export$e5c5a5f917a5871c = $ce68a3edc3fc357d$export$fef62134eea24008() ? $5NSbj.useLayoutEffect : $5NSbj.useEffect;
function $ce68a3edc3fc357d$export$f3e625e1b2b31d60() {
    const [reduceMotion, setReduceMotion] = $5NSbj.useState(false);
    $5NSbj.useEffect(()=>{
        var _a, _b;
        const mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
        setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
        const listener = (event)=>setReduceMotion(event.matches);
        (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 || _b.call(mediaQuery, "change", listener);
        return ()=>{
            var _a;
            return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener);
        };
    }, []);
    return reduceMotion;
}
function $ce68a3edc3fc357d$var$currentTransformation(node) {
    let x = 0;
    let y = 0;
    let z = 0;
    const matrix = window.getComputedStyle(node).transform;
    const matcher = matrix.match(/matrix.*\((.+)\)/);
    if (matcher) {
        const values = matcher[1].split(",").map($ce68a3edc3fc357d$export$5f87784a266e50a4);
        if (values.length === 6) {
            x = values[4];
            y = values[5];
        } else if (values.length === 16) {
            x = values[12];
            y = values[13];
            z = values[14];
        }
    }
    return {
        x: x,
        y: y,
        z: z
    };
}
function $ce68a3edc3fc357d$export$9e2608686d4ad846(nodeRef, computeAnimation) {
    const snapshot = $5NSbj.useRef();
    const animation = $5NSbj.useRef();
    const reduceMotion = $ce68a3edc3fc357d$export$f3e625e1b2b31d60();
    $ce68a3edc3fc357d$export$e5c5a5f917a5871c(()=>{
        var _a, _b, _c;
        if (nodeRef.current && snapshot.current !== undefined && !reduceMotion) {
            const { keyframes: keyframes, duration: duration, easing: easing, onfinish: onfinish } = computeAnimation(snapshot.current, nodeRef.current.getBoundingClientRect(), $ce68a3edc3fc357d$var$currentTransformation(nodeRef.current)) || {};
            if (keyframes && duration) {
                (_a = animation.current) === null || _a === void 0 || _a.cancel();
                animation.current = undefined;
                try {
                    animation.current = (_c = (_b = nodeRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, keyframes, {
                        duration: duration,
                        easing: easing
                    });
                } catch (err) {
                    console.error(err);
                }
                if (animation.current) animation.current.onfinish = ()=>{
                    animation.current = undefined;
                    onfinish === null || onfinish === void 0 || onfinish();
                };
            }
        }
        snapshot.current = undefined;
    });
    return {
        prepareAnimation: (currentSnapshot)=>{
            snapshot.current = currentSnapshot;
        },
        isAnimationPlaying: ()=>{
            var _a;
            return ((_a = animation.current) === null || _a === void 0 ? void 0 : _a.playState) === "running";
        }
    };
}
function $ce68a3edc3fc357d$export$b1d85de58d38d09d() {
    const containerRef = $5NSbj.useRef(null);
    const observerRef = $5NSbj.useRef();
    const [containerRect, setContainerRect] = $5NSbj.useState();
    const setContainerRef = $5NSbj.useCallback((node)=>{
        containerRef.current = node;
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = undefined;
        }
        const updateContainerRect = ()=>{
            if (node) {
                const styles = window.getComputedStyle(node);
                const parse = (value)=>parseFloat(value) || 0;
                setContainerRect({
                    width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
                    height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom))
                });
            } else setContainerRect(undefined);
        };
        updateContainerRect();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateContainerRect);
            observerRef.current.observe(node);
        }
    }, []);
    return {
        setContainerRef: setContainerRef,
        containerRef: containerRef,
        containerRect: containerRect
    };
}
function $ce68a3edc3fc357d$export$69f38700ea0cb3b9() {
    const timeoutId = $5NSbj.useRef();
    const { setTimeout: setTimeout, clearTimeout: clearTimeout } = $ce68a3edc3fc357d$export$1bc7162631c81b3f();
    return $5NSbj.useCallback((callback, delay)=>{
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay > 0 ? delay : 0);
    }, [
        setTimeout,
        clearTimeout
    ]);
}
function $ce68a3edc3fc357d$export$ee5b5d04074a389e(fn) {
    const ref = $5NSbj.useRef(fn);
    $ce68a3edc3fc357d$export$e5c5a5f917a5871c(()=>{
        ref.current = fn;
    });
    return $5NSbj.useCallback((...args)=>{
        var _a;
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args);
    }, []);
}
function $ce68a3edc3fc357d$export$4bb192c7cacf928f(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $ce68a3edc3fc357d$export$ebc1e1560c2dffa5(refA, refB) {
    return $5NSbj.useMemo(()=>refA == null && refB == null ? null : (refValue)=>{
            $ce68a3edc3fc357d$export$4bb192c7cacf928f(refA, refValue);
            $ce68a3edc3fc357d$export$4bb192c7cacf928f(refB, refValue);
        }, [
        refA,
        refB
    ]);
}
function $ce68a3edc3fc357d$export$2bd1c19440b9235c(focus, disabled = false) {
    const focused = $5NSbj.useRef();
    $ce68a3edc3fc357d$export$e5c5a5f917a5871c(()=>{
        if (disabled && focused.current) {
            focused.current = false;
            focus();
        }
    }, [
        disabled,
        focus
    ]);
    const onFocus = $5NSbj.useCallback(()=>{
        focused.current = true;
    }, []);
    const onBlur = $5NSbj.useCallback(()=>{
        focused.current = false;
    }, []);
    return {
        onFocus: onFocus,
        onBlur: onBlur
    };
}
function $ce68a3edc3fc357d$export$81f015b3ec5d61cf() {
    const [isRTL, setIsRTL] = $5NSbj.useState(false);
    $ce68a3edc3fc357d$export$e5c5a5f917a5871c(()=>{
        setIsRTL(window.getComputedStyle(window.document.documentElement).direction === "rtl");
    }, []);
    return isRTL;
}
function $ce68a3edc3fc357d$export$19012f58216d597f() {
    const [subscribers] = $5NSbj.useState({});
    const notifySubscribers = $5NSbj.useCallback((type, event)=>{
        var _a;
        (_a = subscribers[type]) === null || _a === void 0 || _a.forEach((listener)=>{
            if (!event.isPropagationStopped()) listener(event);
        });
    }, [
        subscribers
    ]);
    const registerSensors = $5NSbj.useMemo(()=>({
            onPointerDown: (event)=>notifySubscribers((0, $f848676e0d96e999$export$e15fc153f45a963d), event),
            onPointerMove: (event)=>notifySubscribers((0, $f848676e0d96e999$export$1f8863949fbdd7e5), event),
            onPointerUp: (event)=>notifySubscribers((0, $f848676e0d96e999$export$2d868b67a5791b8a), event),
            onPointerLeave: (event)=>notifySubscribers((0, $f848676e0d96e999$export$526cafa85592f1a5), event),
            onPointerCancel: (event)=>notifySubscribers((0, $f848676e0d96e999$export$22151cee048c4be9), event),
            onKeyDown: (event)=>notifySubscribers((0, $f848676e0d96e999$export$1aba4f3521686ca9), event),
            onKeyUp: (event)=>notifySubscribers((0, $f848676e0d96e999$export$bdb9f99d61a6879b), event),
            onWheel: (event)=>notifySubscribers((0, $f848676e0d96e999$export$5635dc9d647242c7), event)
        }), [
        notifySubscribers
    ]);
    const subscribeSensors = $5NSbj.useCallback((type, callback)=>{
        if (!subscribers[type]) subscribers[type] = [];
        subscribers[type].unshift(callback);
        return ()=>{
            const listeners = subscribers[type];
            if (listeners) listeners.splice(0, listeners.length, ...listeners.filter((el)=>el !== callback));
        };
    }, [
        subscribers
    ]);
    return {
        registerSensors: registerSensors,
        subscribeSensors: subscribeSensors
    };
}
function $ce68a3edc3fc357d$export$8b7b9481d6186f21(callback, delay) {
    const lastCallbackTime = $5NSbj.useRef(0);
    const delayCallback = $ce68a3edc3fc357d$export$69f38700ea0cb3b9();
    const executeCallback = $ce68a3edc3fc357d$export$ee5b5d04074a389e((...args)=>{
        lastCallbackTime.current = Date.now();
        callback(args);
    });
    return $5NSbj.useCallback((...args)=>{
        delayCallback(()=>{
            executeCallback(args);
        }, delay - (Date.now() - lastCallbackTime.current));
    }, [
        delay,
        executeCallback,
        delayCallback
    ]);
}
const $ce68a3edc3fc357d$var$slidePrefix = $ce68a3edc3fc357d$export$3e7cd27eed1727c("slide");
const $ce68a3edc3fc357d$var$slideImagePrefix = $ce68a3edc3fc357d$export$3e7cd27eed1727c("slide_image");
function $ce68a3edc3fc357d$export$ef86b1d52c77b27b({ slide: image, offset: offset, render: render, rect: rect, imageFit: imageFit, imageProps: imageProps, onClick: onClick, onLoad: onLoad, style: style }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const [status, setStatus] = $5NSbj.useState((0, $f848676e0d96e999$export$554a1415841c52a8));
    const { publish: publish } = $ce68a3edc3fc357d$export$91a992459f6e0f07();
    const { setTimeout: setTimeout } = $ce68a3edc3fc357d$export$1bc7162631c81b3f();
    const imageRef = $5NSbj.useRef(null);
    $5NSbj.useEffect(()=>{
        if (offset === 0) publish((0, $f848676e0d96e999$export$6751782e799f6445)(status));
    }, [
        offset,
        status,
        publish
    ]);
    const handleLoading = $ce68a3edc3fc357d$export$ee5b5d04074a389e((img)=>{
        ("decode" in img ? img.decode() : Promise.resolve()).catch(()=>{}).then(()=>{
            if (!img.parentNode) return;
            setStatus((0, $f848676e0d96e999$export$a195e517d37aaa33));
            setTimeout(()=>{
                onLoad === null || onLoad === void 0 || onLoad(img);
            }, 0);
        });
    });
    const setImageRef = $5NSbj.useCallback((img)=>{
        imageRef.current = img;
        if (img === null || img === void 0 ? void 0 : img.complete) handleLoading(img);
    }, [
        handleLoading
    ]);
    const handleOnLoad = $5NSbj.useCallback((event)=>{
        handleLoading(event.currentTarget);
    }, [
        handleLoading
    ]);
    const onError = $5NSbj.useCallback(()=>{
        setStatus((0, $f848676e0d96e999$export$2ed3c80dbc178d91));
    }, []);
    const cover = $ce68a3edc3fc357d$export$f5ba2f5b3fd12e6e(image, imageFit);
    const nonInfinite = (value, fallback)=>Number.isFinite(value) ? value : fallback;
    const maxWidth = nonInfinite(Math.max(...((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map((x)=>x.width)) !== null && _b !== void 0 ? _b : []).concat(image.width ? [
        image.width
    ] : []).filter(Boolean)), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
    const maxHeight = nonInfinite(Math.max(...((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map((x)=>x.height)) !== null && _e !== void 0 ? _e : []).concat(image.height ? [
        image.height
    ] : []).filter(Boolean)), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
    const defaultStyle = maxWidth && maxHeight ? {
        maxWidth: `min(${maxWidth}px, 100%)`,
        maxHeight: `min(${maxHeight}px, 100%)`
    } : {
        maxWidth: "100%",
        maxHeight: "100%"
    };
    const srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.sort((a, b)=>a.width - b.width).map((item)=>`${item.src} ${item.width}w`).join(", ");
    const estimateActualWidth = ()=>rect && !cover && image.width && image.height ? rect.height / image.height * image.width : Number.MAX_VALUE;
    const sizes = srcSet && rect && $ce68a3edc3fc357d$export$fef62134eea24008() ? `${Math.round(Math.min(estimateActualWidth(), rect.width))}px` : undefined;
    const { style: imagePropsStyle, className: imagePropsClassName, ...restImageProps } = imageProps || {};
    return $5NSbj.createElement($5NSbj.Fragment, null, $5NSbj.createElement("img", {
        ref: setImageRef,
        onLoad: handleOnLoad,
        onError: onError,
        onClick: onClick,
        draggable: false,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slideImagePrefix()), cover && $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slideImagePrefix("cover")), status !== (0, $f848676e0d96e999$export$a195e517d37aaa33) && $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slideImagePrefix("loading")), imagePropsClassName),
        style: {
            ...defaultStyle,
            ...style,
            ...imagePropsStyle
        },
        ...restImageProps,
        alt: image.alt,
        sizes: sizes,
        srcSet: srcSet,
        src: image.src
    }), status !== (0, $f848676e0d96e999$export$a195e517d37aaa33) && $5NSbj.createElement("div", {
        className: $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slidePrefix((0, $f848676e0d96e999$export$e51f1c6d74b54a13)))
    }, status === (0, $f848676e0d96e999$export$554a1415841c52a8) && ((render === null || render === void 0 ? void 0 : render.iconLoading) ? render.iconLoading() : $5NSbj.createElement($ce68a3edc3fc357d$export$b936c55164dcf1db, {
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$c5f5ca1963fed141)), $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slidePrefix((0, $f848676e0d96e999$export$554a1415841c52a8))))
    })), status === (0, $f848676e0d96e999$export$2ed3c80dbc178d91) && ((render === null || render === void 0 ? void 0 : render.iconError) ? render.iconError() : $5NSbj.createElement($ce68a3edc3fc357d$export$19bc16ee58e19b3d, {
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$c5f5ca1963fed141)), $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slidePrefix((0, $f848676e0d96e999$export$2ed3c80dbc178d91))))
    }))));
}
var $ce68a3edc3fc357d$export$59f0048f451fc458;
(function(SwipeState) {
    SwipeState[SwipeState["NONE"] = 0] = "NONE";
    SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
    SwipeState[SwipeState["PULL"] = 2] = "PULL";
    SwipeState[SwipeState["ANIMATION"] = 3] = "ANIMATION";
})($ce68a3edc3fc357d$export$59f0048f451fc458 || ($ce68a3edc3fc357d$export$59f0048f451fc458 = {}));
function $ce68a3edc3fc357d$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled) {
    $5NSbj.useEffect(()=>!disabled ? $ce68a3edc3fc357d$export$de863c629cb9919d(subscribeSensors((0, $f848676e0d96e999$export$e15fc153f45a963d), onPointerDown), subscribeSensors((0, $f848676e0d96e999$export$1f8863949fbdd7e5), onPointerMove), subscribeSensors((0, $f848676e0d96e999$export$2d868b67a5791b8a), onPointerUp), subscribeSensors((0, $f848676e0d96e999$export$526cafa85592f1a5), onPointerUp), subscribeSensors((0, $f848676e0d96e999$export$22151cee048c4be9), onPointerUp)) : ()=>{}, [
        subscribeSensors,
        onPointerDown,
        onPointerMove,
        onPointerUp,
        disabled
    ]);
}
var $ce68a3edc3fc357d$var$Gesture;
(function(Gesture) {
    Gesture[Gesture["NONE"] = 0] = "NONE";
    Gesture[Gesture["SWIPE"] = 1] = "SWIPE";
    Gesture[Gesture["PULL"] = 2] = "PULL";
})($ce68a3edc3fc357d$var$Gesture || ($ce68a3edc3fc357d$var$Gesture = {}));
const $ce68a3edc3fc357d$var$SWIPE_THRESHOLD = 30;
function $ce68a3edc3fc357d$export$abaee32ee49963c1(subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel, pullUpEnabled, pullDownEnabled, onPullStart, onPullProgress, onPullFinish, onPullCancel) {
    const offset = $5NSbj.useRef(0);
    const pointers = $5NSbj.useRef([]);
    const activePointer = $5NSbj.useRef();
    const startTime = $5NSbj.useRef(0);
    const gesture = $5NSbj.useRef($ce68a3edc3fc357d$var$Gesture.NONE);
    const clearPointer = $5NSbj.useCallback((event)=>{
        if (activePointer.current === event.pointerId) {
            activePointer.current = undefined;
            gesture.current = $ce68a3edc3fc357d$var$Gesture.NONE;
        }
        const currentPointers = pointers.current;
        currentPointers.splice(0, currentPointers.length, ...currentPointers.filter((p)=>p.pointerId !== event.pointerId));
    }, []);
    const addPointer = $5NSbj.useCallback((event)=>{
        clearPointer(event);
        event.persist();
        pointers.current.push(event);
    }, [
        clearPointer
    ]);
    const onPointerDown = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        addPointer(event);
    });
    const exceedsPullThreshold = (value, threshold)=>pullDownEnabled && value > threshold || pullUpEnabled && value < -threshold;
    const onPointerUp = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        if (pointers.current.find((x)=>x.pointerId === event.pointerId) && activePointer.current === event.pointerId) {
            const duration = Date.now() - startTime.current;
            const currentOffset = offset.current;
            if (gesture.current === $ce68a3edc3fc357d$var$Gesture.SWIPE) {
                if (Math.abs(currentOffset) > 0.3 * containerWidth || Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration) onSwipeFinish(currentOffset, duration);
                else onSwipeCancel(currentOffset);
            } else if (gesture.current === $ce68a3edc3fc357d$var$Gesture.PULL) {
                if (exceedsPullThreshold(currentOffset, 2 * $ce68a3edc3fc357d$var$SWIPE_THRESHOLD)) onPullFinish(currentOffset, duration);
                else onPullCancel(currentOffset);
            }
            offset.current = 0;
            gesture.current = $ce68a3edc3fc357d$var$Gesture.NONE;
        }
        clearPointer(event);
    });
    const onPointerMove = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        const pointer = pointers.current.find((p)=>p.pointerId === event.pointerId);
        if (pointer) {
            const isCurrentPointer = activePointer.current === event.pointerId;
            if (event.buttons === 0) {
                if (isCurrentPointer && offset.current !== 0) onPointerUp(event);
                else clearPointer(pointer);
                return;
            }
            const deltaX = event.clientX - pointer.clientX;
            const deltaY = event.clientY - pointer.clientY;
            if (activePointer.current === undefined) {
                const startGesture = (newGesture)=>{
                    addPointer(event);
                    activePointer.current = event.pointerId;
                    startTime.current = Date.now();
                    gesture.current = newGesture;
                };
                if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > $ce68a3edc3fc357d$var$SWIPE_THRESHOLD && isSwipeValid(deltaX)) {
                    startGesture($ce68a3edc3fc357d$var$Gesture.SWIPE);
                    onSwipeStart();
                } else if (Math.abs(deltaY) > Math.abs(deltaX) && exceedsPullThreshold(deltaY, $ce68a3edc3fc357d$var$SWIPE_THRESHOLD)) {
                    startGesture($ce68a3edc3fc357d$var$Gesture.PULL);
                    onPullStart();
                }
            } else if (isCurrentPointer) {
                if (gesture.current === $ce68a3edc3fc357d$var$Gesture.SWIPE) {
                    offset.current = deltaX;
                    onSwipeProgress(deltaX);
                } else if (gesture.current === $ce68a3edc3fc357d$var$Gesture.PULL) {
                    offset.current = deltaY;
                    onPullProgress(deltaY);
                }
            }
        }
    });
    $ce68a3edc3fc357d$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp);
}
function $ce68a3edc3fc357d$export$145fefb2d7286388({ preventDefaultWheelX: preventDefaultWheelX, preventDefaultWheelY: preventDefaultWheelY }) {
    const ref = $5NSbj.useRef(null);
    const listener = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (horizontal && preventDefaultWheelX || !horizontal && preventDefaultWheelY || event.ctrlKey) event.preventDefault();
    });
    return $5NSbj.useCallback((node)=>{
        var _a;
        if (node) node.addEventListener("wheel", listener, {
            passive: false
        });
        else (_a = ref.current) === null || _a === void 0 || _a.removeEventListener("wheel", listener);
        ref.current = node;
    }, [
        listener
    ]);
}
function $ce68a3edc3fc357d$export$10506de8b6841445(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
    const offset = $5NSbj.useRef(0);
    const intent = $5NSbj.useRef(0);
    const intentCleanup = $5NSbj.useRef();
    const resetCleanup = $5NSbj.useRef();
    const wheelResidualMomentum = $5NSbj.useRef(0);
    const startTime = $5NSbj.useRef(0);
    const { setTimeout: setTimeout, clearTimeout: clearTimeout } = $ce68a3edc3fc357d$export$1bc7162631c81b3f();
    const cancelSwipeIntentCleanup = $5NSbj.useCallback(()=>{
        if (intentCleanup.current) {
            clearTimeout(intentCleanup.current);
            intentCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    const cancelSwipeResetCleanup = $5NSbj.useCallback(()=>{
        if (resetCleanup.current) {
            clearTimeout(resetCleanup.current);
            resetCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    const handleCleanup = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        if (swipeState !== $ce68a3edc3fc357d$export$59f0048f451fc458.SWIPE) {
            offset.current = 0;
            startTime.current = 0;
            cancelSwipeIntentCleanup();
            cancelSwipeResetCleanup();
        }
    });
    $5NSbj.useEffect(handleCleanup, [
        swipeState,
        handleCleanup
    ]);
    const handleCancelSwipe = $ce68a3edc3fc357d$export$ee5b5d04074a389e((currentSwipeOffset)=>{
        resetCleanup.current = undefined;
        if (offset.current === currentSwipeOffset) onSwipeCancel(offset.current);
    });
    const onWheel = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        if (event.ctrlKey) return;
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) return;
        if (swipeState === $ce68a3edc3fc357d$export$59f0048f451fc458.NONE) {
            if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelResidualMomentum.current)) {
                wheelResidualMomentum.current = event.deltaX;
                return;
            }
            if (!isSwipeValid(-event.deltaX)) return;
            intent.current += event.deltaX;
            cancelSwipeIntentCleanup();
            if (Math.abs(intent.current) > 30) {
                intent.current = 0;
                wheelResidualMomentum.current = 0;
                startTime.current = Date.now();
                onSwipeStart();
            } else {
                const currentSwipeIntent = intent.current;
                intentCleanup.current = setTimeout(()=>{
                    intentCleanup.current = undefined;
                    if (currentSwipeIntent === intent.current) intent.current = 0;
                }, swipeAnimationDuration);
            }
        } else if (swipeState === $ce68a3edc3fc357d$export$59f0048f451fc458.SWIPE) {
            let newSwipeOffset = offset.current - event.deltaX;
            newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
            offset.current = newSwipeOffset;
            onSwipeProgress(newSwipeOffset);
            cancelSwipeResetCleanup();
            if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
                wheelResidualMomentum.current = event.deltaX;
                onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
                return;
            }
            resetCleanup.current = setTimeout(()=>handleCancelSwipe(newSwipeOffset), 2 * swipeAnimationDuration);
        } else wheelResidualMomentum.current = event.deltaX;
    });
    $5NSbj.useEffect(()=>subscribeSensors((0, $f848676e0d96e999$export$5635dc9d647242c7), onWheel), [
        subscribeSensors,
        onWheel
    ]);
}
const $ce68a3edc3fc357d$var$cssContainerPrefix = $ce68a3edc3fc357d$export$3e7cd27eed1727c("container");
const $ce68a3edc3fc357d$export$e92ff191b0c59550 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$e8c786024a2b0a79 = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useController", "ControllerContext", $ce68a3edc3fc357d$export$e92ff191b0c59550);
function $ce68a3edc3fc357d$export$bd0bf19f25da8474({ children: children, ...props }) {
    var _a;
    const { carousel: carousel, animation: animation, controller: controller, on: on, styles: styles, render: render } = props;
    const { closeOnPullUp: closeOnPullUp, closeOnPullDown: closeOnPullDown, preventDefaultWheelX: preventDefaultWheelX, preventDefaultWheelY: preventDefaultWheelY } = controller;
    const [toolbarWidth, setToolbarWidth] = $5NSbj.useState();
    const state = $ce68a3edc3fc357d$export$566121e2bbc52eec();
    const dispatch = $ce68a3edc3fc357d$export$9463bb14d6ba055e();
    const [swipeState, setSwipeState] = $5NSbj.useState($ce68a3edc3fc357d$export$59f0048f451fc458.NONE);
    const swipeOffset = $5NSbj.useRef(0);
    const pullOffset = $5NSbj.useRef(0);
    const pullOpacity = $5NSbj.useRef(1);
    const { registerSensors: registerSensors, subscribeSensors: subscribeSensors } = $ce68a3edc3fc357d$export$19012f58216d597f();
    const { subscribe: subscribe, publish: publish } = $ce68a3edc3fc357d$export$91a992459f6e0f07();
    const cleanupAnimationIncrement = $ce68a3edc3fc357d$export$69f38700ea0cb3b9();
    const cleanupSwipeOffset = $ce68a3edc3fc357d$export$69f38700ea0cb3b9();
    const cleanupPullOffset = $ce68a3edc3fc357d$export$69f38700ea0cb3b9();
    const { containerRef: containerRef, setContainerRef: setContainerRef, containerRect: containerRect } = $ce68a3edc3fc357d$export$b1d85de58d38d09d();
    const handleContainerRef = $ce68a3edc3fc357d$export$ebc1e1560c2dffa5($ce68a3edc3fc357d$export$145fefb2d7286388({
        preventDefaultWheelX: preventDefaultWheelX,
        preventDefaultWheelY: preventDefaultWheelY
    }), setContainerRef);
    const carouselRef = $5NSbj.useRef(null);
    const setCarouselRef = $ce68a3edc3fc357d$export$ebc1e1560c2dffa5(carouselRef, undefined);
    const isRTL = $ce68a3edc3fc357d$export$81f015b3ec5d61cf();
    const rtl = (value)=>(isRTL ? -1 : 1) * (typeof value === "number" ? value : 1);
    const focus = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        var _a;
        return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    const getLightboxProps = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>props);
    const getLightboxState = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>state);
    const prev = $5NSbj.useCallback((params)=>publish((0, $f848676e0d96e999$export$a007161537026955), params), [
        publish
    ]);
    const next = $5NSbj.useCallback((params)=>publish((0, $f848676e0d96e999$export$f1d7a854db833ed4), params), [
        publish
    ]);
    const close = $5NSbj.useCallback(()=>publish((0, $f848676e0d96e999$export$493a596486210a21)), [
        publish
    ]);
    const isSwipeValid = (offset)=>!(carousel.finite && (rtl(offset) > 0 && state.currentIndex === 0 || rtl(offset) < 0 && state.currentIndex === state.slides.length - 1));
    const setSwipeOffset = (offset)=>{
        var _a;
        swipeOffset.current = offset;
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($ce68a3edc3fc357d$export$8b4981022bd80a4e("swipe_offset"), `${Math.round(offset)}px`);
    };
    const setPullOffset = (offset)=>{
        var _a, _b;
        pullOffset.current = offset;
        pullOpacity.current = (()=>{
            const threshold = 60;
            const minOpacity = 0.5;
            const offsetValue = (()=>{
                if (closeOnPullDown && offset > 0) return offset;
                if (closeOnPullUp && offset < 0) return -offset;
                return 0;
            })();
            return Math.min(Math.max($ce68a3edc3fc357d$export$2077e0241d6afd3c(1 - offsetValue / threshold * (1 - minOpacity), 2), minOpacity), 1);
        })();
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($ce68a3edc3fc357d$export$8b4981022bd80a4e("pull_offset"), `${Math.round(offset)}px`);
        (_b = containerRef.current) === null || _b === void 0 || _b.style.setProperty($ce68a3edc3fc357d$export$8b4981022bd80a4e("pull_opacity"), `${pullOpacity.current}`);
    };
    const { prepareAnimation: preparePullAnimation } = $ce68a3edc3fc357d$export$9e2608686d4ad846(carouselRef, (snapshot, rect, translate)=>{
        if (carouselRef.current && containerRect) return {
            keyframes: [
                {
                    transform: `translate(0, ${snapshot.rect.y - rect.y + translate.y}px)`,
                    opacity: snapshot.opacity
                },
                {
                    transform: "translate(0, 0)",
                    opacity: 1
                }
            ],
            duration: snapshot.duration,
            easing: animation.easing.fade
        };
        return undefined;
    });
    const pull = (offset, cancel)=>{
        if (closeOnPullUp || closeOnPullDown) {
            setPullOffset(offset);
            let duration = 0;
            if (carouselRef.current) {
                duration = animation.fade * (cancel ? 2 : 1);
                preparePullAnimation({
                    rect: carouselRef.current.getBoundingClientRect(),
                    opacity: pullOpacity.current,
                    duration: duration
                });
            }
            cleanupPullOffset(()=>{
                setPullOffset(0);
                setSwipeState($ce68a3edc3fc357d$export$59f0048f451fc458.NONE);
            }, duration);
            setSwipeState($ce68a3edc3fc357d$export$59f0048f451fc458.ANIMATION);
            if (!cancel) close();
        }
    };
    const { prepareAnimation: prepareAnimation, isAnimationPlaying: isAnimationPlaying } = $ce68a3edc3fc357d$export$9e2608686d4ad846(carouselRef, (snapshot, rect, translate)=>{
        var _a;
        if (carouselRef.current && containerRect && ((_a = state.animation) === null || _a === void 0 ? void 0 : _a.duration)) {
            const parsedSpacing = $ce68a3edc3fc357d$export$7871fb532d320d99(carousel.spacing);
            const spacingValue = (parsedSpacing.percent ? parsedSpacing.percent * containerRect.width / 100 : parsedSpacing.pixel) || 0;
            return {
                keyframes: [
                    {
                        transform: `translate(${rtl(state.globalIndex - snapshot.index) * (containerRect.width + spacingValue) + snapshot.rect.x - rect.x + translate.x}px, 0)`
                    },
                    {
                        transform: "translate(0, 0)"
                    }
                ],
                duration: state.animation.duration,
                easing: state.animation.easing
            };
        }
        return undefined;
    });
    const swipe = $ce68a3edc3fc357d$export$ee5b5d04074a389e((action)=>{
        var _a, _b;
        const currentSwipeOffset = action.offset || 0;
        const swipeDuration = !currentSwipeOffset ? (_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe : animation.swipe;
        const swipeEasing = !currentSwipeOffset && !isAnimationPlaying() ? animation.easing.navigation : animation.easing.swipe;
        let { direction: direction } = action;
        const count = (_b = action.count) !== null && _b !== void 0 ? _b : 1;
        let newSwipeState = $ce68a3edc3fc357d$export$59f0048f451fc458.ANIMATION;
        let newSwipeAnimationDuration = swipeDuration * count;
        if (!direction) {
            const containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
            const elapsedTime = action.duration || 0;
            const expectedTime = containerWidth ? swipeDuration / containerWidth * Math.abs(currentSwipeOffset) : swipeDuration;
            if (count !== 0) {
                if (elapsedTime < expectedTime) newSwipeAnimationDuration = newSwipeAnimationDuration / expectedTime * Math.max(elapsedTime, expectedTime / 5);
                else if (containerWidth) newSwipeAnimationDuration = swipeDuration / containerWidth * (containerWidth - Math.abs(currentSwipeOffset));
                direction = rtl(currentSwipeOffset) > 0 ? (0, $f848676e0d96e999$export$a007161537026955) : (0, $f848676e0d96e999$export$f1d7a854db833ed4);
            } else newSwipeAnimationDuration = swipeDuration / 2;
        }
        let increment = 0;
        if (direction === (0, $f848676e0d96e999$export$a007161537026955)) {
            if (isSwipeValid(rtl(1))) increment = -count;
            else {
                newSwipeState = $ce68a3edc3fc357d$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        } else if (direction === (0, $f848676e0d96e999$export$f1d7a854db833ed4)) {
            if (isSwipeValid(rtl(-1))) increment = count;
            else {
                newSwipeState = $ce68a3edc3fc357d$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
        cleanupSwipeOffset(()=>{
            setSwipeOffset(0);
            setSwipeState($ce68a3edc3fc357d$export$59f0048f451fc458.NONE);
        }, newSwipeAnimationDuration);
        if (carouselRef.current) prepareAnimation({
            rect: carouselRef.current.getBoundingClientRect(),
            index: state.globalIndex
        });
        setSwipeState(newSwipeState);
        publish((0, $f848676e0d96e999$export$c43bd1a4101c4078), {
            type: "swipe",
            increment: increment,
            duration: newSwipeAnimationDuration,
            easing: swipeEasing
        });
    });
    $5NSbj.useEffect(()=>{
        var _a, _b;
        if (((_a = state.animation) === null || _a === void 0 ? void 0 : _a.increment) && ((_b = state.animation) === null || _b === void 0 ? void 0 : _b.duration)) cleanupAnimationIncrement(()=>dispatch({
                type: "swipe",
                increment: 0
            }), state.animation.duration);
    }, [
        state.animation,
        dispatch,
        cleanupAnimationIncrement
    ]);
    const swipeParams = [
        subscribeSensors,
        isSwipeValid,
        (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0,
        animation.swipe,
        ()=>setSwipeState($ce68a3edc3fc357d$export$59f0048f451fc458.SWIPE),
        (offset)=>setSwipeOffset(offset),
        (offset, duration)=>swipe({
                offset: offset,
                duration: duration,
                count: 1
            }),
        (offset)=>swipe({
                offset: offset,
                count: 0
            })
    ];
    const pullParams = [
        ()=>{
            if (closeOnPullDown) setSwipeState($ce68a3edc3fc357d$export$59f0048f451fc458.PULL);
        },
        (offset)=>setPullOffset(offset),
        (offset)=>pull(offset),
        (offset)=>pull(offset, true)
    ];
    $ce68a3edc3fc357d$export$abaee32ee49963c1(...swipeParams, closeOnPullUp, closeOnPullDown, ...pullParams);
    $ce68a3edc3fc357d$export$10506de8b6841445(swipeState, ...swipeParams);
    const focusOnMount = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        if (controller.focus) {
            if (document.querySelector(`.${$ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$9d2e4856063e1a22))} .${$ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssContainerPrefix())}`)) focus();
        }
    });
    $5NSbj.useEffect(focusOnMount, [
        focusOnMount
    ]);
    const onViewCallback = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        var _a;
        (_a = on.view) === null || _a === void 0 || _a.call(on, {
            index: state.currentIndex
        });
    });
    $5NSbj.useEffect(onViewCallback, [
        state.globalIndex,
        onViewCallback
    ]);
    $5NSbj.useEffect(()=>$ce68a3edc3fc357d$export$de863c629cb9919d(subscribe((0, $f848676e0d96e999$export$a007161537026955), (action)=>swipe({
                direction: (0, $f848676e0d96e999$export$a007161537026955),
                ...action
            })), subscribe((0, $f848676e0d96e999$export$f1d7a854db833ed4), (action)=>swipe({
                direction: (0, $f848676e0d96e999$export$f1d7a854db833ed4),
                ...action
            })), subscribe((0, $f848676e0d96e999$export$c43bd1a4101c4078), (action)=>dispatch(action))), [
        subscribe,
        swipe,
        dispatch
    ]);
    const context = $5NSbj.useMemo(()=>({
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            slideRect: containerRect ? $ce68a3edc3fc357d$export$7ff571008bce9900(containerRect, carousel.padding) : {
                width: 0,
                height: 0
            },
            containerRect: containerRect || {
                width: 0,
                height: 0
            },
            subscribeSensors: subscribeSensors,
            containerRef: containerRef,
            setCarouselRef: setCarouselRef,
            toolbarWidth: toolbarWidth,
            setToolbarWidth: setToolbarWidth
        }), [
        prev,
        next,
        close,
        focus,
        subscribeSensors,
        containerRect,
        containerRef,
        setCarouselRef,
        toolbarWidth,
        setToolbarWidth,
        carousel.padding
    ]);
    $5NSbj.useImperativeHandle(controller.ref, ()=>({
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            getLightboxProps: getLightboxProps,
            getLightboxState: getLightboxState
        }), [
        prev,
        next,
        close,
        focus,
        getLightboxProps,
        getLightboxState
    ]);
    return $5NSbj.createElement("div", {
        ref: handleContainerRef,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssContainerPrefix()), $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$974a68ef150451f5))),
        style: {
            ...swipeState === $ce68a3edc3fc357d$export$59f0048f451fc458.SWIPE ? {
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("swipe_offset")]: `${Math.round(swipeOffset.current)}px`
            } : null,
            ...swipeState === $ce68a3edc3fc357d$export$59f0048f451fc458.PULL ? {
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("pull_offset")]: `${Math.round(pullOffset.current)}px`,
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("pull_opacity")]: `${pullOpacity.current}`
            } : null,
            ...controller.touchAction !== "none" ? {
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("controller_touch_action")]: controller.touchAction
            } : null,
            ...styles.container
        },
        ...controller.aria ? {
            role: "presentation",
            "aria-live": "polite"
        } : null,
        tabIndex: -1,
        ...registerSensors
    }, containerRect && $5NSbj.createElement($ce68a3edc3fc357d$export$e92ff191b0c59550.Provider, {
        value: context
    }, children, (_a = render.controls) === null || _a === void 0 ? void 0 : _a.call(render)));
}
const $ce68a3edc3fc357d$export$be59d34228c8ec8a = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$b861c6f4d58b4c2f), $ce68a3edc3fc357d$export$bd0bf19f25da8474);
function $ce68a3edc3fc357d$var$cssPrefix$2(value) {
    return $ce68a3edc3fc357d$export$195c4126907dde97((0, $f848676e0d96e999$export$83fe3bee12eb51bb), value);
}
function $ce68a3edc3fc357d$var$cssSlidePrefix(value) {
    return $ce68a3edc3fc357d$export$195c4126907dde97("slide", value);
}
function $ce68a3edc3fc357d$var$CarouselSlide({ slide: slide, offset: offset }) {
    const containerRef = $5NSbj.useRef(null);
    const { currentIndex: currentIndex } = $ce68a3edc3fc357d$export$566121e2bbc52eec();
    const { slideRect: slideRect, close: close } = $ce68a3edc3fc357d$export$e8c786024a2b0a79();
    const { render: render, carousel: { imageFit: imageFit, imageProps: imageProps }, on: { click: onClick }, controller: { closeOnBackdropClick: closeOnBackdropClick }, styles: { slide: style } } = $ce68a3edc3fc357d$export$d930f3536e1c64f6();
    const renderSlide = ()=>{
        var _a, _b, _c, _d;
        let rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, {
            slide: slide,
            offset: offset,
            rect: slideRect
        });
        if (!rendered && $ce68a3edc3fc357d$export$55ec18c411514c07(slide)) rendered = $5NSbj.createElement($ce68a3edc3fc357d$export$ef86b1d52c77b27b, {
            slide: slide,
            offset: offset,
            render: render,
            rect: slideRect,
            imageFit: imageFit,
            imageProps: imageProps,
            onClick: offset === 0 ? ()=>onClick === null || onClick === void 0 ? void 0 : onClick({
                    index: currentIndex
                }) : undefined
        });
        return rendered ? $5NSbj.createElement($5NSbj.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, {
            slide: slide
        }), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : ({ children: children })=>children)({
            slide: slide,
            children: rendered
        }), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, {
            slide: slide
        })) : null;
    };
    const handleBackdropClick = (event)=>{
        const container = containerRef.current;
        const target = event.target instanceof HTMLElement ? event.target : undefined;
        if (closeOnBackdropClick && target && container && (target === container || Array.from(container.children).find((x)=>x === target) && target.classList.contains($ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$ac396c284080b10c))))) close();
    };
    return $5NSbj.createElement("div", {
        ref: containerRef,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssSlidePrefix()), offset === 0 && $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssSlidePrefix("current")), $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$974a68ef150451f5))),
        onClick: handleBackdropClick,
        style: style
    }, renderSlide());
}
function $ce68a3edc3fc357d$var$Placeholder() {
    const style = $ce68a3edc3fc357d$export$d930f3536e1c64f6().styles.slide;
    return $5NSbj.createElement("div", {
        className: $ce68a3edc3fc357d$export$1283875077dc8f0a("slide"),
        style: style
    });
}
function $ce68a3edc3fc357d$export$144901db2ea8e967({ carousel: carousel }) {
    const { slides: slides, currentIndex: currentIndex, globalIndex: globalIndex } = $ce68a3edc3fc357d$export$566121e2bbc52eec();
    const { setCarouselRef: setCarouselRef } = $ce68a3edc3fc357d$export$e8c786024a2b0a79();
    const spacingValue = $ce68a3edc3fc357d$export$7871fb532d320d99(carousel.spacing);
    const paddingValue = $ce68a3edc3fc357d$export$7871fb532d320d99(carousel.padding);
    const preload = $ce68a3edc3fc357d$export$aab7f3145c728301(carousel, slides, 1);
    const items = [];
    if ($ce68a3edc3fc357d$export$883ece934910f98d(slides)) for(let index = currentIndex - preload; index <= currentIndex + preload; index += 1){
        const slide = $ce68a3edc3fc357d$export$cdfb855c5eb3bc84(slides, index);
        const key = globalIndex - currentIndex + index;
        const placeholder = carousel.finite && (index < 0 || index > slides.length - 1);
        items.push(!placeholder ? {
            key: [
                `${key}`,
                $ce68a3edc3fc357d$export$b2184449b7659b5a(slide)
            ].filter(Boolean).join("|"),
            offset: index - currentIndex,
            slide: slide
        } : {
            key: key
        });
    }
    return $5NSbj.createElement("div", {
        ref: setCarouselRef,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssPrefix$2()), items.length > 0 && $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssPrefix$2("with_slides"))),
        style: {
            [`${$ce68a3edc3fc357d$export$8b4981022bd80a4e($ce68a3edc3fc357d$var$cssPrefix$2("slides_count"))}`]: items.length,
            [`${$ce68a3edc3fc357d$export$8b4981022bd80a4e($ce68a3edc3fc357d$var$cssPrefix$2("spacing_px"))}`]: spacingValue.pixel || 0,
            [`${$ce68a3edc3fc357d$export$8b4981022bd80a4e($ce68a3edc3fc357d$var$cssPrefix$2("spacing_percent"))}`]: spacingValue.percent || 0,
            [`${$ce68a3edc3fc357d$export$8b4981022bd80a4e($ce68a3edc3fc357d$var$cssPrefix$2("padding_px"))}`]: paddingValue.pixel || 0,
            [`${$ce68a3edc3fc357d$export$8b4981022bd80a4e($ce68a3edc3fc357d$var$cssPrefix$2("padding_percent"))}`]: paddingValue.percent || 0
        }
    }, items.map(({ key: key, slide: slide, offset: offset })=>slide ? $5NSbj.createElement($ce68a3edc3fc357d$var$CarouselSlide, {
            key: key,
            slide: slide,
            offset: offset
        }) : $5NSbj.createElement($ce68a3edc3fc357d$var$Placeholder, {
            key: key
        })));
}
const $ce68a3edc3fc357d$export$9c087759a323a56c = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$83fe3bee12eb51bb), $ce68a3edc3fc357d$export$144901db2ea8e967);
function $ce68a3edc3fc357d$export$e482f4662aebc4a0() {
    const { carousel: carousel } = $ce68a3edc3fc357d$export$d930f3536e1c64f6();
    const { slides: slides, currentIndex: currentIndex } = $ce68a3edc3fc357d$export$566121e2bbc52eec();
    const prevDisabled = slides.length === 0 || carousel.finite && currentIndex === 0;
    const nextDisabled = slides.length === 0 || carousel.finite && currentIndex === slides.length - 1;
    return {
        prevDisabled: prevDisabled,
        nextDisabled: nextDisabled
    };
}
function $ce68a3edc3fc357d$export$4da28cf324280418(subscribeSensors) {
    var _a;
    const isRTL = $ce68a3edc3fc357d$export$81f015b3ec5d61cf();
    const { publish: publish } = $ce68a3edc3fc357d$export$91a992459f6e0f07();
    const { animation: animation } = $ce68a3edc3fc357d$export$d930f3536e1c64f6();
    const { prevDisabled: prevDisabled, nextDisabled: nextDisabled } = $ce68a3edc3fc357d$export$e482f4662aebc4a0();
    const throttle = ((_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe) / 2;
    const prev = $ce68a3edc3fc357d$export$8b7b9481d6186f21(()=>publish((0, $f848676e0d96e999$export$a007161537026955)), throttle);
    const next = $ce68a3edc3fc357d$export$8b7b9481d6186f21(()=>publish((0, $f848676e0d96e999$export$f1d7a854db833ed4)), throttle);
    const handleKeyDown = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        switch(event.key){
            case 0, $f848676e0d96e999$export$e8d60d9b5ceff7c0:
                publish((0, $f848676e0d96e999$export$493a596486210a21));
                break;
            case 0, $f848676e0d96e999$export$17dec1da9b0e2eb3:
                if (!(isRTL ? nextDisabled : prevDisabled)) (isRTL ? next : prev)();
                break;
            case 0, $f848676e0d96e999$export$91898c0e7e48903:
                if (!(isRTL ? prevDisabled : nextDisabled)) (isRTL ? prev : next)();
                break;
            default:
        }
    });
    $5NSbj.useEffect(()=>subscribeSensors((0, $f848676e0d96e999$export$1aba4f3521686ca9), handleKeyDown), [
        subscribeSensors,
        handleKeyDown
    ]);
}
function $ce68a3edc3fc357d$export$e2d1bd910e689283({ label: label, icon: icon, renderIcon: renderIcon, action: action, onClick: onClick, disabled: disabled, style: style }) {
    return $5NSbj.createElement($ce68a3edc3fc357d$export$c25acd513dcc8062, {
        label: label,
        icon: icon,
        renderIcon: renderIcon,
        className: $ce68a3edc3fc357d$export$1283875077dc8f0a(`navigation_${action}`),
        disabled: disabled,
        onClick: onClick,
        style: style,
        ...$ce68a3edc3fc357d$export$2bd1c19440b9235c($ce68a3edc3fc357d$export$e8c786024a2b0a79().focus, disabled)
    });
}
function $ce68a3edc3fc357d$export$b8a61e5c71402559({ render: { buttonPrev: buttonPrev, buttonNext: buttonNext, iconPrev: iconPrev, iconNext: iconNext }, styles: styles }) {
    const { prev: prev, next: next, subscribeSensors: subscribeSensors } = $ce68a3edc3fc357d$export$e8c786024a2b0a79();
    const { prevDisabled: prevDisabled, nextDisabled: nextDisabled } = $ce68a3edc3fc357d$export$e482f4662aebc4a0();
    $ce68a3edc3fc357d$export$4da28cf324280418(subscribeSensors);
    return $5NSbj.createElement($5NSbj.Fragment, null, buttonPrev ? buttonPrev() : $5NSbj.createElement($ce68a3edc3fc357d$export$e2d1bd910e689283, {
        label: "Previous",
        action: (0, $f848676e0d96e999$export$a007161537026955),
        icon: $ce68a3edc3fc357d$export$d05925e1c7f3f136,
        renderIcon: iconPrev,
        style: styles.navigationPrev,
        disabled: prevDisabled,
        onClick: prev
    }), buttonNext ? buttonNext() : $5NSbj.createElement($ce68a3edc3fc357d$export$e2d1bd910e689283, {
        label: "Next",
        action: (0, $f848676e0d96e999$export$f1d7a854db833ed4),
        icon: $ce68a3edc3fc357d$export$3da0e0ec94bd4ce1,
        renderIcon: iconNext,
        style: styles.navigationNext,
        disabled: nextDisabled,
        onClick: next
    }));
}
const $ce68a3edc3fc357d$export$6c16e1ac15089858 = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$607ce719f0ec9b98), $ce68a3edc3fc357d$export$b8a61e5c71402559);
const $ce68a3edc3fc357d$var$noScroll = $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$b6426a00c33a0175));
const $ce68a3edc3fc357d$var$noScrollPadding = $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$651541414233b476));
function $ce68a3edc3fc357d$var$isHTMLElement(element) {
    return "style" in element;
}
function $ce68a3edc3fc357d$var$padScrollbar(element, padding, rtl) {
    const styles = window.getComputedStyle(element);
    const property = rtl ? "padding-left" : "padding-right";
    const computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
    const originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, `${($ce68a3edc3fc357d$export$5f87784a266e50a4(computedValue) || 0) + padding}px`);
    return ()=>{
        if (originalValue) element.style.setProperty(property, originalValue);
        else element.style.removeProperty(property);
    };
}
function $ce68a3edc3fc357d$export$bbae9e931237726f({ noScroll: { disabled: disabled }, children: children }) {
    const rtl = $ce68a3edc3fc357d$export$81f015b3ec5d61cf();
    $ce68a3edc3fc357d$export$e5c5a5f917a5871c(()=>{
        if (disabled) return ()=>{};
        const cleanup = [];
        const { body: body, documentElement: documentElement } = document;
        const scrollbar = Math.round(window.innerWidth - documentElement.clientWidth);
        if (scrollbar > 0) {
            cleanup.push($ce68a3edc3fc357d$var$padScrollbar(body, scrollbar, rtl));
            const elements = body.getElementsByTagName("*");
            for(let i = 0; i < elements.length; i += 1){
                const element = elements[i];
                if ($ce68a3edc3fc357d$var$isHTMLElement(element) && window.getComputedStyle(element).getPropertyValue("position") === "fixed" && !element.classList.contains($ce68a3edc3fc357d$var$noScrollPadding)) cleanup.push($ce68a3edc3fc357d$var$padScrollbar(element, scrollbar, rtl));
            }
        }
        body.classList.add($ce68a3edc3fc357d$var$noScroll);
        return ()=>{
            body.classList.remove($ce68a3edc3fc357d$var$noScroll);
            cleanup.forEach((clean)=>clean());
        };
    }, [
        rtl,
        disabled
    ]);
    return $5NSbj.createElement($5NSbj.Fragment, null, children);
}
const $ce68a3edc3fc357d$export$7ded5f1cd4840ad = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$52cbc29cf5406ba8), $ce68a3edc3fc357d$export$bbae9e931237726f);
function $ce68a3edc3fc357d$var$cssPrefix$1(value) {
    return $ce68a3edc3fc357d$export$195c4126907dde97((0, $f848676e0d96e999$export$9d2e4856063e1a22), value);
}
function $ce68a3edc3fc357d$var$setAttribute(element, attribute, value) {
    const previousValue = element.getAttribute(attribute);
    element.setAttribute(attribute, value);
    return ()=>{
        if (previousValue) element.setAttribute(attribute, previousValue);
        else element.removeAttribute(attribute);
    };
}
function $ce68a3edc3fc357d$export$602eac185826482c({ children: children, animation: animation, styles: styles, className: className, on: on, portal: portal, close: close }) {
    const [mounted, setMounted] = $5NSbj.useState(false);
    const [visible, setVisible] = $5NSbj.useState(false);
    const cleanup = $5NSbj.useRef([]);
    const restoreFocus = $5NSbj.useRef(null);
    const { setTimeout: setTimeout } = $ce68a3edc3fc357d$export$1bc7162631c81b3f();
    const { subscribe: subscribe } = $ce68a3edc3fc357d$export$91a992459f6e0f07();
    const reduceMotion = $ce68a3edc3fc357d$export$f3e625e1b2b31d60();
    const animationDuration = !reduceMotion ? animation.fade : 0;
    $5NSbj.useEffect(()=>{
        setMounted(true);
        return ()=>{
            setMounted(false);
            setVisible(false);
        };
    }, []);
    const handleCleanup = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        cleanup.current.forEach((clean)=>clean());
        cleanup.current = [];
    });
    const handleClose = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        var _a;
        setVisible(false);
        handleCleanup();
        (_a = on.exiting) === null || _a === void 0 || _a.call(on);
        setTimeout(()=>{
            var _a;
            (_a = on.exited) === null || _a === void 0 || _a.call(on);
            close();
        }, animationDuration);
    });
    $5NSbj.useEffect(()=>subscribe((0, $f848676e0d96e999$export$493a596486210a21), handleClose), [
        subscribe,
        handleClose
    ]);
    const handleEnter = $ce68a3edc3fc357d$export$ee5b5d04074a389e((node)=>{
        var _a, _b, _c;
        node.scrollTop;
        setVisible(true);
        (_a = on.entering) === null || _a === void 0 || _a.call(on);
        const elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
        for(let i = 0; i < elements.length; i += 1){
            const element = elements[i];
            if ([
                "TEMPLATE",
                "SCRIPT",
                "STYLE"
            ].indexOf(element.tagName) === -1 && element !== node) {
                cleanup.current.push($ce68a3edc3fc357d$var$setAttribute(element, "inert", "true"));
                cleanup.current.push($ce68a3edc3fc357d$var$setAttribute(element, "aria-hidden", "true"));
            }
        }
        cleanup.current.push(()=>{
            var _a, _b;
            (_b = (_a = restoreFocus.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
        });
        setTimeout(()=>{
            var _a;
            (_a = on.entered) === null || _a === void 0 || _a.call(on);
        }, animationDuration);
    });
    const handleRef = $5NSbj.useCallback((node)=>{
        if (node) handleEnter(node);
        else handleCleanup();
    }, [
        handleEnter,
        handleCleanup
    ]);
    return mounted ? (0, $178ae9275e33f716$exports.createPortal)($5NSbj.createElement("div", {
        ref: handleRef,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37(className, $ce68a3edc3fc357d$export$1283875077dc8f0a("root"), $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssPrefix$1()), $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$651541414233b476)), visible && $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssPrefix$1("open"))),
        role: "presentation",
        "aria-live": "polite",
        style: {
            ...animation.fade !== $ce68a3edc3fc357d$export$d626463445cef3e9.animation.fade ? {
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("fade_animation_duration")]: `${animationDuration}ms`
            } : null,
            ...animation.easing.fade !== $ce68a3edc3fc357d$export$d626463445cef3e9.animation.easing.fade ? {
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("fade_animation_timing_function")]: animation.easing.fade
            } : null,
            ...styles.root
        },
        onFocus: (event)=>{
            if (!restoreFocus.current) restoreFocus.current = event.relatedTarget;
        }
    }, children), portal.root || document.body) : null;
}
const $ce68a3edc3fc357d$export$f2a0761442face5c = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$9d2e4856063e1a22), $ce68a3edc3fc357d$export$602eac185826482c);
function $ce68a3edc3fc357d$export$be92b6f5f03c0fe9({ children: children }) {
    return $5NSbj.createElement($5NSbj.Fragment, null, children);
}
const $ce68a3edc3fc357d$export$fa1081225b99a9f2 = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$62f3c66ae8dab8a3), $ce68a3edc3fc357d$export$be92b6f5f03c0fe9);
function $ce68a3edc3fc357d$var$cssPrefix(value) {
    return $ce68a3edc3fc357d$export$195c4126907dde97((0, $f848676e0d96e999$export$5414719b40b8294f), value);
}
function $ce68a3edc3fc357d$export$4c260019440d418f({ toolbar: { buttons: buttons }, render: { buttonClose: buttonClose, iconClose: iconClose }, styles: styles }) {
    const { close: close, setToolbarWidth: setToolbarWidth } = $ce68a3edc3fc357d$export$e8c786024a2b0a79();
    const { setContainerRef: setContainerRef, containerRect: containerRect } = $ce68a3edc3fc357d$export$b1d85de58d38d09d();
    $ce68a3edc3fc357d$export$e5c5a5f917a5871c(()=>{
        setToolbarWidth(containerRect === null || containerRect === void 0 ? void 0 : containerRect.width);
    }, [
        setToolbarWidth,
        containerRect === null || containerRect === void 0 ? void 0 : containerRect.width
    ]);
    const renderCloseButton = ()=>{
        if (buttonClose) return buttonClose();
        return $5NSbj.createElement($ce68a3edc3fc357d$export$c25acd513dcc8062, {
            key: (0, $f848676e0d96e999$export$493a596486210a21),
            label: "Close",
            icon: $ce68a3edc3fc357d$export$cae179f078f4b4a4,
            renderIcon: iconClose,
            onClick: close
        });
    };
    return $5NSbj.createElement("div", {
        ref: setContainerRef,
        style: styles.toolbar,
        className: $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssPrefix())
    }, buttons === null || buttons === void 0 ? void 0 : buttons.map((button)=>button === (0, $f848676e0d96e999$export$493a596486210a21) ? renderCloseButton() : button));
}
const $ce68a3edc3fc357d$export$d0a9743c06e42ce8 = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$5414719b40b8294f), $ce68a3edc3fc357d$export$4c260019440d418f);
function $ce68a3edc3fc357d$var$renderNode(node, props) {
    var _a;
    return $5NSbj.createElement(node.module.component, {
        key: node.module.name,
        ...props
    }, (_a = node.children) === null || _a === void 0 ? void 0 : _a.map((child)=>$ce68a3edc3fc357d$var$renderNode(child, props)));
}
function $ce68a3edc3fc357d$var$mergeAnimation(defaultAnimation, animation = {}) {
    const { easing: defaultAnimationEasing, ...restDefaultAnimation } = defaultAnimation;
    const { easing: easing, ...restAnimation } = animation;
    return {
        easing: {
            ...defaultAnimationEasing,
            ...easing
        },
        ...restDefaultAnimation,
        ...restAnimation
    };
}
function $ce68a3edc3fc357d$export$7d2670a66155874b({ carousel: carousel, animation: animation, render: render, toolbar: toolbar, controller: controller, noScroll: noScroll, on: on, plugins: plugins, slides: slides, index: index, ...restProps }) {
    const { animation: defaultAnimation, carousel: defaultCarousel, render: defaultRender, toolbar: defaultToolbar, controller: defaultController, noScroll: defaultNoScroll, on: defaultOn, slides: defaultSlides, index: defaultIndex, plugins: defaultPlugins, ...restDefaultProps } = $ce68a3edc3fc357d$export$d626463445cef3e9;
    const { config: config, augmentation: augmentation } = $ce68a3edc3fc357d$export$bc996c07eb970c78([
        $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$f2a0761442face5c, [
            $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$7ded5f1cd4840ad, [
                $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$be59d34228c8ec8a, [
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$9c087759a323a56c),
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$d0a9743c06e42ce8),
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$6c16e1ac15089858)
                ])
            ])
        ])
    ], plugins || defaultPlugins);
    const props = augmentation({
        animation: $ce68a3edc3fc357d$var$mergeAnimation(defaultAnimation, animation),
        carousel: {
            ...defaultCarousel,
            ...carousel
        },
        render: {
            ...defaultRender,
            ...render
        },
        toolbar: {
            ...defaultToolbar,
            ...toolbar
        },
        controller: {
            ...defaultController,
            ...controller
        },
        noScroll: {
            ...defaultNoScroll,
            ...noScroll
        },
        on: {
            ...defaultOn,
            ...on
        },
        ...restDefaultProps,
        ...restProps
    });
    if (!props.open) return null;
    return $5NSbj.createElement($ce68a3edc3fc357d$export$7141a340a3dea601, {
        ...props
    }, $5NSbj.createElement($ce68a3edc3fc357d$export$62d2e1d2e7609988, {
        slides: slides || defaultSlides,
        index: $ce68a3edc3fc357d$export$5f87784a266e50a4(index || defaultIndex)
    }, $5NSbj.createElement($ce68a3edc3fc357d$export$9d9954f5885fa393, null, $5NSbj.createElement($ce68a3edc3fc357d$export$686accdd53ac150f, null, $ce68a3edc3fc357d$var$renderNode($ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$fa1081225b99a9f2, config), props)))));
}


// TODO: do the search highlights client-side
function $c7401791303982ef$var$reHighlight(text) {
    return text.split(/<span class="found">(.+?)<\/span>/).map((n, i)=>i % 2 == 0 ? n : /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
            className: "found",
            children: n
        }, i));
}
function $c7401791303982ef$var$setupLightbox({ element: element, setSlides: setSlides, setSelectedPhotoIndex: setSelectedPhotoIndex }) {
    const images = element.querySelectorAll('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[href$=".jpg:large"], a[href$=".jpeg:large"], a[href$=".png:large"], a[href$=".gif:large"]');
    setSlides(Array.from(images).map((link, index)=>{
        link.addEventListener("click", (event)=>{
            event.preventDefault();
            setSelectedPhotoIndex(index);
        });
        return {
            src: link.getAttribute("href")
        };
    }));
}
function $c7401791303982ef$var$stopPropagation(event) {
    event.stopPropagation();
}
function $c7401791303982ef$var$lazyLoadImages(content) {
    content.querySelectorAll("img").forEach((img)=>{
        img.setAttribute("src", img.getAttribute("data-selfoss-src"));
    });
}
// React will prevent the default action when it bubbles to our callbacks.
// Let’s stop bubbling for links.
// https://medium.com/peloton-engineering/onclick-wat-51331718ba9
function $c7401791303982ef$var$fixLinkBubbling(content) {
    content.querySelectorAll("a").forEach((a)=>{
        a.addEventListener("click", (event)=>{
            event.stopPropagation();
        });
    });
}
// Prevent passing referrer info when opening a link.
function $c7401791303982ef$var$sanitizeContent(content) {
    content.querySelectorAll("a").forEach((a)=>{
        const oldRel = a.getAttribute("rel");
        a.setAttribute("rel", "noreferrer" + (oldRel ? " " + oldRel : ""));
        // Ensure links inside item content are opened in new tab/window.
        a.setAttribute("target", "_blank");
    });
}
function $c7401791303982ef$var$handleKeyUp(event) {
    // emulate clicking when using keyboard
    if (event.keyCode === 13) {
        event.target.click();
        event.preventDefault();
        event.stopPropagation();
    }
}
function $c7401791303982ef$var$preventDefaultOnSmartphone(event) {
    // We want to use the whole title as action for opening/closing items
    // and smartphones have separate buttons for opening the article anyway.
    if (selfoss.isSmartphone()) event.preventDefault();
}
// Handle closing fullscreen on mobile
function $c7401791303982ef$var$closeFullScreen({ event: event, history: history, location: location, entryId: entryId }) {
    event.preventDefault();
    event.stopPropagation();
    selfoss.entriesPage.setEntryExpanded(entryId, false);
    history.replace((0, $7c8cbf542ee98bec$export$7f0beea2aa79e4fa)(location, {
        id: null
    }));
}
// show/hide entry
function $c7401791303982ef$var$handleClick({ event: event, history: history, location: location, expanded: expanded, id: id, target: target }) {
    const expected = selfoss.isMobile() ? ".entry" : ".entry-title";
    if (target !== expected) return;
    event.preventDefault();
    event.stopPropagation();
    if (expanded) {
        selfoss.entriesPage.setSelectedEntry(id);
        selfoss.entriesPage.deactivateEntry(id);
        history.replace((0, $7c8cbf542ee98bec$export$7f0beea2aa79e4fa)(location, {
            id: null
        }));
    } else {
        selfoss.entriesPage.activateEntry(id);
        history.replace((0, $7c8cbf542ee98bec$export$7f0beea2aa79e4fa)(location, {
            id: id
        }));
    }
}
// load images
function $c7401791303982ef$var$loadImages({ event: event, setImagesLoaded: setImagesLoaded, contentBlock: contentBlock }) {
    event.preventDefault();
    event.stopPropagation();
    $c7401791303982ef$var$lazyLoadImages(contentBlock.current);
    setImagesLoaded(true);
}
// next item on tablet and smartphone
function $c7401791303982ef$var$openNext(event) {
    event.preventDefault();
    event.stopPropagation();
    // TODO: Figure out why it does not work when run immediately.
    requestAnimationFrame(()=>{
        selfoss.entriesPage?.nextPrev((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).NEXT, true);
    });
}
function $c7401791303982ef$var$ShareButton({ label: label, icon: icon, item: item, action: action, showLabel: showLabel = true }) {
    const shareOnClick = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        action({
            id: item.id,
            url: item.link,
            // TODO: remove HTML
            title: item.title
        });
    }, [
        item,
        action
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
        type: "button",
        className: "entry-share",
        title: label,
        "aria-label": label,
        onClick: shareOnClick,
        children: [
            icon,
            " ",
            showLabel ? label : null
        ]
    });
}
$c7401791303982ef$var$ShareButton.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string.isRequired,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).element
    ]).isRequired,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    action: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    showLabel: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool
};
function $c7401791303982ef$var$ItemTag({ tag: tag, color: color }) {
    const style = (0, $5NSbj.useMemo)(()=>({
            color: color.foreColor,
            backgroundColor: color.backColor
        }), [
        color
    ]);
    const link = (0, $5NSbj.useCallback)((location)=>({
            ...location,
            ...(0, $7c8cbf542ee98bec$export$d0bb2ab5375d1521)(location, {
                category: `tag-${tag}`,
                id: null
            }),
            state: (0, $7c8cbf542ee98bec$export$e64cf1b9b4b3aa56)(location)
        }), [
        tag
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
        className: "entry-tags-tag",
        style: style,
        to: link,
        onClick: $c7401791303982ef$var$preventDefaultOnSmartphone,
        children: tag
    });
}
$c7401791303982ef$var$ItemTag.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired
};
/**
 * Converts Date to a relative string.
 * When the date is too old, null is returned instead.
 * @param {Date} currentTime
 * @param {Date} datetime
 * @return {?String} relative time reference
 */ function $c7401791303982ef$var$datetimeRelative(currentTime, datetime) {
    const ageInseconds = (currentTime - datetime) / 1000;
    const ageInMinutes = ageInseconds / 60;
    const ageInHours = ageInMinutes / 60;
    const ageInDays = ageInHours / 24;
    if (ageInHours < 1) return selfoss.app._("minutes", [
        Math.round(ageInMinutes)
    ]);
    else if (ageInDays < 1) return selfoss.app._("hours", [
        Math.round(ageInHours)
    ]);
    else return null;
}
function $c7401791303982ef$export$2e2bcd8739ae039({ currentTime: currentTime, item: item, selected: selected, expanded: expanded, setNavExpanded: setNavExpanded }) {
    const { title: title, author: author, sourcetitle: sourcetitle } = item;
    const [fullScreenTrap, setFullScreenTrap] = (0, $5NSbj.useState)(null);
    const [imagesLoaded, setImagesLoaded] = (0, $5NSbj.useState)(false);
    const contentBlock = (0, $5NSbj.useRef)(null);
    const location = (0, $88361e604f4abd56$export$45d76561a5302f2b)();
    const history = (0, $88361e604f4abd56$export$3420e1dc2c4a518c)();
    const relDate = (0, $5NSbj.useMemo)(()=>$c7401791303982ef$var$datetimeRelative(currentTime, item.datetime), [
        currentTime,
        item.datetime
    ]);
    const previouslyExpanded = (0, $7591aa31d7cb8c81$export$f6f3f74729fdd0b7)(expanded);
    const configuration = (0, $5NSbj.useContext)((0, $7b0908670bf0de1b$export$326f6d1b69f1c06e));
    const [slides, setSlides] = (0, $5NSbj.useState)([]);
    const [selectedPhotoIndex, setSelectedPhotoIndex] = (0, $5NSbj.useState)(null);
    (0, $5NSbj.useEffect)(()=>{
        // Handle entry becoming/ceasing to be expanded.
        const parent = document.querySelector(`.entry[data-entry-id="${item.id}"]`);
        if (expanded) {
            const firstExpansion = contentBlock.current.childElementCount === 0;
            if (firstExpansion) {
                contentBlock.current.innerHTML = item.content;
                $c7401791303982ef$var$sanitizeContent(contentBlock.current);
                selfoss.extensionPoints.processItemContents(contentBlock.current);
                // load images not on mobile devices
                if (selfoss.isMobile() == false || configuration.loadImagesOnMobile) {
                    setImagesLoaded(true);
                    $c7401791303982ef$var$lazyLoadImages(contentBlock.current);
                }
            }
            if (selfoss.isSmartphone()) {
                // save scroll position
                let scrollTop = window.scrollY;
                setNavExpanded((expanded)=>{
                    // hide nav
                    if (expanded) {
                        scrollTop = scrollTop - document.querySelector("#nav").getBoundingClientRect().height;
                        scrollTop = scrollTop < 0 ? 0 : scrollTop;
                        window.scrollTo({
                            top: scrollTop
                        });
                        return false;
                    }
                    return expanded;
                });
                // show fullscreen
                document.body.classList.add("fullscreen-mode");
                const trap = (0, $66c441288a5fbbb7$export$360440dfcba94c00)(parent);
                setFullScreenTrap(trap);
                trap.activate();
                if (firstExpansion) $c7401791303982ef$var$fixLinkBubbling(contentBlock.current);
            } else {
                if (firstExpansion) // setup fancyBox image viewer
                $c7401791303982ef$var$setupLightbox({
                    element: contentBlock.current,
                    setSlides: setSlides,
                    setSelectedPhotoIndex: setSelectedPhotoIndex
                });
                // scroll to article header
                if (configuration.scrollToArticleHeader) parent.scrollIntoView();
                if (firstExpansion) // turn of column view if entry is too long
                requestAnimationFrame(()=>{
                    // Delayed into next frame so that the entry is expanded when the height is being determined.
                    if (contentBlock.current.getBoundingClientRect().height > document.body.clientHeight) contentBlock.current.parentNode.classList.add("entry-content-nocolumns");
                });
            }
        } else {
            // No longer expanded.
            setFullScreenTrap((trap)=>{
                if (trap !== null) trap.deactivate();
                return null;
            });
            document.body.classList.remove("fullscreen-mode");
        }
    }, [
        configuration,
        expanded,
        item.content,
        item.id,
        setNavExpanded
    ]);
    (0, $5NSbj.useEffect)(()=>{
        // Handle autoHideReadOnMobile setting.
        if (selfoss.isSmartphone() && !expanded && previouslyExpanded) {
            const autoHideReadOnMobile = configuration.autoHideReadOnMobile && item.unread == 1;
            if (autoHideReadOnMobile && item.unread != 1) selfoss.entriesPage.setEntries((entries)=>entries.filter(({ id: id })=>id !== item.id));
        }
    }, [
        configuration,
        expanded,
        item.id,
        item.unread,
        previouslyExpanded
    ]);
    const entryOnClick = (0, $5NSbj.useCallback)((event)=>$c7401791303982ef$var$handleClick({
            event: event,
            history: history,
            location: location,
            expanded: expanded,
            id: item.id,
            target: ".entry"
        }), [
        history,
        location,
        expanded,
        item.id
    ]);
    const titleOnClick = (0, $5NSbj.useCallback)((event)=>$c7401791303982ef$var$handleClick({
            event: event,
            history: history,
            location: location,
            expanded: expanded,
            id: item.id,
            target: ".entry-title"
        }), [
        history,
        location,
        expanded,
        item.id
    ]);
    const starOnClick = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        selfoss.entriesPage.markEntryStarred(item.id, item.starred != 1);
    }, [
        item
    ]);
    const markReadOnClick = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        selfoss.entriesPage.markEntryRead(item.id, item.unread == 1);
    }, [
        item
    ]);
    const loadImagesOnClick = (0, $5NSbj.useCallback)((event)=>$c7401791303982ef$var$loadImages({
            event: event,
            setImagesLoaded: setImagesLoaded,
            contentBlock: contentBlock
        }), []);
    const closeOnClick = (0, $5NSbj.useCallback)((event)=>$c7401791303982ef$var$closeFullScreen({
            event: event,
            history: history,
            location: location,
            entryId: item.id
        }), [
        history,
        location,
        item.id
    ]);
    const titleHtml = (0, $5NSbj.useMemo)(()=>({
            __html: title ? title : selfoss.app._("no_title")
        }), [
        title
    ]);
    const sourceLink = (0, $5NSbj.useCallback)((location)=>({
            ...location,
            ...(0, $7c8cbf542ee98bec$export$d0bb2ab5375d1521)(location, {
                category: `source-${item.source}`,
                id: null
            }),
            state: (0, $7c8cbf542ee98bec$export$e64cf1b9b4b3aa56)(location)
        }), [
        item.source
    ]);
    const canWrite = (0, $49b55be3b2a6e8d6$export$b416b77cd328c02f)();
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    const sharers = (0, $f686a1f3350288b9$export$aebedbd51beb48eb)({
        configuration: configuration,
        _: _
    });
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
        "data-entry-id": item.id,
        "data-entry-source": item.source,
        "data-entry-url": item.link,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            entry: true,
            unread: item.unread == 1,
            expanded: expanded,
            selected: selected
        }),
        role: "article",
        "aria-modal": fullScreenTrap !== null,
        onClick: entryOnClick,
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
                href: item.link,
                className: "entry-icon",
                tabIndex: "-1",
                rel: "noreferrer",
                "aria-hidden": "true",
                onClick: $c7401791303982ef$var$preventDefaultOnSmartphone,
                children: item.icon !== null && item.icon.trim().length > 0 && item.icon != "0" ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("img", {
                    src: `favicons/${item.icon}`,
                    "aria-hidden": "true",
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h3", {
                className: "entry-title",
                onClick: titleOnClick,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                    className: "entry-title-link",
                    "aria-expanded": expanded,
                    "aria-current": selected,
                    role: "link",
                    tabIndex: "0",
                    onKeyUp: $c7401791303982ef$var$handleKeyUp,
                    dangerouslySetInnerHTML: titleHtml
                })
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                className: "entry-tags",
                children: Object.entries(item.tags).map(([tag, color])=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($c7401791303982ef$var$ItemTag, {
                        tag: tag,
                        color: color
                    }, tag))
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
                className: "entry-source",
                to: sourceLink,
                onClick: $c7401791303982ef$var$preventDefaultOnSmartphone,
                children: $c7401791303982ef$var$reHighlight(sourcetitle)
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                className: "entry-separator",
                children: "\u2022"
            }),
            author !== null ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "entry-author",
                        children: author
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "entry-separator",
                        children: "\u2022"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
                href: item.link,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    "entry-datetime": true,
                    timestamped: relDate === null
                }),
                target: "_blank",
                rel: "noreferrer",
                onClick: $c7401791303982ef$var$preventDefaultOnSmartphone,
                children: relDate !== null ? relDate : item.datetime.toLocaleString()
            }),
            configuration.readingSpeed !== null ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "entry-separator",
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "entry-readtime",
                        children: _("article_reading_time", [
                            Math.round(item.wordCount / configuration.readingSpeed)
                        ])
                    })
                ]
            }) : null,
            item.thumbnail && item.thumbnail.trim().length > 0 ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    "entry-thumbnail": true,
                    "entry-thumbnail-always-visible": configuration.showThumbnails
                }),
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
                    href: item.link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("img", {
                        src: `thumbnails/${item.thumbnail}`,
                        alt: item.strippedTitle
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    "entry-content": true,
                    "entry-content-nocolumns": item.lengthWithoutTags < 500
                }),
                children: [
                    slides.length !== 0 && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ce68a3edc3fc357d$export$7d2670a66155874b), {
                        open: selectedPhotoIndex !== null,
                        index: selectedPhotoIndex,
                        close: ()=>setSelectedPhotoIndex(null),
                        carousel: {
                            finite: true
                        },
                        controller: {
                            closeOnBackdropClick: true
                        },
                        on: {
                            entered: ()=>selfoss.lightboxActive.update(true),
                            exited: ()=>selfoss.lightboxActive.update(false)
                        },
                        slides: slides
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                        ref: contentBlock
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                        className: "entry-smartphone-share",
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
                            "aria-label": _("article_actions"),
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("a", {
                                        href: item.link,
                                        className: "entry-newwindow",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        accessKey: "o",
                                        onClick: $c7401791303982ef$var$stopPropagation,
                                        children: [
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                                icon: $4f6e76a0ad832aa1$exports.faExternalLinkAlt
                                            }),
                                            " ",
                                            _("open_window")
                                        ]
                                    })
                                }),
                                sharers.map(({ key: key, label: label, icon: icon, action: action })=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($c7401791303982ef$var$ShareButton, {
                                            label: label,
                                            icon: icon,
                                            item: item,
                                            action: action
                                        })
                                    }, key)),
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                                        type: "button",
                                        accessKey: "n",
                                        className: "entry-next",
                                        onClick: $c7401791303982ef$var$openNext,
                                        children: [
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                                icon: $e4ff5d82615e7815$exports.faArrowRight
                                            }),
                                            " ",
                                            _("next")
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
                "aria-label": _("article_actions"),
                className: "entry-toolbar",
                children: [
                    canWrite && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            accessKey: "a",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                "entry-starr": true,
                                active: item.starred == 1
                            }),
                            onClick: starOnClick,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                    icon: item.starred == 1 ? $2d6ef9374862f0b1$exports.faStar : $1e8ca391384385ce$exports.faStar
                                }),
                                " ",
                                item.starred == 1 ? _("unstar") : _("star")
                            ]
                        })
                    }),
                    canWrite && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            accessKey: "u",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                "entry-unread": true,
                                active: item.unread == 1
                            }),
                            onClick: markReadOnClick,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                    icon: item.unread == 1 ? $8e226679142db257$exports.faCheckCircle : $154f2d6577c9bf5d$exports.faCheckCircle
                                }),
                                " ",
                                item.unread == 1 ? _("mark") : _("unmark")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("a", {
                            href: item.link,
                            className: "entry-newwindow",
                            target: "_blank",
                            rel: "noreferrer",
                            accessKey: "o",
                            onClick: $c7401791303982ef$var$stopPropagation,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                    icon: $4f6e76a0ad832aa1$exports.faExternalLinkAlt
                                }),
                                " ",
                                _("open_window")
                            ]
                        })
                    }),
                    !imagesLoaded ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            className: "entry-loadimages",
                            onClick: loadImagesOnClick,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                    icon: $2feb01c0637ffeff$exports.faArrowAltCircleDown
                                }),
                                " ",
                                _("load_img")
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            type: "button",
                            accessKey: "n",
                            className: "entry-next",
                            onClick: $c7401791303982ef$var$openNext,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                    icon: $e4ff5d82615e7815$exports.faArrowRight
                                }),
                                " ",
                                _("next")
                            ]
                        })
                    }),
                    sharers.map(({ key: key, label: label, icon: icon, action: action })=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($c7401791303982ef$var$ShareButton, {
                                label: label,
                                icon: icon,
                                item: item,
                                action: action,
                                showLabel: false
                            })
                        }, key)),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            accessKey: "c",
                            className: "entry-close",
                            onClick: closeOnClick,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                    icon: $72abcd8059f7a937$exports.faTimesCircle
                                }),
                                " ",
                                _("close_entry")
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
$c7401791303982ef$export$2e2bcd8739ae039.propTypes = {
    currentTime: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).instanceOf(Date).isRequired,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    expanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};





function $c0fc5d9a6429f0a7$var$safeDate(datetimeString) {
    const date = new Date(datetimeString);
    if (isNaN(date.valueOf())) throw new Error(`Invalid date detected: \u{201C}${datetimeString}\u{201D}`);
    else return date;
}
function $c0fc5d9a6429f0a7$export$8ce663b0c6b2535e(ids) {
    return $7d3633f2d0caaef5$export$299ba2dee77727e9("mark", {
        headers: {
            "content-type": "application/json; charset=utf-8"
        },
        body: JSON.stringify(ids)
    }).promise.then((response)=>response.json());
}
function $c0fc5d9a6429f0a7$export$d11ee7cd6d3f95d4(id, starr) {
    return $7d3633f2d0caaef5$export$299ba2dee77727e9(`${starr ? "starr" : "unstarr"}/${id}`).promise;
}
function $c0fc5d9a6429f0a7$export$bf7f2fce5c1cf636(id, read) {
    return $7d3633f2d0caaef5$export$299ba2dee77727e9(`${read ? "unmark" : "mark"}/${id}`).promise;
}
/**
 * Converts some values like dates in an entry into a objects.
 */ function $c0fc5d9a6429f0a7$var$enrichEntry(entry) {
    return {
        ...entry,
        link: (0, $ec6aeee77f582aff$export$e8bacd2802a88316)(entry.link),
        datetime: $c0fc5d9a6429f0a7$var$safeDate(entry.datetime),
        updatetime: entry.updatetime ? $c0fc5d9a6429f0a7$var$safeDate(entry.updatetime) : entry.updatetime
    };
}
/**
 * Converts some values like dates in response into a objects.
 */ function $c0fc5d9a6429f0a7$var$enrichItemsResponse(data) {
    return {
        ...data,
        lastUpdate: data.lastUpdate ? $c0fc5d9a6429f0a7$var$safeDate(data.lastUpdate) : data.lastUpdate,
        // in getItems
        entries: data.entries?.map($c0fc5d9a6429f0a7$var$enrichEntry),
        // in sync
        newItems: data.newItems?.map($c0fc5d9a6429f0a7$var$enrichEntry)
    };
}
function $c0fc5d9a6429f0a7$export$d2f92acf417bbf5d(filter, abortController) {
    return $7d3633f2d0caaef5$export$3988ae62b71be9a3("", {
        body: $7d3633f2d0caaef5$export$92871f7982deaf9f({
            ...filter,
            fromDatetime: filter.fromDatetime ? filter.fromDatetime.toISOString() : filter.fromDatetime
        }),
        abortController: abortController
    }).promise.then((response)=>response.json()).then($c0fc5d9a6429f0a7$var$enrichItemsResponse);
}
function $c0fc5d9a6429f0a7$export$92d6409d68f0739a(updatedStatuses, syncParams) {
    const params = {
        ...syncParams,
        updatedStatuses: syncParams.updatedStatuses ? syncParams.updatedStatuses.map((status)=>{
            return {
                ...status,
                datetime: status.datetime.toISOString()
            };
        }) : syncParams.updatedStatuses
    };
    if ("since" in params) params.since = params.since.toISOString();
    if ("itemsNotBefore" in params) params.itemsNotBefore = params.itemsNotBefore.toISOString();
    const { controller: controller, promise: promise } = $7d3633f2d0caaef5$export$e7aa7bc5c1b3cfb3("items/sync", {
        method: updatedStatuses ? "POST" : "GET",
        body: $7d3633f2d0caaef5$export$92871f7982deaf9f(params)
    });
    return {
        controller: controller,
        promise: promise.then((response)=>response.json()).then($c0fc5d9a6429f0a7$var$enrichItemsResponse)
    };
}













function $9a29cc780ecc33b8$var$reloadList({ fetchParams: fetchParams, abortController: abortController, append: append = false, waitForSync: waitForSync = true, configuration: configuration, entryId: entryId = null, setLoadingState: setLoadingState }) {
    if (abortController.signal.aborted) return Promise.resolve();
    if (entryId && fetchParams.fromId === undefined) fetchParams = {
        ...fetchParams,
        extraIds: [
            ...fetchParams.extraIds,
            entryId
        ]
    };
    if (!append || fetchParams.type !== (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).NEWEST) selfoss.dbOffline.olderEntriesOnline = false;
    setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING);
    const reload = ()=>{
        if (abortController.signal.aborted) return Promise.resolve();
        let reloader = selfoss.dbOffline.getEntries;
        // tag, source and search filtering not supported offline (yet?)
        if (fetchParams.tag || fetchParams.source || fetchParams.search) reloader = selfoss.dbOnline.getEntries;
        const forceLoadOnline = selfoss.dbOffline.olderEntriesOnline || selfoss.dbOffline.shouldLoadEntriesOnline;
        if (!selfoss.db.enableOffline.value || selfoss.isOnline() && forceLoadOnline) reloader = selfoss.dbOnline.getEntries;
        // Clean state when not just adding items.
        if (!append) {
            selfoss.entriesPage.setHasMore(false);
            selfoss.entriesPage.setExpandedEntries({});
            selfoss.entriesPage.setEntries([]);
            selfoss.entriesPage.setSelectedEntry(null);
        }
        setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING);
        return reloader(fetchParams, abortController).then(({ entries: entries, hasMore: hasMore })=>{
            if (abortController.signal.aborted) return;
            setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
            selfoss.entriesPage.setHasMore(hasMore);
            if (append) selfoss.entriesPage.appendEntries(entries);
            else {
                selfoss.entriesPage.setExpandedEntries({});
                selfoss.entriesPage.setEntries(entries);
                // open selected entry only if entry was requested (i.e. if not streaming
                // more)
                if (entryId && fetchParams.fromId === undefined) {
                    const entry = document.querySelector(`.entry[data-entry-id="${entryId}"]`);
                    if (!entry) return;
                    selfoss.entriesPage.activateEntry(entryId);
                    // ensure scrolling to requested entry even if scrolling to article
                    // header is disabled
                    if (!configuration.scrollToArticleHeader) // needs to be delayed for some reason
                    requestAnimationFrame(()=>{
                        entry.scrollIntoView();
                    });
                } else window.scrollTo({
                    top: 0
                });
            }
        }).catch((error)=>{
            if (abortController.signal.aborted) return;
            if (error instanceof (0, $506fdaa0545346a2$export$65bd6083489bd8bb) && error.response.status === 403) {
                selfoss.history.push("/sign/in", {
                    error: selfoss.app._("error_session_expired")
                });
                return;
            }
            setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).FAILURE);
            selfoss.app.showError(selfoss.app._("error_loading") + " " + error.message);
        });
    };
    if (waitForSync && selfoss.dbOnline.syncing.promise) {
        selfoss.db.userWaiting = true;
        return selfoss.dbOnline.syncing.promise.finally(reload);
    } else return reload();
}
/**
 * Try to open the selected article using the preferred method.
 * @param {number} selected
 */ function $9a29cc780ecc33b8$var$openSelectedArticle(selected) {
    const link = document.querySelector(`.entry[data-entry-id="${selected}"] .entry-datetime`);
    if (selfoss.config.openInBackgroundTab) {
        // In Chromium, this will just cause the tab to open in the foreground.
        // Appears to be disallowed by the pop-under prevention:
        // https://crbug.com/431335
        // https://crbug.com/487919
        const event = new MouseEvent("click", {
            ctrlKey: true
        });
        link.dispatchEvent(event);
    } else // open item in new window
    link.click();
}
// updates a source
function $9a29cc780ecc33b8$var$handleRefreshSource({ event: event, source: source, setLoadingState: setLoadingState, setNavExpanded: setNavExpanded, reload: reload }) {
    event.preventDefault();
    // show loading
    setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING);
    return $3972545cf57eb298$export$c1f8f7c408fa54a(source).then(()=>{
        // hide nav on smartphone
        setNavExpanded(false);
        // Fetch the new items and reload the list.
        // Will also clear the loading status.
        reload();
    }).catch((error)=>{
        setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).FAILURE);
        alert(selfoss.app._("error_refreshing_source") + " " + error.message);
    });
}
function $9a29cc780ecc33b8$export$66d62ccfdff1c843({ entries: entries, hasMore: hasMore, loadingState: loadingState, setLoadingState: setLoadingState, selectedEntry: selectedEntry, expandedEntries: expandedEntries, setNavExpanded: setNavExpanded, navSourcesExpanded: navSourcesExpanded, reload: reload, setGlobalUnreadCount: setGlobalUnreadCount, unreadItemsCount: unreadItemsCount }) {
    const allowedToUpdate = (0, $49b55be3b2a6e8d6$export$683005ba76038aff)();
    const allowedToWrite = (0, $49b55be3b2a6e8d6$export$b416b77cd328c02f)();
    const configuration = (0, $5NSbj.useContext)((0, $7b0908670bf0de1b$export$326f6d1b69f1c06e));
    const location = (0, $88361e604f4abd56$export$45d76561a5302f2b)();
    const forceReload = (0, $cdbcc1ec15a05191$export$7bcdf1c247ef07b1)();
    const searchText = (0, $5NSbj.useMemo)(()=>{
        const queryString = new URLSearchParams(location.search);
        return queryString.get("search") ?? "";
    }, [
        location.search
    ]);
    const params = (0, $88361e604f4abd56$export$99eaa27ddbbb95ef)();
    const currentTag = params.category?.startsWith("tag-") ? params.category.replace(/^tag-/, "") : null;
    const currentSource = params.category?.startsWith("source-") ? parseInt(params.category.replace(/^source-/, ""), 10) : null;
    // The offsets for pagination.
    // Clear them when URL changes, except for when only id changes since that happens when reading.
    const [fromDatetime, setFromDatetime] = (0, $7f88ad86c77db2c7$exports.useStateWithDeps)(undefined, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]);
    const [fromId, setFromId] = (0, $7f88ad86c77db2c7$exports.useStateWithDeps)(undefined, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]);
    // Cache the item id from initial URL so that we can fetch it
    // but do not re-fetch when the id in the URI changes later
    // since that happens when reading.
    const initialItemId = (0, $5NSbj.useMemo)(()=>{
        return parseInt(params.id, 10);
    }, [
        params.filter,
        currentTag,
        currentSource,
        searchText,
        forceReload
    ]);
    // Same for the state of navigation being expanded.
    // It is only passed to the API request as a part of optimization scheme
    // so there is no need for it to trigger refresh of the entries.
    const initialNavSourcesExpanded = (0, $5NSbj.useMemo)(()=>{
        return navSourcesExpanded;
    }, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]);
    const [moreLoadingState, setMoreLoadingState] = (0, $5NSbj.useState)((0, $c097b691ff08d4e3$export$62aa48085237e36f).INITIAL);
    // Perform the scheduled reload.
    (0, $5NSbj.useEffect)(()=>{
        const append = fromId !== undefined || fromDatetime !== undefined;
        const abortController = new AbortController();
        $9a29cc780ecc33b8$var$reloadList({
            // Object with parameters for GET /items and similar API calls
            // based on the current location.
            fetchParams: {
                type: params.filter,
                tag: currentTag,
                source: currentSource,
                extraIds: [],
                sourcesNav: initialNavSourcesExpanded,
                search: searchText,
                fromDatetime: fromDatetime,
                fromId: fromId
            },
            abortController: abortController,
            append: append,
            configuration: configuration,
            // We do not want to focus the entry on successive loads.
            entryId: append ? undefined : initialItemId,
            setLoadingState: append ? setMoreLoadingState : setLoadingState
        }).then(()=>{
            if (currentTag !== null && !selfoss.db.isValidTag(currentTag)) selfoss.app.showError(selfoss.app._("error_unknown_tag") + " " + currentTag);
            if (currentSource !== null && !selfoss.db.isValidSource(currentSource)) selfoss.app.showError(selfoss.app._("error_unknown_source") + " " + currentSource);
        });
        return ()=>{
            abortController.abort();
        };
    }, [
        configuration,
        params.filter,
        currentTag,
        currentSource,
        initialNavSourcesExpanded,
        searchText,
        fromDatetime,
        fromId,
        initialItemId,
        setLoadingState,
        forceReload
    ]);
    (0, $5NSbj.useEffect)(()=>{
        // scroll load more
        const onScroll = ()=>{
            const streamMoreButton = document.querySelector(".stream-more");
            if (!streamMoreButton) return;
            const streamMoreButtonTop = window.scrollY + streamMoreButton.getBoundingClientRect().top;
            // When “More” button appears on the screen, click it.
            if (streamMoreButtonTop < document.body.clientHeight + window.scrollY) streamMoreButton.click();
        };
        if (hasMore && moreLoadingState !== (0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING && configuration.autoStreamMore) {
            window.addEventListener("scroll", onScroll);
            return ()=>{
                window.removeEventListener("scroll", onScroll);
            };
        }
    }, [
        configuration,
        hasMore,
        moreLoadingState
    ]);
    (0, $5NSbj.useEffect)(()=>{
        // setup periodic server status sync
        const interval = window.setInterval(selfoss.db.sync, 60000);
        return ()=>{
            window.clearInterval(interval);
        };
    }, []);
    (0, $5NSbj.useEffect)(()=>{
        setGlobalUnreadCount(unreadItemsCount);
        return ()=>{
            setGlobalUnreadCount(null);
        };
    }, [
        setGlobalUnreadCount,
        unreadItemsCount
    ]);
    const isOnline = (0, $3d007043bfaeffb3$export$6feb6ada280bcdab)();
    const refreshOnClick = (0, $5NSbj.useCallback)((event)=>$9a29cc780ecc33b8$var$handleRefreshSource({
            event: event,
            source: currentSource,
            setLoadingState: setLoadingState,
            setNavExpanded: setNavExpanded,
            reload: reload
        }), [
        currentSource,
        setLoadingState,
        setNavExpanded,
        reload
    ]);
    const moreOnClick = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        const lastEntry = entries[entries.length - 1];
        // Calculate offset.
        setFromDatetime(lastEntry ? lastEntry.datetime : undefined);
        setFromId(lastEntry ? lastEntry.id : undefined);
    }, [
        entries,
        setFromDatetime,
        setFromId
    ]);
    // Current time for calculating relative dates in items.
    const [currentTime, setCurrentTime] = (0, $5NSbj.useState)(null);
    (0, $5NSbj.useEffect)(()=>{
        setCurrentTime(new Date());
        const tick = window.setInterval(()=>{
            setCurrentTime(new Date());
        }, 60000);
        return ()=>{
            clearInterval(tick);
        };
    }, []);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    if (loadingState === (0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING) return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $6efe1fd0084e29cd$export$84dbad74efe95918), {
        label: _("entries_loading")
    });
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
        children: [
            currentSource !== null && allowedToUpdate && isOnline ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                type: "button",
                className: "refresh-source",
                onClick: refreshOnClick,
                children: _("source_refresh")
            }) : null,
            currentSource !== null && allowedToWrite && isOnline ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
                to: {
                    pathname: "/manage/sources",
                    hash: `#source-${currentSource}`
                },
                className: "entries-go-to-settings",
                children: _("source_go_to_settings")
            }) : null,
            entries.map((entry)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $c7401791303982ef$export$2e2bcd8739ae039), {
                    item: entry,
                    currentTime: currentTime,
                    selected: selectedEntry == entry.id,
                    expanded: expandedEntries[entry.id] ?? false,
                    setNavExpanded: setNavExpanded
                }, entry.id)),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                id: "stream-buttons",
                children: [
                    loadingState === (0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS && entries.length === 0 ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
                        "aria-live": "assertive",
                        className: "stream-empty",
                        children: _("no_entries")
                    }) : null,
                    hasMore ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                            "stream-button": true,
                            "stream-more": true
                        }),
                        accessKey: "m",
                        "aria-label": _("more"),
                        onClick: moreLoadingState !== (0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING ? moreOnClick : null,
                        children: moreLoadingState !== (0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            children: _("more")
                        }) : /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $6efe1fd0084e29cd$export$7f7cbe89f1eacd2), {
                            size: "3x",
                            label: _("entries_loading")
                        })
                    }) : null,
                    entries.length > 0 ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                        className: "stream-button mark-these-read",
                        "aria-label": _("markread"),
                        onClick: selfoss.entriesPage.markVisibleRead,
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            children: _("markread")
                        })
                    }) : null,
                    loadingState == (0, $c097b691ff08d4e3$export$62aa48085237e36f).FAILURE ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                        className: "stream-button stream-error",
                        "aria-live": "assertive",
                        "aria-label": _("streamerror"),
                        onClick: reload,
                        children: _("streamerror")
                    }) : null
                ]
            })
        ]
    });
}
$9a29cc780ecc33b8$export$66d62ccfdff1c843.propTypes = {
    entries: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).array.isRequired,
    hasMore: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    loadingState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOf(Object.values((0, $c097b691ff08d4e3$export$62aa48085237e36f))).isRequired,
    setLoadingState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    selectedEntry: (0, (/*@__PURE__*/$parcel$interopDefault($ea2d4a6a4b369f4b$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number).isRequired,
    expandedEntries: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool).isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    reload: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    setGlobalUnreadCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired
};
const $9a29cc780ecc33b8$var$initialState = {
    entries: [],
    hasMore: false,
    /**
     * Currently selected entry.
     * The id in the location.hash should imply the selected entry.
     * It will also be used for keyboard navigation (for finding previous/next).
     */ selectedEntry: null,
    expandedEntries: {},
    loadingState: (0, $c097b691ff08d4e3$export$62aa48085237e36f).INITIAL
};
class $9a29cc780ecc33b8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component {
    constructor(props){
        super(props);
        this.state = $9a29cc780ecc33b8$var$initialState;
        this.reload = this.reload.bind(this);
        this.setLoadingState = this.setLoadingState.bind(this);
        this.activateEntry = this.activateEntry.bind(this);
        this.deactivateEntry = this.deactivateEntry.bind(this);
        this.markVisibleRead = this.markVisibleRead.bind(this);
        this.markEntryRead = this.markEntryRead.bind(this);
        this.markEntryStarred = this.markEntryStarred.bind(this);
        this.nextPrev = this.nextPrev.bind(this);
        this.entryNav = this.entryNav.bind(this);
        this.jumpToNext = this.jumpToNext.bind(this);
        this.toggleSelectedStarred = this.toggleSelectedStarred.bind(this);
        this.toggleSelectedRead = this.toggleSelectedRead.bind(this);
        this.toggleSelectedExpanded = this.toggleSelectedExpanded.bind(this);
        this.openSelectedTarget = this.openSelectedTarget.bind(this);
        this.openSelectedTargetAndMarkRead = this.openSelectedTargetAndMarkRead.bind(this);
        this.throw = this.throw.bind(this);
    }
    setEntries(entries) {
        if (typeof entries === "function") this.setState((state)=>({
                entries: entries(state.entries)
            }));
        else this.setState({
            entries: entries
        });
    }
    appendEntries(extraEntries) {
        this.setEntries((entries)=>[
                ...entries,
                ...extraEntries
            ]);
    }
    /**
     * Make the given entry currently selected one.
     * @param {number|function(number): number} id of entry to select, or a function that transforms a previous id into a new one
     */ setSelectedEntry(selectedEntry) {
        if (typeof selectedEntry === "function") this.setState((state)=>({
                selectedEntry: selectedEntry(state.selectedEntry)
            }));
        else this.setState({
            selectedEntry: selectedEntry
        });
    }
    /**
     * Get the currently selected entry.
     * @return {number}
     */ getSelectedEntry() {
        return this.state.selectedEntry;
    }
    setExpandedEntries(expandedEntries) {
        if (typeof expandedEntries === "function") this.setState((state)=>({
                expandedEntries: expandedEntries(state.expandedEntries)
            }));
        else this.setState({
            expandedEntries: expandedEntries
        });
    }
    setEntryExpanded(id, expand) {
        if (typeof expand === "function") this.setExpandedEntries((oldEntries)=>({
                ...oldEntries,
                [id]: expand(oldEntries[id] ?? false)
            }));
        else this.setExpandedEntries((oldEntries)=>({
                ...oldEntries,
                [id]: expand
            }));
    }
    /**
     * Collapse all expanded entries.
     */ collapseAllEntries() {
        this.setExpandedEntries({});
    }
    /**
     * Is given entry expanded?
     * @param {number} id of entry to check
     * @return {bool} whether it is expanded
     */ isEntryExpanded(entry) {
        return this.state.expandedEntries[entry] ?? false;
    }
    /**
     * Toggle expanded state of given entry.
     * @param {number} id of entry to toggle
     */ toggleEntryExpanded(entry) {
        if (!entry) return;
        this.setEntryExpanded(entry, (expanded)=>!(expanded ?? false));
    }
    /**
     * Activate entry as if it were clicked.
     * This will open it, focus it and based on the settings, mark it as read.
     * @param {number} id of entry
     */ activateEntry(id) {
        if (this.props.configuration.autoCollapse) this.collapseAllEntries();
        this.setSelectedEntry(id);
        // show/hide (with toolbar)
        this.setEntryExpanded(id, true);
        // automark as read
        const entry = this.state.entries.find((entry)=>id === entry.id);
        const autoMarkAsRead = selfoss.isAllowedToWrite() && this.props.configuration.autoMarkAsRead && entry.unread == 1;
        if (autoMarkAsRead) this.markEntryRead(id, true);
    }
    /**
     * Deactivate entry, as if it were clicked.
     * This will close it and maybe something more.
     * @param {number} id of entry
     */ deactivateEntry(id) {
        this.setEntryExpanded(id, false);
    }
    starEntryInView(id, starred) {
        this.setEntries((entries)=>entries.map((entry)=>{
                if (entry.id === id) return {
                    ...entry,
                    starred: starred
                };
                else return entry;
            }));
    }
    markEntryInView(id, unread) {
        this.setEntries((entries)=>entries.map((entry)=>{
                if (entry.id === id) return {
                    ...entry,
                    unread: unread
                };
                else return entry;
            }));
    }
    refreshEntryStatuses(entryStatuses) {
        this.state.entries.forEach((entry)=>{
            const { id: id } = entry;
            let newStatus = false;
            entryStatuses.some((entryStatus)=>{
                if (entryStatus.id == id) newStatus = entryStatus;
                return newStatus;
            });
            if (newStatus) {
                this.starEntryInView(id, newStatus.starred);
                this.markEntryInView(id, newStatus.unread);
            }
        });
    }
    setHasMore(hasMore) {
        if (typeof hasMore === "function") this.setState((state)=>({
                hasMore: hasMore(state.hasMore)
            }));
        else this.setState({
            hasMore: hasMore
        });
    }
    setLoadingState(loadingState) {
        if (typeof loadingState === "function") this.setState((state)=>({
                loadingState: loadingState(state.loadingState)
            }));
        else this.setState({
            loadingState: loadingState
        });
    }
    getActiveTag() {
        if (!this.props.match) return null;
        const { params: params } = this.props.match;
        return params.category?.startsWith("tag-") ? params.category.replace(/^tag-/, "") : null;
    }
    getActiveSource() {
        if (!this.props.match) return null;
        const { params: params } = this.props.match;
        return params.category?.startsWith("source-") ? parseInt(params.category.replace(/^source-/, ""), 10) : null;
    }
    getActiveFilter() {
        if (!this.props.match) return null;
        return this.props.match.params.filter;
    }
    /**
     * Mark all visible items as read
     */ markVisibleRead() {
        const ids = [];
        const tagUnreadDiff = {};
        const sourceUnreadDiff = {};
        let markedEntries = this.state.entries.map((entry)=>{
            if (!entry.unread) return entry;
            ids.push(entry.id);
            Object.keys(entry.tags).forEach((tag)=>{
                if (Object.keys(tagUnreadDiff).includes(tag)) tagUnreadDiff[tag] += -1;
                else tagUnreadDiff[tag] = -1;
            });
            const { source: source } = entry;
            if (Object.keys(sourceUnreadDiff).includes(source.toString())) sourceUnreadDiff[source] += -1;
            else sourceUnreadDiff[source] = -1;
            return {
                ...entry,
                unread: false
            };
        });
        const oldEntries = this.state.entries;
        const hadMore = this.state.hasMore;
        // close opened entry and list
        this.setExpandedEntries({});
        this.props.setNavExpanded(false);
        if (ids.length !== 0 && this.props.match.params.filter === (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).UNREAD) markedEntries = markedEntries.filter(({ id: id })=>!ids.includes(id));
        this.setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING);
        this.setEntries(markedEntries);
        // update statistics in main menu
        const updateStats = (markRead)=>{
            // update all unread counters
            const unreadstats = selfoss.app.state.unreadItemsCount;
            const diff = markRead ? -1 : 1;
            selfoss.refreshUnread(unreadstats + diff * ids.length);
            // update unread on tags and sources
            if (markRead) selfoss.app.refreshTagSourceUnread(tagUnreadDiff, sourceUnreadDiff);
            else // Diffs are negative by default.
            selfoss.app.refreshTagSourceUnread(Object.fromEntries(Object.entries(tagUnreadDiff).map(([tag, diff])=>[
                    tag,
                    -1 * diff
                ])), Object.fromEntries(Object.entries(sourceUnreadDiff).map(([source, diff])=>[
                    source,
                    -1 * diff
                ])));
        };
        updateStats(true);
        if (selfoss.db.enableOffline.value) selfoss.dbOffline.entriesMark(ids, false);
        $c0fc5d9a6429f0a7$export$8ce663b0c6b2535e(ids).then(()=>{
            this.setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
        }).catch((error)=>{
            selfoss.handleAjaxError(error).then(()=>{
                const statuses = ids.map((id)=>({
                        entryId: id,
                        name: "unread",
                        value: false
                    }));
                selfoss.dbOffline.enqueueStatuses(statuses);
            }).catch((error)=>{
                if (error instanceof (0, $506fdaa0545346a2$export$65bd6083489bd8bb) && error.response.status === 403) {
                    selfoss.history.push("/sign/in", {
                        error: selfoss.app._("error_session_expired")
                    });
                    return;
                }
                this.setLoadingState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
                this.setEntries(oldEntries);
                updateStats(false);
                this.setHasMore(hadMore);
                selfoss.app.showError(selfoss.app._("error_mark_items") + " " + error.message);
            });
        });
    }
    /**
     * Requests for an entry to be marked read/unread in the model.
     * @param {number} id of entry to mark
     * @param {bool|'toggle'} true to mark read, false to mark unread
     */ markEntryRead(id, markRead) {
        // only loggedin users
        if (!selfoss.isAllowedToWrite()) {
            console.log("User not allowed to mark an entry (un)read.");
            return;
        }
        const entry = this.state.entries.find((entry)=>id === entry.id);
        if (markRead === "toggle") markRead = entry.unread;
        this.markEntryInView(id, !markRead);
        // update statistics in main menue and the currently active tag
        const updateStats = (markRead)=>{
            // update all unread counters
            const unreadstats = selfoss.app.state.unreadItemsCount;
            const diff = markRead ? -1 : 1;
            selfoss.refreshUnread(unreadstats + diff);
            // update unread on tags and sources
            // Only a single instance of each tag per entry so we can just assign.
            const entryTags = Object.fromEntries(Object.keys(entry.tags).map((tag)=>[
                    tag,
                    diff
                ]));
            selfoss.app.refreshTagSourceUnread(entryTags, {
                [entry.source]: diff
            });
        };
        updateStats(markRead);
        if (selfoss.db.enableOffline.value) selfoss.dbOffline.entryMark(id, !markRead);
        $c0fc5d9a6429f0a7$export$bf7f2fce5c1cf636(id, !markRead).then(()=>{
            selfoss.db.setOnline();
        }).catch((error)=>{
            selfoss.handleAjaxError(error).then(()=>{
                selfoss.dbOffline.enqueueStatus(id, "unread", !markRead);
            }).catch((error)=>{
                if (error instanceof (0, $506fdaa0545346a2$export$65bd6083489bd8bb) && error.response.status === 403) {
                    selfoss.history.push("/sign/in", {
                        error: selfoss.app._("error_session_expired")
                    });
                    return;
                }
                // rollback ui changes
                this.markEntryInView(id, markRead);
                updateStats(!markRead);
                selfoss.app.showError(selfoss.app._("error_mark_item") + " " + error.message);
            });
        });
    }
    /**
     * Requests for an entry to be marked (un)starred in the model.
     * @param {number} id of entry to mark
     * @param {bool|'toggle'} true to mark starred, false to mark unstarred
     */ markEntryStarred(id, markStarred) {
        // only loggedin users
        if (!selfoss.isAllowedToWrite()) {
            console.log("User not allowed to (un)star an entry.");
            return;
        }
        if (markStarred === "toggle") {
            const entry = this.state.entries.find((entry)=>id === entry.id);
            markStarred = !entry.starred;
        }
        this.starEntryInView(id, markStarred);
        // update statistics in main menu
        const updateStats = (markStarred)=>{
            selfoss.app.setStarredItemsCount((starred)=>starred + (markStarred ? 1 : -1));
        };
        updateStats(markStarred);
        if (selfoss.db.enableOffline.value) selfoss.dbOffline.entryStar(id, markStarred);
        $c0fc5d9a6429f0a7$export$d11ee7cd6d3f95d4(id, markStarred).then(()=>{
            selfoss.db.setOnline();
        }).catch((error)=>{
            selfoss.handleAjaxError(error).then(()=>{
                selfoss.dbOffline.enqueueStatus(id, "starred", markStarred);
            }).catch((error)=>{
                if (error instanceof (0, $506fdaa0545346a2$export$65bd6083489bd8bb) && error.response.status === 403) {
                    selfoss.history.push("/sign/in", {
                        error: selfoss.app._("error_session_expired")
                    });
                    return;
                }
                // rollback ui changes
                this.starEntryInView(id, !markStarred);
                updateStats(!markStarred);
                selfoss.app.showError(selfoss.app._("error_star_item") + " " + error.message);
            });
        });
    }
    reload() {
        /**
         * HACK: A counter that is increased every time reload action (r key) is triggered.
         */ selfoss.history.replace({
            ...this.props.location,
            ...(0, $7c8cbf542ee98bec$export$d0bb2ab5375d1521)(this.props.location, {
                id: null
            }),
            state: (0, $7c8cbf542ee98bec$export$e64cf1b9b4b3aa56)(this.props.location)
        });
    }
    /**
     * get next/prev item
     * @param direction
     */ nextPrev(direction, open = true) {
        if (direction != (0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).NEXT && direction != (0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).PREV) throw new Error("direction must be one of Direction.{PREV,NEXT}");
        // when there are no entries
        if (this.state.entries.length == 0) return;
        // select current
        const old = this.getSelectedEntry();
        const oldIndex = old !== null ? this.state.entries.findIndex(({ id: id })=>id === old) : null;
        let current = null;
        // select next/prev entry and save it to "current"
        // if we would overflow, we stay on the old one
        if (direction == (0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).NEXT) {
            if (old === null) current = this.state.entries[0].id;
            else {
                const nextIndex = oldIndex + 1;
                if (nextIndex >= this.state.entries.length) {
                    current = old;
                    // attempt to load more
                    document.querySelector(".stream-more")?.click();
                } else current = this.state.entries[nextIndex].id;
            }
        } else {
            if (old === null) return;
            else if (oldIndex <= 0) current = old;
            else current = this.state.entries[oldIndex - 1].id;
        }
        if (old !== current) {
            // remove active
            this.deactivateEntry(old);
            if (open) this.activateEntry(current);
            else this.setSelectedEntry(current);
            const currentElement = document.querySelector(`.entry[data-entry-id="${current}"]`);
            // scroll to element
            (0, $72f11e9f95fb1286$export$d976747ecb966cea)(currentElement);
            // focus the title link for better keyboard navigation
            currentElement.querySelector(".entry-title-link").focus();
        }
    }
    /**
     * entry navigation (next/prev) with keys
     * @param direction
     */ entryNav(direction) {
        if (direction != (0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).NEXT && direction != (0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).PREV) throw new Error("direction must be one of Direction.{PREV,NEXT}");
        const open = this.isEntryExpanded(this.getSelectedEntry());
        this.nextPrev(direction, open);
    }
    jumpToNext() {
        const selected = this.getSelectedEntry();
        if (selected !== null && !this.isEntryExpanded(selected)) this.activateEntry(selected);
        else this.nextPrev((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).NEXT, true);
    }
    toggleSelectedStarred() {
        const selected = this.getSelectedEntry();
        if (selected !== null) this.markEntryStarred(selected, "toggle");
    }
    toggleSelectedRead() {
        const selected = this.getSelectedEntry();
        if (selected !== null) this.markEntryRead(selected, "toggle");
    }
    toggleSelectedExpanded() {
        this.toggleEntryExpanded(this.getSelectedEntry());
    }
    openSelectedTarget() {
        const selected = this.getSelectedEntry();
        if (selected !== null) $9a29cc780ecc33b8$var$openSelectedArticle(selected);
    }
    openSelectedTargetAndMarkRead() {
        const selected = this.getSelectedEntry();
        if (selected !== null) {
            this.markEntryRead(selected, true);
            $9a29cc780ecc33b8$var$openSelectedArticle(selected);
        }
    }
    throw(direction) {
        const selected = this.getSelectedEntry();
        if (selected !== null) this.markEntryRead(selected, true);
        this.nextPrev(direction, true);
    }
    render() {
        return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($9a29cc780ecc33b8$export$66d62ccfdff1c843, {
            entries: this.state.entries,
            selectedEntry: this.state.selectedEntry,
            expandedEntries: this.state.expandedEntries,
            hasMore: this.state.hasMore,
            loadingState: this.state.loadingState,
            setLoadingState: this.setLoadingState,
            setNavExpanded: this.props.setNavExpanded,
            navSourcesExpanded: this.props.navSourcesExpanded,
            reload: this.reload,
            setGlobalUnreadCount: this.props.setGlobalUnreadCount,
            unreadItemsCount: this.props.unreadItemsCount
        });
    }
}
$9a29cc780ecc33b8$export$2e2bcd8739ae039.propTypes = {
    configuration: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    match: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    setGlobalUnreadCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired
};




var $5NSbj = parcelRequire("5NSbj");






var $5NSbj = parcelRequire("5NSbj");









function $9fde4a5b27086c16$export$2e2bcd8739ae039({ setNavExpanded: setNavExpanded, offlineState: offlineState, allItemsCount: allItemsCount, allItemsOfflineCount: allItemsOfflineCount, unreadItemsCount: unreadItemsCount, unreadItemsOfflineCount: unreadItemsOfflineCount, starredItemsCount: starredItemsCount, starredItemsOfflineCount: starredItemsOfflineCount }) {
    const [expanded, setExpanded] = (0, $5NSbj.useState)(true);
    // useParams does not seem to work.
    const match = (0, $88361e604f4abd56$export$632be4bb944c1bc7)((0, $7c8cbf542ee98bec$export$f1004941042944df));
    const params = match !== null ? match.params : {};
    const toggleExpanded = (0, $5NSbj.useCallback)(()=>setExpanded((expanded)=>!expanded), []);
    const collapseNav = (0, $5NSbj.useCallback)(()=>setNavExpanded(false), [
        setNavExpanded
    ]);
    const newestLink = (0, $5NSbj.useCallback)((location)=>({
            ...location,
            ...(0, $7c8cbf542ee98bec$export$d0bb2ab5375d1521)(location, {
                filter: (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).NEWEST,
                id: null
            }),
            state: (0, $7c8cbf542ee98bec$export$e64cf1b9b4b3aa56)(location)
        }), []);
    const unreadLink = (0, $5NSbj.useCallback)((location)=>({
            ...location,
            ...(0, $7c8cbf542ee98bec$export$d0bb2ab5375d1521)(location, {
                filter: (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).UNREAD,
                id: null
            }),
            state: (0, $7c8cbf542ee98bec$export$e64cf1b9b4b3aa56)(location)
        }), []);
    const starredLink = (0, $5NSbj.useCallback)((location)=>({
            ...location,
            ...(0, $7c8cbf542ee98bec$export$d0bb2ab5375d1521)(location, {
                filter: (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).STARRED,
                id: null
            }),
            state: (0, $7c8cbf542ee98bec$export$e64cf1b9b4b3aa56)(location)
        }), []);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
        id: "nav-filter-wrapper",
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-filter-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                        "nav-section-toggle": true,
                        "nav-filter-collapsed": !expanded,
                        "nav-filter-expanded": expanded
                    }),
                    "aria-expanded": expanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                            icon: expanded ? $b39548c706c2a5e0$exports.faCaretDown : $e9e52821f7276495$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        " ",
                        _("filter")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $5c9ab921368ace58$export$78768a9af065a7b), {
                isOpen: expanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
                    id: "nav-filter",
                    "aria-labelledby": "nav-filter-title",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-newest",
                                to: newestLink,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                    "nav-filter-newest": true,
                                    active: params.filter === (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).NEWEST
                                }),
                                onClick: collapseNav,
                                children: [
                                    _("newest"),
                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                            "offline-count": true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            diff: allItemsCount !== allItemsOfflineCount && allItemsOfflineCount
                                        }),
                                        title: _("offline_count"),
                                        children: allItemsOfflineCount > 0 ? allItemsOfflineCount : ""
                                    }),
                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                        className: "count",
                                        title: _("online_count"),
                                        children: allItemsCount > 0 ? allItemsCount : ""
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-unread",
                                to: unreadLink,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                    "nav-filter-unread": true,
                                    active: params.filter === (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).UNREAD
                                }),
                                onClick: collapseNav,
                                children: [
                                    _("unread"),
                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                            "unread-count": true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            unread: unreadItemsCount > 0
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                                    "offline-count": true,
                                                    offline: offlineState,
                                                    online: !offlineState,
                                                    diff: unreadItemsCount !== unreadItemsOfflineCount && unreadItemsOfflineCount
                                                }),
                                                title: _("offline_count"),
                                                children: unreadItemsOfflineCount > 0 ? unreadItemsOfflineCount : ""
                                            }),
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                                className: "count",
                                                title: _("online_count"),
                                                children: unreadItemsCount > 0 ? unreadItemsCount : ""
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-starred",
                                to: starredLink,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                    "nav-filter-starred": true,
                                    active: params.filter === (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).STARRED
                                }),
                                onClick: collapseNav,
                                children: [
                                    _("starred"),
                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                            "offline-count": true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            diff: starredItemsCount !== starredItemsOfflineCount && starredItemsOfflineCount
                                        }),
                                        title: _("offline_count"),
                                        children: starredItemsOfflineCount > 0 ? starredItemsOfflineCount : ""
                                    }),
                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                        className: "count",
                                        title: _("online_count"),
                                        children: starredItemsCount > 0 ? starredItemsCount : ""
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$9fde4a5b27086c16$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    allItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    allItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    unreadItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    starredItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    starredItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired
};




var $5NSbj = parcelRequire("5NSbj");












function $9478b995a6946c16$var$handleTitleClick({ setExpanded: setExpanded, sourcesState: sourcesState, setSourcesState: setSourcesState, setSources: setSources }) {
    if (!selfoss.isOnline()) {
        console.log("Cannot toggle, not online.");
        return;
    }
    setExpanded((expanded)=>{
        if (!expanded && sourcesState === (0, $c097b691ff08d4e3$export$62aa48085237e36f).INITIAL) $3972545cf57eb298$export$432f698644f45d1().then((data)=>{
            setSources(data);
            setSourcesState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
        }).catch((error)=>{
            setSourcesState((0, $c097b691ff08d4e3$export$62aa48085237e36f).FAILURE);
            selfoss.app.showError(selfoss.app._("error_loading_stats") + " " + error.message);
        });
        return !expanded;
    });
}
function $9478b995a6946c16$var$Source({ source: source, active: active, collapseNav: collapseNav }) {
    const link = (0, $5NSbj.useCallback)((location)=>({
            ...location,
            ...(0, $7c8cbf542ee98bec$export$d0bb2ab5375d1521)(location, {
                category: `source-${source.id}`,
                id: null
            }),
            state: (0, $7c8cbf542ee98bec$export$e64cf1b9b4b3aa56)(location)
        }), [
        source.id
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            read: source.unread === 0
        }),
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
            to: link,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                active: active,
                unread: source.unread > 0
            }),
            onClick: collapseNav,
            children: [
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                    className: "nav-source",
                    children: (0, $ec6aeee77f582aff$export$e8bacd2802a88316)(source.title)
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                    className: "unread",
                    children: source.unread > 0 ? source.unread : ""
                })
            ]
        })
    });
}
$9478b995a6946c16$var$Source.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    collapseNav: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};
function $9478b995a6946c16$export$2e2bcd8739ae039({ setNavExpanded: setNavExpanded, navSourcesExpanded: navSourcesExpanded, setNavSourcesExpanded: setNavSourcesExpanded, sourcesState: sourcesState, setSourcesState: setSourcesState, sources: sources, setSources: setSources }) {
    const reallyExpanded = navSourcesExpanded && sourcesState === (0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS;
    // useParams does not seem to work.
    const match = (0, $88361e604f4abd56$export$632be4bb944c1bc7)((0, $7c8cbf542ee98bec$export$f1004941042944df));
    const params = match !== null ? match.params : {};
    const currentSource = params.category?.startsWith("source-") ? parseInt(params.category.replace(/^source-/, ""), 10) : null;
    const toggleExpanded = (0, $5NSbj.useCallback)(()=>$9478b995a6946c16$var$handleTitleClick({
            setExpanded: setNavSourcesExpanded,
            sourcesState: sourcesState,
            setSourcesState: setSourcesState,
            setSources: setSources
        }), [
        setNavSourcesExpanded,
        sourcesState,
        setSourcesState,
        setSources
    ]);
    const collapseNav = (0, $5NSbj.useCallback)(()=>setNavExpanded(false), [
        setNavExpanded
    ]);
    const previousSourcesState = (0, $7591aa31d7cb8c81$export$f6f3f74729fdd0b7)(sourcesState);
    (0, $5NSbj.useEffect)(()=>{
        if (previousSourcesState === (0, $c097b691ff08d4e3$export$62aa48085237e36f).INITIAL && sourcesState === (0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS) setNavSourcesExpanded(true);
    }, [
        previousSourcesState,
        sourcesState,
        setNavSourcesExpanded
    ]);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-sources-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                        "nav-section-toggle": true,
                        "nav-sources-collapsed": !reallyExpanded,
                        "nav-sources-expanded": reallyExpanded
                    }),
                    "aria-expanded": reallyExpanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                            icon: navSourcesExpanded ? $b39548c706c2a5e0$exports.faCaretDown : $e9e52821f7276495$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        "  ",
                        _("sources")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $5c9ab921368ace58$export$78768a9af065a7b), {
                isOpen: reallyExpanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                    id: "nav-sources",
                    "aria-labelledby": "nav-sources-title",
                    children: sources.map((source)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($9478b995a6946c16$var$Source, {
                            source: source,
                            active: currentSource === source.id,
                            collapseNav: collapseNav
                        }, source.id))
                })
            })
        ]
    });
}
$9478b995a6946c16$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    setNavSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    sourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOf(Object.values((0, $c097b691ff08d4e3$export$62aa48085237e36f))).isRequired,
    setSourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    sources: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object).isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};




var $5NSbj = parcelRequire("5NSbj");







// search button shows search input or executes search
function $14a29450156c5218$var$handleSubmit({ active: active, setActive: setActive, searchField: searchField, searchText: searchText, history: history, location: location, setNavExpanded: setNavExpanded }) {
    if (!selfoss.isSmartphone() && !active) {
        setActive(true);
        searchField.current.focus();
        searchField.current.select();
        return;
    }
    history.push((0, $7c8cbf542ee98bec$export$7f0beea2aa79e4fa)(location, {
        search: searchText,
        id: null
    }));
    setActive(false);
    searchField.current.blur();
    setNavExpanded(false);
}
function $14a29450156c5218$var$handleFieldKeyUp({ event: event, searchButton: searchButton, searchRemoveButton: searchRemoveButton }) {
    // keypress enter in search inputfield
    if (event.which == 13) searchButton.current.click();
    if (event.keyCode == 27) searchRemoveButton.current.click();
}
// remove button of search
function $14a29450156c5218$var$handleRemove({ setActive: setActive, searchField: searchField, history: history, location: location }) {
    const queryString = new URLSearchParams(location.search);
    const oldTerm = queryString.get("search");
    setActive(false);
    if (oldTerm == "") {
        searchField.current.blur();
        return;
    }
    history.push((0, $7c8cbf542ee98bec$export$7f0beea2aa79e4fa)(location, {
        search: "",
        id: null
    }));
}
function $14a29450156c5218$export$2e2bcd8739ae039({ setNavExpanded: setNavExpanded, offlineState: offlineState }) {
    const [active, setActive] = (0, $5NSbj.useState)(false);
    const searchField = (0, $5NSbj.useRef)(null);
    const searchButton = (0, $5NSbj.useRef)(null);
    const searchRemoveButton = (0, $5NSbj.useRef)(null);
    const location = (0, $88361e604f4abd56$export$45d76561a5302f2b)();
    const history = (0, $88361e604f4abd56$export$3420e1dc2c4a518c)();
    const queryString = new URLSearchParams(location.search);
    const oldTerm = queryString.get("search") ?? "";
    const [searchText, setSearchText] = (0, $5NSbj.useState)("");
    (0, $5NSbj.useEffect)(()=>{
        // Update the search term when the query string changes.
        setSearchText(oldTerm);
    }, [
        oldTerm
    ]);
    const termOnKeyUp = (0, $5NSbj.useCallback)((event)=>$14a29450156c5218$var$handleFieldKeyUp({
            event: event,
            searchButton: searchButton,
            searchRemoveButton: searchRemoveButton
        }), []);
    const termOnChange = (0, $5NSbj.useCallback)((event)=>setSearchText(event.target.value), []);
    const removeOnClick = (0, $5NSbj.useCallback)(()=>$14a29450156c5218$var$handleRemove({
            setActive: setActive,
            searchField: searchField,
            history: history,
            location: location
        }), [
        history,
        location
    ]);
    const searchOnClick = (0, $5NSbj.useCallback)(()=>$14a29450156c5218$var$handleSubmit({
            active: active,
            setActive: setActive,
            searchField: searchField,
            searchText: searchText,
            history: history,
            location: location,
            setNavExpanded: setNavExpanded
        }), [
        active,
        searchText,
        history,
        location,
        setNavExpanded
    ]);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
        id: "search",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            offline: offlineState,
            online: !offlineState,
            active: active
        }),
        role: "search",
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                "aria-label": _("search_label"),
                type: "search",
                id: "search-term",
                accessKey: "s",
                ref: searchField,
                value: searchText,
                onKeyUp: termOnKeyUp,
                onChange: termOnChange
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                id: "search-remove",
                title: _("searchremove"),
                accessKey: "h",
                "aria-label": _("searchremove"),
                onClick: removeOnClick,
                ref: searchRemoveButton,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $246a305793432a97$exports.faTimes
                })
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                id: "search-button",
                title: _("searchbutton"),
                "aria-label": _("searchbutton"),
                accessKey: "e",
                onClick: searchOnClick,
                ref: searchButton,
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                        icon: $83e399a08305a885$exports.faSearch
                    }),
                    " ",
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "search-button-label",
                        children: _("searchbutton")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("hr", {})
        ]
    });
}
$14a29450156c5218$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired
};




var $5NSbj = parcelRequire("5NSbj");








var $5NSbj = parcelRequire("5NSbj");



/**
 * Get dark OR bright color depending the color contrast.
 *
 * @param string hexColor color (hex) value
 * @param string darkColor dark color value
 * @param string brightColor bright color value
 *
 * @return string dark OR bright color value
 *
 * @see https://24ways.org/2010/calculating-color-contrast/
 */ function $af2c54ce589e70bc$export$97e1e2675ab19423(hexColor, darkColor = "#555", brightColor = "#EEE") {
    // Strip hash sign.
    const color = hexColor.substr(1);
    const r = parseInt(color.substr(0, 2), 16);
    const g = parseInt(color.substr(2, 2), 16);
    const b = parseInt(color.substr(4, 2), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? darkColor : brightColor;
}




const $daf31bb566698b74$var$palette = [
    "#ffccc9",
    "#ffce93",
    "#fffc9e",
    "#ffffc7",
    "#9aff99",
    "#96fffb",
    "#cdffff",
    "#cbcefb",
    "#fffe65",
    "#cfcfcf",
    "#fd6864",
    "#fe996b",
    "#fcff2f",
    "#67fd9a",
    "#38fff8",
    "#68fdff",
    "#9698ed",
    "#c0c0c0",
    "#fe0000",
    "#f8a102",
    "#ffcc67",
    "#f8ff00",
    "#34ff34",
    "#68cbd0",
    "#34cdf9",
    "#6665cd",
    "#9b9b9b",
    "#cb0000",
    "#f56b00",
    "#ffcb2f",
    "#ffc702",
    "#32cb00",
    "#00d2cb",
    "#3166ff",
    "#6434fc",
    "#656565",
    "#9a0000",
    "#ce6301",
    "#cd9934",
    "#999903",
    "#009901",
    "#329a9d",
    "#3531ff",
    "#6200c9",
    "#343434",
    "#680100",
    "#963400",
    "#986536",
    "#646809",
    "#036400",
    "#34696d",
    "#00009b",
    "#303498",
    "#000000",
    "#330001",
    "#643403",
    "#663234",
    "#343300",
    "#013300",
    "#003532",
    "#010066",
    "#340096"
];
function $daf31bb566698b74$var$ColorButton({ tag: tag, color: color }) {
    const style = (0, $5NSbj.useMemo)(()=>({
            backgroundColor: color,
            color: (0, $af2c54ce589e70bc$export$97e1e2675ab19423)(color)
        }), [
        color
    ]);
    const selected = color === tag.color;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $2f8c26b01cf457e1$export$2ce376c2cc3355c8), {
        className: "popup-menu-item",
        value: color,
        style: style,
        children: selected ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
            icon: $e9206858efef3e95$exports.faCheck
        }) : " "
    });
}
$daf31bb566698b74$var$ColorButton.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string.isRequired
};
const $daf31bb566698b74$var$preventDefault = (event)=>{
    event.preventDefault();
    // Prevent closing navigation on mobile.
    event.stopPropagation();
};
function $daf31bb566698b74$export$2e2bcd8739ae039({ tag: tag, onChange: onChange }) {
    const style = (0, $5NSbj.useMemo)(()=>({
            backgroundColor: tag.color
        }), [
        tag.color
    ]);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
        className: "color",
        onClick: $daf31bb566698b74$var$preventDefault,
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $bd4c4042067d9063$export$d9b273488cd8ce6f), {
            menuButton: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $c5b00af6cfe5984a$export$266a769812832828), {
                className: "color-chooser-button",
                title: _("tag_change_color_button_title"),
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "color-box",
                        style: style
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: _("tag_change_color_button_title")
                    })
                ]
            }),
            menuClassName: "color-chooser popup-menu",
            onItemClick: onChange,
            viewScroll: "auto",
            portal: true,
            children: [
                $daf31bb566698b74$var$palette.map((color)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($daf31bb566698b74$var$ColorButton, {
                        color: color,
                        tag: tag
                    }, color)),
                !$daf31bb566698b74$var$palette.includes(tag.color) && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($daf31bb566698b74$var$ColorButton, {
                    color: tag.color,
                    tag: tag
                }, "custom")
            ]
        })
    });
}
$daf31bb566698b74$export$2e2bcd8739ae039.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};







function $1794c4f07556c96e$var$Tag({ tag: tag, active: active, collapseNav: collapseNav }) {
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    const tagName = tag !== null ? tag.tag : null;
    const colorChanged = (0, $5NSbj.useCallback)(({ value: value })=>{
        (0, $c6a75ba9dc9fd47e$export$6f3c7c74c4b252bb)(tagName, value).then(()=>{
            selfoss.entriesPage?.reload();
        }).catch((error)=>{
            selfoss.app.showError(selfoss.app._("error_saving_color") + " " + error.message);
        });
    }, [
        tagName
    ]);
    const category = tag === null ? "all" : `tag-${tag.tag}`;
    const link = (0, $5NSbj.useCallback)((location)=>({
            ...location,
            ...(0, $7c8cbf542ee98bec$export$d0bb2ab5375d1521)(location, {
                category: category,
                id: null
            }),
            state: (0, $7c8cbf542ee98bec$export$e64cf1b9b4b3aa56)(location)
        }), [
        category
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            read: tag !== null && tag.unread === 0
        }),
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
            to: link,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                "nav-tags-all": tag === null,
                active: active
            }),
            onClick: collapseNav,
            children: tag === null ? _("alltags") : /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "tag",
                        children: (0, $ec6aeee77f582aff$export$e8bacd2802a88316)(tag.tag)
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "unread",
                        children: tag.unread > 0 ? tag.unread : ""
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $daf31bb566698b74$export$2e2bcd8739ae039), {
                        tag: tag,
                        onChange: colorChanged
                    })
                ]
            })
        })
    });
}
$1794c4f07556c96e$var$Tag.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($ea2d4a6a4b369f4b$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object).isRequired,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    collapseNav: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};
function $1794c4f07556c96e$export$2e2bcd8739ae039({ setNavExpanded: setNavExpanded, tags: tags }) {
    const [expanded, setExpanded] = (0, $5NSbj.useState)(true);
    // useParams does not seem to work.
    const match = (0, $88361e604f4abd56$export$632be4bb944c1bc7)((0, $7c8cbf542ee98bec$export$f1004941042944df));
    const params = match !== null ? match.params : {};
    const currentAllTags = params.category === "all";
    const currentTag = params.category?.startsWith("tag-") ? params.category.replace(/^tag-/, "") : null;
    const toggleExpanded = (0, $5NSbj.useCallback)(()=>setExpanded((expanded)=>!expanded), []);
    const collapseNav = (0, $5NSbj.useCallback)(()=>setNavExpanded(false), [
        setNavExpanded
    ]);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-tags-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                        "nav-section-toggle": true,
                        "nav-tags-collapsed": !expanded,
                        "nav-tags-expanded": expanded
                    }),
                    "aria-expanded": expanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                            icon: expanded ? $b39548c706c2a5e0$exports.faCaretDown : $e9e52821f7276495$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        "  ",
                        _("tags")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $5c9ab921368ace58$export$78768a9af065a7b), {
                isOpen: expanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
                    id: "nav-tags",
                    "aria-labelledby": "nav-tags-title",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($1794c4f07556c96e$var$Tag, {
                            tag: null,
                            active: currentAllTags,
                            collapseNav: collapseNav
                        }),
                        tags.map((tag)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($1794c4f07556c96e$var$Tag, {
                                tag: tag,
                                active: currentTag === tag.tag,
                                collapseNav: collapseNav
                            }, tag.tag))
                    ]
                })
            })
        ]
    });
}
$1794c4f07556c96e$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    tags: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object).isRequired
};




var $5NSbj = parcelRequire("5NSbj");








function $db9ac14e038271c1$var$handleReloadAll({ reloadAll: reloadAll, setReloading: setReloading, setNavExpanded: setNavExpanded }) {
    setReloading(true);
    reloadAll().finally(()=>{
        setNavExpanded(false);
        setReloading(false);
    });
}
function $db9ac14e038271c1$var$handleLogOut({ setNavExpanded: setNavExpanded }) {
    // only loggedin users
    if (!selfoss.hasSession() || !selfoss.isOnline()) return;
    selfoss.db.clear();
    selfoss.logout();
    setNavExpanded(false);
}
function $db9ac14e038271c1$export$2e2bcd8739ae039({ reloadAll: reloadAll, setNavExpanded: setNavExpanded }) {
    const [reloading, setReloading] = (0, $5NSbj.useState)(false);
    const refreshOnClick = (0, $5NSbj.useCallback)(()=>$db9ac14e038271c1$var$handleReloadAll({
            reloadAll: reloadAll,
            setReloading: setReloading,
            setNavExpanded: setNavExpanded
        }), [
        reloadAll,
        setNavExpanded
    ]);
    const settingsOnClick = (0, $5NSbj.useCallback)(()=>{
        setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    const settingsLink = (0, $5NSbj.useCallback)((location)=>({
            ...location,
            pathname: "/manage/sources",
            state: (0, $7c8cbf542ee98bec$export$e64cf1b9b4b3aa56)(location)
        }), []);
    const logoutOnClick = (0, $5NSbj.useCallback)(()=>$db9ac14e038271c1$var$handleLogOut({
            setNavExpanded: setNavExpanded
        }), [
        setNavExpanded
    ]);
    const isLoggedIn = (0, $49b55be3b2a6e8d6$export$3b062b02b4537682)();
    const canRefreshAll = (0, $49b55be3b2a6e8d6$export$683005ba76038aff)();
    const canVisitSettings = (0, $49b55be3b2a6e8d6$export$b416b77cd328c02f)();
    const canLogOut = isLoggedIn;
    const configuration = (0, $5NSbj.useContext)((0, $7b0908670bf0de1b$export$326f6d1b69f1c06e));
    const canLogIn = !isLoggedIn && configuration.authEnabled;
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
        className: "nav-toolbar",
        children: [
            canRefreshAll && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                id: "nav-refresh",
                title: _("refreshbutton"),
                "aria-label": _("refreshbutton"),
                accessKey: "r",
                onClick: refreshOnClick,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $6a208664f359f326$exports.faSyncAlt,
                    fixedWidth: true,
                    spin: reloading
                })
            }),
            canVisitSettings && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
                id: "nav-settings",
                title: _("settingsbutton"),
                "aria-label": _("settingsbutton"),
                accessKey: "t",
                to: settingsLink,
                onClick: settingsOnClick,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $89b603728dcec9de$exports.faCloudUploadAlt,
                    fixedWidth: true
                })
            }),
            canLogOut && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                id: "nav-logout",
                title: _("logoutbutton"),
                "aria-label": _("logoutbutton"),
                accessKey: "l",
                onClick: logoutOnClick,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $7ab16ab4e5fbaa94$exports.faSignOutAlt,
                    fixedWidth: true
                })
            }),
            canLogIn && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
                id: "nav-login",
                title: _("loginbutton"),
                "aria-label": _("loginbutton"),
                accessKey: "l",
                to: "/sign/in",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                    icon: $c4ec402fabc5b4fe$exports.faKey,
                    fixedWidth: true
                })
            })
        ]
    });
}
$db9ac14e038271c1$export$2e2bcd8739ae039.propTypes = {
    reloadAll: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};







function $0beaf1dad44b806f$export$2e2bcd8739ae039({ entriesPage: entriesPage, setNavExpanded: setNavExpanded, navSourcesExpanded: navSourcesExpanded, setNavSourcesExpanded: setNavSourcesExpanded, offlineState: offlineState, allItemsCount: allItemsCount, allItemsOfflineCount: allItemsOfflineCount, unreadItemsCount: unreadItemsCount, unreadItemsOfflineCount: unreadItemsOfflineCount, starredItemsCount: starredItemsCount, starredItemsOfflineCount: starredItemsOfflineCount, sourcesState: sourcesState, setSourcesState: setSourcesState, sources: sources, setSources: setSources, tags: tags, reloadAll: reloadAll }) {
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    const canWrite = (0, $49b55be3b2a6e8d6$export$b416b77cd328c02f)();
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                id: "nav-logo"
            }),
            canWrite && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                accessKey: "a",
                id: "nav-mark",
                onClick: entriesPage !== null ? entriesPage.markVisibleRead : null,
                disabled: entriesPage === null,
                children: _("markread")
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $9fde4a5b27086c16$export$2e2bcd8739ae039), {
                setNavExpanded: setNavExpanded,
                offlineState: offlineState,
                allItemsCount: allItemsCount,
                allItemsOfflineCount: allItemsOfflineCount,
                unreadItemsCount: unreadItemsCount,
                unreadItemsOfflineCount: unreadItemsOfflineCount,
                starredItemsCount: starredItemsCount,
                starredItemsOfflineCount: starredItemsOfflineCount
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                className: "separator",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("hr", {})
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    "nav-ts-wrapper": true,
                    offline: offlineState,
                    online: !offlineState
                }),
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1794c4f07556c96e$export$2e2bcd8739ae039), {
                        tags: tags,
                        setNavExpanded: setNavExpanded
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $9478b995a6946c16$export$2e2bcd8739ae039), {
                        setNavExpanded: setNavExpanded,
                        navSourcesExpanded: navSourcesExpanded,
                        setNavSourcesExpanded: setNavSourcesExpanded,
                        sourcesState: sourcesState,
                        setSourcesState: setSourcesState,
                        sources: sources,
                        setSources: setSources
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    "nav-unavailable": true,
                    offline: offlineState,
                    online: !offlineState
                }),
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("span", {
                        className: "fa-layers fa-2x",
                        children: [
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                icon: $9abdfe45332a1725$exports.faWifi
                            }),
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                icon: $f7bce8bbcf358cf9$exports.faSlash
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
                        children: _("offline_navigation_unavailable")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                className: "separator",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("hr", {})
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $14a29450156c5218$export$2e2bcd8739ae039), {
                setNavExpanded: setNavExpanded,
                offlineState: offlineState
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $db9ac14e038271c1$export$2e2bcd8739ae039), {
                reloadAll: reloadAll,
                setNavExpanded: setNavExpanded
            })
        ]
    });
}
$0beaf1dad44b806f$export$2e2bcd8739ae039.propTypes = {
    entriesPage: (0, (/*@__PURE__*/$parcel$interopDefault($ea2d4a6a4b369f4b$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).instanceOf((0, $9a29cc780ecc33b8$export$2e2bcd8739ae039))).isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    setNavSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    allItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    allItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    unreadItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    starredItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    starredItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    sourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOf(Object.values((0, $c097b691ff08d4e3$export$62aa48085237e36f))).isRequired,
    setSourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    sources: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object).isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    tags: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object).isRequired,
    reloadAll: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};




var $5NSbj = parcelRequire("5NSbj");






function $0036981abc44d9f9$var$splitTerm(term) {
    if (term == "") return [];
    else if (term.match(/^\/.+\/$/)) return [
        term
    ];
    const words = term.match(/"[^"]+"|\S+/g);
    for(let i = 0; i < words.length; i++)words[i] = words[i].replace(/"/g, "");
    return words;
}
function $0036981abc44d9f9$var$joinTerm(words) {
    if (!words || words.length <= 0) return "";
    for(let i = 0; i < words.length; i++)if (words[i].indexOf(" ") >= 0) words[i] = '"' + words[i] + '"';
    return words.join(" ");
}
// remove search term
function $0036981abc44d9f9$var$handleRemove({ index: index, location: location, history: history, regexSearch: regexSearch }) {
    let newterm;
    if (regexSearch) newterm = "";
    else {
        const queryString = new URLSearchParams(location.search);
        const oldTerm = queryString.get("search");
        const termArray = $0036981abc44d9f9$var$splitTerm(oldTerm);
        termArray.splice(index, 1);
        newterm = $0036981abc44d9f9$var$joinTerm(termArray);
    }
    history.push((0, $7c8cbf542ee98bec$export$7f0beea2aa79e4fa)(location, {
        search: newterm,
        id: null
    }));
}
function $0036981abc44d9f9$var$SearchWord({ regexSearch: regexSearch, index: index, item: item }) {
    const location = (0, $88361e604f4abd56$export$45d76561a5302f2b)();
    const history = (0, $88361e604f4abd56$export$3420e1dc2c4a518c)();
    const removeOnClick = (0, $5NSbj.useCallback)(()=>$0036981abc44d9f9$var$handleRemove({
            index: index,
            location: location,
            history: history,
            regexSearch: regexSearch
        }), [
        index,
        location,
        history,
        regexSearch
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
        onClick: removeOnClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            "regex-search-term": regexSearch
        }),
        children: [
            item,
            " ",
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                icon: $246a305793432a97$exports.faTimes
            })
        ]
    });
}
$0036981abc44d9f9$var$SearchWord.propTypes = {
    regexSearch: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string.isRequired
};
function $0036981abc44d9f9$export$2e2bcd8739ae039() {
    const location = (0, $88361e604f4abd56$export$45d76561a5302f2b)();
    const searchText = (0, $5NSbj.useMemo)(()=>{
        const queryString = new URLSearchParams(location.search);
        return queryString.get("search") ?? "";
    }, [
        location.search
    ]);
    const regexSearch = searchText.match(/^\/.+\/$/) !== null;
    const terms = regexSearch ? [
        searchText
    ] : $0036981abc44d9f9$var$splitTerm(searchText);
    return terms.map((item, index)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($0036981abc44d9f9$var$SearchWord, {
            index: index,
            item: item,
            regexSearch: regexSearch
        }, index));
}


var $5fbb37fe01749ac5$var$t = [
    "Shift",
    "Meta",
    "Alt",
    "Control"
], $5fbb37fe01749ac5$var$e = "object" == typeof navigator ? navigator.platform : "", $5fbb37fe01749ac5$var$n = /Mac|iPod|iPhone|iPad/.test($5fbb37fe01749ac5$var$e), $5fbb37fe01749ac5$var$r = $5fbb37fe01749ac5$var$n ? "Meta" : "Control", $5fbb37fe01749ac5$var$o = "Win32" === $5fbb37fe01749ac5$var$e ? [
    "Control",
    "Alt"
] : $5fbb37fe01749ac5$var$n ? [
    "Alt"
] : [];
function $5fbb37fe01749ac5$var$i(t, e) {
    return "function" == typeof t.getModifierState && (t.getModifierState(e) || $5fbb37fe01749ac5$var$o.includes(e) && t.getModifierState("AltGraph"));
}
function $5fbb37fe01749ac5$export$d0b30d424c95c5e9(t) {
    return t.trim().split(" ").map(function(t) {
        var e = t.split(/\b\+/), n = e.pop();
        return [
            e = e.map(function(t) {
                return "$mod" === t ? $5fbb37fe01749ac5$var$r : t;
            }),
            n
        ];
    });
}
function $5fbb37fe01749ac5$export$a3db0ee43d16bb47(e, n) {
    var r;
    void 0 === n && (n = {});
    var o = null != (r = n.timeout) ? r : 1e3, u = Object.keys(e).map(function(t) {
        return [
            $5fbb37fe01749ac5$export$d0b30d424c95c5e9(t),
            e[t]
        ];
    }), c = new Map, f = null;
    return function(e) {
        e instanceof KeyboardEvent && (u.forEach(function(n) {
            var r = n[0], o = n[1], a = c.get(r) || r;
            !function(e, n) {
                return !(n[1].toUpperCase() !== e.key.toUpperCase() && n[1] !== e.code || n[0].find(function(t) {
                    return !$5fbb37fe01749ac5$var$i(e, t);
                }) || $5fbb37fe01749ac5$var$t.find(function(t) {
                    return !n[0].includes(t) && n[1] !== t && $5fbb37fe01749ac5$var$i(e, t);
                }));
            }(e, a[0]) ? $5fbb37fe01749ac5$var$i(e, e.key) || c.delete(r) : a.length > 1 ? c.set(r, a.slice(1)) : (c.delete(r), o(e));
        }), f && clearTimeout(f), f = setTimeout(c.clear.bind(c), o));
    };
}
function $5fbb37fe01749ac5$export$6fc42dca60e28416(t, e, n) {
    var r;
    void 0 === n && (n = {});
    var o = null != (r = n.event) ? r : "keydown", i = $5fbb37fe01749ac5$export$a3db0ee43d16bb47(e, n);
    return t.addEventListener(o, i), function() {
        t.removeEventListener(o, i);
    };
}



/**
 * Decorates an event handler so that it only runs
 * when not interacting with an input field or lightbox.
 */ function $fe8543f876f4df6e$var$ignoreWhenInteracting(handler) {
    return (event)=>{
        if (selfoss.lightboxActive.value) return;
        // Ignore shortcuts when on input elements.
        // https://github.com/jamiebuilds/tinykeys/issues/17
        const active = document.activeElement;
        const enteringText = active instanceof HTMLElement && (active.isContentEditable || active.tagName === "INPUT" || active.tagName === "TEXTAREA");
        if (!enteringText) return handler(event);
    };
}
function $fe8543f876f4df6e$export$2e2bcd8739ae039() {
    return (0, $5fbb37fe01749ac5$export$6fc42dca60e28416)(document, {
        // 'space': next article
        "Space": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.jumpToNext();
        }),
        // 'n': next article
        "n": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.nextPrev((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).NEXT, false);
        }),
        // 'right cursor': next article
        "ArrowRight": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.entryNav((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).NEXT);
        }),
        // 'j': next article
        "j": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.nextPrev((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).NEXT, true);
        }),
        // 'shift+space': previous article
        "Shift+Space": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.nextPrev((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).PREV, true);
        }),
        // 'p': previous article
        "p": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.nextPrev((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).PREV, false);
        }),
        // 'left': previous article
        "ArrowLeft": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.entryNav((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).PREV);
        }),
        // 'k': previous article
        "k": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.nextPrev((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).PREV, true);
        }),
        // 's': star/unstar
        "s": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.toggleSelectedStarred();
        }),
        // 'm': mark/unmark
        "m": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.toggleSelectedRead();
        }),
        // 'o': open/close entry
        "o": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.toggleSelectedExpanded();
        }),
        // 'Shift + o': close open entries
        "Shift+o": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.collapseAllEntries();
        }),
        // 'v': open target
        "v": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.openSelectedTarget();
        }),
        // 'Shift + v': open target and mark read
        "Shift+v": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.openSelectedTargetAndMarkRead();
        }),
        // 'r': Reload the current view
        "r": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.reload();
        }),
        // 'Shift + r': Refresh sources
        "Shift+r": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            document.querySelector("#nav-refresh").click();
        }),
        // 'Control+m': mark all as read
        "Control+m": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            document.querySelector("#nav-mark").click();
        }),
        // 't': throw (mark as read & open next)
        "t": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.throw((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).NEXT);
        }),
        // throw (mark as read & open previous)
        "Shift+t": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            selfoss.entriesPage?.throw((0, $72f11e9f95fb1286$export$cacd6541cfeeb6c1).PREV);
        }),
        // 'Shift+n': switch to newest items overview / menu item
        "Shift+n": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            document.querySelector("#nav-filter-newest").click();
        }),
        // 'Shift+u': switch to unread items overview / menu item
        "Shift+u": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            document.querySelector("#nav-filter-unread").click();
        }),
        // 'Shift+s': switch to starred items overview / menu item
        "Shift+s": $fe8543f876f4df6e$var$ignoreWhenInteracting((event)=>{
            event.preventDefault();
            document.querySelector("#nav-filter-starred").click();
        })
    });
}










// Unfortunately we need to declare everything manually for Parcel to pick those up.
var $647f766074d64773$exports = {};
$647f766074d64773$exports = JSON.parse('{"lang_markread":"Marca com llegit","lang_filter":"Filtre","lang_newest":"Nous","lang_unread":"Per llegir","lang_starred":"Preferits","lang_online_count":"Elements disponibles al servidor","lang_offline_count":"Elements disponibles localment","lang_tags":"Etiquetes","lang_alltags":"Totes les etiquetes","lang_timestamp":"{0,date} {0,time}","lang_hours":"fa {0,plural,one {1 hora},other {# hores}}","lang_minutes":"fa {0,plural,one {1 minut},other {# minuts}}","lang_seconds":"fa {0,plural,one {1 segon},other {# segons}}","lang_days":"{0,plural,zero {avui},one {ahir},other {fa # dies}}","lang_star":"Preferit","lang_unstar":"Ja no ho prefereixo","lang_mark":"Marca com llegit","lang_unmark":"Marca com no llegit","lang_load_img":"Mostra les imatges","lang_open_window":"Obre","lang_next":"Seg\xfcent","lang_searchbutton":"Cerca","lang_searchremove":"Amaga la cerca","lang_refreshbutton":"Actualitza les fonts","lang_settingsbutton":"Configuraci\xf3","lang_logoutbutton":"Finalitza la sessi\xf3","lang_loginbutton":"Inicia una sessi\xf3","lang_sources":"Fonts","lang_source_add":"Afegeix una font","lang_source_opml":"o importa des d\'un fitxer opml o des del Google Reader (fins al 15 de juliol de 2013)","lang_source_export":"Exporta les fonts","lang_source_edit":"Edita","lang_source_filter":"Filtra","lang_source_delete":"Esborra","lang_source_warn":"Segur que voleu esborrar la font?","lang_source_new":"Nova font per desar","lang_source_title":"T\xedtol","lang_source_autotitle_hint":"Deixa en blanc per a obtindre el t\xedtol","lang_source_tags":"Etiquetes","lang_source_pwd_placeholder":"No ha canviat","lang_source_comma":"Separat per comes","lang_source_select":"Seleccioneu una font","lang_source_type":"Tipus","lang_source_save":"Desa","lang_source_cancel":"Cancel\xb7la","lang_source_saved":"Desat","lang_source_last_post":"\xdaltima entrada vista","lang_source_refresh":"Actualitza aquesta font","lang_no_entries":"No es van trobar entrades","lang_more":"M\xe9s","lang_login":"Inicia una sessi\xf3","lang_login_username":"Nom d\'usuari","lang_login_password":"Contrasenya","lang_login_invalid_credentials":"Nom d\'usuari o contrasenya incorrectes","lang_login_offline":"Emmagatzematge fora de l\xednia","lang_no_title":"Sense t\xedtol","lang_error":"S\'ha produ\xeft un error","lang_streamerror":"No hi ha cap element carregat. Es recarrega?","lang_reload_list":"Recarrega la llista","lang_sources_refreshed":"S\'han actualitzat les fonts","lang_app_update":"selfoss s\'ha actualitzat, torneu a carregar","lang_app_reload":"Recarrega","lang_error_session_expired":"La sessi\xf3 ha expirat","lang_error_add_source":"No s\'ha pogut afegir la font:","lang_error_delete_source":"No s\'ha pogut esborrar la font:","lang_error_load_tags":"No s\'han pogut carregar les etiquetes:","lang_error_unknown_tag":"Etiqueta desconeguda:","lang_error_unknown_source":"Id de font desconeguda:","lang_error_mark_items":"No s\'han pogut marcar tots els elements visibles:","lang_error_mark_item":"No s\'ha pogut marcar/desmarcar element:","lang_error_star_item":"No s\'ha pogut preferir/despreferir l\'element:","lang_error_logout":"No s\'ha pogut finalitzar la sessi\xf3:","lang_error_loading":"Error de c\xe0rrega:","lang_error_loading_stats":"No s\'han pogut carregar les estad\xedstiques de navegaci\xf3:","lang_error_saving_color":"No s\'ha pogut desar el nou color:","lang_error_refreshing_source":"No s\'han pogut refrescar fonts:","lang_error_sync":"No s\'han pogut sincronitzar els \xfaltims canvis del servidor:","lang_error_offline_storage":"Error d\'emmagatzematge fora de l\xednia: {0}. Recarregar pot ajudar. Es desactiva l\'\xfas fora de l\xednia per ara.","lang_error_invalid_subsection":"Subsecci\xf3 inv\xe0lida:","lang_search_label":"Terme de cerca","lang_article_actions":"Accions","lang_error_configuration":"No es pot carregar la configuraci\xf3.","lang_info_url_copied":"S\'ha copiat l\'URL al portaretalls.","lang_share_native_label":"Comparteix","lang_share_diaspora_label":"Comparteix a Diaspora","lang_share_twitter_label":"Comparteix al Twitter","lang_share_facebook_label":"Comparteix al Facebook","lang_share_pocket_label":"Desa a Pocket","lang_share_wallabag_label":"Desa a Wallabag","lang_share_wordpress_label":"Comparteix a WordPress","lang_share_mail_label":"Comparteix per correu electr\xf2nic","lang_share_copy_label":"Copia l\'enlla\xe7 al portaretalls","lang_error_share_native_abort":"No es pot compartir l\'element\u2014o no hi ha destinacions de compartici\xf3, o ho heu cancel\xb7lat.","lang_error_share_native":"No es pot compartir l\'element.","lang_close_entry":"Tanca","lang_error_unwritable_logs":"No es poden escriure els registres.","lang_error_check_system_logs":"S\'ha produ\xeft un error. Comproveu els registres del sistema.","lang_error_check_log_file":"S\'ha produ\xeft un error. Comprova el fitxer de registre \u201C{0}\u201D.","lang_offline_navigation_unavailable":"Canviar etiquetes i fonts no \xe9s disponible en el mode fora de l\xednia.","lang_error_offline_storage_not_available":"Emmagatzematge fora de l\xednia no disponible. Assegureu-vos que el navegador {0}suporta IndexedDB API{1}. Si utilitzeu un navegador basat en Google Chrome, que no estigueu utilitzant selfoss en mode inc\xf2gnit.","lang_error_edit_source":"No es pot desar els canvis a les fonts:","lang_article_reading_time":"{0} min lectura","lang_experimental":"Experimental","lang_source_menu":"M\xe9s accions","lang_source_browse":"Navega","lang_sources_leaving_unsaved_prompt":"Voleu deixar la configuraci\xf3 amb els canvis de font no desats?","lang_source_warn_cancel_dirty":"Vols descartar els canvis no desats?","lang_tag_change_color_button_title":"Canvia el color","lang_sources_loading":"S\'estan carregant les fonts\u2026","lang_source_deleting":"S\'est\xe0 suprimint la font\u2026","lang_source_params_loading":"S\'estan carregant els par\xe0metres\u2026","lang_no_sources":"No hi ha fonts configurades.","lang_source_saving":"S\'estan desant els canvis a la font\u2026","lang_source_go_to_settings":"Obre a la configuraci\xf3","lang_entries_loading":"S\'estan carregant les entrades\u2026","lang_login_in_progress":"S\'est\xe0 intentant iniciar sessi\xf3\u2026","lang_login_error_generic":"No s\'ha pogut iniciar sessi\xf3: {errorMessage}","lang_error_unauthorized":"Si us plau, {link_begin}inicieu sessi\xf3{link_end} per a continuar."}');


var $18e6d39c6df6a504$exports = {};
$18e6d39c6df6a504$exports = JSON.parse('{"lang_markread":"Ozna\u010Dit jako p\u0159e\u010Dten\xe9","lang_filter":"Zobrazovat","lang_newest":"Nejnov\u011Bj\u0161\xed","lang_unread":"Nep\u0159e\u010Dten\xe9","lang_starred":"Ozna\u010Den\xe9","lang_tags":"\u0160t\xedtky","lang_alltags":"V\u0161echny \u0161t\xedtky","lang_timestamp":"{0,date} {0,time}","lang_hours":"p\u0159ed {0,plural,one {1 hodinou},other {# hodinami}}","lang_minutes":"p\u0159ed {0,plural,one {1 minutou},other {# minutami}}","lang_seconds":"p\u0159ed {0,plural,one {chv\xedl\xed},other {# sekundami}}","lang_days":"{0,plural,zero {dnes},one {v\u010Dera},other {p\u0159ed # dny}}","lang_star":"Ozna\u010Dit","lang_unstar":"Odzna\u010Dit","lang_mark":"Ozna\u010Dit jako p\u0159e\u010Dten\xe9","lang_unmark":"Ozna\u010Dit jako nep\u0159e\u010Dten\xe9","lang_load_img":"Zobrazit obr\xe1zky","lang_open_window":"Otev\u0159\xedt","lang_next":"Dal\u0161\xed","lang_search_label":"Vyhled\xe1van\xfd text","lang_searchbutton":"Hledat","lang_searchremove":"Skr\xfdt hled\xe1n\xed","lang_refreshbutton":"Obnovit zdroje","lang_settingsbutton":"Nastaven\xed","lang_logoutbutton":"Odhl\xe1sit se","lang_loginbutton":"P\u0159ihl\xe1sit se","lang_sources":"Zdroje","lang_sources_loading":"Na\u010D\xedt\xe1n\xed zdroj\u016F\u2026","lang_no_sources":"Nejsou nastaveny \u017E\xe1dn\xe9 zdroje.","lang_source_add":"P\u0159idat zdroj","lang_source_opml":"nebo nahr\xe1t opml soubor","lang_source_export":"Export zdroj\u016F","lang_source_edit":"Upravit","lang_source_filter":"Filtr","lang_source_menu":"V\xedce akc\xed","lang_source_browse":"Prohl\xed\u017Eet","lang_source_delete":"Smazat","lang_source_warn":"Opravdu chcete tento zdroj smazat?","lang_source_deleting":"Maz\xe1n\xed zdroje\u2026","lang_source_warn_cancel_dirty":"Opravdu chcete zahodit neulo\u017Een\xe9 zm\u011Bny?","lang_source_new":"Nov\xfd neulo\u017Een\xfd zdroj","lang_source_title":"N\xe1zev","lang_source_autotitle_hint":"Pro automatick\xe9 vypln\u011Bn\xed ponechte pr\xe1zdn\xe9","lang_source_tags":"\u0160t\xedtky","lang_source_pwd_placeholder":"Beze zm\u011Bny","lang_source_comma":"Odd\u011Blen\xe9 \u010D\xe1rkou","lang_source_select":"Vyberte pros\xedm zdroj","lang_source_params_loading":"Na\u010D\xedt\xe1n\xed parametr\u016F\u2026","lang_source_type":"Typ","lang_source_save":"Ulo\u017Eit","lang_source_cancel":"Zru\u0161it","lang_source_saving":"Ukl\xe1d\xe1n\xed zm\u011Bn zdroje\u2026","lang_source_saved":"Ulo\u017Eeno","lang_source_last_post":"Posledn\xed p\u0159\xedsp\u011Bvek spat\u0159en","lang_source_refresh":"Obnovit tento zdroj","lang_source_go_to_settings":"Otev\u0159\xedt v\xa0nastaven\xed","lang_sources_leaving_unsaved_prompt":"Na str\xe1nce jsou neulo\u017Een\xe9 zm\u011Bny. Opravdu chcete opustit nastaven\xed?","lang_tag_change_color_button_title":"Zm\u011Bnit barvu","lang_entries_loading":"Na\u010D\xedt\xe1n\xed z\xe1znam\u016F\u2026","lang_no_entries":"\u017D\xe1dn\xfd z\xe1znam","lang_more":"V\xedce","lang_login":"P\u0159ihl\xe1sit","lang_login_in_progress":"P\u0159ihla\u0161ov\xe1n\xed\u2026","lang_login_username":"Jm\xe9no","lang_login_password":"Heslo","lang_login_invalid_credentials":"\u0160patn\xe9 jm\xe9no nebo heslo","lang_login_error_generic":"Pokus o p\u0159ihl\xe1\u0161en\xed selhal: {errorMessage}","lang_no_title":"Bez titulku","lang_error":"Nastala chyba","lang_error_unauthorized":"Pro pokra\u010Dov\xe1n\xed se pros\xedm {link_begin}p\u0159ihlaste{link_end}.","lang_error_check_log_file":"Nastala chyba, zkontrolujte pros\xedm z\xe1znamy v\xa0souboru \u201E{0}\u201C.","lang_error_check_system_logs":"Nastala chyba, zkontrolujte pros\xedm z\xe1znamy v\xa0opera\u010Dn\xedm syst\xe9mu.","lang_error_unwritable_logs":"Nebylo mo\u017En\xe9 zaznamenat chybu.","lang_streamerror":"Nena\u010Dteny \u017E\xe1dn\xe9 polo\u017Eky, zkusit znovu?","lang_reload_list":"Znovu na\u010D\xedst seznam","lang_sources_refreshed":"Zdroje byly obnoveny","lang_error_session_expired":"Va\u0161e sezen\xed vypr\u0161elo","lang_error_add_source":"Zdroj nemohl b\xfdt p\u0159id\xe1n:","lang_error_delete_source":"Zdroj nemohl b\xfdt smaz\xe1n:","lang_error_load_tags":"\u0160t\xedtky nemohly b\xfdt na\u010Dteny:","lang_error_unknown_tag":"Nezn\xe1m\xfd \u0161t\xedtek:","lang_error_unknown_source":"Nezn\xe1m\xe9 id zdroje:","lang_error_mark_items":"Nelze ozna\u010Dit v\u0161echny viditeln\xe9 zdroje:","lang_error_mark_item":"Nelze ozna\u010Dit polo\u017Eku za (ne)p\u0159e\u010Dtenou:","lang_error_star_item":"Nelze o(d)zna\u010Dit polo\u017Eku hv\u011Bzdi\u010Dkou:","lang_error_logout":"Odhl\xe1\u0161en\xed se nezda\u0159ilo:","lang_error_loading":"Chyba na\u010D\xedt\xe1n\xed:","lang_error_loading_stats":"Na\u010D\xedt\xe1n\xed statistik se nezda\u0159ilo:","lang_error_saving_color":"Nelze zm\u011Bnit barvu:","lang_error_refreshing_source":"Nelze obnovit zdroje:","lang_error_sync":"Synchronizace zm\u011Bn ze serveru selhala:","lang_error_invalid_subsection":"Podsekce neexistuje:","lang_online_count":"Polo\u017Eky dostupn\xe9 na serveru","lang_offline_count":"Polo\u017Eky jsou dostupn\xe9 v prohl\xed\u017Ee\u010Di","lang_offline_navigation_unavailable":"Offline re\u017Eim zat\xedm neumo\u017E\u0148uje p\u0159ep\xednat mezi \u0161t\xedtky a zdroji.","lang_login_offline":"Ukl\xe1dat data v prohl\xed\u017Ee\u010Di","lang_app_update":"selfoss byl aktualizov\xe1n, pros\xedm znovu na\u010Dt\u011Bte str\xe1nku","lang_app_reload":"Znovu na\u010D\xedst","lang_error_offline_storage":"Chyba lok\xe1ln\xedho \xfalo\u017Ei\u0161t\u011B: {0}. Mo\u017En\xe1 pom\u016F\u017Ee znovuna\u010Dten\xed str\xe1nky. Prozat\xedm bude ukl\xe1d\xe1n\xed vypnuto.","lang_article_actions":"Akce","lang_error_configuration":"Nelze na\u010D\xedst konfiguraci.","lang_share_native_label":"Sd\xedlet","lang_share_diaspora_label":"Sd\xedlet na Diaspo\u0159e","lang_share_twitter_label":"Sd\xedlet na Twitteru","lang_share_facebook_label":"Sd\xedlet na Facebooku","lang_share_pocket_label":"Ulo\u017Eit do Pocketu","lang_share_wallabag_label":"Ulo\u017Eit do Wallabagu","lang_share_wordpress_label":"Sd\xedlet na WordPressu","lang_share_mail_label":"Sd\xedlet e-mailem","lang_share_copy_label":"Zkop\xedrovat odkaz do schr\xe1nky","lang_info_url_copied":"URL zkop\xedrov\xe1na do schr\xe1nky.","lang_error_share_native_abort":"Nelze sd\xedlet polo\u017Eku: bu\u010F v\xe1\u0161 prohl\xed\u017Ee\u010D nepodporuje sd\xedlen\xed odkaz\u016F, nebo jste sd\xedlen\xed zru\u0161ili.","lang_error_share_native":"Nelze sd\xedlet polo\u017Eku.","lang_close_entry":"Zav\u0159\xedt","lang_article_reading_time":"{0} min \u010Dten\xed","lang_error_offline_storage_not_available":"Offline \xfalo\u017Ei\u0161t\u011B nen\xed dostupn\xe9. Ujist\u011Bte se, \u017Ee v\xe1\u0161 prohl\xed\u017Ee\u010D {0}podporuje rozhran\xed IndexedDB{1} a, pokud pou\u017E\xedv\xe1te prohl\xed\u017Ee\u010D zalo\u017Een\xfd na Google Chrome, \u017Ee nespou\u0161t\xedte selfoss v re\u017Eimu anonymn\xedho prohl\xed\u017Een\xed.","lang_error_edit_source":"Nelze ulo\u017Eit zm\u011Bny zdroje:","lang_experimental":"Experiment"}');


var $0f57265ba749b28b$exports = {};
$0f57265ba749b28b$exports = JSON.parse('{"lang_markread":"Alles gelesen","lang_newest":"Neueste","lang_unread":"Ungelesen","lang_starred":"Favoriten","lang_tags":"Markierungen","lang_alltags":"Alle Markierungen","lang_timestamp":"{0,date} {0,time}","lang_hours":"vor {0,plural,one {1 Stunde},other {# Stunden}}","lang_minutes":"vor {0,plural,one {1 Minute},other {# Minuten}}","lang_seconds":"{0,plural,one {Jetzt gerade},other {vor # Sekunden}}","lang_days":"{0,plural,zero {heute},one {gestern},other {vor # Tagen}}","lang_star":"behalten","lang_unstar":"vergessen","lang_mark":"als gelesen markieren","lang_unmark":"als ungelesen markieren","lang_load_img":"Zeige Bilder","lang_open_window":"\xf6ffnen","lang_next":"weiter","lang_searchbutton":"suchen","lang_refreshbutton":"Quellen aktualisieren","lang_settingsbutton":"Einstellungen","lang_logoutbutton":"Abmelden","lang_loginbutton":"Anmelden","lang_sources":"Quellen","lang_source_add":"Quelle hinzuf\xfcgen","lang_source_opml":"oder OPML-Datei oder Google Reader importieren","lang_source_export":"Quellen exportieren","lang_source_edit":"bearbeiten","lang_source_filter":"Filter","lang_source_delete":"l\xf6schen","lang_source_warn":"Wirklich diesen Feed entfernen?","lang_source_new":"Neue ungespeicherte Quelle","lang_source_title":"Titel","lang_source_autotitle_hint":"Leer lassen um automatisch Titel zu setzen","lang_source_tags":"Markierungen","lang_source_pwd_placeholder":"Nicht ge\xe4ndert","lang_source_comma":"Komma getrennt","lang_source_select":"Quelle ausw\xe4hlen","lang_source_type":"Typ","lang_source_save":"speichern","lang_source_cancel":"abbrechen","lang_source_saved":"gespeichert","lang_source_last_post":"Letzter gesehener Beitrag","lang_no_entries":"keine Eintr\xe4ge gefunden","lang_more":"mehr","lang_login":"Anmelden","lang_login_username":"Benutzername","lang_login_password":"Passwort","lang_no_title":"kein Titel","lang_error":"Ein Fehler ist aufgetreten","lang_filter":"Filter","lang_online_count":"Auf dem Server verf\xfcgbare Elemente","lang_offline_count":"Lokal verf\xfcgbare Artikel","lang_searchremove":"Suche ausblenden","lang_source_refresh":"Diese Quelle aktualisieren","lang_login_invalid_credentials":"Falscher Benutzername/Passwort","lang_login_offline":"Offline-Speicherung","lang_streamerror":"Keine Artikel geladen, neu laden?","lang_reload_list":"Liste neu laden","lang_sources_refreshed":"Quellen aktualisiert","lang_app_update":"selfoss wurde aktualisiert, bitte neu laden","lang_app_reload":"Neu laden","lang_error_session_expired":"Session abgelaufen","lang_error_add_source":"Die Quelle konnte nicht hinzugef\xfcgt werden:","lang_error_delete_source":"Die Quelle konnte nicht gel\xf6scht werden:","lang_error_load_tags":"Konnte Markierungen nicht laden:","lang_error_unknown_tag":"Unbekannte Markierung:","lang_error_unknown_source":"Unbekannte Quell-ID:","lang_error_mark_items":"Es k\xf6nnen nicht alle sichtbaren Elemente markiert werden:","lang_error_mark_item":"Das Markieren/Deaktivieren von Elementen ist nicht m\xf6glich:","lang_error_star_item":"Artikel kann nicht ge-sternt oder ent-sternt werden:","lang_error_logout":"Konnte nicht ausloggen:","lang_error_loading":"Ladefehler:","lang_error_loading_stats":"Nav-Statistiken k\xf6nnen nicht geladen werden:","lang_error_saving_color":"Neue Farbe kann nicht gespeichert werden:","lang_error_refreshing_source":"Quellen k\xf6nnen nicht aktualisiert werden:","lang_error_sync":"Letzte \xc4nderungen vom Server konnten nicht synchronisiert werden:","lang_error_offline_storage":"Offline-Speicherfehler: {0}. Neu laden k\xf6nnte helfen. Deaktiviere offline vorerst.","lang_error_invalid_subsection":"Ung\xfcltiger Unterabschnitt:","lang_search_label":"Suchbegriff","lang_article_actions":"Aktionen","lang_error_configuration":"Nicht m\xf6glich die Konfiguration zu laden.","lang_info_url_copied":"URL in die Zwischenablage kopiert.","lang_share_native_label":"teilen","lang_share_diaspora_label":"auf Diaspora teilen","lang_share_twitter_label":"auf Twitter teilen","lang_share_facebook_label":"auf Facebook teilen","lang_share_mastodon_label":"auf Mastodon teilen","lang_share_pocket_label":"in Pocket speichern","lang_share_wallabag_label":"in Wallabag speichern","lang_share_wordpress_label":"teile auf WordPress","lang_share_mail_label":"per E-Mail teilen","lang_share_copy_label":"Link in die Zwischenablage kopieren","lang_error_share_native_abort":"Es ist nicht m\xf6glich das Objekt zu teilen\u202F\u2013\u202Fentweder gibt es keine Ziele zum Teilen oder die Aktion wurde abgebrochen.","lang_error_share_native":"Es ist nicht m\xf6glich das Objekt zu teilen.","lang_close_entry":"Schlie\xdfen","lang_error_offline_storage_not_available":"Offline-Speicherung ist nicht verf\xfcgbar. Stelle sicher, dass dein Browser die {0}IndexedDB-API unterst\xfctzt{1} und, falls du einen Browser auf Grundlage von Google Chrome benutzt, dass du selfoss nicht im Incognito-Modus ausf\xfchrst.","lang_error_edit_source":"Konnte die \xc4nderungen an den Quellen nicht speichern:","lang_error_unwritable_logs":"Logdateien konnten nicht geschrieben werden.","lang_error_check_system_logs":"Ein Fehler ist aufgetreten, bitte die Systemlogs pr\xfcfen.","lang_error_check_log_file":"Es ist ein Fehler aufgetreten, bitte Protokolldatei \u201E{0}\u201C pr\xfcfen.","lang_offline_navigation_unavailable":"Markierungen und Quellen zu wechseln wird derzeit im Offline-Modus nicht unterst\xfctzt."}');


var $38fe93b221363e36$exports = {};
$38fe93b221363e36$exports = JSON.parse('{"lang_markread":"Mark as read","lang_filter":"Filter","lang_newest":"Newest","lang_unread":"Unread","lang_starred":"Starred","lang_online_count":"Items available on the server","lang_offline_count":"Items available locally","lang_offline_navigation_unavailable":"Switching tags and sources is currently not available in offline mode.","lang_tags":"Tags","lang_alltags":"All tags","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 hour},other {# hours}} ago","lang_minutes":"{0,plural,one {1 minute},other {# minutes}} ago","lang_seconds":"{0,plural,one {1 second},other {# seconds}} ago","lang_days":"{0,plural,zero {today},one {yesterday},other {# days ago}}","lang_star":"Star","lang_unstar":"Unstar","lang_mark":"Mark as read","lang_unmark":"Mark as unread","lang_load_img":"Show images","lang_open_window":"Open","lang_next":"Next","lang_share_native_label":"Share","lang_share_diaspora_label":"Share on Diaspora","lang_share_twitter_label":"Share on Twitter","lang_share_facebook_label":"Share on Facebook","lang_share_mastodon_label":"Share on Mastodon","lang_share_pocket_label":"Save to Pocket","lang_share_wallabag_label":"Save to Wallabag","lang_share_wordpress_label":"Share on WordPress","lang_share_mail_label":"Share using e-mail","lang_share_copy_label":"Copy link to clipboard","lang_search_label":"Search term","lang_searchbutton":"Search","lang_searchremove":"Hide search","lang_refreshbutton":"Refresh sources","lang_settingsbutton":"Settings","lang_logoutbutton":"Log out","lang_loginbutton":"Log in","lang_sources":"Sources","lang_sources_loading":"Loading sources\u2026","lang_no_sources":"No sources configured.","lang_source_add":"Add source","lang_source_opml":"or import an OPML file","lang_source_export":"Export sources","lang_source_edit":"Edit","lang_source_filter":"Filter","lang_source_menu":"More actions","lang_source_browse":"Browse","lang_source_delete":"Delete","lang_source_warn":"Really delete this source?","lang_source_deleting":"Deleting source\u2026","lang_source_warn_cancel_dirty":"Discard unsaved changes?","lang_source_new":"New unsaved source","lang_source_title":"Title","lang_source_autotitle_hint":"Leave empty to fetch title","lang_source_tags":"Tags","lang_source_pwd_placeholder":"Not changed","lang_source_comma":"Comma separated","lang_source_select":"Please select source","lang_source_params_loading":"Loading parameters\u2026","lang_source_type":"Type","lang_source_save":"Save","lang_source_cancel":"Cancel","lang_source_saving":"Saving source changes\u2026","lang_source_saved":"Saved","lang_source_last_post":"Last post seen","lang_source_refresh":"Refresh this source","lang_source_go_to_settings":"Open in settings","lang_sources_leaving_unsaved_prompt":"Leave settings with unsaved source changes?","lang_tag_change_color_button_title":"Change color","lang_entries_loading":"Loading entries\u2026","lang_no_entries":"No entries found","lang_more":"More","lang_login":"Log in","lang_login_in_progress":"Trying to log in\u2026","lang_login_username":"Username","lang_login_password":"Password","lang_login_invalid_credentials":"Wrong username/password","lang_login_error_generic":"Could not log in: {errorMessage}","lang_login_offline":"Offline storage","lang_no_title":"No title","lang_experimental":"Experimental","lang_error":"An error occurred","lang_error_unauthorized":"Please {link_begin}sign in{link_end} to continue.","lang_error_check_log_file":"An error occured, please check the log file \u201C{0}\u201D.","lang_error_check_system_logs":"An error occured, please check your system logs.","lang_error_unwritable_logs":"Unable to write logs.","lang_streamerror":"No items loaded, reload?","lang_reload_list":"Reload list","lang_sources_refreshed":"Sources refreshed","lang_app_update":"selfoss has been updated, please reload","lang_app_reload":"Reload","lang_error_session_expired":"Session expired","lang_error_add_source":"Could not add source:","lang_error_edit_source":"Could not save source changes:","lang_error_delete_source":"Could not delete source:","lang_error_load_tags":"Could not load tags:","lang_error_unknown_tag":"Unknown tag:","lang_error_unknown_source":"Unknown source ID:","lang_error_mark_items":"Cannot mark all visible items:","lang_error_mark_item":"Cannot mark/unmark item:","lang_error_star_item":"Cannot star/unstar item:","lang_error_logout":"Could not log out:","lang_error_loading":"Loading error:","lang_error_loading_stats":"Cannot load nav stats:","lang_error_saving_color":"Cannot save new color:","lang_error_refreshing_source":"Cannot refresh sources:","lang_error_sync":"Could not sync last changes from server:","lang_error_offline_storage":"Offline storage error: {0}. Reloading may help. Disabling offline for now.","lang_error_offline_storage_not_available":"Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.","lang_error_invalid_subsection":"Invalid subsection:","lang_error_configuration":"Unable to load configuration.","lang_error_share_native_abort":"Unable to share item\u2014either there are no share targets, or you cancelled it.","lang_error_share_native":"Unable to share item.","lang_info_url_copied":"URL copied to clipboard.","lang_close_entry":"Close","lang_article_actions":"Actions","lang_article_reading_time":"{0} min read"}');


var $75c67d0db824a550$exports = {};
$75c67d0db824a550$exports = JSON.parse('{"lang_error_share_native_abort":"Unable to share item\u202F\u2013\u202Feither there are no share targets, or you cancelled it.","lang_error_saving_color":"Cannot save new colour:","lang_close_entry":"Close","lang_error_share_native":"Unable to share item.","lang_share_copy_label":"Copy link to clipboard","lang_share_mail_label":"Share using e-mail","lang_share_wordpress_label":"Share on WordPress","lang_share_wallabag_label":"Save to Wallabag","lang_share_pocket_label":"Save to Pocket","lang_share_facebook_label":"Share on Facebook","lang_share_twitter_label":"Share on Twitter","lang_share_diaspora_label":"Share on Diaspora","lang_share_native_label":"Share","lang_info_url_copied":"URL copied to clipboard.","lang_error_configuration":"Unable to load configuration.","lang_article_actions":"Actions","lang_search_label":"Search term","lang_error_invalid_subsection":"Invalid subsection:","lang_error_offline_storage":"Offline storage error: {0}. Reloading may help. Disabling offline for now.","lang_error_sync":"Could not sync last changes from server:","lang_error_refreshing_source":"Cannot refresh sources:","lang_error_loading_stats":"Cannot load nav stats:","lang_error_loading":"Loading error:","lang_error_logout":"Could not log out:","lang_error_star_item":"Cannot star/unstar item:","lang_error_mark_item":"Cannot mark/unmark item:","lang_error_mark_items":"Cannot mark all visible items:","lang_error_unknown_source":"Unknown source ID:","lang_error_unknown_tag":"Unknown tag:","lang_error_load_tags":"Could not load tags:","lang_error_delete_source":"Could not delete source:","lang_error_add_source":"Could not add source:","lang_error_session_expired":"Session expired","lang_app_reload":"Reload","lang_app_update":"selfoss has been updated, please reload","lang_sources_refreshed":"Sources refreshed","lang_reload_list":"Reload list","lang_streamerror":"No items loaded, reload?","lang_error":"An error occurred","lang_no_title":"No title","lang_login_offline":"Offline storage","lang_login_invalid_credentials":"Wrong username/password","lang_login_password":"Password","lang_login_username":"Username","lang_login":"Log in","lang_more":"More","lang_no_entries":"No entries found","lang_source_refresh":"Refresh this source","lang_source_last_post":"Last post seen","lang_source_saved":"Saved","lang_source_cancel":"Cancel","lang_source_save":"Save","lang_source_type":"Type","lang_source_select":"Please select source","lang_source_comma":"Comma separated","lang_source_pwd_placeholder":"Not changed","lang_source_tags":"Tags","lang_source_autotitle_hint":"Leave empty to fetch title","lang_source_title":"Title","lang_source_new":"New unsaved source","lang_source_warn":"Really delete this source?","lang_source_delete":"Delete","lang_source_filter":"Filter","lang_source_edit":"Edit","lang_source_export":"Export sources","lang_source_opml":"or import an OPML file","lang_source_add":"Add source","lang_sources":"Sources","lang_loginbutton":"Log in","lang_logoutbutton":"Log out","lang_settingsbutton":"Settings","lang_refreshbutton":"Refresh sources","lang_searchremove":"Hide search","lang_searchbutton":"Search","lang_next":"Next","lang_open_window":"Open","lang_load_img":"Show images","lang_unmark":"Mark as unread","lang_mark":"Mark as read","lang_unstar":"Unstar","lang_star":"Star","lang_days":"{0,plural,zero {today},one {yesterday},other {# days ago}}","lang_seconds":"{0,plural,one {1 second},other {# seconds}} ago","lang_minutes":"{0,plural,one {1 minute},other {# minutes}} ago","lang_hours":"{0,plural,one {1 hour},other {# hours}} ago","lang_timestamp":"{0,date} {0,time}","lang_alltags":"All tags","lang_tags":"Tags","lang_offline_count":"Items available locally","lang_online_count":"Items available on the server","lang_starred":"Starred","lang_unread":"Unread","lang_newest":"Newest","lang_filter":"Filter","lang_markread":"Mark as read","lang_error_offline_storage_not_available":"Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.","lang_error_edit_source":"Could not save source changes:","lang_error_unwritable_logs":"Unable to write logs.","lang_error_check_system_logs":"An error occured, please check your system logs.","lang_error_check_log_file":"An error occured, please check the log file \u2018{0}\u2019.","lang_offline_navigation_unavailable":"Switching tags and sources is currently not available in offline mode.","lang_experimental":"Experimental","lang_entries_loading":"Loading entries\u2026","lang_login_in_progress":"Trying to log in\u2026","lang_login_error_generic":"Could not log in: {errorMessage}","lang_error_unauthorized":"Please {link_begin}sign in{link_end} to continue.","lang_no_sources":"No sources configured.","lang_source_menu":"More actions","lang_source_browse":"Browse","lang_source_params_loading":"Loading parameters\u2026","lang_sources_loading":"Loading sources\u2026","lang_source_deleting":"Deleting source\u2026","lang_source_saving":"Saving source changes\u2026","lang_source_go_to_settings":"Open in settings","lang_source_warn_cancel_dirty":"Discard unsaved changes?","lang_sources_leaving_unsaved_prompt":"Leave settings with unsaved source changes?","lang_tag_change_color_button_title":"Change colour","lang_article_reading_time":"{0} min read","lang_share_mastodon_label":"Share on Mastodon"}');


var $e09fd591c81d8c00$exports = {};
$e09fd591c81d8c00$exports = JSON.parse('{"lang_markread":"marcar como le\xeddo","lang_filter":"filtro","lang_newest":"nuevos","lang_unread":"no le\xeddos","lang_starred":"preferidos","lang_online_count":"Elementos disponibles en el servidor","lang_offline_count":"Elementos disponibles localmente","lang_tags":"Etiquetas","lang_alltags":"todas las etiquetas","lang_timestamp":"{0,date} {0,time}","lang_hours":"hace {0,plural,one {1 hora},other {# horas}}","lang_minutes":"hace {0,plural,one {1 minuto},other {# minutos}}","lang_seconds":"hace {0,plural,one {1 segundo},other {# segundos}}","lang_days":"{0,plural,zero {hoy},one {ayer},other {hace # d\xedas}}","lang_star":"preferido","lang_unstar":"ya no lo prefiero","lang_mark":"marcar como le\xeddo","lang_unmark":"marcar como no le\xeddo","lang_load_img":"cargar Im\xe1genes","lang_open_window":"abrir","lang_next":"siguiente","lang_searchbutton":"buscar","lang_searchremove":"ocultar b\xfasqueda","lang_refreshbutton":"actualizar fuentes","lang_settingsbutton":"configuraci\xf3n","lang_logoutbutton":"cerrar sesi\xf3n","lang_loginbutton":"iniciar sesi\xf3n","lang_sources":"Fuentes","lang_source_add":"agregar fuente","lang_source_opml":"o importar desde un archivo opml o desde Google Reader (Hasta el 15 de Julio de 2013)","lang_source_export":"exportar fuentes","lang_source_edit":"editar","lang_source_filter":"Filtrar","lang_source_delete":"borrar","lang_source_warn":"realmente desea borrar esta fuente?","lang_source_new":"nueva fuente sin guardar","lang_source_title":"Titulo","lang_source_autotitle_hint":"Dejar en blanco para obtener t\xedtulo","lang_source_tags":"Etiquetas","lang_source_pwd_placeholder":"no ha cambiado","lang_source_comma":"separado por comas","lang_source_select":"por favor seleccione una fuente","lang_source_type":"Tipo","lang_source_save":"Guardar","lang_source_cancel":"cancelar","lang_source_saved":"Guardado","lang_source_last_post":"\xdaltima entrada vista","lang_source_refresh":"Actualizar esta fuente","lang_no_entries":"No se encontraron entradas","lang_more":"m\xe1s","lang_login":"iniciar sesi\xf3n","lang_login_username":"usuario","lang_login_password":"contrase\xf1a","lang_login_invalid_credentials":"usuario/contrase\xf1a incorrectos","lang_login_offline":"Almacenaje fuera de l\xednea","lang_no_title":"sin t\xedtulo","lang_error":"ha ocurrido un error","lang_streamerror":"Ning\xfan elemento cargado, \xbfrecargar?","lang_reload_list":"Recargar lista","lang_sources_refreshed":"Las fuentes han sido refrescadas","lang_app_update":"selfoss ha sido actualizado, recargue","lang_app_reload":"Recargar","lang_error_session_expired":"La sesi\xf3n ha expirado","lang_error_add_source":"Error a\xf1adiendo fuente:","lang_error_delete_source":"Error borrando fuente:","lang_error_load_tags":"Error cargando etiquetas:","lang_error_unknown_tag":"Etiqueta desconocida:","lang_error_unknown_source":"Id de fuente desconocido:","lang_error_mark_items":"No se pudo marcar todos los elementos visibles:","lang_error_mark_item":"No se pudo marcar/desmarcar elemento:","lang_error_star_item":"No se pudo preferir/despreferir elemento:","lang_error_logout":"No se pudo registrar:","lang_error_loading":"Error cargando:","lang_error_loading_stats":"No se pudo cargar estad\xedsticas de navegaci\xf3n:","lang_error_saving_color":"No se pudo cargar nuevo color:","lang_error_refreshing_source":"No se pudo refrescar fuentes:","lang_error_sync":"No se pudo sincronizar los \xfaltimos cambios del servidor:","lang_error_offline_storage":"Error de almacenaje fuera de l\xednea: {0}. Recargar puede ayudar. Desactivando uso fuera de l\xednea por ahora.","lang_error_invalid_subsection":"Subsecci\xf3n inv\xe1lida:","lang_search_label":"Buscar t\xe9rmino","lang_article_actions":"Acciones","lang_error_configuration":"Imposible cargar configuraci\xf3n.","lang_info_url_copied":"URL copiada al portapapeles.","lang_share_native_label":"Compartir","lang_share_diaspora_label":"Compartir en Diaspora","lang_share_twitter_label":"Compartir en Twitter","lang_share_facebook_label":"Compartir en Facebook","lang_share_pocket_label":"Guardar en Pocket","lang_share_wallabag_label":"Guardar en Wallabag","lang_share_wordpress_label":"Compartir en WordPress","lang_share_mail_label":"Compartir por e-mail","lang_share_copy_label":"Copiar enlace al portapapeles","lang_error_share_native_abort":"Imposible compartir \xedtem-no hay objetivos que compartir, o has cancelado.","lang_error_share_native":"Imposible compartir \xedtem.","lang_close_entry":"Cerrar","lang_error_unwritable_logs":"Imposible escribir logs.","lang_error_check_system_logs":"Un error ha ocurido, por favor comprueba tus logs de sistema.","lang_error_check_log_file":"Un error ha ocurrido, por favor comprueba el fichero de log \u201C{0}\u201D.","lang_offline_navigation_unavailable":"Cambiar etiquetas y fuentes no est\xe1 disponible en el modo fuera de l\xednea.","lang_error_offline_storage_not_available":"Almacenaje fuera de l\xednea no est\xe1 disponible. Aseg\xfarese que su navegador {0}soporta IndexedDB API{1} y, si est\xe1 utilizando un navegador basado en Google Chrome, que no est\xe1 usando selfoss en modo inc\xf3gnito.","lang_error_edit_source":"No se pudo guardar los cambios en las fuentes:","lang_experimental":"Experimental","lang_article_reading_time":"{0} min lectura","lang_sources_loading":"Cargando fuentes\u2026","lang_source_warn_cancel_dirty":"\xbfDescartar los cambios no guardados?","lang_error_unauthorized":"Por favor, {link_begin}firme{link_end} para continuar.","lang_no_sources":"No hay fuentes configuradas.","lang_source_menu":"M\xe1s acciones","lang_source_browse":"Navegar","lang_source_deleting":"Borrando fuente\u2026","lang_source_params_loading":"Cargando par\xe1metros\u2026","lang_login_in_progress":"Intentando iniciar sesi\xf3n\u2026","lang_source_saving":"Guardando cambios en la fuente\u2026","lang_source_go_to_settings":"Abrir en los ajustes","lang_tag_change_color_button_title":"Cambiar el color","lang_entries_loading":"Cargando las entradas\u2026","lang_login_error_generic":"No se ha podido iniciar la sesi\xf3n: {errorMessage}","lang_sources_leaving_unsaved_prompt":"\xbfDejar la configuraci\xf3n con los cambios sin guardar?","lang_share_mastodon_label":"Compartir en Mastodon"}');


var $09197c62e8f40c51$exports = {};
$09197c62e8f40c51$exports = JSON.parse('{"lang_markread":"M\xe4rgi loetuks","lang_newest":"Uued","lang_unread":"Mitteloetud","lang_starred":"T\xe4rniga","lang_tags":"Sildid","lang_alltags":"K\xf5ik sildid","lang_timestamp":"lisatud {0,date} kell {0,time}","lang_hours":"lisatud {0,plural,one {1 tund},other {# tundi}} tagasi","lang_minutes":"lisatud {0,plural,one {1 minut},other {# minutit}} tagasi","lang_seconds":"lisatud {0,plural,one {1 sekund},other {# sekundit}} tagasi","lang_star":"t\xe4rniga","lang_unstar":"t\xe4rnita","lang_mark":"m\xe4rgi loetuks","lang_unmark":"m\xe4rgi mitteloetuks","lang_load_img":"pildid","lang_open_window":"ava","lang_searchbutton":"otsi","lang_sources":"Tellimused","lang_source_add":"Lisa tellimus","lang_source_opml":"v\xf5i impordi opml-fail v\xf5i Google Reader","lang_source_export":"ekspordi tellimused","lang_source_edit":"toimeta","lang_source_delete":"kustuta","lang_source_warn":"Kas t\xf5esti kustutada tellimus?","lang_source_new":"uus salvestamata tellimus","lang_source_title":"Nimi","lang_source_tags":"Sildid","lang_source_comma":"komaga eraldatud","lang_source_select":"Tellimuse allika liik","lang_source_type":"Liik","lang_source_save":"Salvesta","lang_source_cancel":"loobu","lang_source_saved":"salvestatud","lang_no_entries":"\xdchtki s\xfcndmust ei leitud","lang_more":"rohkem","lang_login":"logi sisse","lang_login_username":"Kasutajanimi","lang_login_password":"Parool","lang_no_title":"Nimeta"}');


var $7bfc007d210a165f$exports = {};
$7bfc007d210a165f$exports = JSON.parse('{"lang_markread":"merkitse luetuiksi","lang_newest":"uusimmat","lang_unread":"lukemattomat","lang_starred":"t&auml;hdelliset","lang_tags":"Avainsanat","lang_alltags":"kaikki avainsanat","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 tunti},other {# tuntia}} sitten","lang_minutes":"{0,plural,one {1 minuutti},other {# minuuttia}} sitten","lang_seconds":"{0,plural,one {1 sekunti},other {# sekuntia}} sitten","lang_star":"t&auml;hti","lang_unstar":"t&auml;hti pois","lang_mark":"luetuksi","lang_unmark":"lukemattomaksi","lang_load_img":"lataa kuvat","lang_open_window":"avaa","lang_searchbutton":"etsi","lang_sources":"L&auml;hteet","lang_source_add":"lis&auml;&auml; l&auml;hde","lang_source_opml":"tai tuo opml-tiedosto tai google reader","lang_source_export":"vie l&auml;hteet","lang_source_edit":"muokkaa","lang_source_delete":"poista","lang_source_warn":"Haluatko varmasti poistaa t&auml;m&auml;n l&auml;hteen?","lang_source_new":"uusi tallentamaton l&auml;hde","lang_source_title":"Nimi","lang_source_tags":"Avainsanat","lang_source_comma":"avainsanat erotetaan pilkulla","lang_source_select":"valitse l&auml;hde","lang_source_type":"Tyyppi","lang_source_save":"tallenna","lang_source_cancel":"peruuta","lang_source_saved":"tallennettu","lang_no_entries":"merkint&ouml;j&auml; ei l&ouml;ydetty","lang_more":"lis&auml;&auml;","lang_login":"kirjaudu sis&auml;&auml;n","lang_login_username":"k&auml;ytt&auml;j&auml;tunnus","lang_login_password":"salasana","lang_no_title":"ei otsikkoa","lang_error_share_native_abort":"Kohteen jakaminen ep\xe4onnistui \u2013 joko jakamiskohteita ei ole tai peruutat sen.","lang_close_entry":"Sulje","lang_login_invalid_credentials":"V\xe4\xe4r\xe4 k\xe4ytt\xe4j\xe4nimi/salasana","lang_share_mail_label":"Jaa s\xe4hk\xf6postitse"}');


var $5d661914acf6fff5$exports = {};
$5d661914acf6fff5$exports = JSON.parse('{"lang_markread":"Marquer comme lu","lang_filter":"Filtrer","lang_newest":"Le plus r\xe9cent","lang_unread":"Non lu","lang_starred":"Favoris","lang_online_count":"Sur le serveur","lang_offline_count":"En local","lang_tags":"\xc9tiquettes","lang_alltags":"Toutes les \xe9tiquettes","lang_timestamp":"{0,date} {0,time}","lang_hours":"il y a {0,plural,one {1 heure},other {# heures}}","lang_minutes":"il y a {0,plural,one {1 minute},other {# minutes}}","lang_seconds":"il y a {0,plural,one {1 seconde},other {# secondes}}","lang_days":"{0,plural,zero {aujourd\u2019hui},one {hier},other {il y a # jours}}","lang_star":"Ajouter aux favoris","lang_unstar":"Supprimer des favoris","lang_mark":"Marquer comme lu","lang_unmark":"Marquer comme non lu","lang_load_img":"Afficher les images","lang_open_window":"Ouvrir","lang_next":"Suivant","lang_searchbutton":"Rechercher","lang_searchremove":"Masquer le champ de recherche","lang_refreshbutton":"Actualiser les sources","lang_settingsbutton":"Param\xe8tres","lang_logoutbutton":"Se d\xe9connecter","lang_loginbutton":"Se connecter","lang_sources":"Sources","lang_source_add":"Ajouter une source","lang_source_opml":"ou importer un fichier OPML ou Google Reader","lang_source_export":"Exporter les sources","lang_source_edit":"Modifier","lang_source_filter":"Filtre","lang_source_delete":"Supprimer","lang_source_warn":"Voulez-vous vraiment supprimer cette source ?","lang_source_new":"Nouvelle source non sauvegard\xe9e","lang_source_title":"Titre","lang_source_autotitle_hint":"Laisser vide pour r\xe9cup\xe9rer le titre","lang_source_tags":"\xc9tiquettes","lang_source_pwd_placeholder":"Mot de passe inchang\xe9","lang_source_comma":"S\xe9par\xe9s par une virgule","lang_source_select":"Veuillez s\xe9lectionner une source","lang_source_type":"Type","lang_source_save":"Enregistrer","lang_source_cancel":"Annuler","lang_source_saved":"Enregistr\xe9","lang_source_last_post":"Dernier \xe9l\xe9ment vu","lang_source_refresh":"Rafra\xeechir cette source","lang_no_entries":"Aucun article \xe0 consulter","lang_more":"Plus","lang_login":"Connexion","lang_login_username":"Identifiant","lang_login_password":"Mot de passe","lang_login_invalid_credentials":"Nom d\u2019utilisateur/Mot de passe incorrect","lang_login_offline":"Stockage hors-ligne","lang_no_title":"Sans titre","lang_error":"Une erreur est survenue","lang_streamerror":"Une erreur s\u2019est produite lors du chargement de la liste, essayer \xe0 nouveau\xa0?","lang_reload_list":"Recharger la liste","lang_sources_refreshed":"Sources actualis\xe9es","lang_app_update":"selfoss a \xe9t\xe9 mis \xe0 jour, merci de recharger","lang_app_reload":"Recharger","lang_error_session_expired":"Session expir\xe9e","lang_error_add_source":"Impossible d\'ajouter la source\xa0:","lang_error_delete_source":"Impossible de supprimer la source :","lang_error_load_tags":"Impossible de charger les \xe9tiquettes :","lang_error_unknown_tag":"Tag inconnu\xa0:","lang_error_unknown_source":"Identifiant de source inconnu\xa0:","lang_error_mark_items":"Impossible de marquer tous les \xe9l\xe9ments visibles\xa0:","lang_error_mark_item":"Erreur lors du marquage lu/non lu\xa0:","lang_error_star_item":"Erreur lors de l\u2019ajouter/suppression du favori\xa0:","lang_error_logout":"Impossible de se d\xe9connecter\xa0:","lang_error_loading":"Erreur de chargement\xa0:","lang_error_loading_stats":"Impossible de charger les statistiques de navigation\xa0:","lang_error_saving_color":"Impossible de sauvegarder une nouvelle couleur\xa0:","lang_error_refreshing_source":"Impossible de rafra\xeechir les sources\xa0:","lang_error_sync":"Impossible de synchroniser les derni\xe8res modifications du serveur\xa0:","lang_error_offline_storage":"Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est d\xe9sactiv\xe9 pour le moment.","lang_error_invalid_subsection":"Sous-section erron\xe9e :","lang_search_label":"Terme de recherche","lang_article_actions":"Actions","lang_error_configuration":"Impossible de charger la configuration.","lang_info_url_copied":"URL copi\xe9e dans le presse-papiers.","lang_share_native_label":"Partager","lang_share_diaspora_label":"Partager sur Diaspora","lang_share_twitter_label":"Partager sur Twitter","lang_share_facebook_label":"Partager sur Facebook","lang_share_pocket_label":"Enregistrer dans Pocket","lang_share_wallabag_label":"Enregistrer dans Wallabag","lang_share_wordpress_label":"Partager sur WordPress","lang_share_mail_label":"Partager par courriel","lang_share_copy_label":"Copier le lien dans le presse-papiers","lang_error_share_native_abort":"Impossible de partager l\'\xe9l\xe9ment, soit il n\'y a pas de cible, soit vous avez annul\xe9 le partage.","lang_error_share_native":"Impossible de partager l\'\xe9l\xe9ment.","lang_close_entry":"Fermer","lang_error_unwritable_logs":"Impossible d\'\xe9crire les fichiers de journalisation.","lang_error_check_system_logs":"Une erreur est survenue. Veuillez consulter votre journalisation syst\xe8me.","lang_error_check_log_file":"Une erreur est survenue. Veuillez consulter le fichier \xab {0} \xbb.","lang_offline_navigation_unavailable":"Modifier les \xe9tiquettes et les sources n\'est pas possible hors ligne pour le moment.","lang_error_offline_storage_not_available":"Le stockage hors ligne n\u2019est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l\u2019API IndexedDB{1} et, si vous utilisez un navigateur bas\xe9 sur Google Chrome, que vous n\u2019ex\xe9cutez pas selfoss en mode de navigation priv\xe9e.","lang_error_edit_source":"Impossible d\'enregistrer les modifications de la source\xa0:","lang_source_browse":"Naviguer","lang_no_sources":"Aucune source configur\xe9es.","lang_source_warn_cancel_dirty":"Annuler les changements non sauvegard\xe9s ?","lang_source_deleting":"Suppression de la source\u2026","lang_source_saving":"Sauvegarde des changements de la source\u2026","lang_entries_loading":"Chargement des entr\xe9es\u2026","lang_source_menu":"Plus d\'actions","lang_tag_change_color_button_title":"Changer la couleur","lang_sources_loading":"Chargement des sources\u2026","lang_source_go_to_settings":"Ouvrir dans les param\xe8tres","lang_sources_leaving_unsaved_prompt":"Quitter les param\xe8tres avec des changements sur la source non sauvegard\xe9s ?","lang_source_params_loading":"Chargement des param\xe8tres\u2026","lang_experimental":"Exp\xe9rimentale","lang_article_reading_time":"{0} min de lecture","lang_login_in_progress":"Tentative de connexion\u2026","lang_login_error_generic":"Connexion impossible : {errorMessage}","lang_error_unauthorized":"S\'il vous pla\xeet {link_begin}connectez-vous{link_end} pour continuer."}');


var $17710b319b719f9f$exports = {};
$17710b319b719f9f$exports = JSON.parse('{"lang_error_add_source":"Impossible d\'ajouter la source\u202F:","lang_streamerror":"Une erreur s\u2019est produite lors du chargement de la liste, essayer \xe0 nouveau?","lang_source_warn":"Voulez-vous vraiment supprimer cette source?","lang_sources":"Sources","lang_timestamp":"{0,date} {0,time}","lang_close_entry":"Fermer","lang_error_share_native":"Impossible de partager l\'\xe9l\xe9ment.","lang_error_share_native_abort":"Impossible de partager l\'\xe9l\xe9ment, soit il n\'y a pas de cible, soit vous avez annul\xe9 le partage.","lang_share_copy_label":"Copier le lien dans le presse-papiers","lang_share_mail_label":"Partager par courriel","lang_share_wordpress_label":"Partager sur WordPress","lang_share_wallabag_label":"Enregistrer dans Wallabag","lang_share_pocket_label":"Enregistrer dans Pocket","lang_share_facebook_label":"Partager sur Facebook","lang_share_twitter_label":"Partager sur Twitter","lang_share_diaspora_label":"Partager sur Diaspora","lang_share_native_label":"Partager","lang_info_url_copied":"URL copi\xe9e dans le presse-papiers.","lang_error_configuration":"Impossible de charger la configuration.","lang_article_actions":"Actions","lang_search_label":"Terme de recherche","lang_error_invalid_subsection":"Sous-section erron\xe9e :","lang_error_offline_storage":"Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est d\xe9sactiv\xe9 pour le moment.","lang_error_sync":"Impossible de synchroniser les derni\xe8res modifications du serveur\xa0:","lang_error_refreshing_source":"Impossible de rafra\xeechir les sources\xa0:","lang_error_saving_color":"Impossible de sauvegarder une nouvelle couleur\xa0:","lang_error_loading_stats":"Impossible de charger les statistiques de navigation\xa0:","lang_error_loading":"Erreur de chargement\xa0:","lang_error_logout":"Impossible de se d\xe9connecter\xa0:","lang_error_star_item":"Erreur lors de l\u2019ajouter/suppression du favori\xa0:","lang_error_mark_item":"Erreur lors du marquage lu/non lu\xa0:","lang_error_mark_items":"Impossible de marquer tous les \xe9l\xe9ments visibles\xa0:","lang_error_unknown_source":"Identifiant de source inconnu\xa0:","lang_error_unknown_tag":"Tag inconnu\xa0:","lang_error_load_tags":"Impossible de charger les \xe9tiquettes :","lang_error_delete_source":"Impossible de supprimer la source :","lang_error_session_expired":"Session expir\xe9e","lang_app_reload":"Recharger","lang_app_update":"selfoss a \xe9t\xe9 mis \xe0 jour, merci de recharger","lang_sources_refreshed":"Sources actualis\xe9es","lang_reload_list":"Recharger la liste","lang_error":"Une erreur est survenue","lang_no_title":"Sans titre","lang_login_offline":"Stockage hors-ligne","lang_login_invalid_credentials":"Nom d\u2019utilisateur/Mot de passe incorrect","lang_login_password":"Mot de passe","lang_login_username":"Identifiant","lang_login":"Connexion","lang_more":"Plus","lang_no_entries":"Aucun article \xe0 consulter","lang_source_refresh":"Rafra\xeechir cette source","lang_source_last_post":"Dernier \xe9l\xe9ment vu","lang_source_saved":"Enregistr\xe9","lang_source_cancel":"Annuler","lang_source_save":"Enregistrer","lang_source_type":"Type","lang_source_select":"Veuillez s\xe9lectionner une source","lang_source_comma":"S\xe9par\xe9s par une virgule","lang_source_pwd_placeholder":"Mot de passe inchang\xe9","lang_source_tags":"\xc9tiquettes","lang_source_autotitle_hint":"Laisser vide pour r\xe9cup\xe9rer le titre","lang_source_title":"Titre","lang_source_new":"Nouvelle source non sauvegard\xe9e","lang_source_delete":"Supprimer","lang_source_filter":"Filtre","lang_source_edit":"Modifier","lang_source_export":"Exporter les sources","lang_source_opml":"ou importer un fichier OPML ou Google Reader","lang_source_add":"Ajouter une source","lang_loginbutton":"Se connecter","lang_logoutbutton":"Se d\xe9connecter","lang_settingsbutton":"Param\xe8tres","lang_refreshbutton":"Actualiser les sources","lang_searchremove":"Masquer le champ de recherche","lang_searchbutton":"Rechercher","lang_next":"Suivant","lang_open_window":"Ouvrir","lang_load_img":"Afficher les images","lang_unmark":"Marquer comme non lu","lang_mark":"Marquer comme lu","lang_unstar":"Supprimer des favoris","lang_star":"Ajouter aux favoris","lang_days":"{0,plural,zero {aujourd\u2019hui},one {hier},other {il y a # jours}}","lang_seconds":"il y a {0,plural,one {1 seconde},other {# secondes}}","lang_minutes":"il y a {0,plural,one {1 minute},other {# minutes}}","lang_hours":"il y a {0,plural,one {1 heure},other {# heures}}","lang_alltags":"Toutes les \xe9tiquettes","lang_tags":"\xc9tiquettes","lang_offline_count":"En local","lang_online_count":"Sur le serveur","lang_starred":"Favoris","lang_unread":"Non lu","lang_newest":"Le plus r\xe9cent","lang_filter":"Filtrer","lang_markread":"Marquer comme lu","lang_error_offline_storage_not_available":"Le stockage hors ligne n\u2019est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l\u2019API IndexedDB{1} et, si vous utilisez un navigateur bas\xe9 sur Google Chrome, que vous n\u2019ex\xe9cutez pas selfoss en mode de navigation priv\xe9e.","lang_error_edit_source":"Impossible d\'enregistrer les modifications de la source :","lang_error_unwritable_logs":"Impossible d\'\xe9crire les fichiers de journalisation.","lang_error_check_system_logs":"Une erreur est survenue. Veuillez consulter votre journalisation syst\xe8me.","lang_error_check_log_file":"Une erreur est survenue. Veuillez consulter le fichier \xab {0}\xa0\xbb.","lang_offline_navigation_unavailable":"Modifier les \xe9tiquettes et les sources n\'est pas possible hors ligne pour le moment."}');


var $5842b3cf59e511d5$exports = {};
$5842b3cf59e511d5$exports = JSON.parse('{"lang_tags":"Etiquetas","lang_days":"{0,plural,zero {hoxe},one {onte},other {fai # d\xedas}}","lang_unmark":"Marcar como non lido","lang_share_pocket_label":"Gardar en Pocket","lang_no_entries":"Non se atoparon rexistros","lang_more":"M\xe1is","lang_filter":"Filtro","lang_online_count":"Elementos dispo\xf1ibles no servidor","lang_offline_count":"Elementos dispo\xf1ibles localmente","lang_timestamp":"{0,date} {0,time}","lang_hours":"fai {0,plural,one {1 hora},other {# horas}}","lang_minutes":"fai {0,plural,one {1 minuto},other {# minutos}}","lang_seconds":"fai {0,plural,one {1 segundo},other {# segundos}}","lang_share_wallabag_label":"Gardar en Wallabag","lang_share_wordpress_label":"Compartir en WordPress","lang_share_mail_label":"Compartir por email","lang_share_copy_label":"Copiar ligaz\xf3n o portapap\xe9is","lang_search_label":"Buscar termo","lang_searchbutton":"Procurar","lang_searchremove":"Agochar b\xfasqueda","lang_refreshbutton":"Actualizar as fontes","lang_settingsbutton":"Configuraci\xf3n","lang_logoutbutton":"Fechar a sesi\xf3n","lang_loginbutton":"Iniciar sesi\xf3n","lang_sources":"Fontes","lang_sources_loading":"Cargando as fontes\u2026","lang_no_sources":"Non hai fontes configuradas.","lang_source_add":"Engadir fonte","lang_source_opml":"ou importa dende un ficheiro OPML","lang_source_export":"Exportar fontes","lang_source_edit":"Editar","lang_source_filter":"Filtro","lang_source_menu":"M\xe1is acci\xf3ns","lang_source_browse":"Navegar","lang_source_delete":"Borrar","lang_source_warn":"Realmente queres borrar esta fonte?","lang_source_deleting":"Borrando a fonte\u2026","lang_source_warn_cancel_dirty":"Queres descargar os cambios non gardados?","lang_source_new":"Nova fonte sen gardar","lang_source_title":"T\xedtulo","lang_source_autotitle_hint":"Deixar en branco pra obter t\xedtulo","lang_source_type":"Tipo","lang_source_save":"Gardar","lang_source_cancel":"Cancelar","lang_source_saving":"Gardando cambios da fonte\u2026","lang_source_last_post":"\xdaltima entrada vista","lang_error_session_expired":"A sesi\xf3n expirou","lang_error_add_source":"Non se puido engadira a fonte:","lang_error_edit_source":"Non se puideron gardar os cambios as fontes:","lang_error_delete_source":"Erro borrando a fonte:","lang_error_load_tags":"Non se puideron cargar as etiquetas:","lang_error_unknown_tag":"Etiqueta desco\xf1ecida:","lang_error_unknown_source":"Id de fonte desco\xf1ecida:","lang_error_mark_items":"Non se puideron marcar todos os elementos visib\xe9is:","lang_error_mark_item":"Non se puido marcar/desmarcar elemento:","lang_error_star_item":"Non se puido marcar/desmarcar a estrela no elemento:","lang_error_logout":"Non se puido fechar a sesi\xf3n:","lang_error_loading":"Error cargando:","lang_error_loading_stats":"Non se puideron cargar as estat\xedsticas de navegaci\xf3n:","lang_error_saving_color":"Non se puido cargar a nova cor:","lang_error_refreshing_source":"Non se puideron refrescar as fontes:","lang_error_sync":"Non se puideron sincronizar os \xfaltimos cambios do servidor:","lang_error_offline_storage":"Error do almacenamento fora de li\xf1a: {0}. Recargar pode axudar. Desactivando uso fora de li\xf1a polo momento.","lang_share_twitter_label":"Compartir en Twitter","lang_error_offline_storage_not_available":"Almacenamento fora de li\xf1a non dispo\xf1\xedbel. Asegurase de que o seu navegador {0} soporta IndexedDB API{1} e, se est\xe1 utilizando un navegador baseado en Google Chrome, que non est\xe9 usando selfoss en modo inc\xf3gnito.","lang_error_invalid_subsection":"Subsecci\xf3n inv\xe1lida:","lang_error_configuration":"Non se puido cargar a configuraci\xf3n.","lang_error_share_native_abort":"Non se puido compartir o elemento, non tes onde compartilo ou cancel\xe1chelo.","lang_error_share_native":"Non se puido compartir o elemento.","lang_info_url_copied":"Copiouse a URL o portapap\xe9is.","lang_close_entry":"Fechar","lang_article_actions":"Acci\xf3ns","lang_article_reading_time":"{0} min lectura","lang_unread":"Non lidos","lang_offline_navigation_unavailable":"Cambiar etiquetas e fontes non est\xe1 dispo\xf1ible no modo fora de li\xf1a.","lang_source_go_to_settings":"Abrir a configuraci\xf3n","lang_login_in_progress":"Intentando iniciar sesi\xf3n\u2026","lang_markread":"Marcar como lido","lang_newest":"Novos","lang_alltags":"Todas as etiquetas","lang_source_saved":"Gardado","lang_source_refresh":"Actualizar esta fonte","lang_tag_change_color_button_title":"Cambiar a cor","lang_login":"Iniciar sesi\xf3n","lang_login_password":"Contrasinal","lang_sources_refreshed":"Actualizaronse as fontes","lang_star":"Marcar con estrela","lang_starred":"Con estrela","lang_unstar":"Quitar a estrela","lang_next":"Seguinte","lang_share_native_label":"Compartir","lang_share_diaspora_label":"Compartir en Diaspora","lang_share_facebook_label":"Compartir en Facebook","lang_source_comma":"Separado por comas","lang_mark":"Marcar como lido","lang_open_window":"Abrir","lang_load_img":"Cargar imaxes","lang_login_invalid_credentials":"Usuario/contrasinal incorrectos","lang_source_tags":"Etiquetas","lang_source_select":"Por favor, escolle unha fonte","lang_source_pwd_placeholder":"Non cambiou","lang_source_params_loading":"Estanse cargando os par\xe1metros\u2026","lang_sources_leaving_unsaved_prompt":"Queres deixar a configuraci\xf3n con cambios de fonte non gardados?","lang_login_username":"Usuario","lang_entries_loading":"Estanse cargando as entradas\u2026","lang_login_offline":"Almacenamento fora de li\xf1a","lang_error":"Ocurriu un erro","lang_error_check_system_logs":"Ocurriu un erro, por favor comproba os rexistros do sistema.","lang_error_unwritable_logs":"Non se puideron escribir os rexistros.","lang_no_title":"Sen t\xedtulo","lang_experimental":"Experimental","lang_error_check_log_file":"Produciuse un erro, por favor comproba o ficheiro de rexistro \\"{0}\\".","lang_streamerror":"Non hai elementos cargados, recargar?","lang_reload_list":"Recargar lista","lang_app_update":"Selfoss actualizouse, recargue","lang_app_reload":"Recargar","lang_error_unauthorized":"{link_begin}inicia sesi\xf3n{link_end} para continuar.","lang_login_error_generic":"Non se puido iniciar sesi\xf3n: {errorMessage}","lang_share_mastodon_label":"Comparte en Mastodon"}');


var $785c4eb045100ebe$exports = {};
$785c4eb045100ebe$exports = JSON.parse('{"lang_error_offline_storage_not_available":"\u05D4\u05D0\u05D7\u05E1\u05D5\u05DF \u05D4\u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF \u05D0\u05D9\u05E0\u05D5 \u05D6\u05DE\u05D9\u05DF. \u05E0\u05D0 \u05DC\u05D5\u05D5\u05D3\u05D0 \u05E9\u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DC\u05DA {0}\u05EA\u05D5\u05DE\u05DA \u05D1\u05BEAPI \u05DE\u05E1\u05D5\u05D2 IndexedDB{1} \u05D5\u05D2\u05DD, \u05D0\u05DD \u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DE\u05E9\u05DE\u05E9 \u05D0\u05D5\u05EA\u05DA \u05DE\u05D1\u05D5\u05E1\u05E1 Google Chrome, \u05E9\u05D6\u05D0\u05EA \u05D0\u05D9\u05E0\u05D4 \u05D2\u05DC\u05D9\u05E9\u05D4 \u05D1\u05E1\u05EA\u05E8.","lang_error_invalid_subsection":"\u05EA\u05EA\u05BE\u05E1\u05E2\u05D9\u05E3 \u05E9\u05D2\u05D5\u05D9:","lang_error_offline_storage":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05D0\u05D7\u05E1\u05D5\u05DF \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF: {0}. \u05D0\u05D5\u05DC\u05D9 \u05E8\u05E2\u05E0\u05D5\u05DF \u05D9\u05E2\u05D6\u05D5\u05E8. \u05D4\u05DE\u05E6\u05D1 \u05D4\u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF \u05DE\u05D5\u05E9\u05D1\u05EA \u05DB\u05E8\u05D2\u05E2.","lang_error_share_native_abort":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05EA\u05E3 \u05E4\u05E8\u05D9\u05D8 - \u05D0\u05D5 \u05E9\u05D0\u05D9\u05DF \u05D9\u05E2\u05D3 \u05DC\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D0\u05D5 \u05E9\u05D1\u05D9\u05D8\u05DC\u05EA.","lang_error_configuration":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05D4\u05D2\u05D3\u05E8\u05D5\u05EA.","lang_error_share_native":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05EA\u05E3 \u05E4\u05E8\u05D9\u05D8.","lang_article_actions":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA","lang_close_entry":"\u05E1\u05D2\u05D9\u05E8\u05D4","lang_info_url_copied":"\u05D4\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D5\u05E2\u05EA\u05E7\u05D4 \u05DC\u05DC\u05D5\u05D7 \u05D4\u05D2\u05D6\u05D9\u05E8\u05D9\u05DD.","lang_error_sync":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05E0\u05DB\u05E8\u05DF \u05D0\u05EA \u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D9\u05DD \u05DE\u05D4\u05E9\u05E8\u05EA:","lang_error_refreshing_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E8\u05E2\u05E0\u05DF \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA:","lang_error_saving_color":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DE\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05D7\u05D3\u05E9:","lang_error_loading_stats":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05E1\u05D8\u05D8\u05D9\u05E1\u05D8\u05D9\u05E7\u05EA \u05E0\u05D9\u05D5\u05D5\u05D8:","lang_error_loading":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05D8\u05E2\u05D9\u05E0\u05D4:","lang_error_logout":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E6\u05D0\u05EA:","lang_error_star_item":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1/\u05DC\u05D1\u05D8\u05DC \u05DB\u05D5\u05DB\u05D1 \u05E9\u05DC \u05E4\u05E8\u05D9\u05D8:","lang_error_mark_item":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF/\u05DC\u05D1\u05D8\u05DC \u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05DC \u05E4\u05E8\u05D9\u05D8:","lang_error_mark_items":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF \u05D0\u05EA \u05DB\u05DC \u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D4\u05D2\u05DC\u05D5\u05D9\u05D9\u05DD:","lang_error_unknown_source":"\u05DE\u05D6\u05D4\u05D4 \u05D4\u05DE\u05E7\u05D5\u05E8 \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2:","lang_error_unknown_tag":"\u05EA\u05D2\u05D9\u05EA \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2\u05D4:","lang_error_load_tags":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05EA\u05D2\u05D9\u05D5\u05EA:","lang_error_delete_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DE\u05D7\u05D5\u05E7 \u05DE\u05E7\u05D5\u05E8:","lang_error_edit_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DE\u05D5\u05E8 \u05D0\u05EA \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9 \u05D4\u05DE\u05E7\u05D5\u05E8:","lang_error_add_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05DE\u05E7\u05D5\u05E8:","lang_error_session_expired":"\u05EA\u05D5\u05E7\u05E3 \u05D4\u05D4\u05E4\u05E2\u05DC\u05D4 \u05E4\u05D2","lang_app_reload":"\u05E8\u05E2\u05E0\u05D5\u05DF","lang_app_update":"selfoss \u05D4\u05EA\u05E2\u05D3\u05DB\u05DF, \u05E0\u05D0 \u05DC\u05E8\u05E2\u05E0\u05DF","lang_sources_refreshed":"\u05D4\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05D4\u05EA\u05E8\u05E2\u05E0\u05E0\u05D5","lang_reload_list":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05E8\u05E9\u05D9\u05DE\u05D4","lang_streamerror":"\u05DC\u05D0 \u05E0\u05D8\u05E2\u05E0\u05D5 \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD, \u05DC\u05E8\u05E2\u05E0\u05DF?","lang_error_unwritable_logs":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DB\u05EA\u05D5\u05D1 \u05D9\u05D5\u05DE\u05E0\u05D9\u05DD.","lang_error_check_system_logs":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4, \u05E0\u05D0 \u05DC\u05E2\u05D9\u05D9\u05DF \u05D1\u05D9\u05D5\u05DE\u05E0\u05D9 \u05D4\u05DE\u05E2\u05E8\u05DB\u05EA \u05E9\u05DC\u05DA.","lang_error_check_log_file":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4, \u05E0\u05D0 \u05DC\u05E2\u05D9\u05D9\u05DF \u05D1\u05E7\u05D5\u05D1\u05E5 \u05D4\u05D9\u05D5\u05DE\u05DF \u201E{0}\u201D.","lang_error":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4","lang_no_title":"\u05D0\u05D9\u05DF \u05DB\u05D5\u05EA\u05E8\u05EA","lang_login_offline":"\u05D0\u05D7\u05E1\u05D5\u05DF \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF","lang_login_invalid_credentials":"\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9/\u05E1\u05E1\u05DE\u05D4 \u05E9\u05D2\u05D5\u05D9\u05D9\u05DD","lang_login_password":"\u05E1\u05E1\u05DE\u05D4","lang_login_username":"\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9","lang_login":"\u05DB\u05E0\u05D9\u05E1\u05D4","lang_more":"\u05E2\u05D5\u05D3","lang_no_entries":"\u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0\u05D5 \u05E8\u05E9\u05D5\u05DE\u05D5\u05EA","lang_source_refresh":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05D0\u05EA \u05D4\u05DE\u05E7\u05D5\u05E8 \u05D4\u05D6\u05D4","lang_source_last_post":"\u05D4\u05E8\u05E9\u05D5\u05DE\u05D4 \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D4 \u05E9\u05E0\u05E8\u05D0\u05EA\u05D4","lang_source_saved":"\u05E0\u05E9\u05DE\u05E8","lang_source_cancel":"\u05D1\u05D9\u05D8\u05D5\u05DC","lang_source_save":"\u05E9\u05DE\u05D9\u05E8\u05D4","lang_source_type":"\u05E1\u05D5\u05D2","lang_source_select":"\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DE\u05E7\u05D5\u05E8","lang_source_comma":"\u05E2\u05DD \u05D4\u05E4\u05E8\u05D3\u05D4 \u05D1\u05E4\u05E1\u05D9\u05E7\u05D9\u05DD","lang_source_pwd_placeholder":"\u05DC\u05D0 \u05D4\u05E9\u05EA\u05E0\u05D4","lang_source_tags":"\u05EA\u05D2\u05D9\u05D5\u05EA","lang_source_autotitle_hint":"\u05D9\u05E9 \u05DC\u05D4\u05E9\u05D0\u05D9\u05E8 \u05E8\u05D9\u05E7 \u05DB\u05D3\u05D9 \u05DC\u05E7\u05D1\u05DC \u05D0\u05EA \u05D4\u05DB\u05D5\u05EA\u05E8\u05EA","lang_source_title":"\u05DB\u05D5\u05EA\u05E8\u05EA","lang_source_new":"\u05DE\u05E7\u05D5\u05E8 \u05D7\u05D3\u05E9 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8","lang_source_warn":"\u05DC\u05DE\u05D7\u05D5\u05E7 \u05D0\u05EA \u05D4\u05DE\u05E7\u05D5\u05E8 \u05D4\u05D6\u05D4?","lang_source_delete":"\u05DE\u05D7\u05D9\u05E7\u05D4","lang_source_filter":"\u05DE\u05E1\u05E0\u05DF","lang_source_edit":"\u05E2\u05E8\u05D9\u05DB\u05D4","lang_source_export":"\u05D9\u05D9\u05E6\u05D5\u05D0 \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","lang_source_opml":"\u05D0\u05D5 \u05DC\u05D9\u05D9\u05D1\u05D0 \u05E7\u05D5\u05D1\u05E5 OPML","lang_source_add":"\u05D4\u05D5\u05E1\u05E4\u05EA \u05DE\u05E7\u05D5\u05E8","lang_sources":"\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","lang_loginbutton":"\u05DB\u05E0\u05D9\u05E1\u05D4","lang_logoutbutton":"\u05D9\u05E6\u05D9\u05D0\u05D4","lang_settingsbutton":"\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA","lang_refreshbutton":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","lang_searchremove":"\u05D4\u05E1\u05EA\u05E8\u05EA \u05D7\u05D9\u05E4\u05D5\u05E9","lang_searchbutton":"\u05D7\u05D9\u05E4\u05D5\u05E9","lang_search_label":"\u05D1\u05D9\u05D8\u05D5\u05D9 \u05DC\u05D7\u05D9\u05E4\u05D5\u05E9","lang_share_copy_label":"\u05D4\u05E2\u05EA\u05E7\u05EA \u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05DC\u05D5\u05D7 \u05D2\u05D6\u05D9\u05E8\u05D9\u05DD","lang_share_mail_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D3\u05D5\u05D0\u05F4\u05DC","lang_share_wordpress_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D5\u05D5\u05E8\u05D3\u05E4\u05E8\u05E1","lang_share_wallabag_label":"\u05E9\u05DE\u05D9\u05E8\u05D4 \u05D1\u05BEWallabag","lang_share_pocket_label":"\u05E9\u05DE\u05D9\u05E8\u05D4 \u05D1\u05BEPocket","lang_share_facebook_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05E4\u05D9\u05D9\u05E1\u05D1\u05D5\u05E7","lang_share_twitter_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D8\u05D5\u05D5\u05D9\u05D8\u05E8","lang_share_diaspora_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05BEDiaspora","lang_share_native_label":"\u05E9\u05D9\u05EA\u05D5\u05E3","lang_next":"\u05D4\u05D1\u05D0","lang_open_window":"\u05E4\u05EA\u05D9\u05D7\u05D4","lang_load_img":"\u05D4\u05E6\u05D2\u05EA \u05EA\u05DE\u05D5\u05E0\u05D5\u05EA","lang_unmark":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05DC\u05D0 \u05E0\u05E7\u05E8\u05D0","lang_mark":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05E0\u05E7\u05E8\u05D0","lang_unstar":"\u05D1\u05D9\u05D8\u05D5\u05DC \u05DB\u05D5\u05DB\u05D1","lang_star":"\u05DC\u05E1\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1","lang_days":"{0,plural,zero {\u05D4\u05D9\u05D5\u05DD},one {\u05D0\u05EA\u05DE\u05D5\u05DC},two {\u05E9\u05DC\u05E9\u05D5\u05DD},other {\u05DC\u05E4\u05E0\u05D9 # \u05D9\u05DE\u05D9\u05DD}}","lang_seconds":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05E9\u05E0\u05D9\u05D9\u05D4},other {# \u05E9\u05E0\u05D9\u05D5\u05EA}}","lang_minutes":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05D3\u05E7\u05D4},other {# \u05D3\u05E7\u05D5\u05EA}}","lang_hours":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05E9\u05E2\u05D4},two {\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD},other {# \u05E9\u05E2\u05D5\u05EA}}","lang_timestamp":"\u200E{0,date} {0,time}","lang_alltags":"\u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA","lang_tags":"\u05EA\u05D2\u05D9\u05D5\u05EA","lang_offline_navigation_unavailable":"\u05D4\u05D7\u05DC\u05E4\u05EA \u05EA\u05D2\u05D9\u05D5\u05EA \u05D5\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05D0\u05D9\u05E0\u05D4 \u05D6\u05DE\u05D9\u05E0\u05D4 \u05DB\u05E8\u05D2\u05E2 \u05D1\u05DE\u05E6\u05D1 \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF.","lang_offline_count":"\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05DE\u05E7\u05D5\u05DE\u05D9\u05EA","lang_online_count":"\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05D1\u05E9\u05E8\u05EA","lang_starred":"\u05DE\u05E1\u05D5\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1","lang_unread":"\u05DC\u05D0 \u05E0\u05E7\u05E8\u05D0","lang_newest":"\u05D4\u05D7\u05D3\u05E9 \u05D1\u05D9\u05D5\u05EA\u05E8","lang_filter":"\u05DE\u05E1\u05E0\u05DF","lang_markread":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05E0\u05E7\u05E8\u05D0","lang_article_reading_time":"{0} \u05D3\u05E7\u05D5\u05EA \u05E7\u05E8\u05D9\u05D0\u05D4","lang_experimental":"\u05E0\u05D9\u05E1\u05D9\u05D5\u05E0\u05D9","lang_source_warn_cancel_dirty":"\u05DC\u05D4\u05E9\u05DC\u05D9\u05DA \u05D0\u05EA \u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8\u05D5?","lang_sources_leaving_unsaved_prompt":"\u05DC\u05E6\u05D0\u05EA \u05DE\u05D4\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA \u05E2\u05DD \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05D1\u05DE\u05E7\u05D5\u05E8 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8\u05D5?","lang_source_browse":"\u05E2\u05D9\u05D5\u05DF","lang_source_menu":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA \u05E0\u05D5\u05E1\u05E4\u05D5\u05EA","lang_tag_change_color_button_title":"\u05D4\u05D7\u05DC\u05E4\u05EA \u05E6\u05D1\u05E2","lang_source_go_to_settings":"\u05E4\u05EA\u05D9\u05D7\u05D4 \u05D1\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA","lang_sources_loading":"\u05D4\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05E0\u05D8\u05E2\u05E0\u05D9\u05DD\u2026","lang_no_sources":"\u05DC\u05D0 \u05D4\u05D5\u05D2\u05D3\u05E8\u05D5 \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA.","lang_source_deleting":"\u05D4\u05DE\u05E7\u05D5\u05E8 \u05E0\u05DE\u05D7\u05E7\u2026","lang_source_params_loading":"\u05D4\u05DE\u05E9\u05EA\u05E0\u05D9\u05DD \u05E0\u05D8\u05E2\u05E0\u05D9\u05DD\u2026","lang_source_saving":"\u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05DC\u05DE\u05E7\u05D5\u05E8 \u05E0\u05E9\u05DE\u05E8\u05D9\u05DD\u2026","lang_entries_loading":"\u05D4\u05E8\u05E9\u05D5\u05DE\u05D5\u05EA \u05E0\u05D8\u05E2\u05E0\u05D5\u05EA\u2026","lang_login_in_progress":"\u05DE\u05EA\u05D1\u05E6\u05E2 \u05E0\u05D9\u05E1\u05D9\u05D5\u05DF \u05DB\u05E0\u05D9\u05E1\u05D4\u2026","lang_error_unauthorized":"\u05E0\u05D0 {link_begin}\u05DC\u05D4\u05D9\u05DB\u05E0\u05E1{link_end} \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.","lang_login_error_generic":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D9\u05DB\u05E0\u05E1: {errorMessage}","lang_share_mastodon_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05BEMastodon"}');


var $2e8fa1e1c4881081$exports = {};
$2e8fa1e1c4881081$exports = JSON.parse('{"lang_markread":"Mindet olvastam","lang_newest":"Legfrissebb","lang_unread":"Olvasatlan","lang_starred":"Megjel\xf6lt","lang_tags":"C\xedmk\xe9k","lang_alltags":"\xd6sszes c\xedmke","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \xf3r\xe1ja},other {# \xf3r\xe1ja}}","lang_minutes":"{0,plural,one {1 perce},other {# perce}}","lang_seconds":"{0,plural,one {1 m\xe1sodperce},other {# m\xe1sodperce}}","lang_star":"Megjel\xf6lt","lang_unstar":"Jel\xf6letlen","lang_mark":"Olvasott","lang_unmark":"Olvasatlan","lang_load_img":"K\xe9pbet\xf6lt\xe9s","lang_open_window":"Megnyit\xe1s","lang_searchbutton":"Keres\xe9s","lang_sources":"H\xedrforr\xe1sok","lang_source_add":"\xdaj h\xedrforr\xe1s","lang_source_opml":"OPML-f\xe1jl import\xe1l\xe1sa","lang_source_export":"H\xedrforr\xe1sok export\xe1l\xe1sa","lang_source_edit":"M\xf3dos\xedt\xe1s","lang_source_delete":"T\xf6rl\xe9s","lang_source_warn":"Biztos t\xf6r\xf6lhet\u0151 a h\xedrforr\xe1s?","lang_source_new":"\xdaj h\xedrforr\xe1s","lang_source_title":"C\xedm","lang_source_tags":"C\xedmk\xe9k","lang_source_comma":"(vessz\u0151vel tagolva)","lang_source_select":"A t\xedpus kiv\xe1laszt\xe1sa","lang_source_type":"T\xedpus","lang_source_save":"Ment\xe9s","lang_source_cancel":"M\xe9gsem","lang_source_saved":"Mentve","lang_no_entries":"Nincs megjelen\xedthet\u0151 h\xedr.","lang_more":"Tov\xe1bbiak","lang_login":"Bejelentkez\xe9s","lang_login_username":"Felhaszn\xe1l\xf3n\xe9v","lang_login_password":"Jelsz\xf3","lang_no_title":"Nincs c\xedm","lang_filter":"Sz\u0171r\u0151","lang_online_count":"A kiszolg\xe1l\xf3n l\xe9v\u0151 h\xedrek sz\xe1ma","lang_offline_count":"A helyben t\xe1rolt h\xedrek sz\xe1ma","lang_error_session_expired":"A munkamenet lej\xe1rt.","lang_app_reload":"\xdajrat\xf6lt\xe9s","lang_sources_refreshed":"Az \xfaj h\xedrek keres\xe9se k\xe9sz.","lang_reload_list":"\xdajrat\xf6lt\xe9s","lang_error_unwritable_logs":"A napl\xf3 nem \xedrhat\xf3.","lang_error":"Hiba t\xf6rt\xe9nt","lang_source_pwd_placeholder":"V\xe1ltozatlan","lang_source_filter":"Sz\u0171r\u0151","lang_loginbutton":"Bejelentkez\xe9s","lang_logoutbutton":"Kijelentkez\xe9s","lang_close_entry":"Bez\xe1r\xe1s","lang_share_native_label":"Megoszt\xe1s","lang_error_load_tags":"Nem siker\xfclt bet\xf6lteni a c\xedmk\xe9ket:","lang_searchremove":"Keres\u0151panel elrejt\xe9se","lang_next":"K\xf6vetkez\u0151","lang_app_update":"A selfoss friss\xedtve lett, \xfajra kell t\xf6lteni az oldalt.","lang_error_offline_storage":"T\xe1rol\xf3hiba kapcsolat n\xe9lk\xfcli m\xf3dban: {0}. Az \xfajrat\xf6lt\xe9s seg\xedthet. A kapcsolat n\xe9lk\xfcli m\xf3d mostant\xf3l ki van kapcsolva.","lang_error_star_item":"Nem siker\xfclt m\xf3dos\xedtani a h\xedr megjel\xf6lts\xe9g\xe9t:","lang_days":"{0,plural,zero {ma},one {tegnap},other {# napja}}","lang_share_twitter_label":"Twitter-megoszt\xe1s","lang_share_mail_label":"Megoszt\xe1s e-mailben","lang_settingsbutton":"Be\xe1ll\xedt\xe1sok","lang_sources_loading":"H\xedrforr\xe1sok bet\xf6lt\xe9se\u2026","lang_tag_change_color_button_title":"Sz\xedn cser\xe9je","lang_entries_loading":"Bet\xf6lt\xe9s\u2026","lang_login_invalid_credentials":"Hib\xe1s felhaszn\xe1l\xf3n\xe9v vagy jelsz\xf3","lang_login_error_generic":"Sikertelen bejelentkez\xe9s: {errorMessage}","lang_login_offline":"Kapcsolat n\xe9lk\xfcli t\xe1rol\xf3","lang_experimental":"K\xeds\xe9rleti funkci\xf3","lang_error_saving_color":"Nem siker\xfclt menteni az \xfaj sz\xednt:","lang_error_sync":"Nem siker\xfclt szinkroniz\xe1lni a kiszolg\xe1l\xf3val:","lang_error_configuration":"Nem siker\xfclt beolvasni a be\xe1ll\xedt\xe1sokat.","lang_error_share_native_abort":"Nem siker\xfclt megosztani a h\xedrt \u2013 vagy nincsenek megoszt\xe1si c\xe9lok, vagy a m\u0171velet t\xf6r\xf6lve lett.","lang_error_refreshing_source":"Nem siker\xfclt \xfaj h\xedreket keresni:","lang_info_url_copied":"Az URL a v\xe1g\xf3lapra lett m\xe1solva.","lang_article_actions":"M\u0171veletek","lang_article_reading_time":"~{0} perc","lang_share_diaspora_label":"Diaspora-megoszt\xe1s","lang_share_facebook_label":"Facebook-megoszt\xe1s","lang_offline_navigation_unavailable":"A c\xedmk\xe9k \xe9s h\xedrforr\xe1sok m\xf3dos\xedt\xe1sa kapcsolat n\xe9lk\xfcli m\xf3dban jelenleg nem t\xe1mogatott.","lang_source_last_post":"Legut\xf3bbi h\xedr","lang_source_refresh":"\xdaj h\xedrek keres\xe9se","lang_source_go_to_settings":"Be\xe1ll\xedt\xe1sok","lang_sources_leaving_unsaved_prompt":"Nem minden v\xe1ltoz\xe1s lett elmentve. Biztos bez\xe1rhat\xf3 be\xe1ll\xedt\xf3fel\xfclet?","lang_error_share_native":"Nem siker\xfclt megosztani a h\xedrt.","lang_share_mastodon_label":"Mastodon-megoszt\xe1s","lang_share_pocket_label":"Pocket-ment\xe9s","lang_share_wallabag_label":"Wallabag-ment\xe9s","lang_share_wordpress_label":"WordPress-megoszt\xe1s","lang_share_copy_label":"Hivatkoz\xe1s m\xe1sol\xe1sa","lang_search_label":"Keres\u0151kifejez\xe9s","lang_refreshbutton":"\xdaj h\xedrek keres\xe9se","lang_no_sources":"Nincsenek megadva h\xedrforr\xe1sok.","lang_source_menu":"Tov\xe1bbi m\u0171veletek","lang_source_browse":"Megtekint\xe9s","lang_source_deleting":"A h\xedrforr\xe1s t\xf6rl\xe9se\u2026","lang_source_warn_cancel_dirty":"Bez\xe1r\xe1s ment\xe9s n\xe9lk\xfcl?","lang_source_autotitle_hint":"\xdcresen hagyva automatikus kit\xf6lt\xe9s","lang_source_params_loading":"Param\xe9terek bet\xf6lt\xe9se\u2026","lang_source_saving":"A v\xe1ltoz\xe1sok ment\xe9se\u2026","lang_login_in_progress":"Bejelentkez\xe9s\u2026","lang_error_unauthorized":"A folytat\xe1shoz {link_begin}bejelentkez\xe9s{link_end} sz\xfcks\xe9ges.","lang_error_check_log_file":"Hiba t\xf6rt\xe9nt, r\xe9szletek a napl\xf3f\xe1jlban: \u201E{0}\u201D.","lang_error_check_system_logs":"Hiba t\xf6rt\xe9nt, r\xe9szletek a rendszernapl\xf3ban.","lang_streamerror":"Nem t\xf6lt\u0151d\xf6tt le h\xedr. \xdajrat\xf6lt\xe9s?","lang_error_add_source":"Nem siker\xfclt hozz\xe1adni a h\xedrforr\xe1st:","lang_error_edit_source":"Nem siker\xfclt menteni a h\xedrforr\xe1s v\xe1ltoz\xe1sait:","lang_error_delete_source":"Nem siker\xfclt t\xf6r\xf6lni a h\xedrforr\xe1st:","lang_error_mark_items":"Nem siker\xfclt olvasottra \xe1ll\xedtani a megjelen\xedtett h\xedreket:","lang_error_unknown_tag":"Ismeretlen c\xedmke:","lang_error_unknown_source":"Ismeretlen h\xedrforr\xe1s-azonos\xedt\xf3:","lang_error_mark_item":"Nem siker\xfclt m\xf3dos\xedtani a h\xedr olvasotts\xe1g\xe1t:","lang_error_logout":"Nem siker\xfclt kijelentkezni:","lang_error_loading":"Bet\xf6lt\xe9si hiba:","lang_error_loading_stats":"Nem siker\xfclt bet\xf6lteni a b\xf6ng\xe9sz\xe9si statisztik\xe1t:","lang_error_offline_storage_not_available":"Nem \xe1ll rendelkez\xe9sre t\xe1rol\xf3 a kapcsolat n\xe9lk\xfcli m\xf3dhoz. Ellen\u0151rizni kell, hogy a b\xf6ng\xe9sz\u0151 t\xe1mogatja-e az {0}IndexedDB API{1}-t, illetve Google Chrome alap\xfa b\xf6ng\xe9sz\u0151ben a selfoss nem haszn\xe1lhat\xf3 inkognit\xf3 m\xf3dban.","lang_error_invalid_subsection":"\xc9rv\xe9nytelen aloldal:"}');


var $21a979911d58571c$exports = {};
$21a979911d58571c$exports = JSON.parse('{"lang_timestamp":"{0,date} {0,time}","lang_article_reading_time":"bacaan {0} menit","lang_article_actions":"Tindakan","lang_close_entry":"Tutup","lang_info_url_copied":"Alamat URL disalin ke papanklip.","lang_error_share_native":"Tidak dapat membagikan item.","lang_error_share_native_abort":"Tidak dapat membagikan item\u2014kemungkinan disana tidak ada target untuk dibagikan, atau Anda membatalkan hal tersebut.","lang_error_configuration":"Tidak dapat memuat konfigurasi.","lang_error_invalid_subsection":"Subbagian tidak valid:","lang_error_offline_storage_not_available":"Penyimpanan offline tidak tersedia. Pastikan peramban web Anda {0} mendukung DB API yang Terindeks {1} dan, jika Anda menggunakan peramban web Goggle Chrome, pastikan Anda tidak menjalankan selfoss di dalam mode incognito (rahasia).","lang_error_offline_storage":"Kesalahan penyimpanan offline: {0}. Memuat ulang mungkin dapat membantu. Menonaktifkan offline untuk saat ini.","lang_error_sync":"Tidak dapat mengsinkronisasi perubahan terakhir dari server:","lang_error_refreshing_source":"Tidak dapat menyegarkan sumber:","lang_error_saving_color":"Tidak dapat menyimpan warna baru:","lang_error_loading_stats":"Tidak dapat memuat statistik navigasi:","lang_error_loading":"Kesalahan dalam memuat:","lang_error_logout":"Tidak dapat keluar:","lang_error_star_item":"Tidak dapat bintangi/batal bintangi item:","lang_error_mark_item":"Tidak dapat menandai/hapus tanda item:","lang_error_mark_items":"Tidak dapat menandai semua item yang terlihat:","lang_error_unknown_source":"ID sumber tidak diketahui:","lang_error_unknown_tag":"Tag yang tidak diketahui:","lang_error_load_tags":"Tidak dapat memuat tag:","lang_error_delete_source":"Tidak dapat menghapus sumber:","lang_error_edit_source":"Tidak dapat menyimpan perubahan sumber:","lang_error_add_source":"Tidak dapat menambahkan sumber:","lang_error_session_expired":"Sesi kadaluarsa","lang_app_reload":"Muat ulang","lang_app_update":"selfoss telah diperbarui, silahkan muat ulang","lang_sources_refreshed":"Sumber telah disegarkan","lang_reload_list":"Muat ulang daftar","lang_streamerror":"Tidak ada item yang dimuat, muat ulang?","lang_error_unwritable_logs":"Tidak dapat menulis log.","lang_error_check_system_logs":"Sebuah kesalahan terjadi, silahkan periksa log sistem Anda.","lang_error_check_log_file":"Sebuah kesalahan terjadi, silahkan periksa berkas log \\"{0}\\".","lang_error":"Sebuah kesalahan terjadi","lang_experimental":"Eksperimental","lang_no_title":"Tidak ada judul","lang_login_offline":"Penyimpanan offline","lang_login_invalid_credentials":"Nama pengguna/kata sandi salah","lang_login_password":"Kata sandi","lang_login_username":"Nama pengguna","lang_login":"Masuk","lang_more":"Lebih banyak","lang_no_entries":"Tidak ada entri ditemukan","lang_source_refresh":"Segarkan sumber ini","lang_source_last_post":"Postingan terakhir yang dilihat","lang_source_cancel":"Batal","lang_source_saved":"Disimpan","lang_source_save":"Simpan","lang_source_type":"Jenis","lang_source_select":"Silahkan pilih sumber","lang_source_comma":"Dipisahkan oleh koma","lang_source_pwd_placeholder":"Tidak diubah","lang_source_tags":"Tag","lang_source_autotitle_hint":"Biarkan kosong untuk mengambil judul","lang_source_title":"Judul","lang_source_new":"Sumber baru yang belum disimpan","lang_source_warn":"Yakin ingin menghapus sumber ini?","lang_source_delete":"Hapus","lang_source_filter":"Saring","lang_source_edit":"Sunting","lang_source_export":"Ekspor sumber","lang_source_opml":"atau import sebuah berkas OPML","lang_source_add":"Tambahkan sumber","lang_sources":"Sumber","lang_loginbutton":"Masuk","lang_logoutbutton":"Keluar","lang_settingsbutton":"Pengaturan","lang_refreshbutton":"Segarkan sumber","lang_searchremove":"Sembunyikan pencarian","lang_searchbutton":"Cari","lang_search_label":"Cari istilah","lang_share_copy_label":"Salin tautan ke papanklip","lang_share_mail_label":"Bagikan menggunakan email","lang_share_wordpress_label":"Bagikan di WordPress","lang_share_wallabag_label":"Simpan ke Wallabag","lang_share_pocket_label":"Simpan ke Pocket","lang_share_facebook_label":"Bagikan di Facebook","lang_share_twitter_label":"Bagikan di Twitter","lang_share_diaspora_label":"Bagikan di Diaspora","lang_share_native_label":"Bagikan","lang_load_img":"Tampilkan gambar","lang_open_window":"Buka","lang_next":"Selanjutnya","lang_unmark":"Tandai sebagai belum dibaca","lang_mark":"Tandai sebagai telah dibaca","lang_unstar":"Batal Bintangi","lang_star":"Bintangi","lang_days":"{0,plural,zero {today},satu {yesterday},lainnya {# days ago}}","lang_seconds":"{0,plural,one {1 second},lainnya {# seconds}} lalu","lang_minutes":"{0,plural,one {1 minute},lainnya {# minutes}} lalu","lang_hours":"{0,plural,one {1 hour},lainnya {# hours}} lalu","lang_alltags":"Semua tag","lang_tags":"Tag","lang_offline_navigation_unavailable":"Menukar tag dan sumber saat ini tidak tersedia dalam mode offline.","lang_offline_count":"Item tersedia secara lokal","lang_online_count":"Item tersedia di server","lang_starred":"Dilihat","lang_unread":"Belum Dibaca","lang_newest":"Terbaru","lang_filter":"Saring","lang_markread":"Tandai sebagai telah dibaca","lang_entries_loading":"Memuat entri\u2026","lang_source_deleting":"Menghapus sumber\u2026","lang_source_saving":"Menyimpan perubahan sumber\u2026","lang_sources_leaving_unsaved_prompt":"Tinggalkan setelan dengan perubahan sumber yang belum disimpan?","lang_source_go_to_settings":"Buka pengaturan","lang_source_menu":"Tindakan lainnya","lang_login_in_progress":"Mencoba masuk\u2026","lang_source_browse":"Telusuri","lang_login_error_generic":"Tidak bisa masuk: {errorMessage}","lang_source_params_loading":"Memuat parameter\u2026","lang_share_mastodon_label":"Bagikan di Mastodon","lang_sources_loading":"Memuat sumber\u2026","lang_no_sources":"Tidak ada sumber yang dikonfigurasi.","lang_error_unauthorized":"Silakan {link_begin}masuk{link_end} untuk melanjutkan.","lang_source_warn_cancel_dirty":"Buang perubahan yang belum disimpan?","lang_tag_change_color_button_title":"Ubah warna"}');


var $bcc60c6870c45310$exports = {};
$bcc60c6870c45310$exports = JSON.parse('{"lang_markread":"Tutte lette","lang_newest":"Recenti","lang_unread":"Non lette","lang_starred":"Contrassegnate","lang_tags":"Etichette","lang_alltags":"Tutte le etichette","lang_timestamp":"{0,date} {0,time}","lang_days":"{0,plural,one {1 ora},other {# ore}} fa","lang_minutes":"{0,plural,one {1 minuto},other {# minuti}} fa","lang_seconds":"{0,plural,one {1 secondo},other {# secondi}} fa","lang_star":"Contrassegna","lang_unstar":"Togli contrassegno","lang_mark":"Segna come letta","lang_unmark":"Segna come non letta","lang_load_img":"Caricare le immagini","lang_open_window":"Apri","lang_searchbutton":"Ricerca","lang_sources":"Fonti","lang_source_add":"Aggiungi una fonte","lang_source_opml":"o importa un file OPML / Google reader","lang_source_export":"Esporta fonti","lang_source_edit":"modifica","lang_source_delete":"cancella","lang_source_warn":"Vuoi veramente eliminare questa fonte?","lang_source_new":"Nuova fonte","lang_source_title":"Titolo","lang_source_tags":"Etichette","lang_source_comma":"separate da una virgola","lang_source_select":"seleziona il tipo di fonte","lang_source_type":"Tipo","lang_source_save":"salva","lang_source_cancel":"annulla","lang_no_entries":"Nessuna pubblicazione","lang_more":"Caricare altre pubblicazioni","lang_login":"Accedi","lang_login_username":"Nome utente","lang_login_password":"Password","lang_no_title":"Senza titolo","lang_error_star_item":"Non \xe8 possibile contrassegnare/togliere il contrassegno per l\'elemento:","lang_error_mark_item":"Impossibile segnare l\'elemento come letto/non letto:","lang_article_actions":"Azioni","lang_close_entry":"Chiudi","lang_info_url_copied":"URL copiato negli appunti.","lang_error_share_native":"Impossibile condividere l\'elemento.","lang_error_share_native_abort":"Impossibile condividere l\'articolo\u202F\u2013\u202Fnon ci sono obiettivi di condivisione o l\'hai cancellato.","lang_error_configuration":"Impossibile caricare la configurazione.","lang_error_invalid_subsection":"Sottosezione non valida:","lang_error_offline_storage":"Errore di archiviazione offline: {0}. Il ricaricamento pu\xf2 aiutare. Disabilitazione la modalit\xe0 offline per ora.","lang_error_sync":"Impossibile sincronizzare le ultime modifiche dal server:","lang_error_refreshing_source":"Impossibile aggiornare le fonti:","lang_error_saving_color":"Impossibile salvare un nuovo colore:","lang_error_loading_stats":"Impossibile caricare le statistiche di navigazione:","lang_error_loading":"Errore di caricamento:","lang_error_logout":"Impossibile uscire:","lang_error_mark_items":"Impossibile contrassegnare tutti gli elementi visibili:","lang_error_unknown_source":"Identificazione della fonte sconosciuta:","lang_error_unknown_tag":"Etichetta sconosciuta:","lang_error_load_tags":"Impossibile caricare le etichette:","lang_error_delete_source":"Impossibile eliminare l\'origine:","lang_error_add_source":"Impossibile aggiungere la fonte:","lang_error_session_expired":"Sessione scaduta","lang_app_reload":"Ricarica","lang_app_update":"selfoss \xe8 stato aggiornato, si prega di ricaricare","lang_sources_refreshed":"Fonti aggiornate","lang_reload_list":"Ricarica l\'elenco","lang_streamerror":"Nessun elemento caricato, ricaricare?","lang_error":"Si \xe8 verificato un errore","lang_source_refresh":"Aggiorna questa fonte","lang_source_last_post":"Ultimo elemento visto","lang_source_saved":"Salvato","lang_source_pwd_placeholder":"Non cambiato","lang_source_autotitle_hint":"Lascia vuoto per recuperare il titolo","lang_source_filter":"Filtro","lang_loginbutton":"Accedi","lang_logoutbutton":"Esci","lang_settingsbutton":"Impostazioni","lang_refreshbutton":"Aggiorna le fonti","lang_searchremove":"Nascondi la ricerca","lang_search_label":"Termine di ricerca","lang_share_copy_label":"Copia il collegamento negli appunti","lang_share_wordpress_label":"Condividi su WordPress","lang_share_wallabag_label":"Salva in Wallabag","lang_share_pocket_label":"Salva in Pocket","lang_share_facebook_label":"Condividi su Facebook","lang_share_twitter_label":"Condividi su Twitter","lang_share_diaspora_label":"Condividi su Diaspora","lang_share_native_label":"Condividi","lang_next":"Avanti","lang_hours":"{0,plural,one {1 ora},other {# ore}} fa","lang_offline_count":"Elementi disponibili localmente","lang_online_count":"Articoli disponibili sul server","lang_filter":"Filtra","lang_share_mail_label":"Condividi via posta elettronica","lang_login_offline":"Archiviazione offline","lang_login_invalid_credentials":"Nome utente o password errato","lang_error_offline_storage_not_available":"Non \xe8 disponibile memoria offline. Assicurati che il tuo browser web {0} supporti IdexedDB API {1} e che tu non stia utilizzando la modalit\xe0 incognito su browser basati su Google Chrome.","lang_error_edit_source":"Impossibile salvare le modifiche alla fonte:","lang_error_unwritable_logs":"Impossibile scrivere i log.","lang_error_check_system_logs":"Si \xe8 verificato un errore, controlla i tuoi log di sistema.","lang_error_check_log_file":"Si \xe8 verificato un errore, controlla il file di log \xab{0}\xbb.","lang_offline_navigation_unavailable":"Al momento non \xe8 possibile modificare etichette e fonti nella modalit\xe0 fuori linea.","lang_article_reading_time":"{0} min letti","lang_experimental":"Sperimentale","lang_source_go_to_settings":"Apri nelle impostazioni","lang_sources_loading":"Caricamento delle fonti\u2026","lang_source_deleting":"Eliminazione della fonte\u2026","lang_source_browse":"Sfoglia","lang_source_params_loading":"Caricamento dei parametri\u2026","lang_no_sources":"Nessuna fonte configurata.","lang_source_warn_cancel_dirty":"Scartare le modifiche non salvate?","lang_source_menu":"Pi\xf9 azioni","lang_sources_leaving_unsaved_prompt":"Esci dalle impostazioni con delle modifiche della fonte non salvate?","lang_tag_change_color_button_title":"Cambia il colore","lang_entries_loading":"Caricamento delle pubblicazioni\u2026","lang_source_saving":"Salvataggio delle modifiche alla fonte\u2026","lang_error_unauthorized":"Per favore {link_begin} connettiti{link_end} per continuare.","lang_login_in_progress":"Tentativo di connessione\u2026","lang_login_error_generic":"Connessione impossibile: {errorMessage}"}');


var $176dd0c127d964ee$exports = {};
$176dd0c127d964ee$exports = JSON.parse('{"lang_markread":"\u65E2\u8AAD\u306B\u3059\u308B","lang_filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","lang_newest":"\u65B0\u7740","lang_unread":"\u672A\u8AAD","lang_starred":"\u30B9\u30BF\u30FC","lang_tags":"\u30BF\u30B0","lang_alltags":"\u5168\u3066\u306E\u30BF\u30B0","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u6642\u9593},other {# \u6642\u9593}}\u524D","lang_minutes":"{0,plural,one {1 \u5206},other {# \u5206}}\u524D","lang_seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","lang_days":"{0,plural,zero {\u4ECA\u65E5},one {\u6628\u65E5},other {# \u65E5\u524D}}","lang_star":"\u30B9\u30BF\u30FC\u3092\u3064\u3051\u308B","lang_unstar":"\u30B9\u30BF\u30FC\u3092\u5916\u3059","lang_mark":"\u65E2\u8AAD\u306B\u3059\u308B","lang_unmark":"\u672A\u8AAD\u306B\u3059\u308B","lang_load_img":"\u753B\u50CF\u3092\u8868\u793A","lang_open_window":"\u958B\u304F","lang_next":"\u6B21\u3078","lang_searchbutton":"\u691C\u7D22","lang_searchremove":"\u691C\u7D22\u3092\u975E\u8868\u793A","lang_refreshbutton":"\u30BD\u30FC\u30B9\u306E\u66F4\u65B0","lang_settingsbutton":"\u8A2D\u5B9A","lang_logoutbutton":"\u30ED\u30B0\u30A2\u30A6\u30C8","lang_loginbutton":"\u30ED\u30B0\u30A4\u30F3","lang_sources":"\u30BD\u30FC\u30B9","lang_source_add":"\u30BD\u30FC\u30B9\u3092\u8FFD\u52A0","lang_source_opml":"\u307E\u305F\u306F OPML \u30D5\u30A1\u30A4\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8","lang_source_export":"\u30BD\u30FC\u30B9\u3092\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8","lang_source_edit":"\u7DE8\u96C6","lang_source_filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","lang_source_delete":"\u524A\u9664","lang_source_warn":"\u3053\u306E\u30BD\u30FC\u30B9\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","lang_source_new":"\u65B0\u3057\u3044\u672A\u4FDD\u5B58\u306E\u30BD\u30FC\u30B9","lang_source_title":"\u30BF\u30A4\u30C8\u30EB","lang_source_tags":"\u30BF\u30B0","lang_source_pwd_placeholder":"\u5909\u66F4\u3055\u308C\u3066\u3044\u307E\u305B\u3093","lang_source_comma":"\u30AB\u30F3\u30DE(,)\u533A\u5207\u308A","lang_source_select":"\u30BD\u30FC\u30B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","lang_source_type":"\u30BF\u30A4\u30D7","lang_source_save":"\u4FDD\u5B58","lang_source_cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","lang_source_saved":"\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F","lang_source_last_post":"\u6700\u7D42\u53C2\u7167\u65E5","lang_source_refresh":"\u3053\u306E\u30BD\u30FC\u30B9\u3092\u66F4\u65B0","lang_no_entries":"\u8A18\u4E8B\u304C\u3042\u308A\u307E\u305B\u3093","lang_more":"\u3082\u3063\u3068\u898B\u308B","lang_login":"\u30ED\u30B0\u30A4\u30F3","lang_login_username":"\u30E6\u30FC\u30B6\u30FC\u540D","lang_login_password":"\u30D1\u30B9\u30EF\u30FC\u30C9","lang_no_title":"\u30BF\u30A4\u30C8\u30EB\u306A\u3057","lang_error":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","lang_streamerror":"\u8A18\u4E8B\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u307E\u3059\u304B\uFF1F","lang_source_autotitle_hint":"\u7A7A\u306E\u307E\u307E\u306B\u3059\u308B\u3068\u30BF\u30A4\u30C8\u30EB\u3092\u53D6\u5F97\u3057\u307E\u3059","lang_login_invalid_credentials":"\u30E6\u30FC\u30B6\u30FC\u540D/\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059","lang_reload_list":"\u4E00\u89A7\u3092\u518D\u8AAD\u307F\u8FBC\u307F","lang_sources_refreshed":"\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u3057\u307E\u3057\u305F","lang_error_session_expired":"\u30BB\u30C3\u30B7\u30E7\u30F3\u304C\u671F\u9650\u5207\u308C\u3067\u3059","lang_error_add_source":"\u30BD\u30FC\u30B9\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093:","lang_error_delete_source":"\u30BD\u30FC\u30B9\u3092\u524A\u9664\u3067\u304D\u307E\u305B\u3093:","lang_error_load_tags":"\u30BF\u30B0\u3092\u8AAD\u307F\u8FBC\u307F\u3067\u304D\u307E\u305B\u3093:","lang_error_unknown_tag":"\u4E0D\u660E\u306A\u30BF\u30B0:","lang_error_unknown_source":"\u4E0D\u660E\u306A\u30BD\u30FC\u30B9ID:","lang_error_mark_items":"\u3059\u3079\u3066\u306E\u8868\u793A\u9805\u76EE\u3092\u30DE\u30FC\u30AF\u3067\u304D\u307E\u305B\u3093:","lang_error_mark_item":"\u9805\u76EE\u3092\u30DE\u30FC\u30AF/\u30DE\u30FC\u30AF\u89E3\u9664\u3067\u304D\u307E\u305B\u3093:","lang_error_star_item":"\u9805\u76EE\u3092\u30B9\u30BF\u30FC/\u30B9\u30BF\u30FC\u89E3\u9664\u3067\u304D\u307E\u305B\u3093:","lang_error_logout":"\u30ED\u30B0\u30A2\u30A6\u30C8\u3067\u304D\u307E\u305B\u3093:","lang_error_loading":"\u8AAD\u307F\u8FBC\u307F\u30A8\u30E9\u30FC:","lang_error_loading_stats":"NAV\u7D71\u8A08\u3092\u8AAD\u307F\u8FBC\u307F\u3067\u304D\u307E\u305B\u3093:","lang_error_saving_color":"\u65B0\u3057\u3044\u8272\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093:","lang_error_refreshing_source":"\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u3067\u304D\u307E\u305B\u3093:","lang_error_sync":"\u30B5\u30FC\u30D0\u304B\u3089\u6700\u5F8C\u306E\u5909\u66F4\u3092\u540C\u671F\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F:","lang_error_invalid_subsection":"\u4E0D\u6B63\u306A\u30B5\u30D6\u30BB\u30AF\u30B7\u30E7\u30F3:","lang_online_count":"\u30B5\u30FC\u30D0\u30FC\u3067\u5229\u7528\u53EF\u80FD\u306A\u9805\u76EE","lang_offline_count":"\u30ED\u30FC\u30AB\u30EB\u3067\u5229\u7528\u53EF\u80FD\u306A\u9805\u76EE","lang_login_offline":"\u30AA\u30D5\u30E9\u30A4\u30F3 \u30B9\u30C8\u30EC\u30FC\u30B8","lang_app_update":"selfoss \u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u304F\u3060\u3055\u3044","lang_app_reload":"\u518D\u8AAD\u307F\u8FBC\u307F","lang_error_offline_storage":"\u30AA\u30D5\u30E9\u30A4\u30F3 \u30B9\u30C8\u30EC\u30FC\u30B8 \u30A8\u30E9\u30FC: {0}\u3002 \u518D\u8AAD\u307F\u8FBC\u307F\u304C\u5F79\u7ACB\u3064\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u4ECA\u306E\u3068\u3053\u308D\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u3092\u7121\u52B9\u306B\u3057\u307E\u3059\u3002","lang_search_label":"\u691C\u7D22\u6761\u4EF6","lang_article_actions":"\u30A2\u30AF\u30B7\u30E7\u30F3","lang_error_configuration":"\u8A2D\u5B9A\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3002","lang_info_url_copied":"URL\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002","lang_article_reading_time":"{0} \u5206 \u8AAD\u307F\u307E\u3057\u305F","lang_source_menu":"\u305D\u306E\u4ED6\u306E\u30A2\u30AF\u30B7\u30E7\u30F3","lang_source_browse":"\u691C\u7D22","lang_source_warn_cancel_dirty":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u3092\u7834\u68C4\u3057\u307E\u3059\u304B\uFF1F","lang_sources_leaving_unsaved_prompt":"\u30BD\u30FC\u30B9\u306E\u5909\u66F4\u3092\u4FDD\u5B58\u305B\u305A\u306B\u8A2D\u5B9A\u3092\u6B8B\u3057\u307E\u3059\u304B\uFF1F","lang_experimental":"\u8A66\u9A13\u7684","lang_error_check_system_logs":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30B7\u30B9\u30C6\u30E0\u30ED\u30B0\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lang_error_edit_source":"\u30BD\u30FC\u30B9\u306E\u5909\u66F4\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A","lang_error_share_native":"\u30A2\u30A4\u30C6\u30E0\u3092\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002","lang_error_share_native_abort":"\u30A2\u30A4\u30C6\u30E0\u3092\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u2014\u5171\u6709\u5148\u304C\u306A\u3044\u304B\u3001\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F\u3002","lang_share_pocket_label":"Pocket \u306B\u4FDD\u5B58","lang_share_twitter_label":"Twitter \u3067\u30B7\u30A7\u30A2","lang_close_entry":"\u9589\u3058\u308B","lang_share_facebook_label":"Facebook \u3067\u30B7\u30A7\u30A2","lang_offline_navigation_unavailable":"\u73FE\u5728\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u30E2\u30FC\u30C9\u3067\u306F\u30BF\u30B0\u3068\u30BD\u30FC\u30B9\u306E\u5207\u308A\u66FF\u3048\u304C\u3067\u304D\u307E\u305B\u3093\u3002","lang_share_diaspora_label":"Diaspora \u3067\u30B7\u30A7\u30A2","lang_share_wallabag_label":"Wallabag \u306B\u4FDD\u5B58","lang_share_copy_label":"\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC","lang_error_check_log_file":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30ED\u30B0\u30D5\u30A1\u30A4\u30EB\u300C{0}\u300D\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lang_error_unwritable_logs":"\u30ED\u30B0\u3092\u66F8\u304D\u8FBC\u3081\u307E\u305B\u3093\u3002","lang_share_mail_label":"\u30E1\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u5171\u6709","lang_share_native_label":"\u5171\u6709","lang_share_wordpress_label":"WordPress \u3067\u30B7\u30A7\u30A2","lang_error_offline_storage_not_available":"\u30AA\u30D5\u30E9\u30A4\u30F3\u30B9\u30C8\u30EC\u30FC\u30B8\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002 Web\u30D6\u30E9\u30A6\u30B6 {0} \u304CIndexedDBAPI {1} \u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u308B\u3053\u3068\u3001\u304A\u3088\u3073 Google Chrome \u30D9\u30FC\u30B9\u306E\u30D6\u30E9\u30A6\u30B6\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u30E2\u30FC\u30C9\u3067 selfoss \u3092\u5B9F\u884C\u3057\u3066\u3044\u306A\u3044\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lang_share_mastodon_label":"Mastodon \u3067\u30B7\u30A7\u30A2"}');


var $96d4cdcff3e97d75$exports = {};
$96d4cdcff3e97d75$exports = JSON.parse('{"lang_markread":"atz\u012Bm\u0113t k\u0101 izlas\u012Btu","lang_filter":"filtrs","lang_newest":"jaun\u0101kais","lang_unread":"neizlas\u012Bts","lang_starred":"ar zvaigzn\u012Bt\u0113m","lang_tags":"Birkas","lang_alltags":"visas birkas","lang_timestamp":"{0,date} {0,time}","lang_hours":"pirms {0,plural,one {1 stundas},other {# stund\u0101m}}","lang_minutes":"pirms {0,plural,one {1 min\u016Btes},other {# min\u016Bt\u0113m}}","lang_seconds":"pirms {0,plural,one {1 sekundes},other {# sekund\u0113m}}","lang_days":"{0,plural,zero {\u0161odien},one {vakardien},other {pirms # dien\u0101m}}","lang_star":"pievienot zvaigzn\u012Bti","lang_unstar":"no\u0146emt zvaigzn\u012Bti","lang_mark":"atz\u012Bm\u0113t k\u0101 izlas\u012Btu","lang_unmark":"atz\u012Bm\u0113t k\u0101 neizlas\u012Btu","lang_load_img":"iel\u0101d\u0113t bildes","lang_open_window":"atv\u0113rt","lang_next":"n\u0101kamais","lang_searchbutton":"mekl\u0113t","lang_searchremove":"sl\u0113pt mekl\u0113\u0161anu","lang_refreshbutton":"atsvaidzin\u0101t avotus","lang_settingsbutton":"iestat\u012Bjumi","lang_logoutbutton":"iziet","lang_loginbutton":"ieiet","lang_sources":"Avoti","lang_source_add":"pievienot avotu","lang_source_opml":"vai import\u0113t opml failu, vai google las\u012Bt\u0101ju","lang_source_export":"eksport\u0113t avotus","lang_source_edit":"labot","lang_source_filter":"Filtrs","lang_source_delete":"dz\u0113st","lang_source_warn":"Vai tie\u0161\u0101m v\u0113laties dz\u0113st \u0161o avotu?","lang_source_new":"nesaglab\u0101ts avots","lang_source_title":"Nosaukums","lang_source_tags":"Birkas","lang_source_pwd_placeholder":"nav main\u012Bjies","lang_source_comma":"atdal\u012Bt ar komatu","lang_source_select":"l\u016Bdzu izv\u0113lieties avotu","lang_source_type":"Tips","lang_source_save":"saglab\u0101t","lang_source_cancel":"atcelt","lang_source_saved":"saglab\u0101ts","lang_source_last_post":"P\u0113d\u0113j\u0101 zi\u0146a redz\u0113ta","lang_no_entries":"nav ierakstu","lang_more":"v\u0113l","lang_login":"ien\u0101kt","lang_login_username":"Lietot\u0101jv\u0101rds","lang_login_password":"Parole","lang_no_title":"nav nosaukuma","lang_error":"k\u013C\u016Bda","lang_streamerror":"Zi\u0146as nav iel\u0101d\u0113tas, p\u0101rl\u0101d\u0113t?"}');


var $662f6aa9e169a442$exports = {};
$662f6aa9e169a442$exports = JSON.parse('{"lang_markread":"Marker som lest","lang_newest":"Nyeste","lang_unread":"Ulest","lang_starred":"Stjernemerket","lang_tags":"Etiketter","lang_alltags":"Alle etiketter","lang_timestamp":"{0,date} {0,time}","lang_hours":"for {0,plural,one {\xe9n time},other {# timer}} ago","lang_minutes":"for {0,plural,one {ett minutt},other {# minutter}} ago","lang_seconds":"for {0,plural,one {ett sekund},other {# sekunder}} siden","lang_star":"Stjernemerk","lang_unstar":"Fjern stjerne","lang_mark":"Marker som lest","lang_unmark":"Marker som ulest","lang_load_img":"Vis bilder","lang_open_window":"\xc5pne","lang_searchbutton":"S\xf8k","lang_sources":"Kilder","lang_source_add":"Legg til kilde","lang_source_opml":"eller importer en OPML-fil","lang_source_export":"Eksporter kilder","lang_source_edit":"Endre","lang_source_delete":"Slett","lang_source_warn":"Vil du virkelig fjerne denne kilden?","lang_source_new":"Ny ulagret kilde","lang_source_title":"Tittel","lang_source_tags":"Etiketter","lang_source_comma":"Kommainndelt","lang_source_select":"Velg kilde","lang_source_type":"Type","lang_source_save":"Lagre","lang_source_cancel":"Avbryt","lang_source_saved":"Lagret","lang_no_entries":"Ingen data funnet","lang_more":"Mer","lang_login":"Logg inn","lang_login_username":"Brukernavn","lang_login_password":"Passord","lang_filter":"Filtrer","lang_days":"{0,plural,zero {i dag},one {i g\xe5r},other {# dager siden}}","lang_next":"Neste","lang_searchremove":"Skjul s\xf8k","lang_refreshbutton":"Gjenoppfrisk kilder","lang_settingsbutton":"Innstillinger","lang_logoutbutton":"Logg ut","lang_loginbutton":"Logg inn","lang_source_filter":"Filter","lang_source_autotitle_hint":"La st\xe5 tom for \xe5 hente tittel","lang_source_pwd_placeholder":"Ikke endret","lang_source_last_post":"Siste post sett","lang_source_refresh":"Gjenoppfrisk denne kilden","lang_login_invalid_credentials":"Feil brukernavn/passord","lang_no_title":"Ingen tittel","lang_error":"En feil inntraff","lang_streamerror":"Ingen elementer ble lastet inn, gjeninnlast?","lang_reload_list":"Gjeninnlast liste","lang_sources_refreshed":"Kilder gjeninnlastet","lang_error_session_expired":"\xd8kt utl\xf8pt","lang_error_add_source":"Kunne ikke legge til kilde:","lang_error_delete_source":"Kunne ikke slette kilde:","lang_error_load_tags":"Kunne ikke laste inn etiketter:","lang_error_unknown_tag":"Ukjent etikett:","lang_error_unknown_source":"Ukjent kilde-ID:","lang_error_mark_items":"Kan ikke merke alle synlige elementer:","lang_error_mark_item":"Kan ikke merke/oppheve merking av element:","lang_error_star_item":"Kan ikke stjernemerke/oppheve stjernemerking av element:","lang_error_logout":"Kunne ikke logge ut:","lang_error_loading":"Innlastingsfeil:","lang_error_loading_stats":"Kan ikke laste navigeringsstatistikk:","lang_error_saving_color":"Kan ikke lagre ny farge:","lang_error_refreshing_source":"Kan ikke gjenoppfriske kilder:","lang_error_sync":"Kunne ikke synkronisere siste endringer fra tjener:","lang_error_invalid_subsection":"Ugyldig underdel:","lang_online_count":"Elementer tilgjengelige p\xe5 tjeneren","lang_offline_count":"Elementer tilgjengelige lokalt","lang_login_offline":"Frakoblet lagring","lang_app_update":"selfoss har blitt oppdatert, last inn p\xe5 ny","lang_app_reload":"Gjeninnlast","lang_error_offline_storage":"Lagringsfeil for frakoblet lagring: {0}. Gjeninnlasting kan hjelpe. Skrur av frakoblet imens.","lang_search_label":"S\xf8ketekst","lang_article_actions":"Handlinger","lang_error_configuration":"Kunne ikke laste inn oppsett.","lang_info_url_copied":"Nettadresse kopiert til utklippstavle.","lang_share_native_label":"Del","lang_share_diaspora_label":"Del p\xe5 Diaspora","lang_share_twitter_label":"Del p\xe5 Twitter","lang_share_facebook_label":"Del p\xe5 Facebook","lang_share_pocket_label":"Del til Pocket","lang_share_wallabag_label":"Lagre p\xe5 Wallabag","lang_share_wordpress_label":"Lagre p\xe5 WordPress","lang_share_mail_label":"Del ved bruk av e-post","lang_share_copy_label":"Kopier lenke til utklippstavle","lang_error_share_native_abort":"Kunne ikke dele element, enten finnes det ingen delingsm\xe5l, eller du har avbrutt deling.","lang_error_share_native":"Kunne ikke dele element.","lang_close_entry":"Lukk","lang_error_unwritable_logs":"Kunne ikke loggf\xf8re.","lang_error_check_log_file":"En feil inntraff, sjekk loggfilen \u201C{0}\u201D.","lang_error_check_system_logs":"En feil inntraff, sjekk systemloggene dine.","lang_offline_navigation_unavailable":"\xc5 bytte etiketter og kilder st\xf8ttes forel\xf8pig ikke i frakoblet modus.","lang_error_offline_storage_not_available":"Frakoblet lager ikke tilgjengelig. S\xf8rg for at din nettleser {0}st\xf8tter IndexedDB-API-et{1}, samt at du ikke bruker incognito-modus i en Chrome-basert nettleser.","lang_error_edit_source":"Kunne ikke lagre kildeendringer:","lang_article_reading_time":"{0} min \xe5 lese","lang_experimental":"Eksperimentell","lang_sources_leaving_unsaved_prompt":"Forlat innstillinger med ulagrede kildeendringer?","lang_source_warn_cancel_dirty":"Forkast ulagrede endringer?"}');


var $ce919b35c66c9734$exports = {};
$ce919b35c66c9734$exports = JSON.parse('{"lang_markread":"markeer gelezen","lang_newest":"nieuwste","lang_unread":"ongelezen","lang_starred":"met ster","lang_tags":"Tags","lang_alltags":"alle tags","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 hour},other {# uren}} geleden","lang_minutes":"{0,plural,one {1 minute},other {# minuten}} geleden","lang_seconds":"{0,plural,one {1 second},other {# seconden}} geleden","lang_days":"{0,plural,zero {vandaag},one {gisteren},other {# dagen geleden}}","lang_star":"ster","lang_unstar":"ster verwijderen","lang_mark":"gelezen","lang_unmark":"ongelezen","lang_load_img":"afbeeldingen tonen","lang_open_window":"open","lang_searchbutton":"zoeken","lang_sources":"Bron","lang_source_add":"bron toevoegen","lang_source_opml":"of importeer opml bestand of google reader","lang_source_export":"exporteer bronnen","lang_source_edit":"wijzig","lang_source_delete":"verwijder","lang_source_warn":"bron echt verwijderen?","lang_source_new":"nieuwe bron","lang_source_title":"Titel","lang_source_tags":"Tags","lang_source_comma":"komma gescheiden","lang_source_select":"selecteer een bron","lang_source_type":"Soort","lang_source_save":"opslaan","lang_source_cancel":"annuleren","lang_source_saved":"opgeslagen","lang_source_last_post":"Meest recente artikel is gevonden","lang_no_entries":"geen items gevonden","lang_more":"meer","lang_login":"inloggen","lang_login_username":"gebruikersnaam","lang_login_password":"wachtwoord","lang_no_title":"geen titel"}');


var $33fd991f65022a1d$exports = {};
$33fd991f65022a1d$exports = JSON.parse('{"lang_markread":"oznacz jako przeczytane","lang_filter":"filtr","lang_newest":"najnowsze","lang_unread":"nieprzeczytane","lang_starred":"z gwiazdk\u0105","lang_tags":"Tagi","lang_alltags":"wszystkie","lang_timestamp":"{0,date} {0,time}","lang_hours":"przed {0,plural,one {godzin\u0105},other {# godzinami}}","lang_minutes":"przed {0,plural,one {minut\u0105},other {# minutami}}","lang_seconds":"przed {0,plural,one {chwil\u0105},other {# sekundami}}","lang_days":"{0,plural,zero {dzisiaj},one {wczoraj},other {przejrzany # dni temu}}","lang_star":"oznacz gwiazdk\u0105","lang_unstar":"usu\u0144 gwiazdk\u0119","lang_mark":"oznacz jako przeczytane","lang_unmark":"oznacz jako nieprzeczytane","lang_load_img":"pobierz obrazy","lang_open_window":"otw\xf3rz","lang_next":"nast\u0119pny","lang_searchbutton":"szukaj","lang_searchremove":"ukryj wyszukiwanie","lang_refreshbutton":"od\u015Bwie\u017C","lang_settingsbutton":"opcje","lang_logoutbutton":"wyloguj","lang_loginbutton":"zaloguj","lang_sources":"\u0179r\xf3d\u0142a","lang_source_add":"dodaj \u017Ar\xf3d\u0142o","lang_source_opml":"lub zaimportuj plik OPML z Google Reader","lang_source_export":"eksportuj \u017Ar\xf3d\u0142a","lang_source_edit":"edytuj","lang_source_filter":"Filtr","lang_source_delete":"usu\u0144","lang_source_warn":"Czy na pewno chcesz usun\u0105\u0107 to \u017Ar\xf3d\u0142o?","lang_source_new":"nowe niezapisane \u017Ar\xf3d\u0142o","lang_source_title":"Tytu\u0142","lang_source_autotitle_hint":"Pozostaw puste, aby uzupe\u0142ni\u0107 automatycznie","lang_source_tags":"Tagi","lang_source_pwd_placeholder":"bez zmian","lang_source_comma":"rozdzielone przecinkami","lang_source_select":"prosz\u0119 wybra\u0107 typ \u017Ar\xf3d\u0142a","lang_source_type":"Typ","lang_source_save":"zapisz","lang_source_cancel":"anuluj","lang_source_saved":"zapisano","lang_source_last_post":"Ostatni artyku\u0142 zosta\u0142 przejrzany ","lang_source_refresh":"Od\u015Bwie\u017C to \u017Ar\xf3d\u0142o","lang_no_entries":"brak wpis\xf3w","lang_more":"wi\u0119cej","lang_login":"zaloguj","lang_login_username":"u\u017Cytkownik","lang_login_password":"has\u0142o","lang_login_invalid_credentials":"nieprawid\u0142owy login lub has\u0142o.","lang_no_title":"bez tytu\u0142u","lang_error":"wyst\u0105pi\u0142 b\u0142\u0105d","lang_streamerror":"Nie za\u0142adowano \u017Cadnych element\xf3w, od\u015Bwie\u017Cy\u0107?","lang_error_loading":"B\u0142\u0105d podczas \u0142adowania:","lang_experimental":"Eksperymentalny","lang_article_actions":"Dzia\u0142ania","lang_share_native_label":"Udost\u0119pnij","lang_source_browse":"Przegl\u0105daj","lang_app_reload":"Za\u0142aduj ponownie","lang_error_session_expired":"Sesja wygas\u0142a","lang_close_entry":"Zamknij","lang_sources_refreshed":"Od\u015Bwie\u017Cono \u017Ar\xf3d\u0142a","lang_error_unknown_tag":"Nieznany tag:"}');


var $239d5b3fdb03f0e7$exports = {};
$239d5b3fdb03f0e7$exports = JSON.parse('{"lang_share_mail_label":"Compartilhar usando correio eletr\xf4nico","lang_error":"um erro ocorreu","lang_no_title":"sem t\xedtulo","lang_login_password":"palavra-passe","lang_login_username":"utilizador","lang_login":"entrar","lang_more":"mais","lang_no_entries":"nenhum registo encontrado","lang_source_saved":"gravado","lang_source_cancel":"cancelar","lang_source_save":"gravar","lang_source_type":"Tipo","lang_source_select":"por favor, selecione a fonte","lang_source_comma":"separado por v\xedrgula","lang_source_tags":"Marcadores","lang_source_title":"T\xedtulo","lang_source_new":"nova fonte (n\xe3o salva)","lang_source_warn":"realmente deletar esta fonte?","lang_source_delete":"deletar","lang_source_filter":"Filtro","lang_source_edit":"editar","lang_source_export":"exportar fontes","lang_source_opml":"ou importar ficheiro opml ou google reader","lang_source_add":"adicionar fonte","lang_sources":"Fontes","lang_loginbutton":"entrar","lang_logoutbutton":"sair","lang_settingsbutton":"configura\xe7\xf5es","lang_refreshbutton":"atualizar fontes","lang_searchbutton":"procurar","lang_next":"pr\xf3ximo","lang_open_window":"abrir","lang_load_img":"carregar Imagens","lang_unmark":"marcar como n\xe3o lido","lang_mark":"marcar como lido","lang_unstar":"remover estrela","lang_star":"marcar com estrela","lang_seconds":"{0,plural,one {1 segundo},other {# segundos}} atr\xe1s","lang_minutes":"{0,plural,one {1 minuto},other {# minutos}} atr\xe1s","lang_hours":"{0,plural,one {1 hora},other {# horas}} atr\xe1s","lang_timestamp":"{0,date} {0,time}","lang_alltags":"todos os marcadores","lang_tags":"Marcadores","lang_starred":"com estrela","lang_unread":"n\xe3o lidos","lang_newest":"novos","lang_markread":"marcar como lido","lang_source_last_post":"\xdaltima postagem vista","lang_source_menu":"Mais a\xe7\xf5es","lang_offline_navigation_unavailable":"A troca de etiquetas e fontes n\xe3o est\xe1 atualmente dispon\xedvel em modo offline.","lang_offline_count":"Artigos dispon\xedveis localmente","lang_searchremove":"Ocultar busca","lang_share_diaspora_label":"Compartilhar na Di\xe1spora","lang_share_facebook_label":"Compartilhar no Facebook","lang_share_pocket_label":"Salvar no Pocket","lang_share_wallabag_label":"Salvar no Wallabag","lang_share_copy_label":"Copiar link para a \xe1rea de transfer\xeancia","lang_source_refresh":"Atualizar esta fonte","lang_share_native_label":"Compartilhar","lang_search_label":"Termo de pesquisa","lang_sources_leaving_unsaved_prompt":"Deixar configura\xe7\xf5es com altera\xe7\xf5es de fonte n\xe3o salvas?","lang_online_count":"Itens dispon\xedveis no servidor","lang_share_wordpress_label":"Compartilhar no WordPress","lang_source_autotitle_hint":"Deixe vazio para buscar t\xedtulo","lang_source_browse":"Navegar","lang_source_warn_cancel_dirty":"Descartar altera\xe7\xf5es n\xe3o salvas?","lang_filter":"Filtro","lang_share_twitter_label":"Compartilhe no Twitter","lang_tag_change_color_button_title":"Alterar a cor","lang_sources_loading":"Carregando fontes\u2026","lang_no_sources":"Nenhuma fonte configurada.","lang_source_deleting":"Excluindo fonte\u2026","lang_source_pwd_placeholder":"N\xe3o alterado","lang_source_params_loading":"Carregando par\xe2metros\u2026","lang_source_saving":"Salvar mudan\xe7as de fonte\u2026","lang_source_go_to_settings":"Abrir nas configura\xe7\xf5es","lang_entries_loading":"Carregando entradas\u2026","lang_login_in_progress":"Tentando fazer login\u2026"}');


var $0b5a97e9c325f976$exports = {};
$0b5a97e9c325f976$exports = JSON.parse('{"lang_markread":"marcar como lido","lang_newest":"novos","lang_unread":"n\xe3o lidos","lang_starred":"com estrela","lang_tags":"Marcadores","lang_alltags":"todos os marcadores","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 hora},other {# horas}} atr\xe1s","lang_minutes":"{0,plural,one {1 minuto},other {# minutos}} atr\xe1s","lang_seconds":"{0,plural,one {1 segundo},other {# segundos}} atr\xe1s","lang_star":"marcar com estrela","lang_unstar":"remover estrela","lang_mark":"marcar como lido","lang_unmark":"marcar como n\xe3o lido","lang_load_img":"carregar Imagens","lang_open_window":"abrir","lang_next":"pr\xf3ximo","lang_searchbutton":"procurar","lang_refreshbutton":"atualizar fontes","lang_settingsbutton":"configura\xe7\xf5es","lang_logoutbutton":"sair","lang_loginbutton":"entrar","lang_sources":"Fontes","lang_source_add":"adicionar fonte","lang_source_opml":"ou importar arquivo opml ou google reader","lang_source_export":"exportar fontes","lang_source_edit":"editar","lang_source_filter":"Filtro","lang_source_delete":"deletar","lang_source_warn":"realmente deletar esta fonte?","lang_source_new":"nova fonte (n\xe3o salva)","lang_source_title":"T\xedtulo","lang_source_tags":"Marcadores","lang_source_comma":"separado por v\xedrgula","lang_source_select":"por favor, selecione a fonte","lang_source_type":"Tipo","lang_source_save":"salvar","lang_source_cancel":"cancelar","lang_source_saved":"salvo","lang_no_entries":"nenhum registro encontrado","lang_more":"mais","lang_login":"entrar","lang_login_username":"usu\xe1rio","lang_login_password":"senha","lang_no_title":"sem t\xedtulo","lang_error":"um erro ocorreu","lang_share_mail_label":"Compartilhar usando correio eletr\xf4nico"}');


var $655a661d0a47f25d$exports = {};
$655a661d0a47f25d$exports = JSON.parse('{"lang_markread":"marcar sco leg\xec","lang_newest":"pli novas","lang_unread":"nunleg\xec","lang_starred":"cun staila","lang_tags":"Etichettas","lang_alltags":"tut las etichettas","lang_timestamp":"{0,date} {0,time}","lang_hours":"Avant {0,plural,one {1 ura},other {# uras}}","lang_minutes":"Avant {0,plural,one {1 minuta},other {# minutas}}","lang_seconds":"Avant {0,plural,one {1 secunda},other {# secundas}}","lang_star":"agiuntar staila","lang_unstar":"allontanar staila","lang_mark":"marcar sco leg\xec","lang_unmark":"marcar sco nunleg\xec","lang_load_img":"chargiar maletgs","lang_open_window":"avrir","lang_searchbutton":"tschertgar","lang_sources":"Funtaunas","lang_source_add":"agiuntar funtauna","lang_source_opml":"u importar ina datoteca opml u da google reader","lang_source_export":"exportar las funtaunas","lang_source_edit":"modifitgar","lang_source_delete":"stizzar","lang_source_warn":"propi stizzar questa funtauna?","lang_source_new":"nova funtauna betg memorisada","lang_source_title":"Titel","lang_source_tags":"Etichettas","lang_source_comma":"seper\xe0 entras commas","lang_source_select":"tscherna p.pl. la funtauna","lang_source_type":"Tip","lang_source_save":"memorisar","lang_source_cancel":"interrumper","lang_source_saved":"memoris\xe0","lang_no_entries":"chatt\xe0 naginas endataziuns","lang_more":"dapli","lang_login":"s\'annunziar","lang_login_username":"num d\'utilisader","lang_login_password":"pled-clav","lang_no_title":"nagin titel"}');


var $436a71a33b0f932a$exports = {};
$436a71a33b0f932a$exports = JSON.parse('{"lang_markread":"\u043F\u043E\u043C\u0435\u0442\u0438\u0442\u044C \u043A\u0430\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435","lang_newest":"\u0441\u0432\u0435\u0436\u0438\u0435","lang_unread":"\u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435","lang_starred":"\u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435","lang_tags":"\u041C\u0435\u0442\u043A\u0438","lang_alltags":"\u0432\u0441\u0435 \u043C\u0435\u0442\u043A\u0438","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u0447\u0430\u0441},other {# \u0447\u0430\u0441\u043E\u0432}} \u043D\u0430\u0437\u0430\u0434","lang_minutes":"{0,plural,one {1 \u043C\u0438\u043D\u0443\u0442\u0443},other {# \u043C\u0438\u043D\u0443\u0442}} \u043D\u0430\u0437\u0430\u0434","lang_seconds":"{0,plural,one {1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443},other {# \u0441\u0435\u043A\u0443\u043D\u0434}} \u043D\u0430\u0437\u0430\u0434","lang_star":"\u043E\u0442\u043C\u0435\u0442\u0438\u0442\u044C","lang_unstar":"\u0441\u043D\u044F\u0442\u044C \u043E\u0442\u043C\u0435\u0442\u043A\u0443","lang_mark":"\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E","lang_unmark":"\u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E","lang_load_img":"\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F","lang_open_window":"\u043E\u0442\u043A\u0440\u044B\u0442\u044C","lang_searchbutton":"\u041F\u043E\u0438\u0441\u043A","lang_sources":"\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438","lang_source_add":"\u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A","lang_source_opml":"\u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u0430\u0439\u043B OPML, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u0438\u0437 Google Reader","lang_source_export":"\u044D\u043A\u0441\u043F\u043E\u0440\u0442 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432","lang_source_edit":"\u043F\u0440\u0430\u0432\u0438\u0442\u044C","lang_source_delete":"\u0443\u0434\u0430\u043B\u0438\u0442\u044C","lang_source_warn":"\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A?","lang_source_new":"\u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A","lang_source_title":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435","lang_source_tags":"\u041C\u0435\u0442\u043A\u0438","lang_source_comma":"\u0440\u0430\u0434\u0435\u043B\u044F\u0439\u0442\u0435 \u0437\u0430\u043F\u044F\u0442\u043E\u0439","lang_source_select":"\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430","lang_source_type":"\u0422\u0438\u043F","lang_source_save":"\u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C","lang_source_cancel":"\u043E\u0442\u043C\u0435\u043D\u0430","lang_source_saved":"\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E","lang_no_entries":"\u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E","lang_more":"\u0435\u0449\u0435","lang_login":"\u0432\u0445\u043E\u0434","lang_login_username":"\u0438\u043C\u044F","lang_login_password":"\u043F\u0430\u0440\u043E\u043B\u044C","lang_no_title":"\u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F","lang_searchremove":"\u0421\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0438\u0441\u043A"}');


var $f5ba6c0d14de49b4$exports = {};
$f5ba6c0d14de49b4$exports = JSON.parse('{"lang_markread":"ozna\u010Di\u0165 ako pre\u010D\xedtan\xe9","lang_filter":"Zobrazova\u0165","lang_newest":"najnov\u0161ie","lang_unread":"nepre\u010D\xedtan\xe9","lang_starred":"ozna\u010Den\xe9","lang_tags":"Tagy","lang_alltags":"v\u0161etky tagy","lang_timestamp":"{0,date} {0,time}","lang_hours":"pred {0,plural,one {1 hodinou},other {# hodinami}}","lang_minutes":"pred {0,plural,one {1 min\xfatou},other {# min\xfatami}}","lang_seconds":"pred {0,plural,one {chv\xed\u013Eou},other {# sekundami}}","lang_star":"ozna\u010Di\u0165","lang_unstar":"odzna\u010Di\u0165","lang_mark":"ozna\u010Di\u0165 ako pre\u010D\xedtan\xe9","lang_unmark":"ozna\u010Di\u0165 ako nepr\u010D\xedtan\xe9","lang_load_img":"nahra\u0165 obr\xe1zky","lang_open_window":"otvori\u0165","lang_next":"\u010Fal\u0161ie","lang_searchbutton":"vyh\u013Eada\u0165","lang_searchremove":"skry\u0165 vyh\u013Ead\xe1vanie","lang_refreshbutton":"obnovi\u0165 zdroje","lang_settingsbutton":"nastavenia","lang_logoutbutton":"odhl\xe1si\u0165 sa","lang_loginbutton":"prihl\xe1si\u0165 sa","lang_sources":"Zdroje","lang_source_add":"prida\u0165 zdroj","lang_source_opml":"alebo nahra\u0165 opml s\xfabor","lang_source_export":"export zdrojov","lang_source_edit":"upravi\u0165","lang_source_filter":"Filter","lang_source_delete":"zmaza\u0165","lang_source_warn":"Naozaj chcete tento zdroj zmaza\u0165?","lang_source_new":"nov\xfd neulo\u017Een\xfd zdroj","lang_source_title":"N\xe1zov","lang_source_tags":"Tagy","lang_source_comma":"oddelen\xe9 \u010Diarkou","lang_source_select":"vyberte pros\xedm zdroj","lang_source_type":"Typ","lang_source_save":"ulo\u017Ei\u0165","lang_source_cancel":"zru\u0161i\u0165","lang_source_saved":"ulo\u017Een\xe9","lang_no_entries":"\u017Eiadny z\xe1znam","lang_more":"v\xedac","lang_login":"prihl\xe1si\u0165","lang_login_username":"meno","lang_login_password":"heslo","lang_no_title":"Bez titulku","lang_error":"nastala chyba"}');


var $075ee780f7474188$exports = {};
$075ee780f7474188$exports = JSON.parse('{"lang_markread":"Markera som l\xe4st","lang_newest":"Nyast","lang_unread":"Ol\xe4st","lang_starred":"Stj\xe4rnm\xe4rkt","lang_tags":"Taggar","lang_alltags":"Alla taggar","lang_timestamp":"{0,date} {0,time}","lang_hours":"f\xf6r {0,plural,one {1 timme},other {# timmar}} sedan","lang_minutes":"f\xf6r {0,plural,one {1 minut},other {# minuter}} sedan","lang_seconds":"f\xf6r {0,plural,one {1 sekund},other {# sekunder}} sedan","lang_days":"{0,plural,zero {idag},one {ig\xe5r},other {f\xf6r # dagar sedan}}","lang_star":"stj\xe4rna","lang_unstar":"utan stj\xe4rna","lang_mark":"markera som l\xe4st","lang_unmark":"markera som ol\xe4st","lang_load_img":"bilder","lang_open_window":"\xf6ppna","lang_searchbutton":"s\xf6k","lang_sources":"K\xe4lla","lang_source_add":"L\xe4gg till k\xe4lla","lang_source_opml":"eller importera fr\xe5n opml-fil eller Google Reader","lang_source_edit":"redigera","lang_source_delete":"ta bort","lang_source_warn":"Vill du verkligen ta bort denna k\xe4lla?","lang_source_new":"ny k\xe4lla","lang_source_title":"Titel","lang_source_tags":"Tagg","lang_source_comma":"kommaseparerad","lang_source_select":"v\xe4lj k\xe4lla","lang_source_type":"Typ","lang_source_save":"spara","lang_source_cancel":"avbryt","lang_source_saved":"sparad","lang_no_entries":"hittade inga inl\xe4gg","lang_more":"fler","lang_login":"Logga in","lang_login_username":"Anv\xe4ndarnamn","lang_login_password":"L\xf6senord","lang_source_last_post":"Senaste artikel visad","lang_filter":"Filter","lang_online_count":"Objekt tillg\xe4ngliga p\xe5 servern","lang_offline_count":"Objekt som \xe4r tillg\xe4ngliga lokalt","lang_next":"N\xe4sta","lang_searchremove":"D\xf6lj s\xf6k","lang_refreshbutton":"Uppdatera k\xe4llor","lang_settingsbutton":"Inst\xe4llningar","lang_logoutbutton":"Logga ut","lang_loginbutton":"Logga in","lang_source_export":"Exportera k\xe4llor","lang_source_filter":"Filter","lang_source_autotitle_hint":"L\xe4mna tomt f\xf6r att h\xe4mta titel","lang_source_pwd_placeholder":"Inte f\xf6r\xe4ndrad","lang_source_refresh":"Uppdatera den h\xe4r k\xe4llan","lang_login_invalid_credentials":"Fel anv\xe4ndarnamn/l\xf6senord","lang_login_offline":"Offline-lagring","lang_no_title":"Ingen titel","lang_error":"Ett fel uppstod","lang_streamerror":"Inga objekt laddade, ladda om?","lang_reload_list":"Ladda om listan","lang_sources_refreshed":"K\xe4llor uppdaterade","lang_app_update":"selfoss har uppdaterats, ladda om igen","lang_app_reload":"Ladda om","lang_error_session_expired":"Sessionen har g\xe5tt ut","lang_error_add_source":"Kunde inte l\xe4gga till k\xe4lla:","lang_error_delete_source":"Kunde inte ta bort k\xe4llan:","lang_error_load_tags":"Kunde inte ladda taggar:","lang_error_unknown_tag":"Ok\xe4nd tagg:","lang_error_unknown_source":"Ok\xe4nt k\xe4ll-ID:","lang_error_mark_items":"Kan inte markera alla synliga objekt:","lang_error_mark_item":"Kan inte markera/avmarkera objekt:","lang_error_star_item":"Kan inte stj\xe4rna/avstj\xe4rna objekt:","lang_error_logout":"Kunde inte logga in:","lang_error_loading":"Laddningsfel:","lang_error_loading_stats":"Kan inte ladda nav-statistik:","lang_error_saving_color":"Det g\xe5r inte att spara ny f\xe4rg:","lang_error_refreshing_source":"Kan inte uppdatera k\xe4llor:","lang_error_sync":"Kunde inte synkronisera senaste \xe4ndringarna fr\xe5n servern:","lang_error_offline_storage":"Offline-lagringsfel: {0}. Omladdning kan hj\xe4lpa. Inaktiverar offline f\xf6r tillf\xe4llet.","lang_error_invalid_subsection":"Ogiltigt underavsnitt:","lang_search_label":"S\xf6kterm","lang_article_actions":"\xc5tg\xe4rder","lang_error_configuration":"Det g\xe5r inte att ladda konfiguration.","lang_info_url_copied":"URL kopierad till urklipp.","lang_share_native_label":"Dela","lang_share_diaspora_label":"Dela p\xe5 Diaspora","lang_share_twitter_label":"Dela p\xe5 Twitter","lang_share_facebook_label":"Dela p\xe5 Facebook","lang_share_pocket_label":"Spara i Pocket","lang_share_wallabag_label":"Spara i Wallabag","lang_share_wordpress_label":"Dela p\xe5 WordPress","lang_share_mail_label":"Dela med e-post","lang_share_copy_label":"Kopiera l\xe4nk till urklipp","lang_error_share_native_abort":"Det g\xe5r inte att dela objektet - antingen finns det inga delningsm\xe5l eller s\xe5 avbr\xf6t du det.","lang_error_share_native":"Det g\xe5r inte att dela objektet.","lang_close_entry":"St\xe4ng","lang_experimental":"Experimentell","lang_error_unwritable_logs":"Det gick inte att skriva loggar.","lang_error_check_system_logs":"Ett fel uppstod. Kontrollera dina systemloggar.","lang_error_check_log_file":"Ett fel uppstod. Kontrollera loggfilen \u201C{0}\u201D.","lang_source_browse":"Bl\xe4ddra","lang_tag_change_color_button_title":"\xc4ndra f\xe4rg","lang_source_warn_cancel_dirty":"Kasta bort osparade \xe4ndringar?","lang_offline_navigation_unavailable":"Att byta taggar och k\xe4llor \xe4r f\xf6r n\xe4rvarande inte tillg\xe4ngligt i offlinel\xe4ge.","lang_sources_leaving_unsaved_prompt":"L\xe4mna inst\xe4llningar med osparade k\xe4ll\xe4ndringar?","lang_error_offline_storage_not_available":"Offlinelagring \xe4r inte tillg\xe4ngligt. Se till att din webbl\xe4sare {0}st\xf6djer IndexedDB API{1} och, om du anv\xe4nder en Google Chrome baserad webbl\xe4sare, att du inte k\xf6r selfoss i incognito l\xe4ge.","lang_error_edit_source":"Kunde inte spara k\xe4ll\xe4ndringar:","lang_source_menu":"Mer \xe5tg\xe4rder","lang_no_sources":"Inga k\xe4llor konfigurerade.","lang_source_deleting":"Raderar k\xe4lla\u2026","lang_login_error_generic":"Kunde inte logga in: {errorMessage}","lang_sources_loading":"Laddar k\xe4llor\u2026","lang_source_params_loading":"Laddar parametrar\u2026","lang_source_saving":"Sparar k\xe4ll\xe4ndringar\u2026","lang_source_go_to_settings":"\xd6ppna i inst\xe4llningar","lang_entries_loading":"L\xe4ser in poster\u2026","lang_login_in_progress":"F\xf6rs\xf6ker att logga in\u2026","lang_error_unauthorized":"V\xe4nligen {link_begin}logga in{link_end} f\xf6r att forts\xe4tta.","lang_article_reading_time":"{0}min l\xe4s","lang_share_mastodon_label":"Dela p\xe5 Mastodon"}');


var $2fdd723177d78183$exports = {};
$2fdd723177d78183$exports = JSON.parse('{"lang_markread":"Okundu olarak i\u015Faretle","lang_newest":"En yeni","lang_unread":"Okunmayan","lang_starred":"Y\u0131ld\u0131zlanan","lang_tags":"Etiketler","lang_alltags":"T\xfcm etiketler","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0, plural,other {#}} saat \xf6nce","lang_minutes":"{0, plural,other {#}} dakika \xf6nce","lang_seconds":"{0, plural,other {#}} saniye \xf6nce","lang_star":"Y\u0131ld\u0131z ekle","lang_unstar":"Y\u0131ld\u0131z kald\u0131r","lang_mark":"Okundu olarak i\u015Faretle","lang_unmark":"Okunmad\u0131 olarak i\u015Faretle","lang_load_img":"Resimleri g\xf6ster","lang_open_window":"A\xe7","lang_searchbutton":"Ara","lang_sources":"Kaynaklar","lang_source_add":"Kaynak ekle","lang_source_opml":"veya bir OPML dosyas\u0131n\u0131 i\xe7e aktar","lang_source_export":"Kaynaklar\u0131 d\u0131\u015Fa aktar","lang_source_edit":"D\xfczenle","lang_source_delete":"Sil","lang_source_warn":"Bu kaynak ger\xe7ekten silinsin mi?","lang_source_new":"Yeni kaydedilmemi\u015F kaynak","lang_source_title":"Ba\u015Fl\u0131k","lang_source_tags":"Etiketler","lang_source_comma":"Virg\xfclle ayr\u0131lm\u0131\u015F","lang_source_select":"L\xfctfen kaynak se\xe7in","lang_source_type":"T\xfcr","lang_source_save":"Kaydet","lang_source_cancel":"\u0130ptal","lang_source_saved":"Kaydedildi","lang_no_entries":"Yay\u0131n bulunmad\u0131","lang_more":"Daha fazla","lang_login":"Oturum a\xe7","lang_login_username":"Kullan\u0131c\u0131 ad\u0131","lang_login_password":"Parola","lang_no_title":"Ba\u015Fl\u0131k yok","lang_article_actions":"Eylemler","lang_close_entry":"Kapat","lang_info_url_copied":"URL panoya kopyaland\u0131.","lang_error_share_native":"\xd6ge payla\u015F\u0131lam\u0131yor.","lang_error_share_native_abort":"\xd6ge payla\u015F\u0131lam\u0131yor \u2014 ya hi\xe7 payla\u015F\u0131m hedefi yok ya da siz iptal ettiniz.","lang_error_configuration":"Yap\u0131land\u0131rma y\xfcklenemiyor.","lang_error_invalid_subsection":"Ge\xe7ersiz alt b\xf6l\xfcm:","lang_error_offline_storage_not_available":"\xc7evrim d\u0131\u015F\u0131 depolama kullan\u0131lam\u0131yor. Web taray\u0131c\u0131n\u0131z\u0131n {0}IndexedDB API\'sini{1} destekledi\u011Finden ve Google Chrome tabanl\u0131 bir taray\u0131c\u0131 kullan\u0131yorsan\u0131z selfoss\'u gizli modda \xe7al\u0131\u015Ft\u0131rmad\u0131\u011F\u0131n\u0131zdan emin olun.","lang_error_offline_storage":"\xc7evrim d\u0131\u015F\u0131 depolama hatas\u0131: {0}. Yeniden y\xfcklemek yard\u0131mc\u0131 olabilir. \xc7evrim d\u0131\u015F\u0131 \u015Fimdilik devre d\u0131\u015F\u0131 b\u0131rak\u0131l\u0131yor.","lang_error_sync":"Sunucudan son de\u011Fi\u015Fiklikler e\u015Fzamanlanamad\u0131:","lang_error_refreshing_source":"Kaynaklar yenilenemiyor:","lang_error_saving_color":"Yeni renk kaydedilemiyor:","lang_error_loading_stats":"G\xf6z atma istatistikleri y\xfcklenemiyor:","lang_error_loading":"Y\xfckleme hatas\u0131:","lang_error_logout":"Oturum kapat\u0131lamad\u0131:","lang_error_star_item":"\xd6geye y\u0131ld\u0131z eklenemiyor/y\u0131ld\u0131z\u0131 kald\u0131r\u0131lam\u0131yor:","lang_error_mark_item":"\xd6ge i\u015Faretlenemiyor/i\u015Fareti kald\u0131r\u0131lam\u0131yor:","lang_error_mark_items":"T\xfcm g\xf6r\xfcn\xfcr \xf6geler i\u015Faretlenemiyor:","lang_error_unknown_source":"Bilinmeyen kaynak kimli\u011Fi:","lang_error_unknown_tag":"Bilinmeyen etiket:","lang_error_load_tags":"Etiketler y\xfcklenemedi:","lang_error_delete_source":"Kaynak silinemedi:","lang_error_edit_source":"Kaynak de\u011Fi\u015Fiklikleri kaydedilemedi:","lang_error_add_source":"Kaynak eklenemedi:","lang_error_session_expired":"Oturumun s\xfcresi doldu","lang_app_reload":"Yeniden y\xfckle","lang_app_update":"selfoss g\xfcncellendi, l\xfctfen yeniden y\xfckleyin","lang_sources_refreshed":"Kaynaklar yenilendi","lang_reload_list":"Listeyi yeniden y\xfckle","lang_streamerror":"Hi\xe7bir \xf6ge y\xfcklenmedi, yeniden y\xfcklensin mi?","lang_error_unwritable_logs":"G\xfcnl\xfck yaz\u0131lam\u0131yor.","lang_error_check_system_logs":"Bir hata olu\u015Ftu, l\xfctfen sistem g\xfcnl\xfcklerinize bak\u0131n.","lang_error_check_log_file":"Bir hata olu\u015Ftu, l\xfctfen g\xfcnl\xfck dosyas\u0131na bak\u0131n \u201C{0}\u201D.","lang_error":"Bir hata olu\u015Ftu","lang_login_offline":"\xc7evrim d\u0131\u015F\u0131 depolama","lang_login_invalid_credentials":"Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131/parola","lang_source_refresh":"Bu kayna\u011F\u0131 yenile","lang_source_last_post":"G\xf6r\xfclen son g\xf6nderi","lang_source_pwd_placeholder":"De\u011Fi\u015Fmedi","lang_source_autotitle_hint":"Ba\u015Fl\u0131\u011F\u0131 almak i\xe7in bo\u015F b\u0131rak\u0131n","lang_source_filter":"Filtrele","lang_loginbutton":"Oturum a\xe7","lang_logoutbutton":"Oturumu kapat","lang_settingsbutton":"Ayarlar","lang_refreshbutton":"Kaynaklar\u0131 yenile","lang_searchremove":"Aramay\u0131 gizle","lang_search_label":"Arama terimi","lang_share_copy_label":"Ba\u011Flant\u0131y\u0131 panoya kopyala","lang_share_mail_label":"E-posta ile payla\u015F","lang_share_wordpress_label":"WordPress\'te payla\u015F","lang_share_wallabag_label":"Wallabag\'e kaydet","lang_share_pocket_label":"Pocket\'a kaydet","lang_share_facebook_label":"Facebook\'ta payla\u015F","lang_share_twitter_label":"Twitter\'da payla\u015F","lang_share_diaspora_label":"Diaspora\'da payla\u015F","lang_share_native_label":"Payla\u015F","lang_next":"Sonraki","lang_days":"{0,plural,zero {bug\xfcn},one {d\xfcn},other {# g\xfcn \xf6nce}}","lang_offline_navigation_unavailable":"Etiketleri ve kaynaklar\u0131 de\u011Fi\u015Ftirmek \u015Fu anda \xe7evrim d\u0131\u015F\u0131 modda kullan\u0131lam\u0131yor.","lang_offline_count":"Yerel olarak kullan\u0131labilen \xf6geler","lang_online_count":"Sunucuda bulunan \xf6geler","lang_filter":"Filtrele","lang_article_reading_time":"{0} dakika okuma","lang_experimental":"Deneysel","lang_source_warn_cancel_dirty":"Kaydedilmemi\u015F de\u011Fi\u015Fiklikler at\u0131ls\u0131n m\u0131?","lang_sources_leaving_unsaved_prompt":"Kaydedilmemi\u015F kaynak de\u011Fi\u015Fiklikleri olmas\u0131na ra\u011Fmen ayarlardan \xe7\u0131k\u0131ls\u0131n m\u0131?","lang_source_browse":"G\xf6z at","lang_source_menu":"Daha fazla eylem","lang_tag_change_color_button_title":"Rengi de\u011Fi\u015Ftir","lang_source_go_to_settings":"Ayarlarda a\xe7","lang_sources_loading":"Kaynaklar y\xfckleniyor\u2026","lang_no_sources":"Yap\u0131land\u0131r\u0131lan kaynak yok.","lang_entries_loading":"Yay\u0131nlar y\xfckleniyor\u2026","lang_source_deleting":"Kaynak siliniyor\u2026","lang_login_in_progress":"Oturum a\xe7maya \xe7al\u0131\u015F\u0131l\u0131yor\u2026","lang_source_params_loading":"Parametreler y\xfckleniyor\u2026","lang_source_saving":"Kaynak de\u011Fi\u015Fiklikleri kaydediliyor\u2026","lang_error_unauthorized":"Devam etmek i\xe7in l\xfctfen {link_begin}oturum a\xe7\u0131n{link_end}.","lang_login_error_generic":"Oturum a\xe7\u0131lamad\u0131: {errorMessage}","lang_share_mastodon_label":"Mastodon\'da payla\u015F"}');


var $d1a3f8492d1a8641$exports = {};
$d1a3f8492d1a8641$exports = JSON.parse('{"lang_markread":"\u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u044F\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0456","lang_newest":"\u043D\u043E\u0432\u0456","lang_unread":"\u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0456","lang_starred":"\u0432\u0456\u0434\u0437\u043D\u0430\u0447\u0435\u043D\u0456","lang_tags":"\u0422\u0435\u0433\u0438","lang_alltags":"\u0443\u0441\u0456 \u0442\u0435\u0433\u0438","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u0433\u043E\u0434\u0438\u043D\u0443},other {# \u0433\u043E\u0434\u0438\u043D\u0438}} \u0442\u043E\u043C\u0443","lang_minutes":"{0,plural,one {1 \u0445\u0432\u0438\u043B\u0438\u043D\u0443},other {# \u0445\u0432\u0438\u043B\u0438\u043D\u0438}} \u0442\u043E\u043C\u0443","lang_seconds":"{0,plural,one {1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443},other {# \u0441\u0435\u043A\u0443\u043D\u0434\u0438}} \u0442\u043E\u043C\u0443","lang_star":"\u0432\u0456\u0434\u0437\u043D\u0430\u0447\u0438\u0442\u0438","lang_unstar":"\u0437\u043D\u044F\u0442\u0438 \u043F\u043E\u0437\u043D\u0430\u0447\u043A\u0443","lang_mark":"\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0435","lang_unmark":"\u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0435","lang_load_img":"\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F","lang_open_window":"\u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438","lang_searchbutton":"\u043F\u043E\u0448\u0443\u043A","lang_sources":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430","lang_source_add":"\u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","lang_source_opml":"\u0430\u0431\u043E \u0456\u043C\u043F\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437 OPML \u0444\u0430\u0439\u043B\u0443","lang_source_export":"\u0435\u043A\u0441\u043F\u043E\u0440\u0442 \u0434\u0436\u0435\u0440\u0435\u043B","lang_source_edit":"\u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438","lang_source_delete":"\u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438","lang_source_warn":"\u0434\u0456\u0439\u0441\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E?","lang_source_new":"\u043D\u043E\u0432\u0435 \u043D\u0435 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","lang_source_title":"\u041D\u0430\u0437\u0432\u0430","lang_source_tags":"\u0422\u0435\u0433\u0438","lang_source_comma":"\u0440\u043E\u0437\u0456\u043B\u0435\u043D\u0456 \u043A\u043E\u043C\u043E\u044E","lang_source_select":"\u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0434\u0436\u0435\u0440\u0435\u043B\u0430","lang_source_type":"\u0422\u0438\u043F","lang_source_save":"\u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438","lang_source_cancel":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","lang_source_saved":"\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E","lang_no_entries":"\u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0430\u043F\u0438\u0441\u0456\u0432","lang_more":"\u0449\u0435","lang_login":"\u0432\u0445\u0456\u0434","lang_login_username":"\u0456\u043C\'\u044F","lang_login_password":"\u043F\u0430\u0440\u043E\u043B\u044C","lang_no_title":"\u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0438","lang_filter":"\u0424\u0456\u043B\u044C\u0442\u0440","lang_online_count":"\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0456","lang_offline_count":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E","lang_source_browse":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434","lang_share_facebook_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Facebook","lang_error_check_log_file":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0444\u0430\u0439\u043B \u0436\u0443\u0440\u043D\u0430\u043B\u0443 \\"{0}\\".","lang_error_check_system_logs":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u0436\u0443\u0440\u043D\u0430\u043B\u0438.","lang_error_unwritable_logs":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u0438\u0441\u0430\u0442\u0438 \u043B\u043E\u0433\u0438.","lang_streamerror":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u043D\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0456, \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438?","lang_error_edit_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","lang_error_mark_items":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0434\u0438\u043C\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438:","lang_error_star_item":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0430\u0431\u043E \u0437\u043D\u044F\u0442\u0438 \u0437\u0456\u0440\u043E\u0447\u043A\u0443:","lang_error_logout":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0439\u0442\u0438:","lang_error_saving_color":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u043E\u043B\u0456\u0440:","lang_error_sync":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0443\u0432\u0430\u0442\u0438 \u043E\u0441\u0442\u0430\u043D\u043D\u0456 \u0437\u043C\u0456\u043D\u0438 \u0437 \u0441\u0435\u0440\u0432\u0435\u0440\u0430:","lang_error_unknown_source":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","lang_error_load_tags":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0442\u0435\u0433\u0438:","lang_error_unknown_tag":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 \u0442\u0435\u0433:","lang_error_refreshing_source":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","lang_error_mark_item":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438/\u0437\u043D\u044F\u0442\u0438 \u0432\u0456\u0434\u043C\u0456\u0442\u043A\u0443 \u0437 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430:","lang_error_offline_storage":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432 \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u043E\u043C\u0443 \u0441\u0445\u043E\u0432\u0438\u0449\u0456: {0}. \u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438. \u041D\u0430\u0440\u0430\u0437\u0456 \u0432\u0456\u0434\u043A\u043B\u044E\u0447\u0430\u0454\u043C\u043E \u043E\u0444\u043B\u0430\u0439\u043D.","lang_days":"{0,plural,zero {\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456},one {\u0432\u0447\u043E\u0440\u0430},other {# \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443}}","lang_error_unauthorized":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, {link_begin}\u0443\u0432\u0456\u0439\u0434\u0456\u0442\u044C \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443{link_end}, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438.","lang_share_native_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F","lang_share_twitter_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0432 Twitter","lang_share_mastodon_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Mastodon","lang_source_deleting":"\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0434\u0436\u0435\u0440\u0435\u043B\u0430\u2026","lang_share_wordpress_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 WordPress","lang_share_copy_label":"\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443","lang_search_label":"\u041F\u043E\u0448\u0443\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0442","lang_share_mail_label":"\u041F\u043E\u0434\u0456\u043B\u0456\u0442\u044C\u0441\u044F \u043D\u0430 e-mail","lang_searchremove":"\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u043E\u0448\u0443\u043A","lang_logoutbutton":"\u0412\u0438\u0439\u0442\u0438","lang_settingsbutton":"\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F","lang_loginbutton":"\u0423\u0432\u0456\u0439\u0442\u0438","lang_no_sources":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430 \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u0456.","lang_source_filter":"\u0424\u0456\u043B\u044C\u0442\u0440","lang_error_loading_stats":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0439\u043D\u0443 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443:","lang_source_menu":"\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0434\u0456\u0457","lang_sources_leaving_unsaved_prompt":"\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0438\u043C\u0438 \u0437\u043C\u0456\u043D\u0430\u043C\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430?","lang_login_error_generic":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0443\u0432\u0456\u0439\u0442\u0438: {errorMessage}","lang_experimental":"\u0415\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0456","lang_tag_change_color_button_title":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043A\u043E\u043B\u0456\u0440","lang_login_in_progress":"\u0421\u043F\u0440\u043E\u0431\u0430 \u0443\u0432\u0456\u0439\u0442\u0438\u2026","lang_sources_refreshed":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0456","lang_error":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430","lang_sources_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0436\u0435\u0440\u0435\u043B\u2026","lang_login_invalid_credentials":"\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0435 \u0456\u043C\'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430/\u043F\u0430\u0440\u043E\u043B\u044C","lang_error_loading":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u0456:","lang_source_last_post":"\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u043F\u043E\u0431\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u043E\u0441\u0442","lang_refreshbutton":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430","lang_share_diaspora_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Diaspora","lang_share_wallabag_label":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0443 Wallabag","lang_next":"\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439","lang_source_saving":"\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D \u0434\u0436\u0435\u0440\u0435\u043B\u0430\u2026","lang_entries_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0438\u0441\u0456\u0432\u2026","lang_reload_list":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u043F\u0438\u0441\u043E\u043A","lang_share_pocket_label":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0432 Pocket","lang_info_url_copied":"URL \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443.","lang_offline_navigation_unavailable":"\u041F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u043D\u043D\u044F \u0442\u0435\u0433\u0456\u0432 \u0456 \u0434\u0436\u0435\u0440\u0435\u043B \u043D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u0432 \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u043E\u043C\u0443 \u0440\u0435\u0436\u0438\u043C\u0456.","lang_source_warn_cancel_dirty":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438?","lang_error_offline_storage_not_available":"\u0410\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u0435 \u0441\u0445\u043E\u0432\u0438\u0449\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435. \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0432\u0430\u0448 \u0432\u0435\u0431-\u0431\u0440\u0430\u0443\u0437\u0435\u0440 {0} \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 API IndexedDB{1} \u0456, \u044F\u043A\u0449\u043E \u0432\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454\u0442\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0430 \u0431\u0430\u0437\u0456 Google Chrome, \u0442\u043E \u0432\u0438 \u043D\u0435 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u0454\u0442\u0435 selfoss \u0432 \u0440\u0435\u0436\u0438\u043C\u0456 \u0456\u043D\u043A\u043E\u0433\u043D\u0456\u0442\u043E.","lang_error_invalid_subsection":"\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u043F\u0456\u0434\u0440\u043E\u0437\u0434\u0456\u043B:","lang_error_configuration":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044E.","lang_error_share_native_abort":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F - \u0430\u0431\u043E \u043D\u0435\u043C\u0430\u0454 \u0446\u0456\u043B\u0435\u0439, \u0430\u0431\u043E \u0432\u0438 \u0457\u0445 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u043B\u0438.","lang_error_share_native":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F.","lang_close_entry":"\u0417\u0430\u043A\u0440\u0438\u0442\u0438","lang_article_actions":"\u0414\u0456\u0457","lang_article_reading_time":"{0} \u0445\u0432 \u0447\u0438\u0442\u0430\u043D\u043D\u044F","lang_source_autotitle_hint":"\u0417\u0430\u043B\u0438\u0448\u0442\u0435 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C, \u0449\u043E\u0431 \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u043D\u0430\u0437\u0432\u0443","lang_source_pwd_placeholder":"\u0411\u0435\u0437 \u0437\u043C\u0456\u043D","lang_source_params_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u043C\u043E \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438\u2026","lang_source_refresh":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0446\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","lang_source_go_to_settings":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u0445","lang_login_offline":"\u0410\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u0435 \u0441\u0445\u043E\u0432\u0438\u0449\u0435","lang_app_update":"selfoss \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435","lang_app_reload":"\u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438","lang_error_session_expired":"\u0421\u0435\u0441\u0456\u044F \u0432\u0436\u0435 \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u043B\u0430\u0441\u044F","lang_error_add_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E:","lang_error_delete_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E:"}');


var $e7426becb1609a72$exports = {};
$e7426becb1609a72$exports = JSON.parse('{"lang_markread":"\u5168\u90E8\u6807\u8BB0\u4E3A\u5DF2\u8BFB","lang_newest":"\u6700\u65B0\u6761\u76EE","lang_unread":"\u672A\u8BFB\u6761\u76EE","lang_starred":"\u52A0\u661F\u6807\u7684\u6761\u76EE","lang_tags":"\u6807\u7B7E","lang_alltags":"\u6240\u6709\u6807\u7B7E","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u5C0F\u65F6},other {# \u5C0F\u65F6}}\u524D","lang_minutes":"{0,plural,one {1 \u5206\u949F},other {# \u5206\u949F}}\u524D","lang_seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","lang_days":"{0,plural,zero {\u4ECA\u5929},one {\u6628\u5929},other {# \u5929\u524D}}","lang_star":"\u52A0\u661F\u6807","lang_unstar":"\u53D6\u6D88\u661F\u6807","lang_mark":"\u6807\u8BB0\u4E3A\u5DF2\u8BFB","lang_unmark":"\u6807\u8BB0\u4E3A\u672A\u8BFB","lang_load_img":"\u52A0\u8F7D\u56FE\u7247","lang_open_window":"\u6253\u5F00","lang_searchbutton":"\u641C\u7D22","lang_sources":"\u6E90","lang_source_add":"\u6DFB\u52A0\u6E90","lang_source_opml":"\u6216\u5BFC\u5165 OPML \u6587\u4EF6/Google \u9605\u8BFB\u5668\u8BA2\u9605","lang_source_export":"\u5BFC\u51FA\u6E90","lang_source_edit":"\u7F16\u8F91","lang_source_delete":"\u5220\u9664","lang_source_warn":"\u786E\u8BA4\u8981\u5220\u9664\u8BE5\u6E90?","lang_source_new":"\u65B0\u7684\u6E90","lang_source_title":"\u6807\u9898","lang_source_tags":"\u6807\u7B7E","lang_source_comma":"\u4EE5\u9017\u53F7\u5206\u9694","lang_source_select":"\u8BF7\u9009\u62E9\u6E90","lang_source_type":"\u7C7B\u578B","lang_source_save":"\u4FDD\u5B58","lang_source_cancel":"\u53D6\u6D88","lang_source_saved":"\u5DF2\u4FDD\u5B58","lang_source_last_post":"\u66F4\u65B0\u4E8E","lang_no_entries":"\u6CA1\u6709\u6761\u76EE","lang_more":"\u66F4\u591A","lang_login":"\u767B\u5F55","lang_login_username":"\u7528\u6237\u540D","lang_login_password":"\u5BC6\u7801","lang_no_title":"\u65E0\u6807\u9898","lang_logoutbutton":"\u767B\u51FA","lang_loginbutton":"\u767B\u5F55","lang_error_logout":"\u4E0D\u80FD\u767B\u51FA\uFF1A","lang_settingsbutton":"\u8BBE\u7F6E","lang_app_reload":"\u518D\u542F\u52A8","lang_error_session_expired":"\u4F1A\u8BDD\u5DF2\u8FC7\u671F","lang_close_entry":"\u5173\u95ED","lang_error_sync":"\u65E0\u6CD5\u4ECE\u670D\u52A1\u5668\u540C\u6B65\u65B0\u7684\u66F4\u6539\uFF1A","lang_share_pocket_label":"\u4FDD\u5B58\u5230 Pocket","lang_searchremove":"\u9690\u85CF\u641C\u7D22","lang_error_share_native_abort":"\u65E0\u6CD5\u5206\u4EAB\u6761\u76EE - \u53EF\u80FD\u662F\u7F3A\u5C11\u5206\u4EAB\u5BF9\u8C61\u6216\u60A8\u5DF2\u53D6\u6D88\u5206\u4EAB\u3002","lang_error_mark_items":"\u65E0\u6CD5\u6807\u8BB0\u6240\u6709\u53EF\u89C1\u9879\u76EE\uFF1A","lang_share_twitter_label":"\u5206\u4EAB\u5230 Twitter","lang_share_wallabag_label":"\u4FDD\u5B58\u5230 Wallabag","lang_filter":"\u7B5B\u9009","lang_online_count":"\u670D\u52A1\u5668\u53EF\u7528\u7684\u6761\u76EE","lang_offline_navigation_unavailable":"\u79BB\u7EBF\u6A21\u5F0F\u4E0B\u6682\u65F6\u4E0D\u80FD\u5207\u6362\u6807\u7B7E\u548C\u6765\u6E90\u3002","lang_source_menu":"\u66F4\u591A\u64CD\u4F5C","lang_source_browse":"\u6D4F\u89C8","lang_offline_count":"\u672C\u5730\u53EF\u7528\u7684\u6761\u76EE","lang_next":"\u4E0B\u4E00\u4E2A","lang_share_native_label":"\u5206\u4EAB","lang_refreshbutton":"\u66F4\u65B0\u6570\u636E\u6E90","lang_share_diaspora_label":"\u5206\u4EAB\u5230 Diaspora","lang_share_wordpress_label":"\u5206\u4EAB\u5230 WordPress","lang_search_label":"\u641C\u7D22\u8BCD","lang_share_mail_label":"\u901A\u8FC7\u90AE\u4EF6\u5206\u4EAB","lang_source_warn_cancel_dirty":"\u4E22\u5F03\u672A\u4FDD\u5B58\u7684\u66F4\u6539\uFF1F","lang_share_copy_label":"\u590D\u5236\u94FE\u63A5\u5230\u526A\u5207\u677F","lang_source_filter":"\u7B5B\u9009","lang_share_facebook_label":"\u5206\u4EAB\u5230 Facebook","lang_tag_change_color_button_title":"\u66F4\u6539\u989C\u8272","lang_experimental":"\u8BD5\u9A8C\u6027\u7684","lang_login_invalid_credentials":"\u9519\u8BEF\u7684\u7528\u6237\u540D\u6216\u5BC6\u7801","lang_error_check_log_file":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u65E5\u5FD7\u6587\u4EF6 \u201C{0}\u201D\u3002","lang_login_offline":"\u79BB\u7EBF\u5B58\u50A8","lang_error_unknown_source":"\u672A\u77E5\u6765\u6E90 ID\uFF1A","lang_error_mark_item":"\u65E0\u6CD5\u6807\u8BB0\u6216\u53D6\u6D88\u6807\u8BB0\uFF1A","lang_error_star_item":"\u65E0\u6CD5\u661F\u6807\u6216\u53D6\u6D88\u661F\u6807\uFF1A","lang_error_loading":"\u52A0\u8F7D\u9519\u8BEF\uFF1A","lang_article_reading_time":"{0} \u5206\u949F\u9605\u8BFB\u65F6\u957F","lang_sources_loading":"\u6570\u636E\u6E90\u52A0\u8F7D\u4E2D\u2026","lang_no_sources":"\u6570\u636E\u6E90\u672A\u914D\u7F6E\u3002","lang_source_deleting":"\u6B63\u5728\u5220\u9664\u6570\u636E\u6E90\u2026","lang_source_autotitle_hint":"\u7559\u7A7A\u4EE5\u81EA\u52A8\u586B\u5145\u6807\u9898","lang_source_pwd_placeholder":"\u6CA1\u6709\u6539\u53D8","lang_source_params_loading":"\u6B63\u5728\u52A0\u8F7D\u53C2\u6570\u2026","lang_source_saving":"\u6B63\u5728\u4FDD\u5B58\u6570\u636E\u6E90\u66F4\u6539\u2026","lang_source_refresh":"\u5237\u65B0\u6B64\u6570\u636E\u6E90","lang_source_go_to_settings":"\u5728\u8BBE\u7F6E\u4E2D\u6253\u5F00","lang_sources_leaving_unsaved_prompt":"\u4FDD\u7559\u672A\u4FDD\u5B58\u7684\u6570\u636E\u6E90\u66F4\u6539\uFF1F","lang_entries_loading":"\u52A0\u8F7D\u6761\u76EE\u4E2D\u2026","lang_login_in_progress":"\u5C1D\u8BD5\u767B\u5F55\u4E2D\u2026","lang_error":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF","lang_error_check_system_logs":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u4F60\u7684\u7CFB\u7EDF\u65E5\u5FD7\u3002","lang_error_unwritable_logs":"\u65E0\u6CD5\u5199\u5165\u65E5\u5FD7\u3002","lang_streamerror":"\u6CA1\u6709\u52A0\u8F7D\u5230\u6761\u76EE\uFF0C\u91CD\u65B0\u52A0\u8F7D\uFF1F","lang_sources_refreshed":"\u6570\u636E\u6E90\u5DF2\u5237\u65B0","lang_app_update":"selfoss \u5DF2\u88AB\u66F4\u65B0\uFF0C\u8BF7\u91CD\u65B0\u52A0\u8F7D","lang_error_add_source":"\u65E0\u6CD5\u6DFB\u52A0\u6E90\uFF1A","lang_error_edit_source":"\u65E0\u6CD5\u4FDD\u5B58\u6E90\u66F4\u6539\uFF1A","lang_error_delete_source":"\u65E0\u6CD5\u5220\u9664\u6E90\uFF1A","lang_error_load_tags":"\u65E0\u6CD5\u52A0\u8F7D\u6807\u7B7E\uFF1A","lang_error_unknown_tag":"\u672A\u77E5\u7684\u6807\u7B7E\uFF1A","lang_error_loading_stats":"\u65E0\u6CD5\u52A0\u8F7D\u7EDF\u8BA1\u4FE1\u606F\uFF1A","lang_error_saving_color":"\u65E0\u6CD5\u4FDD\u5B58\u65B0\u989C\u8272\uFF1A","lang_error_refreshing_source":"\u65E0\u6CD5\u5237\u65B0\u6570\u636E\u6E90\uFF1A","lang_error_offline_storage":"\u79BB\u7EBF\u5B58\u50A8\u51FA\u9519\uFF1A{0} \uFF0C\u8BF7\u5C1D\u8BD5\u91CD\u65B0\u52A0\u8F7D\u3002\u79BB\u7EBF\u6A21\u5F0F\u5DF2\u88AB\u4E34\u65F6\u7981\u7528\u3002","lang_error_offline_storage_not_available":"\u79BB\u7EBF\u5B58\u50A8\u4E0D\u53EF\u7528\u3002\u786E\u4FDD\u60A8\u7684\u7F51\u7EDC\u6D4F\u89C8\u5668 {0} \u652F\u6301 IndexedDB API{1}\uFF0C\u5982\u679C\u60A8\u4F7F\u7528\u7684\u662F\u57FA\u4E8E Google Chrome \u7684\u6D4F\u89C8\u5668\uFF0C\u8BF7\u786E\u4FDD\u60A8\u6CA1\u6709\u5728\u9690\u8EAB\u6A21\u5F0F\u4E0B\u8FD0\u884C selfoss\u3002","lang_error_invalid_subsection":"\u65E0\u6548\u7684\u5C0F\u8282\uFF1A","lang_error_configuration":"\u65E0\u6CD5\u52A0\u8F7D\u914D\u7F6E\u3002","lang_info_url_copied":"URL \u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F\u3002","lang_error_share_native":"\u65E0\u6CD5\u5206\u4EAB\u6761\u76EE\u3002","lang_article_actions":"\u52A8\u4F5C","lang_reload_list":"\u91CD\u65B0\u52A0\u8F7D\u5217\u8868","lang_login_error_generic":"\u65E0\u6CD5\u767B\u5F55: {errorMessage}","lang_error_unauthorized":"\u8BF7 {link_begin}\u767B\u5F55{link_end} \u4EE5\u7EE7\u7EED\u3002"}');


var $71137174854b0ca9$exports = {};
$71137174854b0ca9$exports = JSON.parse('{"lang_markread":"\u5168\u90E8\u6A19\u8A18\u70BA\u5DF2\u8B80","lang_newest":"\u6700\u65B0\u689D\u76EE","lang_unread":"\u672A\u8B80\u689D\u76EE","lang_starred":"\u52A0\u661F\u6A19\u7684\u689D\u76EE","lang_tags":"\u6A19\u7C64","lang_alltags":"\u6240\u6709\u6A19\u7C64","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u5C0F\u6642},other {# \u5C0F\u6642}}\u524D","lang_minutes":"{0,plural,one {1 \u5206\u9418},other {# \u5206\u9418}}\u524D","lang_seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","lang_days":"{0,plural,zero {\u4ECA\u5929},one {\u6628\u5929},other {# \u5929\u524D}}","lang_star":"\u52A0\u661F\u6A19","lang_unstar":"\u53D6\u6D88\u661F\u6A19","lang_mark":"\u6A19\u8A18\u70BA\u5DF2\u8B80","lang_unmark":"\u6A19\u8A18\u70BA\u672A\u8B80","lang_load_img":"\u8F09\u5165\u5716\u7247","lang_open_window":"\u6253\u958B","lang_searchbutton":"\u641C\u7D22","lang_sources":"\u6E90","lang_source_add":"\u6DFB\u52A0\u6E90","lang_source_opml":"\u6216\u532F\u5165 OPML \u6587\u4EF6/Google \u95B1\u8B80\u5668\u8A02\u95B1","lang_source_export":"\u532F\u51FA\u6E90","lang_source_edit":"\u7DE8\u8F2F","lang_source_delete":"\u522A\u9664","lang_source_warn":"\u78BA\u8A8D\u8981\u522A\u9664\u8A72\u6E90?","lang_source_new":"\u65B0\u7684\u6E90","lang_source_title":"\u6A19\u984C","lang_source_tags":"\u6A19\u7C64","lang_source_comma":"\u4EE5\u9017\u865F\u5206\u9694","lang_source_select":"\u8ACB\u9078\u64C7\u6E90","lang_source_type":"\u985E\u578B","lang_source_save":"\u5132\u5B58","lang_source_cancel":"\u53D6\u6D88","lang_source_saved":"\u5DF2\u5132\u5B58","lang_source_last_post":"\u66F4\u65B0\u65BC ","lang_no_entries":"\u6C92\u6709\u689D\u76EE","lang_more":"\u66F4\u591A","lang_login":"\u767B\u5165","lang_login_username":"\u5E33\u865F","lang_login_password":"\u5BC6\u78BC","lang_no_title":"\u7121\u6A19\u984C"}');


var $e76472f510f3ef5d$export$2e2bcd8739ae039 = {
    "ca": (0, (/*@__PURE__*/$parcel$interopDefault($647f766074d64773$exports))),
    "cs": (0, (/*@__PURE__*/$parcel$interopDefault($18e6d39c6df6a504$exports))),
    "de": (0, (/*@__PURE__*/$parcel$interopDefault($0f57265ba749b28b$exports))),
    "en": (0, (/*@__PURE__*/$parcel$interopDefault($38fe93b221363e36$exports))),
    "en-GB": (0, (/*@__PURE__*/$parcel$interopDefault($75c67d0db824a550$exports))),
    "es": (0, (/*@__PURE__*/$parcel$interopDefault($e09fd591c81d8c00$exports))),
    "et": (0, (/*@__PURE__*/$parcel$interopDefault($09197c62e8f40c51$exports))),
    "fi": (0, (/*@__PURE__*/$parcel$interopDefault($7bfc007d210a165f$exports))),
    "fr": (0, (/*@__PURE__*/$parcel$interopDefault($5d661914acf6fff5$exports))),
    "fr-CA": (0, (/*@__PURE__*/$parcel$interopDefault($17710b319b719f9f$exports))),
    "gl": (0, (/*@__PURE__*/$parcel$interopDefault($5842b3cf59e511d5$exports))),
    "he": (0, (/*@__PURE__*/$parcel$interopDefault($785c4eb045100ebe$exports))),
    "hu": (0, (/*@__PURE__*/$parcel$interopDefault($2e8fa1e1c4881081$exports))),
    "id": (0, (/*@__PURE__*/$parcel$interopDefault($21a979911d58571c$exports))),
    "it": (0, (/*@__PURE__*/$parcel$interopDefault($bcc60c6870c45310$exports))),
    "ja": (0, (/*@__PURE__*/$parcel$interopDefault($176dd0c127d964ee$exports))),
    "lv": (0, (/*@__PURE__*/$parcel$interopDefault($96d4cdcff3e97d75$exports))),
    "nb": (0, (/*@__PURE__*/$parcel$interopDefault($662f6aa9e169a442$exports))),
    "nl": (0, (/*@__PURE__*/$parcel$interopDefault($ce919b35c66c9734$exports))),
    "pl": (0, (/*@__PURE__*/$parcel$interopDefault($33fd991f65022a1d$exports))),
    "pt": (0, (/*@__PURE__*/$parcel$interopDefault($239d5b3fdb03f0e7$exports))),
    "pt-BR": (0, (/*@__PURE__*/$parcel$interopDefault($0b5a97e9c325f976$exports))),
    "rm": (0, (/*@__PURE__*/$parcel$interopDefault($655a661d0a47f25d$exports))),
    "ru": (0, (/*@__PURE__*/$parcel$interopDefault($436a71a33b0f932a$exports))),
    "sk": (0, (/*@__PURE__*/$parcel$interopDefault($f5ba6c0d14de49b4$exports))),
    "sv": (0, (/*@__PURE__*/$parcel$interopDefault($075ee780f7474188$exports))),
    "tr": (0, (/*@__PURE__*/$parcel$interopDefault($2fdd723177d78183$exports))),
    "uk": (0, (/*@__PURE__*/$parcel$interopDefault($d1a3f8492d1a8641$exports))),
    "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($e7426becb1609a72$exports))),
    "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($71137174854b0ca9$exports)))
};


function $f72bf3d6649abea1$var$handleNavToggle({ event: event, setNavExpanded: setNavExpanded }) {
    event.preventDefault();
    // show hide navigation for mobile version
    setNavExpanded((expanded)=>!expanded);
    window.scrollTo({
        top: 0
    });
}
function $f72bf3d6649abea1$var$dismissMessage(event) {
    selfoss.app.setGlobalMessage(null);
    event.stopPropagation();
}
/**
 * Global message bar for showing errors/information at the top of the page.
 * It watches globalMessage and updates/shows/hides itself as necessary
 * when the value changes.
 */ function $f72bf3d6649abea1$var$Message({ message: message }) {
    // Whenever message changes, dismiss it after 15 seconds.
    (0, $5NSbj.useEffect)(()=>{
        if (message !== null) {
            const dismissTimeout = window.setTimeout(()=>{
                selfoss.app.setGlobalMessage(null);
            }, 15000);
            return ()=>{
                // Destory previous timeout.
                window.clearTimeout(dismissTimeout);
            };
        }
    }, [
        message
    ]);
    return message !== null ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
        id: "message",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            error: message.isError
        }),
        onClick: $f72bf3d6649abea1$var$dismissMessage,
        children: [
            message.message,
            message.actions.map(({ label: label, callback: callback }, index)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                    type: "button",
                    onClick: callback,
                    children: label
                }, index))
        ]
    }) : null;
}
$f72bf3d6649abea1$var$Message.propTypes = {
    message: (0, (/*@__PURE__*/$parcel$interopDefault($ea2d4a6a4b369f4b$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object).isRequired
};
function $f72bf3d6649abea1$var$NotFound() {
    const location = (0, $88361e604f4abd56$export$45d76561a5302f2b)();
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
        children: _("error_invalid_subsection") + location.pathname
    });
}
function $f72bf3d6649abea1$var$CheckAuthorization({ isAllowed: isAllowed, returnLocation: returnLocation, _: _, children: children }) {
    const history = (0, $88361e604f4abd56$export$3420e1dc2c4a518c)();
    if (!isAllowed) {
        const [preLink, inLink, postLink] = _("error_unauthorized").split(/\{(?:link_begin|link_end)\}/);
        history.push("/sign/in", {
            returnLocation: returnLocation
        });
        return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("p", {
            children: [
                preLink,
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $a751150471783e33$export$a6c7ac8248d6e38a), {
                    to: "/sign/in",
                    children: inLink
                }),
                postLink
            ]
        });
    } else return children;
}
$f72bf3d6649abea1$var$CheckAuthorization.propTypes = {
    isAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    returnLocation: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).string,
    _: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).any
};
function $f72bf3d6649abea1$var$PureApp({ navSourcesExpanded: navSourcesExpanded, setNavSourcesExpanded: setNavSourcesExpanded, offlineState: offlineState, allItemsCount: allItemsCount, allItemsOfflineCount: allItemsOfflineCount, unreadItemsCount: unreadItemsCount, unreadItemsOfflineCount: unreadItemsOfflineCount, starredItemsCount: starredItemsCount, starredItemsOfflineCount: starredItemsOfflineCount, globalMessage: globalMessage, sourcesState: sourcesState, setSourcesState: setSourcesState, sources: sources, setSources: setSources, tags: tags, reloadAll: reloadAll }) {
    const [navExpanded, setNavExpanded] = (0, $5NSbj.useState)(false);
    const smartphone = (0, $cdbcc1ec15a05191$export$443718c44347a6b3)();
    const offlineEnabled = (0, $cdbcc1ec15a05191$export$96b5b894afc1d2e3)(selfoss.db.enableOffline);
    const [entriesPage, setEntriesPage] = (0, $5NSbj.useState)(null);
    const configuration = (0, $5NSbj.useContext)((0, $7b0908670bf0de1b$export$326f6d1b69f1c06e));
    (0, $5NSbj.useEffect)(()=>{
        // init shortcut handler
        const destroyShortcuts = (0, $fe8543f876f4df6e$export$2e2bcd8739ae039)();
        return ()=>{
            destroyShortcuts();
        };
    }, []);
    // TODO: move stuff that depends on this to the App.
    const history = (0, $88361e604f4abd56$export$3420e1dc2c4a518c)();
    (0, $5NSbj.useEffect)(()=>{
        selfoss.history = history;
    }, [
        history
    ]);
    // Prepare path of the homepage for redirecting from /
    const homePagePath = configuration.homepage.split("/");
    if (!homePagePath[1]) homePagePath.push("all");
    const menuButtonOnClick = (0, $5NSbj.useCallback)((event)=>$f72bf3d6649abea1$var$handleNavToggle({
            event: event,
            setNavExpanded: setNavExpanded
        }), []);
    const entriesRef = (0, $5NSbj.useCallback)((entriesPage)=>{
        setEntriesPage(entriesPage);
        selfoss.entriesPage = entriesPage;
    }, []);
    const [title, setTitle] = (0, $5NSbj.useState)(null);
    const [globalUnreadCount, setGlobalUnreadCount] = (0, $5NSbj.useState)(null);
    (0, $5NSbj.useEffect)(()=>{
        document.title = (title ?? configuration.htmlTitle) + ((globalUnreadCount ?? 0) > 0 ? ` (${globalUnreadCount})` : "");
    }, [
        configuration,
        title,
        globalUnreadCount
    ]);
    const _ = (0, $5NSbj.useContext)((0, $5211519f9db04406$export$51216bcc3983e55d));
    const isAllowedToRead = (0, $49b55be3b2a6e8d6$export$f5bdb3b3cec7f803)();
    const isAllowedToWrite = (0, $49b55be3b2a6e8d6$export$b416b77cd328c02f)();
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).StrictMode, {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($f72bf3d6649abea1$var$Message, {
                message: globalMessage
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $88361e604f4abd56$export$b5d5cf8927ab7262), {
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $88361e604f4abd56$export$e7b0ac011bb776c6), {
                        path: "/sign/in",
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                            id: "loginform",
                            role: "main",
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $8ef53a23f964ed7b$export$2e2bcd8739ae039), {
                                offlineEnabled: offlineEnabled
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $88361e604f4abd56$export$e7b0ac011bb776c6), {
                        path: "/password",
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($f72bf3d6649abea1$var$CheckAuthorization, {
                            isAllowed: isAllowedToWrite,
                            returnLocation: "/password",
                            _: _,
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                                id: "hashpasswordbody",
                                role: "main",
                                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1adbe19d09ddc903$export$2e2bcd8739ae039), {
                                    setTitle: setTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $88361e604f4abd56$export$e7b0ac011bb776c6), {
                        path: "/opml",
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($f72bf3d6649abea1$var$CheckAuthorization, {
                            isAllowed: selfoss.isAllowedToWrite(),
                            returnLocation: "/opml",
                            _: _,
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("main", {
                                id: "opmlbody",
                                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $4a4791c9c37eaae1$export$2e2bcd8739ae039), {
                                    setTitle: setTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $88361e604f4abd56$export$e7b0ac011bb776c6), {
                        path: "/",
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)($f72bf3d6649abea1$var$CheckAuthorization, {
                            isAllowed: isAllowedToRead,
                            _: _,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                                    id: "nav-mobile",
                                    role: "navigation",
                                    children: [
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                                            id: "nav-mobile-logo",
                                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                                                id: "nav-mobile-count",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                                    "unread-count": true,
                                                    offline: offlineState,
                                                    online: !offlineState,
                                                    unread: unreadItemsCount > 0
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                                            "offline-count": true,
                                                            offline: offlineState,
                                                            online: !offlineState,
                                                            diff: unreadItemsCount !== unreadItemsOfflineCount && unreadItemsOfflineCount
                                                        }),
                                                        children: unreadItemsOfflineCount > 0 ? unreadItemsOfflineCount : ""
                                                    }),
                                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                                        className: "count",
                                                        children: unreadItemsCount
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                                            id: "nav-mobile-settings",
                                            accessKey: "t",
                                            "aria-label": _("settingsbutton"),
                                            onClick: menuButtonOnClick,
                                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ed572b0153b27b45$export$2b9260d4a45c8710), {
                                                icon: $2af23e40017b25d9$exports.faCog,
                                                size: "2x"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $5c9ab921368ace58$export$78768a9af065a7b), {
                                    isOpen: !smartphone || navExpanded,
                                    className: "collapse-css-transition",
                                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                                        id: "nav",
                                        role: "navigation",
                                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $0beaf1dad44b806f$export$2e2bcd8739ae039), {
                                            entriesPage: entriesPage,
                                            setNavExpanded: setNavExpanded,
                                            navSourcesExpanded: navSourcesExpanded,
                                            setNavSourcesExpanded: setNavSourcesExpanded,
                                            offlineState: offlineState,
                                            allItemsCount: allItemsCount,
                                            allItemsOfflineCount: allItemsOfflineCount,
                                            unreadItemsCount: unreadItemsCount,
                                            unreadItemsOfflineCount: unreadItemsOfflineCount,
                                            starredItemsCount: starredItemsCount,
                                            starredItemsOfflineCount: starredItemsOfflineCount,
                                            sourcesState: sourcesState,
                                            setSourcesState: setSourcesState,
                                            sources: sources,
                                            setSources: setSources,
                                            tags: tags,
                                            reloadAll: reloadAll
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                                    id: "search-list",
                                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $0036981abc44d9f9$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                                    id: "content",
                                    role: "main",
                                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $88361e604f4abd56$export$b5d5cf8927ab7262), {
                                        children: [
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $88361e604f4abd56$export$e7b0ac011bb776c6), {
                                                exact: true,
                                                path: "/",
                                                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $88361e604f4abd56$export$2d8d895a0a0f636e), {
                                                    to: `/${homePagePath.join("/")}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $88361e604f4abd56$export$e7b0ac011bb776c6), {
                                                path: (0, $7c8cbf542ee98bec$export$f1004941042944df),
                                                children: (routeProps)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $9a29cc780ecc33b8$export$2e2bcd8739ae039), {
                                                        ...routeProps,
                                                        ref: entriesRef,
                                                        setNavExpanded: setNavExpanded,
                                                        configuration: configuration,
                                                        navSourcesExpanded: navSourcesExpanded,
                                                        unreadItemsCount: unreadItemsCount,
                                                        setGlobalUnreadCount: setGlobalUnreadCount
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $88361e604f4abd56$export$e7b0ac011bb776c6), {
                                                path: "/manage/sources",
                                                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $354786050498b51e$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $88361e604f4abd56$export$e7b0ac011bb776c6), {
                                                path: "*",
                                                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($f72bf3d6649abea1$var$NotFound, {})
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
$f72bf3d6649abea1$var$PureApp.propTypes = {
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    setNavSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).bool.isRequired,
    allItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    allItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    unreadItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    starredItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    starredItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).number.isRequired,
    globalMessage: (0, (/*@__PURE__*/$parcel$interopDefault($ea2d4a6a4b369f4b$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object).isRequired,
    sourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).oneOf(Object.values((0, $c097b691ff08d4e3$export$62aa48085237e36f))).isRequired,
    setSourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    sources: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object).isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired,
    tags: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object).isRequired,
    reloadAll: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).func.isRequired
};
class $f72bf3d6649abea1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component {
    constructor(props){
        super(props);
        this.state = {
            /**
             * tag repository
             */ tags: [],
            tagsState: (0, $c097b691ff08d4e3$export$62aa48085237e36f).INITIAL,
            /**
             * source repository
             */ sources: [],
            sourcesState: (0, $c097b691ff08d4e3$export$62aa48085237e36f).INITIAL,
            /**
             * true when sources in the sidebar are expanded
             * and we should fetch info about them in API requests.
             */ navSourcesExpanded: false,
            /**
             * whether off-line mode is enabled
             */ offlineState: false,
            /**
             * number of unread items
             */ unreadItemsCount: 0,
            /**
             * number of unread items available offline
             */ unreadItemsOfflineCount: 0,
            /**
             * number of starred items
             */ starredItemsCount: 0,
            /**
             * number of starred items available offline
             */ starredItemsOfflineCount: 0,
            /**
             * number of all items
             */ allItemsCount: 0,
            /**
             * number of all items available offline
             */ allItemsOfflineCount: 0,
            /**
             * Global message popup.
             * @var ?Object.{message: string, actions: Array.<Object.{label: string, callback: function>}, isError: bool}
             */ globalMessage: null
        };
        this._ = this._.bind(this);
        this.setTags = this.setTags.bind(this);
        this.setTagsState = this.setTagsState.bind(this);
        this.setSources = this.setSources.bind(this);
        this.setSourcesState = this.setSourcesState.bind(this);
        this.setOfflineState = this.setOfflineState.bind(this);
        this.setNavSourcesExpanded = this.setNavSourcesExpanded.bind(this);
        this.setUnreadItemsCount = this.setUnreadItemsCount.bind(this);
        this.setUnreadItemsOfflineCount = this.setUnreadItemsOfflineCount.bind(this);
        this.setStarredItemsCount = this.setStarredItemsCount.bind(this);
        this.setStarredItemsOfflineCount = this.setStarredItemsOfflineCount.bind(this);
        this.setAllItemsCount = this.setAllItemsCount.bind(this);
        this.setAllItemsOfflineCount = this.setAllItemsOfflineCount.bind(this);
        this.setGlobalMessage = this.setGlobalMessage.bind(this);
        this.reloadAll = this.reloadAll.bind(this);
    }
    setTags(tags) {
        if (typeof tags === "function") this.setState((state)=>({
                tags: tags(state.tags)
            }));
        else this.setState({
            tags: tags
        });
    }
    setTagsState(tagsState) {
        if (typeof tagsState === "function") this.setState((state)=>({
                tagsState: tagsState(state.tagsState)
            }));
        else this.setState({
            tagsState: tagsState
        });
    }
    setSources(sources) {
        if (typeof sources === "function") this.setState((state)=>({
                sources: sources(state.sources)
            }));
        else this.setState({
            sources: sources
        });
    }
    setSourcesState(sourcesState) {
        if (typeof sourcesState === "function") this.setState((state)=>({
                sourcesState: sourcesState(state.sourcesState)
            }));
        else this.setState({
            sourcesState: sourcesState
        });
    }
    setOfflineState(offlineState) {
        if (typeof offlineState === "function") this.setState((state)=>({
                offlineState: offlineState(state.offlineState)
            }));
        else this.setState({
            offlineState: offlineState
        });
    }
    setNavSourcesExpanded(navSourcesExpanded) {
        if (typeof navSourcesExpanded === "function") this.setState((state)=>({
                navSourcesExpanded: navSourcesExpanded(state.navSourcesExpanded)
            }));
        else this.setState({
            navSourcesExpanded: navSourcesExpanded
        });
    }
    setUnreadItemsCount(unreadItemsCount) {
        if (typeof unreadItemsCount === "function") this.setState((state)=>({
                unreadItemsCount: unreadItemsCount(state.unreadItemsCount)
            }));
        else this.setState({
            unreadItemsCount: unreadItemsCount
        });
    }
    setUnreadItemsOfflineCount(unreadItemsOfflineCount) {
        if (typeof unreadItemsOfflineCount === "function") this.setState((state)=>({
                unreadItemsOfflineCount: unreadItemsOfflineCount(state.unreadItemsOfflineCount)
            }));
        else this.setState({
            unreadItemsOfflineCount: unreadItemsOfflineCount
        });
    }
    setStarredItemsCount(starredItemsCount) {
        if (typeof starredItemsCount === "function") this.setState((state)=>({
                starredItemsCount: starredItemsCount(state.starredItemsCount)
            }));
        else this.setState({
            starredItemsCount: starredItemsCount
        });
    }
    setStarredItemsOfflineCount(starredItemsOfflineCount) {
        if (typeof starredItemsOfflineCount === "function") this.setState((state)=>({
                starredItemsOfflineCount: starredItemsOfflineCount(state.starredItemsOfflineCount)
            }));
        else this.setState({
            starredItemsOfflineCount: starredItemsOfflineCount
        });
    }
    setAllItemsCount(allItemsCount) {
        if (typeof allItemsCount === "function") this.setState((state)=>({
                allItemsCount: allItemsCount(state.allItemsCount)
            }));
        else this.setState({
            allItemsCount: allItemsCount
        });
    }
    setAllItemsOfflineCount(allItemsOfflineCount) {
        if (typeof allItemsOfflineCount === "function") this.setState((state)=>({
                allItemsOfflineCount: allItemsOfflineCount(state.allItemsOfflineCount)
            }));
        else this.setState({
            allItemsOfflineCount: allItemsOfflineCount
        });
    }
    setGlobalMessage(globalMessage) {
        if (typeof globalMessage === "function") this.setState((state)=>({
                globalMessage: globalMessage(state.globalMessage)
            }));
        else this.setState({
            globalMessage: globalMessage
        });
    }
    /**
     * Triggers fetching news from all sources.
     * @return Promise<undefined>
     */ reloadAll() {
        if (!selfoss.isOnline()) return Promise.resolve();
        return $3972545cf57eb298$export$c5eb18431f66026b().then(()=>{
            // probe stats and prompt reload to the user
            selfoss.dbOnline.sync().then(()=>{
                if (this.state.unreadItemsCount > 0) this.showMessage(this._("sources_refreshed"), [
                    {
                        label: this._("reload_list"),
                        callback () {
                            document.querySelector("#nav-filter-unread").click();
                        }
                    }
                ]);
            });
        }).catch((error)=>{
            this.showError(this._("error_refreshing_source") + " " + error.message);
        });
    }
    /**
    * Obtain a localized message for given key, substituting placeholders for values, when given.
    * @param string key
    * @param ?array parameters
    * @return string
    */ _(identifier, params) {
        const fallbackLanguage = "en";
        const langKey = `lang_${identifier}`;
        let preferredLanguage = this.props.configuration.language;
        // locale auto-detection
        if (preferredLanguage === null) {
            if ("languages" in navigator) preferredLanguage = navigator.languages.find((lang)=>Object.keys((0, $e76472f510f3ef5d$export$2e2bcd8739ae039)).includes(lang));
        }
        if (!Object.keys((0, $e76472f510f3ef5d$export$2e2bcd8739ae039)).includes(preferredLanguage)) preferredLanguage = fallbackLanguage;
        let translated = (0, $e76472f510f3ef5d$export$2e2bcd8739ae039)[preferredLanguage][langKey] || (0, $e76472f510f3ef5d$export$2e2bcd8739ae039)[fallbackLanguage][langKey] || `#untranslated:${identifier}`;
        if (params) translated = (0, $5211519f9db04406$export$e51161e9fbfde80e)(translated, params);
        return translated;
    }
    /**
     * Show error message in the message bar in the UI.
     *
     * @param {string} message
     * @return void
     */ showError(message) {
        this.showMessage(message, [], true);
    }
    /**
     * Show message in the message bar in the UI.
     *
     * @param {string} message
     * @param {Array.<Object.{label: string, callback: function>} actions
     * @param {bool} isError
     * @return void
     */ showMessage(message, actions = [], isError = false) {
        this.setGlobalMessage({
            message: message,
            actions: actions,
            isError: isError
        });
    }
    notifyNewVersion(cb) {
        if (!cb) cb = ()=>{
            window.location.reload();
        };
        this.showMessage(this._("app_update"), [
            {
                label: this._("app_reload"),
                callback: cb
            }
        ]);
    }
    refreshTagSourceUnread(tagCounts, sourceCounts, diff = true) {
        this.setTags((tags)=>tags.map((tag)=>{
                if (!(tag.tag in tagCounts)) return tag;
                let unread;
                if (diff) unread = tag.unread + tagCounts[tag.tag];
                else unread = tagCounts[tag.tag];
                return {
                    ...tag,
                    unread: unread
                };
            }));
        this.setSources((sources)=>sources.map((source)=>{
                if (!(source.id in sourceCounts)) return source;
                let unread;
                if (diff) unread = source.unread + sourceCounts[source.id];
                else unread = sourceCounts[source.id];
                return {
                    ...source,
                    unread: unread
                };
            }));
    }
    refreshOfflineCounts(offlineCounts) {
        for (const [kind, newCount] of Object.entries(offlineCounts)){
            if (newCount === "keep") continue;
            if (kind === "unread") this.setUnreadItemsOfflineCount(newCount);
            else if (kind === "starred") this.setStarredItemsOfflineCount(newCount);
            else if (kind === "newest") this.setAllItemsOfflineCount(newCount);
        }
    }
    render() {
        return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $7b0908670bf0de1b$export$326f6d1b69f1c06e).Provider, {
            value: this.props.configuration,
            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $5211519f9db04406$export$51216bcc3983e55d).Provider, {
                value: this._,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($f72bf3d6649abea1$var$PureApp, {
                    navSourcesExpanded: this.state.navSourcesExpanded,
                    setNavSourcesExpanded: this.setNavSourcesExpanded,
                    offlineState: this.state.offlineState,
                    allItemsCount: this.state.allItemsCount,
                    allItemsOfflineCount: this.state.allItemsOfflineCount,
                    unreadItemsCount: this.state.unreadItemsCount,
                    unreadItemsOfflineCount: this.state.unreadItemsOfflineCount,
                    starredItemsCount: this.state.starredItemsCount,
                    starredItemsOfflineCount: this.state.starredItemsOfflineCount,
                    globalMessage: this.state.globalMessage,
                    sourcesState: this.state.sourcesState,
                    setSourcesState: this.setSourcesState,
                    sources: this.state.sources,
                    setSources: this.setSources,
                    tags: this.state.tags,
                    reloadAll: this.reloadAll
                })
            })
        });
    }
}
$f72bf3d6649abea1$export$2e2bcd8739ae039.propTypes = {
    configuration: (0, (/*@__PURE__*/$parcel$interopDefault($f95d863e1a691bb4$exports))).object.isRequired
};
function $f72bf3d6649abea1$export$4e373c34abfa8c68({ basePath: basePath, appRef: appRef, configuration: configuration }) {
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $a751150471783e33$export$9ba4e89fdfa1fc54), {
        basename: basePath,
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($f72bf3d6649abea1$export$2e2bcd8739ae039, {
            ref: appRef,
            configuration: configuration
        })
    });
}


var $d33f9d73d3d858f8$exports = {};
$d33f9d73d3d858f8$exports = new URL("selfoss-sw-offline.js", import.meta.url).toString();


/**
 * base javascript application
 *
 * @package    public_js
 * @copyright  Copyright (c) Tobias Zeising (http://www.aditu.de)
 * @license    GPLv3 (https://www.gnu.org/licenses/gpl-3.0.html)
 */ const $ee388dae0165e99c$var$selfoss = {
    /**
     * The main App component.
     * @var App
     */ app: null,
    /**
     * React component for entries page.
     */ entriesPage: null,
    serviceWorkerInitialized: false,
    /**
     * Whether lightbox is open.
     */ lightboxActive: new (0, $648254c988c3de43$export$8fa6ce44b7b131e9)(false),
    /**
     * initialize application
     */ async init () {
        // Load off-line mode enabledness.
        $ee388dae0165e99c$var$selfoss.db.enableOffline.update(window.localStorage.getItem("enableOffline") === "true");
        // Ignore stored config when off-line mode is disabled, since it is likely stale.
        const storedConfig = $ee388dae0165e99c$var$selfoss.db.enableOffline.value ? localStorage.getItem("configuration") : null;
        let oldConfiguration = null;
        try {
            oldConfiguration = storedConfig !== null ? JSON.parse(storedConfig) : null;
        } catch  {
        // We will try to obtain a new configuration anyway.
        }
        // Fall back to the last cached config on failure.
        let configurationToUse = oldConfiguration;
        try {
            const { configuration: configuration } = await (0, $3b58afcf3e935267$export$1d2e6bc0307ffd89)();
            configurationToUse = configuration;
            // We are on-line, prune the user files when changed.
            if ("caches" in window && "serviceWorker" in navigator) {
                if (oldConfiguration === null || oldConfiguration.userCss !== configuration.userCss) await caches.delete("userCss");
                if (oldConfiguration === null || oldConfiguration.userJs !== configuration.userJs) await caches.delete("userJs");
            }
        } finally{
            if (configurationToUse) await $ee388dae0165e99c$var$selfoss.initMain(configurationToUse);
            else // TODO: Add a more proper error page
            document.body.innerHTML = $ee388dae0165e99c$var$selfoss.app._("error_configuration");
        }
    },
    async initMain (configuration) {
        $ee388dae0165e99c$var$selfoss.config = configuration;
        if ($ee388dae0165e99c$var$selfoss.db.enableOffline.value) $ee388dae0165e99c$var$selfoss.setupServiceWorker();
        if (configuration.language !== null) document.documentElement.setAttribute("lang", configuration.language);
        document.querySelector('meta[name="application-name"]').setAttribute("content", configuration.htmlTitle);
        const feedLink = document.createElement("link");
        feedLink.setAttribute("rel", "alternate");
        feedLink.setAttribute("type", "application/rss+xml");
        feedLink.setAttribute("title", "RSS Feed");
        feedLink.setAttribute("href", "feed");
        document.head.appendChild(feedLink);
        if (configuration.userCss !== null) {
            const link = document.createElement("link");
            link.setAttribute("rel", "stylesheet");
            link.setAttribute("href", `user.css?v=${configuration.userCss}`);
            document.head.appendChild(link);
        }
        if (configuration.userJs !== null) {
            const script = document.createElement("script");
            script.setAttribute("src", `user.js?v=${configuration.userJs}`);
            document.body.appendChild(script);
        }
        // init offline if supported
        $ee388dae0165e99c$var$selfoss.dbOffline.init();
        if (configuration.authEnabled) $ee388dae0165e99c$var$selfoss.loggedin.update(window.localStorage.getItem("onlineSession") == "true");
        $ee388dae0165e99c$var$selfoss.attachApp(configuration);
    },
    /**
     * Create basic DOM structure of the page.
     */ attachApp (configuration) {
        document.getElementById("js-loading-message")?.remove();
        const mainUi = document.createElement("div");
        document.body.appendChild(mainUi);
        mainUi.classList.add("app-toplevel");
        // BrowserRouter expects no slash at the end.
        const basePath = new URL(document.baseURI).pathname.replace(/\/$/, "");
        const root = (0, $fdb09cd070e137df$export$882461b6382ed46c)(mainUi);
        root.render((0, $f72bf3d6649abea1$export$4e373c34abfa8c68)({
            basePath: basePath,
            appRef: (app)=>{
                $ee388dae0165e99c$var$selfoss.app = app;
            },
            configuration: configuration
        }));
    },
    loggedin: new (0, $648254c988c3de43$export$8fa6ce44b7b131e9)(false),
    setSession () {
        window.localStorage.setItem("onlineSession", true);
        $ee388dae0165e99c$var$selfoss.loggedin.update(true);
    },
    clearSession () {
        window.localStorage.removeItem("onlineSession");
        $ee388dae0165e99c$var$selfoss.loggedin.update(false);
    },
    hasSession () {
        return $ee388dae0165e99c$var$selfoss.loggedin.value;
    },
    /**
     * Try to log in using given credentials
     * @return Promise<undefined>
     */ login ({ configuration: configuration, username: username, password: password, enableOffline: enableOffline }) {
        $ee388dae0165e99c$var$selfoss.db.enableOffline.update(enableOffline);
        window.localStorage.setItem("enableOffline", $ee388dae0165e99c$var$selfoss.db.enableOffline.value);
        if (!$ee388dae0165e99c$var$selfoss.db.enableOffline.value) $ee388dae0165e99c$var$selfoss.db.clear();
        const credentials = {
            username: username,
            password: password
        };
        return (0, $3b58afcf3e935267$export$596d806903d1f59e)(credentials).then(()=>{
            $ee388dae0165e99c$var$selfoss.setSession();
            // init offline if supported and not inited yet
            $ee388dae0165e99c$var$selfoss.dbOffline.init();
            if ((!$ee388dae0165e99c$var$selfoss.db.storage || $ee388dae0165e99c$var$selfoss.db.broken) && $ee388dae0165e99c$var$selfoss.db.enableOffline.value) {
                // Initialize database in offline mode when it has not been initialized yet or it got broken.
                $ee388dae0165e99c$var$selfoss.dbOffline.init();
                // Store config for off-line use.
                localStorage.setItem("configuration", JSON.stringify(configuration));
                // Cache user files manually since service worker is not aware of them.
                if ("caches" in window && "serviceWorker" in navigator) {
                    caches.open("userCss").then((cache)=>cache.add(`user.css?v=${configuration.userCss}`));
                    caches.open("userJs").then((cache)=>cache.add(`user.js?v=${configuration.userJs}`));
                }
                $ee388dae0165e99c$var$selfoss.setupServiceWorker();
            }
        });
    },
    setupServiceWorker () {
        if (!("serviceWorker" in navigator) || $ee388dae0165e99c$var$selfoss.serviceWorkerInitialized) return;
        $ee388dae0165e99c$var$selfoss.serviceWorkerInitialized = true;
        navigator.serviceWorker.addEventListener("controllerchange", ()=>{
            window.location.reload();
        });
        navigator.serviceWorker.register($d33f9d73d3d858f8$exports).then((reg)=>{
            $ee388dae0165e99c$var$selfoss.listenWaitingSW(reg, (reg)=>{
                $ee388dae0165e99c$var$selfoss.app.notifyNewVersion(()=>{
                    if (reg.waiting) reg.waiting.postMessage("skipWaiting");
                });
            });
        });
    },
    async logout () {
        $ee388dae0165e99c$var$selfoss.clearSession();
        $ee388dae0165e99c$var$selfoss.db.clear(); // will not work after a failure, since storage is nulled
        window.localStorage.clear();
        if ("serviceWorker" in navigator) {
            if ("caches" in window) caches.keys().then((keys)=>keys.forEach((key)=>caches.delete(key)));
            navigator.serviceWorker.getRegistrations().then((registrations)=>{
                registrations.forEach((reg)=>{
                    reg.unregister();
                });
            });
            $ee388dae0165e99c$var$selfoss.serviceWorkerInitialized = false;
        }
        try {
            await (0, $3b58afcf3e935267$export$a0973bcfe11b05c9)();
            if (!$ee388dae0165e99c$var$selfoss.config.publicMode) $ee388dae0165e99c$var$selfoss.history.push("/sign/in");
        } catch (error) {
            $ee388dae0165e99c$var$selfoss.app.showError($ee388dae0165e99c$var$selfoss.app._("error_logout") + " " + error.message);
        }
    },
    /**
     * Checks whether the current user is allowed to perform read operations.
     *
     * @returns {boolean}
     */ isAllowedToRead () {
        return $ee388dae0165e99c$var$selfoss.hasSession() || !$ee388dae0165e99c$var$selfoss.config.authEnabled || $ee388dae0165e99c$var$selfoss.config.publicMode;
    },
    /**
     * Checks whether the current user is allowed to perform update-tier operations.
     *
     * @returns {boolean}
     */ isAllowedToUpdate () {
        return $ee388dae0165e99c$var$selfoss.hasSession() || !$ee388dae0165e99c$var$selfoss.config.authEnabled || $ee388dae0165e99c$var$selfoss.config.allowPublicUpdate;
    },
    /**
     * Checks whether the current user is allowed to perform write operations.
     *
     * @returns {boolean}
     */ isAllowedToWrite () {
        return $ee388dae0165e99c$var$selfoss.hasSession() || !$ee388dae0165e99c$var$selfoss.config.authEnabled;
    },
    /**
     * Checks whether the current user is allowed to perform write operations.
     *
     * @returns {boolean}
     */ isOnline () {
        return $ee388dae0165e99c$var$selfoss.db.online;
    },
    /**
     * indicates whether a mobile device is host
     *
     * @return true if device resolution smaller equals 1024
     */ isMobile () {
        // first check useragent
        if (/iPhone|iPod|iPad|Android|BlackBerry/.test(navigator.userAgent)) return true;
        // otherwise check resolution
        return $ee388dae0165e99c$var$selfoss.isTablet() || $ee388dae0165e99c$var$selfoss.isSmartphone();
    },
    /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */ isTablet () {
        if (document.body.clientWidth <= 1024) return true;
        return false;
    },
    /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */ isSmartphone () {
        if (document.body.clientWidth <= 640) return true;
        return false;
    },
    /**
     * Override these functions to customize selfoss behaviour.
     */ extensionPoints: {
        /**
         * Called when an article is first expanded.
         * @param {HTMLElement} HTML element containing the article contents
         */ processItemContents () {}
    },
    /**
     * refresh stats.
     *
     * @return void
     * @param {Number} new all stats
     * @param {Number} new unread stats
     * @param {Number} new starred stats
     */ refreshStats (all, unread, starred) {
        $ee388dae0165e99c$var$selfoss.app.setAllItemsCount(all);
        $ee388dae0165e99c$var$selfoss.app.setStarredItemsCount(starred);
        $ee388dae0165e99c$var$selfoss.refreshUnread(unread);
    },
    /**
     * refresh unread stats.
     *
     * @return void
     * @param {Number} new unread stats
     */ refreshUnread (unread) {
        $ee388dae0165e99c$var$selfoss.app.setUnreadItemsCount(unread);
    },
    /**
     * refresh current tags.
     *
     * @return void
     */ reloadTags () {
        $ee388dae0165e99c$var$selfoss.app.setTagsState((0, $c097b691ff08d4e3$export$62aa48085237e36f).LOADING);
        (0, $c6a75ba9dc9fd47e$export$c36f611d5eb39a7)().then((data)=>{
            $ee388dae0165e99c$var$selfoss.app.setTags(data);
            $ee388dae0165e99c$var$selfoss.app.setTagsState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
        }).catch((error)=>{
            $ee388dae0165e99c$var$selfoss.app.setTagsState((0, $c097b691ff08d4e3$export$62aa48085237e36f).FAILURE);
            $ee388dae0165e99c$var$selfoss.app.showError($ee388dae0165e99c$var$selfoss.app._("error_load_tags") + " " + error.message);
        });
    },
    handleAjaxError (error, tryOffline = true) {
        if (!(error instanceof (0, $506fdaa0545346a2$export$65bd6083489bd8bb) || error instanceof (0, $506fdaa0545346a2$export$66d311bf29d5c89c))) return Promise.reject(error);
        const httpCode = error?.response?.status || 0;
        if (tryOffline && httpCode != 403) return $ee388dae0165e99c$var$selfoss.db.setOffline();
        else return Promise.reject(error);
    },
    listenWaitingSW (reg, callback) {
        const awaitStateChange = ()=>{
            reg.installing.addEventListener("statechange", (event)=>{
                if (event.target.state === "installed") callback(reg);
            });
        };
        if (!reg) return;
        else if (reg.waiting) return callback(reg);
        else if (reg.installing) {
            awaitStateChange();
            reg.addEventListener("updatefound", awaitStateChange);
        }
    },
    ajax: // Include helpers for user scripts.
    $7d3633f2d0caaef5$exports
};
var $ee388dae0165e99c$export$2e2bcd8739ae039 = $ee388dae0165e99c$var$selfoss;






(0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline = {
    syncing: {
        promise: null,
        request: null,
        resolve: null,
        reject: null
    },
    statsDirty: false,
    firstSync: true,
    _syncBegin () {
        if (!(0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.promise = new Promise((resolve, reject)=>{
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.resolve = resolve;
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.reject = reject;
                const monitor = window.setInterval(()=>{
                    let stopChecking = false;
                    if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
                        if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.userWaiting) {
                            // reject if user has been waiting for more than 10s,
                            // this means that connectivity is bad: user will get
                            // local content and server request will continue in
                            // the background.
                            reject();
                            stopChecking = true;
                        }
                    } else stopChecking = true;
                    if (stopChecking) window.clearInterval(monitor);
                }, 10000);
            });
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.promise.finally(()=>{
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.promise = null;
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.userWaiting = false;
            });
        }
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.promise;
    },
    _syncDone (success = true) {
        if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
            if (success) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.resolve();
            else {
                const request = (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.request;
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.reject();
                if (request) request.controller.abort();
            }
        }
    },
    /**
     * sync server status.
     *
     * @return Promise
     */ sync (updatedStatuses, chained) {
        if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.promise && !chained) {
            if (updatedStatuses) // Ensure the status queue is not cleared and gets sync'ed at
            // next sync.
            return Promise.reject();
            else return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.promise;
        }
        const syncing = (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline._syncBegin();
        let getStatuses = true;
        if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastUpdate === null || (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.firstSync) {
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastUpdate = new Date(0);
            getStatuses = undefined;
        }
        const syncParams = {
            since: (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastUpdate,
            tags: true,
            sources: (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.state.navSourcesExpanded || undefined,
            itemsStatuses: getStatuses
        };
        if (updatedStatuses && updatedStatuses.length > 0) syncParams.updatedStatuses = updatedStatuses;
        if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.enableOffline.value) {
            syncParams.itemsSinceId = (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.lastItemId;
            syncParams.itemsNotBefore = (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry;
            syncParams.itemsHowMany = (0, $ee388dae0165e99c$export$2e2bcd8739ae039).config.itemsPerPage;
        }
        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.statsDirty = false;
        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.request = $c0fc5d9a6429f0a7$export$92d6409d68f0739a(updatedStatuses, syncParams);
        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.request.promise.then((data)=>{
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.setOnline();
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastSync = Date.now();
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.firstSync = false;
            const dataDate = data.lastUpdate;
            let storing = false;
            if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.enableOffline.value) {
                if ("newItems" in data) {
                    let maxId = 0;
                    data.newItems.forEach((item)=>{
                        maxId = Math.max(item.id, maxId);
                    });
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing = "lastId" in data && data.lastId > (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.lastItemId && data.lastId > maxId;
                    storing = (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing;
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.shouldLoadEntriesOnline = "lastId" in data && data.lastId - (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.lastItemId > 2 * (0, $ee388dae0165e99c$export$2e2bcd8739ae039).config.itemsPerPage;
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.storeEntries(data.newItems).then(()=>{
                        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.storeLastUpdate(dataDate);
                        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline._syncDone();
                    });
                }
                if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing || (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.needsSync) // There are still new items to fetch
                // or statuses to send
                syncing.then(()=>{
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.sendNewStatuses();
                });
                if ("itemUpdates" in data) // refresh entry statuses in db and dequeue queued
                // statuses but do not calculate stats as they are taken
                // directly from the server as provided.
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses(data.itemUpdates, true, false).then(()=>{
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.storeLastUpdate(dataDate);
                });
                if ("stats" in data) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.storeStats(data.stats);
            }
            if (!(0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.statsDirty && "stats" in data) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).refreshStats(data.stats.total, data.stats.unread, data.stats.starred);
            if ("tags" in data) {
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setTags(data.tags);
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setTagsState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
            }
            if ("sources" in data) {
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setSources(data.sources);
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setSourcesState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
            }
            if ("stats" in data && data.stats.unread > 0 && (0, $ee388dae0165e99c$export$2e2bcd8739ae039).entriesPage && ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).entriesPage.state.entries.length === 0 || (0, $ee388dae0165e99c$export$2e2bcd8739ae039).entriesPage.state.entries.loadingState === (0, $c097b691ff08d4e3$export$62aa48085237e36f).FAILURE)) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).entriesPage?.reload();
            else {
                if ("itemUpdates" in data) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).entriesPage.refreshEntryStatuses(data.itemUpdates);
                if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).entriesPage && (0, $ee388dae0165e99c$export$2e2bcd8739ae039).entriesPage.getActiveFilter() === (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).UNREAD) {
                    const unreadCount = "stats" in data ? data.stats.unread : (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.state.unreadItemsCount;
                    if (unreadCount > (0, $ee388dae0165e99c$export$2e2bcd8739ae039).entriesPage.state.entries.filter(({ unread: unread })=>unread == 1).length) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).entriesPage.setHasMore(true);
                }
            }
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastUpdate = dataDate;
            if (!storing) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline._syncDone();
        }).catch((error)=>{
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline._syncDone(false);
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).handleAjaxError(error).catch((error)=>{
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.showError((0, $ee388dae0165e99c$export$2e2bcd8739ae039).app._("error_sync") + " " + error.message);
            });
        }).finally(()=>{
            if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.promise) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.syncing.request = null;
        });
        return syncing;
    },
    /**
     * refresh current items.
     *
     * @return void
     */ getEntries (fetchParams, abortController) {
        return $c0fc5d9a6429f0a7$export$d2f92acf417bbf5d({
            ...fetchParams,
            itemsPerPage: (0, $ee388dae0165e99c$export$2e2bcd8739ae039).config.itemsPerPage
        }, abortController).then((data)=>{
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.setOnline();
            if (!(0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.enableOffline.value) {
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastSync = Date.now();
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastUpdate = data.lastUpdate;
            }
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).refreshStats(data.all, data.unread, data.starred);
            // update tags
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setTags(data.tags);
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setTagsState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
            if (typeof data.sources !== "undefined" && (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.state.navSourcesExpanded) {
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setSources(data.sources);
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setSourcesState((0, $c097b691ff08d4e3$export$62aa48085237e36f).SUCCESS);
            }
            return {
                entries: data.entries,
                hasMore: data.hasMore
            };
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).handleAjaxError(error).then(()=>{
                return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.getEntries(fetchParams);
            });
        });
    }
};




/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 3.2.7, Wed Mar 20 2024
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $6c079b6dfb8f58a4$var$__assign = function() {
    $6c079b6dfb8f58a4$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6c079b6dfb8f58a4$var$__assign.apply(this, arguments);
};
function $6c079b6dfb8f58a4$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $6c079b6dfb8f58a4$var$_global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
var $6c079b6dfb8f58a4$var$keys = Object.keys;
var $6c079b6dfb8f58a4$var$isArray = Array.isArray;
if (typeof Promise !== "undefined" && !$6c079b6dfb8f58a4$var$_global.Promise) $6c079b6dfb8f58a4$var$_global.Promise = Promise;
function $6c079b6dfb8f58a4$var$extend(obj, extension) {
    if (typeof extension !== "object") return obj;
    $6c079b6dfb8f58a4$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $6c079b6dfb8f58a4$var$getProto = Object.getPrototypeOf;
var $6c079b6dfb8f58a4$var$_hasOwn = {}.hasOwnProperty;
function $6c079b6dfb8f58a4$var$hasOwn(obj, prop) {
    return $6c079b6dfb8f58a4$var$_hasOwn.call(obj, prop);
}
function $6c079b6dfb8f58a4$var$props(proto, extension) {
    if (typeof extension === "function") extension = extension($6c079b6dfb8f58a4$var$getProto(proto));
    (typeof Reflect === "undefined" ? $6c079b6dfb8f58a4$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $6c079b6dfb8f58a4$var$setProp(proto, key, extension[key]);
    });
}
var $6c079b6dfb8f58a4$var$defineProperty = Object.defineProperty;
function $6c079b6dfb8f58a4$var$setProp(obj, prop, functionOrGetSet, options) {
    $6c079b6dfb8f58a4$var$defineProperty(obj, prop, $6c079b6dfb8f58a4$var$extend(functionOrGetSet && $6c079b6dfb8f58a4$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === "function" ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $6c079b6dfb8f58a4$var$derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $6c079b6dfb8f58a4$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $6c079b6dfb8f58a4$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $6c079b6dfb8f58a4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $6c079b6dfb8f58a4$var$getPropertyDescriptor(obj, prop) {
    var pd = $6c079b6dfb8f58a4$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $6c079b6dfb8f58a4$var$getProto(obj)) && $6c079b6dfb8f58a4$var$getPropertyDescriptor(proto, prop);
}
var $6c079b6dfb8f58a4$var$_slice = [].slice;
function $6c079b6dfb8f58a4$var$slice(args, start, end) {
    return $6c079b6dfb8f58a4$var$_slice.call(args, start, end);
}
function $6c079b6dfb8f58a4$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $6c079b6dfb8f58a4$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $6c079b6dfb8f58a4$var$asap$1(fn) {
    if ($6c079b6dfb8f58a4$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $6c079b6dfb8f58a4$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $6c079b6dfb8f58a4$var$tryCatch(fn, onerror, args) {
    try {
        fn.apply(null, args);
    } catch (ex) {
        onerror && onerror(ex);
    }
}
function $6c079b6dfb8f58a4$var$getByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string" && $6c079b6dfb8f58a4$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== "string") {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $6c079b6dfb8f58a4$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf(".");
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj == null ? undefined : $6c079b6dfb8f58a4$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $6c079b6dfb8f58a4$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ("isFrozen" in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== "string" && "length" in keyPath) {
        $6c079b6dfb8f58a4$var$assert(typeof value !== "string" && "length" in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$6c079b6dfb8f58a4$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf(".");
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($6c079b6dfb8f58a4$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$6c079b6dfb8f58a4$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $6c079b6dfb8f58a4$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($6c079b6dfb8f58a4$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $6c079b6dfb8f58a4$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string") $6c079b6dfb8f58a4$var$setByKeyPath(obj, keyPath, undefined);
    else if ("length" in keyPath) [].map.call(keyPath, function(kp) {
        $6c079b6dfb8f58a4$var$setByKeyPath(obj, kp, undefined);
    });
}
function $6c079b6dfb8f58a4$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($6c079b6dfb8f58a4$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $6c079b6dfb8f58a4$var$concat = [].concat;
function $6c079b6dfb8f58a4$var$flatten(a) {
    return $6c079b6dfb8f58a4$var$concat.apply([], a);
}
var $6c079b6dfb8f58a4$var$intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat($6c079b6dfb8f58a4$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $6c079b6dfb8f58a4$var$_global[t];
});
var $6c079b6dfb8f58a4$var$intrinsicTypes = $6c079b6dfb8f58a4$var$intrinsicTypeNames.map(function(t) {
    return $6c079b6dfb8f58a4$var$_global[t];
});
$6c079b6dfb8f58a4$var$arrayToObject($6c079b6dfb8f58a4$var$intrinsicTypeNames, function(x) {
    return [
        x,
        true
    ];
});
var $6c079b6dfb8f58a4$var$circularRefs = null;
function $6c079b6dfb8f58a4$var$deepClone(any) {
    $6c079b6dfb8f58a4$var$circularRefs = typeof WeakMap !== "undefined" && new WeakMap();
    var rv = $6c079b6dfb8f58a4$var$innerDeepClone(any);
    $6c079b6dfb8f58a4$var$circularRefs = null;
    return rv;
}
function $6c079b6dfb8f58a4$var$innerDeepClone(any) {
    if (!any || typeof any !== "object") return any;
    var rv = $6c079b6dfb8f58a4$var$circularRefs && $6c079b6dfb8f58a4$var$circularRefs.get(any);
    if (rv) return rv;
    if ($6c079b6dfb8f58a4$var$isArray(any)) {
        rv = [];
        $6c079b6dfb8f58a4$var$circularRefs && $6c079b6dfb8f58a4$var$circularRefs.set(any, rv);
        for(var i = 0, l = any.length; i < l; ++i)rv.push($6c079b6dfb8f58a4$var$innerDeepClone(any[i]));
    } else if ($6c079b6dfb8f58a4$var$intrinsicTypes.indexOf(any.constructor) >= 0) rv = any;
    else {
        var proto = $6c079b6dfb8f58a4$var$getProto(any);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $6c079b6dfb8f58a4$var$circularRefs && $6c079b6dfb8f58a4$var$circularRefs.set(any, rv);
        for(var prop in any)if ($6c079b6dfb8f58a4$var$hasOwn(any, prop)) rv[prop] = $6c079b6dfb8f58a4$var$innerDeepClone(any[prop]);
    }
    return rv;
}
var $6c079b6dfb8f58a4$var$toString = {}.toString;
function $6c079b6dfb8f58a4$var$toStringTag(o) {
    return $6c079b6dfb8f58a4$var$toString.call(o).slice(8, -1);
}
var $6c079b6dfb8f58a4$var$iteratorSymbol = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
var $6c079b6dfb8f58a4$var$getIteratorOf = typeof $6c079b6dfb8f58a4$var$iteratorSymbol === "symbol" ? function(x) {
    var i;
    return x != null && (i = x[$6c079b6dfb8f58a4$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
var $6c079b6dfb8f58a4$var$NO_CHAR_ARRAY = {};
function $6c079b6dfb8f58a4$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($6c079b6dfb8f58a4$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $6c079b6dfb8f58a4$var$NO_CHAR_ARRAY && typeof arrayLike === "string") return [
            arrayLike
        ];
        if (it = $6c079b6dfb8f58a4$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === "number") {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $6c079b6dfb8f58a4$var$isAsyncFunction = typeof Symbol !== "undefined" ? function(fn) {
    return fn[Symbol.toStringTag] === "AsyncFunction";
} : function() {
    return false;
};
var $6c079b6dfb8f58a4$var$debug = typeof location !== "undefined" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $6c079b6dfb8f58a4$var$setDebug(value, filter) {
    $6c079b6dfb8f58a4$var$debug = value;
    $6c079b6dfb8f58a4$var$libraryFilter = filter;
}
var $6c079b6dfb8f58a4$var$libraryFilter = function() {
    return true;
};
var $6c079b6dfb8f58a4$var$NEEDS_THROW_FOR_STACK = !new Error("").stack;
function $6c079b6dfb8f58a4$var$getErrorWithStack() {
    if ($6c079b6dfb8f58a4$var$NEEDS_THROW_FOR_STACK) try {
        $6c079b6dfb8f58a4$var$getErrorWithStack.arguments;
        throw new Error();
    } catch (e) {
        return e;
    }
    return new Error();
}
function $6c079b6dfb8f58a4$var$prettyStack(exception, numIgnoredFrames) {
    var stack = exception.stack;
    if (!stack) return "";
    numIgnoredFrames = numIgnoredFrames || 0;
    if (stack.indexOf(exception.name) === 0) numIgnoredFrames += (exception.name + exception.message).split("\n").length;
    return stack.split("\n").slice(numIgnoredFrames).filter($6c079b6dfb8f58a4$var$libraryFilter).map(function(frame) {
        return "\n" + frame;
    }).join("");
}
var $6c079b6dfb8f58a4$var$dexieErrorNames = [
    "Modify",
    "Bulk",
    "OpenFailed",
    "VersionChange",
    "Schema",
    "Upgrade",
    "InvalidTable",
    "MissingAPI",
    "NoSuchDatabase",
    "InvalidArgument",
    "SubTransaction",
    "Unsupported",
    "Internal",
    "DatabaseClosed",
    "PrematureCommit",
    "ForeignAwait"
];
var $6c079b6dfb8f58a4$var$idbDomErrorNames = [
    "Unknown",
    "Constraint",
    "Data",
    "TransactionInactive",
    "ReadOnly",
    "Version",
    "NotFound",
    "InvalidState",
    "InvalidAccess",
    "Abort",
    "Timeout",
    "QuotaExceeded",
    "Syntax",
    "DataClone"
];
var $6c079b6dfb8f58a4$var$errorList = $6c079b6dfb8f58a4$var$dexieErrorNames.concat($6c079b6dfb8f58a4$var$idbDomErrorNames);
var $6c079b6dfb8f58a4$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $6c079b6dfb8f58a4$var$DexieError(name, msg) {
    this._e = $6c079b6dfb8f58a4$var$getErrorWithStack();
    this.name = name;
    this.message = msg;
}
$6c079b6dfb8f58a4$var$derive($6c079b6dfb8f58a4$var$DexieError).from(Error).extend({
    stack: {
        get: function() {
            return this._stack || (this._stack = this.name + ": " + this.message + $6c079b6dfb8f58a4$var$prettyStack(this._e, 2));
        }
    },
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function $6c079b6dfb8f58a4$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join("\n");
}
function $6c079b6dfb8f58a4$var$ModifyError(msg, failures, successCount, failedKeys) {
    this._e = $6c079b6dfb8f58a4$var$getErrorWithStack();
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $6c079b6dfb8f58a4$var$getMultiErrorMessage(msg, failures);
}
$6c079b6dfb8f58a4$var$derive($6c079b6dfb8f58a4$var$ModifyError).from($6c079b6dfb8f58a4$var$DexieError);
function $6c079b6dfb8f58a4$var$BulkError(msg, failures) {
    this._e = $6c079b6dfb8f58a4$var$getErrorWithStack();
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $6c079b6dfb8f58a4$var$getMultiErrorMessage(msg, failures);
}
$6c079b6dfb8f58a4$var$derive($6c079b6dfb8f58a4$var$BulkError).from($6c079b6dfb8f58a4$var$DexieError);
var $6c079b6dfb8f58a4$var$errnames = $6c079b6dfb8f58a4$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $6c079b6dfb8f58a4$var$BaseException = $6c079b6dfb8f58a4$var$DexieError;
var $6c079b6dfb8f58a4$var$exceptions = $6c079b6dfb8f58a4$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this._e = $6c079b6dfb8f58a4$var$getErrorWithStack();
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $6c079b6dfb8f58a4$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === "string") {
            this.message = "" + msgOrInner + (!inner ? "" : "\n " + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === "object") {
            this.message = msgOrInner.name + " " + msgOrInner.message;
            this.inner = msgOrInner;
        }
    }
    $6c079b6dfb8f58a4$var$derive(DexieError).from($6c079b6dfb8f58a4$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$6c079b6dfb8f58a4$var$exceptions.Syntax = SyntaxError;
$6c079b6dfb8f58a4$var$exceptions.Type = TypeError;
$6c079b6dfb8f58a4$var$exceptions.Range = RangeError;
var $6c079b6dfb8f58a4$var$exceptionMap = $6c079b6dfb8f58a4$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $6c079b6dfb8f58a4$var$exceptions[name];
    return obj;
}, {});
function $6c079b6dfb8f58a4$var$mapError(domError, message) {
    if (!domError || domError instanceof $6c079b6dfb8f58a4$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$6c079b6dfb8f58a4$var$exceptionMap[domError.name]) return domError;
    var rv = new $6c079b6dfb8f58a4$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $6c079b6dfb8f58a4$var$setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $6c079b6dfb8f58a4$var$fullNameExceptions = $6c079b6dfb8f58a4$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $6c079b6dfb8f58a4$var$exceptions[name];
    return obj;
}, {});
$6c079b6dfb8f58a4$var$fullNameExceptions.ModifyError = $6c079b6dfb8f58a4$var$ModifyError;
$6c079b6dfb8f58a4$var$fullNameExceptions.DexieError = $6c079b6dfb8f58a4$var$DexieError;
$6c079b6dfb8f58a4$var$fullNameExceptions.BulkError = $6c079b6dfb8f58a4$var$BulkError;
function $6c079b6dfb8f58a4$var$nop() {}
function $6c079b6dfb8f58a4$var$mirror(val) {
    return val;
}
function $6c079b6dfb8f58a4$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $6c079b6dfb8f58a4$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $6c079b6dfb8f58a4$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $6c079b6dfb8f58a4$var$hookCreatingChain(f1, f2) {
    if (f1 === $6c079b6dfb8f58a4$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $6c079b6dfb8f58a4$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $6c079b6dfb8f58a4$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $6c079b6dfb8f58a4$var$hookDeletingChain(f1, f2) {
    if (f1 === $6c079b6dfb8f58a4$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $6c079b6dfb8f58a4$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $6c079b6dfb8f58a4$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $6c079b6dfb8f58a4$var$hookUpdatingChain(f1, f2) {
    if (f1 === $6c079b6dfb8f58a4$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $6c079b6dfb8f58a4$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $6c079b6dfb8f58a4$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $6c079b6dfb8f58a4$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $6c079b6dfb8f58a4$var$extend(res, res2);
    };
}
function $6c079b6dfb8f58a4$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $6c079b6dfb8f58a4$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $6c079b6dfb8f58a4$var$promisableChain(f1, f2) {
    if (f1 === $6c079b6dfb8f58a4$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === "function") {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $6c079b6dfb8f58a4$var$INTERNAL = {};
var $6c079b6dfb8f58a4$var$LONG_STACKS_CLIP_LIMIT = 100, $6c079b6dfb8f58a4$var$MAX_LONG_STACKS = 20, $6c079b6dfb8f58a4$var$ZONE_ECHO_LIMIT = 100, $6c079b6dfb8f58a4$var$_a$1 = typeof Promise === "undefined" ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === "undefined" || !crypto.subtle) return [
        globalP,
        $6c079b6dfb8f58a4$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $6c079b6dfb8f58a4$var$getProto(nativeP),
        globalP
    ];
}(), $6c079b6dfb8f58a4$var$resolvedNativePromise = $6c079b6dfb8f58a4$var$_a$1[0], $6c079b6dfb8f58a4$var$nativePromiseProto = $6c079b6dfb8f58a4$var$_a$1[1], $6c079b6dfb8f58a4$var$resolvedGlobalPromise = $6c079b6dfb8f58a4$var$_a$1[2], $6c079b6dfb8f58a4$var$nativePromiseThen = $6c079b6dfb8f58a4$var$nativePromiseProto && $6c079b6dfb8f58a4$var$nativePromiseProto.then;
var $6c079b6dfb8f58a4$var$NativePromise = $6c079b6dfb8f58a4$var$resolvedNativePromise && $6c079b6dfb8f58a4$var$resolvedNativePromise.constructor;
var $6c079b6dfb8f58a4$var$patchGlobalPromise = !!$6c079b6dfb8f58a4$var$resolvedGlobalPromise;
var $6c079b6dfb8f58a4$var$stack_being_generated = false;
var $6c079b6dfb8f58a4$var$schedulePhysicalTick = $6c079b6dfb8f58a4$var$resolvedGlobalPromise ? function() {
    $6c079b6dfb8f58a4$var$resolvedGlobalPromise.then($6c079b6dfb8f58a4$var$physicalTick);
} : $6c079b6dfb8f58a4$var$_global.setImmediate ? setImmediate.bind(null, $6c079b6dfb8f58a4$var$physicalTick) : $6c079b6dfb8f58a4$var$_global.MutationObserver ? function() {
    var hiddenDiv = document.createElement("div");
    new MutationObserver(function() {
        $6c079b6dfb8f58a4$var$physicalTick();
        hiddenDiv = null;
    }).observe(hiddenDiv, {
        attributes: true
    });
    hiddenDiv.setAttribute("i", "1");
} : function() {
    setTimeout($6c079b6dfb8f58a4$var$physicalTick, 0);
};
var $6c079b6dfb8f58a4$var$asap = function(callback, args) {
    $6c079b6dfb8f58a4$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($6c079b6dfb8f58a4$var$needsNewPhysicalTick) {
        $6c079b6dfb8f58a4$var$schedulePhysicalTick();
        $6c079b6dfb8f58a4$var$needsNewPhysicalTick = false;
    }
};
var $6c079b6dfb8f58a4$var$isOutsideMicroTick = true, $6c079b6dfb8f58a4$var$needsNewPhysicalTick = true, $6c079b6dfb8f58a4$var$unhandledErrors = [], $6c079b6dfb8f58a4$var$rejectingErrors = [], $6c079b6dfb8f58a4$var$currentFulfiller = null, $6c079b6dfb8f58a4$var$rejectionMapper = $6c079b6dfb8f58a4$var$mirror;
var $6c079b6dfb8f58a4$var$globalPSD = {
    id: "global",
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $6c079b6dfb8f58a4$var$globalError,
    pgp: false,
    env: {},
    finalize: function() {
        this.unhandleds.forEach(function(uh) {
            try {
                $6c079b6dfb8f58a4$var$globalError(uh[0], uh[1]);
            } catch (e) {}
        });
    }
};
var $6c079b6dfb8f58a4$var$PSD = $6c079b6dfb8f58a4$var$globalPSD;
var $6c079b6dfb8f58a4$var$microtickQueue = [];
var $6c079b6dfb8f58a4$var$numScheduledCalls = 0;
var $6c079b6dfb8f58a4$var$tickFinalizers = [];
function $6c079b6dfb8f58a4$var$DexiePromise(fn) {
    if (typeof this !== "object") throw new TypeError("Promises must be constructed via new");
    this._listeners = [];
    this.onuncatched = $6c079b6dfb8f58a4$var$nop;
    this._lib = false;
    var psd = this._PSD = $6c079b6dfb8f58a4$var$PSD;
    if ($6c079b6dfb8f58a4$var$debug) {
        this._stackHolder = $6c079b6dfb8f58a4$var$getErrorWithStack();
        this._prev = null;
        this._numPrev = 0;
    }
    if (typeof fn !== "function") {
        if (fn !== $6c079b6dfb8f58a4$var$INTERNAL) throw new TypeError("Not a function");
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $6c079b6dfb8f58a4$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $6c079b6dfb8f58a4$var$executePromiseTask(this, fn);
}
var $6c079b6dfb8f58a4$var$thenProp = {
    get: function() {
        var psd = $6c079b6dfb8f58a4$var$PSD, microTaskId = $6c079b6dfb8f58a4$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $6c079b6dfb8f58a4$var$PSD || microTaskId !== $6c079b6dfb8f58a4$var$totalEchoes);
            var cleanup = possibleAwait && !$6c079b6dfb8f58a4$var$decrementExpectedAwaits();
            var rv = new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
                $6c079b6dfb8f58a4$var$propagateToListener(_this, new $6c079b6dfb8f58a4$var$Listener($6c079b6dfb8f58a4$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $6c079b6dfb8f58a4$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            $6c079b6dfb8f58a4$var$debug && $6c079b6dfb8f58a4$var$linkToPreviousPromise(rv, this);
            return rv;
        }
        then.prototype = $6c079b6dfb8f58a4$var$INTERNAL;
        return then;
    },
    set: function(value) {
        $6c079b6dfb8f58a4$var$setProp(this, "then", value && value.prototype === $6c079b6dfb8f58a4$var$INTERNAL ? $6c079b6dfb8f58a4$var$thenProp : {
            get: function() {
                return value;
            },
            set: $6c079b6dfb8f58a4$var$thenProp.set
        });
    }
};
$6c079b6dfb8f58a4$var$props($6c079b6dfb8f58a4$var$DexiePromise.prototype, {
    then: $6c079b6dfb8f58a4$var$thenProp,
    _then: function(onFulfilled, onRejected) {
        $6c079b6dfb8f58a4$var$propagateToListener(this, new $6c079b6dfb8f58a4$var$Listener(null, null, onFulfilled, onRejected, $6c079b6dfb8f58a4$var$PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === "function" ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $6c079b6dfb8f58a4$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $6c079b6dfb8f58a4$var$PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            onFinally();
            return value;
        }, function(err) {
            onFinally();
            return $6c079b6dfb8f58a4$var$PromiseReject(err);
        });
    },
    stack: {
        get: function() {
            if (this._stack) return this._stack;
            try {
                $6c079b6dfb8f58a4$var$stack_being_generated = true;
                var stacks = $6c079b6dfb8f58a4$var$getStack(this, [], $6c079b6dfb8f58a4$var$MAX_LONG_STACKS);
                var stack = stacks.join("\nFrom previous: ");
                if (this._state !== null) this._stack = stack;
                return stack;
            } finally{
                $6c079b6dfb8f58a4$var$stack_being_generated = false;
            }
        }
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $6c079b6dfb8f58a4$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag) $6c079b6dfb8f58a4$var$setProp($6c079b6dfb8f58a4$var$DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise");
$6c079b6dfb8f58a4$var$globalPSD.env = $6c079b6dfb8f58a4$var$snapShot();
function $6c079b6dfb8f58a4$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$6c079b6dfb8f58a4$var$props($6c079b6dfb8f58a4$var$DexiePromise, {
    all: function() {
        var values = $6c079b6dfb8f58a4$var$getArrayOf.apply(null, arguments).map($6c079b6dfb8f58a4$var$onPossibleParallellAsync);
        return new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $6c079b6dfb8f58a4$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof $6c079b6dfb8f58a4$var$DexiePromise) return value;
        if (value && typeof value.then === "function") return new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $6c079b6dfb8f58a4$var$DexiePromise($6c079b6dfb8f58a4$var$INTERNAL, true, value);
        $6c079b6dfb8f58a4$var$linkToPreviousPromise(rv, $6c079b6dfb8f58a4$var$currentFulfiller);
        return rv;
    },
    reject: $6c079b6dfb8f58a4$var$PromiseReject,
    race: function() {
        var values = $6c079b6dfb8f58a4$var$getArrayOf.apply(null, arguments).map($6c079b6dfb8f58a4$var$onPossibleParallellAsync);
        return new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $6c079b6dfb8f58a4$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return $6c079b6dfb8f58a4$var$PSD;
        },
        set: function(value) {
            return $6c079b6dfb8f58a4$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function() {
            return $6c079b6dfb8f58a4$var$totalEchoes;
        }
    },
    newPSD: $6c079b6dfb8f58a4$var$newScope,
    usePSD: $6c079b6dfb8f58a4$var$usePSD,
    scheduler: {
        get: function() {
            return $6c079b6dfb8f58a4$var$asap;
        },
        set: function(value) {
            $6c079b6dfb8f58a4$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return $6c079b6dfb8f58a4$var$rejectionMapper;
        },
        set: function(value) {
            $6c079b6dfb8f58a4$var$rejectionMapper = value;
        }
    },
    follow: function(fn, zoneProps) {
        return new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            return $6c079b6dfb8f58a4$var$newScope(function(resolve, reject) {
                var psd = $6c079b6dfb8f58a4$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $6c079b6dfb8f58a4$var$callBoth(function() {
                    var _this = this;
                    $6c079b6dfb8f58a4$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($6c079b6dfb8f58a4$var$NativePromise) {
    if ($6c079b6dfb8f58a4$var$NativePromise.allSettled) $6c079b6dfb8f58a4$var$setProp($6c079b6dfb8f58a4$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $6c079b6dfb8f58a4$var$getArrayOf.apply(null, arguments).map($6c079b6dfb8f58a4$var$onPossibleParallellAsync);
        return new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $6c079b6dfb8f58a4$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($6c079b6dfb8f58a4$var$NativePromise.any && typeof AggregateError !== "undefined") $6c079b6dfb8f58a4$var$setProp($6c079b6dfb8f58a4$var$DexiePromise, "any", function() {
        var possiblePromises = $6c079b6dfb8f58a4$var$getArrayOf.apply(null, arguments).map($6c079b6dfb8f58a4$var$onPossibleParallellAsync);
        return new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $6c079b6dfb8f58a4$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
}
function $6c079b6dfb8f58a4$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError("A promise cannot be resolved with itself.");
            var shouldExecuteTick = promise._lib && $6c079b6dfb8f58a4$var$beginMicroTickScope();
            if (value && typeof value.then === "function") $6c079b6dfb8f58a4$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $6c079b6dfb8f58a4$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $6c079b6dfb8f58a4$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $6c079b6dfb8f58a4$var$endMicroTickScope();
        }, $6c079b6dfb8f58a4$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $6c079b6dfb8f58a4$var$handleRejection(promise, ex);
    }
}
function $6c079b6dfb8f58a4$var$handleRejection(promise, reason) {
    $6c079b6dfb8f58a4$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $6c079b6dfb8f58a4$var$beginMicroTickScope();
    reason = $6c079b6dfb8f58a4$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $6c079b6dfb8f58a4$var$debug && reason !== null && typeof reason === "object" && !reason._promise && $6c079b6dfb8f58a4$var$tryCatch(function() {
        var origProp = $6c079b6dfb8f58a4$var$getPropertyDescriptor(reason, "stack");
        reason._promise = promise;
        $6c079b6dfb8f58a4$var$setProp(reason, "stack", {
            get: function() {
                return $6c079b6dfb8f58a4$var$stack_being_generated ? origProp && (origProp.get ? origProp.get.apply(reason) : origProp.value) : promise.stack;
            }
        });
    });
    $6c079b6dfb8f58a4$var$addPossiblyUnhandledError(promise);
    $6c079b6dfb8f58a4$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $6c079b6dfb8f58a4$var$endMicroTickScope();
}
function $6c079b6dfb8f58a4$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$6c079b6dfb8f58a4$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($6c079b6dfb8f58a4$var$numScheduledCalls === 0) {
        ++$6c079b6dfb8f58a4$var$numScheduledCalls;
        $6c079b6dfb8f58a4$var$asap(function() {
            if (--$6c079b6dfb8f58a4$var$numScheduledCalls === 0) $6c079b6dfb8f58a4$var$finalizePhysicalTick();
        }, []);
    }
}
function $6c079b6dfb8f58a4$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$6c079b6dfb8f58a4$var$numScheduledCalls;
    $6c079b6dfb8f58a4$var$asap($6c079b6dfb8f58a4$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $6c079b6dfb8f58a4$var$callListener(cb, promise, listener) {
    try {
        $6c079b6dfb8f58a4$var$currentFulfiller = promise;
        var ret, value = promise._value;
        if (promise._state) ret = cb(value);
        else {
            if ($6c079b6dfb8f58a4$var$rejectingErrors.length) $6c079b6dfb8f58a4$var$rejectingErrors = [];
            ret = cb(value);
            if ($6c079b6dfb8f58a4$var$rejectingErrors.indexOf(value) === -1) $6c079b6dfb8f58a4$var$markErrorAsHandled(promise);
        }
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        $6c079b6dfb8f58a4$var$currentFulfiller = null;
        if (--$6c079b6dfb8f58a4$var$numScheduledCalls === 0) $6c079b6dfb8f58a4$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $6c079b6dfb8f58a4$var$getStack(promise, stacks, limit) {
    if (stacks.length === limit) return stacks;
    var stack = "";
    if (promise._state === false) {
        var failure = promise._value, errorName, message;
        if (failure != null) {
            errorName = failure.name || "Error";
            message = failure.message || failure;
            stack = $6c079b6dfb8f58a4$var$prettyStack(failure, 0);
        } else {
            errorName = failure;
            message = "";
        }
        stacks.push(errorName + (message ? ": " + message : "") + stack);
    }
    if ($6c079b6dfb8f58a4$var$debug) {
        stack = $6c079b6dfb8f58a4$var$prettyStack(promise._stackHolder, 2);
        if (stack && stacks.indexOf(stack) === -1) stacks.push(stack);
        if (promise._prev) $6c079b6dfb8f58a4$var$getStack(promise._prev, stacks, limit);
    }
    return stacks;
}
function $6c079b6dfb8f58a4$var$linkToPreviousPromise(promise, prev) {
    var numPrev = prev ? prev._numPrev + 1 : 0;
    if (numPrev < $6c079b6dfb8f58a4$var$LONG_STACKS_CLIP_LIMIT) {
        promise._prev = prev;
        promise._numPrev = numPrev;
    }
}
function $6c079b6dfb8f58a4$var$physicalTick() {
    $6c079b6dfb8f58a4$var$beginMicroTickScope() && $6c079b6dfb8f58a4$var$endMicroTickScope();
}
function $6c079b6dfb8f58a4$var$beginMicroTickScope() {
    var wasRootExec = $6c079b6dfb8f58a4$var$isOutsideMicroTick;
    $6c079b6dfb8f58a4$var$isOutsideMicroTick = false;
    $6c079b6dfb8f58a4$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $6c079b6dfb8f58a4$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($6c079b6dfb8f58a4$var$microtickQueue.length > 0){
        callbacks = $6c079b6dfb8f58a4$var$microtickQueue;
        $6c079b6dfb8f58a4$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($6c079b6dfb8f58a4$var$microtickQueue.length > 0);
    $6c079b6dfb8f58a4$var$isOutsideMicroTick = true;
    $6c079b6dfb8f58a4$var$needsNewPhysicalTick = true;
}
function $6c079b6dfb8f58a4$var$finalizePhysicalTick() {
    var unhandledErrs = $6c079b6dfb8f58a4$var$unhandledErrors;
    $6c079b6dfb8f58a4$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $6c079b6dfb8f58a4$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $6c079b6dfb8f58a4$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $6c079b6dfb8f58a4$var$tickFinalizers.splice($6c079b6dfb8f58a4$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $6c079b6dfb8f58a4$var$tickFinalizers.push(finalizer);
    ++$6c079b6dfb8f58a4$var$numScheduledCalls;
    $6c079b6dfb8f58a4$var$asap(function() {
        if (--$6c079b6dfb8f58a4$var$numScheduledCalls === 0) $6c079b6dfb8f58a4$var$finalizePhysicalTick();
    }, []);
}
function $6c079b6dfb8f58a4$var$addPossiblyUnhandledError(promise) {
    if (!$6c079b6dfb8f58a4$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $6c079b6dfb8f58a4$var$unhandledErrors.push(promise);
}
function $6c079b6dfb8f58a4$var$markErrorAsHandled(promise) {
    var i = $6c079b6dfb8f58a4$var$unhandledErrors.length;
    while(i)if ($6c079b6dfb8f58a4$var$unhandledErrors[--i]._value === promise._value) {
        $6c079b6dfb8f58a4$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $6c079b6dfb8f58a4$var$PromiseReject(reason) {
    return new $6c079b6dfb8f58a4$var$DexiePromise($6c079b6dfb8f58a4$var$INTERNAL, false, reason);
}
function $6c079b6dfb8f58a4$var$wrap(fn, errorCatcher) {
    var psd = $6c079b6dfb8f58a4$var$PSD;
    return function() {
        var wasRootExec = $6c079b6dfb8f58a4$var$beginMicroTickScope(), outerScope = $6c079b6dfb8f58a4$var$PSD;
        try {
            $6c079b6dfb8f58a4$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $6c079b6dfb8f58a4$var$switchToZone(outerScope, false);
            if (wasRootExec) $6c079b6dfb8f58a4$var$endMicroTickScope();
        }
    };
}
var $6c079b6dfb8f58a4$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $6c079b6dfb8f58a4$var$taskCounter = 0;
var $6c079b6dfb8f58a4$var$zoneStack = [];
var $6c079b6dfb8f58a4$var$zoneEchoes = 0;
var $6c079b6dfb8f58a4$var$totalEchoes = 0;
var $6c079b6dfb8f58a4$var$zone_id_counter = 0;
function $6c079b6dfb8f58a4$var$newScope(fn, props, a1, a2) {
    var parent = $6c079b6dfb8f58a4$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$6c079b6dfb8f58a4$var$zone_id_counter;
    var globalEnv = $6c079b6dfb8f58a4$var$globalPSD.env;
    psd.env = $6c079b6dfb8f58a4$var$patchGlobalPromise ? {
        Promise: $6c079b6dfb8f58a4$var$DexiePromise,
        PromiseProp: {
            value: $6c079b6dfb8f58a4$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $6c079b6dfb8f58a4$var$DexiePromise.all,
        race: $6c079b6dfb8f58a4$var$DexiePromise.race,
        allSettled: $6c079b6dfb8f58a4$var$DexiePromise.allSettled,
        any: $6c079b6dfb8f58a4$var$DexiePromise.any,
        resolve: $6c079b6dfb8f58a4$var$DexiePromise.resolve,
        reject: $6c079b6dfb8f58a4$var$DexiePromise.reject,
        nthen: $6c079b6dfb8f58a4$var$getPatchedPromiseThen(globalEnv.nthen, psd),
        gthen: $6c079b6dfb8f58a4$var$getPatchedPromiseThen(globalEnv.gthen, psd)
    } : {};
    if (props) $6c079b6dfb8f58a4$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $6c079b6dfb8f58a4$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $6c079b6dfb8f58a4$var$incrementExpectedAwaits() {
    if (!$6c079b6dfb8f58a4$var$task.id) $6c079b6dfb8f58a4$var$task.id = ++$6c079b6dfb8f58a4$var$taskCounter;
    ++$6c079b6dfb8f58a4$var$task.awaits;
    $6c079b6dfb8f58a4$var$task.echoes += $6c079b6dfb8f58a4$var$ZONE_ECHO_LIMIT;
    return $6c079b6dfb8f58a4$var$task.id;
}
function $6c079b6dfb8f58a4$var$decrementExpectedAwaits() {
    if (!$6c079b6dfb8f58a4$var$task.awaits) return false;
    if (--$6c079b6dfb8f58a4$var$task.awaits === 0) $6c079b6dfb8f58a4$var$task.id = 0;
    $6c079b6dfb8f58a4$var$task.echoes = $6c079b6dfb8f58a4$var$task.awaits * $6c079b6dfb8f58a4$var$ZONE_ECHO_LIMIT;
    return true;
}
if (("" + $6c079b6dfb8f58a4$var$nativePromiseThen).indexOf("[native code]") === -1) $6c079b6dfb8f58a4$var$incrementExpectedAwaits = $6c079b6dfb8f58a4$var$decrementExpectedAwaits = $6c079b6dfb8f58a4$var$nop;
function $6c079b6dfb8f58a4$var$onPossibleParallellAsync(possiblePromise) {
    if ($6c079b6dfb8f58a4$var$task.echoes && possiblePromise && possiblePromise.constructor === $6c079b6dfb8f58a4$var$NativePromise) {
        $6c079b6dfb8f58a4$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $6c079b6dfb8f58a4$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $6c079b6dfb8f58a4$var$decrementExpectedAwaits();
            return $6c079b6dfb8f58a4$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $6c079b6dfb8f58a4$var$zoneEnterEcho(targetZone) {
    ++$6c079b6dfb8f58a4$var$totalEchoes;
    if (!$6c079b6dfb8f58a4$var$task.echoes || --$6c079b6dfb8f58a4$var$task.echoes === 0) $6c079b6dfb8f58a4$var$task.echoes = $6c079b6dfb8f58a4$var$task.id = 0;
    $6c079b6dfb8f58a4$var$zoneStack.push($6c079b6dfb8f58a4$var$PSD);
    $6c079b6dfb8f58a4$var$switchToZone(targetZone, true);
}
function $6c079b6dfb8f58a4$var$zoneLeaveEcho() {
    var zone = $6c079b6dfb8f58a4$var$zoneStack[$6c079b6dfb8f58a4$var$zoneStack.length - 1];
    $6c079b6dfb8f58a4$var$zoneStack.pop();
    $6c079b6dfb8f58a4$var$switchToZone(zone, false);
}
function $6c079b6dfb8f58a4$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $6c079b6dfb8f58a4$var$PSD;
    if (bEnteringZone ? $6c079b6dfb8f58a4$var$task.echoes && (!$6c079b6dfb8f58a4$var$zoneEchoes++ || targetZone !== $6c079b6dfb8f58a4$var$PSD) : $6c079b6dfb8f58a4$var$zoneEchoes && (!--$6c079b6dfb8f58a4$var$zoneEchoes || targetZone !== $6c079b6dfb8f58a4$var$PSD)) $6c079b6dfb8f58a4$var$enqueueNativeMicroTask(bEnteringZone ? $6c079b6dfb8f58a4$var$zoneEnterEcho.bind(null, targetZone) : $6c079b6dfb8f58a4$var$zoneLeaveEcho);
    if (targetZone === $6c079b6dfb8f58a4$var$PSD) return;
    $6c079b6dfb8f58a4$var$PSD = targetZone;
    if (currentZone === $6c079b6dfb8f58a4$var$globalPSD) $6c079b6dfb8f58a4$var$globalPSD.env = $6c079b6dfb8f58a4$var$snapShot();
    if ($6c079b6dfb8f58a4$var$patchGlobalPromise) {
        var GlobalPromise_1 = $6c079b6dfb8f58a4$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        $6c079b6dfb8f58a4$var$nativePromiseProto.then = targetEnv.nthen;
        GlobalPromise_1.prototype.then = targetEnv.gthen;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($6c079b6dfb8f58a4$var$_global, "Promise", targetEnv.PromiseProp);
            GlobalPromise_1.all = targetEnv.all;
            GlobalPromise_1.race = targetEnv.race;
            GlobalPromise_1.resolve = targetEnv.resolve;
            GlobalPromise_1.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise_1.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise_1.any = targetEnv.any;
        }
    }
}
function $6c079b6dfb8f58a4$var$snapShot() {
    var GlobalPromise = $6c079b6dfb8f58a4$var$_global.Promise;
    return $6c079b6dfb8f58a4$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($6c079b6dfb8f58a4$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject,
        nthen: $6c079b6dfb8f58a4$var$nativePromiseProto.then,
        gthen: GlobalPromise.prototype.then
    } : {};
}
function $6c079b6dfb8f58a4$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $6c079b6dfb8f58a4$var$PSD;
    try {
        $6c079b6dfb8f58a4$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $6c079b6dfb8f58a4$var$switchToZone(outerScope, false);
    }
}
function $6c079b6dfb8f58a4$var$enqueueNativeMicroTask(job) {
    $6c079b6dfb8f58a4$var$nativePromiseThen.call($6c079b6dfb8f58a4$var$resolvedNativePromise, job);
}
function $6c079b6dfb8f58a4$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== "function" ? fn : function() {
        var outerZone = $6c079b6dfb8f58a4$var$PSD;
        if (possibleAwait) $6c079b6dfb8f58a4$var$incrementExpectedAwaits();
        $6c079b6dfb8f58a4$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $6c079b6dfb8f58a4$var$switchToZone(outerZone, false);
            if (cleanup) $6c079b6dfb8f58a4$var$enqueueNativeMicroTask($6c079b6dfb8f58a4$var$decrementExpectedAwaits);
        }
    };
}
function $6c079b6dfb8f58a4$var$getPatchedPromiseThen(origThen, zone) {
    return function(onResolved, onRejected) {
        return origThen.call(this, $6c079b6dfb8f58a4$var$nativeAwaitCompatibleWrap(onResolved, zone), $6c079b6dfb8f58a4$var$nativeAwaitCompatibleWrap(onRejected, zone));
    };
}
var $6c079b6dfb8f58a4$var$UNHANDLEDREJECTION = "unhandledrejection";
function $6c079b6dfb8f58a4$var$globalError(err, promise) {
    var rv;
    try {
        rv = promise.onuncatched(err);
    } catch (e) {}
    if (rv !== false) try {
        var event, eventData = {
            promise: promise,
            reason: err
        };
        if ($6c079b6dfb8f58a4$var$_global.document && document.createEvent) {
            event = document.createEvent("Event");
            event.initEvent($6c079b6dfb8f58a4$var$UNHANDLEDREJECTION, true, true);
            $6c079b6dfb8f58a4$var$extend(event, eventData);
        } else if ($6c079b6dfb8f58a4$var$_global.CustomEvent) {
            event = new CustomEvent($6c079b6dfb8f58a4$var$UNHANDLEDREJECTION, {
                detail: eventData
            });
            $6c079b6dfb8f58a4$var$extend(event, eventData);
        }
        if (event && $6c079b6dfb8f58a4$var$_global.dispatchEvent) {
            dispatchEvent(event);
            if (!$6c079b6dfb8f58a4$var$_global.PromiseRejectionEvent && $6c079b6dfb8f58a4$var$_global.onunhandledrejection) try {
                $6c079b6dfb8f58a4$var$_global.onunhandledrejection(event);
            } catch (_) {}
        }
        if ($6c079b6dfb8f58a4$var$debug && event && !event.defaultPrevented) console.warn("Unhandled rejection: " + (err.stack || err));
    } catch (e) {}
}
var $6c079b6dfb8f58a4$var$rejection = $6c079b6dfb8f58a4$var$DexiePromise.reject;
function $6c079b6dfb8f58a4$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$6c079b6dfb8f58a4$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $6c079b6dfb8f58a4$var$rejection(new $6c079b6dfb8f58a4$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._options.autoOpen) return $6c079b6dfb8f58a4$var$rejection(new $6c079b6dfb8f58a4$var$exceptions.DatabaseClosed());
            db.open().catch($6c079b6dfb8f58a4$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $6c079b6dfb8f58a4$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $6c079b6dfb8f58a4$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $6c079b6dfb8f58a4$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $6c079b6dfb8f58a4$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $6c079b6dfb8f58a4$var$newScope(function() {
                $6c079b6dfb8f58a4$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            return trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $6c079b6dfb8f58a4$var$DEXIE_VERSION = "3.2.7";
var $6c079b6dfb8f58a4$var$maxString = String.fromCharCode(65535);
var $6c079b6dfb8f58a4$var$minKey = -Infinity;
var $6c079b6dfb8f58a4$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $6c079b6dfb8f58a4$var$STRING_EXPECTED = "String expected.";
var $6c079b6dfb8f58a4$var$connections = [];
var $6c079b6dfb8f58a4$var$isIEOrEdge = typeof navigator !== "undefined" && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
var $6c079b6dfb8f58a4$var$hasIEDeleteObjectStoreBug = $6c079b6dfb8f58a4$var$isIEOrEdge;
var $6c079b6dfb8f58a4$var$hangsOnDeleteLargeKeyRange = $6c079b6dfb8f58a4$var$isIEOrEdge;
var $6c079b6dfb8f58a4$var$dexieStackFrameFilter = function(frame) {
    return !/(dexie\.js|dexie\.min\.js)/.test(frame);
};
var $6c079b6dfb8f58a4$var$DBNAMES_DB = "__dbnames";
var $6c079b6dfb8f58a4$var$READONLY = "readonly";
var $6c079b6dfb8f58a4$var$READWRITE = "readwrite";
function $6c079b6dfb8f58a4$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $6c079b6dfb8f58a4$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $6c079b6dfb8f58a4$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $6c079b6dfb8f58a4$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
var $6c079b6dfb8f58a4$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $6c079b6dfb8f58a4$var$PSD.trans;
        var tableName = this.name;
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $6c079b6dfb8f58a4$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $6c079b6dfb8f58a4$var$beginMicroTickScope();
        try {
            return trans && trans.db === this.db ? trans === $6c079b6dfb8f58a4$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $6c079b6dfb8f58a4$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $6c079b6dfb8f58a4$var$PSD.transless || $6c079b6dfb8f58a4$var$PSD
            }) : $6c079b6dfb8f58a4$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
        } finally{
            if (wasRootExec) $6c079b6dfb8f58a4$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        return this._trans("readonly", function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === "string") return new this.db.WhereClause(this, indexOrCrit);
        if ($6c079b6dfb8f58a4$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[" + indexOrCrit.join("+") + "]");
        var keyPaths = $6c079b6dfb8f58a4$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== $6c079b6dfb8f58a4$var$maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && $6c079b6dfb8f58a4$var$debug) console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " + ("compound index [" + keyPaths.join("+") + "]"));
        var idxByName = this.schema.idxByName;
        var idb = this.db._deps.indexedDB;
        function equals(a, b) {
            try {
                return idb.cmp(a, b) === 0;
            } catch (e) {
                return false;
            }
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $6c079b6dfb8f58a4$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $6c079b6dfb8f58a4$var$getByKeyPath(x, keyPath);
                    return $6c079b6dfb8f58a4$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $6c079b6dfb8f58a4$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals("");
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $6c079b6dfb8f58a4$var$isArray(index) ? "[" + index.join("+") + "]" : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        this.schema.mappedClass = constructor;
        var readHook = function(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if ($6c079b6dfb8f58a4$var$hasOwn(obj, m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $6c079b6dfb8f58a4$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $6c079b6dfb8f58a4$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $6c079b6dfb8f58a4$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $6c079b6dfb8f58a4$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === "object" && !$6c079b6dfb8f58a4$var$isArray(keyOrObject)) {
            var key = $6c079b6dfb8f58a4$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $6c079b6dfb8f58a4$var$rejection(new $6c079b6dfb8f58a4$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            try {
                if (typeof modifications !== "function") $6c079b6dfb8f58a4$var$keys(modifications).forEach(function(keyPath) {
                    $6c079b6dfb8f58a4$var$setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
                });
                else modifications(keyOrObject, {
                    value: keyOrObject,
                    primKey: key
                });
            } catch (_a) {}
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $6c079b6dfb8f58a4$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "put",
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $6c079b6dfb8f58a4$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $6c079b6dfb8f58a4$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: [
                    key
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $6c079b6dfb8f58a4$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "deleteRange",
                range: $6c079b6dfb8f58a4$var$AnyRange
            });
        }).then(function(res) {
            return res.numFailures ? $6c079b6dfb8f58a4$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans("readonly", function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $6c079b6dfb8f58a4$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $6c079b6dfb8f58a4$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($6c079b6dfb8f58a4$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $6c079b6dfb8f58a4$var$BulkError(_this.name + ".bulkAdd(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $6c079b6dfb8f58a4$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $6c079b6dfb8f58a4$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($6c079b6dfb8f58a4$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "put",
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $6c079b6dfb8f58a4$var$BulkError(_this.name + ".bulkPut(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: keys
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $6c079b6dfb8f58a4$var$BulkError(_this.name + ".bulkDelete(): " + numFailures + " of " + numKeys + " operations failed", failures);
        });
    };
    return Table;
}();
function $6c079b6dfb8f58a4$var$Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === "string") return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === "object") return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $6c079b6dfb8f58a4$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $6c079b6dfb8f58a4$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $6c079b6dfb8f58a4$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($6c079b6dfb8f58a4$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === "asap") var context = add(eventName, $6c079b6dfb8f58a4$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $6c079b6dfb8f58a4$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $6c079b6dfb8f58a4$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $6c079b6dfb8f58a4$var$makeClassConstructor(prototype, constructor) {
    $6c079b6dfb8f58a4$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $6c079b6dfb8f58a4$var$createTableConstructor(db) {
    return $6c079b6dfb8f58a4$var$makeClassConstructor($6c079b6dfb8f58a4$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $6c079b6dfb8f58a4$var$Events(null, {
            "creating": [
                $6c079b6dfb8f58a4$var$hookCreatingChain,
                $6c079b6dfb8f58a4$var$nop
            ],
            "reading": [
                $6c079b6dfb8f58a4$var$pureFunctionChain,
                $6c079b6dfb8f58a4$var$mirror
            ],
            "updating": [
                $6c079b6dfb8f58a4$var$hookUpdatingChain,
                $6c079b6dfb8f58a4$var$nop
            ],
            "deleting": [
                $6c079b6dfb8f58a4$var$hookDeletingChain,
                $6c079b6dfb8f58a4$var$nop
            ]
        });
    });
}
function $6c079b6dfb8f58a4$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $6c079b6dfb8f58a4$var$addFilter(ctx, fn) {
    ctx.filter = $6c079b6dfb8f58a4$var$combine(ctx.filter, fn);
}
function $6c079b6dfb8f58a4$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $6c079b6dfb8f58a4$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $6c079b6dfb8f58a4$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $6c079b6dfb8f58a4$var$combine(ctx.isMatch, fn);
}
function $6c079b6dfb8f58a4$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $6c079b6dfb8f58a4$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $6c079b6dfb8f58a4$var$openCursor(ctx, coreTable, trans) {
    var index = $6c079b6dfb8f58a4$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === "prev",
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $6c079b6dfb8f58a4$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $6c079b6dfb8f58a4$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $6c079b6dfb8f58a4$var$iterate($6c079b6dfb8f58a4$var$openCursor(ctx, coreTable, coreTrans), $6c079b6dfb8f58a4$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = "" + primaryKey;
                if (key === "[object ArrayBuffer]") key = "" + new Uint8Array(primaryKey);
                if (!$6c079b6dfb8f58a4$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $6c079b6dfb8f58a4$var$iterate($6c079b6dfb8f58a4$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $6c079b6dfb8f58a4$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $6c079b6dfb8f58a4$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $6c079b6dfb8f58a4$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $6c079b6dfb8f58a4$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
function $6c079b6dfb8f58a4$var$cmp(a, b) {
    try {
        var ta = $6c079b6dfb8f58a4$var$type(a);
        var tb = $6c079b6dfb8f58a4$var$type(b);
        if (ta !== tb) {
            if (ta === "Array") return 1;
            if (tb === "Array") return -1;
            if (ta === "binary") return 1;
            if (tb === "binary") return -1;
            if (ta === "string") return 1;
            if (tb === "string") return -1;
            if (ta === "Date") return 1;
            if (tb !== "Date") return NaN;
            return -1;
        }
        switch(ta){
            case "number":
            case "Date":
            case "string":
                return a > b ? 1 : a < b ? -1 : 0;
            case "binary":
                return $6c079b6dfb8f58a4$var$compareUint8Arrays($6c079b6dfb8f58a4$var$getUint8Array(a), $6c079b6dfb8f58a4$var$getUint8Array(b));
            case "Array":
                return $6c079b6dfb8f58a4$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $6c079b6dfb8f58a4$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $6c079b6dfb8f58a4$var$cmp(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $6c079b6dfb8f58a4$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $6c079b6dfb8f58a4$var$type(x) {
    var t = typeof x;
    if (t !== "object") return t;
    if (ArrayBuffer.isView(x)) return "binary";
    var tsTag = $6c079b6dfb8f58a4$var$toStringTag(x);
    return tsTag === "ArrayBuffer" ? "binary" : tsTag;
}
function $6c079b6dfb8f58a4$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
var $6c079b6dfb8f58a4$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $6c079b6dfb8f58a4$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readonly", fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $6c079b6dfb8f58a4$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readwrite", fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $6c079b6dfb8f58a4$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $6c079b6dfb8f58a4$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $6c079b6dfb8f58a4$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $6c079b6dfb8f58a4$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($6c079b6dfb8f58a4$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $6c079b6dfb8f58a4$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $6c079b6dfb8f58a4$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split(".").reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return aVal < bVal ? -order : aVal > bVal ? order : 0;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === "next" && $6c079b6dfb8f58a4$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $6c079b6dfb8f58a4$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $6c079b6dfb8f58a4$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($6c079b6dfb8f58a4$var$isPlainKeyRange(ctx)) $6c079b6dfb8f58a4$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $6c079b6dfb8f58a4$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $6c079b6dfb8f58a4$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $6c079b6dfb8f58a4$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $6c079b6dfb8f58a4$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $6c079b6dfb8f58a4$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === "next" && $6c079b6dfb8f58a4$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $6c079b6dfb8f58a4$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $6c079b6dfb8f58a4$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $6c079b6dfb8f58a4$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === "function") modifyer = changes;
            else {
                var keyPaths = $6c079b6dfb8f58a4$var$keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i], val = changes[keyPath];
                        if ($6c079b6dfb8f58a4$var$getByKeyPath(item, keyPath) !== val) {
                            $6c079b6dfb8f58a4$var$setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = _this.db._options.modifyChunkSize || 200;
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $6c079b6dfb8f58a4$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            return _this.clone().primaryKeys().then(function(keys) {
                var nextChunk = function(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    return coreTable.getMany({
                        trans: trans,
                        keys: keys.slice(offset, offset + count),
                        cache: "immutable"
                    }).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = [];
                        for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $6c079b6dfb8f58a4$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $6c079b6dfb8f58a4$var$cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        var criteria = $6c079b6dfb8f58a4$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== "function" || changes === $6c079b6dfb8f58a4$var$deleteCallback) && {
                            index: ctx.index,
                            range: ctx.range
                        };
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: "add",
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === "object") && coreTable.mutate({
                                trans: trans,
                                type: "put",
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== "function" && changes
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && changes === $6c079b6dfb8f58a4$var$deleteCallback) && coreTable.mutate({
                                trans: trans,
                                type: "delete",
                                keys: deleteKeys,
                                criteria: criteria
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $6c079b6dfb8f58a4$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($6c079b6dfb8f58a4$var$isPlainKeyRange(ctx) && (ctx.isPrimKey && !$6c079b6dfb8f58a4$var$hangsOnDeleteLargeKeyRange || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: "deleteRange",
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures;
                    _a.lastResult;
                    _a.results;
                    var numFailures = _a.numFailures;
                    if (numFailures) throw new $6c079b6dfb8f58a4$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($6c079b6dfb8f58a4$var$deleteCallback);
    };
    return Collection;
}();
var $6c079b6dfb8f58a4$var$deleteCallback = function(value, ctx) {
    return ctx.value = null;
};
function $6c079b6dfb8f58a4$var$createCollectionConstructor(db) {
    return $6c079b6dfb8f58a4$var$makeClassConstructor($6c079b6dfb8f58a4$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $6c079b6dfb8f58a4$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $6c079b6dfb8f58a4$var$mirror ? readingHook : null
        };
    });
}
function $6c079b6dfb8f58a4$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $6c079b6dfb8f58a4$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $6c079b6dfb8f58a4$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $6c079b6dfb8f58a4$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $6c079b6dfb8f58a4$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $6c079b6dfb8f58a4$var$rangeEqual("");
    }).limit(0);
}
function $6c079b6dfb8f58a4$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $6c079b6dfb8f58a4$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $6c079b6dfb8f58a4$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $6c079b6dfb8f58a4$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === "string";
    })) return $6c079b6dfb8f58a4$var$fail(whereClause, $6c079b6dfb8f58a4$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $6c079b6dfb8f58a4$var$upperFactory(dir);
        lower = $6c079b6dfb8f58a4$var$lowerFactory(dir);
        compare = dir === "next" ? $6c079b6dfb8f58a4$var$simpleCompare : $6c079b6dfb8f58a4$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $6c079b6dfb8f58a4$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== "string") return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $6c079b6dfb8f58a4$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $6c079b6dfb8f58a4$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $6c079b6dfb8f58a4$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $6c079b6dfb8f58a4$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $6c079b6dfb8f58a4$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $6c079b6dfb8f58a4$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $6c079b6dfb8f58a4$var$fail(this, $6c079b6dfb8f58a4$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $6c079b6dfb8f58a4$var$fail(this, $6c079b6dfb8f58a4$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $6c079b6dfb8f58a4$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $6c079b6dfb8f58a4$var$fail(this, $6c079b6dfb8f58a4$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $6c079b6dfb8f58a4$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $6c079b6dfb8f58a4$var$fail(this, $6c079b6dfb8f58a4$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $6c079b6dfb8f58a4$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $6c079b6dfb8f58a4$var$fail(this, $6c079b6dfb8f58a4$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $6c079b6dfb8f58a4$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $6c079b6dfb8f58a4$var$fail(this, $6c079b6dfb8f58a4$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $6c079b6dfb8f58a4$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== "string") return $6c079b6dfb8f58a4$var$fail(this, $6c079b6dfb8f58a4$var$STRING_EXPECTED);
        return this.between(str, str + $6c079b6dfb8f58a4$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $6c079b6dfb8f58a4$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $6c079b6dfb8f58a4$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $6c079b6dfb8f58a4$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $6c079b6dfb8f58a4$var$getArrayOf.apply($6c079b6dfb8f58a4$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $6c079b6dfb8f58a4$var$emptyCollection(this);
        return $6c079b6dfb8f58a4$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $6c079b6dfb8f58a4$var$getArrayOf.apply($6c079b6dfb8f58a4$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $6c079b6dfb8f58a4$var$emptyCollection(this);
        return $6c079b6dfb8f58a4$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $6c079b6dfb8f58a4$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $6c079b6dfb8f58a4$var$getArrayOf.apply($6c079b6dfb8f58a4$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $6c079b6dfb8f58a4$var$fail(this, $6c079b6dfb8f58a4$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $6c079b6dfb8f58a4$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $6c079b6dfb8f58a4$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $6c079b6dfb8f58a4$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $6c079b6dfb8f58a4$var$getArrayOf.apply($6c079b6dfb8f58a4$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $6c079b6dfb8f58a4$var$fail(this, $6c079b6dfb8f58a4$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $6c079b6dfb8f58a4$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $6c079b6dfb8f58a4$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $6c079b6dfb8f58a4$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $6c079b6dfb8f58a4$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $6c079b6dfb8f58a4$var$fail(this, $6c079b6dfb8f58a4$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $6c079b6dfb8f58a4$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $6c079b6dfb8f58a4$var$getArrayOf.apply($6c079b6dfb8f58a4$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === "string";
        })) return $6c079b6dfb8f58a4$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $6c079b6dfb8f58a4$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $6c079b6dfb8f58a4$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $6c079b6dfb8f58a4$var$createWhereClauseConstructor(db) {
    return $6c079b6dfb8f58a4$var$makeClassConstructor($6c079b6dfb8f58a4$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        var indexedDB1 = db._deps.indexedDB;
        if (!indexedDB1) throw new $6c079b6dfb8f58a4$var$exceptions.MissingAPI();
        this._cmp = this._ascending = indexedDB1.cmp.bind(indexedDB1);
        this._descending = function(a, b) {
            return indexedDB1.cmp(b, a);
        };
        this._max = function(a, b) {
            return indexedDB1.cmp(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return indexedDB1.cmp(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
    });
}
function $6c079b6dfb8f58a4$var$eventRejectHandler(reject) {
    return $6c079b6dfb8f58a4$var$wrap(function(event) {
        $6c079b6dfb8f58a4$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $6c079b6dfb8f58a4$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $6c079b6dfb8f58a4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = "storagemutated";
var $6c079b6dfb8f58a4$var$STORAGE_MUTATED_DOM_EVENT_NAME = "x-storagemutated-1";
var $6c079b6dfb8f58a4$var$globalEvents = $6c079b6dfb8f58a4$var$Events(null, $6c079b6dfb8f58a4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $6c079b6dfb8f58a4$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $6c079b6dfb8f58a4$var$assert(!$6c079b6dfb8f58a4$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$6c079b6dfb8f58a4$var$PSD.global) $6c079b6dfb8f58a4$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $6c079b6dfb8f58a4$var$assert(!$6c079b6dfb8f58a4$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$6c079b6dfb8f58a4$var$PSD.global) $6c079b6dfb8f58a4$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $6c079b6dfb8f58a4$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $6c079b6dfb8f58a4$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $6c079b6dfb8f58a4$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $6c079b6dfb8f58a4$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $6c079b6dfb8f58a4$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $6c079b6dfb8f58a4$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $6c079b6dfb8f58a4$var$exceptions.TransactionInactive();
        $6c079b6dfb8f58a4$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $6c079b6dfb8f58a4$var$wrap(function(ev) {
            $6c079b6dfb8f58a4$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $6c079b6dfb8f58a4$var$wrap(function(ev) {
            $6c079b6dfb8f58a4$var$preventDefault(ev);
            _this.active && _this._reject(new $6c079b6dfb8f58a4$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $6c079b6dfb8f58a4$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ("mutatedParts" in idbtrans) $6c079b6dfb8f58a4$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === "readwrite" && this.mode !== "readwrite") return $6c079b6dfb8f58a4$var$rejection(new $6c079b6dfb8f58a4$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $6c079b6dfb8f58a4$var$rejection(new $6c079b6dfb8f58a4$var$exceptions.TransactionInactive());
        if (this._locked()) return new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $6c079b6dfb8f58a4$var$PSD
            ]);
        });
        else if (bWriteLock) return $6c079b6dfb8f58a4$var$newScope(function() {
            var p = new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $6c079b6dfb8f58a4$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($6c079b6dfb8f58a4$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($6c079b6dfb8f58a4$var$wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $6c079b6dfb8f58a4$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($6c079b6dfb8f58a4$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $6c079b6dfb8f58a4$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $6c079b6dfb8f58a4$var$createTransactionConstructor(db) {
    return $6c079b6dfb8f58a4$var$makeClassConstructor($6c079b6dfb8f58a4$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $6c079b6dfb8f58a4$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $6c079b6dfb8f58a4$var$rejection(e);
        });
    });
}
function $6c079b6dfb8f58a4$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? "&" : "") + (multi ? "*" : "") + (auto ? "++" : "") + $6c079b6dfb8f58a4$var$nameFromKeyPath(keyPath)
    };
}
function $6c079b6dfb8f58a4$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === "string" ? keyPath : keyPath ? "[" + [].join.call(keyPath, "+") + "]" : "";
}
function $6c079b6dfb8f58a4$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $6c079b6dfb8f58a4$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $6c079b6dfb8f58a4$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $6c079b6dfb8f58a4$var$getMaxKey = function(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $6c079b6dfb8f58a4$var$getMaxKey = function() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $6c079b6dfb8f58a4$var$getMaxKey = function() {
            return $6c079b6dfb8f58a4$var$maxString;
        };
        return $6c079b6dfb8f58a4$var$maxString;
    }
};
function $6c079b6dfb8f58a4$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === "string") return $6c079b6dfb8f58a4$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $6c079b6dfb8f58a4$var$getByKeyPath(obj, keyPath);
    };
}
function $6c079b6dfb8f58a4$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split(".");
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $6c079b6dfb8f58a4$var$getByKeyPath(obj, keyPath);
    };
}
function $6c079b6dfb8f58a4$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $6c079b6dfb8f58a4$var$_id_counter = 0;
function $6c079b6dfb8f58a4$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === "string" ? keyPath : "[" + keyPath.join("+") + "]";
}
function $6c079b6dfb8f58a4$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $6c079b6dfb8f58a4$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $6c079b6dfb8f58a4$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $6c079b6dfb8f58a4$var$getKeyExtractor(keyPath)
                        },
                        indexes: $6c079b6dfb8f58a4$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $6c079b6dfb8f58a4$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $6c079b6dfb8f58a4$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$6c079b6dfb8f58a4$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function(keyPath) {
                            return indexByKeyPath[$6c079b6dfb8f58a4$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$6c079b6dfb8f58a4$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && "getAll" in trans.objectStore(tables[0]) && !(typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $6c079b6dfb8f58a4$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== "delete" && type !== "deleteRange") throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function(event) {
                    ++numFailures;
                    $6c079b6dfb8f58a4$var$preventDefault(event);
                };
                if (type === "deleteRange") {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _a[0], args2 = _a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $6c079b6dfb8f58a4$var$wrap(resolve);
                var index = query.index, range = query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !("openKeyCursor" in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $6c079b6dfb8f58a4$var$eventRejectHandler(reject);
                req.onsuccess = $6c079b6dfb8f58a4$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$6c079b6dfb8f58a4$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $6c079b6dfb8f58a4$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $6c079b6dfb8f58a4$var$wrap(resolveIteration);
                            req.onerror = $6c079b6dfb8f58a4$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $6c079b6dfb8f58a4$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $6c079b6dfb8f58a4$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $6c079b6dfb8f58a4$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !("openKeyCursor" in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = $6c079b6dfb8f58a4$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $6c079b6dfb8f58a4$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $6c079b6dfb8f58a4$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $6c079b6dfb8f58a4$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $6c079b6dfb8f58a4$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function(_a) {
                var query = _a.query, trans = _a.trans;
                var index = query.index, range = query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $6c079b6dfb8f58a4$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $6c079b6dfb8f58a4$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '" + name + "' not found");
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $6c079b6dfb8f58a4$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $6c079b6dfb8f58a4$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $6c079b6dfb8f58a4$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $6c079b6dfb8f58a4$var$createMiddlewareStack($6c079b6dfb8f58a4$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $6c079b6dfb8f58a4$var$generateMiddlewareStacks(_a, tmpTrans) {
    var db = _a._novip;
    var idbdb = tmpTrans.db;
    var stacks = $6c079b6dfb8f58a4$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $6c079b6dfb8f58a4$var$setApiOnPlace(_a, objs, tableNames, dbschema) {
    var db = _a._novip;
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $6c079b6dfb8f58a4$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $6c079b6dfb8f58a4$var$setProp(obj, tableName, {
                    get: function() {
                        return this.table(tableName);
                    },
                    set: function(value) {
                        $6c079b6dfb8f58a4$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $6c079b6dfb8f58a4$var$removeTablesApi(_a, objs) {
    var db = _a._novip;
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $6c079b6dfb8f58a4$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $6c079b6dfb8f58a4$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    var trans = db._createTransaction("readwrite", db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $6c079b6dfb8f58a4$var$PSD.transless || $6c079b6dfb8f58a4$var$PSD;
    $6c079b6dfb8f58a4$var$newScope(function() {
        $6c079b6dfb8f58a4$var$PSD.trans = trans;
        $6c079b6dfb8f58a4$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $6c079b6dfb8f58a4$var$keys(globalSchema).forEach(function(tableName) {
                $6c079b6dfb8f58a4$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $6c079b6dfb8f58a4$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $6c079b6dfb8f58a4$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else $6c079b6dfb8f58a4$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans).catch(rejectTransaction);
    });
}
function $6c079b6dfb8f58a4$var$updateTablesAndIndexes(_a, oldVersion, trans, idbUpgradeTrans) {
    var db = _a._novip;
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $6c079b6dfb8f58a4$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var anyContentUpgraderHasRun = false;
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $6c079b6dfb8f58a4$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $6c079b6dfb8f58a4$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $6c079b6dfb8f58a4$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $6c079b6dfb8f58a4$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $6c079b6dfb8f58a4$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $6c079b6dfb8f58a4$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $6c079b6dfb8f58a4$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $6c079b6dfb8f58a4$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                anyContentUpgraderHasRun = true;
                var upgradeSchema_1 = $6c079b6dfb8f58a4$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $6c079b6dfb8f58a4$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $6c079b6dfb8f58a4$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $6c079b6dfb8f58a4$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $6c079b6dfb8f58a4$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $6c079b6dfb8f58a4$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $6c079b6dfb8f58a4$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $6c079b6dfb8f58a4$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === "function" ? $6c079b6dfb8f58a4$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            if (!anyContentUpgraderHasRun || !$6c079b6dfb8f58a4$var$hasIEDeleteObjectStoreBug) {
                var newSchema = version._cfg.dbschema;
                $6c079b6dfb8f58a4$var$deleteRemovedTables(newSchema, idbtrans);
            }
            $6c079b6dfb8f58a4$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $6c079b6dfb8f58a4$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
    });
    function runQueue() {
        return queue.length ? $6c079b6dfb8f58a4$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $6c079b6dfb8f58a4$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $6c079b6dfb8f58a4$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $6c079b6dfb8f58a4$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ("" + (oldDef.primKey.keyPath || "") !== "" + (newDef.primKey.keyPath || "") || oldDef.primKey.auto !== newDef.primKey.auto && !$6c079b6dfb8f58a4$var$isIEOrEdge) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $6c079b6dfb8f58a4$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $6c079b6dfb8f58a4$var$addIndex(store, idx);
    });
    return store;
}
function $6c079b6dfb8f58a4$var$createMissingTables(newSchema, idbtrans) {
    $6c079b6dfb8f58a4$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) $6c079b6dfb8f58a4$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
    });
}
function $6c079b6dfb8f58a4$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $6c079b6dfb8f58a4$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $6c079b6dfb8f58a4$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $6c079b6dfb8f58a4$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $6c079b6dfb8f58a4$var$createIndexSpec($6c079b6dfb8f58a4$var$nameFromKeyPath(keyPath), keyPath || "", false, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $6c079b6dfb8f58a4$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $6c079b6dfb8f58a4$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $6c079b6dfb8f58a4$var$readGlobalSchema(_a, idbdb, tmpTrans) {
    var db = _a._novip;
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $6c079b6dfb8f58a4$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $6c079b6dfb8f58a4$var$slice(idbdb.objectStoreNames, 0);
    $6c079b6dfb8f58a4$var$setApiOnPlace(db, [
        db._allTables
    ], $6c079b6dfb8f58a4$var$keys(globalSchema), globalSchema);
}
function $6c079b6dfb8f58a4$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $6c079b6dfb8f58a4$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $6c079b6dfb8f58a4$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $6c079b6dfb8f58a4$var$adjustToExistingIndexNames(_a, schema, idbtrans) {
    var db = _a._novip;
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = "getAll" in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === "string" ? keyPath : "[" + $6c079b6dfb8f58a4$var$slice(keyPath).join("+") + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $6c079b6dfb8f58a4$var$_global.WorkerGlobalScope && $6c079b6dfb8f58a4$var$_global instanceof $6c079b6dfb8f58a4$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $6c079b6dfb8f58a4$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(",").map(function(index, indexNum) {
        index = index.trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split("+") : name;
        return $6c079b6dfb8f58a4$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $6c079b6dfb8f58a4$var$isArray(keyPath), indexNum === 0);
    });
}
var $6c079b6dfb8f58a4$var$Version = function() {
    function Version() {}
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        $6c079b6dfb8f58a4$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = $6c079b6dfb8f58a4$var$parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                if (primKey.multi) throw new $6c079b6dfb8f58a4$var$exceptions.Schema("Primary key cannot be multi-valued");
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $6c079b6dfb8f58a4$var$exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!idx.keyPath) throw new $6c079b6dfb8f58a4$var$exceptions.Schema("Index must have a name and cannot be an empty string");
                });
                outSchema[tableName] = $6c079b6dfb8f58a4$var$createTableSchema(tableName, primKey, indexes);
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $6c079b6dfb8f58a4$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $6c079b6dfb8f58a4$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $6c079b6dfb8f58a4$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $6c079b6dfb8f58a4$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $6c079b6dfb8f58a4$var$keys(dbschema), dbschema);
        db._storeNames = $6c079b6dfb8f58a4$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $6c079b6dfb8f58a4$var$promisableChain(this._cfg.contentUpgrade || $6c079b6dfb8f58a4$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $6c079b6dfb8f58a4$var$createVersionConstructor(db) {
    return $6c079b6dfb8f58a4$var$makeClassConstructor($6c079b6dfb8f58a4$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $6c079b6dfb8f58a4$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $6c079b6dfb8f58a4$export$4ece27d405df7279($6c079b6dfb8f58a4$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $6c079b6dfb8f58a4$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $6c079b6dfb8f58a4$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $6c079b6dfb8f58a4$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $6c079b6dfb8f58a4$var$DBNAMES_DB;
        });
    }) : $6c079b6dfb8f58a4$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $6c079b6dfb8f58a4$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$6c079b6dfb8f58a4$var$hasDatabasesNative(indexedDB1) && name !== $6c079b6dfb8f58a4$var$DBNAMES_DB && $6c079b6dfb8f58a4$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch($6c079b6dfb8f58a4$var$nop);
}
function $6c079b6dfb8f58a4$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$6c079b6dfb8f58a4$var$hasDatabasesNative(indexedDB1) && name !== $6c079b6dfb8f58a4$var$DBNAMES_DB && $6c079b6dfb8f58a4$var$getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch($6c079b6dfb8f58a4$var$nop);
}
function $6c079b6dfb8f58a4$var$vip(fn) {
    return $6c079b6dfb8f58a4$var$newScope(function() {
        $6c079b6dfb8f58a4$var$PSD.letThrough = true;
        return fn();
    });
}
function $6c079b6dfb8f58a4$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
function $6c079b6dfb8f58a4$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $6c079b6dfb8f58a4$var$rejection(state.dbOpenError) : db;
    });
    $6c079b6dfb8f58a4$var$debug && (state.openCanceller._stackHolder = $6c079b6dfb8f58a4$var$getErrorWithStack());
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $6c079b6dfb8f58a4$var$exceptions.DatabaseClosed("db.open() was cancelled");
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function() {
        return new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new $6c079b6dfb8f58a4$var$exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema ? indexedDB1.open(dbName) : indexedDB1.open(dbName, Math.round(db.verno * 10));
            if (!req) throw new $6c079b6dfb8f58a4$var$exceptions.MissingAPI();
            req.onerror = $6c079b6dfb8f58a4$var$eventRejectHandler(reject);
            req.onblocked = $6c079b6dfb8f58a4$var$wrap(db._fireOnBlocked);
            req.onupgradeneeded = $6c079b6dfb8f58a4$var$wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = $6c079b6dfb8f58a4$var$preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = $6c079b6dfb8f58a4$var$wrap(function() {
                        reject(new $6c079b6dfb8f58a4$var$exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
                    });
                } else {
                    upgradeTransaction.onerror = $6c079b6dfb8f58a4$var$eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db._novip.idbdb = req.result;
                    $6c079b6dfb8f58a4$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = $6c079b6dfb8f58a4$var$wrap(function() {
                upgradeTransaction = null;
                var idbdb = db._novip.idbdb = req.result;
                var objectStoreNames = $6c079b6dfb8f58a4$var$slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction($6c079b6dfb8f58a4$var$safariMultiStoreFix(objectStoreNames), "readonly");
                    if (state.autoSchema) $6c079b6dfb8f58a4$var$readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        $6c079b6dfb8f58a4$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!$6c079b6dfb8f58a4$var$verifyInstalledSchema(db, tmpTrans)) console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.");
                    }
                    $6c079b6dfb8f58a4$var$generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                $6c079b6dfb8f58a4$var$connections.push(db);
                idbdb.onversionchange = $6c079b6dfb8f58a4$var$wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = $6c079b6dfb8f58a4$var$wrap(function(ev) {
                    db.on("close").fire(ev);
                });
                if (wasCreated) $6c079b6dfb8f58a4$var$_onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            if (err && err.name === "UnknownError" && state.PR1398_maxLoop > 0) {
                state.PR1398_maxLoop--;
                console.warn("Dexie: Workaround for Chrome UnknownError on open()");
                return tryOpenDB();
            } else return $6c079b6dfb8f58a4$var$DexiePromise.reject(err);
        });
    };
    return $6c079b6dfb8f58a4$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === "undefined" ? $6c079b6dfb8f58a4$var$DexiePromise.resolve() : $6c079b6dfb8f58a4$var$idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $6c079b6dfb8f58a4$var$DexiePromise.resolve($6c079b6dfb8f58a4$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($6c079b6dfb8f58a4$var$promisableChain, $6c079b6dfb8f58a4$var$nop);
                state.onReadyBeingFired = [];
                return $6c079b6dfb8f58a4$var$DexiePromise.resolve($6c079b6dfb8f58a4$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        state.onReadyBeingFired = null;
        state.isBeingOpened = false;
    }).then(function() {
        return db;
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $6c079b6dfb8f58a4$var$rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    });
}
function $6c079b6dfb8f58a4$var$awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== "function" ? $6c079b6dfb8f58a4$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $6c079b6dfb8f58a4$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $6c079b6dfb8f58a4$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $6c079b6dfb8f58a4$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $6c079b6dfb8f58a4$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $6c079b6dfb8f58a4$var$DexiePromise.resolve().then(function() {
        var transless = $6c079b6dfb8f58a4$var$PSD.transless || $6c079b6dfb8f58a4$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $6c079b6dfb8f58a4$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $6c079b6dfb8f58a4$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $6c079b6dfb8f58a4$var$rejection(ex);
        }
        var scopeFuncIsAsync = $6c079b6dfb8f58a4$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $6c079b6dfb8f58a4$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $6c079b6dfb8f58a4$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $6c079b6dfb8f58a4$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === "function" && typeof returnValue.throw === "function") returnValue = $6c079b6dfb8f58a4$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === "function" ? $6c079b6dfb8f58a4$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $6c079b6dfb8f58a4$var$rejection(new $6c079b6dfb8f58a4$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return $6c079b6dfb8f58a4$var$rejection(e);
        });
    });
}
function $6c079b6dfb8f58a4$var$pad(a, value, count) {
    var result = $6c079b6dfb8f58a4$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $6c079b6dfb8f58a4$var$createVirtualIndexMiddleware(down) {
    return $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, down), {
        table: function(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $6c079b6dfb8f58a4$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === "string" ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, lowLevelIndex), {
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $6c079b6dfb8f58a4$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$6c079b6dfb8f58a4$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $6c079b6dfb8f58a4$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $6c079b6dfb8f58a4$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, req), {
                    query: {
                        index: index,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, table), {
                schema: $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function(req) {
                    return table.count(translateRequest(req));
                },
                query: function(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue($6c079b6dfb8f58a4$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function(key, primaryKey) {
                                    cursor.continuePrimaryKey($6c079b6dfb8f58a4$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $6c079b6dfb8f58a4$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $6c079b6dfb8f58a4$var$createVirtualIndexMiddleware
};
function $6c079b6dfb8f58a4$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || "";
    $6c079b6dfb8f58a4$var$keys(a).forEach(function(prop) {
        if (!$6c079b6dfb8f58a4$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === "object" && typeof bp === "object" && ap && bp) {
                var apTypeName = $6c079b6dfb8f58a4$var$toStringTag(ap);
                var bpTypeName = $6c079b6dfb8f58a4$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === "Object") $6c079b6dfb8f58a4$var$getObjectDiff(ap, bp, rv, prfx + prop + ".");
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $6c079b6dfb8f58a4$var$keys(b).forEach(function(prop) {
        if (!$6c079b6dfb8f58a4$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $6c079b6dfb8f58a4$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === "delete") return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $6c079b6dfb8f58a4$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function(downCore) {
        return $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, downCore), {
            table: function(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var dxTrans = $6c079b6dfb8f58a4$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case "add":
                                if (creating.fire === $6c079b6dfb8f58a4$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "put":
                                if (creating.fire === $6c079b6dfb8f58a4$var$nop && updating.fire === $6c079b6dfb8f58a4$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "delete":
                                if (deleting.fire === $6c079b6dfb8f58a4$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "deleteRange":
                                if (deleting.fire === $6c079b6dfb8f58a4$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $6c079b6dfb8f58a4$var$PSD.trans;
                            var keys = req.keys || $6c079b6dfb8f58a4$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === "add" || req.type === "put" ? $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, req), {
                                keys: keys
                            }) : $6c079b6dfb8f58a4$var$__assign({}, req);
                            if (req.type !== "delete") req.values = $6c079b6dfb8f58a4$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $6c079b6dfb8f58a4$var$__spreadArray([], req.keys, true);
                            return $6c079b6dfb8f58a4$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === "delete") deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === "add" || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $6c079b6dfb8f58a4$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $6c079b6dfb8f58a4$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($6c079b6dfb8f58a4$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $6c079b6dfb8f58a4$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === "put" && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: "delete",
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $6c079b6dfb8f58a4$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $6c079b6dfb8f58a4$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($6c079b6dfb8f58a4$var$cmp(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $6c079b6dfb8f58a4$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $6c079b6dfb8f58a4$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function(core) {
        return {
            table: function(tableName) {
                var table = core.table(tableName);
                return $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, table), {
                    getMany: function(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $6c079b6dfb8f58a4$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $6c079b6dfb8f58a4$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $6c079b6dfb8f58a4$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
var $6c079b6dfb8f58a4$var$_a;
function $6c079b6dfb8f58a4$var$isEmptyRange(node) {
    return !("from" in node);
}
var $6c079b6dfb8f58a4$export$34cb5241245008dd = function(fromOrTree, to) {
    if (this) $6c079b6dfb8f58a4$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $6c079b6dfb8f58a4$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $6c079b6dfb8f58a4$var$extend(rv, fromOrTree);
        return rv;
    }
};
$6c079b6dfb8f58a4$var$props($6c079b6dfb8f58a4$export$34cb5241245008dd.prototype, ($6c079b6dfb8f58a4$var$_a = {
    add: function(rangeSet) {
        $6c079b6dfb8f58a4$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function(key) {
        $6c079b6dfb8f58a4$var$addRange(this, key, key);
        return this;
    },
    addKeys: function(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $6c079b6dfb8f58a4$var$addRange(_this, key, key);
        });
        return this;
    }
}, $6c079b6dfb8f58a4$var$_a[$6c079b6dfb8f58a4$var$iteratorSymbol] = function() {
    return $6c079b6dfb8f58a4$var$getRangeSetIterator(this);
}, $6c079b6dfb8f58a4$var$_a));
function $6c079b6dfb8f58a4$var$addRange(target, from, to) {
    var diff = $6c079b6dfb8f58a4$var$cmp(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($6c079b6dfb8f58a4$var$isEmptyRange(target)) return $6c079b6dfb8f58a4$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($6c079b6dfb8f58a4$var$cmp(to, target.from) < 0) {
        left ? $6c079b6dfb8f58a4$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $6c079b6dfb8f58a4$var$rebalance(target);
    }
    if ($6c079b6dfb8f58a4$var$cmp(from, target.to) > 0) {
        right ? $6c079b6dfb8f58a4$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $6c079b6dfb8f58a4$var$rebalance(target);
    }
    if ($6c079b6dfb8f58a4$var$cmp(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($6c079b6dfb8f58a4$var$cmp(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $6c079b6dfb8f58a4$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $6c079b6dfb8f58a4$export$4876cc3130d3f820(target, right);
}
function $6c079b6dfb8f58a4$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $6c079b6dfb8f58a4$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$6c079b6dfb8f58a4$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $6c079b6dfb8f58a4$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $6c079b6dfb8f58a4$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $6c079b6dfb8f58a4$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($6c079b6dfb8f58a4$var$cmp(b.from, a.to) <= 0 && $6c079b6dfb8f58a4$var$cmp(b.to, a.from) >= 0) return true;
        $6c079b6dfb8f58a4$var$cmp(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $6c079b6dfb8f58a4$var$getRangeSetIterator(node) {
    var state = $6c079b6dfb8f58a4$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $6c079b6dfb8f58a4$var$cmp(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $6c079b6dfb8f58a4$var$cmp(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $6c079b6dfb8f58a4$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $6c079b6dfb8f58a4$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $6c079b6dfb8f58a4$var$computeDepth(rootClone);
    }
    target.d = $6c079b6dfb8f58a4$var$computeDepth(target);
}
function $6c079b6dfb8f58a4$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
var $6c079b6dfb8f58a4$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    create: function(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $6c079b6dfb8f58a4$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, core), {
            table: function(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var tableClone = $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, table), {
                    mutate: function(req) {
                        var trans = req.trans;
                        var mutatedParts = trans.mutatedParts || (trans.mutatedParts = {});
                        var getRangeSet = function(indexName) {
                            var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                            return mutatedParts[part] || (mutatedParts[part] = new $6c079b6dfb8f58a4$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _a = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            [],
                            req.values
                        ] : [], keys = _a[0], newObjs = _a[1];
                        var oldCache = req.trans["_cache"];
                        return table.mutate(req).then(function(res) {
                            if ($6c079b6dfb8f58a4$var$isArray(keys)) {
                                if (type !== "delete") keys = res.results;
                                pkRangeSet.addKeys(keys);
                                var oldObjs = $6c079b6dfb8f58a4$var$getFromTransactionCache(keys, oldCache);
                                if (!oldObjs && type !== "add") delsRangeSet.addKeys(keys);
                                if (oldObjs || newObjs) $6c079b6dfb8f58a4$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                            } else if (keys) {
                                var range = {
                                    from: keys.lower,
                                    to: keys.upper
                                };
                                delsRangeSet.add(range);
                                pkRangeSet.add(range);
                            } else {
                                pkRangeSet.add(FULL_RANGE);
                                delsRangeSet.add(FULL_RANGE);
                                schema.indexes.forEach(function(idx) {
                                    return getRangeSet(idx.name).add(FULL_RANGE);
                                });
                            }
                            return res;
                        });
                    }
                });
                var getRange = function(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $6c079b6dfb8f58a4$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function(req) {
                        return [
                            primaryKey,
                            new $6c079b6dfb8f58a4$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function(req) {
                        return [
                            primaryKey,
                            new $6c079b6dfb8f58a4$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $6c079b6dfb8f58a4$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $6c079b6dfb8f58a4$var$PSD.subscr;
                        if (subscr) {
                            var getRangeSet = function(indexName) {
                                var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                                return subscr[part] || (subscr[part] = new $6c079b6dfb8f58a4$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $6c079b6dfb8f58a4$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function(key) {
            return ix.multiEntry && $6c079b6dfb8f58a4$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($6c079b6dfb8f58a4$var$cmp(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
var $6c079b6dfb8f58a4$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $6c079b6dfb8f58a4$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $6c079b6dfb8f58a4$var$nop,
            dbReadyPromise: null,
            cancelOpen: $6c079b6dfb8f58a4$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3
        };
        state.dbReadyPromise = new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $6c079b6dfb8f58a4$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $6c079b6dfb8f58a4$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $6c079b6dfb8f58a4$var$promisableChain,
                $6c079b6dfb8f58a4$var$nop
            ]
        });
        this.on.ready.subscribe = $6c079b6dfb8f58a4$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $6c079b6dfb8f58a4$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $6c079b6dfb8f58a4$var$createCollectionConstructor(this);
        this.Table = $6c079b6dfb8f58a4$var$createTableConstructor(this);
        this.Transaction = $6c079b6dfb8f58a4$var$createTransactionConstructor(this);
        this.Version = $6c079b6dfb8f58a4$var$createVersionConstructor(this);
        this.WhereClause = $6c079b6dfb8f58a4$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '" + _this.name + "'. Closing db now to resume the upgrade.");
            else console.warn("Another connection wants to delete database '" + _this.name + "'. Closing db now to resume the delete request.");
            _this.close();
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('" + _this.name + "') was blocked");
            else console.warn("Upgrade '" + _this.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
        });
        this._maxKey = $6c079b6dfb8f58a4$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $6c079b6dfb8f58a4$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($6c079b6dfb8f58a4$var$virtualIndexMiddleware);
        this.use($6c079b6dfb8f58a4$var$hooksMiddleware);
        this.use($6c079b6dfb8f58a4$var$observabilityMiddleware);
        this.use($6c079b6dfb8f58a4$var$cacheExistingValuesMiddleware);
        this.vip = Object.create(this, {
            _vip: {
                value: true
            }
        });
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $6c079b6dfb8f58a4$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $6c079b6dfb8f58a4$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($6c079b6dfb8f58a4$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $6c079b6dfb8f58a4$var$PSD.letThrough || this._vip) ? fn() : new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $6c079b6dfb8f58a4$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._options.autoOpen) {
                    reject(new $6c079b6dfb8f58a4$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch($6c079b6dfb8f58a4$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        return $6c079b6dfb8f58a4$var$dexieOpen(this);
    };
    Dexie.prototype._close = function() {
        var state = this._state;
        var idx = $6c079b6dfb8f58a4$var$connections.indexOf(this);
        if (idx >= 0) $6c079b6dfb8f58a4$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this._novip.idbdb = null;
        }
        state.dbReadyPromise = new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $6c079b6dfb8f58a4$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
    };
    Dexie.prototype.close = function() {
        this._close();
        var state = this._state;
        this._options.autoOpen = false;
        state.dbOpenError = new $6c079b6dfb8f58a4$var$exceptions.DatabaseClosed();
        if (state.isBeingOpened) state.cancelOpen(state.dbOpenError);
    };
    Dexie.prototype.delete = function() {
        var _this = this;
        var hasArguments = arguments.length > 0;
        var state = this._state;
        return new $6c079b6dfb8f58a4$var$DexiePromise(function(resolve, reject) {
            var doDelete = function() {
                _this.close();
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $6c079b6dfb8f58a4$var$wrap(function() {
                    $6c079b6dfb8f58a4$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $6c079b6dfb8f58a4$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasArguments) throw new $6c079b6dfb8f58a4$var$exceptions.InvalidArgument("Arguments not allowed in db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === "DatabaseClosed";
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function() {
            var _this = this;
            return $6c079b6dfb8f58a4$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $6c079b6dfb8f58a4$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $6c079b6dfb8f58a4$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf("!") !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf("?") !== -1;
        mode = mode.replace("!", "").replace("?", "");
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== "string") throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $6c079b6dfb8f58a4$var$READONLY) idbMode = $6c079b6dfb8f58a4$var$READONLY;
            else if (mode == "rw" || mode == $6c079b6dfb8f58a4$var$READWRITE) idbMode = $6c079b6dfb8f58a4$var$READWRITE;
            else throw new $6c079b6dfb8f58a4$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $6c079b6dfb8f58a4$var$READONLY && idbMode === $6c079b6dfb8f58a4$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $6c079b6dfb8f58a4$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $6c079b6dfb8f58a4$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $6c079b6dfb8f58a4$var$rejection(e);
        }
        var enterTransaction = $6c079b6dfb8f58a4$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $6c079b6dfb8f58a4$var$PSD.trans ? $6c079b6dfb8f58a4$var$usePSD($6c079b6dfb8f58a4$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$6c079b6dfb8f58a4$var$hasOwn(this._allTables, tableName)) throw new $6c079b6dfb8f58a4$var$exceptions.InvalidTable("Table " + tableName + " does not exist");
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $6c079b6dfb8f58a4$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $6c079b6dfb8f58a4$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$6c079b6dfb8f58a4$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
function $6c079b6dfb8f58a4$var$extendObservabilitySet(target, newSet) {
    $6c079b6dfb8f58a4$var$keys(newSet).forEach(function(part) {
        var rangeSet = target[part] || (target[part] = new $6c079b6dfb8f58a4$export$34cb5241245008dd());
        $6c079b6dfb8f58a4$export$4876cc3130d3f820(rangeSet, newSet[part]);
    });
    return target;
}
function $6c079b6dfb8f58a4$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue = undefined;
    var observable = new $6c079b6dfb8f58a4$var$Observable(function(observer) {
        var scopeFuncIsAsync = $6c079b6dfb8f58a4$var$isAsyncFunction(querier);
        function execute(subscr) {
            if (scopeFuncIsAsync) $6c079b6dfb8f58a4$var$incrementExpectedAwaits();
            var exec = function() {
                return $6c079b6dfb8f58a4$var$newScope(querier, {
                    subscr: subscr,
                    trans: null
                });
            };
            var rv = $6c079b6dfb8f58a4$var$PSD.trans ? $6c079b6dfb8f58a4$var$usePSD($6c079b6dfb8f58a4$var$PSD.transless, exec) : exec();
            if (scopeFuncIsAsync) rv.then($6c079b6dfb8f58a4$var$decrementExpectedAwaits, $6c079b6dfb8f58a4$var$decrementExpectedAwaits);
            return rv;
        }
        var closed = false;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function() {
                closed = true;
                $6c079b6dfb8f58a4$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var querying = false, startedListening = false;
        function shouldNotify() {
            return $6c079b6dfb8f58a4$var$keys(currentObs).some(function(key) {
                return accumMuts[key] && $6c079b6dfb8f58a4$export$8f43b23b5d8de905(accumMuts[key], currentObs[key]);
            });
        }
        var mutationListener = function(parts) {
            $6c079b6dfb8f58a4$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var doQuery = function() {
            if (querying || closed) return;
            accumMuts = {};
            var subscr = {};
            var ret = execute(subscr);
            if (!startedListening) {
                $6c079b6dfb8f58a4$var$globalEvents($6c079b6dfb8f58a4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                startedListening = true;
            }
            querying = true;
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                querying = false;
                if (closed) return;
                if (shouldNotify()) doQuery();
                else {
                    accumMuts = {};
                    currentObs = subscr;
                    observer.next && observer.next(result);
                }
            }, function(err) {
                querying = false;
                hasValue = false;
                observer.error && observer.error(err);
                subscription.unsubscribe();
            });
        };
        doQuery();
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $6c079b6dfb8f58a4$var$domDeps;
try {
    $6c079b6dfb8f58a4$var$domDeps = {
        indexedDB: $6c079b6dfb8f58a4$var$_global.indexedDB || $6c079b6dfb8f58a4$var$_global.mozIndexedDB || $6c079b6dfb8f58a4$var$_global.webkitIndexedDB || $6c079b6dfb8f58a4$var$_global.msIndexedDB,
        IDBKeyRange: $6c079b6dfb8f58a4$var$_global.IDBKeyRange || $6c079b6dfb8f58a4$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $6c079b6dfb8f58a4$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
var $6c079b6dfb8f58a4$var$Dexie = $6c079b6dfb8f58a4$export$4ece27d405df7279;
$6c079b6dfb8f58a4$var$props($6c079b6dfb8f58a4$var$Dexie, $6c079b6dfb8f58a4$var$__assign($6c079b6dfb8f58a4$var$__assign({}, $6c079b6dfb8f58a4$var$fullNameExceptions), {
    delete: function(databaseName) {
        var db = new $6c079b6dfb8f58a4$var$Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function(name) {
        return new $6c079b6dfb8f58a4$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch("NoSuchDatabaseError", function() {
            return false;
        });
    },
    getDatabaseNames: function(cb) {
        try {
            return $6c079b6dfb8f58a4$var$getDatabaseNames($6c079b6dfb8f58a4$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $6c079b6dfb8f58a4$var$rejection(new $6c079b6dfb8f58a4$var$exceptions.MissingAPI());
        }
    },
    defineClass: function() {
        function Class(content) {
            $6c079b6dfb8f58a4$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function(scopeFunc) {
        return $6c079b6dfb8f58a4$var$PSD.trans ? $6c079b6dfb8f58a4$var$usePSD($6c079b6dfb8f58a4$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $6c079b6dfb8f58a4$var$vip,
    async: function(generatorFn) {
        return function() {
            try {
                var rv = $6c079b6dfb8f58a4$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== "function") return $6c079b6dfb8f58a4$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $6c079b6dfb8f58a4$var$rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = $6c079b6dfb8f58a4$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== "function") return $6c079b6dfb8f58a4$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $6c079b6dfb8f58a4$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function() {
            return $6c079b6dfb8f58a4$var$PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        var promise = $6c079b6dfb8f58a4$var$DexiePromise.resolve(typeof promiseOrFunction === "function" ? $6c079b6dfb8f58a4$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $6c079b6dfb8f58a4$var$PSD.trans ? $6c079b6dfb8f58a4$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $6c079b6dfb8f58a4$var$DexiePromise,
    debug: {
        get: function() {
            return $6c079b6dfb8f58a4$var$debug;
        },
        set: function(value) {
            $6c079b6dfb8f58a4$var$setDebug(value, value === "dexie" ? function() {
                return true;
            } : $6c079b6dfb8f58a4$var$dexieStackFrameFilter);
        }
    },
    derive: $6c079b6dfb8f58a4$var$derive,
    extend: $6c079b6dfb8f58a4$var$extend,
    props: $6c079b6dfb8f58a4$var$props,
    override: $6c079b6dfb8f58a4$var$override,
    Events: $6c079b6dfb8f58a4$var$Events,
    on: $6c079b6dfb8f58a4$var$globalEvents,
    liveQuery: $6c079b6dfb8f58a4$export$6a9705d8f6f38796,
    extendObservabilitySet: $6c079b6dfb8f58a4$var$extendObservabilitySet,
    getByKeyPath: $6c079b6dfb8f58a4$var$getByKeyPath,
    setByKeyPath: $6c079b6dfb8f58a4$var$setByKeyPath,
    delByKeyPath: $6c079b6dfb8f58a4$var$delByKeyPath,
    shallowClone: $6c079b6dfb8f58a4$var$shallowClone,
    deepClone: $6c079b6dfb8f58a4$var$deepClone,
    getObjectDiff: $6c079b6dfb8f58a4$var$getObjectDiff,
    cmp: $6c079b6dfb8f58a4$var$cmp,
    asap: $6c079b6dfb8f58a4$var$asap$1,
    minKey: $6c079b6dfb8f58a4$var$minKey,
    addons: [],
    connections: $6c079b6dfb8f58a4$var$connections,
    errnames: $6c079b6dfb8f58a4$var$errnames,
    dependencies: $6c079b6dfb8f58a4$var$domDeps,
    semVer: $6c079b6dfb8f58a4$var$DEXIE_VERSION,
    version: $6c079b6dfb8f58a4$var$DEXIE_VERSION.split(".").map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$6c079b6dfb8f58a4$var$Dexie.maxKey = $6c079b6dfb8f58a4$var$getMaxKey($6c079b6dfb8f58a4$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== "undefined" && typeof addEventListener !== "undefined") {
    $6c079b6dfb8f58a4$var$globalEvents($6c079b6dfb8f58a4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$6c079b6dfb8f58a4$var$propagatingLocally) {
            var event_1;
            if ($6c079b6dfb8f58a4$var$isIEOrEdge) {
                event_1 = document.createEvent("CustomEvent");
                event_1.initCustomEvent($6c079b6dfb8f58a4$var$STORAGE_MUTATED_DOM_EVENT_NAME, true, true, updatedParts);
            } else event_1 = new CustomEvent($6c079b6dfb8f58a4$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $6c079b6dfb8f58a4$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $6c079b6dfb8f58a4$var$propagatingLocally = false;
        }
    });
    addEventListener($6c079b6dfb8f58a4$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$6c079b6dfb8f58a4$var$propagatingLocally) $6c079b6dfb8f58a4$var$propagateLocally(detail);
    });
}
function $6c079b6dfb8f58a4$var$propagateLocally(updateParts) {
    var wasMe = $6c079b6dfb8f58a4$var$propagatingLocally;
    try {
        $6c079b6dfb8f58a4$var$propagatingLocally = true;
        $6c079b6dfb8f58a4$var$globalEvents.storagemutated.fire(updateParts);
    } finally{
        $6c079b6dfb8f58a4$var$propagatingLocally = wasMe;
    }
}
var $6c079b6dfb8f58a4$var$propagatingLocally = false;
if (typeof BroadcastChannel !== "undefined") {
    var $6c079b6dfb8f58a4$var$bc_1 = new BroadcastChannel($6c079b6dfb8f58a4$var$STORAGE_MUTATED_DOM_EVENT_NAME);
    if (typeof $6c079b6dfb8f58a4$var$bc_1.unref === "function") $6c079b6dfb8f58a4$var$bc_1.unref();
    $6c079b6dfb8f58a4$var$globalEvents($6c079b6dfb8f58a4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$6c079b6dfb8f58a4$var$propagatingLocally) $6c079b6dfb8f58a4$var$bc_1.postMessage(changedParts);
    });
    $6c079b6dfb8f58a4$var$bc_1.onmessage = function(ev) {
        if (ev.data) $6c079b6dfb8f58a4$var$propagateLocally(ev.data);
    };
} else if (typeof self !== "undefined" && typeof navigator !== "undefined") {
    $6c079b6dfb8f58a4$var$globalEvents($6c079b6dfb8f58a4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        try {
            if (!$6c079b6dfb8f58a4$var$propagatingLocally) {
                if (typeof localStorage !== "undefined") localStorage.setItem($6c079b6dfb8f58a4$var$STORAGE_MUTATED_DOM_EVENT_NAME, JSON.stringify({
                    trig: Math.random(),
                    changedParts: changedParts
                }));
                if (typeof self["clients"] === "object") $6c079b6dfb8f58a4$var$__spreadArray([], self["clients"].matchAll({
                    includeUncontrolled: true
                }), true).forEach(function(client) {
                    return client.postMessage({
                        type: $6c079b6dfb8f58a4$var$STORAGE_MUTATED_DOM_EVENT_NAME,
                        changedParts: changedParts
                    });
                });
            }
        } catch (_a) {}
    });
    if (typeof addEventListener !== "undefined") addEventListener("storage", function(ev) {
        if (ev.key === $6c079b6dfb8f58a4$var$STORAGE_MUTATED_DOM_EVENT_NAME) {
            var data = JSON.parse(ev.newValue);
            if (data) $6c079b6dfb8f58a4$var$propagateLocally(data.changedParts);
        }
    });
    var $6c079b6dfb8f58a4$var$swContainer = self.document && navigator.serviceWorker;
    if ($6c079b6dfb8f58a4$var$swContainer) $6c079b6dfb8f58a4$var$swContainer.addEventListener("message", $6c079b6dfb8f58a4$var$propagateMessageLocally);
}
function $6c079b6dfb8f58a4$var$propagateMessageLocally(_a) {
    var data = _a.data;
    if (data && data.type === $6c079b6dfb8f58a4$var$STORAGE_MUTATED_DOM_EVENT_NAME) $6c079b6dfb8f58a4$var$propagateLocally(data.changedParts);
}
$6c079b6dfb8f58a4$var$DexiePromise.rejectionMapper = $6c079b6dfb8f58a4$var$mapError;
$6c079b6dfb8f58a4$var$setDebug($6c079b6dfb8f58a4$var$debug, $6c079b6dfb8f58a4$var$dexieStackFrameFilter);



(0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline = {
    /** @var Date the datetime of the newest garbage collected entry, i.e. deleted because not of interest. */ newestGCedEntry: null,
    offlineDays: 10,
    lastItemId: null,
    newerEntriesMissing: false,
    shouldLoadEntriesOnline: false,
    olderEntriesOnline: false,
    _tr (...args) {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.transaction(...args).catch((error)=>{
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.showError((0, $ee388dae0165e99c$export$2e2bcd8739ae039).app._("error_offline_storage", [
                error.message
            ]));
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.broken = true;
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.enableOffline.update(false);
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).entries?.reload();
            // If this is a QuotaExceededError, garbage collect more
            // entries and hope it helps.
            if (error.name === (0, $6c079b6dfb8f58a4$export$4ece27d405df7279).errnames.QuotaExceeded) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.GCEntries(true);
            return Promise.reject(error);
        });
    },
    init () {
        if (!(0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.enableOffline.value || (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage) return;
        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.broken = false;
        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage = new (0, $6c079b6dfb8f58a4$export$4ece27d405df7279)("selfoss");
        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.version(1).stores({
            entries: "&id,*datetime,[datetime+id]",
            statusq: "++id,*entryId",
            stamps: "&name,datetime",
            stats: "&name",
            tags: "&name",
            sources: "&id"
        });
        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.on("populate", ()=>{
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stats.add({
                name: "unread",
                value: 0
            });
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stats.add({
                name: "starred",
                value: 0
            });
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stats.add({
                name: "total",
                value: 0
            });
        });
        // retrieve last update stats in offline db
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._tr("r", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries, (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stamps, ()=>{
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._memLastItemId();
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stamps.get("lastItemsUpdate", (stamp)=>{
                if (stamp) {
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastUpdate = stamp.datetime;
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.firstSync = false;
                } else (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.shouldLoadEntriesOnline = true;
            });
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stamps.get("newestGCedEntry", (stamp)=>{
                if (stamp) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = stamp.datetime;
                const limit = new Date(Date.now() - 259200000);
                if (!stamp || (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry < limit) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = new Date(Date.now() - 86400000);
            });
        }).then(()=>{
            const offlineDays = window.localStorage.getItem("offlineDays");
            if (offlineDays !== null) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.offlineDays = parseInt(offlineDays);
            // The newest garbage collected entry is either what's already
            // in the offline db or if more recent the entry older than
            // offlineDays ago.
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = new Date(Math.max((0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry, Date.now() - (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.offlineDays * 86400000));
            window.addEventListener("online", ()=>{
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.tryOnline();
            });
            window.addEventListener("offline", ()=>{
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.setOffline().catch((error)=>{
                    if (error instanceof (0, $506fdaa0545346a2$export$1871035840b7f83a)) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.showError((0, $ee388dae0165e99c$export$2e2bcd8739ae039).app._("error_offline_storage_not_available", [
                        '<a href="https://caniuse.com/#feat=indexeddb">',
                        "</a>"
                    ]));
                    else throw error;
                });
            });
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setOfflineState(false);
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.tryOnline().then(()=>{
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).reloadTags();
            });
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.reloadOnlineStats();
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.refreshStats();
        }).catch(()=>{
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.broken = true;
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.enableOffline.update(false);
        });
    },
    _memLastItemId () {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries.orderBy("id").reverse().first((entry)=>{
            if (entry) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.lastItemId = entry.id;
            else (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.lastItemId = 0;
        });
    },
    storeEntries (entries) {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._tr("rw", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries, (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stamps, ()=>{
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.GCEntries();
            // store entries offline
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries.bulkPut(entries).then(()=>{
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._memLastItemId();
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.refreshStats();
            });
        });
    },
    GCEntries (more = false) {
        if (more) {
            // We need to garbage collect more, as the browser storage limit
            // seems to be exceeded: decrease the amount of days entries are
            // kept offline.
            const keptDays = Math.floor((new Date() - (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry) / 86400000);
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.offlineDays = Math.max(Math.min(keptDays - 1, (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.offlineDays - 1), 0);
            window.localStorage.setItem("offlineDays", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.offlineDays);
        }
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.transaction("rw", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries, (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stamps, ()=>{
            // cleanup and remember when
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stamps.get("lastCleanup", (stamp)=>{
                // Cleanup once a day or once after db reset
                if (!stamp || more || stamp && Date.now() - stamp.datetime > 86400000) {
                    // Cleanup items older than offlineDays days, not of
                    // interest.
                    const limit = new Date(Date.now() - (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.offlineDays * 86400000);
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries.where("datetime").below(limit).filter((entry)=>{
                        return !entry.unread && !entry.starred;
                    }).each((entry)=>{
                        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries.delete(entry.id);
                        if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry < entry.datetime) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = entry.datetime;
                    }).then(()=>{
                        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stamps.bulkPut([
                            {
                                name: "lastCleanup",
                                datetime: new Date()
                            },
                            {
                                name: "newestGCedEntry",
                                datetime: (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry
                            }
                        ]);
                    });
                }
            });
        });
    },
    storeStats (stats) {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._tr("rw", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stats, ()=>{
            for (const [name, value] of Object.entries(stats))(0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stats.put({
                name: name,
                value: value
            });
        });
    },
    storeLastUpdate (lastUpdate) {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._tr("rw", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stamps, ()=>{
            if (lastUpdate) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stamps.put({
                name: "lastItemsUpdate",
                datetime: lastUpdate
            });
        });
    },
    getEntries (fetchParams) {
        let hasMore = false;
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._tr("r", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries, ()=>{
            let howMany = 0;
            const ascOrder = (0, $ee388dae0165e99c$export$2e2bcd8739ae039).config.unreadOrder === "asc" && fetchParams.type === (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).UNREAD;
            let entries = (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries.orderBy("[datetime+id]");
            if (!ascOrder) entries = entries.reverse();
            const fromDatetime = fetchParams.fromDatetime;
            const fromId = fetchParams.fromId;
            const seek = fromDatetime && fromId;
            const alwaysInDb = fetchParams.type === (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).STARRED || fetchParams.type === (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).UNREAD;
            return entries.filter((entry)=>{
                let keepEntry = false;
                if (fetchParams.extraIds.includes(entry.id)) return true;
                if (fetchParams.type === (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).STARRED) keepEntry = entry.starred;
                else if (fetchParams.type === (0, $1901e2fb1eeb5912$export$c67e46de1ec7dfa6).UNREAD) keepEntry = entry.unread;
                else keepEntry = true;
                // seek pagination
                if (seek) {
                    if (ascOrder) keepEntry &&= entry.datetime > fromDatetime || entry.datetime.getTime() == fromDatetime.getTime() && entry.id > fromId;
                    else keepEntry &&= entry.datetime < fromDatetime || entry.datetime.getTime() == fromDatetime.getTime() && entry.id < fromId;
                }
                return keepEntry;
            }).until((entry)=>{
                howMany += 1;
                if (!ascOrder && !alwaysInDb && entry.datetime < (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.newestGCedEntry) {
                    // the offline db is missing older entries, the next
                    // seek will have to find them online.
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.olderEntriesOnline = true;
                    hasMore = true;
                    return true; // stop iteration
                }
                // stop iteration if enough entries have been shown
                // go one further to assess if has more
                if (howMany >= (0, $ee388dae0165e99c$export$2e2bcd8739ae039).config.itemsPerPage + 1) {
                    hasMore = true;
                    return true;
                }
                return false;
            });
        }).then((entriesCollection)=>entriesCollection.toArray()).then((entries)=>({
                entries: entries,
                hasMore: hasMore
            }));
    },
    reloadOnlineStats () {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._tr("r", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stats, ()=>{
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stats.toArray((stats)=>{
                const newStats = {};
                stats.forEach((stat)=>{
                    newStats[stat.name] = stat.value;
                });
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).refreshStats(newStats.total, newStats.unread, newStats.starred);
            });
        });
    },
    refreshStats () {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._tr("r", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries, ()=>{
            const offlineCounts = {
                newest: 0,
                unread: 0,
                starred: 0
            };
            // IDBKeyRange does not support boolean indexes, so we need to
            // iterate over all the entries.
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries.each((entry)=>{
                offlineCounts.newest = offlineCounts.newest + 1;
                if (entry.unread) offlineCounts.unread = offlineCounts.unread + 1;
                if (entry.starred) offlineCounts.starred = offlineCounts.starred + 1;
            }).then(()=>{
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.refreshOfflineCounts(offlineCounts);
            });
        });
    },
    enqueueStatuses (statuses) {
        if (statuses) (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.needsSync = true;
        const d = new Date();
        const newQueuedStatuses = statuses.map((newStatus)=>({
                entryId: parseInt(newStatus.entryId),
                name: newStatus.name,
                value: newStatus.value,
                datetime: d
            }));
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._tr("rw", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.statusq, ()=>{
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.statusq.bulkAdd(newQueuedStatuses);
        });
    },
    enqueueStatus (entryId, statusName, statusValue) {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.enqueueStatuses([
            {
                entryId: entryId,
                name: statusName,
                value: statusValue
            }
        ]);
    },
    sendNewStatuses () {
        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.statusq.toArray().then((statuses)=>{
            return statuses.map((s)=>{
                const statusUpdate = {
                    id: s.entryId,
                    datetime: s.datetime
                };
                statusUpdate[s.name] = s.value;
                return statusUpdate;
            });
        }).then((statuses)=>{
            const s = statuses.length > 0 ? statuses : undefined;
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.sync(s, true).then(()=>{
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.needsSync = false;
            });
        });
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline._syncBegin();
    },
    storeEntryStatuses (itemStatuses, dequeue = false, updateStats = true) {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline._tr("rw", (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries, (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stats, (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.statusq, ()=>{
            const statsDiff = {};
            // update entries statuses
            itemStatuses.forEach((itemStatus)=>{
                const newStatus = {};
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.entryStatusNames.forEach((statusName)=>{
                    if (statusName in itemStatus) {
                        statsDiff[statusName] = 0;
                        newStatus[statusName] = itemStatus[statusName];
                        if (updateStats) {
                            if (itemStatus[statusName]) statsDiff[statusName]++;
                            else statsDiff[statusName]--;
                        }
                    }
                });
                const id = parseInt(itemStatus.id);
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries.get(id).then(()=>{
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.entries.update(id, newStatus);
                }, ()=>{
                    // the key was not found, the status of an entry
                    // missing in db was updated, request sync.
                    (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.needsSync = true;
                });
                if (dequeue) // status update from server, remove from status queue
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.statusq.where("entryId").equals(id).delete();
            });
            if (updateStats) for (const [name, value] of Object.entries(statsDiff))(0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stats.get(name, (stat)=>{
                (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.stats.put({
                    name: name,
                    value: stat.value + value
                });
            });
        }).then((0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.refreshStats);
    },
    entriesMark (itemIds, unread) {
        (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.statsDirty = true;
        const newStatuses = itemIds.map((itemId)=>{
            return {
                id: itemId,
                unread: unread
            };
        });
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses(newStatuses);
    },
    entryMark (itemId, unread) {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.entriesMark([
            itemId
        ], unread);
    },
    entryStar (itemId, starred) {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses([
            {
                id: itemId,
                starred: starred
            }
        ]);
    }
};


/**
 * db functions: client data repository (and offline storage)
 *
 * db is a dispatcher class and holds the logic for deciding whether selfoss
 * is running online with access to the server or offline.
 *
 * dbOnline contains AJAX calls that provide access to the server db.
 *
 * dbOffline is the entry point for the offline database held in the client.
 */ 


(0, $ee388dae0165e99c$export$2e2bcd8739ae039).db = {
    /** When an error occurs we disable the offline mode and mark the database as broken so it can be retried. */ broken: false,
    storage: null,
    online: true,
    enableOffline: new (0, $648254c988c3de43$export$8fa6ce44b7b131e9)(window.localStorage.getItem("enableOffline") === "true"),
    entryStatusNames: [
        "unread",
        "starred"
    ],
    userWaiting: true,
    /**
     * last db timestamp known client side
     */ lastUpdate: null,
    setOnline () {
        if (!(0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.online) {
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.online = true;
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.sync();
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).reloadTags();
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setOfflineState(false);
        }
    },
    tryOnline () {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.sync(true);
    },
    setOffline () {
        if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage && !(0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.broken) {
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline._syncDone(false);
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.online = false;
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.setOfflineState(true);
            return Promise.resolve();
        } else {
            const err = new (0, $506fdaa0545346a2$export$1871035840b7f83a)();
            return Promise.reject(err);
        }
    },
    clear () {
        if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage) {
            window.localStorage.removeItem("offlineDays");
            const clearing = (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage.delete();
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.storage = null;
            (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastUpdate = null;
            return clearing;
        } else return Promise.resolve();
    },
    isValidTag (name) {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.state.tags.length === 0 || (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.state.tags.find((tag)=>tag.tag === name) !== undefined;
    },
    isValidSource (id) {
        return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.state.sources.length === 0 || (0, $ee388dae0165e99c$export$2e2bcd8739ae039).app.state.sources.find((source)=>source.id === id) !== undefined;
    },
    lastSync: null,
    sync (force = false) {
        const lastUpdateIsOld = (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastUpdate === null || (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastSync === null || Date.now() - (0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.lastSync > 300000;
        const shouldSync = force || (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.needsSync || lastUpdateIsOld;
        if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).isAllowedToRead() && (0, $ee388dae0165e99c$export$2e2bcd8739ae039).isOnline() && shouldSync) {
            if ((0, $ee388dae0165e99c$export$2e2bcd8739ae039).db.enableOffline.value) return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOffline.sendNewStatuses();
            else return (0, $ee388dae0165e99c$export$2e2bcd8739ae039).dbOnline.sync();
        } else return Promise.resolve(); // ensure any chained function runs
    }
};


(0, $ee388dae0165e99c$export$2e2bcd8739ae039).init();
// make selfoss available in console for debugging
window.selfoss = (0, $ee388dae0165e99c$export$2e2bcd8739ae039);


//# sourceMappingURL=index.0457741a.js.map
